(function (f, e) {
  "object" === typeof exports && "object" === typeof module
    ? (module.exports = e(require("vue")))
    : "function" === typeof define && define.amd
    ? define([], e)
    : "object" === typeof exports
    ? (exports["vue-beautiful-chat"] = e(require("vue")))
    : (f["vue-beautiful-chat"] = e(f["Vue"]));
})("undefined" !== typeof self ? self : this, function (f) {
  return (function (f) {
    var e = {};
    function t(n) {
      if (e[n]) return e[n].exports;
      var r = (e[n] = { i: n, l: !1, exports: {} });
      return f[n].call(r.exports, r, r.exports, t), (r.l = !0), r.exports;
    }
    return (
      (t.m = f),
      (t.c = e),
      (t.d = function (f, e, n) {
        t.o(f, e) || Object.defineProperty(f, e, { enumerable: !0, get: n });
      }),
      (t.r = function (f) {
        "undefined" !== typeof Symbol &&
          Symbol.toStringTag &&
          Object.defineProperty(f, Symbol.toStringTag, { value: "Module" }),
          Object.defineProperty(f, "__esModule", { value: !0 });
      }),
      (t.t = function (f, e) {
        if ((1 & e && (f = t(f)), 8 & e)) return f;
        if (4 & e && "object" === typeof f && f && f.__esModule) return f;
        var n = Object.create(null);
        if (
          (t.r(n),
          Object.defineProperty(n, "default", { enumerable: !0, value: f }),
          2 & e && "string" != typeof f)
        )
          for (var r in f)
            t.d(
              n,
              r,
              function (e) {
                return f[e];
              }.bind(null, r)
            );
        return n;
      }),
      (t.n = function (f) {
        var e =
          f && f.__esModule
            ? function () {
                return f["default"];
              }
            : function () {
                return f;
              };
        return t.d(e, "a", e), e;
      }),
      (t.o = function (f, e) {
        return Object.prototype.hasOwnProperty.call(f, e);
      }),
      (t.p = ""),
      t((t.s = "fb15"))
    );
  })({
    "00ee": function (f, e, t) {
      var n = t("b622"),
        r = n("toStringTag"),
        o = {};
      (o[r] = "z"), (f.exports = "[object z]" === String(o));
    },
    "00fd": function (f, e, t) {
      var n = t("9e69"),
        r = Object.prototype,
        o = r.hasOwnProperty,
        a = r.toString,
        i = n ? n.toStringTag : void 0;
      function s(f) {
        var e = o.call(f, i),
          t = f[i];
        try {
          f[i] = void 0;
          var n = !0;
        } catch (s) {}
        var r = a.call(f);
        return n && (e ? (f[i] = t) : delete f[i]), r;
      }
      f.exports = s;
    },
    "01e9": function (f, e, t) {
      var n = t("24fb");
      (e = n(!1)),
        e.push([
          f.i,
          ".sc-chat-window[data-v-193ba5e7]{width:375px;height:calc(100% - 120px);max-height:590px;position:fixed;right:25px;bottom:90px;box-sizing:border-box;box-shadow:0 7px 40px 2px rgba(148,149,150,.1);background:#fff;background-size:cover;display:flex;flex-direction:column;justify-content:space-between;border-radius:10px;-webkit-animation:fadeIn-data-v-193ba5e7;animation:fadeIn-data-v-193ba5e7;-webkit-animation-duration:.2s;animation-duration:.2s;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}.sc-chat-window.closed[data-v-193ba5e7]{display:none;opacity:0;bottom:0}@-webkit-keyframes fadeIn-data-v-193ba5e7{0%{display:none;opacity:0;bottom:0}to{display:flex;opacity:1;bottom:90px}}@keyframes fadeIn-data-v-193ba5e7{0%{display:none;opacity:0;bottom:0}to{display:flex;opacity:1;bottom:90px}}@-webkit-keyframes mobileFadeIn-data-v-193ba5e7{0%{display:none;opacity:0;bottom:-30px}to{display:flex;opacity:1;bottom:0}}@keyframes mobileFadeIn-data-v-193ba5e7{0%{display:none;opacity:0;bottom:-30px}to{display:flex;opacity:1;bottom:0}}.sc-message--me[data-v-193ba5e7]{text-align:right}.sc-message--them[data-v-193ba5e7]{text-align:left}@media (max-width:450px){.sc-chat-window[data-v-193ba5e7]{width:100%;height:100%;max-height:100%;right:0;bottom:0;border-radius:0;-webkit-animation:mobileFadeIn-data-v-193ba5e7;animation:mobileFadeIn-data-v-193ba5e7;-webkit-animation-duration:.2s;animation-duration:.2s;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out;transition:.1s ease-in-out}.sc-chat-window.closed[data-v-193ba5e7]{bottom:0}}[data-v-193ba5e7]::-webkit-scrollbar{width:10px}[data-v-193ba5e7]::-webkit-scrollbar-track{background:transparent}[data-v-193ba5e7]::-webkit-scrollbar-thumb{background:#bbb;opacity:.3}",
          "",
        ]),
        (f.exports = e);
    },
    "01f5": function (f, e) {
      f.exports =
        "data:image/png;base64,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";
    },
    "0366": function (f, e, t) {
      var n = t("e330"),
        r = t("59ed"),
        o = n(n.bind);
      f.exports = function (f, e) {
        return (
          r(f),
          void 0 === e
            ? f
            : o
            ? o(f, e)
            : function () {
                return f.apply(e, arguments);
              }
        );
      };
    },
    "03dd": function (f, e, t) {
      var n = t("eac5"),
        r = t("57a5"),
        o = Object.prototype,
        a = o.hasOwnProperty;
      function i(f) {
        if (!n(f)) return r(f);
        var e = [];
        for (var t in Object(f))
          a.call(f, t) && "constructor" != t && e.push(t);
        return e;
      }
      f.exports = i;
    },
    "0538": function (f, e, t) {
      "use strict";
      var n = t("da84"),
        r = t("e330"),
        o = t("59ed"),
        a = t("861d"),
        i = t("1a2d"),
        s = t("f36a"),
        d = n.Function,
        c = r([].concat),
        l = r([].join),
        u = {},
        p = function (f, e, t) {
          if (!i(u, e)) {
            for (var n = [], r = 0; r < e; r++) n[r] = "a[" + r + "]";
            u[e] = d("C,a", "return new C(" + l(n, ",") + ")");
          }
          return u[e](f, t);
        };
      f.exports =
        d.bind ||
        function (f) {
          var e = o(this),
            t = e.prototype,
            n = s(arguments, 1),
            r = function () {
              var t = c(n, s(arguments));
              return this instanceof r ? p(e, t.length, t) : e.apply(f, t);
            };
          return a(t) && (r.prototype = t), r;
        };
    },
    "057f": function (f, e, t) {
      var n = t("c6b6"),
        r = t("fc6a"),
        o = t("241c").f,
        a = t("4dae"),
        i =
          "object" == typeof window && window && Object.getOwnPropertyNames
            ? Object.getOwnPropertyNames(window)
            : [],
        s = function (f) {
          try {
            return o(f);
          } catch (e) {
            return a(i);
          }
        };
      f.exports.f = function (f) {
        return i && "Window" == n(f) ? s(f) : o(r(f));
      };
    },
    "0601": function (f, e, t) {
      var n = t("24fb");
      (e = n(!1)),
        e.push([f.i, "*{transition:all .2s ease}", ""]),
        (f.exports = e);
    },
    "0669": function (f, e, t) {
      var n = t("24fb");
      (e = n(!1)),
        e.push([
          f.i,
          ".sc-user-input--emoji-icon-wrapper[data-v-1a7c780e]{display:block;background:none;border:none;padding:0;margin:0;outline:none}.sc-user-input--emoji-icon-wrapper[data-v-1a7c780e]:focus{outline:none}.sc-user-input--emoji-icon[data-v-1a7c780e]{display:block;cursor:pointer}",
          "",
        ]),
        (f.exports = e);
    },
    "06cf": function (f, e, t) {
      var n = t("83ab"),
        r = t("c65b"),
        o = t("d1e7"),
        a = t("5c6c"),
        i = t("fc6a"),
        s = t("a04b"),
        d = t("1a2d"),
        c = t("0cfb"),
        l = Object.getOwnPropertyDescriptor;
      e.f = n
        ? l
        : function (f, e) {
            if (((f = i(f)), (e = s(e)), c))
              try {
                return l(f, e);
              } catch (t) {}
            if (d(f, e)) return a(!r(o.f, f, e), f[e]);
          };
    },
    "07c7": function (f, e) {
      function t() {
        return !1;
      }
      f.exports = t;
    },
    "07fa": function (f, e, t) {
      var n = t("50c4");
      f.exports = function (f) {
        return n(f.length);
      };
    },
    "087d": function (f, e) {
      function t(f, e) {
        var t = -1,
          n = e.length,
          r = f.length;
        while (++t < n) f[r + t] = e[t];
        return f;
      }
      f.exports = t;
    },
    "092d": function (f, e, t) {
      var n = t("24fb");
      (e = n(!1)),
        e.push([
          f.i,
          '.sc-emoji-picker[data-v-5503164d]{position:absolute;bottom:50px;right:12px;width:330px;max-height:215px;box-shadow:0 7px 40px 2px rgba(148,149,150,.3);background:#fff;border-radius:10px;outline:none}.sc-emoji-picker[data-v-5503164d]:after{content:"";width:14px;height:14px;background:#fff;position:absolute;bottom:-6px;right:55px;transform:rotate(45deg);border-radius:2px}.sc-emoji-picker--content[data-v-5503164d]{padding:10px;overflow:auto;width:100%;max-height:195px;margin-top:7px;box-sizing:border-box}.sc-emoji-picker--category[data-v-5503164d]{display:flex;flex-direction:row;flex-wrap:wrap}.sc-emoji-picker--category-title[data-v-5503164d]{min-width:100%;color:#b8c3ca;font-size:13px;margin:5px;letter-spacing:1px}.sc-emoji-picker--emoji[data-v-5503164d]{margin:5px;width:30px;line-height:30px;text-align:center;cursor:pointer;vertical-align:middle;font-size:28px;transition:transform 60ms ease-out}.sc-emoji-picker--emoji[data-v-5503164d]:hover{transform:scale(1.4)}',
          "",
        ]),
        (f.exports = e);
    },
    "0a0b": function (f, e, t) {
      var n = t("de59");
      n.__esModule && (n = n.default),
        "string" === typeof n && (n = [[f.i, n, ""]]),
        n.locals && (f.exports = n.locals);
      var r = t("499e").default;
      r("3d1563f9", n, !0, { sourceMap: !1, shadowMode: !1 });
    },
    "0a97": function (f, e, t) {
      "use strict";
      t("2d2a");
    },
    "0b07": function (f, e, t) {
      var n = t("34ac"),
        r = t("3698");
      function o(f, e) {
        var t = r(f, e);
        return n(t) ? t : void 0;
      }
      f.exports = o;
    },
    "0b42": function (f, e, t) {
      var n = t("da84"),
        r = t("e8b5"),
        o = t("68ee"),
        a = t("861d"),
        i = t("b622"),
        s = i("species"),
        d = n.Array;
      f.exports = function (f) {
        var e;
        return (
          r(f) &&
            ((e = f.constructor),
            o(e) && (e === d || r(e.prototype))
              ? (e = void 0)
              : a(e) && ((e = e[s]), null === e && (e = void 0))),
          void 0 === e ? d : e
        );
      };
    },
    "0cfb": function (f, e, t) {
      var n = t("83ab"),
        r = t("d039"),
        o = t("cc12");
      f.exports =
        !n &&
        !r(function () {
          return (
            7 !=
            Object.defineProperty(o("div"), "a", {
              get: function () {
                return 7;
              },
            }).a
          );
        });
    },
    "0d24": function (f, e, t) {
      (function (f) {
        var n = t("2b3e"),
          r = t("07c7"),
          o = e && !e.nodeType && e,
          a = o && "object" == typeof f && f && !f.nodeType && f,
          i = a && a.exports === o,
          s = i ? n.Buffer : void 0,
          d = s ? s.isBuffer : void 0,
          c = d || r;
        f.exports = c;
      }).call(this, t("62e4")(f));
    },
    "0d51": function (f, e, t) {
      var n = t("da84"),
        r = n.String;
      f.exports = function (f) {
        try {
          return r(f);
        } catch (e) {
          return "Object";
        }
      };
    },
    "0e25": function (f, e, t) {
      var n = t("24fb");
      (e = n(!1)),
        e.push([
          f.i,
          "input[type=file][data-v-ba6bc394]{display:none}.sc-user-input--file-icon-wrapper[data-v-ba6bc394]{display:block;cursor:pointer}.sc-user-input--file-icon[data-v-ba6bc394]{display:block}",
          "",
        ]),
        (f.exports = e);
    },
    "100e": function (f, e, t) {
      var n = t("cd9d"),
        r = t("2286"),
        o = t("c1c9");
      function a(f, e) {
        return o(r(f, e, n), f + "");
      }
      f.exports = a;
    },
    "107c": function (f, e, t) {
      var n = t("d039"),
        r = t("da84"),
        o = r.RegExp;
      f.exports = n(function () {
        var f = o("(?<a>b)", "g");
        return "b" !== f.exec("b").groups.a || "bc" !== "b".replace(f, "$<a>c");
      });
    },
    "11d3": function (f, e, t) {
      var n = t("24fb");
      (e = n(!1)),
        e.push([
          f.i,
          ".sc-user-input--button-icon-wrapper[data-v-122be205]{display:block;background:none;border:none;padding:.5em .6em;margin:0;outline:none;cursor:pointer}button[data-v-122be205]:disabled{cursor:auto}",
          "",
        ]),
        (f.exports = e);
    },
    1290: function (f, e) {
      function t(f) {
        var e = typeof f;
        return "string" == e || "number" == e || "symbol" == e || "boolean" == e
          ? "__proto__" !== f
          : null === f;
      }
      f.exports = t;
    },
    "129f": function (f, e, t) {
      var n = t("9a1e");
      n.__esModule && (n = n.default),
        "string" === typeof n && (n = [[f.i, n, ""]]),
        n.locals && (f.exports = n.locals);
      var r = t("499e").default;
      r("40ea28b8", n, !0, { sourceMap: !1, shadowMode: !1 });
    },
    1310: function (f, e) {
      function t(f) {
        return null != f && "object" == typeof f;
      }
      f.exports = t;
    },
    1368: function (f, e, t) {
      var n = t("da03"),
        r = (function () {
          var f = /[^.]+$/.exec((n && n.keys && n.keys.IE_PROTO) || "");
          return f ? "Symbol(src)_1." + f : "";
        })();
      function o(f) {
        return !!r && r in f;
      }
      f.exports = o;
    },
    "14c3": function (f, e, t) {
      var n = t("da84"),
        r = t("c65b"),
        o = t("825a"),
        a = t("1626"),
        i = t("c6b6"),
        s = t("9263"),
        d = n.TypeError;
      f.exports = function (f, e) {
        var t = f.exec;
        if (a(t)) {
          var n = r(t, f, e);
          return null !== n && o(n), n;
        }
        if ("RegExp" === i(f)) return r(s, f, e);
        throw d("RegExp#exec called on incompatible receiver");
      };
    },
    "159b": function (f, e, t) {
      var n = t("da84"),
        r = t("fdbc"),
        o = t("785a"),
        a = t("17c2"),
        i = t("9112"),
        s = function (f) {
          if (f && f.forEach !== a)
            try {
              i(f, "forEach", a);
            } catch (e) {
              f.forEach = a;
            }
        };
      for (var d in r) r[d] && s(n[d] && n[d].prototype);
      s(o);
    },
    1626: function (f, e) {
      f.exports = function (f) {
        return "function" == typeof f;
      };
    },
    1738: function (f, e, t) {
      var n = t("842b");
      n.__esModule && (n = n.default),
        "string" === typeof n && (n = [[f.i, n, ""]]),
        n.locals && (f.exports = n.locals);
      var r = t("499e").default;
      r("09479fa2", n, !0, { sourceMap: !1, shadowMode: !1 });
    },
    "173d": function (f, e, t) {
      var n = t("24fb");
      (e = n(!1)),
        e.push([
          f.i,
          ".sc-suggestions-row{text-align:center;background:inherit}.sc-suggestions-element{margin:3px;padding:5px 10px 5px 10px;border:1px solid;border-radius:15px;font-size:14px;background:inherit;cursor:pointer;border-color:var(--color);color:var(--color);box-shadow:0 1px 4px rgba(0,0,0,.2)}.sc-suggestions-element:hover{background-color:var(--color);color:var(--fontcolor);border-color:var(--color)}",
          "",
        ]),
        (f.exports = e);
    },
    "17c2": function (f, e, t) {
      "use strict";
      var n = t("b727").forEach,
        r = t("a640"),
        o = r("forEach");
      f.exports = o
        ? [].forEach
        : function (f) {
            return n(this, f, arguments.length > 1 ? arguments[1] : void 0);
          };
    },
    1937: function (f) {
      f.exports = JSON.parse(
        '{"writeMsg":"输入讯息...","here2help":"我能够帮助您","send":"发送","edit":"编辑","cancel":"取消"}'
      );
    },
    1997: function (f, e, t) {
      var n = t("24fb");
      (e = n(!1)),
        e.push([
          f.i,
          ".sc-message--text[data-v-31de3dd1]{word-break:break-word;padding:4px 15px;border-radius:.7rem;font-weight:400;font-size:14px;line-height:1.4;position:relative;-webkit-font-smoothing:subpixel-antialiased}.sc-message--text .sc-message--text-content[data-v-31de3dd1]{white-space:pre-wrap;margin:5px 0}.sc-message--text:hover .sc-message--toolbox[data-v-31de3dd1]{left:-20px;opacity:1}.sc-message--text .sc-message--toolbox[data-v-31de3dd1]{transition:left .2s ease-out 0s;white-space:normal;opacity:0;position:absolute;left:0;width:25px;top:0}.sc-message--text .sc-message--toolbox button[data-v-31de3dd1]{background:none;border:none;padding:0;margin:0;outline:none;width:100%;text-align:center;cursor:pointer}.sc-message--text .sc-message--toolbox button[data-v-31de3dd1]:focus{outline:none}.sc-message--text .sc-message--toolbox[data-v-31de3dd1] svg{margin-left:5px}.sc-message--content.sent .sc-message--text[data-v-31de3dd1]{color:#fff;background-color:#4e8cff;max-width:calc(100% - 120px);word-wrap:break-word}.sc-message--content.received .sc-message--text[data-v-31de3dd1]{color:#263238;background-color:#f4f7f9}a.chatLink[data-v-31de3dd1]{color:inherit!important}",
          "",
        ]),
        (f.exports = e);
    },
    "19aa": function (f, e, t) {
      var n = t("da84"),
        r = t("3a9b"),
        o = n.TypeError;
      f.exports = function (f, e) {
        if (r(e, f)) return f;
        throw o("Incorrect invocation");
      };
    },
    "1a2d": function (f, e, t) {
      var n = t("e330"),
        r = t("7b0b"),
        o = n({}.hasOwnProperty);
      f.exports =
        Object.hasOwn ||
        function (f, e) {
          return o(r(f), e);
        };
    },
    "1a8c": function (f, e) {
      function t(f) {
        var e = typeof f;
        return null != f && ("object" == e || "function" == e);
      }
      f.exports = t;
    },
    "1be4": function (f, e, t) {
      var n = t("d066");
      f.exports = n("document", "documentElement");
    },
    "1c3c": function (f, e, t) {
      var n = t("9e69"),
        r = t("2474"),
        o = t("9638"),
        a = t("a2be"),
        i = t("edfa"),
        s = t("ac41"),
        d = 1,
        c = 2,
        l = "[object Boolean]",
        u = "[object Date]",
        p = "[object Error]",
        b = "[object Map]",
        h = "[object Number]",
        g = "[object RegExp]",
        m = "[object Set]",
        v = "[object String]",
        y = "[object Symbol]",
        w = "[object ArrayBuffer]",
        x = "[object DataView]",
        _ = n ? n.prototype : void 0,
        k = _ ? _.valueOf : void 0;
      function M(f, e, t, n, _, M, C) {
        switch (t) {
          case x:
            if (f.byteLength != e.byteLength || f.byteOffset != e.byteOffset)
              return !1;
            (f = f.buffer), (e = e.buffer);
          case w:
            return !(f.byteLength != e.byteLength || !M(new r(f), new r(e)));
          case l:
          case u:
          case h:
            return o(+f, +e);
          case p:
            return f.name == e.name && f.message == e.message;
          case g:
          case v:
            return f == e + "";
          case b:
            var A = i;
          case m:
            var j = n & d;
            if ((A || (A = s), f.size != e.size && !j)) return !1;
            var I = C.get(f);
            if (I) return I == e;
            (n |= c), C.set(f, e);
            var T = a(A(f), A(e), n, _, M, C);
            return C["delete"](f), T;
          case y:
            if (k) return k.call(f) == k.call(e);
        }
        return !1;
      }
      f.exports = M;
    },
    "1c7e": function (f, e, t) {
      var n = t("b622"),
        r = n("iterator"),
        o = !1;
      try {
        var a = 0,
          i = {
            next: function () {
              return { done: !!a++ };
            },
            return: function () {
              o = !0;
            },
          };
        (i[r] = function () {
          return this;
        }),
          Array.from(i, function () {
            throw 2;
          });
      } catch (s) {}
      f.exports = function (f, e) {
        if (!e && !o) return !1;
        var t = !1;
        try {
          var n = {};
          (n[r] = function () {
            return {
              next: function () {
                return { done: (t = !0) };
              },
            };
          }),
            f(n);
        } catch (s) {}
        return t;
      };
    },
    "1cdc": function (f, e, t) {
      var n = t("342f");
      f.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(n);
    },
    "1cec": function (f, e, t) {
      var n = t("0b07"),
        r = t("2b3e"),
        o = n(r, "Promise");
      f.exports = o;
    },
    "1d1c": function (f, e, t) {
      var n = t("23e7"),
        r = t("83ab"),
        o = t("37e8");
      n(
        { target: "Object", stat: !0, forced: !r, sham: !r },
        { defineProperties: o }
      );
    },
    "1d80": function (f, e, t) {
      var n = t("da84"),
        r = n.TypeError;
      f.exports = function (f) {
        if (void 0 == f) throw r("Can't call method on " + f);
        return f;
      };
    },
    "1dde": function (f, e, t) {
      var n = t("d039"),
        r = t("b622"),
        o = t("2d00"),
        a = r("species");
      f.exports = function (f) {
        return (
          o >= 51 ||
          !n(function () {
            var e = [],
              t = (e.constructor = {});
            return (
              (t[a] = function () {
                return { foo: 1 };
              }),
              1 !== e[f](Boolean).foo
            );
          })
        );
      };
    },
    "1efc": function (f, e) {
      function t(f) {
        var e = this.has(f) && delete this.__data__[f];
        return (this.size -= e ? 1 : 0), e;
      }
      f.exports = t;
    },
    "1fc8": function (f, e, t) {
      var n = t("4245");
      function r(f, e) {
        var t = n(this, f),
          r = t.size;
        return t.set(f, e), (this.size += t.size == r ? 0 : 1), this;
      }
      f.exports = r;
    },
    "21eb": function (f, e, t) {
      "use strict";
      (e.escape = (f) =>
        f
          .replace(/&/g, "&amp;")
          .replace(/"/g, "&quot;")
          .replace(/'/g, "&#39;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")),
        (e.unescape = (f) =>
          f
            .replace(/&gt;/g, ">")
            .replace(/&lt;/g, "<")
            .replace(/&#39;/g, "'")
            .replace(/&quot;/g, '"')
            .replace(/&amp;/g, "&")),
        (e.escapeTag = function (f) {
          let t = f[0];
          for (let n = 1; n < arguments.length; n++)
            t = t + e.escape(arguments[n]) + f[n];
          return t;
        }),
        (e.unescapeTag = function (f) {
          let t = f[0];
          for (let n = 1; n < arguments.length; n++)
            t = t + e.unescape(arguments[n]) + f[n];
          return t;
        });
    },
    2266: function (f, e, t) {
      var n = t("da84"),
        r = t("0366"),
        o = t("c65b"),
        a = t("825a"),
        i = t("0d51"),
        s = t("e95a"),
        d = t("07fa"),
        c = t("3a9b"),
        l = t("9a1f"),
        u = t("35a1"),
        p = t("2a62"),
        b = n.TypeError,
        h = function (f, e) {
          (this.stopped = f), (this.result = e);
        },
        g = h.prototype;
      f.exports = function (f, e, t) {
        var n,
          m,
          v,
          y,
          w,
          x,
          _,
          k = t && t.that,
          M = !(!t || !t.AS_ENTRIES),
          C = !(!t || !t.IS_ITERATOR),
          A = !(!t || !t.INTERRUPTED),
          j = r(e, k),
          I = function (f) {
            return n && p(n, "normal", f), new h(!0, f);
          },
          T = function (f) {
            return M
              ? (a(f), A ? j(f[0], f[1], I) : j(f[0], f[1]))
              : A
              ? j(f, I)
              : j(f);
          };
        if (C) n = f;
        else {
          if (((m = u(f)), !m)) throw b(i(f) + " is not iterable");
          if (s(m)) {
            for (v = 0, y = d(f); y > v; v++)
              if (((w = T(f[v])), w && c(g, w))) return w;
            return new h(!1);
          }
          n = l(f, m);
        }
        x = n.next;
        while (!(_ = o(x, n)).done) {
          try {
            w = T(_.value);
          } catch (S) {
            p(n, "throw", S);
          }
          if ("object" == typeof w && w && c(g, w)) return w;
        }
        return new h(!1);
      };
    },
    2286: function (f, e, t) {
      var n = t("85e3"),
        r = Math.max;
      function o(f, e, t) {
        return (
          (e = r(void 0 === e ? f.length - 1 : e, 0)),
          function () {
            var o = arguments,
              a = -1,
              i = r(o.length - e, 0),
              s = Array(i);
            while (++a < i) s[a] = o[e + a];
            a = -1;
            var d = Array(e + 1);
            while (++a < e) d[a] = o[a];
            return (d[e] = t(s)), n(f, this, d);
          }
        );
      }
      f.exports = o;
    },
    "23cb": function (f, e, t) {
      var n = t("5926"),
        r = Math.max,
        o = Math.min;
      f.exports = function (f, e) {
        var t = n(f);
        return t < 0 ? r(t + e, 0) : o(t, e);
      };
    },
    "23e7": function (f, e, t) {
      var n = t("da84"),
        r = t("06cf").f,
        o = t("9112"),
        a = t("6eeb"),
        i = t("ce4e"),
        s = t("e893"),
        d = t("94ca");
      f.exports = function (f, e) {
        var t,
          c,
          l,
          u,
          p,
          b,
          h = f.target,
          g = f.global,
          m = f.stat;
        if (((c = g ? n : m ? n[h] || i(h, {}) : (n[h] || {}).prototype), c))
          for (l in e) {
            if (
              ((p = e[l]),
              f.noTargetGet ? ((b = r(c, l)), (u = b && b.value)) : (u = c[l]),
              (t = d(g ? l : h + (m ? "." : "#") + l, f.forced)),
              !t && void 0 !== u)
            ) {
              if (typeof p == typeof u) continue;
              s(p, u);
            }
            (f.sham || (u && u.sham)) && o(p, "sham", !0), a(c, l, p, f);
          }
      };
    },
    "241c": function (f, e, t) {
      var n = t("ca84"),
        r = t("7839"),
        o = r.concat("length", "prototype");
      e.f =
        Object.getOwnPropertyNames ||
        function (f) {
          return n(f, o);
        };
    },
    2474: function (f, e, t) {
      var n = t("2b3e"),
        r = n.Uint8Array;
      f.exports = r;
    },
    2478: function (f, e, t) {
      var n = t("4245");
      function r(f) {
        return n(this, f).get(f);
      }
      f.exports = r;
    },
    "24fb": function (f, e, t) {
      "use strict";
      function n(f, e) {
        var t = f[1] || "",
          n = f[3];
        if (!n) return t;
        if (e && "function" === typeof btoa) {
          var o = r(n),
            a = n.sources.map(function (f) {
              return "/*# sourceURL="
                .concat(n.sourceRoot || "")
                .concat(f, " */");
            });
          return [t].concat(a).concat([o]).join("\n");
        }
        return [t].join("\n");
      }
      function r(f) {
        var e = btoa(unescape(encodeURIComponent(JSON.stringify(f)))),
          t =
            "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(
              e
            );
        return "/*# ".concat(t, " */");
      }
      f.exports = function (f) {
        var e = [];
        return (
          (e.toString = function () {
            return this.map(function (e) {
              var t = n(e, f);
              return e[2] ? "@media ".concat(e[2], " {").concat(t, "}") : t;
            }).join("");
          }),
          (e.i = function (f, t, n) {
            "string" === typeof f && (f = [[null, f, ""]]);
            var r = {};
            if (n)
              for (var o = 0; o < this.length; o++) {
                var a = this[o][0];
                null != a && (r[a] = !0);
              }
            for (var i = 0; i < f.length; i++) {
              var s = [].concat(f[i]);
              (n && r[s[0]]) ||
                (t &&
                  (s[2]
                    ? (s[2] = "".concat(t, " and ").concat(s[2]))
                    : (s[2] = t)),
                e.push(s));
            }
          }),
          e
        );
      };
    },
    2524: function (f, e, t) {
      var n = t("6044"),
        r = "__lodash_hash_undefined__";
      function o(f, e) {
        var t = this.__data__;
        return (
          (this.size += this.has(f) ? 0 : 1),
          (t[f] = n && void 0 === e ? r : e),
          this
        );
      }
      f.exports = o;
    },
    "252c": function (f, e, t) {
      "use strict";
      (function (f) {
        function n() {
          var f = window.navigator.userAgent,
            e = f.indexOf("MSIE ");
          if (e > 0) return parseInt(f.substring(e + 5, f.indexOf(".", e)), 10);
          var t = f.indexOf("Trident/");
          if (t > 0) {
            var n = f.indexOf("rv:");
            return parseInt(f.substring(n + 3, f.indexOf(".", n)), 10);
          }
          var r = f.indexOf("Edge/");
          return r > 0
            ? parseInt(f.substring(r + 5, f.indexOf(".", r)), 10)
            : -1;
        }
        var r;
        function o() {
          o.init || ((o.init = !0), (r = -1 !== n()));
        }
        t.d(e, "a", function () {
          return h;
        });
        var a = {
          name: "ResizeObserver",
          props: {
            emitOnMount: { type: Boolean, default: !1 },
            ignoreWidth: { type: Boolean, default: !1 },
            ignoreHeight: { type: Boolean, default: !1 },
          },
          mounted: function () {
            var f = this;
            o(),
              this.$nextTick(function () {
                (f._w = f.$el.offsetWidth),
                  (f._h = f.$el.offsetHeight),
                  f.emitOnMount && f.emitSize();
              });
            var e = document.createElement("object");
            (this._resizeObject = e),
              e.setAttribute("aria-hidden", "true"),
              e.setAttribute("tabindex", -1),
              (e.onload = this.addResizeHandlers),
              (e.type = "text/html"),
              r && this.$el.appendChild(e),
              (e.data = "about:blank"),
              r || this.$el.appendChild(e);
          },
          beforeDestroy: function () {
            this.removeResizeHandlers();
          },
          methods: {
            compareAndNotify: function () {
              ((!this.ignoreWidth && this._w !== this.$el.offsetWidth) ||
                (!this.ignoreHeight && this._h !== this.$el.offsetHeight)) &&
                ((this._w = this.$el.offsetWidth),
                (this._h = this.$el.offsetHeight),
                this.emitSize());
            },
            emitSize: function () {
              this.$emit("notify", { width: this._w, height: this._h });
            },
            addResizeHandlers: function () {
              this._resizeObject.contentDocument.defaultView.addEventListener(
                "resize",
                this.compareAndNotify
              ),
                this.compareAndNotify();
            },
            removeResizeHandlers: function () {
              this._resizeObject &&
                this._resizeObject.onload &&
                (!r &&
                  this._resizeObject.contentDocument &&
                  this._resizeObject.contentDocument.defaultView.removeEventListener(
                    "resize",
                    this.compareAndNotify
                  ),
                this.$el.removeChild(this._resizeObject),
                (this._resizeObject.onload = null),
                (this._resizeObject = null));
            },
          },
        };
        function i(f, e, t, n, r, o, a, i, s, d) {
          "boolean" !== typeof a && ((s = i), (i = a), (a = !1));
          var c,
            l = "function" === typeof t ? t.options : t;
          if (
            (f &&
              f.render &&
              ((l.render = f.render),
              (l.staticRenderFns = f.staticRenderFns),
              (l._compiled = !0),
              r && (l.functional = !0)),
            n && (l._scopeId = n),
            o
              ? ((c = function (f) {
                  (f =
                    f ||
                    (this.$vnode && this.$vnode.ssrContext) ||
                    (this.parent &&
                      this.parent.$vnode &&
                      this.parent.$vnode.ssrContext)),
                    f ||
                      "undefined" === typeof __VUE_SSR_CONTEXT__ ||
                      (f = __VUE_SSR_CONTEXT__),
                    e && e.call(this, s(f)),
                    f &&
                      f._registeredComponents &&
                      f._registeredComponents.add(o);
                }),
                (l._ssrRegister = c))
              : e &&
                (c = a
                  ? function (f) {
                      e.call(this, d(f, this.$root.$options.shadowRoot));
                    }
                  : function (f) {
                      e.call(this, i(f));
                    }),
            c)
          )
            if (l.functional) {
              var u = l.render;
              l.render = function (f, e) {
                return c.call(e), u(f, e);
              };
            } else {
              var p = l.beforeCreate;
              l.beforeCreate = p ? [].concat(p, c) : [c];
            }
          return t;
        }
        var s = a,
          d = function () {
            var f = this,
              e = f.$createElement,
              t = f._self._c || e;
            return t("div", {
              staticClass: "resize-observer",
              attrs: { tabindex: "-1" },
            });
          },
          c = [];
        d._withStripped = !0;
        var l = void 0,
          u = "data-v-8859cc6c",
          p = void 0,
          b = !1,
          h = i(
            { render: d, staticRenderFns: c },
            l,
            s,
            u,
            b,
            p,
            !1,
            void 0,
            void 0,
            void 0
          );
        function g(f) {
          f.component("resize-observer", h), f.component("ResizeObserver", h);
        }
        var m = { version: "1.0.1", install: g },
          v = null;
        "undefined" !== typeof window
          ? (v = window.Vue)
          : "undefined" !== typeof f && (v = f.Vue),
          v && v.use(m);
      }).call(this, t("c8ba"));
    },
    2532: function (f, e, t) {
      "use strict";
      var n = t("23e7"),
        r = t("e330"),
        o = t("5a34"),
        a = t("1d80"),
        i = t("577e"),
        s = t("ab13"),
        d = r("".indexOf);
      n(
        { target: "String", proto: !0, forced: !s("includes") },
        {
          includes: function (f) {
            return !!~d(
              i(a(this)),
              i(o(f)),
              arguments.length > 1 ? arguments[1] : void 0
            );
          },
        }
      );
    },
    "253c": function (f, e, t) {
      var n = t("3729"),
        r = t("1310"),
        o = "[object Arguments]";
      function a(f) {
        return r(f) && n(f) == o;
      }
      f.exports = a;
    },
    2626: function (f, e, t) {
      "use strict";
      var n = t("d066"),
        r = t("9bf2"),
        o = t("b622"),
        a = t("83ab"),
        i = o("species");
      f.exports = function (f) {
        var e = n(f),
          t = r.f;
        a &&
          e &&
          !e[i] &&
          t(e, i, {
            configurable: !0,
            get: function () {
              return this;
            },
          });
      };
    },
    "28c9": function (f, e) {
      function t() {
        (this.__data__ = []), (this.size = 0);
      }
      f.exports = t;
    },
    2938: function (f, e, t) {
      var n = t("4d1c");
      n.__esModule && (n = n.default),
        "string" === typeof n && (n = [[f.i, n, ""]]),
        n.locals && (f.exports = n.locals);
      var r = t("499e").default;
      r("fdb03e1a", n, !0, { sourceMap: !1, shadowMode: !1 });
    },
    "29f3": function (f, e) {
      var t = Object.prototype,
        n = t.toString;
      function r(f) {
        return n.call(f);
      }
      f.exports = r;
    },
    "2a62": function (f, e, t) {
      var n = t("c65b"),
        r = t("825a"),
        o = t("dc4a");
      f.exports = function (f, e, t) {
        var a, i;
        r(f);
        try {
          if (((a = o(f, "return")), !a)) {
            if ("throw" === e) throw t;
            return t;
          }
          a = n(a, f);
        } catch (s) {
          (i = !0), (a = s);
        }
        if ("throw" === e) throw t;
        if (i) throw a;
        return r(a), t;
      };
    },
    "2b3e": function (f, e, t) {
      var n = t("585a"),
        r = "object" == typeof self && self && self.Object === Object && self,
        o = n || r || Function("return this")();
      f.exports = o;
    },
    "2ba4": function (f, e) {
      var t = Function.prototype,
        n = t.apply,
        r = t.bind,
        o = t.call;
      f.exports =
        ("object" == typeof Reflect && Reflect.apply) ||
        (r
          ? o.bind(n)
          : function () {
              return o.apply(n, arguments);
            });
    },
    "2cf4": function (f, e, t) {
      var n,
        r,
        o,
        a,
        i = t("da84"),
        s = t("2ba4"),
        d = t("0366"),
        c = t("1626"),
        l = t("1a2d"),
        u = t("d039"),
        p = t("1be4"),
        b = t("f36a"),
        h = t("cc12"),
        g = t("1cdc"),
        m = t("605d"),
        v = i.setImmediate,
        y = i.clearImmediate,
        w = i.process,
        x = i.Dispatch,
        _ = i.Function,
        k = i.MessageChannel,
        M = i.String,
        C = 0,
        A = {},
        j = "onreadystatechange";
      try {
        n = i.location;
      } catch (E) {}
      var I = function (f) {
          if (l(A, f)) {
            var e = A[f];
            delete A[f], e();
          }
        },
        T = function (f) {
          return function () {
            I(f);
          };
        },
        S = function (f) {
          I(f.data);
        },
        O = function (f) {
          i.postMessage(M(f), n.protocol + "//" + n.host);
        };
      (v && y) ||
        ((v = function (f) {
          var e = b(arguments, 1);
          return (
            (A[++C] = function () {
              s(c(f) ? f : _(f), void 0, e);
            }),
            r(C),
            C
          );
        }),
        (y = function (f) {
          delete A[f];
        }),
        m
          ? (r = function (f) {
              w.nextTick(T(f));
            })
          : x && x.now
          ? (r = function (f) {
              x.now(T(f));
            })
          : k && !g
          ? ((o = new k()),
            (a = o.port2),
            (o.port1.onmessage = S),
            (r = d(a.postMessage, a)))
          : i.addEventListener &&
            c(i.postMessage) &&
            !i.importScripts &&
            n &&
            "file:" !== n.protocol &&
            !u(O)
          ? ((r = O), i.addEventListener("message", S, !1))
          : (r =
              j in h("script")
                ? function (f) {
                    p.appendChild(h("script"))[j] = function () {
                      p.removeChild(this), I(f);
                    };
                  }
                : function (f) {
                    setTimeout(T(f), 0);
                  })),
        (f.exports = { set: v, clear: y });
    },
    "2d00": function (f, e, t) {
      var n,
        r,
        o = t("da84"),
        a = t("342f"),
        i = o.process,
        s = o.Deno,
        d = (i && i.versions) || (s && s.version),
        c = d && d.v8;
      c &&
        ((n = c.split(".")), (r = n[0] > 0 && n[0] < 4 ? 1 : +(n[0] + n[1]))),
        !r &&
          a &&
          ((n = a.match(/Edge\/(\d+)/)),
          (!n || n[1] >= 74) &&
            ((n = a.match(/Chrome\/(\d+)/)), n && (r = +n[1]))),
        (f.exports = r);
    },
    "2d2a": function (f, e, t) {
      var n = t("7bd0");
      n.__esModule && (n = n.default),
        "string" === typeof n && (n = [[f.i, n, ""]]),
        n.locals && (f.exports = n.locals);
      var r = t("499e").default;
      r("39a0f958", n, !0, { sourceMap: !1, shadowMode: !1 });
    },
    "2d7c": function (f, e) {
      function t(f, e) {
        var t = -1,
          n = null == f ? 0 : f.length,
          r = 0,
          o = [];
        while (++t < n) {
          var a = f[t];
          e(a, t, f) && (o[r++] = a);
        }
        return o;
      }
      f.exports = t;
    },
    "2dcb": function (f, e, t) {
      var n = t("91e9"),
        r = n(Object.getPrototypeOf, Object);
      f.exports = r;
    },
    "2e57": function (f, e, t) {
      var n = t("092d");
      n.__esModule && (n = n.default),
        "string" === typeof n && (n = [[f.i, n, ""]]),
        n.locals && (f.exports = n.locals);
      var r = t("499e").default;
      r("2bed1a7c", n, !0, { sourceMap: !1, shadowMode: !1 });
    },
    "2ec1": function (f, e, t) {
      var n = t("100e"),
        r = t("9aff");
      function o(f) {
        return n(function (e, t) {
          var n = -1,
            o = t.length,
            a = o > 1 ? t[o - 1] : void 0,
            i = o > 2 ? t[2] : void 0;
          (a = f.length > 3 && "function" == typeof a ? (o--, a) : void 0),
            i && r(t[0], t[1], i) && ((a = o < 3 ? void 0 : a), (o = 1)),
            (e = Object(e));
          while (++n < o) {
            var s = t[n];
            s && f(e, s, n, a);
          }
          return e;
        });
      }
      f.exports = o;
    },
    "2fcc": function (f, e) {
      function t(f) {
        var e = this.__data__,
          t = e["delete"](f);
        return (this.size = e.size), t;
      }
      f.exports = t;
    },
    "30c9": function (f, e, t) {
      var n = t("9520"),
        r = t("b218");
      function o(f) {
        return null != f && r(f.length) && !n(f);
      }
      f.exports = o;
    },
    "32b3": function (f, e, t) {
      var n = t("872a"),
        r = t("9638"),
        o = Object.prototype,
        a = o.hasOwnProperty;
      function i(f, e, t) {
        var o = f[e];
        (a.call(f, e) && r(o, t) && (void 0 !== t || e in f)) || n(f, e, t);
      }
      f.exports = i;
    },
    "32f4": function (f, e, t) {
      var n = t("2d7c"),
        r = t("d327"),
        o = Object.prototype,
        a = o.propertyIsEnumerable,
        i = Object.getOwnPropertySymbols,
        s = i
          ? function (f) {
              return null == f
                ? []
                : ((f = Object(f)),
                  n(i(f), function (e) {
                    return a.call(f, e);
                  }));
            }
          : r;
      f.exports = s;
    },
    "342f": function (f, e, t) {
      var n = t("d066");
      f.exports = n("navigator", "userAgent") || "";
    },
    "34ac": function (f, e, t) {
      var n = t("9520"),
        r = t("1368"),
        o = t("1a8c"),
        a = t("dc57"),
        i = /[\\^$.*+?()[\]{}|]/g,
        s = /^\[object .+?Constructor\]$/,
        d = Function.prototype,
        c = Object.prototype,
        l = d.toString,
        u = c.hasOwnProperty,
        p = RegExp(
          "^" +
            l
              .call(u)
              .replace(i, "\\$&")
              .replace(
                /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
                "$1.*?"
              ) +
            "$"
        );
      function b(f) {
        if (!o(f) || r(f)) return !1;
        var e = n(f) ? p : s;
        return e.test(a(f));
      }
      f.exports = b;
    },
    "35a1": function (f, e, t) {
      var n = t("f5df"),
        r = t("dc4a"),
        o = t("3f8c"),
        a = t("b622"),
        i = a("iterator");
      f.exports = function (f) {
        if (void 0 != f) return r(f, i) || r(f, "@@iterator") || o[n(f)];
      };
    },
    3698: function (f, e) {
      function t(f, e) {
        return null == f ? void 0 : f[e];
      }
      f.exports = t;
    },
    3715: function (f, e) {
      const t = {
          bold: { delimiter: "*", tag: "strong" },
          italic: { delimiter: "/", tag: "em" },
          underline: { delimiter: "_", tag: "u" },
          strike: { delimiter: "~", tag: "del" },
          code: { delimiter: "`", tag: "code" },
          sup: { delimiter: "^", tag: "sup" },
          sub: { delimiter: "¡", tag: "sub" },
        },
        n = (f) => `<${f}>`,
        r = (f) => `</${f}>`,
        o = (f, e) => `${n(e)}${f}${r(e)}`,
        a = (f, e) => {
          let t = 0,
            n = "";
          while (t < f.length && f[t] !== e) (n += f[t]), t++;
          return t === f.length ? "" : n;
        };
      f.exports = (f, e = t) => {
        e = Object.assign({}, t, e);
        let n = "",
          r = 0;
        const i = () => {
            (n += f[r]), r++;
          },
          s = (f, e) => {
            (n += e + f), (r += f.length);
          },
          d = (e) => {
            if ((r++, " " === f[r])) (n += e.delimiter), i();
            else {
              const t = f.substr(r),
                i = a(t, e.delimiter);
              0 === i.length
                ? s(t, e.delimiter)
                : ((n += o(i, e.tag)), (r += i.length + 1));
            }
          };
        while (r < f.length) {
          const t = f[r];
          t === e.bold.delimiter
            ? d(e.bold)
            : t === e.italic.delimiter
            ? d(e.italic)
            : t === e.underline.delimiter
            ? d(e.underline)
            : t === e.strike.delimiter
            ? d(e.strike)
            : t === e.code.delimiter
            ? d(e.code)
            : t === e.sup.delimiter
            ? d(e.sup)
            : t === e.sub.delimiter
            ? d(e.sub)
            : i();
        }
        return n;
      };
    },
    3729: function (f, e, t) {
      var n = t("9e69"),
        r = t("00fd"),
        o = t("29f3"),
        a = "[object Null]",
        i = "[object Undefined]",
        s = n ? n.toStringTag : void 0;
      function d(f) {
        return null == f
          ? void 0 === f
            ? i
            : a
          : s && s in Object(f)
          ? r(f)
          : o(f);
      }
      f.exports = d;
    },
    "37e8": function (f, e, t) {
      var n = t("83ab"),
        r = t("9bf2"),
        o = t("825a"),
        a = t("fc6a"),
        i = t("df75");
      f.exports = n
        ? Object.defineProperties
        : function (f, e) {
            o(f);
            var t,
              n = a(e),
              s = i(e),
              d = s.length,
              c = 0;
            while (d > c) r.f(f, (t = s[c++]), n[t]);
            return f;
          };
    },
    "387a": function (f, e, t) {
      "use strict";
      t("6408");
    },
    "39ba": function (f, e, t) {
      "use strict";
      t("0a0b");
    },
    "39c2": function (f, e, t) {
      "use strict";
      t("df43");
    },
    "39ff": function (f, e, t) {
      var n = t("0b07"),
        r = t("2b3e"),
        o = n(r, "WeakMap");
      f.exports = o;
    },
    "3a9b": function (f, e, t) {
      var n = t("e330");
      f.exports = n({}.isPrototypeOf);
    },
    "3b4a": function (f, e, t) {
      var n = t("0b07"),
        r = (function () {
          try {
            var f = n(Object, "defineProperty");
            return f({}, "", {}), f;
          } catch (e) {}
        })();
      f.exports = r;
    },
    "3bbe": function (f, e, t) {
      var n = t("da84"),
        r = t("1626"),
        o = n.String,
        a = n.TypeError;
      f.exports = function (f) {
        if ("object" == typeof f || r(f)) return f;
        throw a("Can't set " + o(f) + " as a prototype");
      };
    },
    "3ca3": function (f, e, t) {
      "use strict";
      var n = t("6547").charAt,
        r = t("577e"),
        o = t("69f3"),
        a = t("7dd0"),
        i = "String Iterator",
        s = o.set,
        d = o.getterFor(i);
      a(
        String,
        "String",
        function (f) {
          s(this, { type: i, string: r(f), index: 0 });
        },
        function () {
          var f,
            e = d(this),
            t = e.string,
            r = e.index;
          return r >= t.length
            ? { value: void 0, done: !0 }
            : ((f = n(t, r)), (e.index += f.length), { value: f, done: !1 });
        }
      );
    },
    "3df2": function (f, e) {
      f.exports =
        "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTgiIGhlaWdodD0iMTgiPjxyZWN0IGlkPSJiYWNrZ3JvdW5kcmVjdCIgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgeD0iMCIgeT0iMCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJub25lIi8+PGRlZnM+PHN0eWxlPi5he2ZpbGw6bm9uZTt9LmJ7ZmlsbDojNGU4Y2ZmO30uY3tjbGlwLXBhdGg6dXJsKCNhKTt9LmR7ZmlsbDojZmZmO30uZXtmaWxsOiNlZmY0Zjk7fTwvc3R5bGU+PGNsaXBQYXRoIGlkPSJhIj48cGF0aCBjbGFzcz0iYSIgZD0iTSAwIDAgSCAxNy41NTUgdiAxNy41NTUgSCAwIFoiIGlkPSJzdmdfMSIgdHJhbnNmb3JtPSIiLz48L2NsaXBQYXRoPjwvZGVmcz48ZyBjbGFzcz0iY3VycmVudExheWVyIiBzdHlsZT0iIj48dGl0bGU+TGF5ZXIgMTwvdGl0bGU+PGcgaWQ9InN2Z18yIiBjbGFzcz0ic2VsZWN0ZWQiIHRyYW5zZm9ybT0iIj48ZyBpZD0ic3ZnXzMiIHRyYW5zZm9ybT0iIj48ZyBjbGFzcz0iYyIgaWQ9InN2Z180IiB0cmFuc2Zvcm09IiI+PGcgaWQ9InN2Z181IiB0cmFuc2Zvcm09IiI+PHBhdGggY2xhc3M9ImQiIGQ9Ik0gMTcuNTU2IDguNzc4NDIgYSA4Ljc3OCA4Ljc3OCAwIDAgMCAtOC43NzggLTguNzc4IGEgOC43NzggOC43NzggMCAwIDAgLTguNzc4IDguNzc4IGEgOC43NDUgOC43NDUgMCAwIDAgMi4yNiA1Ljg3OSB2IDEuNDQyIGMgMCAwLjggMC40OTIgMS40NTcgMS4xIDEuNDU3IGggNS44MyBhIDAuODQzIDAuODQzIDAgMCAwIDAuMTgzIC0wLjAyIGEgOC43NzggOC43NzggMCAwIDAgOC4xODQgLTguNzU3IiBpZD0ic3ZnXzYiIHRyYW5zZm9ybT0iIi8+PC9nPjxnIGlkPSJzdmdfNyIgdHJhbnNmb3JtPSIiPjxwYXRoIGNsYXNzPSJlIiBkPSJNIDMuMTYxNDggOC45MjEgYSA5LjI5MiA5LjI5MiAwIDAgMSA2LjM4IC04Ljg4OCBjIC0wLjI1MiAtMC4wMjIgLTAuNTA2IC0wLjAzMyAtMC43NjMgLTAuMDMzIGEgOC43NzQgOC43NzQgMCAwIDAgLTguNzc4IDguNzc4IEEgOS41MDggOS41MDggMCAwIDAgMi4yMjQ0NyAxNC43MDAzIGMgMC4wMDUgMCAwIDAuMDA5IDAgMC4wMSBjIC0wLjMxMSAwLjM1MiAtMS45MjQgMi44NDkgMC4wMjEgMi44NDkgaCAyLjI1IGMgLTEuMjMgLTAuMDIyIDEuMjYzIC0yLjEwNyAwLjI2OSAtMy40OTQgYSA4LjIyNSA4LjIyNSAwIDAgMSAtMS42IC01LjE0MSIgaWQ9InN2Z184IiB0cmFuc2Zvcm09IiIvPjwvZz48L2c+PC9nPjwvZz48L2c+PC9zdmc+";
    },
    "3f8c": function (f, e) {
      f.exports = {};
    },
    "408a": function (f, e, t) {
      var n = t("e330");
      f.exports = n((1).valueOf);
    },
    4160: function (f, e, t) {
      "use strict";
      var n = t("23e7"),
        r = t("17c2");
      n(
        { target: "Array", proto: !0, forced: [].forEach != r },
        { forEach: r }
      );
    },
    "41c3": function (f, e, t) {
      var n = t("1a8c"),
        r = t("eac5"),
        o = t("ec8c"),
        a = Object.prototype,
        i = a.hasOwnProperty;
      function s(f) {
        if (!n(f)) return o(f);
        var e = r(f),
          t = [];
        for (var a in f)
          ("constructor" != a || (!e && i.call(f, a))) && t.push(a);
        return t;
      }
      f.exports = s;
    },
    4245: function (f, e, t) {
      var n = t("1290");
      function r(f, e) {
        var t = f.__data__;
        return n(e) ? t["string" == typeof e ? "string" : "hash"] : t.map;
      }
      f.exports = r;
    },
    42454: function (f, e, t) {
      var n = t("f909"),
        r = t("2ec1"),
        o = r(function (f, e, t) {
          n(f, e, t);
        });
      f.exports = o;
    },
    4284: function (f, e) {
      function t(f, e) {
        var t = -1,
          n = null == f ? 0 : f.length;
        while (++t < n) if (e(f[t], t, f)) return !0;
        return !1;
      }
      f.exports = t;
    },
    "428f": function (f, e, t) {
      var n = t("da84");
      f.exports = n;
    },
    "42a2": function (f, e, t) {
      var n = t("b5a7"),
        r = t("79bc"),
        o = t("1cec"),
        a = t("c869"),
        i = t("39ff"),
        s = t("3729"),
        d = t("dc57"),
        c = "[object Map]",
        l = "[object Object]",
        u = "[object Promise]",
        p = "[object Set]",
        b = "[object WeakMap]",
        h = "[object DataView]",
        g = d(n),
        m = d(r),
        v = d(o),
        y = d(a),
        w = d(i),
        x = s;
      ((n && x(new n(new ArrayBuffer(1))) != h) ||
        (r && x(new r()) != c) ||
        (o && x(o.resolve()) != u) ||
        (a && x(new a()) != p) ||
        (i && x(new i()) != b)) &&
        (x = function (f) {
          var e = s(f),
            t = e == l ? f.constructor : void 0,
            n = t ? d(t) : "";
          if (n)
            switch (n) {
              case g:
                return h;
              case m:
                return c;
              case v:
                return u;
              case y:
                return p;
              case w:
                return b;
            }
          return e;
        }),
        (f.exports = x);
    },
    4359: function (f, e) {
      function t(f, e) {
        var t = -1,
          n = f.length;
        e || (e = Array(n));
        while (++t < n) e[t] = f[t];
        return e;
      }
      f.exports = t;
    },
    "443c": function (f, e, t) {
      var n = t("c54e");
      n.__esModule && (n = n.default),
        "string" === typeof n && (n = [[f.i, n, ""]]),
        n.locals && (f.exports = n.locals);
      var r = t("499e").default;
      r("b134f8f8", n, !0, { sourceMap: !1, shadowMode: !1 });
    },
    "44ad": function (f, e, t) {
      var n = t("da84"),
        r = t("e330"),
        o = t("d039"),
        a = t("c6b6"),
        i = n.Object,
        s = r("".split);
      f.exports = o(function () {
        return !i("z").propertyIsEnumerable(0);
      })
        ? function (f) {
            return "String" == a(f) ? s(f, "") : i(f);
          }
        : i;
    },
    "44d2": function (f, e, t) {
      var n = t("b622"),
        r = t("7c73"),
        o = t("9bf2"),
        a = n("unscopables"),
        i = Array.prototype;
      void 0 == i[a] && o.f(i, a, { configurable: !0, value: r(null) }),
        (f.exports = function (f) {
          i[a][f] = !0;
        });
    },
    "44de": function (f, e, t) {
      var n = t("da84");
      f.exports = function (f, e) {
        var t = n.console;
        t && t.error && (1 == arguments.length ? t.error(f) : t.error(f, e));
      };
    },
    "44e7": function (f, e, t) {
      var n = t("861d"),
        r = t("c6b6"),
        o = t("b622"),
        a = o("match");
      f.exports = function (f) {
        var e;
        return n(f) && (void 0 !== (e = f[a]) ? !!e : "RegExp" == r(f));
      };
    },
    "456a": function (f, e, t) {
      "use strict";
      t("1738");
    },
    "466d": function (f, e, t) {
      "use strict";
      var n = t("c65b"),
        r = t("d784"),
        o = t("825a"),
        a = t("50c4"),
        i = t("577e"),
        s = t("1d80"),
        d = t("dc4a"),
        c = t("8aa5"),
        l = t("14c3");
      r("match", function (f, e, t) {
        return [
          function (e) {
            var t = s(this),
              r = void 0 == e ? void 0 : d(e, f);
            return r ? n(r, e, t) : new RegExp(e)[f](i(t));
          },
          function (f) {
            var n = o(this),
              r = i(f),
              s = t(e, n, r);
            if (s.done) return s.value;
            if (!n.global) return l(n, r);
            var d = n.unicode;
            n.lastIndex = 0;
            var u,
              p = [],
              b = 0;
            while (null !== (u = l(n, r))) {
              var h = i(u[0]);
              (p[b] = h),
                "" === h && (n.lastIndex = c(r, a(n.lastIndex), d)),
                b++;
            }
            return 0 === b ? null : p;
          },
        ];
      });
    },
    "46c7": function (f, e) {
      f.exports =
        "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTguMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgNTYgNTYiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDU2IDU2OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnIGlkPSJzdmdfMSI+CiAgIDxwYXRoIGlkPSJzdmdfMiIgZmlsbD0iI0U5RTlFMCIgZD0ibTM2Ljk4NSwwbC0yOS4wMjIsMGMtMC44MDgsMCAtMS40NjMsMC42NTUgLTEuNDYzLDEuOTI2bDAsNTMuMDc0YzAsMC4zNDUgMC42NTUsMSAxLjQ2MywxbDQwLjA3NCwwYzAuODA4LDAgMS40NjMsLTAuNjU1IDEuNDYzLC0xbDAsLTQyLjAyMmMwLC0wLjY5NiAtMC4wOTMsLTAuOTIgLTAuMjU3LC0xLjA4NWwtMTEuNjM2LC0xMS42MzZjLTAuMTY1LC0wLjE2NCAtMC4zODksLTAuMjU3IC0wLjYyMiwtMC4yNTd6Ii8+CiAgIDxwb2x5Z29uIGlkPSJzdmdfMyIgZmlsbD0iI0Q5RDdDQSIgcG9pbnRzPSIzNy41LDAuMTUxIDM3LjUsMTIgNDkuMzQ5LDEyICAiLz4KICAgPHBhdGggaWQ9InN2Z180IiBmaWxsPSIjOTVBNUE1IiBkPSJtNDguMDM3LDU2bC00MC4wNzQsMGMtMC44MDgsMCAtMS40NjMsLTAuNjU1IC0xLjQ2MywtMS40NjNsMCwtMTUuNTM3bDQzLDBsMCwxNS41MzdjMCwwLjgwOCAtMC42NTUsMS40NjMgLTEuNDYzLDEuNDYzeiIvPgogICA8cGF0aCBpZD0ic3ZnXzkiIGZpbGw9IiNDOEJEQjgiIGQ9Im0xOC41LDEzbC02LDBjLTAuNTUzLDAgLTEsLTAuNDQ4IC0xLC0xczAuNDQ3LC0xIDEsLTFsNiwwYzAuNTUzLDAgMSwwLjQ0OCAxLDFzLTAuNDQ3LDEgLTEsMXoiLz4KICAgPHBhdGggaWQ9InN2Z18xMCIgZmlsbD0iI0M4QkRCOCIgZD0ibTIxLjUsMThsLTksMGMtMC41NTMsMCAtMSwtMC40NDggLTEsLTFzMC40NDcsLTEgMSwtMWw5LDBjMC41NTMsMCAxLDAuNDQ4IDEsMXMtMC40NDcsMSAtMSwxeiIvPgogICA8cGF0aCBpZD0ic3ZnXzExIiBmaWxsPSIjQzhCREI4IiBkPSJtMjUuNSwxOGMtMC4yNiwwIC0wLjUyMSwtMC4xMSAtMC43MSwtMC4yOWMtMC4xODEsLTAuMTkgLTAuMjksLTAuNDQgLTAuMjksLTAuNzFzMC4xMDksLTAuNTIgMC4zLC0wLjcxYzAuMzYsLTAuMzcgMS4wNCwtMC4zNyAxLjQxLDBjMC4xOCwwLjE5IDAuMjksMC40NSAwLjI5LDAuNzFjMCwwLjI2IC0wLjExLDAuNTIgLTAuMjksMC43MWMtMC4xOSwwLjE4IC0wLjQ1LDAuMjkgLTAuNzEsMC4yOXoiLz4KICAgPHBhdGggaWQ9InN2Z18xMiIgZmlsbD0iI0M4QkRCOCIgZD0ibTM3LjUsMThsLTgsMGMtMC41NTMsMCAtMSwtMC40NDggLTEsLTFzMC40NDcsLTEgMSwtMWw4LDBjMC41NTMsMCAxLDAuNDQ4IDEsMXMtMC40NDcsMSAtMSwxeiIvPgogICA8cGF0aCBpZD0ic3ZnXzEzIiBmaWxsPSIjQzhCREI4IiBkPSJtMTIuNSwzM2MtMC4yNiwwIC0wLjUyMSwtMC4xMSAtMC43MSwtMC4yOWMtMC4xODEsLTAuMTkgLTAuMjksLTAuNDUgLTAuMjksLTAuNzFjMCwtMC4yNiAwLjEwOSwtMC41MiAwLjI5LC0wLjcxYzAuMzcsLTAuMzcgMS4wNSwtMC4zNyAxLjQyLDAuMDFjMC4xOCwwLjE4IDAuMjksMC40NCAwLjI5LDAuN2MwLDAuMjYgLTAuMTEsMC41MiAtMC4yOSwwLjcxYy0wLjE5LDAuMTggLTAuNDUsMC4yOSAtMC43MSwwLjI5eiIvPgogICA8cGF0aCBpZD0ic3ZnXzE0IiBmaWxsPSIjQzhCREI4IiBkPSJtMjQuNSwzM2wtOCwwYy0wLjU1MywwIC0xLC0wLjQ0OCAtMSwtMXMwLjQ0NywtMSAxLC0xbDgsMGMwLjU1MywwIDEsMC40NDggMSwxcy0wLjQ0NywxIC0xLDF6Ii8+CiAgIDxwYXRoIGlkPSJzdmdfMTUiIGZpbGw9IiNDOEJEQjgiIGQ9Im00My41LDE4bC0yLDBjLTAuNTUzLDAgLTEsLTAuNDQ4IC0xLC0xczAuNDQ3LC0xIDEsLTFsMiwwYzAuNTUzLDAgMSwwLjQ0OCAxLDFzLTAuNDQ3LDEgLTEsMXoiLz4KICAgPHBhdGggaWQ9InN2Z18xNiIgZmlsbD0iI0M4QkRCOCIgZD0ibTM0LjUsMjNsLTIyLDBjLTAuNTUzLDAgLTEsLTAuNDQ4IC0xLC0xczAuNDQ3LC0xIDEsLTFsMjIsMGMwLjU1MywwIDEsMC40NDggMSwxcy0wLjQ0NywxIC0xLDF6Ii8+CiAgIDxwYXRoIGlkPSJzdmdfMTciIGZpbGw9IiNDOEJEQjgiIGQ9Im00My41LDIzbC02LDBjLTAuNTUzLDAgLTEsLTAuNDQ4IC0xLC0xczAuNDQ3LC0xIDEsLTFsNiwwYzAuNTUzLDAgMSwwLjQ0OCAxLDFzLTAuNDQ3LDEgLTEsMXoiLz4KICAgPHBhdGggaWQ9InN2Z18xOCIgZmlsbD0iI0M4QkRCOCIgZD0ibTE2LjUsMjhsLTQsMGMtMC41NTMsMCAtMSwtMC40NDggLTEsLTFzMC40NDcsLTEgMSwtMWw0LDBjMC41NTMsMCAxLDAuNDQ4IDEsMXMtMC40NDcsMSAtMSwxeiIvPgogICA8cGF0aCBpZD0ic3ZnXzE5IiBmaWxsPSIjQzhCREI4IiBkPSJtMzAuNSwyOGwtMTAsMGMtMC41NTMsMCAtMSwtMC40NDggLTEsLTFzMC40NDcsLTEgMSwtMWwxMCwwYzAuNTUzLDAgMSwwLjQ0OCAxLDFzLTAuNDQ3LDEgLTEsMXoiLz4KICAgPHBhdGggaWQ9InN2Z18yMCIgZmlsbD0iI0M4QkRCOCIgZD0ibTQzLjUsMjhsLTksMGMtMC41NTMsMCAtMSwtMC40NDggLTEsLTFzMC40NDcsLTEgMSwtMWw5LDBjMC41NTMsMCAxLDAuNDQ4IDEsMXMtMC40NDcsMSAtMSwxeiIvPgogIDwvZz4KICA8ZyBpZD0ic3ZnXzIxIi8+CiAgPGcgaWQ9InN2Z18yMiIvPgogIDxnIGlkPSJzdmdfMjMiLz4KICA8ZyBpZD0ic3ZnXzI0Ii8+CiAgPGcgaWQ9InN2Z18yNSIvPgogIDxnIGlkPSJzdmdfMjYiLz4KICA8ZyBpZD0ic3ZnXzI3Ii8+CiAgPGcgaWQ9InN2Z18yOCIvPgogIDxnIGlkPSJzdmdfMjkiLz4KICA8ZyBpZD0ic3ZnXzMwIi8+CiAgPGcgaWQ9InN2Z18zMSIvPgogIDxnIGlkPSJzdmdfMzIiLz4KICA8ZyBpZD0ic3ZnXzMzIi8+CiAgPGcgaWQ9InN2Z18zNCIvPgogIDxnIGlkPSJzdmdfMzUiLz4KPC9zdmc+";
    },
    4795: function (f, e, t) {
      var n = t("23e7"),
        r = t("da84"),
        o = t("2ba4"),
        a = t("1626"),
        i = t("342f"),
        s = t("f36a"),
        d = /MSIE .\./.test(i),
        c = r.Function,
        l = function (f) {
          return function (e, t) {
            var n = arguments.length > 2,
              r = n ? s(arguments, 2) : void 0;
            return f(
              n
                ? function () {
                    o(a(e) ? e : c(e), this, r);
                  }
                : e,
              t
            );
          };
        };
      n(
        { global: !0, bind: !0, forced: d },
        { setTimeout: l(r.setTimeout), setInterval: l(r.setInterval) }
      );
    },
    4840: function (f, e, t) {
      var n = t("825a"),
        r = t("5087"),
        o = t("b622"),
        a = o("species");
      f.exports = function (f, e) {
        var t,
          o = n(f).constructor;
        return void 0 === o || void 0 == (t = n(o)[a]) ? e : r(t);
      };
    },
    "485a": function (f, e, t) {
      var n = t("da84"),
        r = t("c65b"),
        o = t("1626"),
        a = t("861d"),
        i = n.TypeError;
      f.exports = function (f, e) {
        var t, n;
        if ("string" === e && o((t = f.toString)) && !a((n = r(t, f))))
          return n;
        if (o((t = f.valueOf)) && !a((n = r(t, f)))) return n;
        if ("string" !== e && o((t = f.toString)) && !a((n = r(t, f))))
          return n;
        throw i("Can't convert object to primitive value");
      };
    },
    4930: function (f, e, t) {
      var n = t("2d00"),
        r = t("d039");
      f.exports =
        !!Object.getOwnPropertySymbols &&
        !r(function () {
          var f = Symbol();
          return (
            !String(f) ||
            !(Object(f) instanceof Symbol) ||
            (!Symbol.sham && n && n < 41)
          );
        });
    },
    "498a": function (f, e, t) {
      "use strict";
      var n = t("23e7"),
        r = t("58a8").trim,
        o = t("c8d2");
      n(
        { target: "String", proto: !0, forced: o("trim") },
        {
          trim: function () {
            return r(this);
          },
        }
      );
    },
    "499e": function (f, e, t) {
      "use strict";
      function n(f, e) {
        for (var t = [], n = {}, r = 0; r < e.length; r++) {
          var o = e[r],
            a = o[0],
            i = o[1],
            s = o[2],
            d = o[3],
            c = { id: f + ":" + r, css: i, media: s, sourceMap: d };
          n[a] ? n[a].parts.push(c) : t.push((n[a] = { id: a, parts: [c] }));
        }
        return t;
      }
      t.r(e),
        t.d(e, "default", function () {
          return b;
        });
      var r = "undefined" !== typeof document;
      if ("undefined" !== typeof DEBUG && DEBUG && !r)
        throw new Error(
          "vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
        );
      var o = {},
        a = r && (document.head || document.getElementsByTagName("head")[0]),
        i = null,
        s = 0,
        d = !1,
        c = function () {},
        l = null,
        u = "data-vue-ssr-id",
        p =
          "undefined" !== typeof navigator &&
          /msie [6-9]\b/.test(navigator.userAgent.toLowerCase());
      function b(f, e, t, r) {
        (d = t), (l = r || {});
        var a = n(f, e);
        return (
          h(a),
          function (e) {
            for (var t = [], r = 0; r < a.length; r++) {
              var i = a[r],
                s = o[i.id];
              s.refs--, t.push(s);
            }
            e ? ((a = n(f, e)), h(a)) : (a = []);
            for (r = 0; r < t.length; r++) {
              s = t[r];
              if (0 === s.refs) {
                for (var d = 0; d < s.parts.length; d++) s.parts[d]();
                delete o[s.id];
              }
            }
          }
        );
      }
      function h(f) {
        for (var e = 0; e < f.length; e++) {
          var t = f[e],
            n = o[t.id];
          if (n) {
            n.refs++;
            for (var r = 0; r < n.parts.length; r++) n.parts[r](t.parts[r]);
            for (; r < t.parts.length; r++) n.parts.push(m(t.parts[r]));
            n.parts.length > t.parts.length &&
              (n.parts.length = t.parts.length);
          } else {
            var a = [];
            for (r = 0; r < t.parts.length; r++) a.push(m(t.parts[r]));
            o[t.id] = { id: t.id, refs: 1, parts: a };
          }
        }
      }
      function g() {
        var f = document.createElement("style");
        return (f.type = "text/css"), a.appendChild(f), f;
      }
      function m(f) {
        var e,
          t,
          n = document.querySelector("style[" + u + '~="' + f.id + '"]');
        if (n) {
          if (d) return c;
          n.parentNode.removeChild(n);
        }
        if (p) {
          var r = s++;
          (n = i || (i = g())),
            (e = y.bind(null, n, r, !1)),
            (t = y.bind(null, n, r, !0));
        } else
          (n = g()),
            (e = w.bind(null, n)),
            (t = function () {
              n.parentNode.removeChild(n);
            });
        return (
          e(f),
          function (n) {
            if (n) {
              if (
                n.css === f.css &&
                n.media === f.media &&
                n.sourceMap === f.sourceMap
              )
                return;
              e((f = n));
            } else t();
          }
        );
      }
      var v = (function () {
        var f = [];
        return function (e, t) {
          return (f[e] = t), f.filter(Boolean).join("\n");
        };
      })();
      function y(f, e, t, n) {
        var r = t ? "" : n.css;
        if (f.styleSheet) f.styleSheet.cssText = v(e, r);
        else {
          var o = document.createTextNode(r),
            a = f.childNodes;
          a[e] && f.removeChild(a[e]),
            a.length ? f.insertBefore(o, a[e]) : f.appendChild(o);
        }
      }
      function w(f, e) {
        var t = e.css,
          n = e.media,
          r = e.sourceMap;
        if (
          (n && f.setAttribute("media", n),
          l.ssrId && f.setAttribute(u, e.id),
          r &&
            ((t += "\n/*# sourceURL=" + r.sources[0] + " */"),
            (t +=
              "\n/*# sourceMappingURL=data:application/json;base64," +
              btoa(unescape(encodeURIComponent(JSON.stringify(r)))) +
              " */")),
          f.styleSheet)
        )
          f.styleSheet.cssText = t;
        else {
          while (f.firstChild) f.removeChild(f.firstChild);
          f.appendChild(document.createTextNode(t));
        }
      }
    },
    "49f4": function (f, e, t) {
      var n = t("6044");
      function r() {
        (this.__data__ = n ? n(null) : {}), (this.size = 0);
      }
      f.exports = r;
    },
    "4b27": function (f, e, t) {
      var n = t("24fb");
      (e = n(!1)),
        e.push([
          f.i,
          ".user-list[data-v-30547438]{height:100%;overflow:auto;padding-left:5px;padding-top:8px}.img-msg[data-v-30547438]{border-radius:50%;width:50px;margin-right:5px}.user-element[data-v-30547438]{font-size:20px;vertical-align:middle}",
          "",
        ]),
        (f.exports = e);
    },
    "4d1c": function (f, e, t) {
      var n = t("24fb");
      (e = n(!1)),
        e.push([
          f.i,
          '.sc-launcher[data-v-e889f236]{background-position:50%;background-repeat:no-repeat;position:fixed;right:90px;bottom:25px;box-shadow:none;cursor:pointer}.sc-launcher[data-v-e889f236],.sc-launcher[data-v-e889f236]:before{width:60px;height:60px;border-radius:50%;transition:box-shadow .2s ease-in-out}.sc-launcher[data-v-e889f236]:before{content:"";position:relative;display:block}.sc-launcher .sc-closed-icon[data-v-e889f236],.sc-launcher .sc-open-icon[data-v-e889f236]{position:fixed;right:90px;bottom:25px;display:flex}.sc-launcher .sc-closed-icon[data-v-e889f236],.sc-launcher .sc-open-icon[data-v-e889f236]{width:60px;height:60px;transition:opacity .1s ease-in-out,transform .1s ease-in-out}.sc-launcher .sc-open-icon[data-v-e889f236]{padding:5px;box-sizing:border-box;opacity:1}.sc-launcher.opened .sc-open-icon[data-v-e889f236]{opacity:1}.sc-launcher.opened .sc-closed-icon[data-v-e889f236]{transform:rotate(-90deg);opacity:1}.sc-launcher.opened[data-v-e889f236]:before{box-shadow:0 0 400px 250px rgba(148,149,150,.2)}.sc-launcher[data-v-e889f236]:hover{box-shadow:0 0 27px 1.5px rgba(0,0,0,.2)}.sc-new-messsages-count[data-v-e889f236]{position:absolute;top:-3px;left:41px;display:flex;justify-content:center;flex-direction:column;border-radius:50%;width:22px;height:22px;background:#ff4646;color:#fff;text-align:center;margin:auto;font-size:12px;font-weight:500}@-webkit-keyframes shockwaveJump-data-v-e889f236{0%{transform:scale(1)}40%{transform:scale(1.2)}50%{transform:scale(.9)}55%{transform:scale(1.1)}60%{transform:scale(.9)}to{transform:scale(1)}}@keyframes shockwaveJump-data-v-e889f236{0%{transform:scale(1)}40%{transform:scale(1.2)}50%{transform:scale(.9)}55%{transform:scale(1.1)}60%{transform:scale(.9)}to{transform:scale(1)}}@-webkit-keyframes shockwave-data-v-e889f236{0%{transform:scale(1);box-shadow:0 0 2px rgba(0,0,0,.15),inset 0 0 1px rgba(0,0,0,.15)}95%{box-shadow:0 0 50px transparent,inset 0 0 30px transparent}to{transform:scale(2.25)}}@keyframes shockwave-data-v-e889f236{0%{transform:scale(1);box-shadow:0 0 2px rgba(0,0,0,.15),inset 0 0 1px rgba(0,0,0,.15)}95%{box-shadow:0 0 50px transparent,inset 0 0 30px transparent}to{transform:scale(2.25)}}.shockwave[data-v-e889f236]{-webkit-animation:shockwaveJump-data-v-e889f236 1s ease-out 5;animation:shockwaveJump-data-v-e889f236 1s ease-out 5}.shockwave[data-v-e889f236]:after{-webkit-animation:shockwave-data-v-e889f236 1s ease-out .65s 5;animation:shockwave-data-v-e889f236 1s ease-out .65s 5}.shockwave[data-v-e889f236]:after,.shockwave[data-v-e889f236]:before{content:"";position:absolute;top:0;left:0;bottom:0;right:0;border-radius:50%}.shockwave[data-v-e889f236]:before{-webkit-animation:shockwave-data-v-e889f236 1s ease-out .5s 5;animation:shockwave-data-v-e889f236 1s ease-out .5s 5}',
          "",
        ]),
        (f.exports = e);
    },
    "4d64": function (f, e, t) {
      var n = t("fc6a"),
        r = t("23cb"),
        o = t("07fa"),
        a = function (f) {
          return function (e, t, a) {
            var i,
              s = n(e),
              d = o(s),
              c = r(a, d);
            if (f && t != t) {
              while (d > c) if (((i = s[c++]), i != i)) return !0;
            } else
              for (; d > c; c++)
                if ((f || c in s) && s[c] === t) return f || c || 0;
            return !f && -1;
          };
        };
      f.exports = { includes: a(!0), indexOf: a(!1) };
    },
    "4dae": function (f, e, t) {
      var n = t("da84"),
        r = t("23cb"),
        o = t("07fa"),
        a = t("8418"),
        i = n.Array,
        s = Math.max;
      f.exports = function (f, e, t) {
        for (
          var n = o(f),
            d = r(e, n),
            c = r(void 0 === t ? n : t, n),
            l = i(s(c - d, 0)),
            u = 0;
          d < c;
          d++, u++
        )
          a(l, u, f[d]);
        return (l.length = u), l;
      };
    },
    "4de4": function (f, e, t) {
      "use strict";
      var n = t("23e7"),
        r = t("b727").filter,
        o = t("1dde"),
        a = o("filter");
      n(
        { target: "Array", proto: !0, forced: !a },
        {
          filter: function (f) {
            return r(this, f, arguments.length > 1 ? arguments[1] : void 0);
          },
        }
      );
    },
    "4f50": function (f, e, t) {
      var n = t("b760"),
        r = t("e5383"),
        o = t("c8fe"),
        a = t("4359"),
        i = t("fa21"),
        s = t("d370"),
        d = t("6747"),
        c = t("dcbe"),
        l = t("0d24"),
        u = t("9520"),
        p = t("1a8c"),
        b = t("60ed"),
        h = t("73ac"),
        g = t("8adb"),
        m = t("8de2");
      function v(f, e, t, v, y, w, x) {
        var _ = g(f, t),
          k = g(e, t),
          M = x.get(k);
        if (M) n(f, t, M);
        else {
          var C = w ? w(_, k, t + "", f, e, x) : void 0,
            A = void 0 === C;
          if (A) {
            var j = d(k),
              I = !j && l(k),
              T = !j && !I && h(k);
            (C = k),
              j || I || T
                ? d(_)
                  ? (C = _)
                  : c(_)
                  ? (C = a(_))
                  : I
                  ? ((A = !1), (C = r(k, !0)))
                  : T
                  ? ((A = !1), (C = o(k, !0)))
                  : (C = [])
                : b(k) || s(k)
                ? ((C = _), s(_) ? (C = m(_)) : (p(_) && !u(_)) || (C = i(k)))
                : (A = !1);
          }
          A && (x.set(k, C), y(C, k, v, w, x), x["delete"](k)), n(f, t, C);
        }
      }
      f.exports = v;
    },
    5087: function (f, e, t) {
      var n = t("da84"),
        r = t("68ee"),
        o = t("0d51"),
        a = n.TypeError;
      f.exports = function (f) {
        if (r(f)) return f;
        throw a(o(f) + " is not a constructor");
      };
    },
    "50c4": function (f, e, t) {
      var n = t("5926"),
        r = Math.min;
      f.exports = function (f) {
        return f > 0 ? r(n(f), 9007199254740991) : 0;
      };
    },
    "50d8": function (f, e) {
      function t(f, e) {
        var t = -1,
          n = Array(f);
        while (++t < f) n[t] = e(t);
        return n;
      }
      f.exports = t;
    },
    "55a3": function (f, e) {
      function t(f) {
        return this.__data__.has(f);
      }
      f.exports = t;
    },
    5692: function (f, e, t) {
      var n = t("c430"),
        r = t("c6cd");
      (f.exports = function (f, e) {
        return r[f] || (r[f] = void 0 !== e ? e : {});
      })("versions", []).push({
        version: "3.19.2",
        mode: n ? "pure" : "global",
        copyright: "© 2021 Denis Pushkarev (zloirock.ru)",
      });
    },
    "56ef": function (f, e, t) {
      var n = t("d066"),
        r = t("e330"),
        o = t("241c"),
        a = t("7418"),
        i = t("825a"),
        s = r([].concat);
      f.exports =
        n("Reflect", "ownKeys") ||
        function (f) {
          var e = o.f(i(f)),
            t = a.f;
          return t ? s(e, t(f)) : e;
        };
    },
    "577e": function (f, e, t) {
      var n = t("da84"),
        r = t("f5df"),
        o = n.String;
      f.exports = function (f) {
        if ("Symbol" === r(f))
          throw TypeError("Cannot convert a Symbol value to a string");
        return o(f);
      };
    },
    "57a5": function (f, e, t) {
      var n = t("91e9"),
        r = n(Object.keys, Object);
      f.exports = r;
    },
    "585a": function (f, e, t) {
      (function (e) {
        var t = "object" == typeof e && e && e.Object === Object && e;
        f.exports = t;
      }).call(this, t("c8ba"));
    },
    "586d": function (f, e, t) {
      "use strict";
      t("2938");
    },
    5899: function (f, e) {
      f.exports = "\t\n\v\f\r                　\u2028\u2029\ufeff";
    },
    "58a8": function (f, e, t) {
      var n = t("e330"),
        r = t("1d80"),
        o = t("577e"),
        a = t("5899"),
        i = n("".replace),
        s = "[" + a + "]",
        d = RegExp("^" + s + s + "*"),
        c = RegExp(s + s + "*$"),
        l = function (f) {
          return function (e) {
            var t = o(r(e));
            return 1 & f && (t = i(t, d, "")), 2 & f && (t = i(t, c, "")), t;
          };
        };
      f.exports = { start: l(1), end: l(2), trim: l(3) };
    },
    5926: function (f, e) {
      var t = Math.ceil,
        n = Math.floor;
      f.exports = function (f) {
        var e = +f;
        return e !== e || 0 === e ? 0 : (e > 0 ? n : t)(e);
      };
    },
    "59ed": function (f, e, t) {
      var n = t("da84"),
        r = t("1626"),
        o = t("0d51"),
        a = n.TypeError;
      f.exports = function (f) {
        if (r(f)) return f;
        throw a(o(f) + " is not a function");
      };
    },
    "5a34": function (f, e, t) {
      var n = t("da84"),
        r = t("44e7"),
        o = n.TypeError;
      f.exports = function (f) {
        if (r(f)) throw o("The method doesn't accept regular expressions");
        return f;
      };
    },
    "5bc3": function (f, e, t) {
      function n(f, e) {
        for (var t = 0; t < e.length; t++) {
          var n = e[t];
          (n.enumerable = n.enumerable || !1),
            (n.configurable = !0),
            "value" in n && (n.writable = !0),
            Object.defineProperty(f, n.key, n);
        }
      }
      function r(f, e, t) {
        return e && n(f.prototype, e), t && n(f, t), f;
      }
      t("7a82"),
        (f.exports = r),
        (f.exports["default"] = f.exports),
        (f.exports.__esModule = !0);
    },
    "5c6c": function (f, e) {
      f.exports = function (f, e) {
        return {
          enumerable: !(1 & f),
          configurable: !(2 & f),
          writable: !(4 & f),
          value: e,
        };
      };
    },
    "5e2e": function (f, e, t) {
      var n = t("28c9"),
        r = t("69d5"),
        o = t("b4c0"),
        a = t("fba5"),
        i = t("67ca");
      function s(f) {
        var e = -1,
          t = null == f ? 0 : f.length;
        this.clear();
        while (++e < t) {
          var n = f[e];
          this.set(n[0], n[1]);
        }
      }
      (s.prototype.clear = n),
        (s.prototype["delete"] = r),
        (s.prototype.get = o),
        (s.prototype.has = a),
        (s.prototype.set = i),
        (f.exports = s);
    },
    "5e5f": function (f, e, t) {
      var n = t("24fb");
      (e = n(!1)),
        e.push([
          f.i,
          ".sc-header[data-v-12a03780]{min-height:65px;border-top-left-radius:9px;border-top-right-radius:9px;padding:10px 15px;box-shadow:0 1px 4px rgba(0,0,0,.2);position:relative;box-sizing:border-box;display:flex;align-content:center}.sc-header--img[data-v-12a03780]{border-radius:50%;align-self:center;padding:6px;max-width:35px;max-height:35px;background-color:#d3d3d3}.sc-header--close-button[data-v-12a03780]{width:40px;align-self:center;height:40px;box-sizing:border-box;cursor:pointer;border-radius:5px;margin-left:auto}.sc-header--close-button img[data-v-12a03780]{width:100%;height:100%;padding:13px;box-sizing:border-box}@media (max-width:450px){.sc-header[data-v-12a03780]{border-radius:0}}.sc-header--username[data-v-12a03780]{margin-left:9px;display:flex;flex-direction:column;justify-content:center}.sc-header--username--name[data-v-12a03780]{color:#fff;font-weight:600;font-size:18px}.sc-header--username--status[data-v-12a03780]{color:#c8c8c8;font-size:14px}",
          "",
        ]),
        (f.exports = e);
    },
    "5e77": function (f, e, t) {
      var n = t("83ab"),
        r = t("1a2d"),
        o = Function.prototype,
        a = n && Object.getOwnPropertyDescriptor,
        i = r(o, "name"),
        s = i && "something" === function () {}.name,
        d = i && (!n || (n && a(o, "name").configurable));
      f.exports = { EXISTS: i, PROPER: s, CONFIGURABLE: d };
    },
    6044: function (f, e, t) {
      var n = t("0b07"),
        r = n(Object, "create");
      f.exports = r;
    },
    "605d": function (f, e, t) {
      var n = t("c6b6"),
        r = t("da84");
      f.exports = "process" == n(r.process);
    },
    6069: function (f, e) {
      f.exports = "object" == typeof window;
    },
    "60da": function (f, e, t) {
      "use strict";
      var n = t("83ab"),
        r = t("e330"),
        o = t("c65b"),
        a = t("d039"),
        i = t("df75"),
        s = t("7418"),
        d = t("d1e7"),
        c = t("7b0b"),
        l = t("44ad"),
        u = Object.assign,
        p = Object.defineProperty,
        b = r([].concat);
      f.exports =
        !u ||
        a(function () {
          if (
            n &&
            1 !==
              u(
                { b: 1 },
                u(
                  p({}, "a", {
                    enumerable: !0,
                    get: function () {
                      p(this, "b", { value: 3, enumerable: !1 });
                    },
                  }),
                  { b: 2 }
                )
              ).b
          )
            return !0;
          var f = {},
            e = {},
            t = Symbol(),
            r = "abcdefghijklmnopqrst";
          return (
            (f[t] = 7),
            r.split("").forEach(function (f) {
              e[f] = f;
            }),
            7 != u({}, f)[t] || i(u({}, e)).join("") != r
          );
        })
          ? function (f, e) {
              var t = c(f),
                r = arguments.length,
                a = 1,
                u = s.f,
                p = d.f;
              while (r > a) {
                var h,
                  g = l(arguments[a++]),
                  m = u ? b(i(g), u(g)) : i(g),
                  v = m.length,
                  y = 0;
                while (v > y) (h = m[y++]), (n && !o(p, g, h)) || (t[h] = g[h]);
              }
              return t;
            }
          : u;
    },
    "60ed": function (f, e, t) {
      var n = t("3729"),
        r = t("2dcb"),
        o = t("1310"),
        a = "[object Object]",
        i = Function.prototype,
        s = Object.prototype,
        d = i.toString,
        c = s.hasOwnProperty,
        l = d.call(Object);
      function u(f) {
        if (!o(f) || n(f) != a) return !1;
        var e = r(f);
        if (null === e) return !0;
        var t = c.call(e, "constructor") && e.constructor;
        return "function" == typeof t && t instanceof t && d.call(t) == l;
      }
      f.exports = u;
    },
    6250: function (f, e, t) {
      "use strict";
      t("6d0b");
    },
    "62e4": function (f, e) {
      f.exports = function (f) {
        return (
          f.webpackPolyfill ||
            ((f.deprecate = function () {}),
            (f.paths = []),
            f.children || (f.children = []),
            Object.defineProperty(f, "loaded", {
              enumerable: !0,
              get: function () {
                return f.l;
              },
            }),
            Object.defineProperty(f, "id", {
              enumerable: !0,
              get: function () {
                return f.i;
              },
            }),
            (f.webpackPolyfill = 1)),
          f
        );
      };
    },
    6306: function (f, e, t) {
      var n = t("24fb");
      (e = n(!1)),
        e.push([
          f.i,
          ".sc-message-list[data-v-1c13b751]{height:80%;overflow-y:auto;background-size:100%;padding:20px 20px 40px 20px}.sc-bot-info-area[data-v-1c13b751]{text-align:center;padding:20px 0}.sc-bot-info--title[data-v-1c13b751]{font-size:15px;font-weight:600;padding:10px;margin:-12px 0;color:#000}.sc-bot-info--subtitle[data-v-1c13b751]{font-size:13px;font-weight:500;padding:5px;margin:0;color:rgba(0,0,0,.5647058823529412)}.sc-logo[data-v-1c13b751]{max-width:100px;max-height:100px}",
          "",
        ]),
        (f.exports = e);
    },
    "634c": function (f, e, t) {
      var n = t("d57d");
      n.__esModule && (n = n.default),
        "string" === typeof n && (n = [[f.i, n, ""]]),
        n.locals && (f.exports = n.locals);
      var r = t("499e").default;
      r("36c161dd", n, !0, { sourceMap: !1, shadowMode: !1 });
    },
    "63ea": function (f, e, t) {
      var n = t("c05f");
      function r(f, e) {
        return n(f, e);
      }
      f.exports = r;
    },
    6408: function (f, e, t) {
      var n = t("4b27");
      n.__esModule && (n = n.default),
        "string" === typeof n && (n = [[f.i, n, ""]]),
        n.locals && (f.exports = n.locals);
      var r = t("499e").default;
      r("bc63b5e0", n, !0, { sourceMap: !1, shadowMode: !1 });
    },
    6547: function (f, e, t) {
      var n = t("e330"),
        r = t("5926"),
        o = t("577e"),
        a = t("1d80"),
        i = n("".charAt),
        s = n("".charCodeAt),
        d = n("".slice),
        c = function (f) {
          return function (e, t) {
            var n,
              c,
              l = o(a(e)),
              u = r(t),
              p = l.length;
            return u < 0 || u >= p
              ? f
                ? ""
                : void 0
              : ((n = s(l, u)),
                n < 55296 ||
                n > 56319 ||
                u + 1 === p ||
                (c = s(l, u + 1)) < 56320 ||
                c > 57343
                  ? f
                    ? i(l, u)
                    : n
                  : f
                  ? d(l, u, u + 2)
                  : c - 56320 + ((n - 55296) << 10) + 65536);
          };
        };
      f.exports = { codeAt: c(!1), charAt: c(!0) };
    },
    "65f0": function (f, e, t) {
      var n = t("0b42");
      f.exports = function (f, e) {
        return new (n(f))(0 === e ? 0 : e);
      };
    },
    6747: function (f, e) {
      var t = Array.isArray;
      f.exports = t;
    },
    "67ca": function (f, e, t) {
      var n = t("cb5a");
      function r(f, e) {
        var t = this.__data__,
          r = n(t, f);
        return r < 0 ? (++this.size, t.push([f, e])) : (t[r][1] = e), this;
      }
      f.exports = r;
    },
    6863: function (f, e, t) {
      "use strict";
      t("8dd5");
    },
    "68ee": function (f, e, t) {
      var n = t("e330"),
        r = t("d039"),
        o = t("1626"),
        a = t("f5df"),
        i = t("d066"),
        s = t("8925"),
        d = function () {},
        c = [],
        l = i("Reflect", "construct"),
        u = /^\s*(?:class|function)\b/,
        p = n(u.exec),
        b = !u.exec(d),
        h = function (f) {
          if (!o(f)) return !1;
          try {
            return l(d, c, f), !0;
          } catch (e) {
            return !1;
          }
        },
        g = function (f) {
          if (!o(f)) return !1;
          switch (a(f)) {
            case "AsyncFunction":
            case "GeneratorFunction":
            case "AsyncGeneratorFunction":
              return !1;
          }
          return b || !!p(u, s(f));
        };
      f.exports =
        !l ||
        r(function () {
          var f;
          return (
            h(h.call) ||
            !h(Object) ||
            !h(function () {
              f = !0;
            }) ||
            f
          );
        })
          ? g
          : h;
    },
    "69d5": function (f, e, t) {
      var n = t("cb5a"),
        r = Array.prototype,
        o = r.splice;
      function a(f) {
        var e = this.__data__,
          t = n(e, f);
        if (t < 0) return !1;
        var r = e.length - 1;
        return t == r ? e.pop() : o.call(e, t, 1), --this.size, !0;
      }
      f.exports = a;
    },
    "69f3": function (f, e, t) {
      var n,
        r,
        o,
        a = t("7f9a"),
        i = t("da84"),
        s = t("e330"),
        d = t("861d"),
        c = t("9112"),
        l = t("1a2d"),
        u = t("c6cd"),
        p = t("f772"),
        b = t("d012"),
        h = "Object already initialized",
        g = i.TypeError,
        m = i.WeakMap,
        v = function (f) {
          return o(f) ? r(f) : n(f, {});
        },
        y = function (f) {
          return function (e) {
            var t;
            if (!d(e) || (t = r(e)).type !== f)
              throw g("Incompatible receiver, " + f + " required");
            return t;
          };
        };
      if (a || u.state) {
        var w = u.state || (u.state = new m()),
          x = s(w.get),
          _ = s(w.has),
          k = s(w.set);
        (n = function (f, e) {
          if (_(w, f)) throw new g(h);
          return (e.facade = f), k(w, f, e), e;
        }),
          (r = function (f) {
            return x(w, f) || {};
          }),
          (o = function (f) {
            return _(w, f);
          });
      } else {
        var M = p("state");
        (b[M] = !0),
          (n = function (f, e) {
            if (l(f, M)) throw new g(h);
            return (e.facade = f), c(f, M, e), e;
          }),
          (r = function (f) {
            return l(f, M) ? f[M] : {};
          }),
          (o = function (f) {
            return l(f, M);
          });
      }
      f.exports = { set: n, get: r, has: o, enforce: v, getterFor: y };
    },
    "6b8f": function (f, e, t) {
      var n = t("24fb");
      (e = n(!1)),
        e.push([f.i, "svg[data-v-4339dcad]{display:block}", ""]),
        (f.exports = e);
    },
    "6d0b": function (f, e, t) {
      var n = t("a05a");
      n.__esModule && (n = n.default),
        "string" === typeof n && (n = [[f.i, n, ""]]),
        n.locals && (f.exports = n.locals);
      var r = t("499e").default;
      r("590da98e", n, !0, { sourceMap: !1, shadowMode: !1 });
    },
    "6eeb": function (f, e, t) {
      var n = t("da84"),
        r = t("1626"),
        o = t("1a2d"),
        a = t("9112"),
        i = t("ce4e"),
        s = t("8925"),
        d = t("69f3"),
        c = t("5e77").CONFIGURABLE,
        l = d.get,
        u = d.enforce,
        p = String(String).split("String");
      (f.exports = function (f, e, t, s) {
        var d,
          l = !!s && !!s.unsafe,
          b = !!s && !!s.enumerable,
          h = !!s && !!s.noTargetGet,
          g = s && void 0 !== s.name ? s.name : e;
        r(t) &&
          ("Symbol(" === String(g).slice(0, 7) &&
            (g = "[" + String(g).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"),
          (!o(t, "name") || (c && t.name !== g)) && a(t, "name", g),
          (d = u(t)),
          d.source || (d.source = p.join("string" == typeof g ? g : ""))),
          f !== n
            ? (l ? !h && f[e] && (b = !0) : delete f[e],
              b ? (f[e] = t) : a(f, e, t))
            : b
            ? (f[e] = t)
            : i(e, t);
      })(Function.prototype, "toString", function () {
        return (r(this) && l(this).source) || s(this);
      });
    },
    "6fcd": function (f, e, t) {
      var n = t("50d8"),
        r = t("d370"),
        o = t("6747"),
        a = t("0d24"),
        i = t("c098"),
        s = t("73ac"),
        d = Object.prototype,
        c = d.hasOwnProperty;
      function l(f, e) {
        var t = o(f),
          d = !t && r(f),
          l = !t && !d && a(f),
          u = !t && !d && !l && s(f),
          p = t || d || l || u,
          b = p ? n(f.length, String) : [],
          h = b.length;
        for (var g in f)
          (!e && !c.call(f, g)) ||
            (p &&
              ("length" == g ||
                (l && ("offset" == g || "parent" == g)) ||
                (u &&
                  ("buffer" == g || "byteLength" == g || "byteOffset" == g)) ||
                i(g, h))) ||
            b.push(g);
        return b;
      }
      f.exports = l;
    },
    7037: function (f, e, t) {
      function n(e) {
        return (
          "function" === typeof Symbol && "symbol" === typeof Symbol.iterator
            ? ((f.exports = n =
                function (f) {
                  return typeof f;
                }),
              (f.exports["default"] = f.exports),
              (f.exports.__esModule = !0))
            : ((f.exports = n =
                function (f) {
                  return f &&
                    "function" === typeof Symbol &&
                    f.constructor === Symbol &&
                    f !== Symbol.prototype
                    ? "symbol"
                    : typeof f;
                }),
              (f.exports["default"] = f.exports),
              (f.exports.__esModule = !0)),
          n(e)
        );
      }
      t("a4d3"),
        t("e01a"),
        t("d3b7"),
        t("d28b"),
        t("e260"),
        t("3ca3"),
        t("ddb0"),
        (f.exports = n),
        (f.exports["default"] = f.exports),
        (f.exports.__esModule = !0);
    },
    7156: function (f, e, t) {
      var n = t("1626"),
        r = t("861d"),
        o = t("d2bb");
      f.exports = function (f, e, t) {
        var a, i;
        return (
          o &&
            n((a = e.constructor)) &&
            a !== t &&
            r((i = a.prototype)) &&
            i !== t.prototype &&
            o(f, i),
          f
        );
      };
    },
    "71cc": function (f, e, t) {
      var n, r, o;
      /*!
       * Autolinker.js
       * 1.8.3
       *
       * Copyright(c) 2018 Gregory Jacobs <greg@greg-jacobs.com>
       * MIT License
       *
       * https://github.com/gregjacobs/Autolinker.js
       */ (function (t, a) {
        (r = []),
          (n = a),
          (o = "function" === typeof n ? n.apply(e, r) : n),
          void 0 === o || (f.exports = o);
      })(0, function () {
        var f = function (e) {
          (e = e || {}),
            (this.version = f.version),
            (this.urls = this.normalizeUrlsCfg(e.urls)),
            (this.email = "boolean" !== typeof e.email || e.email),
            (this.phone = "boolean" !== typeof e.phone || e.phone),
            (this.hashtag = e.hashtag || !1),
            (this.mention = e.mention || !1),
            (this.newWindow = "boolean" !== typeof e.newWindow || e.newWindow),
            (this.stripPrefix = this.normalizeStripPrefixCfg(e.stripPrefix)),
            (this.stripTrailingSlash =
              "boolean" !== typeof e.stripTrailingSlash ||
              e.stripTrailingSlash),
            (this.decodePercentEncoding =
              "boolean" !== typeof e.decodePercentEncoding ||
              e.decodePercentEncoding);
          var t = this.mention;
          if (
            !1 !== t &&
            "twitter" !== t &&
            "instagram" !== t &&
            "soundcloud" !== t
          )
            throw new Error("invalid `mention` cfg - see docs");
          var n = this.hashtag;
          if (
            !1 !== n &&
            "twitter" !== n &&
            "facebook" !== n &&
            "instagram" !== n
          )
            throw new Error("invalid `hashtag` cfg - see docs");
          (this.truncate = this.normalizeTruncateCfg(e.truncate)),
            (this.className = e.className || ""),
            (this.replaceFn = e.replaceFn || null),
            (this.context = e.context || this),
            (this.htmlParser = null),
            (this.matchers = null),
            (this.tagBuilder = null);
        };
        return (
          (f.link = function (e, t) {
            var n = new f(t);
            return n.link(e);
          }),
          (f.parse = function (e, t) {
            var n = new f(t);
            return n.parse(e);
          }),
          (f.version = "1.8.3"),
          (f.prototype = {
            constructor: f,
            normalizeUrlsCfg: function (f) {
              return (
                null == f && (f = !0),
                "boolean" === typeof f
                  ? { schemeMatches: f, wwwMatches: f, tldMatches: f }
                  : {
                      schemeMatches:
                        "boolean" !== typeof f.schemeMatches || f.schemeMatches,
                      wwwMatches:
                        "boolean" !== typeof f.wwwMatches || f.wwwMatches,
                      tldMatches:
                        "boolean" !== typeof f.tldMatches || f.tldMatches,
                    }
              );
            },
            normalizeStripPrefixCfg: function (f) {
              return (
                null == f && (f = !0),
                "boolean" === typeof f
                  ? { scheme: f, www: f }
                  : {
                      scheme: "boolean" !== typeof f.scheme || f.scheme,
                      www: "boolean" !== typeof f.www || f.www,
                    }
              );
            },
            normalizeTruncateCfg: function (e) {
              return "number" === typeof e
                ? { length: e, location: "end" }
                : f.Util.defaults(e || {}, {
                    length: Number.POSITIVE_INFINITY,
                    location: "end",
                  });
            },
            parse: function (f) {
              for (
                var e = this.getHtmlParser(),
                  t = e.parse(f),
                  n = 0,
                  r = [],
                  o = 0,
                  a = t.length;
                o < a;
                o++
              ) {
                var i = t[o],
                  s = i.getType();
                if (
                  "element" === s &&
                  -1 !== ["a", "style", "script"].indexOf(i.getTagName())
                )
                  i.isClosing() ? (n = Math.max(n - 1, 0)) : n++;
                else if ("text" === s && 0 === n) {
                  var d = this.parseText(i.getText(), i.getOffset());
                  r.push.apply(r, d);
                }
              }
              return (
                (r = this.compactMatches(r)),
                (r = this.removeUnwantedMatches(r)),
                r
              );
            },
            compactMatches: function (f) {
              f.sort(function (f, e) {
                return f.getOffset() - e.getOffset();
              });
              for (var e = 0; e < f.length - 1; e++) {
                var t = f[e],
                  n = t.getOffset(),
                  r = t.getMatchedText().length,
                  o = n + r;
                if (e + 1 < f.length) {
                  if (f[e + 1].getOffset() === n) {
                    var a = f[e + 1].getMatchedText().length > r ? e : e + 1;
                    f.splice(a, 1);
                    continue;
                  }
                  f[e + 1].getOffset() < o && f.splice(e + 1, 1);
                }
              }
              return f;
            },
            removeUnwantedMatches: function (e) {
              var t = f.Util.remove;
              return (
                this.hashtag ||
                  t(e, function (f) {
                    return "hashtag" === f.getType();
                  }),
                this.email ||
                  t(e, function (f) {
                    return "email" === f.getType();
                  }),
                this.phone ||
                  t(e, function (f) {
                    return "phone" === f.getType();
                  }),
                this.mention ||
                  t(e, function (f) {
                    return "mention" === f.getType();
                  }),
                this.urls.schemeMatches ||
                  t(e, function (f) {
                    return (
                      "url" === f.getType() && "scheme" === f.getUrlMatchType()
                    );
                  }),
                this.urls.wwwMatches ||
                  t(e, function (f) {
                    return (
                      "url" === f.getType() && "www" === f.getUrlMatchType()
                    );
                  }),
                this.urls.tldMatches ||
                  t(e, function (f) {
                    return (
                      "url" === f.getType() && "tld" === f.getUrlMatchType()
                    );
                  }),
                e
              );
            },
            parseText: function (f, e) {
              e = e || 0;
              for (
                var t = this.getMatchers(), n = [], r = 0, o = t.length;
                r < o;
                r++
              ) {
                for (
                  var a = t[r].parseMatches(f), i = 0, s = a.length;
                  i < s;
                  i++
                )
                  a[i].setOffset(e + a[i].getOffset());
                n.push.apply(n, a);
              }
              return n;
            },
            link: function (f) {
              if (!f) return "";
              for (
                var e = this.parse(f), t = [], n = 0, r = 0, o = e.length;
                r < o;
                r++
              ) {
                var a = e[r];
                t.push(f.substring(n, a.getOffset())),
                  t.push(this.createMatchReturnVal(a)),
                  (n = a.getOffset() + a.getMatchedText().length);
              }
              return t.push(f.substring(n)), t.join("");
            },
            createMatchReturnVal: function (e) {
              var t;
              if (
                (this.replaceFn && (t = this.replaceFn.call(this.context, e)),
                "string" === typeof t)
              )
                return t;
              if (!1 === t) return e.getMatchedText();
              if (t instanceof f.HtmlTag) return t.toAnchorString();
              var n = e.buildTag();
              return n.toAnchorString();
            },
            getHtmlParser: function () {
              var e = this.htmlParser;
              return (
                e || (e = this.htmlParser = new f.htmlParser.HtmlParser()), e
              );
            },
            getMatchers: function () {
              if (this.matchers) return this.matchers;
              var e = f.matcher,
                t = this.getTagBuilder(),
                n = [
                  new e.Hashtag({ tagBuilder: t, serviceName: this.hashtag }),
                  new e.Email({ tagBuilder: t }),
                  new e.Phone({ tagBuilder: t }),
                  new e.Mention({ tagBuilder: t, serviceName: this.mention }),
                  new e.Url({
                    tagBuilder: t,
                    stripPrefix: this.stripPrefix,
                    stripTrailingSlash: this.stripTrailingSlash,
                    decodePercentEncoding: this.decodePercentEncoding,
                  }),
                ];
              return (this.matchers = n);
            },
            getTagBuilder: function () {
              var e = this.tagBuilder;
              return (
                e ||
                  (e = this.tagBuilder =
                    new f.AnchorTagBuilder({
                      newWindow: this.newWindow,
                      truncate: this.truncate,
                      className: this.className,
                    })),
                e
              );
            },
          }),
          (f.match = {}),
          (f.matcher = {}),
          (f.htmlParser = {}),
          (f.truncate = {}),
          (f.Util = {
            abstractMethod: function () {
              throw "abstract";
            },
            trimRegex: /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
            assign: function (f, e) {
              for (var t in e) e.hasOwnProperty(t) && (f[t] = e[t]);
              return f;
            },
            defaults: function (f, e) {
              for (var t in e)
                e.hasOwnProperty(t) && void 0 === f[t] && (f[t] = e[t]);
              return f;
            },
            extend: function (e, t) {
              var n,
                r = e.prototype,
                o = function () {};
              (o.prototype = r),
                (n = t.hasOwnProperty("constructor")
                  ? t.constructor
                  : function () {
                      r.constructor.apply(this, arguments);
                    });
              var a = (n.prototype = new o());
              return (
                (a.constructor = n),
                (a.superclass = r),
                delete t.constructor,
                f.Util.assign(a, t),
                n
              );
            },
            ellipsis: function (f, e, t) {
              var n;
              return (
                f.length > e &&
                  (null == t ? ((t = "&hellip;"), (n = 3)) : (n = t.length),
                  (f = f.substring(0, e - n) + t)),
                f
              );
            },
            indexOf: function (f, e) {
              if (Array.prototype.indexOf) return f.indexOf(e);
              for (var t = 0, n = f.length; t < n; t++)
                if (f[t] === e) return t;
              return -1;
            },
            remove: function (f, e) {
              for (var t = f.length - 1; t >= 0; t--)
                !0 === e(f[t]) && f.splice(t, 1);
            },
            splitAndCapture: function (f, e) {
              if (!e.global)
                throw new Error("`splitRegex` must have the 'g' flag set");
              var t,
                n = [],
                r = 0;
              while ((t = e.exec(f)))
                n.push(f.substring(r, t.index)),
                  n.push(t[0]),
                  (r = t.index + t[0].length);
              return n.push(f.substring(r)), n;
            },
            trim: function (f) {
              return f.replace(this.trimRegex, "");
            },
          }),
          (f.HtmlTag = f.Util.extend(Object, {
            whitespaceRegex: /\s+/,
            constructor: function (e) {
              f.Util.assign(this, e),
                (this.innerHtml = this.innerHtml || this.innerHTML);
            },
            setTagName: function (f) {
              return (this.tagName = f), this;
            },
            getTagName: function () {
              return this.tagName || "";
            },
            setAttr: function (f, e) {
              var t = this.getAttrs();
              return (t[f] = e), this;
            },
            getAttr: function (f) {
              return this.getAttrs()[f];
            },
            setAttrs: function (e) {
              var t = this.getAttrs();
              return f.Util.assign(t, e), this;
            },
            getAttrs: function () {
              return this.attrs || (this.attrs = {});
            },
            setClass: function (f) {
              return this.setAttr("class", f);
            },
            addClass: function (e) {
              var t,
                n = this.getClass(),
                r = this.whitespaceRegex,
                o = f.Util.indexOf,
                a = n ? n.split(r) : [],
                i = e.split(r);
              while ((t = i.shift())) -1 === o(a, t) && a.push(t);
              return (this.getAttrs()["class"] = a.join(" ")), this;
            },
            removeClass: function (e) {
              var t,
                n = this.getClass(),
                r = this.whitespaceRegex,
                o = f.Util.indexOf,
                a = n ? n.split(r) : [],
                i = e.split(r);
              while (a.length && (t = i.shift())) {
                var s = o(a, t);
                -1 !== s && a.splice(s, 1);
              }
              return (this.getAttrs()["class"] = a.join(" ")), this;
            },
            getClass: function () {
              return this.getAttrs()["class"] || "";
            },
            hasClass: function (f) {
              return (
                -1 !== (" " + this.getClass() + " ").indexOf(" " + f + " ")
              );
            },
            setInnerHtml: function (f) {
              return (this.innerHtml = f), this;
            },
            getInnerHtml: function () {
              return this.innerHtml || "";
            },
            toAnchorString: function () {
              var f = this.getTagName(),
                e = this.buildAttrsStr();
              return (
                (e = e ? " " + e : ""),
                ["<", f, e, ">", this.getInnerHtml(), "</", f, ">"].join("")
              );
            },
            buildAttrsStr: function () {
              if (!this.attrs) return "";
              var f = this.getAttrs(),
                e = [];
              for (var t in f)
                f.hasOwnProperty(t) && e.push(t + '="' + f[t] + '"');
              return e.join(" ");
            },
          })),
          (f.RegexLib = (function () {
            var f =
                "A-Za-z\\xAA\\xB5\\xBA\\xC0-\\xD6\\xD8-\\xF6\\xF8-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՙա-ևא-תװ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࢠ-ࢴऄ-हऽॐक़-ॡॱ-ঀঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡૹଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-హఽౘ-ౚౠౡಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೞೠೡೱೲഅ-ഌഎ-ഐഒ-ഺഽൎൟ-ൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄງຈຊຍດ-ທນ-ຟມ-ຣລວສຫອ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏽᏸ-ᏽᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛱ-ᛸᜀ-ᜌᜎ-ᜑᜠ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡷᢀ-ᢨᢪᢰ-ᣵᤀ-ᤞᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭋᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᳩ-ᳬᳮ-ᳱᳵᳶᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℹℼ-ℿⅅ-ⅉⅎↃↄⰀ-Ⱞⰰ-ⱞⱠ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞⸯ々〆〱-〵〻〼ぁ-ゖゝ-ゟァ-ヺー-ヿㄅ-ㄭㄱ-ㆎㆠ-ㆺㇰ-ㇿ㐀-䶵一-鿕ꀀ-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚝꚠ-ꛥꜗ-ꜟꜢ-ꞈꞋ-ꞭꞰ-ꞷꟷ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꣽꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꧠ-ꧤꧦ-ꧯꧺ-ꧾꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꩾ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚꭜ-ꭥꭰ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ",
              e =
                "0-9٠-٩۰-۹߀-߉०-९০-৯੦-੯૦-૯୦-୯௦-௯౦-౯೦-೯൦-൯෦-෯๐-๙໐-໙༠-༩၀-၉႐-႙០-៩᠐-᠙᥆-᥏᧐-᧙᪀-᪉᪐-᪙᭐-᭙᮰-᮹᱀-᱉᱐-᱙꘠-꘩꣐-꣙꤀-꤉꧐-꧙꧰-꧹꩐-꩙꯰-꯹０-９",
              t = f + e,
              n = "(?:[" + e + "]{1,3}\\.){3}[" + e + "]{1,3}",
              r = "[" + t + "](?:[" + t + "\\-]{0,61}[" + t + "])?",
              o = function (f) {
                return "(?=(" + r + "))\\" + f;
              },
              a = function (f) {
                return (
                  "(?:" + o(f) + "(?:\\." + o(f + 1) + "){0,126}|" + n + ")"
                );
              };
            return {
              alphaNumericCharsStr: t,
              alphaCharsStr: f,
              getDomainNameStr: a,
            };
          })()),
          (f.AnchorTagBuilder = f.Util.extend(Object, {
            constructor: function (f) {
              (f = f || {}),
                (this.newWindow = f.newWindow),
                (this.truncate = f.truncate),
                (this.className = f.className);
            },
            build: function (e) {
              return new f.HtmlTag({
                tagName: "a",
                attrs: this.createAttrs(e),
                innerHtml: this.processAnchorText(e.getAnchorText()),
              });
            },
            createAttrs: function (f) {
              var e = { href: f.getAnchorHref() },
                t = this.createCssClass(f);
              return (
                t && (e["class"] = t),
                this.newWindow &&
                  ((e["target"] = "_blank"),
                  (e["rel"] = "noopener noreferrer")),
                this.truncate &&
                  this.truncate.length &&
                  this.truncate.length < f.getAnchorText().length &&
                  (e["title"] = f.getAnchorHref()),
                e
              );
            },
            createCssClass: function (f) {
              var e = this.className;
              if (e) {
                for (
                  var t = [e], n = f.getCssClassSuffixes(), r = 0, o = n.length;
                  r < o;
                  r++
                )
                  t.push(e + "-" + n[r]);
                return t.join(" ");
              }
              return "";
            },
            processAnchorText: function (f) {
              return (f = this.doTruncate(f)), f;
            },
            doTruncate: function (e) {
              var t = this.truncate;
              if (!t || !t.length) return e;
              var n = t.length,
                r = t.location;
              return "smart" === r
                ? f.truncate.TruncateSmart(e, n)
                : "middle" === r
                ? f.truncate.TruncateMiddle(e, n)
                : f.truncate.TruncateEnd(e, n);
            },
          })),
          (f.htmlParser.HtmlParser = f.Util.extend(Object, {
            htmlRegex: (function () {
              var f = /!--([\s\S]+?)--/,
                e = /[0-9a-zA-Z][0-9a-zA-Z:]*/,
                t = /[^\s"'>\/=\x00-\x1F\x7F]+/,
                n = /(?:"[^"]*?"|'[^']*?'|[^'"=<>`\s]+)/,
                r = "(?:\\s*?=\\s*?" + n.source + ")?",
                o = function (f) {
                  return "(?=(" + t.source + "))\\" + f + r;
                };
              return new RegExp(
                [
                  "(?:",
                  "<(!DOCTYPE)",
                  "(?:",
                  "\\s+",
                  "(?:",
                  o(2),
                  "|",
                  n.source + ")",
                  ")*",
                  ">",
                  ")",
                  "|",
                  "(?:",
                  "<(/)?",
                  "(?:",
                  f.source,
                  "|",
                  "(?:",
                  "(" + e.source + ")",
                  "\\s*/?",
                  ")",
                  "|",
                  "(?:",
                  "(" + e.source + ")",
                  "\\s+",
                  "(?:",
                  "(?:\\s+|\\b)",
                  o(7),
                  ")*",
                  "\\s*/?",
                  ")",
                  ")",
                  ">",
                  ")",
                ].join(""),
                "gi"
              );
            })(),
            htmlCharacterEntitiesRegex:
              /(&nbsp;|&#160;|&lt;|&#60;|&gt;|&#62;|&quot;|&#34;|&#39;)/gi,
            parse: function (f) {
              var e,
                t,
                n = this.htmlRegex,
                r = 0,
                o = [];
              while (null !== (e = n.exec(f))) {
                var a = e[0],
                  i = e[4],
                  s = e[1] || e[5] || e[6],
                  d = !!e[3],
                  c = e.index,
                  l = f.substring(r, c);
                l &&
                  ((t = this.parseTextAndEntityNodes(r, l)),
                  o.push.apply(o, t)),
                  i
                    ? o.push(this.createCommentNode(c, a, i))
                    : o.push(this.createElementNode(c, a, s, d)),
                  (r = c + a.length);
              }
              if (r < f.length) {
                var u = f.substring(r);
                u &&
                  ((t = this.parseTextAndEntityNodes(r, u)),
                  t.forEach(function (f) {
                    o.push(f);
                  }));
              }
              return o;
            },
            parseTextAndEntityNodes: function (e, t) {
              for (
                var n = [],
                  r = f.Util.splitAndCapture(
                    t,
                    this.htmlCharacterEntitiesRegex
                  ),
                  o = 0,
                  a = r.length;
                o < a;
                o += 2
              ) {
                var i = r[o],
                  s = r[o + 1];
                i && (n.push(this.createTextNode(e, i)), (e += i.length)),
                  s && (n.push(this.createEntityNode(e, s)), (e += s.length));
              }
              return n;
            },
            createCommentNode: function (e, t, n) {
              return new f.htmlParser.CommentNode({
                offset: e,
                text: t,
                comment: f.Util.trim(n),
              });
            },
            createElementNode: function (e, t, n, r) {
              return new f.htmlParser.ElementNode({
                offset: e,
                text: t,
                tagName: n.toLowerCase(),
                closing: r,
              });
            },
            createEntityNode: function (e, t) {
              return new f.htmlParser.EntityNode({ offset: e, text: t });
            },
            createTextNode: function (e, t) {
              return new f.htmlParser.TextNode({ offset: e, text: t });
            },
          })),
          (f.htmlParser.HtmlNode = f.Util.extend(Object, {
            offset: void 0,
            text: void 0,
            constructor: function (e) {
              if ((f.Util.assign(this, e), null == this.offset))
                throw new Error("`offset` cfg required");
              if (null == this.text) throw new Error("`text` cfg required");
            },
            getType: f.Util.abstractMethod,
            getOffset: function () {
              return this.offset;
            },
            getText: function () {
              return this.text;
            },
          })),
          (f.htmlParser.CommentNode = f.Util.extend(f.htmlParser.HtmlNode, {
            comment: "",
            getType: function () {
              return "comment";
            },
            getComment: function () {
              return this.comment;
            },
          })),
          (f.htmlParser.ElementNode = f.Util.extend(f.htmlParser.HtmlNode, {
            tagName: "",
            closing: !1,
            getType: function () {
              return "element";
            },
            getTagName: function () {
              return this.tagName;
            },
            isClosing: function () {
              return this.closing;
            },
          })),
          (f.htmlParser.EntityNode = f.Util.extend(f.htmlParser.HtmlNode, {
            getType: function () {
              return "entity";
            },
          })),
          (f.htmlParser.TextNode = f.Util.extend(f.htmlParser.HtmlNode, {
            getType: function () {
              return "text";
            },
          })),
          (f.match.Match = f.Util.extend(Object, {
            constructor: function (f) {
              if (null == f.tagBuilder)
                throw new Error("`tagBuilder` cfg required");
              if (null == f.matchedText)
                throw new Error("`matchedText` cfg required");
              if (null == f.offset) throw new Error("`offset` cfg required");
              (this.tagBuilder = f.tagBuilder),
                (this.matchedText = f.matchedText),
                (this.offset = f.offset);
            },
            getType: f.Util.abstractMethod,
            getMatchedText: function () {
              return this.matchedText;
            },
            setOffset: function (f) {
              this.offset = f;
            },
            getOffset: function () {
              return this.offset;
            },
            getAnchorHref: f.Util.abstractMethod,
            getAnchorText: f.Util.abstractMethod,
            getCssClassSuffixes: function () {
              return [this.getType()];
            },
            buildTag: function () {
              return this.tagBuilder.build(this);
            },
          })),
          (f.match.Email = f.Util.extend(f.match.Match, {
            constructor: function (e) {
              if ((f.match.Match.prototype.constructor.call(this, e), !e.email))
                throw new Error("`email` cfg required");
              this.email = e.email;
            },
            getType: function () {
              return "email";
            },
            getEmail: function () {
              return this.email;
            },
            getAnchorHref: function () {
              return "mailto:" + this.email;
            },
            getAnchorText: function () {
              return this.email;
            },
          })),
          (f.match.Hashtag = f.Util.extend(f.match.Match, {
            constructor: function (e) {
              if (
                (f.match.Match.prototype.constructor.call(this, e), !e.hashtag)
              )
                throw new Error("`hashtag` cfg required");
              (this.serviceName = e.serviceName), (this.hashtag = e.hashtag);
            },
            getType: function () {
              return "hashtag";
            },
            getServiceName: function () {
              return this.serviceName;
            },
            getHashtag: function () {
              return this.hashtag;
            },
            getAnchorHref: function () {
              var f = this.serviceName,
                e = this.hashtag;
              switch (f) {
                case "twitter":
                  return "https://twitter.com/hashtag/" + e;
                case "facebook":
                  return "https://www.facebook.com/hashtag/" + e;
                case "instagram":
                  return "https://instagram.com/explore/tags/" + e;
                default:
                  throw new Error(
                    "Unknown service name to point hashtag to: ",
                    f
                  );
              }
            },
            getAnchorText: function () {
              return "#" + this.hashtag;
            },
          })),
          (f.match.Phone = f.Util.extend(f.match.Match, {
            constructor: function (e) {
              if (
                (f.match.Match.prototype.constructor.call(this, e), !e.number)
              )
                throw new Error("`number` cfg required");
              if (null == e.plusSign)
                throw new Error("`plusSign` cfg required");
              (this.number = e.number), (this.plusSign = e.plusSign);
            },
            getType: function () {
              return "phone";
            },
            getNumber: function () {
              return this.number;
            },
            getAnchorHref: function () {
              return "tel:" + (this.plusSign ? "+" : "") + this.number;
            },
            getAnchorText: function () {
              return this.matchedText;
            },
          })),
          (f.match.Mention = f.Util.extend(f.match.Match, {
            constructor: function (e) {
              if (
                (f.match.Match.prototype.constructor.call(this, e),
                !e.serviceName)
              )
                throw new Error("`serviceName` cfg required");
              if (!e.mention) throw new Error("`mention` cfg required");
              (this.mention = e.mention), (this.serviceName = e.serviceName);
            },
            getType: function () {
              return "mention";
            },
            getMention: function () {
              return this.mention;
            },
            getServiceName: function () {
              return this.serviceName;
            },
            getAnchorHref: function () {
              switch (this.serviceName) {
                case "twitter":
                  return "https://twitter.com/" + this.mention;
                case "instagram":
                  return "https://instagram.com/" + this.mention;
                case "soundcloud":
                  return "https://soundcloud.com/" + this.mention;
                default:
                  throw new Error(
                    "Unknown service name to point mention to: ",
                    this.serviceName
                  );
              }
            },
            getAnchorText: function () {
              return "@" + this.mention;
            },
            getCssClassSuffixes: function () {
              var e = f.match.Match.prototype.getCssClassSuffixes.call(this),
                t = this.getServiceName();
              return t && e.push(t), e;
            },
          })),
          (f.match.Url = f.Util.extend(f.match.Match, {
            constructor: function (e) {
              if (
                (f.match.Match.prototype.constructor.call(this, e),
                "scheme" !== e.urlMatchType &&
                  "www" !== e.urlMatchType &&
                  "tld" !== e.urlMatchType)
              )
                throw new Error(
                  '`urlMatchType` cfg must be one of: "scheme", "www", or "tld"'
                );
              if (!e.url) throw new Error("`url` cfg required");
              if (null == e.protocolUrlMatch)
                throw new Error("`protocolUrlMatch` cfg required");
              if (null == e.protocolRelativeMatch)
                throw new Error("`protocolRelativeMatch` cfg required");
              if (null == e.stripPrefix)
                throw new Error("`stripPrefix` cfg required");
              if (null == e.stripTrailingSlash)
                throw new Error("`stripTrailingSlash` cfg required");
              if (null == e.decodePercentEncoding)
                throw new Error("`decodePercentEncoding` cfg required");
              (this.urlMatchType = e.urlMatchType),
                (this.url = e.url),
                (this.protocolUrlMatch = e.protocolUrlMatch),
                (this.protocolRelativeMatch = e.protocolRelativeMatch),
                (this.stripPrefix = e.stripPrefix),
                (this.stripTrailingSlash = e.stripTrailingSlash),
                (this.decodePercentEncoding = e.decodePercentEncoding);
            },
            schemePrefixRegex: /^(https?:\/\/)?/i,
            wwwPrefixRegex: /^(https?:\/\/)?(www\.)?/i,
            protocolRelativeRegex: /^\/\//,
            protocolPrepended: !1,
            getType: function () {
              return "url";
            },
            getUrlMatchType: function () {
              return this.urlMatchType;
            },
            getUrl: function () {
              var f = this.url;
              return (
                this.protocolRelativeMatch ||
                  this.protocolUrlMatch ||
                  this.protocolPrepended ||
                  ((f = this.url = "http://" + f),
                  (this.protocolPrepended = !0)),
                f
              );
            },
            getAnchorHref: function () {
              var f = this.getUrl();
              return f.replace(/&amp;/g, "&");
            },
            getAnchorText: function () {
              var f = this.getMatchedText();
              return (
                this.protocolRelativeMatch &&
                  (f = this.stripProtocolRelativePrefix(f)),
                this.stripPrefix.scheme && (f = this.stripSchemePrefix(f)),
                this.stripPrefix.www && (f = this.stripWwwPrefix(f)),
                this.stripTrailingSlash && (f = this.removeTrailingSlash(f)),
                this.decodePercentEncoding &&
                  (f = this.removePercentEncoding(f)),
                f
              );
            },
            stripSchemePrefix: function (f) {
              return f.replace(this.schemePrefixRegex, "");
            },
            stripWwwPrefix: function (f) {
              return f.replace(this.wwwPrefixRegex, "$1");
            },
            stripProtocolRelativePrefix: function (f) {
              return f.replace(this.protocolRelativeRegex, "");
            },
            removeTrailingSlash: function (f) {
              return "/" === f.charAt(f.length - 1) && (f = f.slice(0, -1)), f;
            },
            removePercentEncoding: function (f) {
              try {
                return decodeURIComponent(
                  f
                    .replace(/%22/gi, "&quot;")
                    .replace(/%26/gi, "&amp;")
                    .replace(/%27/gi, "&#39;")
                    .replace(/%3C/gi, "&lt;")
                    .replace(/%3E/gi, "&gt;")
                );
              } catch (e) {
                return f;
              }
            },
          })),
          (f.tldRegex =
            /(?:xn--vermgensberatung-pwb|xn--vermgensberater-ctb|xn--clchc0ea0b2g2a9gcd|xn--w4r85el8fhu5dnra|northwesternmutual|travelersinsurance|vermögensberatung|xn--3oq18vl8pn36a|xn--5su34j936bgsg|xn--bck1b9a5dre4c|xn--mgbai9azgqp6j|xn--mgberp4a5d4ar|xn--xkc2dl3a5ee0h|vermögensberater|xn--fzys8d69uvgm|xn--mgba7c0bbn0a|xn--xkc2al3hye2a|americanexpress|kerryproperties|sandvikcoromant|xn--i1b6b1a6a2e|xn--kcrx77d1x4a|xn--lgbbat1ad8j|xn--mgba3a4f16a|xn--mgbc0a9azcg|xn--nqv7fs00ema|afamilycompany|americanfamily|bananarepublic|cancerresearch|cookingchannel|kerrylogistics|weatherchannel|xn--54b7fta0cc|xn--6qq986b3xl|xn--80aqecdr1a|xn--b4w605ferd|xn--fiq228c5hs|xn--jlq61u9w7b|xn--mgba3a3ejt|xn--mgbaam7a8h|xn--mgbayh7gpa|xn--mgbb9fbpob|xn--mgbbh1a71e|xn--mgbca7dzdo|xn--mgbi4ecexp|xn--mgbx4cd0ab|international|lifeinsurance|orientexpress|spreadbetting|travelchannel|wolterskluwer|xn--eckvdtc9d|xn--fpcrj9c3d|xn--fzc2c9e2c|xn--tiq49xqyj|xn--yfro4i67o|xn--ygbi2ammx|construction|lplfinancial|pamperedchef|scholarships|versicherung|xn--3e0b707e|xn--80adxhks|xn--80asehdb|xn--8y0a063a|xn--gckr3f0f|xn--mgb9awbf|xn--mgbab2bd|xn--mgbpl2fh|xn--mgbt3dhd|xn--mk1bu44c|xn--ngbc5azd|xn--ngbe9e0a|xn--ogbpf8fl|xn--qcka1pmc|accountants|barclaycard|blackfriday|blockbuster|bridgestone|calvinklein|contractors|creditunion|engineering|enterprises|foodnetwork|investments|kerryhotels|lamborghini|motorcycles|olayangroup|photography|playstation|productions|progressive|redumbrella|rightathome|williamhill|xn--11b4c3d|xn--1ck2e1b|xn--1qqw23a|xn--3bst00m|xn--3ds443g|xn--42c2d9a|xn--45brj9c|xn--55qw42g|xn--6frz82g|xn--80ao21a|xn--9krt00a|xn--cck2b3b|xn--czr694b|xn--d1acj3b|xn--efvy88h|xn--estv75g|xn--fct429k|xn--fjq720a|xn--flw351e|xn--g2xx48c|xn--gecrj9c|xn--gk3at1e|xn--h2brj9c|xn--hxt814e|xn--imr513n|xn--j6w193g|xn--jvr189m|xn--kprw13d|xn--kpry57d|xn--kpu716f|xn--mgbtx2b|xn--mix891f|xn--nyqy26a|xn--pbt977c|xn--pgbs0dh|xn--q9jyb4c|xn--rhqv96g|xn--rovu88b|xn--s9brj9c|xn--ses554g|xn--t60b56a|xn--vuq861b|xn--w4rs40l|xn--xhq521b|xn--zfr164b|சிங்கப்பூர்|accountant|apartments|associates|basketball|bnpparibas|boehringer|capitalone|consulting|creditcard|cuisinella|eurovision|extraspace|foundation|healthcare|immobilien|industries|management|mitsubishi|nationwide|newholland|nextdirect|onyourside|properties|protection|prudential|realestate|republican|restaurant|schaeffler|swiftcover|tatamotors|technology|telefonica|university|vistaprint|vlaanderen|volkswagen|xn--30rr7y|xn--3pxu8k|xn--45q11c|xn--4gbrim|xn--55qx5d|xn--5tzm5g|xn--80aswg|xn--90a3ac|xn--9dbq2a|xn--9et52u|xn--c2br7g|xn--cg4bki|xn--czrs0t|xn--czru2d|xn--fiq64b|xn--fiqs8s|xn--fiqz9s|xn--io0a7i|xn--kput3i|xn--mxtq1m|xn--o3cw4h|xn--pssy2u|xn--unup4y|xn--wgbh1c|xn--wgbl6a|xn--y9a3aq|accenture|alfaromeo|allfinanz|amsterdam|analytics|aquarelle|barcelona|bloomberg|christmas|community|directory|education|equipment|fairwinds|financial|firestone|fresenius|frontdoor|fujixerox|furniture|goldpoint|goodhands|hisamitsu|homedepot|homegoods|homesense|honeywell|institute|insurance|kuokgroup|ladbrokes|lancaster|landrover|lifestyle|marketing|marshalls|mcdonalds|melbourne|microsoft|montblanc|panasonic|passagens|pramerica|richardli|scjohnson|shangrila|solutions|statebank|statefarm|stockholm|travelers|vacations|xn--90ais|xn--c1avg|xn--d1alf|xn--e1a4c|xn--fhbei|xn--j1aef|xn--j1amh|xn--l1acc|xn--nqv7f|xn--p1acf|xn--tckwe|xn--vhquv|yodobashi|abudhabi|airforce|allstate|attorney|barclays|barefoot|bargains|baseball|boutique|bradesco|broadway|brussels|budapest|builders|business|capetown|catering|catholic|chrysler|cipriani|cityeats|cleaning|clinique|clothing|commbank|computer|delivery|deloitte|democrat|diamonds|discount|discover|download|engineer|ericsson|esurance|everbank|exchange|feedback|fidelity|firmdale|football|frontier|goodyear|grainger|graphics|guardian|hdfcbank|helsinki|holdings|hospital|infiniti|ipiranga|istanbul|jpmorgan|lighting|lundbeck|marriott|maserati|mckinsey|memorial|mortgage|movistar|observer|partners|pharmacy|pictures|plumbing|property|redstone|reliance|saarland|samsclub|security|services|shopping|showtime|softbank|software|stcgroup|supplies|symantec|telecity|training|uconnect|vanguard|ventures|verisign|woodside|xn--90ae|xn--node|xn--p1ai|xn--qxam|yokohama|السعودية|abogado|academy|agakhan|alibaba|android|athleta|auction|audible|auspost|avianca|banamex|bauhaus|bentley|bestbuy|booking|brother|bugatti|capital|caravan|careers|cartier|channel|chintai|citadel|clubmed|college|cologne|comcast|company|compare|contact|cooking|corsica|country|coupons|courses|cricket|cruises|dentist|digital|domains|exposed|express|farmers|fashion|ferrari|ferrero|finance|fishing|fitness|flights|florist|flowers|forsale|frogans|fujitsu|gallery|genting|godaddy|guitars|hamburg|hangout|hitachi|holiday|hosting|hoteles|hotmail|hyundai|iselect|ismaili|jewelry|juniper|kitchen|komatsu|lacaixa|lancome|lanxess|lasalle|latrobe|leclerc|liaison|limited|lincoln|markets|metlife|monster|netbank|netflix|network|neustar|okinawa|oldnavy|organic|origins|panerai|philips|pioneer|politie|realtor|recipes|rentals|reviews|rexroth|samsung|sandvik|schmidt|schwarz|science|shiksha|shriram|singles|spiegel|staples|starhub|statoil|storage|support|surgery|systems|temasek|theater|theatre|tickets|tiffany|toshiba|trading|walmart|wanggou|watches|weather|website|wedding|whoswho|windows|winners|xfinity|yamaxun|youtube|zuerich|католик|الجزائر|العليان|پاکستان|كاثوليك|موبايلي|இந்தியா|abarth|abbott|abbvie|active|africa|agency|airbus|airtel|alipay|alsace|alstom|anquan|aramco|author|bayern|beauty|berlin|bharti|blanco|bostik|boston|broker|camera|career|caseih|casino|center|chanel|chrome|church|circle|claims|clinic|coffee|comsec|condos|coupon|credit|cruise|dating|datsun|dealer|degree|dental|design|direct|doctor|dunlop|dupont|durban|emerck|energy|estate|events|expert|family|flickr|futbol|gallup|garden|george|giving|global|google|gratis|health|hermes|hiphop|hockey|hughes|imamat|insure|intuit|jaguar|joburg|juegos|kaufen|kinder|kindle|kosher|lancia|latino|lawyer|lefrak|living|locker|london|luxury|madrid|maison|makeup|market|mattel|mobile|mobily|monash|mormon|moscow|museum|mutual|nagoya|natura|nissan|nissay|norton|nowruz|office|olayan|online|oracle|orange|otsuka|pfizer|photos|physio|piaget|pictet|quebec|racing|realty|reisen|repair|report|review|rocher|rogers|ryukyu|safety|sakura|sanofi|school|schule|secure|select|shouji|soccer|social|stream|studio|supply|suzuki|swatch|sydney|taipei|taobao|target|tattoo|tennis|tienda|tjmaxx|tkmaxx|toyota|travel|unicom|viajes|viking|villas|virgin|vision|voting|voyage|vuelos|walter|warman|webcam|xihuan|xperia|yachts|yandex|zappos|москва|онлайн|ابوظبي|ارامكو|الاردن|المغرب|امارات|فلسطين|مليسيا|இலங்கை|ファッション|actor|adult|aetna|amfam|amica|apple|archi|audio|autos|azure|baidu|beats|bible|bingo|black|boats|boots|bosch|build|canon|cards|chase|cheap|chloe|cisco|citic|click|cloud|coach|codes|crown|cymru|dabur|dance|deals|delta|dodge|drive|dubai|earth|edeka|email|epost|epson|faith|fedex|final|forex|forum|gallo|games|gifts|gives|glade|glass|globo|gmail|green|gripe|group|gucci|guide|homes|honda|horse|house|hyatt|ikano|intel|irish|iveco|jetzt|koeln|kyoto|lamer|lease|legal|lexus|lilly|linde|lipsy|lixil|loans|locus|lotte|lotto|lupin|macys|mango|media|miami|money|mopar|movie|nadex|nexus|nikon|ninja|nokia|nowtv|omega|osaka|paris|parts|party|phone|photo|pizza|place|poker|praxi|press|prime|promo|quest|radio|rehab|reise|ricoh|rocks|rodeo|salon|sener|seven|sharp|shell|shoes|skype|sling|smart|smile|solar|space|stada|store|study|style|sucks|swiss|tatar|tires|tirol|tmall|today|tokyo|tools|toray|total|tours|trade|trust|tunes|tushu|ubank|vegas|video|vista|vodka|volvo|wales|watch|weber|weibo|works|world|xerox|yahoo|zippo|ایران|بازار|بھارت|سودان|سورية|همراه|संगठन|বাংলা|భారత్|嘉里大酒店|aarp|able|adac|aero|aigo|akdn|ally|amex|army|arpa|arte|asda|asia|audi|auto|baby|band|bank|bbva|beer|best|bike|bing|blog|blue|bofa|bond|book|buzz|cafe|call|camp|care|cars|casa|case|cash|cbre|cern|chat|citi|city|club|cool|coop|cyou|data|date|dclk|deal|dell|desi|diet|dish|docs|doha|duck|duns|dvag|erni|fage|fail|fans|farm|fast|fiat|fido|film|fire|fish|flir|food|ford|free|fund|game|gbiz|gent|ggee|gift|gmbh|gold|golf|goog|guge|guru|hair|haus|hdfc|help|here|hgtv|host|hsbc|icbc|ieee|imdb|immo|info|itau|java|jeep|jobs|jprs|kddi|kiwi|kpmg|kred|land|lego|lgbt|lidl|life|like|limo|link|live|loan|loft|love|ltda|luxe|maif|meet|meme|menu|mini|mint|mobi|moda|moto|mtpc|name|navy|news|next|nico|nike|ollo|open|page|pars|pccw|pics|ping|pink|play|plus|pohl|porn|post|prod|prof|qpon|raid|read|reit|rent|rest|rich|rmit|room|rsvp|ruhr|safe|sale|sapo|sarl|save|saxo|scor|scot|seat|seek|sexy|shaw|shia|shop|show|silk|sina|site|skin|sncf|sohu|song|sony|spot|star|surf|talk|taxi|team|tech|teva|tiaa|tips|town|toys|tube|vana|visa|viva|vivo|vote|voto|wang|weir|wien|wiki|wine|work|xbox|yoga|zara|zero|zone|дети|сайт|بيتك|تونس|شبكة|عراق|عمان|موقع|भारत|ভারত|ਭਾਰਤ|ભારત|ලංකා|グーグル|クラウド|ポイント|大众汽车|组织机构|電訊盈科|香格里拉|aaa|abb|abc|aco|ads|aeg|afl|aig|anz|aol|app|art|aws|axa|bar|bbc|bbt|bcg|bcn|bet|bid|bio|biz|bms|bmw|bnl|bom|boo|bot|box|buy|bzh|cab|cal|cam|car|cat|cba|cbn|cbs|ceb|ceo|cfa|cfd|com|crs|csc|dad|day|dds|dev|dhl|diy|dnp|dog|dot|dtv|dvr|eat|eco|edu|esq|eus|fan|fit|fly|foo|fox|frl|ftr|fun|fyi|gal|gap|gdn|gea|gle|gmo|gmx|goo|gop|got|gov|hbo|hiv|hkt|hot|how|htc|ibm|ice|icu|ifm|ing|ink|int|ist|itv|iwc|jcb|jcp|jio|jlc|jll|jmp|jnj|jot|joy|kfh|kia|kim|kpn|krd|lat|law|lds|lol|lpl|ltd|man|mba|mcd|med|men|meo|mil|mit|mlb|mls|mma|moe|moi|mom|mov|msd|mtn|mtr|nab|nba|nec|net|new|nfl|ngo|nhk|now|nra|nrw|ntt|nyc|obi|off|one|ong|onl|ooo|org|ott|ovh|pay|pet|pid|pin|pnc|pro|pru|pub|pwc|qvc|red|ren|ril|rio|rip|run|rwe|sap|sas|sbi|sbs|sca|scb|ses|sew|sex|sfr|ski|sky|soy|srl|srt|stc|tab|tax|tci|tdk|tel|thd|tjx|top|trv|tui|tvs|ubs|uno|uol|ups|vet|vig|vin|vip|wed|win|wme|wow|wtc|wtf|xin|xxx|xyz|you|yun|zip|бел|ком|қаз|мкд|мон|орг|рус|срб|укр|հայ|קום|قطر|كوم|مصر|कॉम|नेट|คอม|ไทย|ストア|セール|みんな|中文网|天主教|我爱你|新加坡|淡马锡|诺基亚|飞利浦|ac|ad|ae|af|ag|ai|al|am|ao|aq|ar|as|at|au|aw|ax|az|ba|bb|bd|be|bf|bg|bh|bi|bj|bm|bn|bo|br|bs|bt|bv|bw|by|bz|ca|cc|cd|cf|cg|ch|ci|ck|cl|cm|cn|co|cr|cu|cv|cw|cx|cy|cz|de|dj|dk|dm|do|dz|ec|ee|eg|er|es|et|eu|fi|fj|fk|fm|fo|fr|ga|gb|gd|ge|gf|gg|gh|gi|gl|gm|gn|gp|gq|gr|gs|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|im|in|io|iq|ir|is|it|je|jm|jo|jp|ke|kg|kh|ki|km|kn|kp|kr|kw|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|me|mg|mh|mk|ml|mm|mn|mo|mp|mq|mr|ms|mt|mu|mv|mw|mx|my|mz|na|nc|ne|nf|ng|ni|nl|no|np|nr|nu|nz|om|pa|pe|pf|pg|ph|pk|pl|pm|pn|pr|ps|pt|pw|py|qa|re|ro|rs|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sj|sk|sl|sm|sn|so|sr|st|su|sv|sx|sy|sz|tc|td|tf|tg|th|tj|tk|tl|tm|tn|to|tr|tt|tv|tw|tz|ua|ug|uk|us|uy|uz|va|vc|ve|vg|vi|vn|vu|wf|ws|ye|yt|za|zm|zw|ελ|бг|ею|рф|გე|닷넷|닷컴|삼성|한국|コム|世界|中信|中国|中國|企业|佛山|信息|健康|八卦|公司|公益|台湾|台灣|商城|商店|商标|嘉里|在线|大拿|娱乐|家電|工行|广东|微博|慈善|手机|手表|政务|政府|新闻|时尚|書籍|机构|游戏|澳門|点看|珠宝|移动|网址|网店|网站|网络|联通|谷歌|购物|通販|集团|食品|餐厅|香港)/),
          (f.matcher.Matcher = f.Util.extend(Object, {
            constructor: function (f) {
              if (!f.tagBuilder) throw new Error("`tagBuilder` cfg required");
              this.tagBuilder = f.tagBuilder;
            },
            parseMatches: f.Util.abstractMethod,
          })),
          (f.matcher.Email = f.Util.extend(f.matcher.Matcher, {
            matcherRegex: (function () {
              var e = f.RegexLib.alphaNumericCharsStr,
                t = "!#$%&'*+\\-\\/=?^_`{|}~",
                n = '\\s"(),:;<>@\\[\\]',
                r = e + t,
                o = r + n,
                a = new RegExp(
                  "(?:[" +
                    r +
                    "](?:[" +
                    r +
                    ']|\\.(?!\\.|@))*|\\"[' +
                    o +
                    '.]+\\")@'
                ),
                i = f.RegexLib.getDomainNameStr,
                s = f.tldRegex;
              return new RegExp(
                [a.source, i(1), "\\.", s.source].join(""),
                "gi"
              );
            })(),
            parseMatches: function (e) {
              var t,
                n = this.matcherRegex,
                r = this.tagBuilder,
                o = [];
              while (null !== (t = n.exec(e))) {
                var a = t[0];
                o.push(
                  new f.match.Email({
                    tagBuilder: r,
                    matchedText: a,
                    offset: t.index,
                    email: a,
                  })
                );
              }
              return o;
            },
          })),
          (f.matcher.Hashtag = f.Util.extend(f.matcher.Matcher, {
            matcherRegex: new RegExp(
              "#[_" + f.RegexLib.alphaNumericCharsStr + "]{1,139}",
              "g"
            ),
            nonWordCharRegex: new RegExp(
              "[^" + f.RegexLib.alphaNumericCharsStr + "]"
            ),
            constructor: function (e) {
              f.matcher.Matcher.prototype.constructor.call(this, e),
                (this.serviceName = e.serviceName);
            },
            parseMatches: function (e) {
              var t,
                n = this.matcherRegex,
                r = this.nonWordCharRegex,
                o = this.serviceName,
                a = this.tagBuilder,
                i = [];
              while (null !== (t = n.exec(e))) {
                var s = t.index,
                  d = e.charAt(s - 1);
                if (0 === s || r.test(d)) {
                  var c = t[0],
                    l = t[0].slice(1);
                  i.push(
                    new f.match.Hashtag({
                      tagBuilder: a,
                      matchedText: c,
                      offset: s,
                      serviceName: o,
                      hashtag: l,
                    })
                  );
                }
              }
              return i;
            },
          })),
          (f.matcher.Phone = f.Util.extend(f.matcher.Matcher, {
            matcherRegex:
              /(?:(?:(?:(\+)?\d{1,3}[-\040.]?)?\(?\d{3}\)?[-\040.]?\d{3}[-\040.]?\d{4})|(?:(\+)(?:9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)[-\040.]?(?:\d[-\040.]?){6,12}\d+))([,;]+[0-9]+#?)*/g,
            parseMatches: function (e) {
              var t,
                n = this.matcherRegex,
                r = this.tagBuilder,
                o = [];
              while (null !== (t = n.exec(e))) {
                var a = t[0],
                  i = a.replace(/[^0-9,;#]/g, ""),
                  s = !(!t[1] && !t[2]),
                  d = 0 == t.index ? "" : e.substr(t.index - 1, 1),
                  c = e.substr(t.index + a.length, 1),
                  l = !d.match(/\d/) && !c.match(/\d/);
                this.testMatch(t[3]) &&
                  this.testMatch(a) &&
                  l &&
                  o.push(
                    new f.match.Phone({
                      tagBuilder: r,
                      matchedText: a,
                      offset: t.index,
                      number: i,
                      plusSign: s,
                    })
                  );
              }
              return o;
            },
            testMatch: function (f) {
              return /\D/.test(f);
            },
          })),
          (f.matcher.Mention = f.Util.extend(f.matcher.Matcher, {
            matcherRegexes: {
              twitter: new RegExp(
                "@[_" + f.RegexLib.alphaNumericCharsStr + "]{1,20}",
                "g"
              ),
              instagram: new RegExp(
                "@[_." + f.RegexLib.alphaNumericCharsStr + "]{1,50}",
                "g"
              ),
              soundcloud: new RegExp(
                "@[_." + f.RegexLib.alphaNumericCharsStr + "-]{1,50}",
                "g"
              ),
            },
            nonWordCharRegex: new RegExp(
              "[^" + f.RegexLib.alphaNumericCharsStr + "]"
            ),
            constructor: function (e) {
              f.matcher.Matcher.prototype.constructor.call(this, e),
                (this.serviceName = e.serviceName);
            },
            parseMatches: function (e) {
              var t,
                n = this.matcherRegexes[this.serviceName],
                r = this.nonWordCharRegex,
                o = this.serviceName,
                a = this.tagBuilder,
                i = [];
              if (!n) return i;
              while (null !== (t = n.exec(e))) {
                var s = t.index,
                  d = e.charAt(s - 1);
                if (0 === s || r.test(d)) {
                  var c = t[0].replace(/\.+$/g, ""),
                    l = c.slice(1);
                  i.push(
                    new f.match.Mention({
                      tagBuilder: a,
                      matchedText: c,
                      offset: s,
                      serviceName: o,
                      mention: l,
                    })
                  );
                }
              }
              return i;
            },
          })),
          (f.matcher.Url = f.Util.extend(f.matcher.Matcher, {
            matcherRegex: (function () {
              var e =
                  /(?:[A-Za-z][-.+A-Za-z0-9]{0,63}:(?![A-Za-z][-.+A-Za-z0-9]{0,63}:\/\/)(?!\d+\/?)(?:\/\/)?)/,
                t = /(?:www\.)/,
                n = f.RegexLib.getDomainNameStr,
                r = f.tldRegex,
                o = f.RegexLib.alphaNumericCharsStr,
                a = new RegExp(
                  "[/?#](?:[" +
                    o +
                    "\\-+&@#/%=~_()|'$*\\[\\]?!:,.;✓]*[" +
                    o +
                    "\\-+&@#/%=~_()|'$*\\[\\]✓])?"
                );
              return new RegExp(
                [
                  "(?:",
                  "(",
                  e.source,
                  n(2),
                  ")",
                  "|",
                  "(",
                  "(//)?",
                  t.source,
                  n(6),
                  ")",
                  "|",
                  "(",
                  "(//)?",
                  n(10) + "\\.",
                  r.source,
                  "(?![-" + o + "])",
                  ")",
                  ")",
                  "(?::[0-9]+)?",
                  "(?:" + a.source + ")?",
                ].join(""),
                "gi"
              );
            })(),
            wordCharRegExp: new RegExp(
              "[" + f.RegexLib.alphaNumericCharsStr + "]"
            ),
            openParensRe: /\(/g,
            closeParensRe: /\)/g,
            constructor: function (e) {
              if (
                (f.matcher.Matcher.prototype.constructor.call(this, e),
                null == e.stripPrefix)
              )
                throw new Error("`stripPrefix` cfg required");
              if (null == e.stripTrailingSlash)
                throw new Error("`stripTrailingSlash` cfg required");
              (this.stripPrefix = e.stripPrefix),
                (this.stripTrailingSlash = e.stripTrailingSlash),
                (this.decodePercentEncoding = e.decodePercentEncoding);
            },
            parseMatches: function (e) {
              var t,
                n = this.matcherRegex,
                r = this.stripPrefix,
                o = this.stripTrailingSlash,
                a = this.decodePercentEncoding,
                i = this.tagBuilder,
                s = [];
              while (null !== (t = n.exec(e))) {
                var d = t[0],
                  c = t[1],
                  l = t[4],
                  u = t[5],
                  p = t[9],
                  b = t.index,
                  h = u || p,
                  g = e.charAt(b - 1);
                if (
                  f.matcher.UrlMatchValidator.isValid(d, c) &&
                  !(b > 0 && "@" === g) &&
                  !(b > 0 && h && this.wordCharRegExp.test(g))
                ) {
                  if (
                    (/\?$/.test(d) && (d = d.substr(0, d.length - 1)),
                    this.matchHasUnbalancedClosingParen(d))
                  )
                    d = d.substr(0, d.length - 1);
                  else {
                    var m = this.matchHasInvalidCharAfterTld(d, c);
                    m > -1 && (d = d.substr(0, m));
                  }
                  var v = c ? "scheme" : l ? "www" : "tld",
                    y = !!c;
                  s.push(
                    new f.match.Url({
                      tagBuilder: i,
                      matchedText: d,
                      offset: b,
                      urlMatchType: v,
                      url: d,
                      protocolUrlMatch: y,
                      protocolRelativeMatch: !!h,
                      stripPrefix: r,
                      stripTrailingSlash: o,
                      decodePercentEncoding: a,
                    })
                  );
                }
              }
              return s;
            },
            matchHasUnbalancedClosingParen: function (f) {
              var e = f.charAt(f.length - 1);
              if (")" === e) {
                var t = f.match(this.openParensRe),
                  n = f.match(this.closeParensRe),
                  r = (t && t.length) || 0,
                  o = (n && n.length) || 0;
                if (r < o) return !0;
              }
              return !1;
            },
            matchHasInvalidCharAfterTld: function (e, t) {
              if (!e) return -1;
              var n = 0;
              t && ((n = e.indexOf(":")), (e = e.slice(n)));
              var r = f.RegexLib.alphaNumericCharsStr,
                o = new RegExp(
                  "^((.?//)?[-." + r + "]*[-" + r + "]\\.[-" + r + "]+)"
                ),
                a = o.exec(e);
              return null === a
                ? -1
                : ((n += a[1].length),
                  (e = e.slice(a[1].length)),
                  /^[^-.A-Za-z0-9:\/?#]/.test(e) ? n : -1);
            },
          })),
          (f.matcher.UrlMatchValidator = {
            hasFullProtocolRegex: /^[A-Za-z][-.+A-Za-z0-9]*:\/\//,
            uriSchemeRegex: /^[A-Za-z][-.+A-Za-z0-9]*:/,
            hasWordCharAfterProtocolRegex: new RegExp(
              ":[^\\s]*?[" + f.RegexLib.alphaCharsStr + "]"
            ),
            ipRegex:
              /[0-9][0-9]?[0-9]?\.[0-9][0-9]?[0-9]?\.[0-9][0-9]?[0-9]?\.[0-9][0-9]?[0-9]?(:[0-9]*)?\/?$/,
            isValid: function (f, e) {
              return !(
                (e && !this.isValidUriScheme(e)) ||
                this.urlMatchDoesNotHaveProtocolOrDot(f, e) ||
                (this.urlMatchDoesNotHaveAtLeastOneWordChar(f, e) &&
                  !this.isValidIpAddress(f)) ||
                this.containsMultipleDots(f)
              );
            },
            isValidIpAddress: function (f) {
              var e = new RegExp(
                  this.hasFullProtocolRegex.source + this.ipRegex.source
                ),
                t = f.match(e);
              return null !== t;
            },
            containsMultipleDots: function (f) {
              var e = f;
              return (
                this.hasFullProtocolRegex.test(f) && (e = f.split("://")[1]),
                e.split("/")[0].indexOf("..") > -1
              );
            },
            isValidUriScheme: function (f) {
              var e = f.match(this.uriSchemeRegex)[0].toLowerCase();
              return "javascript:" !== e && "vbscript:" !== e;
            },
            urlMatchDoesNotHaveProtocolOrDot: function (f, e) {
              return (
                !!f &&
                (!e || !this.hasFullProtocolRegex.test(e)) &&
                -1 === f.indexOf(".")
              );
            },
            urlMatchDoesNotHaveAtLeastOneWordChar: function (f, e) {
              return !(!f || !e) && !this.hasWordCharAfterProtocolRegex.test(f);
            },
          }),
          (f.truncate.TruncateEnd = function (e, t, n) {
            return f.Util.ellipsis(e, t, n);
          }),
          (f.truncate.TruncateMiddle = function (f, e, t) {
            if (f.length <= e) return f;
            var n, r;
            null == t
              ? ((t = "&hellip;"), (n = 8), (r = 3))
              : ((n = t.length), (r = t.length));
            var o = e - r,
              a = "";
            return (
              o > 0 && (a = f.substr(-1 * Math.floor(o / 2))),
              (f.substr(0, Math.ceil(o / 2)) + t + a).substr(0, o + n)
            );
          }),
          (f.truncate.TruncateSmart = function (f, e, t) {
            var n, r;
            null == t
              ? ((t = "&hellip;"), (r = 3), (n = 8))
              : ((r = t.length), (n = t.length));
            var o = function (f) {
                var e = {},
                  t = f,
                  n = t.match(/^([a-z]+):\/\//i);
                return (
                  n && ((e.scheme = n[1]), (t = t.substr(n[0].length))),
                  (n = t.match(/^(.*?)(?=(\?|#|\/|$))/i)),
                  n && ((e.host = n[1]), (t = t.substr(n[0].length))),
                  (n = t.match(/^\/(.*?)(?=(\?|#|$))/i)),
                  n && ((e.path = n[1]), (t = t.substr(n[0].length))),
                  (n = t.match(/^\?(.*?)(?=(#|$))/i)),
                  n && ((e.query = n[1]), (t = t.substr(n[0].length))),
                  (n = t.match(/^#(.*?)$/i)),
                  n && (e.fragment = n[1]),
                  e
                );
              },
              a = function (f) {
                var e = "";
                return (
                  f.scheme && f.host && (e += f.scheme + "://"),
                  f.host && (e += f.host),
                  f.path && (e += "/" + f.path),
                  f.query && (e += "?" + f.query),
                  f.fragment && (e += "#" + f.fragment),
                  e
                );
              },
              i = function (f, e) {
                var n = e / 2,
                  r = Math.ceil(n),
                  o = -1 * Math.floor(n),
                  a = "";
                return o < 0 && (a = f.substr(o)), f.substr(0, r) + t + a;
              };
            if (f.length <= e) return f;
            var s = e - r,
              d = o(f);
            if (d.query) {
              var c = d.query.match(/^(.*?)(?=(\?|\#))(.*?)$/i);
              c && ((d.query = d.query.substr(0, c[1].length)), (f = a(d)));
            }
            if (f.length <= e) return f;
            if (
              (d.host && ((d.host = d.host.replace(/^www\./, "")), (f = a(d))),
              f.length <= e)
            )
              return f;
            var l = "";
            if ((d.host && (l += d.host), l.length >= s))
              return d.host.length == e
                ? (d.host.substr(0, e - r) + t).substr(0, s + n)
                : i(l, s).substr(0, s + n);
            var u = "";
            if (
              (d.path && (u += "/" + d.path),
              d.query && (u += "?" + d.query),
              u)
            ) {
              if ((l + u).length >= s) {
                if ((l + u).length == e) return (l + u).substr(0, e);
                var p = s - l.length;
                return (l + i(u, p)).substr(0, s + n);
              }
              l += u;
            }
            if (d.fragment) {
              var b = "#" + d.fragment;
              if ((l + b).length >= s) {
                if ((l + b).length == e) return (l + b).substr(0, e);
                var h = s - l.length;
                return (l + i(b, h)).substr(0, s + n);
              }
              l += b;
            }
            if (d.scheme && d.host) {
              var g = d.scheme + "://";
              if ((l + g).length < s) return (g + l).substr(0, e);
            }
            if (l.length <= e) return l;
            var m = "";
            return (
              s > 0 && (m = l.substr(-1 * Math.floor(s / 2))),
              (l.substr(0, Math.ceil(s / 2)) + t + m).substr(0, s + n)
            );
          }),
          f
        );
      });
    },
    "72af": function (f, e, t) {
      var n = t("99cd"),
        r = n();
      f.exports = r;
    },
    "72f0": function (f, e) {
      function t(f) {
        return function () {
          return f;
        };
      }
      f.exports = t;
    },
    "73ac": function (f, e, t) {
      var n = t("743f"),
        r = t("b047"),
        o = t("99d3"),
        a = o && o.isTypedArray,
        i = a ? r(a) : n;
      f.exports = i;
    },
    7418: function (f, e) {
      e.f = Object.getOwnPropertySymbols;
    },
    "743f": function (f, e, t) {
      var n = t("3729"),
        r = t("b218"),
        o = t("1310"),
        a = "[object Arguments]",
        i = "[object Array]",
        s = "[object Boolean]",
        d = "[object Date]",
        c = "[object Error]",
        l = "[object Function]",
        u = "[object Map]",
        p = "[object Number]",
        b = "[object Object]",
        h = "[object RegExp]",
        g = "[object Set]",
        m = "[object String]",
        v = "[object WeakMap]",
        y = "[object ArrayBuffer]",
        w = "[object DataView]",
        x = "[object Float32Array]",
        _ = "[object Float64Array]",
        k = "[object Int8Array]",
        M = "[object Int16Array]",
        C = "[object Int32Array]",
        A = "[object Uint8Array]",
        j = "[object Uint8ClampedArray]",
        I = "[object Uint16Array]",
        T = "[object Uint32Array]",
        S = {};
      function O(f) {
        return o(f) && r(f.length) && !!S[n(f)];
      }
      (S[x] = S[_] = S[k] = S[M] = S[C] = S[A] = S[j] = S[I] = S[T] = !0),
        (S[a] =
          S[i] =
          S[y] =
          S[s] =
          S[w] =
          S[d] =
          S[c] =
          S[l] =
          S[u] =
          S[p] =
          S[b] =
          S[h] =
          S[g] =
          S[m] =
          S[v] =
            !1),
        (f.exports = O);
    },
    "746f": function (f, e, t) {
      var n = t("428f"),
        r = t("1a2d"),
        o = t("e538"),
        a = t("9bf2").f;
      f.exports = function (f) {
        var e = n.Symbol || (n.Symbol = {});
        r(e, f) || a(e, f, { value: o.f(f) });
      };
    },
    7530: function (f, e, t) {
      var n = t("1a8c"),
        r = Object.create,
        o = (function () {
          function f() {}
          return function (e) {
            if (!n(e)) return {};
            if (r) return r(e);
            f.prototype = e;
            var t = new f();
            return (f.prototype = void 0), t;
          };
        })();
      f.exports = o;
    },
    7839: function (f, e) {
      f.exports = [
        "constructor",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "toLocaleString",
        "toString",
        "valueOf",
      ];
    },
    "785a": function (f, e, t) {
      var n = t("cc12"),
        r = n("span").classList,
        o = r && r.constructor && r.constructor.prototype;
      f.exports = o === Object.prototype ? void 0 : o;
    },
    "79bc": function (f, e, t) {
      var n = t("0b07"),
        r = t("2b3e"),
        o = n(r, "Map");
      f.exports = o;
    },
    "7a48": function (f, e, t) {
      var n = t("6044"),
        r = Object.prototype,
        o = r.hasOwnProperty;
      function a(f) {
        var e = this.__data__;
        return n ? void 0 !== e[f] : o.call(e, f);
      }
      f.exports = a;
    },
    "7a82": function (f, e, t) {
      var n = t("23e7"),
        r = t("83ab"),
        o = t("9bf2");
      n(
        { target: "Object", stat: !0, forced: !r, sham: !r },
        { defineProperty: o.f }
      );
    },
    "7b0b": function (f, e, t) {
      var n = t("da84"),
        r = t("1d80"),
        o = n.Object;
      f.exports = function (f) {
        return o(r(f));
      };
    },
    "7b83": function (f, e, t) {
      var n = t("7c64"),
        r = t("93ed"),
        o = t("2478"),
        a = t("a524"),
        i = t("1fc8");
      function s(f) {
        var e = -1,
          t = null == f ? 0 : f.length;
        this.clear();
        while (++e < t) {
          var n = f[e];
          this.set(n[0], n[1]);
        }
      }
      (s.prototype.clear = n),
        (s.prototype["delete"] = r),
        (s.prototype.get = o),
        (s.prototype.has = a),
        (s.prototype.set = i),
        (f.exports = s);
    },
    "7b97": function (f, e, t) {
      var n = t("7e64"),
        r = t("a2be"),
        o = t("1c3c"),
        a = t("b1e5"),
        i = t("42a2"),
        s = t("6747"),
        d = t("0d24"),
        c = t("73ac"),
        l = 1,
        u = "[object Arguments]",
        p = "[object Array]",
        b = "[object Object]",
        h = Object.prototype,
        g = h.hasOwnProperty;
      function m(f, e, t, h, m, v) {
        var y = s(f),
          w = s(e),
          x = y ? p : i(f),
          _ = w ? p : i(e);
        (x = x == u ? b : x), (_ = _ == u ? b : _);
        var k = x == b,
          M = _ == b,
          C = x == _;
        if (C && d(f)) {
          if (!d(e)) return !1;
          (y = !0), (k = !1);
        }
        if (C && !k)
          return (
            v || (v = new n()),
            y || c(f) ? r(f, e, t, h, m, v) : o(f, e, x, t, h, m, v)
          );
        if (!(t & l)) {
          var A = k && g.call(f, "__wrapped__"),
            j = M && g.call(e, "__wrapped__");
          if (A || j) {
            var I = A ? f.value() : f,
              T = j ? e.value() : e;
            return v || (v = new n()), m(I, T, t, h, v);
          }
        }
        return !!C && (v || (v = new n()), a(f, e, t, h, m, v));
      }
      f.exports = m;
    },
    "7bd0": function (f, e, t) {
      var n = t("24fb");
      (e = n(!1)),
        e.push([
          f.i,
          ".sc-user-input[data-v-23e31aa6]{min-height:55px;max-height:55px;margin:0;position:relative;bottom:0;background-color:#f4f7f9;transition:background-color .2s ease,box-shadow .2s ease}.sc-user-input[data-v-23e31aa6],.sc-user-input-area[data-v-23e31aa6]{display:flex;border-bottom-left-radius:10px;border-bottom-right-radius:10px}.sc-user-input-area[data-v-23e31aa6]{width:100%;align-items:center;background-color:#eee}.sc-user-input--text[data-v-23e31aa6]{flex-grow:1;outline:none;border:0;box-sizing:border-box;margin:10px;padding:4px 15px;font-size:15px;line-height:1.33;white-space:pre-wrap;word-wrap:break-word;color:#565867;-webkit-font-smoothing:antialiased;max-height:200px;overflow-x:hidden;overflow-y:auto;background-color:#fff;border-radius:20px}input[type=text][data-v-23e31aa6]:disabled{background-color:#ddd}.sc-user-input--text[data-v-23e31aa6]:empty:before{content:attr(placeholder);display:block;filter:contrast(15%);outline:none;cursor:text}.sc-user-input--word-counter[data-v-23e31aa6]{font-size:10px;display:flex;align-items:flex-end}.sc-user-input--buttons[data-v-23e31aa6]{display:flex;align-items:center;padding:0 4px}.sc-user-input--button[data-v-23e31aa6]{margin:0 4px}.file-container[data-v-23e31aa6]{background-color:#f4f7f9;border-top-left-radius:10px;padding:5px 20px;color:#565867}.delete-file-message[data-v-23e31aa6]{font-style:normal;float:right;cursor:pointer;color:#c8cad0}.delete-file-message[data-v-23e31aa6]:hover{color:#5d5e6d}.icon-file-message[data-v-23e31aa6]{margin-right:5px}.sc-review-btn[data-v-23e31aa6]{position:absolute;right:0;bottom:65px}",
          "",
        ]),
        (f.exports = e);
    },
    "7c64": function (f, e, t) {
      var n = t("e24b"),
        r = t("5e2e"),
        o = t("79bc");
      function a() {
        (this.size = 0),
          (this.__data__ = {
            hash: new n(),
            map: new (o || r)(),
            string: new n(),
          });
      }
      f.exports = a;
    },
    "7c73": function (f, e, t) {
      var n,
        r = t("825a"),
        o = t("37e8"),
        a = t("7839"),
        i = t("d012"),
        s = t("1be4"),
        d = t("cc12"),
        c = t("f772"),
        l = ">",
        u = "<",
        p = "prototype",
        b = "script",
        h = c("IE_PROTO"),
        g = function () {},
        m = function (f) {
          return u + b + l + f + u + "/" + b + l;
        },
        v = function (f) {
          f.write(m("")), f.close();
          var e = f.parentWindow.Object;
          return (f = null), e;
        },
        y = function () {
          var f,
            e = d("iframe"),
            t = "java" + b + ":";
          return (
            (e.style.display = "none"),
            s.appendChild(e),
            (e.src = String(t)),
            (f = e.contentWindow.document),
            f.open(),
            f.write(m("document.F=Object")),
            f.close(),
            f.F
          );
        },
        w = function () {
          try {
            n = new ActiveXObject("htmlfile");
          } catch (e) {}
          w =
            "undefined" != typeof document
              ? document.domain && n
                ? v(n)
                : y()
              : v(n);
          var f = a.length;
          while (f--) delete w[p][a[f]];
          return w();
        };
      (i[h] = !0),
        (f.exports =
          Object.create ||
          function (f, e) {
            var t;
            return (
              null !== f
                ? ((g[p] = r(f)), (t = new g()), (g[p] = null), (t[h] = f))
                : (t = w()),
              void 0 === e ? t : o(t, e)
            );
          });
    },
    "7d1f": function (f, e, t) {
      var n = t("087d"),
        r = t("6747");
      function o(f, e, t) {
        var o = e(f);
        return r(f) ? o : n(o, t(f));
      }
      f.exports = o;
    },
    "7db0": function (f, e, t) {
      "use strict";
      var n = t("23e7"),
        r = t("b727").find,
        o = t("44d2"),
        a = "find",
        i = !0;
      a in [] &&
        Array(1)[a](function () {
          i = !1;
        }),
        n(
          { target: "Array", proto: !0, forced: i },
          {
            find: function (f) {
              return r(this, f, arguments.length > 1 ? arguments[1] : void 0);
            },
          }
        ),
        o(a);
    },
    "7dd0": function (f, e, t) {
      "use strict";
      var n = t("23e7"),
        r = t("c65b"),
        o = t("c430"),
        a = t("5e77"),
        i = t("1626"),
        s = t("9ed3"),
        d = t("e163"),
        c = t("d2bb"),
        l = t("d44e"),
        u = t("9112"),
        p = t("6eeb"),
        b = t("b622"),
        h = t("3f8c"),
        g = t("ae93"),
        m = a.PROPER,
        v = a.CONFIGURABLE,
        y = g.IteratorPrototype,
        w = g.BUGGY_SAFARI_ITERATORS,
        x = b("iterator"),
        _ = "keys",
        k = "values",
        M = "entries",
        C = function () {
          return this;
        };
      f.exports = function (f, e, t, a, b, g, A) {
        s(t, e, a);
        var j,
          I,
          T,
          S = function (f) {
            if (f === b && z) return z;
            if (!w && f in L) return L[f];
            switch (f) {
              case _:
                return function () {
                  return new t(this, f);
                };
              case k:
                return function () {
                  return new t(this, f);
                };
              case M:
                return function () {
                  return new t(this, f);
                };
            }
            return function () {
              return new t(this);
            };
          },
          O = e + " Iterator",
          E = !1,
          L = f.prototype,
          N = L[x] || L["@@iterator"] || (b && L[b]),
          z = (!w && N) || S(b),
          P = ("Array" == e && L.entries) || N;
        if (
          (P &&
            ((j = d(P.call(new f()))),
            j !== Object.prototype &&
              j.next &&
              (o || d(j) === y || (c ? c(j, y) : i(j[x]) || p(j, x, C)),
              l(j, O, !0, !0),
              o && (h[O] = C))),
          m &&
            b == k &&
            N &&
            N.name !== k &&
            (!o && v
              ? u(L, "name", k)
              : ((E = !0),
                (z = function () {
                  return r(N, this);
                }))),
          b)
        )
          if (((I = { values: S(k), keys: g ? z : S(_), entries: S(M) }), A))
            for (T in I) (w || E || !(T in L)) && p(L, T, I[T]);
          else n({ target: e, proto: !0, forced: w || E }, I);
        return (
          (o && !A) || L[x] === z || p(L, x, z, { name: b }), (h[e] = z), I
        );
      };
    },
    "7e64": function (f, e, t) {
      var n = t("5e2e"),
        r = t("efb6"),
        o = t("2fcc"),
        a = t("802a"),
        i = t("55a3"),
        s = t("d02c");
      function d(f) {
        var e = (this.__data__ = new n(f));
        this.size = e.size;
      }
      (d.prototype.clear = r),
        (d.prototype["delete"] = o),
        (d.prototype.get = a),
        (d.prototype.has = i),
        (d.prototype.set = s),
        (f.exports = d);
    },
    "7ed2": function (f, e) {
      var t = "__lodash_hash_undefined__";
      function n(f) {
        return this.__data__.set(f, t), this;
      }
      f.exports = n;
    },
    "7f2b": function (f, e, t) {
      "use strict";
      t("99ec");
    },
    "7f9a": function (f, e, t) {
      var n = t("da84"),
        r = t("1626"),
        o = t("8925"),
        a = n.WeakMap;
      f.exports = r(a) && /native code/.test(o(a));
    },
    "802a": function (f, e) {
      function t(f) {
        return this.__data__.get(f);
      }
      f.exports = t;
    },
    "825a": function (f, e, t) {
      var n = t("da84"),
        r = t("861d"),
        o = n.String,
        a = n.TypeError;
      f.exports = function (f) {
        if (r(f)) return f;
        throw a(o(f) + " is not an object");
      };
    },
    "83ab": function (f, e, t) {
      var n = t("d039");
      f.exports = !n(function () {
        return (
          7 !=
          Object.defineProperty({}, 1, {
            get: function () {
              return 7;
            },
          })[1]
        );
      });
    },
    8418: function (f, e, t) {
      "use strict";
      var n = t("a04b"),
        r = t("9bf2"),
        o = t("5c6c");
      f.exports = function (f, e, t) {
        var a = n(e);
        a in f ? r.f(f, a, o(0, t)) : (f[a] = t);
      };
    },
    "842b": function (f, e, t) {
      var n = t("24fb");
      (e = n(!1)),
        e.push([
          f.i,
          ".sc-message--system[data-v-50d00423]{padding:8px 20px;border-radius:10px;font-weight:500;font-size:12px;line-height:1.2;white-space:pre-wrap;-webkit-font-smoothing:subpixel-antialiased;font-style:italic;opacity:.55}.sc-message--meta[data-v-50d00423]{font-size:xx-small;margin-bottom:0;margin-top:5px;opacity:.5;text-align:center}",
          "",
        ]),
        (f.exports = e);
    },
    8571: function (f, e, t) {
      "use strict";
      t("443c");
    },
    "857a": function (f, e, t) {
      var n = t("e330"),
        r = t("1d80"),
        o = t("577e"),
        a = /"/g,
        i = n("".replace);
      f.exports = function (f, e, t, n) {
        var s = o(r(f)),
          d = "<" + e;
        return (
          "" !== t && (d += " " + t + '="' + i(o(n), a, "&quot;") + '"'),
          d + ">" + s + "</" + e + ">"
        );
      };
    },
    "85e3": function (f, e) {
      function t(f, e, t) {
        switch (t.length) {
          case 0:
            return f.call(e);
          case 1:
            return f.call(e, t[0]);
          case 2:
            return f.call(e, t[0], t[1]);
          case 3:
            return f.call(e, t[0], t[1], t[2]);
        }
        return f.apply(e, t);
      }
      f.exports = t;
    },
    "861d": function (f, e, t) {
      var n = t("1626");
      f.exports = function (f) {
        return "object" == typeof f ? null !== f : n(f);
      };
    },
    "872a": function (f, e, t) {
      var n = t("3b4a");
      function r(f, e, t) {
        "__proto__" == e && n
          ? n(f, e, {
              configurable: !0,
              enumerable: !0,
              value: t,
              writable: !0,
            })
          : (f[e] = t);
      }
      f.exports = r;
    },
    8925: function (f, e, t) {
      var n = t("e330"),
        r = t("1626"),
        o = t("c6cd"),
        a = n(Function.toString);
      r(o.inspectSource) ||
        (o.inspectSource = function (f) {
          return a(f);
        }),
        (f.exports = o.inspectSource);
    },
    "8aa5": function (f, e, t) {
      "use strict";
      var n = t("6547").charAt;
      f.exports = function (f, e, t) {
        return e + (t ? n(f, e).length : 1);
      };
    },
    "8adb": function (f, e) {
      function t(f, e) {
        if (
          ("constructor" !== e || "function" !== typeof f[e]) &&
          "__proto__" != e
        )
          return f[e];
      }
      f.exports = t;
    },
    "8bbf": function (e, t) {
      e.exports = f;
    },
    "8dd5": function (f, e, t) {
      var n = t("11d3");
      n.__esModule && (n = n.default),
        "string" === typeof n && (n = [[f.i, n, ""]]),
        n.locals && (f.exports = n.locals);
      var r = t("499e").default;
      r("25c1cea7", n, !0, { sourceMap: !1, shadowMode: !1 });
    },
    "8de2": function (f, e, t) {
      var n = t("8eeb"),
        r = t("9934");
      function o(f) {
        return n(f, r(f));
      }
      f.exports = o;
    },
    "8eeb": function (f, e, t) {
      var n = t("32b3"),
        r = t("872a");
      function o(f, e, t, o) {
        var a = !t;
        t || (t = {});
        var i = -1,
          s = e.length;
        while (++i < s) {
          var d = e[i],
            c = o ? o(t[d], f[d], d, t, f) : void 0;
          void 0 === c && (c = f[d]), a ? r(t, d, c) : n(t, d, c);
        }
        return t;
      }
      f.exports = o;
    },
    "90e3": function (f, e, t) {
      var n = t("e330"),
        r = 0,
        o = Math.random(),
        a = n((1).toString);
      f.exports = function (f) {
        return "Symbol(" + (void 0 === f ? "" : f) + ")_" + a(++r + o, 36);
      };
    },
    9112: function (f, e, t) {
      var n = t("83ab"),
        r = t("9bf2"),
        o = t("5c6c");
      f.exports = n
        ? function (f, e, t) {
            return r.f(f, e, o(1, t));
          }
        : function (f, e, t) {
            return (f[e] = t), f;
          };
    },
    "91e9": function (f, e) {
      function t(f, e) {
        return function (t) {
          return f(e(t));
        };
      }
      f.exports = t;
    },
    9263: function (f, e, t) {
      "use strict";
      var n = t("c65b"),
        r = t("e330"),
        o = t("577e"),
        a = t("ad6d"),
        i = t("9f7f"),
        s = t("5692"),
        d = t("7c73"),
        c = t("69f3").get,
        l = t("fce3"),
        u = t("107c"),
        p = s("native-string-replace", String.prototype.replace),
        b = RegExp.prototype.exec,
        h = b,
        g = r("".charAt),
        m = r("".indexOf),
        v = r("".replace),
        y = r("".slice),
        w = (function () {
          var f = /a/,
            e = /b*/g;
          return (
            n(b, f, "a"), n(b, e, "a"), 0 !== f.lastIndex || 0 !== e.lastIndex
          );
        })(),
        x = i.BROKEN_CARET,
        _ = void 0 !== /()??/.exec("")[1],
        k = w || _ || x || l || u;
      k &&
        (h = function (f) {
          var e,
            t,
            r,
            i,
            s,
            l,
            u,
            k = this,
            M = c(k),
            C = o(f),
            A = M.raw;
          if (A)
            return (
              (A.lastIndex = k.lastIndex),
              (e = n(h, A, C)),
              (k.lastIndex = A.lastIndex),
              e
            );
          var j = M.groups,
            I = x && k.sticky,
            T = n(a, k),
            S = k.source,
            O = 0,
            E = C;
          if (
            (I &&
              ((T = v(T, "y", "")),
              -1 === m(T, "g") && (T += "g"),
              (E = y(C, k.lastIndex)),
              k.lastIndex > 0 &&
                (!k.multiline ||
                  (k.multiline && "\n" !== g(C, k.lastIndex - 1))) &&
                ((S = "(?: " + S + ")"), (E = " " + E), O++),
              (t = new RegExp("^(?:" + S + ")", T))),
            _ && (t = new RegExp("^" + S + "$(?!\\s)", T)),
            w && (r = k.lastIndex),
            (i = n(b, I ? t : k, E)),
            I
              ? i
                ? ((i.input = y(i.input, O)),
                  (i[0] = y(i[0], O)),
                  (i.index = k.lastIndex),
                  (k.lastIndex += i[0].length))
                : (k.lastIndex = 0)
              : w && i && (k.lastIndex = k.global ? i.index + i[0].length : r),
            _ &&
              i &&
              i.length > 1 &&
              n(p, i[0], t, function () {
                for (s = 1; s < arguments.length - 2; s++)
                  void 0 === arguments[s] && (i[s] = void 0);
              }),
            i && j)
          )
            for (i.groups = l = d(null), s = 0; s < j.length; s++)
              (u = j[s]), (l[u[0]] = i[u[1]]);
          return i;
        }),
        (f.exports = h);
    },
    "93ed": function (f, e, t) {
      var n = t("4245");
      function r(f) {
        var e = n(this, f)["delete"](f);
        return (this.size -= e ? 1 : 0), e;
      }
      f.exports = r;
    },
    "94ca": function (f, e, t) {
      var n = t("d039"),
        r = t("1626"),
        o = /#|\.prototype\./,
        a = function (f, e) {
          var t = s[i(f)];
          return t == c || (t != d && (r(e) ? n(e) : !!e));
        },
        i = (a.normalize = function (f) {
          return String(f).replace(o, ".").toLowerCase();
        }),
        s = (a.data = {}),
        d = (a.NATIVE = "N"),
        c = (a.POLYFILL = "P");
      f.exports = a;
    },
    9520: function (f, e, t) {
      var n = t("3729"),
        r = t("1a8c"),
        o = "[object AsyncFunction]",
        a = "[object Function]",
        i = "[object GeneratorFunction]",
        s = "[object Proxy]";
      function d(f) {
        if (!r(f)) return !1;
        var e = n(f);
        return e == a || e == i || e == o || e == s;
      }
      f.exports = d;
    },
    9523: function (f, e, t) {
      function n(f, e, t) {
        return (
          e in f
            ? Object.defineProperty(f, e, {
                value: t,
                enumerable: !0,
                configurable: !0,
                writable: !0,
              })
            : (f[e] = t),
          f
        );
      }
      t("7a82"),
        (f.exports = n),
        (f.exports["default"] = f.exports),
        (f.exports.__esModule = !0);
    },
    9638: function (f, e) {
      function t(f, e) {
        return f === e || (f !== f && e !== e);
      }
      f.exports = t;
    },
    "96ec": function (f, e, t) {
      "use strict";
      t("ae3e");
    },
    "970b": function (f, e) {
      function t(f, e) {
        if (!(f instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      (f.exports = t),
        (f.exports["default"] = f.exports),
        (f.exports.__esModule = !0);
    },
    9911: function (f, e, t) {
      "use strict";
      var n = t("23e7"),
        r = t("857a"),
        o = t("af03");
      n(
        { target: "String", proto: !0, forced: o("link") },
        {
          link: function (f) {
            return r(this, "a", "href", f);
          },
        }
      );
    },
    9934: function (f, e, t) {
      var n = t("6fcd"),
        r = t("41c3"),
        o = t("30c9");
      function a(f) {
        return o(f) ? n(f, !0) : r(f);
      }
      f.exports = a;
    },
    "99cd": function (f, e) {
      function t(f) {
        return function (e, t, n) {
          var r = -1,
            o = Object(e),
            a = n(e),
            i = a.length;
          while (i--) {
            var s = a[f ? i : ++r];
            if (!1 === t(o[s], s, o)) break;
          }
          return e;
        };
      }
      f.exports = t;
    },
    "99d3": function (f, e, t) {
      (function (f) {
        var n = t("585a"),
          r = e && !e.nodeType && e,
          o = r && "object" == typeof f && f && !f.nodeType && f,
          a = o && o.exports === r,
          i = a && n.process,
          s = (function () {
            try {
              var f = o && o.require && o.require("util").types;
              return f || (i && i.binding && i.binding("util"));
            } catch (e) {}
          })();
        f.exports = s;
      }).call(this, t("62e4")(f));
    },
    "99ec": function (f, e, t) {
      var n = t("fc8c");
      n.__esModule && (n = n.default),
        "string" === typeof n && (n = [[f.i, n, ""]]),
        n.locals && (f.exports = n.locals);
      var r = t("499e").default;
      r("fd677b4a", n, !0, { sourceMap: !1, shadowMode: !1 });
    },
    "9a1e": function (f, e, t) {
      var n = t("24fb");
      (e = n(!1)),
        e.push([
          f.i,
          ".sc-review-btn-body[data-v-46bb18a0]{padding:5px 15px;background-position:50%;background-repeat:no-repeat;border-radius:17px 0 0 17px;box-shadow:none;transition:box-shadow .2s ease-in-out;cursor:pointer;display:flex;align-items:center}.sc-review-btn-body *[data-v-46bb18a0]{color:#fff}.sc-review-btn-icon[data-v-46bb18a0]{margin-right:6px}",
          "",
        ]),
        (f.exports = e);
    },
    "9a1f": function (f, e, t) {
      var n = t("da84"),
        r = t("c65b"),
        o = t("59ed"),
        a = t("825a"),
        i = t("0d51"),
        s = t("35a1"),
        d = n.TypeError;
      f.exports = function (f, e) {
        var t = arguments.length < 2 ? s(f) : e;
        if (o(t)) return a(r(t, f));
        throw d(i(f) + " is not iterable");
      };
    },
    "9aff": function (f, e, t) {
      var n = t("9638"),
        r = t("30c9"),
        o = t("c098"),
        a = t("1a8c");
      function i(f, e, t) {
        if (!a(t)) return !1;
        var i = typeof e;
        return (
          !!("number" == i
            ? r(t) && o(e, t.length)
            : "string" == i && e in t) && n(t[e], f)
        );
      }
      f.exports = i;
    },
    "9bf2": function (f, e, t) {
      var n = t("da84"),
        r = t("83ab"),
        o = t("0cfb"),
        a = t("825a"),
        i = t("a04b"),
        s = n.TypeError,
        d = Object.defineProperty;
      e.f = r
        ? d
        : function (f, e, t) {
            if ((a(f), (e = i(e)), a(t), o))
              try {
                return d(f, e, t);
              } catch (n) {}
            if ("get" in t || "set" in t) throw s("Accessors not supported");
            return "value" in t && (f[e] = t.value), f;
          };
    },
    "9e69": function (f, e, t) {
      var n = t("2b3e"),
        r = n.Symbol;
      f.exports = r;
    },
    "9ed3": function (f, e, t) {
      "use strict";
      var n = t("ae93").IteratorPrototype,
        r = t("7c73"),
        o = t("5c6c"),
        a = t("d44e"),
        i = t("3f8c"),
        s = function () {
          return this;
        };
      f.exports = function (f, e, t) {
        var d = e + " Iterator";
        return (
          (f.prototype = r(n, { next: o(1, t) })),
          a(f, d, !1, !0),
          (i[d] = s),
          f
        );
      };
    },
    "9f7f": function (f, e, t) {
      var n = t("d039"),
        r = t("da84"),
        o = r.RegExp,
        a = n(function () {
          var f = o("a", "y");
          return (f.lastIndex = 2), null != f.exec("abcd");
        }),
        i =
          a ||
          n(function () {
            return !o("a", "y").sticky;
          }),
        s =
          a ||
          n(function () {
            var f = o("^r", "gy");
            return (f.lastIndex = 2), null != f.exec("str");
          });
      f.exports = { BROKEN_CARET: s, MISSED_STICKY: i, UNSUPPORTED_Y: a };
    },
    a04b: function (f, e, t) {
      var n = t("c04e"),
        r = t("d9b5");
      f.exports = function (f) {
        var e = n(f, "string");
        return r(e) ? e : e + "";
      };
    },
    a05a: function (f, e, t) {
      var n = t("24fb");
      (e = n(!1)),
        e.push([
          f.i,
          ".modal-mask[data-v-1d5e0284]{position:absolute;z-index:9998;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.6);display:table;transition:opacity .3s ease;border-radius:9px}.modal-wrapper[data-v-1d5e0284]{display:table-cell;vertical-align:middle}.modal-container[data-v-1d5e0284]{width:300px;margin:0 auto;border-radius:5px;box-shadow:0 2px 8px rgba(0,0,0,.33);transition:all .3s ease;font-family:Helvetica,Arial,sans-serif}.modal-header[data-v-1d5e0284]{display:flex;justify-content:space-between;padding:20px;border-top-left-radius:5px;border-top-right-radius:5px}.modal-body[data-v-1d5e0284]{text-align:center}.modal-body[data-v-1d5e0284],.modal-footer[data-v-1d5e0284]{padding:20px;background-color:#fff}.modal-footer[data-v-1d5e0284]{text-align:right;border-bottom-left-radius:5px;border-bottom-right-radius:5px}.modal-default-button[data-v-1d5e0284]{float:right}.modal-enter[data-v-1d5e0284],.modal-leave-active[data-v-1d5e0284]{opacity:0}.modal-enter .modal-container[data-v-1d5e0284],.modal-leave-active .modal-container[data-v-1d5e0284]{transform:scale(1.1)}.sc-header--close-button[data-v-1d5e0284]{width:40px;align-self:center;height:40px;box-sizing:border-box;cursor:pointer;border-radius:5px;margin-left:auto}.sc-header--close-button img[data-v-1d5e0284]{width:100%;height:100%;padding:13px;box-sizing:border-box}.sc-header--username[data-v-1d5e0284]{display:flex;flex-direction:column;justify-content:center}.sc-header--username--name[data-v-1d5e0284]{color:#fff;font-weight:600;font-size:16px}.btn[data-v-1d5e0284]{background-color:transparent;border:0;cursor:pointer}",
          "",
        ]),
        (f.exports = e);
    },
    a1a1: function (f, e, t) {
      "use strict";
      t("f5e6");
    },
    a2be: function (f, e, t) {
      var n = t("d612"),
        r = t("4284"),
        o = t("c584"),
        a = 1,
        i = 2;
      function s(f, e, t, s, d, c) {
        var l = t & a,
          u = f.length,
          p = e.length;
        if (u != p && !(l && p > u)) return !1;
        var b = c.get(f),
          h = c.get(e);
        if (b && h) return b == e && h == f;
        var g = -1,
          m = !0,
          v = t & i ? new n() : void 0;
        c.set(f, e), c.set(e, f);
        while (++g < u) {
          var y = f[g],
            w = e[g];
          if (s) var x = l ? s(w, y, g, e, f, c) : s(y, w, g, f, e, c);
          if (void 0 !== x) {
            if (x) continue;
            m = !1;
            break;
          }
          if (v) {
            if (
              !r(e, function (f, e) {
                if (!o(v, e) && (y === f || d(y, f, t, s, c))) return v.push(e);
              })
            ) {
              m = !1;
              break;
            }
          } else if (y !== w && !d(y, w, t, s, c)) {
            m = !1;
            break;
          }
        }
        return c["delete"](f), c["delete"](e), m;
      }
      f.exports = s;
    },
    a454: function (f, e, t) {
      var n = t("72f0"),
        r = t("3b4a"),
        o = t("cd9d"),
        a = r
          ? function (f, e) {
              return r(f, "toString", {
                configurable: !0,
                enumerable: !1,
                value: n(e),
                writable: !0,
              });
            }
          : o;
      f.exports = a;
    },
    a4b4: function (f, e, t) {
      var n = t("342f");
      f.exports = /web0s(?!.*chrome)/i.test(n);
    },
    a4d3: function (f, e, t) {
      "use strict";
      var n = t("23e7"),
        r = t("da84"),
        o = t("d066"),
        a = t("2ba4"),
        i = t("c65b"),
        s = t("e330"),
        d = t("c430"),
        c = t("83ab"),
        l = t("4930"),
        u = t("d039"),
        p = t("1a2d"),
        b = t("e8b5"),
        h = t("1626"),
        g = t("861d"),
        m = t("3a9b"),
        v = t("d9b5"),
        y = t("825a"),
        w = t("7b0b"),
        x = t("fc6a"),
        _ = t("a04b"),
        k = t("577e"),
        M = t("5c6c"),
        C = t("7c73"),
        A = t("df75"),
        j = t("241c"),
        I = t("057f"),
        T = t("7418"),
        S = t("06cf"),
        O = t("9bf2"),
        E = t("d1e7"),
        L = t("f36a"),
        N = t("6eeb"),
        z = t("5692"),
        P = t("f772"),
        D = t("d012"),
        B = t("90e3"),
        R = t("b622"),
        U = t("e538"),
        F = t("746f"),
        G = t("d44e"),
        H = t("69f3"),
        Z = t("b727").forEach,
        q = P("hidden"),
        Q = "Symbol",
        W = "prototype",
        V = R("toPrimitive"),
        J = H.set,
        Y = H.getterFor(Q),
        X = Object[W],
        K = r.Symbol,
        $ = K && K[W],
        ff = r.TypeError,
        ef = r.QObject,
        tf = o("JSON", "stringify"),
        nf = S.f,
        rf = O.f,
        of = I.f,
        af = E.f,
        sf = s([].push),
        df = z("symbols"),
        cf = z("op-symbols"),
        lf = z("string-to-symbol-registry"),
        uf = z("symbol-to-string-registry"),
        pf = z("wks"),
        bf = !ef || !ef[W] || !ef[W].findChild,
        hf =
          c &&
          u(function () {
            return (
              7 !=
              C(
                rf({}, "a", {
                  get: function () {
                    return rf(this, "a", { value: 7 }).a;
                  },
                })
              ).a
            );
          })
            ? function (f, e, t) {
                var n = nf(X, e);
                n && delete X[e], rf(f, e, t), n && f !== X && rf(X, e, n);
              }
            : rf,
        gf = function (f, e) {
          var t = (df[f] = C($));
          return (
            J(t, { type: Q, tag: f, description: e }),
            c || (t.description = e),
            t
          );
        },
        mf = function (f, e, t) {
          f === X && mf(cf, e, t), y(f);
          var n = _(e);
          return (
            y(t),
            p(df, n)
              ? (t.enumerable
                  ? (p(f, q) && f[q][n] && (f[q][n] = !1),
                    (t = C(t, { enumerable: M(0, !1) })))
                  : (p(f, q) || rf(f, q, M(1, {})), (f[q][n] = !0)),
                hf(f, n, t))
              : rf(f, n, t)
          );
        },
        vf = function (f, e) {
          y(f);
          var t = x(e),
            n = A(t).concat(kf(t));
          return (
            Z(n, function (e) {
              (c && !i(wf, t, e)) || mf(f, e, t[e]);
            }),
            f
          );
        },
        yf = function (f, e) {
          return void 0 === e ? C(f) : vf(C(f), e);
        },
        wf = function (f) {
          var e = _(f),
            t = i(af, this, e);
          return (
            !(this === X && p(df, e) && !p(cf, e)) &&
            (!(t || !p(this, e) || !p(df, e) || (p(this, q) && this[q][e])) ||
              t)
          );
        },
        xf = function (f, e) {
          var t = x(f),
            n = _(e);
          if (t !== X || !p(df, n) || p(cf, n)) {
            var r = nf(t, n);
            return (
              !r || !p(df, n) || (p(t, q) && t[q][n]) || (r.enumerable = !0), r
            );
          }
        },
        _f = function (f) {
          var e = of(x(f)),
            t = [];
          return (
            Z(e, function (f) {
              p(df, f) || p(D, f) || sf(t, f);
            }),
            t
          );
        },
        kf = function (f) {
          var e = f === X,
            t = of(e ? cf : x(f)),
            n = [];
          return (
            Z(t, function (f) {
              !p(df, f) || (e && !p(X, f)) || sf(n, df[f]);
            }),
            n
          );
        };
      if (
        (l ||
          ((K = function () {
            if (m($, this)) throw ff("Symbol is not a constructor");
            var f =
                arguments.length && void 0 !== arguments[0]
                  ? k(arguments[0])
                  : void 0,
              e = B(f),
              t = function (f) {
                this === X && i(t, cf, f),
                  p(this, q) && p(this[q], e) && (this[q][e] = !1),
                  hf(this, e, M(1, f));
              };
            return c && bf && hf(X, e, { configurable: !0, set: t }), gf(e, f);
          }),
          ($ = K[W]),
          N($, "toString", function () {
            return Y(this).tag;
          }),
          N(K, "withoutSetter", function (f) {
            return gf(B(f), f);
          }),
          (E.f = wf),
          (O.f = mf),
          (S.f = xf),
          (j.f = I.f = _f),
          (T.f = kf),
          (U.f = function (f) {
            return gf(R(f), f);
          }),
          c &&
            (rf($, "description", {
              configurable: !0,
              get: function () {
                return Y(this).description;
              },
            }),
            d || N(X, "propertyIsEnumerable", wf, { unsafe: !0 }))),
        n({ global: !0, wrap: !0, forced: !l, sham: !l }, { Symbol: K }),
        Z(A(pf), function (f) {
          F(f);
        }),
        n(
          { target: Q, stat: !0, forced: !l },
          {
            for: function (f) {
              var e = k(f);
              if (p(lf, e)) return lf[e];
              var t = K(e);
              return (lf[e] = t), (uf[t] = e), t;
            },
            keyFor: function (f) {
              if (!v(f)) throw ff(f + " is not a symbol");
              if (p(uf, f)) return uf[f];
            },
            useSetter: function () {
              bf = !0;
            },
            useSimple: function () {
              bf = !1;
            },
          }
        ),
        n(
          { target: "Object", stat: !0, forced: !l, sham: !c },
          {
            create: yf,
            defineProperty: mf,
            defineProperties: vf,
            getOwnPropertyDescriptor: xf,
          }
        ),
        n(
          { target: "Object", stat: !0, forced: !l },
          { getOwnPropertyNames: _f, getOwnPropertySymbols: kf }
        ),
        n(
          {
            target: "Object",
            stat: !0,
            forced: u(function () {
              T.f(1);
            }),
          },
          {
            getOwnPropertySymbols: function (f) {
              return T.f(w(f));
            },
          }
        ),
        tf)
      ) {
        var Mf =
          !l ||
          u(function () {
            var f = K();
            return (
              "[null]" != tf([f]) ||
              "{}" != tf({ a: f }) ||
              "{}" != tf(Object(f))
            );
          });
        n(
          { target: "JSON", stat: !0, forced: Mf },
          {
            stringify: function (f, e, t) {
              var n = L(arguments),
                r = e;
              if ((g(e) || void 0 !== f) && !v(f))
                return (
                  b(e) ||
                    (e = function (f, e) {
                      if ((h(r) && (e = i(r, this, f, e)), !v(e))) return e;
                    }),
                  (n[1] = e),
                  a(tf, null, n)
                );
            },
          }
        );
      }
      if (!$[V]) {
        var Cf = $.valueOf;
        N($, V, function (f) {
          return i(Cf, this);
        });
      }
      G(K, Q), (D[q] = !0);
    },
    a524: function (f, e, t) {
      var n = t("4245");
      function r(f) {
        return n(this, f).has(f);
      }
      f.exports = r;
    },
    a5d7: function (f, e) {
      f.exports =
        "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSItNDc0OS40OCAtNTAyMCAzNS4wMzYgMzUuMDM2Ij48ZGVmcz48c3R5bGU+LmF7ZmlsbDpub25lO30uYntmaWxsOiM0ZThjZmY7fS5je2NsaXAtcGF0aDp1cmwoI2EpO30uZHtmaWxsOiNmZmY7fS5le2ZpbGw6I2VmZjRmOTt9PC9zdHlsZT48Y2xpcFBhdGggaWQ9ImEiPjxwYXRoIGNsYXNzPSJhIiBkPSJNMC0zOTkuNDc5SDE3LjU1NXYxNy41NTVIMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMzk5LjQ3OSkiLz48L2NsaXBQYXRoPjwvZGVmcz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDg4NiAtNTA3NSkiPjxjaXJjbGUgY2xhc3M9ImIiIGN4PSIxNy41MTgiIGN5PSIxNy41MTgiIHI9IjE3LjUxOCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTM2LjUyIDU1KSIvPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE0NS4xMyA2NCkiPjxnIGNsYXNzPSJjIj48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDApIj48cGF0aCBjbGFzcz0iZCIgZD0iTS0zODEuOTI0LTE5MC45NjJhOC43NzgsOC43NzgsMCwwLDAtOC43NzgtOC43NzgsOC43NzgsOC43NzgsMCwwLDAtOC43NzgsOC43NzgsOC43NDUsOC43NDUsMCwwLDAsMi4yNiw1Ljg3OXYxLjQ0MmMwLC44LjQ5MiwxLjQ1NywxLjEsMS40NTdoNS44M2EuODQzLjg0MywwLDAsMCwuMTgzLS4wMiw4Ljc3OCw4Ljc3OCwwLDAsMCw4LjE4NC04Ljc1NyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzk5LjQ3OSAxOTkuNzQpIi8+PC9nPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMCkiPjxwYXRoIGNsYXNzPSJlIiBkPSJNLTY4Ljc2My0xOTQuMDc5YTkuMjkyLDkuMjkyLDAsMCwxLDYuMzgtOC44ODhjLS4yNTItLjAyMi0uNTA2LS4wMzMtLjc2My0uMDMzYTguNzc0LDguNzc0LDAsMCwwLTguNzc4LDguNzc4QTkuNTA4LDkuNTA4LDAsMCwwLTY5LjctMTg4LjNjLjAwNSwwLDAsLjAwOSwwLC4wMS0uMzExLjM1Mi0xLjkyNCwyLjg0OS4wMjEsMi44NDloMi4yNWMtMS4yMy0uMDIyLDEuMjYzLTIuMTA3LjI2OS0zLjQ5NGE4LjIyNSw4LjIyNSwwLDAsMS0xLjYtNS4xNDEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDcxLjkyNCAyMDMpIi8+PC9nPjwvZz48L2c+PC9nPjwvc3ZnPg==";
    },
    a640: function (f, e, t) {
      "use strict";
      var n = t("d039");
      f.exports = function (f, e) {
        var t = [][f];
        return (
          !!t &&
          n(function () {
            t.call(
              null,
              e ||
                function () {
                  throw 1;
                },
              1
            );
          })
        );
      };
    },
    a78d: function (f, e, t) {
      var n = t("173d");
      n.__esModule && (n = n.default),
        "string" === typeof n && (n = [[f.i, n, ""]]),
        n.locals && (f.exports = n.locals);
      var r = t("499e").default;
      r("1b8de9d4", n, !0, { sourceMap: !1, shadowMode: !1 });
    },
    a918: function (f, e, t) {
      "use strict";
      t("b522");
    },
    a994: function (f, e, t) {
      var n = t("7d1f"),
        r = t("32f4"),
        o = t("ec69");
      function a(f) {
        return n(f, o, r);
      }
      f.exports = a;
    },
    a9e3: function (f, e, t) {
      "use strict";
      var n = t("83ab"),
        r = t("da84"),
        o = t("e330"),
        a = t("94ca"),
        i = t("6eeb"),
        s = t("1a2d"),
        d = t("7156"),
        c = t("3a9b"),
        l = t("d9b5"),
        u = t("c04e"),
        p = t("d039"),
        b = t("241c").f,
        h = t("06cf").f,
        g = t("9bf2").f,
        m = t("408a"),
        v = t("58a8").trim,
        y = "Number",
        w = r[y],
        x = w.prototype,
        _ = r.TypeError,
        k = o("".slice),
        M = o("".charCodeAt),
        C = function (f) {
          var e = u(f, "number");
          return "bigint" == typeof e ? e : A(e);
        },
        A = function (f) {
          var e,
            t,
            n,
            r,
            o,
            a,
            i,
            s,
            d = u(f, "number");
          if (l(d)) throw _("Cannot convert a Symbol value to a number");
          if ("string" == typeof d && d.length > 2)
            if (((d = v(d)), (e = M(d, 0)), 43 === e || 45 === e)) {
              if (((t = M(d, 2)), 88 === t || 120 === t)) return NaN;
            } else if (48 === e) {
              switch (M(d, 1)) {
                case 66:
                case 98:
                  (n = 2), (r = 49);
                  break;
                case 79:
                case 111:
                  (n = 8), (r = 55);
                  break;
                default:
                  return +d;
              }
              for (o = k(d, 2), a = o.length, i = 0; i < a; i++)
                if (((s = M(o, i)), s < 48 || s > r)) return NaN;
              return parseInt(o, n);
            }
          return +d;
        };
      if (a(y, !w(" 0o1") || !w("0b1") || w("+0x1"))) {
        for (
          var j,
            I = function (f) {
              var e = arguments.length < 1 ? 0 : w(C(f)),
                t = this;
              return c(x, t) &&
                p(function () {
                  m(t);
                })
                ? d(Object(e), t, I)
                : e;
            },
            T = n
              ? b(w)
              : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,fromString,range".split(
                  ","
                ),
            S = 0;
          T.length > S;
          S++
        )
          s(w, (j = T[S])) && !s(I, j) && g(I, j, h(w, j));
        (I.prototype = x), (x.constructor = I), i(r, y, I);
      }
    },
    ab13: function (f, e, t) {
      var n = t("b622"),
        r = n("match");
      f.exports = function (f) {
        var e = /./;
        try {
          "/./"[f](e);
        } catch (t) {
          try {
            return (e[r] = !1), "/./"[f](e);
          } catch (n) {}
        }
        return !1;
      };
    },
    ac1f: function (f, e, t) {
      "use strict";
      var n = t("23e7"),
        r = t("9263");
      n({ target: "RegExp", proto: !0, forced: /./.exec !== r }, { exec: r });
    },
    ac41: function (f, e) {
      function t(f) {
        var e = -1,
          t = Array(f.size);
        return (
          f.forEach(function (f) {
            t[++e] = f;
          }),
          t
        );
      }
      f.exports = t;
    },
    ad6d: function (f, e, t) {
      "use strict";
      var n = t("825a");
      f.exports = function () {
        var f = n(this),
          e = "";
        return (
          f.global && (e += "g"),
          f.ignoreCase && (e += "i"),
          f.multiline && (e += "m"),
          f.dotAll && (e += "s"),
          f.unicode && (e += "u"),
          f.sticky && (e += "y"),
          e
        );
      };
    },
    ae04: function (f, e, t) {
      "use strict";
      t("129f");
    },
    ae3e: function (f, e, t) {
      var n = t("0e25");
      n.__esModule && (n = n.default),
        "string" === typeof n && (n = [[f.i, n, ""]]),
        n.locals && (f.exports = n.locals);
      var r = t("499e").default;
      r("140e5103", n, !0, { sourceMap: !1, shadowMode: !1 });
    },
    ae93: function (f, e, t) {
      "use strict";
      var n,
        r,
        o,
        a = t("d039"),
        i = t("1626"),
        s = t("7c73"),
        d = t("e163"),
        c = t("6eeb"),
        l = t("b622"),
        u = t("c430"),
        p = l("iterator"),
        b = !1;
      [].keys &&
        ((o = [].keys()),
        "next" in o
          ? ((r = d(d(o))), r !== Object.prototype && (n = r))
          : (b = !0));
      var h =
        void 0 == n ||
        a(function () {
          var f = {};
          return n[p].call(f) !== f;
        });
      h ? (n = {}) : u && (n = s(n)),
        i(n[p]) ||
          c(n, p, function () {
            return this;
          }),
        (f.exports = { IteratorPrototype: n, BUGGY_SAFARI_ITERATORS: b });
    },
    af03: function (f, e, t) {
      var n = t("d039");
      f.exports = function (f) {
        return n(function () {
          var e = ""[f]('"');
          return e !== e.toLowerCase() || e.split('"').length > 3;
        });
      };
    },
    b041: function (f, e, t) {
      "use strict";
      var n = t("00ee"),
        r = t("f5df");
      f.exports = n
        ? {}.toString
        : function () {
            return "[object " + r(this) + "]";
          };
    },
    b047: function (f, e) {
      function t(f) {
        return function (e) {
          return f(e);
        };
      }
      f.exports = t;
    },
    b0c0: function (f, e, t) {
      var n = t("83ab"),
        r = t("5e77").EXISTS,
        o = t("e330"),
        a = t("9bf2").f,
        i = Function.prototype,
        s = o(i.toString),
        d = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/,
        c = o(d.exec),
        l = "name";
      n &&
        !r &&
        a(i, l, {
          configurable: !0,
          get: function () {
            try {
              return c(d, s(this))[1];
            } catch (f) {
              return "";
            }
          },
        });
    },
    b1e5: function (f, e, t) {
      var n = t("a994"),
        r = 1,
        o = Object.prototype,
        a = o.hasOwnProperty;
      function i(f, e, t, o, i, s) {
        var d = t & r,
          c = n(f),
          l = c.length,
          u = n(e),
          p = u.length;
        if (l != p && !d) return !1;
        var b = l;
        while (b--) {
          var h = c[b];
          if (!(d ? h in e : a.call(e, h))) return !1;
        }
        var g = s.get(f),
          m = s.get(e);
        if (g && m) return g == e && m == f;
        var v = !0;
        s.set(f, e), s.set(e, f);
        var y = d;
        while (++b < l) {
          h = c[b];
          var w = f[h],
            x = e[h];
          if (o) var _ = d ? o(x, w, h, e, f, s) : o(w, x, h, f, e, s);
          if (!(void 0 === _ ? w === x || i(w, x, t, o, s) : _)) {
            v = !1;
            break;
          }
          y || (y = "constructor" == h);
        }
        if (v && !y) {
          var k = f.constructor,
            M = e.constructor;
          k == M ||
            !("constructor" in f) ||
            !("constructor" in e) ||
            ("function" == typeof k &&
              k instanceof k &&
              "function" == typeof M &&
              M instanceof M) ||
            (v = !1);
        }
        return s["delete"](f), s["delete"](e), v;
      }
      f.exports = i;
    },
    b218: function (f, e) {
      var t = 9007199254740991;
      function n(f) {
        return "number" == typeof f && f > -1 && f % 1 == 0 && f <= t;
      }
      f.exports = n;
    },
    b4be: function (f, e, t) {
      "use strict";
      t("f7fa");
    },
    b4c0: function (f, e, t) {
      var n = t("cb5a");
      function r(f) {
        var e = this.__data__,
          t = n(e, f);
        return t < 0 ? void 0 : e[t][1];
      }
      f.exports = r;
    },
    b522: function (f, e, t) {
      var n = t("1997");
      n.__esModule && (n = n.default),
        "string" === typeof n && (n = [[f.i, n, ""]]),
        n.locals && (f.exports = n.locals);
      var r = t("499e").default;
      r("05bc7f3c", n, !0, { sourceMap: !1, shadowMode: !1 });
    },
    b575: function (f, e, t) {
      var n,
        r,
        o,
        a,
        i,
        s,
        d,
        c,
        l = t("da84"),
        u = t("0366"),
        p = t("06cf").f,
        b = t("2cf4").set,
        h = t("1cdc"),
        g = t("d4c3"),
        m = t("a4b4"),
        v = t("605d"),
        y = l.MutationObserver || l.WebKitMutationObserver,
        w = l.document,
        x = l.process,
        _ = l.Promise,
        k = p(l, "queueMicrotask"),
        M = k && k.value;
      M ||
        ((n = function () {
          var f, e;
          v && (f = x.domain) && f.exit();
          while (r) {
            (e = r.fn), (r = r.next);
            try {
              e();
            } catch (t) {
              throw (r ? a() : (o = void 0), t);
            }
          }
          (o = void 0), f && f.enter();
        }),
        h || v || m || !y || !w
          ? !g && _ && _.resolve
            ? ((d = _.resolve(void 0)),
              (d.constructor = _),
              (c = u(d.then, d)),
              (a = function () {
                c(n);
              }))
            : v
            ? (a = function () {
                x.nextTick(n);
              })
            : ((b = u(b, l)),
              (a = function () {
                b(n);
              }))
          : ((i = !0),
            (s = w.createTextNode("")),
            new y(n).observe(s, { characterData: !0 }),
            (a = function () {
              s.data = i = !i;
            }))),
        (f.exports =
          M ||
          function (f) {
            var e = { fn: f, next: void 0 };
            o && (o.next = e), r || ((r = e), a()), (o = e);
          });
    },
    b5a7: function (f, e, t) {
      var n = t("0b07"),
        r = t("2b3e"),
        o = n(r, "DataView");
      f.exports = o;
    },
    b622: function (f, e, t) {
      var n = t("da84"),
        r = t("5692"),
        o = t("1a2d"),
        a = t("90e3"),
        i = t("4930"),
        s = t("fdbf"),
        d = r("wks"),
        c = n.Symbol,
        l = c && c["for"],
        u = s ? c : (c && c.withoutSetter) || a;
      f.exports = function (f) {
        if (!o(d, f) || (!i && "string" != typeof d[f])) {
          var e = "Symbol." + f;
          i && o(c, f) ? (d[f] = c[f]) : (d[f] = s && l ? l(e) : u(e));
        }
        return d[f];
      };
    },
    b64b: function (f, e, t) {
      var n = t("23e7"),
        r = t("7b0b"),
        o = t("df75"),
        a = t("d039"),
        i = a(function () {
          o(1);
        });
      n(
        { target: "Object", stat: !0, forced: i },
        {
          keys: function (f) {
            return o(r(f));
          },
        }
      );
    },
    b727: function (f, e, t) {
      var n = t("0366"),
        r = t("e330"),
        o = t("44ad"),
        a = t("7b0b"),
        i = t("07fa"),
        s = t("65f0"),
        d = r([].push),
        c = function (f) {
          var e = 1 == f,
            t = 2 == f,
            r = 3 == f,
            c = 4 == f,
            l = 6 == f,
            u = 7 == f,
            p = 5 == f || l;
          return function (b, h, g, m) {
            for (
              var v,
                y,
                w = a(b),
                x = o(w),
                _ = n(h, g),
                k = i(x),
                M = 0,
                C = m || s,
                A = e ? C(b, k) : t || u ? C(b, 0) : void 0;
              k > M;
              M++
            )
              if ((p || M in x) && ((v = x[M]), (y = _(v, M, w)), f))
                if (e) A[M] = y;
                else if (y)
                  switch (f) {
                    case 3:
                      return !0;
                    case 5:
                      return v;
                    case 6:
                      return M;
                    case 2:
                      d(A, v);
                  }
                else
                  switch (f) {
                    case 4:
                      return !1;
                    case 7:
                      d(A, v);
                  }
            return l ? -1 : r || c ? c : A;
          };
        };
      f.exports = {
        forEach: c(0),
        map: c(1),
        filter: c(2),
        some: c(3),
        every: c(4),
        find: c(5),
        findIndex: c(6),
        filterReject: c(7),
      };
    },
    b760: function (f, e, t) {
      var n = t("872a"),
        r = t("9638");
      function o(f, e, t) {
        ((void 0 !== t && !r(f[e], t)) || (void 0 === t && !(e in f))) &&
          n(f, e, t);
      }
      f.exports = o;
    },
    bb06: function (f, e, t) {
      "use strict";
      t("a78d");
    },
    bbc0: function (f, e, t) {
      var n = t("6044"),
        r = "__lodash_hash_undefined__",
        o = Object.prototype,
        a = o.hasOwnProperty;
      function i(f) {
        var e = this.__data__;
        if (n) {
          var t = e[f];
          return t === r ? void 0 : t;
        }
        return a.call(e, f) ? e[f] : void 0;
      }
      f.exports = i;
    },
    bd73: function (f, e) {
      f.exports =
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAfCAMAAACxiD++AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAtUExURUxpcf///////////////////////////////////////////////////////3EAnbYAAAAOdFJOUwADZ66SoQjEhnS7/gsNGQL7+wAAAKtJREFUKM+F01sOhCAQRNESFV/I/pc70Og0YJfyJbmHhBAbGGYHstw8IPV4EOGOmERYIhGpxyUAJxHSz/xlC+1FxE64qB1yj1ZID7oXsel+63ovnj2JXUXue+hvrcLugL+EdG+9XBG8X+Kl34J3YM1g/egvIvdx5EK691RIz78YEXdnQrst6m6JqemXmNo+D/WJNAyVePZWWL0WdlfB+l+UAQQReaAc65DB/wGsZgzLN0IQWAAAAABJRU5ErkJggg==";
    },
    bf37: function (f, e) {
      f.exports =
        "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgNDcuOTcxIDQ3Ljk3MSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDcuOTcxIDQ3Ljk3MTsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8Zz4KCTxwYXRoIGQ9Ik0yOC4yMjgsMjMuOTg2TDQ3LjA5Miw1LjEyMmMxLjE3Mi0xLjE3MSwxLjE3Mi0zLjA3MSwwLTQuMjQyYy0xLjE3Mi0xLjE3Mi0zLjA3LTEuMTcyLTQuMjQyLDBMMjMuOTg2LDE5Ljc0NEw1LjEyMSwwLjg4CgkJYy0xLjE3Mi0xLjE3Mi0zLjA3LTEuMTcyLTQuMjQyLDBjLTEuMTcyLDEuMTcxLTEuMTcyLDMuMDcxLDAsNC4yNDJsMTguODY1LDE4Ljg2NEwwLjg3OSw0Mi44NWMtMS4xNzIsMS4xNzEtMS4xNzIsMy4wNzEsMCw0LjI0MgoJCUMxLjQ2NSw0Ny42NzcsMi4yMzMsNDcuOTcsMyw0Ny45N3MxLjUzNS0wLjI5MywyLjEyMS0wLjg3OWwxOC44NjUtMTguODY0TDQyLjg1LDQ3LjA5MWMwLjU4NiwwLjU4NiwxLjM1NCwwLjg3OSwyLjEyMSwwLjg3OQoJCXMxLjUzNS0wLjI5MywyLjEyMS0wLjg3OWMxLjE3Mi0xLjE3MSwxLjE3Mi0zLjA3MSwwLTQuMjQyTDI4LjIyOCwyMy45ODZ6Ii8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+";
    },
    c04e: function (f, e, t) {
      var n = t("da84"),
        r = t("c65b"),
        o = t("861d"),
        a = t("d9b5"),
        i = t("dc4a"),
        s = t("485a"),
        d = t("b622"),
        c = n.TypeError,
        l = d("toPrimitive");
      f.exports = function (f, e) {
        if (!o(f) || a(f)) return f;
        var t,
          n = i(f, l);
        if (n) {
          if (
            (void 0 === e && (e = "default"), (t = r(n, f, e)), !o(t) || a(t))
          )
            return t;
          throw c("Can't convert object to primitive value");
        }
        return void 0 === e && (e = "number"), s(f, e);
      };
    },
    c05f: function (f, e, t) {
      var n = t("7b97"),
        r = t("1310");
      function o(f, e, t, a, i) {
        return (
          f === e ||
          (null == f || null == e || (!r(f) && !r(e))
            ? f !== f && e !== e
            : n(f, e, t, a, o, i))
        );
      }
      f.exports = o;
    },
    c094: function (f, e, t) {
      var n = t("5e5f");
      n.__esModule && (n = n.default),
        "string" === typeof n && (n = [[f.i, n, ""]]),
        n.locals && (f.exports = n.locals);
      var r = t("499e").default;
      r("a7b604ac", n, !0, { sourceMap: !1, shadowMode: !1 });
    },
    c098: function (f, e) {
      var t = 9007199254740991,
        n = /^(?:0|[1-9]\d*)$/;
      function r(f, e) {
        var r = typeof f;
        return (
          (e = null == e ? t : e),
          !!e &&
            ("number" == r || ("symbol" != r && n.test(f))) &&
            f > -1 &&
            f % 1 == 0 &&
            f < e
        );
      }
      f.exports = r;
    },
    c0b6: function (f, e, t) {
      var n = t("23e7"),
        r = t("0538");
      n({ target: "Function", proto: !0 }, { bind: r });
    },
    c1c9: function (f, e, t) {
      var n = t("a454"),
        r = t("f3c1"),
        o = r(n);
      f.exports = o;
    },
    c2f4: function (f, e) {
      f.exports =
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAMAAAANIilAAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAKVQTFRFAAAA////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////uP3jVQAAADd0Uk5TAE9lCAXd9XA4y/9zDQJG7HYB8Hc3yHoPQ8fuezMSoYPrEcEugj0tqb6G+Lw5ifHcKk3SIAx/MjRpS8YAAADsSURBVHic7dDJDoIwEIDhQURwQNGiIBVkUQH3BfX9H00MEvHW9qj9L3RIvkxTAJlMJvu1lI7aHtWOwm67Wk9vz3pP67Jro4+m1QyWiX2D3cJgqNmjt7ZGtjYccGAYK8R26qNjE2XMY6smU3Q9AM/F6YSTVrtnPp173pz6M969Lx1Q6rqUBgK2KvAR/UCIAoQLxEUoiCMSxyQSokmE6XKZYpQI2BVJ1wDrlKz4dXXn7PXN+G8e5lhk9TErMOd6tXCz3e2bYb/bbnj04Xg6f6bz6Xhgtxe8lu25vOKFGd/uj+8fj/uNfbVMJpP9QU/STxAzeUFqVwAAAABJRU5ErkJggg==";
    },
    c430: function (f, e) {
      f.exports = !1;
    },
    c54e: function (f, e, t) {
      var n = t("24fb");
      (e = n(!1)),
        e.push([
          f.i,
          ".sc-message{margin-bottom:10px;display:flex}.sc-message .sc-message--edited{opacity:.7;word-wrap:normal;font-size:xx-small;text-align:center}.sc-message.sent{-webkit-animation:rightFadeIn .2s ease-in both;animation:rightFadeIn .2s ease-in both}.sc-message.received{-webkit-animation:leftFadeIn .2s ease-in both;animation:leftFadeIn .2s ease-in both}.sc-message--content{width:100%;display:flex}.sc-message--content.sent{justify-content:flex-end}.sc-message--content.system{justify-content:center}.sc-message--content.sent .sc-message--avatar{display:none}.sc-message--avatar{background-repeat:no-repeat;background-size:100%;background-position:50%;min-width:30px;min-height:30px;border-radius:50%;align-self:flex-end;margin-right:6px}.sc-message-tts{display:flex;align-items:center}.tts-btn{margin-left:6px!important}@-webkit-keyframes leftFadeIn{0%{opacity:0;transform:translate3d(-5px,0,0)}to{opacity:1;transform:translateZ(0)}}@keyframes leftFadeIn{0%{opacity:0;transform:translate3d(-5px,0,0)}to{opacity:1;transform:translateZ(0)}}@-webkit-keyframes rightFadeIn{0%{opacity:0;transform:translate3d(5px,0,0)}to{opacity:1;transform:translateZ(0)}}@keyframes rightFadeIn{0%{opacity:0;transform:translate3d(5px,0,0)}to{opacity:1;transform:translateZ(0)}}.sc-message--meta{font-size:xx-small;margin-bottom:0;color:#fff}@media (max-width:450px){.sc-message{width:100%}}.tooltip{display:block!important;z-index:10000}.tooltip .tooltip-inner{background:#000;color:#fff;border-radius:16px;padding:5px 10px 4px}.tooltip .tooltip-arrow{width:0;height:0;border-style:solid;position:absolute;margin:5px;border-color:#000;z-index:1}.tooltip[x-placement^=top]{margin-bottom:5px}.tooltip[x-placement^=top] .tooltip-arrow{border-width:5px 5px 0 5px;border-left-color:transparent!important;border-right-color:transparent!important;border-bottom-color:transparent!important;bottom:-5px;left:calc(50% - 5px);margin-top:0;margin-bottom:0}.tooltip[x-placement^=bottom]{margin-top:5px}.tooltip[x-placement^=bottom] .tooltip-arrow{border-width:0 5px 5px 5px;border-left-color:transparent!important;border-right-color:transparent!important;border-top-color:transparent!important;top:-5px;left:calc(50% - 5px);margin-top:0;margin-bottom:0}.tooltip[x-placement^=right]{margin-left:5px}.tooltip[x-placement^=right] .tooltip-arrow{border-width:5px 5px 5px 0;border-left-color:transparent!important;border-top-color:transparent!important;border-bottom-color:transparent!important;left:-5px;top:calc(50% - 5px);margin-left:0;margin-right:0}.tooltip[x-placement^=left]{margin-right:5px}.tooltip[x-placement^=left] .tooltip-arrow{border-width:5px 0 5px 5px;border-top-color:transparent!important;border-right-color:transparent!important;border-bottom-color:transparent!important;right:-5px;top:calc(50% - 5px);margin-left:0;margin-right:0}.tooltip[aria-hidden=true]{visibility:hidden;opacity:0;transition:opacity .15s,visibility .15s}.tooltip[aria-hidden=false]{visibility:visible;opacity:1;transition:opacity .15s}.tooltip.info .tooltip-inner{background:rgba(0,68,153,.9);color:#fff;padding:24px;border-radius:5px;box-shadow:0 5px 30px rgba(0,0,0,.1)}.tooltip.info .tooltip-arrow{border-color:rgba(0,68,153,.9)}.tooltip.popover .popover-inner{background:#f9f9f9;color:#000;padding:24px;border-radius:5px;box-shadow:0 5px 30px rgba(0,0,0,.1)}.tooltip.popover .popover-arrow{border-color:#f9f9f9}",
          "",
        ]),
        (f.exports = e);
    },
    c584: function (f, e) {
      function t(f, e) {
        return f.has(e);
      }
      f.exports = t;
    },
    c65b: function (f, e) {
      var t = Function.prototype.call;
      f.exports = t.bind
        ? t.bind(t)
        : function () {
            return t.apply(t, arguments);
          };
    },
    c676: function (f, e, t) {
      "use strict";
      t("e3e9");
    },
    c6b6: function (f, e, t) {
      var n = t("e330"),
        r = n({}.toString),
        o = n("".slice);
      f.exports = function (f) {
        return o(r(f), 8, -1);
      };
    },
    c6c5: function (f, e, t) {
      "use strict";
      t("634c");
    },
    c6cd: function (f, e, t) {
      var n = t("da84"),
        r = t("ce4e"),
        o = "__core-js_shared__",
        a = n[o] || r(o, {});
      f.exports = a;
    },
    c869: function (f, e, t) {
      var n = t("0b07"),
        r = t("2b3e"),
        o = n(r, "Set");
      f.exports = o;
    },
    c8ba: function (f, e) {
      var t;
      t = (function () {
        return this;
      })();
      try {
        t = t || new Function("return this")();
      } catch (n) {
        "object" === typeof window && (t = window);
      }
      f.exports = t;
    },
    c8d2: function (f, e, t) {
      var n = t("5e77").PROPER,
        r = t("d039"),
        o = t("5899"),
        a = "​᠎";
      f.exports = function (f) {
        return r(function () {
          return !!o[f]() || a[f]() !== a || (n && o[f].name !== f);
        });
      };
    },
    c8fe: function (f, e, t) {
      var n = t("f8af");
      function r(f, e) {
        var t = e ? n(f.buffer) : f.buffer;
        return new f.constructor(t, f.byteOffset, f.length);
      }
      f.exports = r;
    },
    ca84: function (f, e, t) {
      var n = t("e330"),
        r = t("1a2d"),
        o = t("fc6a"),
        a = t("4d64").indexOf,
        i = t("d012"),
        s = n([].push);
      f.exports = function (f, e) {
        var t,
          n = o(f),
          d = 0,
          c = [];
        for (t in n) !r(i, t) && r(n, t) && s(c, t);
        while (e.length > d) r(n, (t = e[d++])) && (~a(c, t) || s(c, t));
        return c;
      };
    },
    caad: function (f, e, t) {
      "use strict";
      var n = t("23e7"),
        r = t("4d64").includes,
        o = t("44d2");
      n(
        { target: "Array", proto: !0 },
        {
          includes: function (f) {
            return r(this, f, arguments.length > 1 ? arguments[1] : void 0);
          },
        }
      ),
        o("includes");
    },
    cb5a: function (f, e, t) {
      var n = t("9638");
      function r(f, e) {
        var t = f.length;
        while (t--) if (n(f[t][0], e)) return t;
        return -1;
      }
      f.exports = r;
    },
    cc12: function (f, e, t) {
      var n = t("da84"),
        r = t("861d"),
        o = n.document,
        a = r(o) && r(o.createElement);
      f.exports = function (f) {
        return a ? o.createElement(f) : {};
      };
    },
    cca6: function (f, e, t) {
      var n = t("23e7"),
        r = t("60da");
      n(
        { target: "Object", stat: !0, forced: Object.assign !== r },
        { assign: r }
      );
    },
    cd9d: function (f, e) {
      function t(f) {
        return f;
      }
      f.exports = t;
    },
    cdf9: function (f, e, t) {
      var n = t("825a"),
        r = t("861d"),
        o = t("f069");
      f.exports = function (f, e) {
        if ((n(f), r(e) && e.constructor === f)) return e;
        var t = o.f(f),
          a = t.resolve;
        return a(e), t.promise;
      };
    },
    ce4e: function (f, e, t) {
      var n = t("da84"),
        r = Object.defineProperty;
      f.exports = function (f, e) {
        try {
          r(n, f, { value: e, configurable: !0, writable: !0 });
        } catch (t) {
          n[f] = e;
        }
        return e;
      };
    },
    d012: function (f, e) {
      f.exports = {};
    },
    d02c: function (f, e, t) {
      var n = t("5e2e"),
        r = t("79bc"),
        o = t("7b83"),
        a = 200;
      function i(f, e) {
        var t = this.__data__;
        if (t instanceof n) {
          var i = t.__data__;
          if (!r || i.length < a - 1)
            return i.push([f, e]), (this.size = ++t.size), this;
          t = this.__data__ = new o(i);
        }
        return t.set(f, e), (this.size = t.size), this;
      }
      f.exports = i;
    },
    d039: function (f, e) {
      f.exports = function (f) {
        try {
          return !!f();
        } catch (e) {
          return !0;
        }
      };
    },
    d066: function (f, e, t) {
      var n = t("da84"),
        r = t("1626"),
        o = function (f) {
          return r(f) ? f : void 0;
        };
      f.exports = function (f, e) {
        return arguments.length < 2 ? o(n[f]) : n[f] && n[f][e];
      };
    },
    d1e7: function (f, e, t) {
      "use strict";
      var n = {}.propertyIsEnumerable,
        r = Object.getOwnPropertyDescriptor,
        o = r && !n.call({ 1: 2 }, 1);
      e.f = o
        ? function (f) {
            var e = r(this, f);
            return !!e && e.enumerable;
          }
        : n;
    },
    d28b: function (f, e, t) {
      var n = t("746f");
      n("iterator");
    },
    d2bb: function (f, e, t) {
      var n = t("e330"),
        r = t("825a"),
        o = t("3bbe");
      f.exports =
        Object.setPrototypeOf ||
        ("__proto__" in {}
          ? (function () {
              var f,
                e = !1,
                t = {};
              try {
                (f = n(
                  Object.getOwnPropertyDescriptor(Object.prototype, "__proto__")
                    .set
                )),
                  f(t, []),
                  (e = t instanceof Array);
              } catch (a) {}
              return function (t, n) {
                return r(t), o(n), e ? f(t, n) : (t.__proto__ = n), t;
              };
            })()
          : void 0);
    },
    d327: function (f, e) {
      function t() {
        return [];
      }
      f.exports = t;
    },
    d370: function (f, e, t) {
      var n = t("253c"),
        r = t("1310"),
        o = Object.prototype,
        a = o.hasOwnProperty,
        i = o.propertyIsEnumerable,
        s = n(
          (function () {
            return arguments;
          })()
        )
          ? n
          : function (f) {
              return r(f) && a.call(f, "callee") && !i.call(f, "callee");
            };
      f.exports = s;
    },
    d3b7: function (f, e, t) {
      var n = t("00ee"),
        r = t("6eeb"),
        o = t("b041");
      n || r(Object.prototype, "toString", o, { unsafe: !0 });
    },
    d44e: function (f, e, t) {
      var n = t("9bf2").f,
        r = t("1a2d"),
        o = t("b622"),
        a = o("toStringTag");
      f.exports = function (f, e, t) {
        f &&
          !r((f = t ? f : f.prototype), a) &&
          n(f, a, { configurable: !0, value: e });
      };
    },
    d4c3: function (f, e, t) {
      var n = t("342f"),
        r = t("da84");
      f.exports = /ipad|iphone|ipod/i.test(n) && void 0 !== r.Pebble;
    },
    d57d: function (f, e, t) {
      var n = t("24fb");
      (e = n(!1)),
        e.push([
          f.i,
          '@font-face{font-family:Kanit;src:local("Kanit"),url(https://fonts.googleapis.com/css?family=Kanit) format("truetype")}*{font-family:Kanit,Helvetica,Arial,sans-serif}',
          "",
        ]),
        (f.exports = e);
    },
    d612: function (f, e, t) {
      var n = t("7b83"),
        r = t("7ed2"),
        o = t("dc0f");
      function a(f) {
        var e = -1,
          t = null == f ? 0 : f.length;
        this.__data__ = new n();
        while (++e < t) this.add(f[e]);
      }
      (a.prototype.add = a.prototype.push = r),
        (a.prototype.has = o),
        (f.exports = a);
    },
    d784: function (f, e, t) {
      "use strict";
      t("ac1f");
      var n = t("e330"),
        r = t("6eeb"),
        o = t("9263"),
        a = t("d039"),
        i = t("b622"),
        s = t("9112"),
        d = i("species"),
        c = RegExp.prototype;
      f.exports = function (f, e, t, l) {
        var u = i(f),
          p = !a(function () {
            var e = {};
            return (
              (e[u] = function () {
                return 7;
              }),
              7 != ""[f](e)
            );
          }),
          b =
            p &&
            !a(function () {
              var e = !1,
                t = /a/;
              return (
                "split" === f &&
                  ((t = {}),
                  (t.constructor = {}),
                  (t.constructor[d] = function () {
                    return t;
                  }),
                  (t.flags = ""),
                  (t[u] = /./[u])),
                (t.exec = function () {
                  return (e = !0), null;
                }),
                t[u](""),
                !e
              );
            });
        if (!p || !b || t) {
          var h = n(/./[u]),
            g = e(u, ""[f], function (f, e, t, r, a) {
              var i = n(f),
                s = e.exec;
              return s === o || s === c.exec
                ? p && !a
                  ? { done: !0, value: h(e, t, r) }
                  : { done: !0, value: i(t, e, r) }
                : { done: !1 };
            });
          r(String.prototype, f, g[0]), r(c, u, g[1]);
        }
        l && s(c[u], "sham", !0);
      };
    },
    d79b: function (f, e, t) {
      "use strict";
      t("e310");
    },
    d9b5: function (f, e, t) {
      var n = t("da84"),
        r = t("d066"),
        o = t("1626"),
        a = t("3a9b"),
        i = t("fdbf"),
        s = n.Object;
      f.exports = i
        ? function (f) {
            return "symbol" == typeof f;
          }
        : function (f) {
            var e = r("Symbol");
            return o(e) && a(e.prototype, s(f));
          };
    },
    da03: function (f, e, t) {
      var n = t("2b3e"),
        r = n["__core-js_shared__"];
      f.exports = r;
    },
    da84: function (f, e, t) {
      (function (e) {
        var t = function (f) {
          return f && f.Math == Math && f;
        };
        f.exports =
          t("object" == typeof globalThis && globalThis) ||
          t("object" == typeof window && window) ||
          t("object" == typeof self && self) ||
          t("object" == typeof e && e) ||
          (function () {
            return this;
          })() ||
          Function("return this")();
      }).call(this, t("c8ba"));
    },
    dbb4: function (f, e, t) {
      var n = t("23e7"),
        r = t("83ab"),
        o = t("56ef"),
        a = t("fc6a"),
        i = t("06cf"),
        s = t("8418");
      n(
        { target: "Object", stat: !0, sham: !r },
        {
          getOwnPropertyDescriptors: function (f) {
            var e,
              t,
              n = a(f),
              r = i.f,
              d = o(n),
              c = {},
              l = 0;
            while (d.length > l)
              (t = r(n, (e = d[l++]))), void 0 !== t && s(c, e, t);
            return c;
          },
        }
      );
    },
    dc0f: function (f, e) {
      function t(f) {
        return this.__data__.has(f);
      }
      f.exports = t;
    },
    dc4a: function (f, e, t) {
      var n = t("59ed");
      f.exports = function (f, e) {
        var t = f[e];
        return null == t ? void 0 : n(t);
      };
    },
    dc57: function (f, e) {
      var t = Function.prototype,
        n = t.toString;
      function r(f) {
        if (null != f) {
          try {
            return n.call(f);
          } catch (e) {}
          try {
            return f + "";
          } catch (e) {}
        }
        return "";
      }
      f.exports = r;
    },
    dcbe: function (f, e, t) {
      var n = t("30c9"),
        r = t("1310");
      function o(f) {
        return r(f) && n(f);
      }
      f.exports = o;
    },
    ddb0: function (f, e, t) {
      var n = t("da84"),
        r = t("fdbc"),
        o = t("785a"),
        a = t("e260"),
        i = t("9112"),
        s = t("b622"),
        d = s("iterator"),
        c = s("toStringTag"),
        l = a.values,
        u = function (f, e) {
          if (f) {
            if (f[d] !== l)
              try {
                i(f, d, l);
              } catch (n) {
                f[d] = l;
              }
            if ((f[c] || i(f, c, e), r[e]))
              for (var t in a)
                if (f[t] !== a[t])
                  try {
                    i(f, t, a[t]);
                  } catch (n) {
                    f[t] = a[t];
                  }
          }
        };
      for (var p in r) u(n[p] && n[p].prototype, p);
      u(o, "DOMTokenList");
    },
    de59: function (f, e, t) {
      var n = t("24fb");
      (e = n(!1)),
        e.push([
          f.i,
          ".sc-typing-indicator[data-v-255b28fb]{text-align:center;padding:10px 20px;border-radius:.7rem}.sc-typing-indicator span[data-v-255b28fb]{display:inline-block;width:7px;height:7px;border-radius:100%;margin-right:3px;-webkit-animation:bob-data-v-255b28fb 2s infinite;animation:bob-data-v-255b28fb 2s infinite}.sc-typing-indicator span[data-v-255b28fb]:first-child{-webkit-animation-delay:-1s;animation-delay:-1s}.sc-typing-indicator span[data-v-255b28fb]:nth-child(2){-webkit-animation-delay:-.85s;animation-delay:-.85s}.sc-typing-indicator span[data-v-255b28fb]:nth-child(3){-webkit-animation-delay:-.7s;animation-delay:-.7s}@-webkit-keyframes bob-data-v-255b28fb{10%{transform:translateY(-10px)}50%{transform:translateY(0)}}@keyframes bob-data-v-255b28fb{10%{transform:translateY(-10px)}50%{transform:translateY(0)}}.dot1[data-v-255b28fb]{background-color:#e15b64}.dot2[data-v-255b28fb]{background-color:#f8b26a}.dot3[data-v-255b28fb]{background-color:#abbd81}",
          "",
        ]),
        (f.exports = e);
    },
    deb8: function (f, e, t) {
      "use strict";
      t("fb4c");
    },
    df43: function (f, e, t) {
      var n = t("f66f");
      n.__esModule && (n = n.default),
        "string" === typeof n && (n = [[f.i, n, ""]]),
        n.locals && (f.exports = n.locals);
      var r = t("499e").default;
      r("13979642", n, !0, { sourceMap: !1, shadowMode: !1 });
    },
    df75: function (f, e, t) {
      var n = t("ca84"),
        r = t("7839");
      f.exports =
        Object.keys ||
        function (f) {
          return n(f, r);
        };
    },
    e01a: function (f, e, t) {
      "use strict";
      var n = t("23e7"),
        r = t("83ab"),
        o = t("da84"),
        a = t("e330"),
        i = t("1a2d"),
        s = t("1626"),
        d = t("3a9b"),
        c = t("577e"),
        l = t("9bf2").f,
        u = t("e893"),
        p = o.Symbol,
        b = p && p.prototype;
      if (r && s(p) && (!("description" in b) || void 0 !== p().description)) {
        var h = {},
          g = function () {
            var f =
                arguments.length < 1 || void 0 === arguments[0]
                  ? void 0
                  : c(arguments[0]),
              e = d(b, this) ? new p(f) : void 0 === f ? p() : p(f);
            return "" === f && (h[e] = !0), e;
          };
        u(g, p), (g.prototype = b), (b.constructor = g);
        var m = "Symbol(test)" == String(p("test")),
          v = a(b.toString),
          y = a(b.valueOf),
          w = /^Symbol\((.*)\)[^)]+$/,
          x = a("".replace),
          _ = a("".slice);
        l(b, "description", {
          configurable: !0,
          get: function () {
            var f = y(this),
              e = v(f);
            if (i(h, f)) return "";
            var t = m ? _(e, 7, -1) : x(e, w, "$1");
            return "" === t ? void 0 : t;
          },
        }),
          n({ global: !0, forced: !0 }, { Symbol: g });
      }
    },
    e088: function (f) {
      f.exports = JSON.parse(
        '{"writeMsg":"Write a message...","here2help":"I am here to help","send":"Send","edit":"Edit","cancel":"Cancel","rating":"Rating","submit":"Submit","back":"Back"}'
      );
    },
    e163: function (f, e, t) {
      var n = t("da84"),
        r = t("1a2d"),
        o = t("1626"),
        a = t("7b0b"),
        i = t("f772"),
        s = t("e177"),
        d = i("IE_PROTO"),
        c = n.Object,
        l = c.prototype;
      f.exports = s
        ? c.getPrototypeOf
        : function (f) {
            var e = a(f);
            if (r(e, d)) return e[d];
            var t = e.constructor;
            return o(t) && e instanceof t
              ? t.prototype
              : e instanceof c
              ? l
              : null;
          };
    },
    e177: function (f, e, t) {
      var n = t("d039");
      f.exports = !n(function () {
        function f() {}
        return (
          (f.prototype.constructor = null),
          Object.getPrototypeOf(new f()) !== f.prototype
        );
      });
    },
    e24b: function (f, e, t) {
      var n = t("49f4"),
        r = t("1efc"),
        o = t("bbc0"),
        a = t("7a48"),
        i = t("2524");
      function s(f) {
        var e = -1,
          t = null == f ? 0 : f.length;
        this.clear();
        while (++e < t) {
          var n = f[e];
          this.set(n[0], n[1]);
        }
      }
      (s.prototype.clear = n),
        (s.prototype["delete"] = r),
        (s.prototype.get = o),
        (s.prototype.has = a),
        (s.prototype.set = i),
        (f.exports = s);
    },
    e260: function (f, e, t) {
      "use strict";
      var n = t("fc6a"),
        r = t("44d2"),
        o = t("3f8c"),
        a = t("69f3"),
        i = t("7dd0"),
        s = "Array Iterator",
        d = a.set,
        c = a.getterFor(s);
      (f.exports = i(
        Array,
        "Array",
        function (f, e) {
          d(this, { type: s, target: n(f), index: 0, kind: e });
        },
        function () {
          var f = c(this),
            e = f.target,
            t = f.kind,
            n = f.index++;
          return !e || n >= e.length
            ? ((f.target = void 0), { value: void 0, done: !0 })
            : "keys" == t
            ? { value: n, done: !1 }
            : "values" == t
            ? { value: e[n], done: !1 }
            : { value: [n, e[n]], done: !1 };
        },
        "values"
      )),
        (o.Arguments = o.Array),
        r("keys"),
        r("values"),
        r("entries");
    },
    e2cc: function (f, e, t) {
      var n = t("6eeb");
      f.exports = function (f, e, t) {
        for (var r in e) n(f, r, e[r], t);
        return f;
      };
    },
    e310: function (f, e, t) {
      var n = t("6b8f");
      n.__esModule && (n = n.default),
        "string" === typeof n && (n = [[f.i, n, ""]]),
        n.locals && (f.exports = n.locals);
      var r = t("499e").default;
      r("ba26a154", n, !0, { sourceMap: !1, shadowMode: !1 });
    },
    e330: function (f, e) {
      var t = Function.prototype,
        n = t.bind,
        r = t.call,
        o = n && n.bind(r);
      f.exports = n
        ? function (f) {
            return f && o(r, f);
          }
        : function (f) {
            return (
              f &&
              function () {
                return r.apply(f, arguments);
              }
            );
          };
    },
    e37d: function (f, e, t) {
      "use strict";
      (function (f) {
        var n = t("7037"),
          r = t.n(n),
          o = t("9523"),
          a = t.n(o),
          i = t("970b"),
          s = t.n(i),
          d = t("5bc3"),
          c = t.n(d),
          l = t("f0bd"),
          u = t("63ea"),
          p = t.n(u),
          b = t("252c"),
          h = t("42454"),
          g = t.n(h),
          m = function () {};
        function v(f) {
          return "string" === typeof f && (f = f.split(" ")), f;
        }
        function y(f, e) {
          var t,
            n = v(e);
          (t =
            f.className instanceof m ? v(f.className.baseVal) : v(f.className)),
            n.forEach(function (f) {
              -1 === t.indexOf(f) && t.push(f);
            }),
            f instanceof SVGElement
              ? f.setAttribute("class", t.join(" "))
              : (f.className = t.join(" "));
        }
        function w(f, e) {
          var t,
            n = v(e);
          (t =
            f.className instanceof m ? v(f.className.baseVal) : v(f.className)),
            n.forEach(function (f) {
              var e = t.indexOf(f);
              -1 !== e && t.splice(e, 1);
            }),
            f instanceof SVGElement
              ? f.setAttribute("class", t.join(" "))
              : (f.className = t.join(" "));
        }
        "undefined" !== typeof window && (m = window.SVGAnimatedString);
        var x = !1;
        if ("undefined" !== typeof window) {
          x = !1;
          try {
            var _ = Object.defineProperty({}, "passive", {
              get: function () {
                x = !0;
              },
            });
            window.addEventListener("test", null, _);
          } catch (vf) {}
        }
        function k(f, e) {
          var t = Object.keys(f);
          if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(f);
            e &&
              (n = n.filter(function (e) {
                return Object.getOwnPropertyDescriptor(f, e).enumerable;
              })),
              t.push.apply(t, n);
          }
          return t;
        }
        function M(f) {
          for (var e = 1; e < arguments.length; e++) {
            var t = null != arguments[e] ? arguments[e] : {};
            e % 2
              ? k(Object(t), !0).forEach(function (e) {
                  a()(f, e, t[e]);
                })
              : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(f, Object.getOwnPropertyDescriptors(t))
              : k(Object(t)).forEach(function (e) {
                  Object.defineProperty(
                    f,
                    e,
                    Object.getOwnPropertyDescriptor(t, e)
                  );
                });
          }
          return f;
        }
        var C = {
            container: !1,
            delay: 0,
            html: !1,
            placement: "top",
            title: "",
            template:
              '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
            trigger: "hover focus",
            offset: 0,
          },
          A = [],
          j = (function () {
            function f(e, t) {
              var n = this;
              s()(this, f),
                a()(this, "_events", []),
                a()(this, "_setTooltipNodeEvent", function (f, e, t, r) {
                  var o = f.relatedreference || f.toElement || f.relatedTarget,
                    a = function t(o) {
                      var a =
                        o.relatedreference || o.toElement || o.relatedTarget;
                      n._tooltipNode.removeEventListener(f.type, t),
                        e.contains(a) || n._scheduleHide(e, r.delay, r, o);
                    };
                  return (
                    !!n._tooltipNode.contains(o) &&
                    (n._tooltipNode.addEventListener(f.type, a), !0)
                  );
                }),
                (t = M(M({}, C), t)),
                e.jquery && (e = e[0]),
                (this.show = this.show.bind(this)),
                (this.hide = this.hide.bind(this)),
                (this.reference = e),
                (this.options = t),
                (this._isOpen = !1),
                this._init();
            }
            return (
              c()(f, [
                {
                  key: "show",
                  value: function () {
                    this._show(this.reference, this.options);
                  },
                },
                {
                  key: "hide",
                  value: function () {
                    this._hide();
                  },
                },
                {
                  key: "dispose",
                  value: function () {
                    this._dispose();
                  },
                },
                {
                  key: "toggle",
                  value: function () {
                    return this._isOpen ? this.hide() : this.show();
                  },
                },
                {
                  key: "setClasses",
                  value: function (f) {
                    this._classes = f;
                  },
                },
                {
                  key: "setContent",
                  value: function (f) {
                    (this.options.title = f),
                      this._tooltipNode && this._setContent(f, this.options);
                  },
                },
                {
                  key: "setOptions",
                  value: function (f) {
                    var e = !1,
                      t = (f && f.classes) || R.options.defaultClass;
                    p()(this._classes, t) || (this.setClasses(t), (e = !0)),
                      (f = L(f));
                    var n = !1,
                      r = !1;
                    for (var o in ((this.options.offset === f.offset &&
                      this.options.placement === f.placement) ||
                      (n = !0),
                    (this.options.template !== f.template ||
                      this.options.trigger !== f.trigger ||
                      this.options.container !== f.container ||
                      e) &&
                      (r = !0),
                    f))
                      this.options[o] = f[o];
                    if (this._tooltipNode)
                      if (r) {
                        var a = this._isOpen;
                        this.dispose(), this._init(), a && this.show();
                      } else n && this.popperInstance.update();
                  },
                },
                {
                  key: "_init",
                  value: function () {
                    var f =
                      "string" === typeof this.options.trigger
                        ? this.options.trigger.split(" ")
                        : [];
                    (this._isDisposed = !1),
                      (this._enableDocumentTouch = -1 === f.indexOf("manual")),
                      (f = f.filter(function (f) {
                        return -1 !== ["click", "hover", "focus"].indexOf(f);
                      })),
                      this._setEventListeners(this.reference, f, this.options),
                      (this.$_originalTitle =
                        this.reference.getAttribute("title")),
                      this.reference.removeAttribute("title"),
                      this.reference.setAttribute(
                        "data-original-title",
                        this.$_originalTitle
                      );
                  },
                },
                {
                  key: "_create",
                  value: function (f, e) {
                    var t = this,
                      n = window.document.createElement("div");
                    n.innerHTML = e.trim();
                    var r = n.childNodes[0];
                    return (
                      (r.id =
                        this.options.ariaId ||
                        "tooltip_".concat(
                          Math.random().toString(36).substr(2, 10)
                        )),
                      r.setAttribute("aria-hidden", "true"),
                      this.options.autoHide &&
                        -1 !== this.options.trigger.indexOf("hover") &&
                        (r.addEventListener("mouseenter", function (e) {
                          return t._scheduleHide(
                            f,
                            t.options.delay,
                            t.options,
                            e
                          );
                        }),
                        r.addEventListener("click", function (e) {
                          return t._scheduleHide(
                            f,
                            t.options.delay,
                            t.options,
                            e
                          );
                        })),
                      r
                    );
                  },
                },
                {
                  key: "_setContent",
                  value: function (f, e) {
                    var t = this;
                    (this.asyncContent = !1),
                      this._applyContent(f, e).then(function () {
                        t.popperInstance && t.popperInstance.update();
                      });
                  },
                },
                {
                  key: "_applyContent",
                  value: function (f, e) {
                    var t = this;
                    return new Promise(function (n, r) {
                      var o = e.html,
                        a = t._tooltipNode;
                      if (a) {
                        var i = a.querySelector(t.options.innerSelector);
                        if (1 === f.nodeType) {
                          if (o) {
                            while (i.firstChild) i.removeChild(i.firstChild);
                            i.appendChild(f);
                          }
                        } else {
                          if ("function" === typeof f) {
                            var s = f();
                            return void (s && "function" === typeof s.then
                              ? ((t.asyncContent = !0),
                                e.loadingClass && y(a, e.loadingClass),
                                e.loadingContent &&
                                  t._applyContent(e.loadingContent, e),
                                s
                                  .then(function (f) {
                                    return (
                                      e.loadingClass && w(a, e.loadingClass),
                                      t._applyContent(f, e)
                                    );
                                  })
                                  .then(n)
                                  .catch(r))
                              : t._applyContent(s, e).then(n).catch(r));
                          }
                          o ? (i.innerHTML = f) : (i.innerText = f);
                        }
                        n();
                      }
                    });
                  },
                },
                {
                  key: "_show",
                  value: function (f, e) {
                    if (e && "string" === typeof e.container) {
                      var t = document.querySelector(e.container);
                      if (!t) return;
                    }
                    clearTimeout(this._disposeTimer),
                      (e = Object.assign({}, e)),
                      delete e.offset;
                    var n = !0;
                    this._tooltipNode &&
                      (y(this._tooltipNode, this._classes), (n = !1));
                    var r = this._ensureShown(f, e);
                    return (
                      n &&
                        this._tooltipNode &&
                        y(this._tooltipNode, this._classes),
                      y(f, ["v-tooltip-open"]),
                      r
                    );
                  },
                },
                {
                  key: "_ensureShown",
                  value: function (f, e) {
                    var t = this;
                    if (this._isOpen) return this;
                    if (((this._isOpen = !0), A.push(this), this._tooltipNode))
                      return (
                        (this._tooltipNode.style.display = ""),
                        this._tooltipNode.setAttribute("aria-hidden", "false"),
                        this.popperInstance.enableEventListeners(),
                        this.popperInstance.update(),
                        this.asyncContent && this._setContent(e.title, e),
                        this
                      );
                    var n = f.getAttribute("title") || e.title;
                    if (!n) return this;
                    var r = this._create(f, e.template);
                    (this._tooltipNode = r),
                      f.setAttribute("aria-describedby", r.id);
                    var o = this._findContainer(e.container, f);
                    this._append(r, o);
                    var a = M(
                      M({}, e.popperOptions),
                      {},
                      { placement: e.placement }
                    );
                    return (
                      (a.modifiers = M(
                        M({}, a.modifiers),
                        {},
                        { arrow: { element: this.options.arrowSelector } }
                      )),
                      e.boundariesElement &&
                        (a.modifiers.preventOverflow = {
                          boundariesElement: e.boundariesElement,
                        }),
                      (this.popperInstance = new l["a"](f, r, a)),
                      this._setContent(n, e),
                      requestAnimationFrame(function () {
                        !t._isDisposed && t.popperInstance
                          ? (t.popperInstance.update(),
                            requestAnimationFrame(function () {
                              t._isDisposed
                                ? t.dispose()
                                : t._isOpen &&
                                  r.setAttribute("aria-hidden", "false");
                            }))
                          : t.dispose();
                      }),
                      this
                    );
                  },
                },
                {
                  key: "_noLongerOpen",
                  value: function () {
                    var f = A.indexOf(this);
                    -1 !== f && A.splice(f, 1);
                  },
                },
                {
                  key: "_hide",
                  value: function () {
                    var f = this;
                    if (!this._isOpen) return this;
                    (this._isOpen = !1),
                      this._noLongerOpen(),
                      (this._tooltipNode.style.display = "none"),
                      this._tooltipNode.setAttribute("aria-hidden", "true"),
                      this.popperInstance &&
                        this.popperInstance.disableEventListeners(),
                      clearTimeout(this._disposeTimer);
                    var e = R.options.disposeTimeout;
                    return (
                      null !== e &&
                        (this._disposeTimer = setTimeout(function () {
                          f._tooltipNode &&
                            (f._tooltipNode.removeEventListener(
                              "mouseenter",
                              f.hide
                            ),
                            f._tooltipNode.removeEventListener("click", f.hide),
                            f._removeTooltipNode());
                        }, e)),
                      w(this.reference, ["v-tooltip-open"]),
                      this
                    );
                  },
                },
                {
                  key: "_removeTooltipNode",
                  value: function () {
                    if (this._tooltipNode) {
                      var f = this._tooltipNode.parentNode;
                      f &&
                        (f.removeChild(this._tooltipNode),
                        this.reference.removeAttribute("aria-describedby")),
                        (this._tooltipNode = null);
                    }
                  },
                },
                {
                  key: "_dispose",
                  value: function () {
                    var f = this;
                    return (
                      (this._isDisposed = !0),
                      this.reference.removeAttribute("data-original-title"),
                      this.$_originalTitle &&
                        this.reference.setAttribute(
                          "title",
                          this.$_originalTitle
                        ),
                      this._events.forEach(function (e) {
                        var t = e.func,
                          n = e.event;
                        f.reference.removeEventListener(n, t);
                      }),
                      (this._events = []),
                      this._tooltipNode
                        ? (this._hide(),
                          this._tooltipNode.removeEventListener(
                            "mouseenter",
                            this.hide
                          ),
                          this._tooltipNode.removeEventListener(
                            "click",
                            this.hide
                          ),
                          this.popperInstance.destroy(),
                          this.popperInstance.options.removeOnDestroy ||
                            this._removeTooltipNode())
                        : this._noLongerOpen(),
                      this
                    );
                  },
                },
                {
                  key: "_findContainer",
                  value: function (f, e) {
                    return (
                      "string" === typeof f
                        ? (f = window.document.querySelector(f))
                        : !1 === f && (f = e.parentNode),
                      f
                    );
                  },
                },
                {
                  key: "_append",
                  value: function (f, e) {
                    e.appendChild(f);
                  },
                },
                {
                  key: "_setEventListeners",
                  value: function (f, e, t) {
                    var n = this,
                      r = [],
                      o = [];
                    e.forEach(function (f) {
                      switch (f) {
                        case "hover":
                          r.push("mouseenter"),
                            o.push("mouseleave"),
                            n.options.hideOnTargetClick && o.push("click");
                          break;
                        case "focus":
                          r.push("focus"),
                            o.push("blur"),
                            n.options.hideOnTargetClick && o.push("click");
                          break;
                        case "click":
                          r.push("click"), o.push("click");
                          break;
                      }
                    }),
                      r.forEach(function (e) {
                        var r = function (e) {
                          !0 !== n._isOpen &&
                            ((e.usedByTooltip = !0),
                            n._scheduleShow(f, t.delay, t, e));
                        };
                        n._events.push({ event: e, func: r }),
                          f.addEventListener(e, r);
                      }),
                      o.forEach(function (e) {
                        var r = function (e) {
                          !0 !== e.usedByTooltip &&
                            n._scheduleHide(f, t.delay, t, e);
                        };
                        n._events.push({ event: e, func: r }),
                          f.addEventListener(e, r);
                      });
                  },
                },
                {
                  key: "_onDocumentTouch",
                  value: function (f) {
                    this._enableDocumentTouch &&
                      this._scheduleHide(
                        this.reference,
                        this.options.delay,
                        this.options,
                        f
                      );
                  },
                },
                {
                  key: "_scheduleShow",
                  value: function (f, e, t) {
                    var n = this,
                      r = (e && e.show) || e || 0;
                    clearTimeout(this._scheduleTimer),
                      (this._scheduleTimer = window.setTimeout(function () {
                        return n._show(f, t);
                      }, r));
                  },
                },
                {
                  key: "_scheduleHide",
                  value: function (f, e, t, n) {
                    var r = this,
                      o = (e && e.hide) || e || 0;
                    clearTimeout(this._scheduleTimer),
                      (this._scheduleTimer = window.setTimeout(function () {
                        if (
                          !1 !== r._isOpen &&
                          r._tooltipNode.ownerDocument.body.contains(
                            r._tooltipNode
                          )
                        ) {
                          if ("mouseleave" === n.type) {
                            var o = r._setTooltipNodeEvent(n, f, e, t);
                            if (o) return;
                          }
                          r._hide(f, t);
                        }
                      }, o));
                  },
                },
              ]),
              f
            );
          })();
        function I(f, e) {
          var t = Object.keys(f);
          if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(f);
            e &&
              (n = n.filter(function (e) {
                return Object.getOwnPropertyDescriptor(f, e).enumerable;
              })),
              t.push.apply(t, n);
          }
          return t;
        }
        function T(f) {
          for (var e = 1; e < arguments.length; e++) {
            var t = null != arguments[e] ? arguments[e] : {};
            e % 2
              ? I(Object(t), !0).forEach(function (e) {
                  a()(f, e, t[e]);
                })
              : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(f, Object.getOwnPropertyDescriptors(t))
              : I(Object(t)).forEach(function (e) {
                  Object.defineProperty(
                    f,
                    e,
                    Object.getOwnPropertyDescriptor(t, e)
                  );
                });
          }
          return f;
        }
        "undefined" !== typeof document &&
          document.addEventListener(
            "touchstart",
            function (f) {
              for (var e = 0; e < A.length; e++) A[e]._onDocumentTouch(f);
            },
            !x || { passive: !0, capture: !0 }
          );
        var S = { enabled: !0 },
          O = [
            "top",
            "top-start",
            "top-end",
            "right",
            "right-start",
            "right-end",
            "bottom",
            "bottom-start",
            "bottom-end",
            "left",
            "left-start",
            "left-end",
          ],
          E = {
            defaultPlacement: "top",
            defaultClass: "vue-tooltip-theme",
            defaultTargetClass: "has-tooltip",
            defaultHtml: !0,
            defaultTemplate:
              '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
            defaultArrowSelector: ".tooltip-arrow, .tooltip__arrow",
            defaultInnerSelector: ".tooltip-inner, .tooltip__inner",
            defaultDelay: 0,
            defaultTrigger: "hover focus",
            defaultOffset: 0,
            defaultContainer: "body",
            defaultBoundariesElement: void 0,
            defaultPopperOptions: {},
            defaultLoadingClass: "tooltip-loading",
            defaultLoadingContent: "...",
            autoHide: !0,
            defaultHideOnTargetClick: !0,
            disposeTimeout: 5e3,
            popover: {
              defaultPlacement: "bottom",
              defaultClass: "vue-popover-theme",
              defaultBaseClass: "tooltip popover",
              defaultWrapperClass: "wrapper",
              defaultInnerClass: "tooltip-inner popover-inner",
              defaultArrowClass: "tooltip-arrow popover-arrow",
              defaultOpenClass: "open",
              defaultDelay: 0,
              defaultTrigger: "click",
              defaultOffset: 0,
              defaultContainer: "body",
              defaultBoundariesElement: void 0,
              defaultPopperOptions: {},
              defaultAutoHide: !0,
              defaultHandleResize: !0,
            },
          };
        function L(f) {
          var e = {
            placement:
              "undefined" !== typeof f.placement
                ? f.placement
                : R.options.defaultPlacement,
            delay:
              "undefined" !== typeof f.delay ? f.delay : R.options.defaultDelay,
            html:
              "undefined" !== typeof f.html ? f.html : R.options.defaultHtml,
            template:
              "undefined" !== typeof f.template
                ? f.template
                : R.options.defaultTemplate,
            arrowSelector:
              "undefined" !== typeof f.arrowSelector
                ? f.arrowSelector
                : R.options.defaultArrowSelector,
            innerSelector:
              "undefined" !== typeof f.innerSelector
                ? f.innerSelector
                : R.options.defaultInnerSelector,
            trigger:
              "undefined" !== typeof f.trigger
                ? f.trigger
                : R.options.defaultTrigger,
            offset:
              "undefined" !== typeof f.offset
                ? f.offset
                : R.options.defaultOffset,
            container:
              "undefined" !== typeof f.container
                ? f.container
                : R.options.defaultContainer,
            boundariesElement:
              "undefined" !== typeof f.boundariesElement
                ? f.boundariesElement
                : R.options.defaultBoundariesElement,
            autoHide:
              "undefined" !== typeof f.autoHide
                ? f.autoHide
                : R.options.autoHide,
            hideOnTargetClick:
              "undefined" !== typeof f.hideOnTargetClick
                ? f.hideOnTargetClick
                : R.options.defaultHideOnTargetClick,
            loadingClass:
              "undefined" !== typeof f.loadingClass
                ? f.loadingClass
                : R.options.defaultLoadingClass,
            loadingContent:
              "undefined" !== typeof f.loadingContent
                ? f.loadingContent
                : R.options.defaultLoadingContent,
            popperOptions: T(
              {},
              "undefined" !== typeof f.popperOptions
                ? f.popperOptions
                : R.options.defaultPopperOptions
            ),
          };
          if (e.offset) {
            var t = r()(e.offset),
              n = e.offset;
            ("number" === t || ("string" === t && -1 === n.indexOf(","))) &&
              (n = "0, ".concat(n)),
              e.popperOptions.modifiers || (e.popperOptions.modifiers = {}),
              (e.popperOptions.modifiers.offset = { offset: n });
          }
          return (
            e.trigger &&
              -1 !== e.trigger.indexOf("click") &&
              (e.hideOnTargetClick = !1),
            e
          );
        }
        function N(f, e) {
          for (var t = f.placement, n = 0; n < O.length; n++) {
            var r = O[n];
            e[r] && (t = r);
          }
          return t;
        }
        function z(f) {
          var e = r()(f);
          return "string" === e ? f : !(!f || "object" !== e) && f.content;
        }
        function P(f, e) {
          var t =
              arguments.length > 2 && void 0 !== arguments[2]
                ? arguments[2]
                : {},
            n = z(e),
            o =
              "undefined" !== typeof e.classes
                ? e.classes
                : R.options.defaultClass,
            a = T(
              { title: n },
              L(
                T(
                  T({}, "object" === r()(e) ? e : {}),
                  {},
                  { placement: N(e, t) }
                )
              )
            ),
            i = (f._tooltip = new j(f, a));
          i.setClasses(o), (i._vueEl = f);
          var s =
            "undefined" !== typeof e.targetClasses
              ? e.targetClasses
              : R.options.defaultTargetClass;
          return (f._tooltipTargetClasses = s), y(f, s), i;
        }
        function D(f) {
          f._tooltip &&
            (f._tooltip.dispose(), delete f._tooltip, delete f._tooltipOldShow),
            f._tooltipTargetClasses &&
              (w(f, f._tooltipTargetClasses), delete f._tooltipTargetClasses);
        }
        function B(f, e) {
          var t = e.value;
          e.oldValue;
          var n,
            r = e.modifiers,
            o = z(t);
          o && S.enabled
            ? (f._tooltip
                ? ((n = f._tooltip),
                  n.setContent(o),
                  n.setOptions(T(T({}, t), {}, { placement: N(t, r) })))
                : (n = P(f, t, r)),
              "undefined" !== typeof t.show &&
                t.show !== f._tooltipOldShow &&
                ((f._tooltipOldShow = t.show), t.show ? n.show() : n.hide()))
            : D(f);
        }
        var R = {
          options: E,
          bind: B,
          update: B,
          unbind: function (f) {
            D(f);
          },
        };
        function U(f) {
          f.addEventListener("click", G),
            f.addEventListener("touchstart", H, !!x && { passive: !0 });
        }
        function F(f) {
          f.removeEventListener("click", G),
            f.removeEventListener("touchstart", H),
            f.removeEventListener("touchend", Z),
            f.removeEventListener("touchcancel", q);
        }
        function G(f) {
          var e = f.currentTarget;
          (f.closePopover = !e.$_vclosepopover_touch),
            (f.closeAllPopover =
              e.$_closePopoverModifiers && !!e.$_closePopoverModifiers.all);
        }
        function H(f) {
          if (1 === f.changedTouches.length) {
            var e = f.currentTarget;
            e.$_vclosepopover_touch = !0;
            var t = f.changedTouches[0];
            (e.$_vclosepopover_touchPoint = t),
              e.addEventListener("touchend", Z),
              e.addEventListener("touchcancel", q);
          }
        }
        function Z(f) {
          var e = f.currentTarget;
          if (((e.$_vclosepopover_touch = !1), 1 === f.changedTouches.length)) {
            var t = f.changedTouches[0],
              n = e.$_vclosepopover_touchPoint;
            (f.closePopover =
              Math.abs(t.screenY - n.screenY) < 20 &&
              Math.abs(t.screenX - n.screenX) < 20),
              (f.closeAllPopover =
                e.$_closePopoverModifiers && !!e.$_closePopoverModifiers.all);
          }
        }
        function q(f) {
          var e = f.currentTarget;
          e.$_vclosepopover_touch = !1;
        }
        var Q = {
          bind: function (f, e) {
            var t = e.value,
              n = e.modifiers;
            (f.$_closePopoverModifiers = n),
              ("undefined" === typeof t || t) && U(f);
          },
          update: function (f, e) {
            var t = e.value,
              n = e.oldValue,
              r = e.modifiers;
            (f.$_closePopoverModifiers = r),
              t !== n && ("undefined" === typeof t || t ? U(f) : F(f));
          },
          unbind: function (f) {
            F(f);
          },
        };
        function W(f, e) {
          var t = Object.keys(f);
          if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(f);
            e &&
              (n = n.filter(function (e) {
                return Object.getOwnPropertyDescriptor(f, e).enumerable;
              })),
              t.push.apply(t, n);
          }
          return t;
        }
        function V(f) {
          for (var e = 1; e < arguments.length; e++) {
            var t = null != arguments[e] ? arguments[e] : {};
            e % 2
              ? W(Object(t), !0).forEach(function (e) {
                  a()(f, e, t[e]);
                })
              : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(f, Object.getOwnPropertyDescriptors(t))
              : W(Object(t)).forEach(function (e) {
                  Object.defineProperty(
                    f,
                    e,
                    Object.getOwnPropertyDescriptor(t, e)
                  );
                });
          }
          return f;
        }
        function J(f) {
          var e = R.options.popover[f];
          return "undefined" === typeof e ? R.options[f] : e;
        }
        var Y = !1;
        "undefined" !== typeof window &&
          "undefined" !== typeof navigator &&
          (Y =
            /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream);
        var X = [],
          K = function () {};
        "undefined" !== typeof window && (K = window.Element);
        var $ = {
          name: "VPopover",
          components: { ResizeObserver: b["a"] },
          props: {
            open: { type: Boolean, default: !1 },
            disabled: { type: Boolean, default: !1 },
            placement: {
              type: String,
              default: function () {
                return J("defaultPlacement");
              },
            },
            delay: {
              type: [String, Number, Object],
              default: function () {
                return J("defaultDelay");
              },
            },
            offset: {
              type: [String, Number],
              default: function () {
                return J("defaultOffset");
              },
            },
            trigger: {
              type: String,
              default: function () {
                return J("defaultTrigger");
              },
            },
            container: {
              type: [String, Object, K, Boolean],
              default: function () {
                return J("defaultContainer");
              },
            },
            boundariesElement: {
              type: [String, K],
              default: function () {
                return J("defaultBoundariesElement");
              },
            },
            popperOptions: {
              type: Object,
              default: function () {
                return J("defaultPopperOptions");
              },
            },
            popoverClass: {
              type: [String, Array],
              default: function () {
                return J("defaultClass");
              },
            },
            popoverBaseClass: {
              type: [String, Array],
              default: function () {
                return R.options.popover.defaultBaseClass;
              },
            },
            popoverInnerClass: {
              type: [String, Array],
              default: function () {
                return R.options.popover.defaultInnerClass;
              },
            },
            popoverWrapperClass: {
              type: [String, Array],
              default: function () {
                return R.options.popover.defaultWrapperClass;
              },
            },
            popoverArrowClass: {
              type: [String, Array],
              default: function () {
                return R.options.popover.defaultArrowClass;
              },
            },
            autoHide: {
              type: Boolean,
              default: function () {
                return R.options.popover.defaultAutoHide;
              },
            },
            handleResize: {
              type: Boolean,
              default: function () {
                return R.options.popover.defaultHandleResize;
              },
            },
            openGroup: { type: String, default: null },
            openClass: {
              type: [String, Array],
              default: function () {
                return R.options.popover.defaultOpenClass;
              },
            },
            ariaId: { default: null },
          },
          data: function () {
            return { isOpen: !1, id: Math.random().toString(36).substr(2, 10) };
          },
          computed: {
            cssClass: function () {
              return a()({}, this.openClass, this.isOpen);
            },
            popoverId: function () {
              return "popover_".concat(
                null != this.ariaId ? this.ariaId : this.id
              );
            },
          },
          watch: {
            open: function (f) {
              f ? this.show() : this.hide();
            },
            disabled: function (f, e) {
              f !== e && (f ? this.hide() : this.open && this.show());
            },
            container: function (f) {
              if (this.isOpen && this.popperInstance) {
                var e = this.$refs.popover,
                  t = this.$refs.trigger,
                  n = this.$_findContainer(this.container, t);
                if (!n)
                  return void console.warn("No container for popover", this);
                n.appendChild(e), this.popperInstance.scheduleUpdate();
              }
            },
            trigger: function (f) {
              this.$_removeEventListeners(), this.$_addEventListeners();
            },
            placement: function (f) {
              var e = this;
              this.$_updatePopper(function () {
                e.popperInstance.options.placement = f;
              });
            },
            offset: "$_restartPopper",
            boundariesElement: "$_restartPopper",
            popperOptions: { handler: "$_restartPopper", deep: !0 },
          },
          created: function () {
            (this.$_isDisposed = !1),
              (this.$_mounted = !1),
              (this.$_events = []),
              (this.$_preventOpen = !1);
          },
          mounted: function () {
            var f = this.$refs.popover;
            f.parentNode && f.parentNode.removeChild(f),
              this.$_init(),
              this.open && this.show();
          },
          deactivated: function () {
            this.hide();
          },
          beforeDestroy: function () {
            this.dispose();
          },
          methods: {
            show: function () {
              var f = this,
                e =
                  arguments.length > 0 && void 0 !== arguments[0]
                    ? arguments[0]
                    : {},
                t = e.event;
              e.skipDelay;
              var n = e.force,
                r = void 0 !== n && n;
              (!r && this.disabled) ||
                (this.$_scheduleShow(t), this.$emit("show")),
                this.$emit("update:open", !0),
                (this.$_beingShowed = !0),
                requestAnimationFrame(function () {
                  f.$_beingShowed = !1;
                });
            },
            hide: function () {
              var f =
                  arguments.length > 0 && void 0 !== arguments[0]
                    ? arguments[0]
                    : {},
                e = f.event;
              f.skipDelay,
                this.$_scheduleHide(e),
                this.$emit("hide"),
                this.$emit("update:open", !1);
            },
            dispose: function () {
              if (
                ((this.$_isDisposed = !0),
                this.$_removeEventListeners(),
                this.hide({ skipDelay: !0 }),
                this.popperInstance &&
                  (this.popperInstance.destroy(),
                  !this.popperInstance.options.removeOnDestroy))
              ) {
                var f = this.$refs.popover;
                f.parentNode && f.parentNode.removeChild(f);
              }
              (this.$_mounted = !1),
                (this.popperInstance = null),
                (this.isOpen = !1),
                this.$emit("dispose");
            },
            $_init: function () {
              -1 === this.trigger.indexOf("manual") &&
                this.$_addEventListeners();
            },
            $_show: function () {
              var f = this,
                e = this.$refs.trigger,
                t = this.$refs.popover;
              if ((clearTimeout(this.$_disposeTimer), !this.isOpen)) {
                if (
                  (this.popperInstance &&
                    ((this.isOpen = !0),
                    this.popperInstance.enableEventListeners(),
                    this.popperInstance.scheduleUpdate()),
                  !this.$_mounted)
                ) {
                  var n = this.$_findContainer(this.container, e);
                  if (!n)
                    return void console.warn("No container for popover", this);
                  n.appendChild(t),
                    (this.$_mounted = !0),
                    (this.isOpen = !1),
                    this.popperInstance &&
                      requestAnimationFrame(function () {
                        f.hidden || (f.isOpen = !0);
                      });
                }
                if (!this.popperInstance) {
                  var r = V(
                    V({}, this.popperOptions),
                    {},
                    { placement: this.placement }
                  );
                  if (
                    ((r.modifiers = V(
                      V({}, r.modifiers),
                      {},
                      {
                        arrow: V(
                          V({}, r.modifiers && r.modifiers.arrow),
                          {},
                          { element: this.$refs.arrow }
                        ),
                      }
                    )),
                    this.offset)
                  ) {
                    var o = this.$_getOffset();
                    r.modifiers.offset = V(
                      V({}, r.modifiers && r.modifiers.offset),
                      {},
                      { offset: o }
                    );
                  }
                  this.boundariesElement &&
                    (r.modifiers.preventOverflow = V(
                      V({}, r.modifiers && r.modifiers.preventOverflow),
                      {},
                      { boundariesElement: this.boundariesElement }
                    )),
                    (this.popperInstance = new l["a"](e, t, r)),
                    requestAnimationFrame(function () {
                      if (f.hidden) return (f.hidden = !1), void f.$_hide();
                      !f.$_isDisposed && f.popperInstance
                        ? (f.popperInstance.scheduleUpdate(),
                          requestAnimationFrame(function () {
                            if (f.hidden)
                              return (f.hidden = !1), void f.$_hide();
                            f.$_isDisposed ? f.dispose() : (f.isOpen = !0);
                          }))
                        : f.dispose();
                    });
                }
                var a = this.openGroup;
                if (a)
                  for (var i, s = 0; s < X.length; s++)
                    (i = X[s]),
                      i.openGroup !== a && (i.hide(), i.$emit("close-group"));
                X.push(this), this.$emit("apply-show");
              }
            },
            $_hide: function () {
              var f = this;
              if (this.isOpen) {
                var e = X.indexOf(this);
                -1 !== e && X.splice(e, 1),
                  (this.isOpen = !1),
                  this.popperInstance &&
                    this.popperInstance.disableEventListeners(),
                  clearTimeout(this.$_disposeTimer);
                var t =
                  R.options.popover.disposeTimeout || R.options.disposeTimeout;
                null !== t &&
                  (this.$_disposeTimer = setTimeout(function () {
                    var e = f.$refs.popover;
                    e &&
                      (e.parentNode && e.parentNode.removeChild(e),
                      (f.$_mounted = !1));
                  }, t)),
                  this.$emit("apply-hide");
              }
            },
            $_findContainer: function (f, e) {
              return (
                "string" === typeof f
                  ? (f = window.document.querySelector(f))
                  : !1 === f && (f = e.parentNode),
                f
              );
            },
            $_getOffset: function () {
              var f = r()(this.offset),
                e = this.offset;
              return (
                ("number" === f || ("string" === f && -1 === e.indexOf(","))) &&
                  (e = "0, ".concat(e)),
                e
              );
            },
            $_addEventListeners: function () {
              var f = this,
                e = this.$refs.trigger,
                t = [],
                n = [],
                r =
                  "string" === typeof this.trigger
                    ? this.trigger.split(" ").filter(function (f) {
                        return -1 !== ["click", "hover", "focus"].indexOf(f);
                      })
                    : [];
              r.forEach(function (f) {
                switch (f) {
                  case "hover":
                    t.push("mouseenter"), n.push("mouseleave");
                    break;
                  case "focus":
                    t.push("focus"), n.push("blur");
                    break;
                  case "click":
                    t.push("click"), n.push("click");
                    break;
                }
              }),
                t.forEach(function (t) {
                  var n = function (e) {
                    f.isOpen ||
                      ((e.usedByTooltip = !0),
                      !f.$_preventOpen && f.show({ event: e }),
                      (f.hidden = !1));
                  };
                  f.$_events.push({ event: t, func: n }),
                    e.addEventListener(t, n);
                }),
                n.forEach(function (t) {
                  var n = function (e) {
                    e.usedByTooltip || (f.hide({ event: e }), (f.hidden = !0));
                  };
                  f.$_events.push({ event: t, func: n }),
                    e.addEventListener(t, n);
                });
            },
            $_scheduleShow: function () {
              var f =
                arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
              if ((clearTimeout(this.$_scheduleTimer), f)) this.$_show();
              else {
                var e = parseInt(
                  (this.delay && this.delay.show) || this.delay || 0
                );
                this.$_scheduleTimer = setTimeout(this.$_show.bind(this), e);
              }
            },
            $_scheduleHide: function () {
              var f = this,
                e =
                  arguments.length > 0 && void 0 !== arguments[0]
                    ? arguments[0]
                    : null,
                t =
                  arguments.length > 1 &&
                  void 0 !== arguments[1] &&
                  arguments[1];
              if ((clearTimeout(this.$_scheduleTimer), t)) this.$_hide();
              else {
                var n = parseInt(
                  (this.delay && this.delay.hide) || this.delay || 0
                );
                this.$_scheduleTimer = setTimeout(function () {
                  if (f.isOpen) {
                    if (e && "mouseleave" === e.type) {
                      var t = f.$_setTooltipNodeEvent(e);
                      if (t) return;
                    }
                    f.$_hide();
                  }
                }, n);
              }
            },
            $_setTooltipNodeEvent: function (f) {
              var e = this,
                t = this.$refs.trigger,
                n = this.$refs.popover,
                r = f.relatedreference || f.toElement || f.relatedTarget,
                o = function r(o) {
                  var a = o.relatedreference || o.toElement || o.relatedTarget;
                  n.removeEventListener(f.type, r),
                    t.contains(a) || e.hide({ event: o });
                };
              return !!n.contains(r) && (n.addEventListener(f.type, o), !0);
            },
            $_removeEventListeners: function () {
              var f = this.$refs.trigger;
              this.$_events.forEach(function (e) {
                var t = e.func,
                  n = e.event;
                f.removeEventListener(n, t);
              }),
                (this.$_events = []);
            },
            $_updatePopper: function (f) {
              this.popperInstance &&
                (f(), this.isOpen && this.popperInstance.scheduleUpdate());
            },
            $_restartPopper: function () {
              if (this.popperInstance) {
                var f = this.isOpen;
                this.dispose(),
                  (this.$_isDisposed = !1),
                  this.$_init(),
                  f && this.show({ skipDelay: !0, force: !0 });
              }
            },
            $_handleGlobalClose: function (f) {
              var e = this,
                t =
                  arguments.length > 1 &&
                  void 0 !== arguments[1] &&
                  arguments[1];
              this.$_beingShowed ||
                (this.hide({ event: f }),
                f.closePopover
                  ? this.$emit("close-directive")
                  : this.$emit("auto-hide"),
                t &&
                  ((this.$_preventOpen = !0),
                  setTimeout(function () {
                    e.$_preventOpen = !1;
                  }, 300)));
            },
            $_handleResize: function () {
              this.isOpen &&
                this.popperInstance &&
                (this.popperInstance.scheduleUpdate(), this.$emit("resize"));
            },
          },
        };
        function ff(f) {
          tf(f);
        }
        function ef(f) {
          tf(f, !0);
        }
        function tf(f) {
          for (
            var e =
                arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
              t = function (t) {
                var n = X[t];
                if (n.$refs.popover) {
                  var r = n.$refs.popover.contains(f.target);
                  requestAnimationFrame(function () {
                    (f.closeAllPopover ||
                      (f.closePopover && r) ||
                      (n.autoHide && !r)) &&
                      n.$_handleGlobalClose(f, e);
                  });
                }
              },
              n = 0;
            n < X.length;
            n++
          )
            t(n);
        }
        function nf(f, e, t, n, r, o, a, i, s, d) {
          "boolean" !== typeof a && ((s = i), (i = a), (a = !1));
          const c = "function" === typeof t ? t.options : t;
          let l;
          if (
            (f &&
              f.render &&
              ((c.render = f.render),
              (c.staticRenderFns = f.staticRenderFns),
              (c._compiled = !0),
              r && (c.functional = !0)),
            n && (c._scopeId = n),
            o
              ? ((l = function (f) {
                  (f =
                    f ||
                    (this.$vnode && this.$vnode.ssrContext) ||
                    (this.parent &&
                      this.parent.$vnode &&
                      this.parent.$vnode.ssrContext)),
                    f ||
                      "undefined" === typeof __VUE_SSR_CONTEXT__ ||
                      (f = __VUE_SSR_CONTEXT__),
                    e && e.call(this, s(f)),
                    f &&
                      f._registeredComponents &&
                      f._registeredComponents.add(o);
                }),
                (c._ssrRegister = l))
              : e &&
                (l = a
                  ? function (f) {
                      e.call(this, d(f, this.$root.$options.shadowRoot));
                    }
                  : function (f) {
                      e.call(this, i(f));
                    }),
            l)
          )
            if (c.functional) {
              const f = c.render;
              c.render = function (e, t) {
                return l.call(t), f(e, t);
              };
            } else {
              const f = c.beforeCreate;
              c.beforeCreate = f ? [].concat(f, l) : [l];
            }
          return t;
        }
        "undefined" !== typeof document &&
          "undefined" !== typeof window &&
          (Y
            ? document.addEventListener(
                "touchend",
                ef,
                !x || { passive: !0, capture: !0 }
              )
            : window.addEventListener("click", ff, !0));
        var rf = $,
          of = function () {
            var f = this,
              e = f.$createElement,
              t = f._self._c || e;
            return t("div", { staticClass: "v-popover", class: f.cssClass }, [
              t(
                "div",
                {
                  ref: "trigger",
                  staticClass: "trigger",
                  staticStyle: { display: "inline-block" },
                  attrs: {
                    "aria-describedby": f.isOpen ? f.popoverId : void 0,
                    tabindex: -1 !== f.trigger.indexOf("focus") ? 0 : void 0,
                  },
                },
                [f._t("default")],
                2
              ),
              f._v(" "),
              t(
                "div",
                {
                  ref: "popover",
                  class: [f.popoverBaseClass, f.popoverClass, f.cssClass],
                  style: { visibility: f.isOpen ? "visible" : "hidden" },
                  attrs: {
                    id: f.popoverId,
                    "aria-hidden": f.isOpen ? "false" : "true",
                    tabindex: f.autoHide ? 0 : void 0,
                  },
                  on: {
                    keyup: function (e) {
                      if (
                        !e.type.indexOf("key") &&
                        f._k(e.keyCode, "esc", 27, e.key, ["Esc", "Escape"])
                      )
                        return null;
                      f.autoHide && f.hide();
                    },
                  },
                },
                [
                  t("div", { class: f.popoverWrapperClass }, [
                    t(
                      "div",
                      {
                        ref: "inner",
                        class: f.popoverInnerClass,
                        staticStyle: { position: "relative" },
                      },
                      [
                        t(
                          "div",
                          [f._t("popover", null, { isOpen: f.isOpen })],
                          2
                        ),
                        f._v(" "),
                        f.handleResize
                          ? t("ResizeObserver", {
                              on: { notify: f.$_handleResize },
                            })
                          : f._e(),
                      ],
                      1
                    ),
                    f._v(" "),
                    t("div", { ref: "arrow", class: f.popoverArrowClass }),
                  ]),
                ]
              ),
            ]);
          },
          af = [];
        of._withStripped = !0;
        var sf = void 0,
          df = void 0,
          cf = void 0,
          lf = !1,
          uf = nf(
            { render: of, staticRenderFns: af },
            sf,
            rf,
            df,
            lf,
            cf,
            !1,
            void 0,
            void 0,
            void 0
          );
        function pf(f, e) {
          void 0 === e && (e = {});
          var t = e.insertAt;
          if (f && "undefined" !== typeof document) {
            var n = document.head || document.getElementsByTagName("head")[0],
              r = document.createElement("style");
            (r.type = "text/css"),
              "top" === t && n.firstChild
                ? n.insertBefore(r, n.firstChild)
                : n.appendChild(r),
              r.styleSheet
                ? (r.styleSheet.cssText = f)
                : r.appendChild(document.createTextNode(f));
          }
        }
        var bf =
          ".resize-observer[data-v-8859cc6c]{position:absolute;top:0;left:0;z-index:-1;width:100%;height:100%;border:none;background-color:transparent;pointer-events:none;display:block;overflow:hidden;opacity:0}.resize-observer[data-v-8859cc6c] object{display:block;position:absolute;top:0;left:0;height:100%;width:100%;overflow:hidden;pointer-events:none;z-index:-1}";
        function hf(f) {
          var e =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          if (!hf.installed) {
            hf.installed = !0;
            var t = {};
            g()(t, E, e),
              (gf.options = t),
              (R.options = t),
              f.directive("tooltip", R),
              f.directive("close-popover", Q),
              f.component("VPopover", uf);
          }
        }
        pf(bf);
        var gf = {
            install: hf,
            get enabled() {
              return S.enabled;
            },
            set enabled(f) {
              S.enabled = f;
            },
          },
          mf = null;
        "undefined" !== typeof window
          ? (mf = window.Vue)
          : "undefined" !== typeof f && (mf = f.Vue),
          mf && mf.use(gf),
          (e["a"] = gf);
      }).call(this, t("c8ba"));
    },
    e3e9: function (f, e, t) {
      var n = t("0669");
      n.__esModule && (n = n.default),
        "string" === typeof n && (n = [[f.i, n, ""]]),
        n.locals && (f.exports = n.locals);
      var r = t("499e").default;
      r("8ccc3e42", n, !0, { sourceMap: !1, shadowMode: !1 });
    },
    e439: function (f, e, t) {
      var n = t("23e7"),
        r = t("d039"),
        o = t("fc6a"),
        a = t("06cf").f,
        i = t("83ab"),
        s = r(function () {
          a(1);
        }),
        d = !i || s;
      n(
        { target: "Object", stat: !0, forced: d, sham: !i },
        {
          getOwnPropertyDescriptor: function (f, e) {
            return a(o(f), e);
          },
        }
      );
    },
    e538: function (f, e, t) {
      var n = t("b622");
      e.f = n;
    },
    e5383: function (f, e, t) {
      (function (f) {
        var n = t("2b3e"),
          r = e && !e.nodeType && e,
          o = r && "object" == typeof f && f && !f.nodeType && f,
          a = o && o.exports === r,
          i = a ? n.Buffer : void 0,
          s = i ? i.allocUnsafe : void 0;
        function d(f, e) {
          if (e) return f.slice();
          var t = f.length,
            n = s ? s(t) : new f.constructor(t);
          return f.copy(n), n;
        }
        f.exports = d;
      }).call(this, t("62e4")(f));
    },
    e667: function (f, e) {
      f.exports = function (f) {
        try {
          return { error: !1, value: f() };
        } catch (e) {
          return { error: !0, value: e };
        }
      };
    },
    e6cf: function (f, e, t) {
      "use strict";
      var n,
        r,
        o,
        a,
        i = t("23e7"),
        s = t("c430"),
        d = t("da84"),
        c = t("d066"),
        l = t("c65b"),
        u = t("fea9"),
        p = t("6eeb"),
        b = t("e2cc"),
        h = t("d2bb"),
        g = t("d44e"),
        m = t("2626"),
        v = t("59ed"),
        y = t("1626"),
        w = t("861d"),
        x = t("19aa"),
        _ = t("8925"),
        k = t("2266"),
        M = t("1c7e"),
        C = t("4840"),
        A = t("2cf4").set,
        j = t("b575"),
        I = t("cdf9"),
        T = t("44de"),
        S = t("f069"),
        O = t("e667"),
        E = t("69f3"),
        L = t("94ca"),
        N = t("b622"),
        z = t("6069"),
        P = t("605d"),
        D = t("2d00"),
        B = N("species"),
        R = "Promise",
        U = E.get,
        F = E.set,
        G = E.getterFor(R),
        H = u && u.prototype,
        Z = u,
        q = H,
        Q = d.TypeError,
        W = d.document,
        V = d.process,
        J = S.f,
        Y = J,
        X = !!(W && W.createEvent && d.dispatchEvent),
        K = y(d.PromiseRejectionEvent),
        $ = "unhandledrejection",
        ff = "rejectionhandled",
        ef = 0,
        tf = 1,
        nf = 2,
        rf = 1,
        of = 2,
        af = !1,
        sf = L(R, function () {
          var f = _(Z),
            e = f !== String(Z);
          if (!e && 66 === D) return !0;
          if (s && !q["finally"]) return !0;
          if (D >= 51 && /native code/.test(f)) return !1;
          var t = new Z(function (f) {
              f(1);
            }),
            n = function (f) {
              f(
                function () {},
                function () {}
              );
            },
            r = (t.constructor = {});
          return (
            (r[B] = n),
            (af = t.then(function () {}) instanceof n),
            !af || (!e && z && !K)
          );
        }),
        df =
          sf ||
          !M(function (f) {
            Z.all(f)["catch"](function () {});
          }),
        cf = function (f) {
          var e;
          return !(!w(f) || !y((e = f.then))) && e;
        },
        lf = function (f, e) {
          if (!f.notified) {
            f.notified = !0;
            var t = f.reactions;
            j(function () {
              var n = f.value,
                r = f.state == tf,
                o = 0;
              while (t.length > o) {
                var a,
                  i,
                  s,
                  d = t[o++],
                  c = r ? d.ok : d.fail,
                  u = d.resolve,
                  p = d.reject,
                  b = d.domain;
                try {
                  c
                    ? (r || (f.rejection === of && hf(f), (f.rejection = rf)),
                      !0 === c
                        ? (a = n)
                        : (b && b.enter(),
                          (a = c(n)),
                          b && (b.exit(), (s = !0))),
                      a === d.promise
                        ? p(Q("Promise-chain cycle"))
                        : (i = cf(a))
                        ? l(i, a, u, p)
                        : u(a))
                    : p(n);
                } catch (h) {
                  b && !s && b.exit(), p(h);
                }
              }
              (f.reactions = []), (f.notified = !1), e && !f.rejection && pf(f);
            });
          }
        },
        uf = function (f, e, t) {
          var n, r;
          X
            ? ((n = W.createEvent("Event")),
              (n.promise = e),
              (n.reason = t),
              n.initEvent(f, !1, !0),
              d.dispatchEvent(n))
            : (n = { promise: e, reason: t }),
            !K && (r = d["on" + f])
              ? r(n)
              : f === $ && T("Unhandled promise rejection", t);
        },
        pf = function (f) {
          l(A, d, function () {
            var e,
              t = f.facade,
              n = f.value,
              r = bf(f);
            if (
              r &&
              ((e = O(function () {
                P ? V.emit("unhandledRejection", n, t) : uf($, t, n);
              })),
              (f.rejection = P || bf(f) ? of : rf),
              e.error)
            )
              throw e.value;
          });
        },
        bf = function (f) {
          return f.rejection !== rf && !f.parent;
        },
        hf = function (f) {
          l(A, d, function () {
            var e = f.facade;
            P ? V.emit("rejectionHandled", e) : uf(ff, e, f.value);
          });
        },
        gf = function (f, e, t) {
          return function (n) {
            f(e, n, t);
          };
        },
        mf = function (f, e, t) {
          f.done ||
            ((f.done = !0),
            t && (f = t),
            (f.value = e),
            (f.state = nf),
            lf(f, !0));
        },
        vf = function (f, e, t) {
          if (!f.done) {
            (f.done = !0), t && (f = t);
            try {
              if (f.facade === e) throw Q("Promise can't be resolved itself");
              var n = cf(e);
              n
                ? j(function () {
                    var t = { done: !1 };
                    try {
                      l(n, e, gf(vf, t, f), gf(mf, t, f));
                    } catch (r) {
                      mf(t, r, f);
                    }
                  })
                : ((f.value = e), (f.state = tf), lf(f, !1));
            } catch (r) {
              mf({ done: !1 }, r, f);
            }
          }
        };
      if (
        sf &&
        ((Z = function (f) {
          x(this, q), v(f), l(n, this);
          var e = U(this);
          try {
            f(gf(vf, e), gf(mf, e));
          } catch (t) {
            mf(e, t);
          }
        }),
        (q = Z.prototype),
        (n = function (f) {
          F(this, {
            type: R,
            done: !1,
            notified: !1,
            parent: !1,
            reactions: [],
            rejection: !1,
            state: ef,
            value: void 0,
          });
        }),
        (n.prototype = b(q, {
          then: function (f, e) {
            var t = G(this),
              n = t.reactions,
              r = J(C(this, Z));
            return (
              (r.ok = !y(f) || f),
              (r.fail = y(e) && e),
              (r.domain = P ? V.domain : void 0),
              (t.parent = !0),
              (n[n.length] = r),
              t.state != ef && lf(t, !1),
              r.promise
            );
          },
          catch: function (f) {
            return this.then(void 0, f);
          },
        })),
        (r = function () {
          var f = new n(),
            e = U(f);
          (this.promise = f),
            (this.resolve = gf(vf, e)),
            (this.reject = gf(mf, e));
        }),
        (S.f = J =
          function (f) {
            return f === Z || f === o ? new r(f) : Y(f);
          }),
        !s && y(u) && H !== Object.prototype)
      ) {
        (a = H.then),
          af ||
            (p(
              H,
              "then",
              function (f, e) {
                var t = this;
                return new Z(function (f, e) {
                  l(a, t, f, e);
                }).then(f, e);
              },
              { unsafe: !0 }
            ),
            p(H, "catch", q["catch"], { unsafe: !0 }));
        try {
          delete H.constructor;
        } catch (yf) {}
        h && h(H, q);
      }
      i({ global: !0, wrap: !0, forced: sf }, { Promise: Z }),
        g(Z, R, !1, !0),
        m(R),
        (o = c(R)),
        i(
          { target: R, stat: !0, forced: sf },
          {
            reject: function (f) {
              var e = J(this);
              return l(e.reject, void 0, f), e.promise;
            },
          }
        ),
        i(
          { target: R, stat: !0, forced: s || sf },
          {
            resolve: function (f) {
              return I(s && this === o ? Z : this, f);
            },
          }
        ),
        i(
          { target: R, stat: !0, forced: df },
          {
            all: function (f) {
              var e = this,
                t = J(e),
                n = t.resolve,
                r = t.reject,
                o = O(function () {
                  var t = v(e.resolve),
                    o = [],
                    a = 0,
                    i = 1;
                  k(f, function (f) {
                    var s = a++,
                      d = !1;
                    i++,
                      l(t, e, f).then(function (f) {
                        d || ((d = !0), (o[s] = f), --i || n(o));
                      }, r);
                  }),
                    --i || n(o);
                });
              return o.error && r(o.value), t.promise;
            },
            race: function (f) {
              var e = this,
                t = J(e),
                n = t.reject,
                r = O(function () {
                  var r = v(e.resolve);
                  k(f, function (f) {
                    l(r, e, f).then(t.resolve, n);
                  });
                });
              return r.error && n(r.value), t.promise;
            },
          }
        );
    },
    e893: function (f, e, t) {
      var n = t("1a2d"),
        r = t("56ef"),
        o = t("06cf"),
        a = t("9bf2");
      f.exports = function (f, e) {
        for (var t = r(e), i = a.f, s = o.f, d = 0; d < t.length; d++) {
          var c = t[d];
          n(f, c) || i(f, c, s(e, c));
        }
      };
    },
    e8b5: function (f, e, t) {
      var n = t("c6b6");
      f.exports =
        Array.isArray ||
        function (f) {
          return "Array" == n(f);
        };
    },
    e95a: function (f, e, t) {
      var n = t("b622"),
        r = t("3f8c"),
        o = n("iterator"),
        a = Array.prototype;
      f.exports = function (f) {
        return void 0 !== f && (r.Array === f || a[o] === f);
      };
    },
    eac5: function (f, e) {
      var t = Object.prototype;
      function n(f) {
        var e = f && f.constructor,
          n = ("function" == typeof e && e.prototype) || t;
        return f === n;
      }
      f.exports = n;
    },
    ec69: function (f, e, t) {
      var n = t("6fcd"),
        r = t("03dd"),
        o = t("30c9");
      function a(f) {
        return o(f) ? n(f) : r(f);
      }
      f.exports = a;
    },
    ec8c: function (f, e) {
      function t(f) {
        var e = [];
        if (null != f) for (var t in Object(f)) e.push(t);
        return e;
      }
      f.exports = t;
    },
    edbf: function (f, e, t) {
      "use strict";
      (function (t) {
        (function () {
          var t = this,
            n = t.EmojiConvertor,
            r = function () {
              var f = this;
              return (
                (f.img_set = "apple"),
                (f.img_sets = {
                  apple: {
                    path: "/emoji-data/img-apple-64/",
                    sheet: "/emoji-data/sheet_apple_64.png",
                    sheet_size: 64,
                    mask: 1,
                  },
                  google: {
                    path: "/emoji-data/img-google-64/",
                    sheet: "/emoji-data/sheet_google_64.png",
                    sheet_size: 64,
                    mask: 2,
                  },
                  twitter: {
                    path: "/emoji-data/img-twitter-64/",
                    sheet: "/emoji-data/sheet_twitter_64.png",
                    sheet_size: 64,
                    mask: 4,
                  },
                  facebook: {
                    path: "/emoji-data/img-facebook-64/",
                    sheet: "/emoji-data/sheet_facebook_64.png",
                    sheet_size: 64,
                    mask: 8,
                  },
                  messenger: {
                    path: "/emoji-data/img-messenger-64/",
                    sheet: "/emoji-data/sheet_messenger_64.png",
                    sheet_size: 64,
                    mask: 16,
                  },
                }),
                (f.use_css_imgs = !1),
                (f.colons_mode = !1),
                (f.text_mode = !1),
                (f.include_title = !1),
                (f.include_text = !1),
                (f.allow_native = !0),
                (f.wrap_native = !1),
                (f.use_sheet = !1),
                (f.avoid_ms_emoji = !0),
                (f.allow_caps = !1),
                (f.img_suffix = ""),
                (f.inits = {}),
                (f.map = {}),
                f.init_env(),
                f
              );
            };
          (r.prototype.noConflict = function () {
            return (t.EmojiConvertor = n), r;
          }),
            (r.prototype.replace_emoticons = function (f) {
              var e = this,
                t = e.replace_emoticons_with_colons(f);
              return e.replace_colons(t);
            }),
            (r.prototype.replace_emoticons_with_colons = function (f) {
              var e = this;
              e.init_emoticons();
              var t = 0,
                n = [],
                r = f.replace(e.rx_emoticons, function (r, o, a, i) {
                  var s = t;
                  t = i + r.length;
                  var d = -1 !== a.indexOf("("),
                    c = -1 !== a.indexOf(")");
                  if (((d || c) && -1 == n.indexOf(a) && n.push(a), c && !d)) {
                    var l = f.substring(s, i);
                    if (-1 !== l.indexOf("(") && -1 === l.indexOf(")"))
                      return r;
                  }
                  if ("\n8)" === r) {
                    var u = f.substring(0, i);
                    if (/\n?(6\)|7\))/.test(u)) return r;
                  }
                  var p = e.data[e.map.emoticons[a]][3][0];
                  return p ? o + ":" + p + ":" : r;
                });
              if (n.length) {
                var o = n.map(e.escape_rx),
                  a = new RegExp("(\\(.+)(" + o.join("|") + ")(.+\\))", "g");
                r = r.replace(a, function (f, t, n, r) {
                  var o = e.data[e.map.emoticons[n]][3][0];
                  return o ? t + ":" + o + ":" + r : f;
                });
              }
              return r;
            }),
            (r.prototype.replace_colons = function (f) {
              var e = this;
              return (
                e.init_colons(),
                f.replace(e.rx_colons, function (f) {
                  var t = f.substr(1, f.length - 2);
                  if (
                    (e.allow_caps && (t = t.toLowerCase()),
                    t.indexOf("::skin-tone-") > -1)
                  ) {
                    var n = t.substr(-1, 1),
                      r = "skin-tone-" + n,
                      o = e.map.colons[r];
                    t = t.substr(0, t.length - 13);
                    var a = e.map.colons[t];
                    return a
                      ? e.replacement(a, t, ":", {
                          idx: o,
                          actual: r,
                          wrapper: ":",
                        })
                      : ":" + t + ":" + e.replacement(o, r, ":");
                  }
                  a = e.map.colons[t];
                  return a ? e.replacement(a, t, ":") : f;
                })
              );
            }),
            (r.prototype.replace_unified = function (f) {
              var e = this;
              return (
                e.init_unified(),
                f.replace(e.rx_unified, function (f, t, n) {
                  var r = e.map.unified[t];
                  if (r) {
                    var o = null;
                    return (
                      "🏻" == n && (o = "1f3fb"),
                      "🏼" == n && (o = "1f3fc"),
                      "🏽" == n && (o = "1f3fd"),
                      "🏾" == n && (o = "1f3fe"),
                      "🏿" == n && (o = "1f3ff"),
                      o
                        ? e.replacement(r, null, null, {
                            idx: o,
                            actual: n,
                            wrapper: "",
                          })
                        : e.replacement(r)
                    );
                  }
                  return (
                    (r = e.map.unified_vars[t]),
                    r
                      ? e.replacement(r[0], null, null, {
                          idx: r[1],
                          actual: "",
                          wrapper: "",
                        })
                      : f
                  );
                })
              );
            }),
            (r.prototype.addAliases = function (f) {
              var e = this;
              for (var t in (e.init_colons(), f)) e.map.colons[t] = f[t];
            }),
            (r.prototype.removeAliases = function (f) {
              for (var e = this, t = 0; t < f.length; t++) {
                var n = f[t];
                delete e.map.colons[n];
                f: for (var r in e.data)
                  for (var o = 0; o < e.data[r][3].length; o++)
                    if (n == e.data[r][3][o]) {
                      e.map.colons[n] = r;
                      break f;
                    }
              }
            }),
            (r.prototype.replacement = function (f, e, t, n, r) {
              var o = this,
                a = "",
                i = null;
              if (
                ("object" === typeof n &&
                  ((a = o.replacement(n.idx, n.actual, n.wrapper, void 0, !0)),
                  (i = n.idx)),
                (t = t || ""),
                o.colons_mode)
              )
                return ":" + o.data[f][3][0] + ":" + a;
              var s = e ? t + e + t : o.data[f][8] || t + o.data[f][3][0] + t;
              if (o.text_mode) return s + a;
              var d = o.find_image(f, i);
              if (
                (o.init_env(),
                "softbank" == o.replace_mode && o.allow_native && o.data[f][1])
              )
                return o.format_native(o.data[f][1] + a, !r);
              if ("google" == o.replace_mode && o.allow_native && o.data[f][2])
                return o.format_native(o.data[f][2] + a, !r);
              if (
                (d.is_var && (a = ""),
                "unified" == o.replace_mode && o.allow_native)
              )
                return o.format_native(d.unified + a, !r);
              var c = o.include_title
                  ? ' title="' + (e || o.data[f][3][0]) + '"'
                  : "",
                l = o.include_text ? t + (e || o.data[f][3][0]) + t : "";
              if (
                (o.data[f][7] &&
                  ((d.path = o.data[f][7]),
                  (d.px = null),
                  (d.py = null),
                  (d.is_var = !1)),
                d.is_var &&
                  o.include_text &&
                  n &&
                  n.actual &&
                  n.wrapper &&
                  (l += n.wrapper + n.actual + n.wrapper),
                o.supports_css)
              ) {
                if (o.use_sheet && null != d.px && null != d.py) {
                  var u = (100 * d.px) / (o.sheet_size - 1),
                    p = (100 * d.py) / (o.sheet_size - 1),
                    b = 100 * o.sheet_size,
                    h =
                      "background: url(" +
                      d.sheet +
                      ");background-position:" +
                      u +
                      "% " +
                      p +
                      "%;background-size:" +
                      b +
                      "% " +
                      b +
                      "%";
                  return (
                    '<span class="emoji-outer emoji-sizer"><span class="emoji-inner" style="' +
                    h +
                    '"' +
                    c +
                    ' data-codepoints="' +
                    d.full_idx +
                    '">' +
                    l +
                    "</span></span>" +
                    a
                  );
                }
                return o.use_css_imgs
                  ? '<span class="emoji emoji-' +
                      f +
                      '"' +
                      c +
                      ' data-codepoints="' +
                      d.full_idx +
                      '">' +
                      l +
                      "</span>" +
                      a
                  : '<span class="emoji emoji-sizer" style="background-image:url(' +
                      d.path +
                      ')"' +
                      c +
                      ' data-codepoints="' +
                      d.full_idx +
                      '">' +
                      l +
                      "</span>" +
                      a;
              }
              return (
                '<img src="' +
                d.path +
                '" class="emoji" data-codepoints="' +
                d.full_idx +
                '" ' +
                c +
                "/>" +
                a
              );
            }),
            (r.prototype.format_native = function (f, e) {
              var t = this;
              return t.wrap_native && e
                ? '<span class="emoji-native">' + f + "</span>"
                : f;
            }),
            (r.prototype.find_image = function (f, e) {
              var t = this,
                n = {
                  path: "",
                  sheet: "",
                  sheet_size: 0,
                  px: t.data[f][4],
                  py: t.data[f][5],
                  full_idx: f,
                  is_var: !1,
                  unified: t.data[f][0][0],
                },
                r = t.data[f][6];
              if (e && t.variations_data[f] && t.variations_data[f][e]) {
                var o = t.variations_data[f][e];
                (n.px = o[1]),
                  (n.py = o[2]),
                  (n.full_idx = o[0]),
                  (n.is_var = !0),
                  (n.unified = o[4][0]),
                  (r = o[3]);
              }
              for (
                var a = [
                    t.img_set,
                    "apple",
                    "google",
                    "twitter",
                    "facebook",
                    "messenger",
                  ],
                  i = 0;
                i < a.length;
                i++
              ) {
                if (r & t.img_sets[a[i]].mask)
                  return (
                    (n.path =
                      t.img_sets[a[i]].path +
                      n.full_idx +
                      ".png" +
                      t.img_suffix),
                    (n.sheet = t.img_sets[t.img_set].sheet),
                    (n.sheet_size = t.img_sets[t.img_set].sheet_size),
                    n
                  );
                if (t.obsoletes_data[n.full_idx]) {
                  var s = t.obsoletes_data[n.full_idx];
                  if (s[3] & t.img_sets[a[i]].mask)
                    return (
                      (n.path =
                        t.img_sets[a[i]].path + s[0] + ".png" + t.img_suffix),
                      (n.sheet = t.img_sets[a[i]].sheet),
                      (n.sheet_size = t.img_sets[a[i]].sheet_size),
                      (n.px = s[1]),
                      (n.py = s[2]),
                      n
                    );
                }
              }
              return n;
            }),
            (r.prototype.init_emoticons = function () {
              var f = this;
              if (!f.inits.emoticons) {
                f.init_colons(), (f.inits.emoticons = 1);
                var e = [];
                for (var t in ((f.map.emoticons = {}), f.emoticons_data)) {
                  var n = t
                    .replace(/\&/g, "&amp;")
                    .replace(/\</g, "&lt;")
                    .replace(/\>/g, "&gt;");
                  f.map.colons[f.emoticons_data[t]] &&
                    ((f.map.emoticons[n] = f.map.colons[f.emoticons_data[t]]),
                    e.push(f.escape_rx(n)));
                }
                f.rx_emoticons = new RegExp(
                  "(^|\\s)(" + e.join("|") + ")(?=$|[\\s|\\?\\.,!])",
                  "g"
                );
              }
            }),
            (r.prototype.init_colons = function () {
              var f = this;
              if (!f.inits.colons)
                for (var e in ((f.inits.colons = 1),
                (f.rx_colons = new RegExp(
                  ":[a-zA-Z0-9-_+]+:(:skin-tone-[2-6]:)?",
                  "g"
                )),
                (f.map.colons = {}),
                f.data))
                  for (var t = 0; t < f.data[e][3].length; t++)
                    f.map.colons[f.data[e][3][t]] = e;
            }),
            (r.prototype.init_unified = function () {
              var f = this;
              if (!f.inits.unified) {
                f.inits.unified = 1;
                var e = [];
                for (var t in ((f.map.unified = {}),
                (f.map.unified_vars = {}),
                f.data))
                  for (var n = 0; n < f.data[t][0].length; n++)
                    e.push(f.data[t][0][n].replace("*", "\\*")),
                      (f.map.unified[f.data[t][0][n]] = t);
                for (var t in f.variations_data)
                  if (
                    !f.variations_data[t]["1f3fb"] ||
                    f.variations_data[t]["1f3fb"][0] != t + "-1f3fb"
                  )
                    for (var r in f.variations_data[t])
                      for (n = 0; n < f.variations_data[t][r][4].length; n++)
                        e.push(
                          f.variations_data[t][r][4][n].replace("*", "\\*")
                        ),
                          (f.map.unified_vars[f.variations_data[t][r][4][n]] = [
                            t,
                            r,
                          ]);
                (e = e.sort(function (f, e) {
                  return e.length - f.length;
                })),
                  (f.rx_unified = new RegExp(
                    "(" + e.join("|") + ")(\ud83c[\udffb-\udfff])?",
                    "g"
                  ));
              }
            }),
            (r.prototype.init_env = function () {
              var f = this;
              if (!f.inits.env) {
                if (
                  ((f.inits.env = 1),
                  (f.replace_mode = "img"),
                  (f.supports_css = !1),
                  "undefined" !== typeof navigator)
                ) {
                  var e = navigator.userAgent;
                  if ("undefined" !== typeof window && window.getComputedStyle)
                    try {
                      var t = window.getComputedStyle(document.body);
                      (t["background-size"] || t["backgroundSize"]) &&
                        (f.supports_css = !0);
                    } catch (n) {
                      e.match(/Firefox/i) && (f.supports_css = !0);
                    }
                  if (navigator.product.match(/ReactNative/i))
                    return void (f.replace_mode = "unified");
                  if (e.match(/(iPhone|iPod|iPad|iPhone\s+Simulator)/i)) {
                    if (e.match(/OS\s+[12345]/i))
                      return void (f.replace_mode = "softbank");
                    if (e.match(/OS\s+[6789]/i))
                      return void (f.replace_mode = "unified");
                  }
                  if (e.match(/Mac OS X (10[._ ](?:[789]|1)|11[._ ]\d)/i))
                    return void (f.replace_mode = "unified");
                  if (
                    !f.avoid_ms_emoji &&
                    (e.match(/Windows NT 6.[1-9]/i) ||
                      e.match(/Windows NT 10.[0-9]/i)) &&
                    !e.match(/Chrome/i) &&
                    !e.match(/MSIE 8/i)
                  )
                    return void (f.replace_mode = "unified");
                }
                0, f.supports_css && (f.replace_mode = "css");
              }
            }),
            (r.prototype.escape_rx = function (f) {
              return f.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
            }),
            (r.prototype.sheet_size = 60),
            (r.prototype.data = {
              "0023-fe0f-20e3": [["#️⃣", "#⃣"], "", "󾠬", ["hash"], 0, 0, 7, 0],
              "002a-fe0f-20e3": [
                ["*️⃣", "*⃣"],
                "",
                "",
                ["keycap_star"],
                0,
                1,
                7,
                0,
              ],
              "0030-fe0f-20e3": [["0️⃣", "0⃣"], "", "󾠷", ["zero"], 0, 2, 7, 0],
              "0031-fe0f-20e3": [["1️⃣", "1⃣"], "", "󾠮", ["one"], 0, 3, 7, 0],
              "0032-fe0f-20e3": [["2️⃣", "2⃣"], "", "󾠯", ["two"], 0, 4, 7, 0],
              "0033-fe0f-20e3": [["3️⃣", "3⃣"], "", "󾠰", ["three"], 0, 5, 7, 0],
              "0034-fe0f-20e3": [["4️⃣", "4⃣"], "", "󾠱", ["four"], 0, 6, 7, 0],
              "0035-fe0f-20e3": [["5️⃣", "5⃣"], "", "󾠲", ["five"], 0, 7, 7, 0],
              "0036-fe0f-20e3": [["6️⃣", "6⃣"], "", "󾠳", ["six"], 0, 8, 7, 0],
              "0037-fe0f-20e3": [["7️⃣", "7⃣"], "", "󾠴", ["seven"], 0, 9, 7, 0],
              "0038-fe0f-20e3": [
                ["8️⃣", "8⃣"],
                "",
                "󾠵",
                ["eight"],
                0,
                10,
                7,
                0,
              ],
              "0039-fe0f-20e3": [["9️⃣", "9⃣"], "", "󾠶", ["nine"], 0, 11, 7, 0],
              "00a9-fe0f": [["©️", "©"], "", "󾬩", ["copyright"], 0, 12, 7, 0],
              "00ae-fe0f": [["®️", "®"], "", "󾬭", ["registered"], 0, 13, 7, 0],
              "1f004": [["🀄"], "", "󾠋", ["mahjong"], 0, 14, 15, 0],
              "1f0cf": [["🃏"], "", "󾠒", ["black_joker"], 0, 15, 15, 0],
              "1f170-fe0f": [["🅰️", "🅰"], "", "󾔋", ["a"], 0, 16, 15, 0],
              "1f171-fe0f": [["🅱️", "🅱"], "", "󾔌", ["b"], 0, 17, 15, 0],
              "1f17e-fe0f": [["🅾️", "🅾"], "", "󾔎", ["o2"], 0, 18, 15, 0],
              "1f17f-fe0f": [["🅿️", "🅿"], "", "󾟶", ["parking"], 0, 19, 15, 0],
              "1f18e": [["🆎"], "", "󾔍", ["ab"], 0, 20, 15, 0],
              "1f191": [["🆑"], "", "󾮄", ["cl"], 0, 21, 15, 0],
              "1f192": [["🆒"], "", "󾬸", ["cool"], 0, 22, 15, 0],
              "1f193": [["🆓"], "", "󾬡", ["free"], 0, 23, 15, 0],
              "1f194": [["🆔"], "", "󾮁", ["id"], 0, 24, 15, 0],
              "1f195": [["🆕"], "", "󾬶", ["new"], 0, 25, 15, 0],
              "1f196": [["🆖"], "", "󾬨", ["ng"], 0, 26, 15, 0],
              "1f197": [["🆗"], "", "󾬧", ["ok"], 0, 27, 15, 0],
              "1f198": [["🆘"], "", "󾭏", ["sos"], 0, 28, 15, 0],
              "1f199": [["🆙"], "", "󾬷", ["up"], 0, 29, 15, 0],
              "1f19a": [["🆚"], "", "󾬲", ["vs"], 0, 30, 15, 0],
              "1f1e6-1f1e8": [["🇦🇨"], "", "", ["flag-ac"], 0, 31, 15, 0],
              "1f1e6-1f1e9": [["🇦🇩"], "", "", ["flag-ad"], 0, 32, 15, 0],
              "1f1e6-1f1ea": [["🇦🇪"], "", "", ["flag-ae"], 0, 33, 15, 0],
              "1f1e6-1f1eb": [["🇦🇫"], "", "", ["flag-af"], 0, 34, 15, 0],
              "1f1e6-1f1ec": [["🇦🇬"], "", "", ["flag-ag"], 0, 35, 15, 0],
              "1f1e6-1f1ee": [["🇦🇮"], "", "", ["flag-ai"], 0, 36, 15, 0],
              "1f1e6-1f1f1": [["🇦🇱"], "", "", ["flag-al"], 0, 37, 15, 0],
              "1f1e6-1f1f2": [["🇦🇲"], "", "", ["flag-am"], 0, 38, 15, 0],
              "1f1e6-1f1f4": [["🇦🇴"], "", "", ["flag-ao"], 0, 39, 15, 0],
              "1f1e6-1f1f6": [["🇦🇶"], "", "", ["flag-aq"], 0, 40, 15, 0],
              "1f1e6-1f1f7": [["🇦🇷"], "", "", ["flag-ar"], 0, 41, 15, 0],
              "1f1e6-1f1f8": [["🇦🇸"], "", "", ["flag-as"], 0, 42, 15, 0],
              "1f1e6-1f1f9": [["🇦🇹"], "", "", ["flag-at"], 0, 43, 15, 0],
              "1f1e6-1f1fa": [["🇦🇺"], "", "", ["flag-au"], 0, 44, 15, 0],
              "1f1e6-1f1fc": [["🇦🇼"], "", "", ["flag-aw"], 0, 45, 15, 0],
              "1f1e6-1f1fd": [["🇦🇽"], "", "", ["flag-ax"], 0, 46, 15, 0],
              "1f1e6-1f1ff": [["🇦🇿"], "", "", ["flag-az"], 0, 47, 15, 0],
              "1f1e7-1f1e6": [["🇧🇦"], "", "", ["flag-ba"], 0, 48, 15, 0],
              "1f1e7-1f1e7": [["🇧🇧"], "", "", ["flag-bb"], 0, 49, 15, 0],
              "1f1e7-1f1e9": [["🇧🇩"], "", "", ["flag-bd"], 0, 50, 15, 0],
              "1f1e7-1f1ea": [["🇧🇪"], "", "", ["flag-be"], 0, 51, 15, 0],
              "1f1e7-1f1eb": [["🇧🇫"], "", "", ["flag-bf"], 0, 52, 15, 0],
              "1f1e7-1f1ec": [["🇧🇬"], "", "", ["flag-bg"], 0, 53, 15, 0],
              "1f1e7-1f1ed": [["🇧🇭"], "", "", ["flag-bh"], 0, 54, 15, 0],
              "1f1e7-1f1ee": [["🇧🇮"], "", "", ["flag-bi"], 0, 55, 15, 0],
              "1f1e7-1f1ef": [["🇧🇯"], "", "", ["flag-bj"], 0, 56, 15, 0],
              "1f1e7-1f1f1": [["🇧🇱"], "", "", ["flag-bl"], 0, 57, 15, 0],
              "1f1e7-1f1f2": [["🇧🇲"], "", "", ["flag-bm"], 0, 58, 15, 0],
              "1f1e7-1f1f3": [["🇧🇳"], "", "", ["flag-bn"], 0, 59, 15, 0],
              "1f1e7-1f1f4": [["🇧🇴"], "", "", ["flag-bo"], 1, 0, 15, 0],
              "1f1e7-1f1f6": [["🇧🇶"], "", "", ["flag-bq"], 1, 1, 15, 0],
              "1f1e7-1f1f7": [["🇧🇷"], "", "", ["flag-br"], 1, 2, 15, 0],
              "1f1e7-1f1f8": [["🇧🇸"], "", "", ["flag-bs"], 1, 3, 15, 0],
              "1f1e7-1f1f9": [["🇧🇹"], "", "", ["flag-bt"], 1, 4, 15, 0],
              "1f1e7-1f1fb": [["🇧🇻"], "", "", ["flag-bv"], 1, 5, 15, 0],
              "1f1e7-1f1fc": [["🇧🇼"], "", "", ["flag-bw"], 1, 6, 15, 0],
              "1f1e7-1f1fe": [["🇧🇾"], "", "", ["flag-by"], 1, 7, 15, 0],
              "1f1e7-1f1ff": [["🇧🇿"], "", "", ["flag-bz"], 1, 8, 15, 0],
              "1f1e8-1f1e6": [["🇨🇦"], "", "", ["flag-ca"], 1, 9, 15, 0],
              "1f1e8-1f1e8": [["🇨🇨"], "", "", ["flag-cc"], 1, 10, 15, 0],
              "1f1e8-1f1e9": [["🇨🇩"], "", "", ["flag-cd"], 1, 11, 15, 0],
              "1f1e8-1f1eb": [["🇨🇫"], "", "", ["flag-cf"], 1, 12, 15, 0],
              "1f1e8-1f1ec": [["🇨🇬"], "", "", ["flag-cg"], 1, 13, 15, 0],
              "1f1e8-1f1ed": [["🇨🇭"], "", "", ["flag-ch"], 1, 14, 15, 0],
              "1f1e8-1f1ee": [["🇨🇮"], "", "", ["flag-ci"], 1, 15, 15, 0],
              "1f1e8-1f1f0": [["🇨🇰"], "", "", ["flag-ck"], 1, 16, 15, 0],
              "1f1e8-1f1f1": [["🇨🇱"], "", "", ["flag-cl"], 1, 17, 15, 0],
              "1f1e8-1f1f2": [["🇨🇲"], "", "", ["flag-cm"], 1, 18, 15, 0],
              "1f1e8-1f1f3": [
                ["🇨🇳"],
                "",
                "󾓭",
                ["cn", "flag-cn"],
                1,
                19,
                15,
                0,
              ],
              "1f1e8-1f1f4": [["🇨🇴"], "", "", ["flag-co"], 1, 20, 15, 0],
              "1f1e8-1f1f5": [["🇨🇵"], "", "", ["flag-cp"], 1, 21, 15, 0],
              "1f1e8-1f1f7": [["🇨🇷"], "", "", ["flag-cr"], 1, 22, 15, 0],
              "1f1e8-1f1fa": [["🇨🇺"], "", "", ["flag-cu"], 1, 23, 15, 0],
              "1f1e8-1f1fb": [["🇨🇻"], "", "", ["flag-cv"], 1, 24, 15, 0],
              "1f1e8-1f1fc": [["🇨🇼"], "", "", ["flag-cw"], 1, 25, 15, 0],
              "1f1e8-1f1fd": [["🇨🇽"], "", "", ["flag-cx"], 1, 26, 15, 0],
              "1f1e8-1f1fe": [["🇨🇾"], "", "", ["flag-cy"], 1, 27, 15, 0],
              "1f1e8-1f1ff": [["🇨🇿"], "", "", ["flag-cz"], 1, 28, 15, 0],
              "1f1e9-1f1ea": [
                ["🇩🇪"],
                "",
                "󾓨",
                ["de", "flag-de"],
                1,
                29,
                15,
                0,
              ],
              "1f1e9-1f1ec": [["🇩🇬"], "", "", ["flag-dg"], 1, 30, 15, 0],
              "1f1e9-1f1ef": [["🇩🇯"], "", "", ["flag-dj"], 1, 31, 15, 0],
              "1f1e9-1f1f0": [["🇩🇰"], "", "", ["flag-dk"], 1, 32, 15, 0],
              "1f1e9-1f1f2": [["🇩🇲"], "", "", ["flag-dm"], 1, 33, 15, 0],
              "1f1e9-1f1f4": [["🇩🇴"], "", "", ["flag-do"], 1, 34, 15, 0],
              "1f1e9-1f1ff": [["🇩🇿"], "", "", ["flag-dz"], 1, 35, 15, 0],
              "1f1ea-1f1e6": [["🇪🇦"], "", "", ["flag-ea"], 1, 36, 15, 0],
              "1f1ea-1f1e8": [["🇪🇨"], "", "", ["flag-ec"], 1, 37, 15, 0],
              "1f1ea-1f1ea": [["🇪🇪"], "", "", ["flag-ee"], 1, 38, 15, 0],
              "1f1ea-1f1ec": [["🇪🇬"], "", "", ["flag-eg"], 1, 39, 15, 0],
              "1f1ea-1f1ed": [["🇪🇭"], "", "", ["flag-eh"], 1, 40, 15, 0],
              "1f1ea-1f1f7": [["🇪🇷"], "", "", ["flag-er"], 1, 41, 15, 0],
              "1f1ea-1f1f8": [
                ["🇪🇸"],
                "",
                "󾓫",
                ["es", "flag-es"],
                1,
                42,
                15,
                0,
              ],
              "1f1ea-1f1f9": [["🇪🇹"], "", "", ["flag-et"], 1, 43, 15, 0],
              "1f1ea-1f1fa": [["🇪🇺"], "", "", ["flag-eu"], 1, 44, 15, 0],
              "1f1eb-1f1ee": [["🇫🇮"], "", "", ["flag-fi"], 1, 45, 15, 0],
              "1f1eb-1f1ef": [["🇫🇯"], "", "", ["flag-fj"], 1, 46, 15, 0],
              "1f1eb-1f1f0": [["🇫🇰"], "", "", ["flag-fk"], 1, 47, 15, 0],
              "1f1eb-1f1f2": [["🇫🇲"], "", "", ["flag-fm"], 1, 48, 15, 0],
              "1f1eb-1f1f4": [["🇫🇴"], "", "", ["flag-fo"], 1, 49, 15, 0],
              "1f1eb-1f1f7": [
                ["🇫🇷"],
                "",
                "󾓧",
                ["fr", "flag-fr"],
                1,
                50,
                15,
                0,
              ],
              "1f1ec-1f1e6": [["🇬🇦"], "", "", ["flag-ga"], 1, 51, 15, 0],
              "1f1ec-1f1e7": [
                ["🇬🇧"],
                "",
                "󾓪",
                ["gb", "uk", "flag-gb"],
                1,
                52,
                15,
                0,
              ],
              "1f1ec-1f1e9": [["🇬🇩"], "", "", ["flag-gd"], 1, 53, 15, 0],
              "1f1ec-1f1ea": [["🇬🇪"], "", "", ["flag-ge"], 1, 54, 15, 0],
              "1f1ec-1f1eb": [["🇬🇫"], "", "", ["flag-gf"], 1, 55, 15, 0],
              "1f1ec-1f1ec": [["🇬🇬"], "", "", ["flag-gg"], 1, 56, 15, 0],
              "1f1ec-1f1ed": [["🇬🇭"], "", "", ["flag-gh"], 1, 57, 15, 0],
              "1f1ec-1f1ee": [["🇬🇮"], "", "", ["flag-gi"], 1, 58, 15, 0],
              "1f1ec-1f1f1": [["🇬🇱"], "", "", ["flag-gl"], 1, 59, 15, 0],
              "1f1ec-1f1f2": [["🇬🇲"], "", "", ["flag-gm"], 2, 0, 15, 0],
              "1f1ec-1f1f3": [["🇬🇳"], "", "", ["flag-gn"], 2, 1, 15, 0],
              "1f1ec-1f1f5": [["🇬🇵"], "", "", ["flag-gp"], 2, 2, 15, 0],
              "1f1ec-1f1f6": [["🇬🇶"], "", "", ["flag-gq"], 2, 3, 15, 0],
              "1f1ec-1f1f7": [["🇬🇷"], "", "", ["flag-gr"], 2, 4, 15, 0],
              "1f1ec-1f1f8": [["🇬🇸"], "", "", ["flag-gs"], 2, 5, 15, 0],
              "1f1ec-1f1f9": [["🇬🇹"], "", "", ["flag-gt"], 2, 6, 15, 0],
              "1f1ec-1f1fa": [["🇬🇺"], "", "", ["flag-gu"], 2, 7, 15, 0],
              "1f1ec-1f1fc": [["🇬🇼"], "", "", ["flag-gw"], 2, 8, 15, 0],
              "1f1ec-1f1fe": [["🇬🇾"], "", "", ["flag-gy"], 2, 9, 15, 0],
              "1f1ed-1f1f0": [["🇭🇰"], "", "", ["flag-hk"], 2, 10, 15, 0],
              "1f1ed-1f1f2": [["🇭🇲"], "", "", ["flag-hm"], 2, 11, 15, 0],
              "1f1ed-1f1f3": [["🇭🇳"], "", "", ["flag-hn"], 2, 12, 15, 0],
              "1f1ed-1f1f7": [["🇭🇷"], "", "", ["flag-hr"], 2, 13, 15, 0],
              "1f1ed-1f1f9": [["🇭🇹"], "", "", ["flag-ht"], 2, 14, 15, 0],
              "1f1ed-1f1fa": [["🇭🇺"], "", "", ["flag-hu"], 2, 15, 15, 0],
              "1f1ee-1f1e8": [["🇮🇨"], "", "", ["flag-ic"], 2, 16, 15, 0],
              "1f1ee-1f1e9": [["🇮🇩"], "", "", ["flag-id"], 2, 17, 15, 0],
              "1f1ee-1f1ea": [["🇮🇪"], "", "", ["flag-ie"], 2, 18, 15, 0],
              "1f1ee-1f1f1": [["🇮🇱"], "", "", ["flag-il"], 2, 19, 15, 0],
              "1f1ee-1f1f2": [["🇮🇲"], "", "", ["flag-im"], 2, 20, 15, 0],
              "1f1ee-1f1f3": [["🇮🇳"], "", "", ["flag-in"], 2, 21, 15, 0],
              "1f1ee-1f1f4": [["🇮🇴"], "", "", ["flag-io"], 2, 22, 15, 0],
              "1f1ee-1f1f6": [["🇮🇶"], "", "", ["flag-iq"], 2, 23, 15, 0],
              "1f1ee-1f1f7": [["🇮🇷"], "", "", ["flag-ir"], 2, 24, 15, 0],
              "1f1ee-1f1f8": [["🇮🇸"], "", "", ["flag-is"], 2, 25, 15, 0],
              "1f1ee-1f1f9": [
                ["🇮🇹"],
                "",
                "󾓩",
                ["it", "flag-it"],
                2,
                26,
                15,
                0,
              ],
              "1f1ef-1f1ea": [["🇯🇪"], "", "", ["flag-je"], 2, 27, 15, 0],
              "1f1ef-1f1f2": [["🇯🇲"], "", "", ["flag-jm"], 2, 28, 15, 0],
              "1f1ef-1f1f4": [["🇯🇴"], "", "", ["flag-jo"], 2, 29, 15, 0],
              "1f1ef-1f1f5": [
                ["🇯🇵"],
                "",
                "󾓥",
                ["jp", "flag-jp"],
                2,
                30,
                15,
                0,
              ],
              "1f1f0-1f1ea": [["🇰🇪"], "", "", ["flag-ke"], 2, 31, 15, 0],
              "1f1f0-1f1ec": [["🇰🇬"], "", "", ["flag-kg"], 2, 32, 15, 0],
              "1f1f0-1f1ed": [["🇰🇭"], "", "", ["flag-kh"], 2, 33, 15, 0],
              "1f1f0-1f1ee": [["🇰🇮"], "", "", ["flag-ki"], 2, 34, 15, 0],
              "1f1f0-1f1f2": [["🇰🇲"], "", "", ["flag-km"], 2, 35, 15, 0],
              "1f1f0-1f1f3": [["🇰🇳"], "", "", ["flag-kn"], 2, 36, 15, 0],
              "1f1f0-1f1f5": [["🇰🇵"], "", "", ["flag-kp"], 2, 37, 15, 0],
              "1f1f0-1f1f7": [
                ["🇰🇷"],
                "",
                "󾓮",
                ["kr", "flag-kr"],
                2,
                38,
                15,
                0,
              ],
              "1f1f0-1f1fc": [["🇰🇼"], "", "", ["flag-kw"], 2, 39, 15, 0],
              "1f1f0-1f1fe": [["🇰🇾"], "", "", ["flag-ky"], 2, 40, 15, 0],
              "1f1f0-1f1ff": [["🇰🇿"], "", "", ["flag-kz"], 2, 41, 15, 0],
              "1f1f1-1f1e6": [["🇱🇦"], "", "", ["flag-la"], 2, 42, 15, 0],
              "1f1f1-1f1e7": [["🇱🇧"], "", "", ["flag-lb"], 2, 43, 15, 0],
              "1f1f1-1f1e8": [["🇱🇨"], "", "", ["flag-lc"], 2, 44, 15, 0],
              "1f1f1-1f1ee": [["🇱🇮"], "", "", ["flag-li"], 2, 45, 15, 0],
              "1f1f1-1f1f0": [["🇱🇰"], "", "", ["flag-lk"], 2, 46, 15, 0],
              "1f1f1-1f1f7": [["🇱🇷"], "", "", ["flag-lr"], 2, 47, 15, 0],
              "1f1f1-1f1f8": [["🇱🇸"], "", "", ["flag-ls"], 2, 48, 15, 0],
              "1f1f1-1f1f9": [["🇱🇹"], "", "", ["flag-lt"], 2, 49, 15, 0],
              "1f1f1-1f1fa": [["🇱🇺"], "", "", ["flag-lu"], 2, 50, 15, 0],
              "1f1f1-1f1fb": [["🇱🇻"], "", "", ["flag-lv"], 2, 51, 15, 0],
              "1f1f1-1f1fe": [["🇱🇾"], "", "", ["flag-ly"], 2, 52, 15, 0],
              "1f1f2-1f1e6": [["🇲🇦"], "", "", ["flag-ma"], 2, 53, 15, 0],
              "1f1f2-1f1e8": [["🇲🇨"], "", "", ["flag-mc"], 2, 54, 15, 0],
              "1f1f2-1f1e9": [["🇲🇩"], "", "", ["flag-md"], 2, 55, 15, 0],
              "1f1f2-1f1ea": [["🇲🇪"], "", "", ["flag-me"], 2, 56, 15, 0],
              "1f1f2-1f1eb": [["🇲🇫"], "", "", ["flag-mf"], 2, 57, 15, 0],
              "1f1f2-1f1ec": [["🇲🇬"], "", "", ["flag-mg"], 2, 58, 15, 0],
              "1f1f2-1f1ed": [["🇲🇭"], "", "", ["flag-mh"], 2, 59, 15, 0],
              "1f1f2-1f1f0": [["🇲🇰"], "", "", ["flag-mk"], 3, 0, 15, 0],
              "1f1f2-1f1f1": [["🇲🇱"], "", "", ["flag-ml"], 3, 1, 15, 0],
              "1f1f2-1f1f2": [["🇲🇲"], "", "", ["flag-mm"], 3, 2, 15, 0],
              "1f1f2-1f1f3": [["🇲🇳"], "", "", ["flag-mn"], 3, 3, 15, 0],
              "1f1f2-1f1f4": [["🇲🇴"], "", "", ["flag-mo"], 3, 4, 15, 0],
              "1f1f2-1f1f5": [["🇲🇵"], "", "", ["flag-mp"], 3, 5, 15, 0],
              "1f1f2-1f1f6": [["🇲🇶"], "", "", ["flag-mq"], 3, 6, 15, 0],
              "1f1f2-1f1f7": [["🇲🇷"], "", "", ["flag-mr"], 3, 7, 15, 0],
              "1f1f2-1f1f8": [["🇲🇸"], "", "", ["flag-ms"], 3, 8, 15, 0],
              "1f1f2-1f1f9": [["🇲🇹"], "", "", ["flag-mt"], 3, 9, 15, 0],
              "1f1f2-1f1fa": [["🇲🇺"], "", "", ["flag-mu"], 3, 10, 15, 0],
              "1f1f2-1f1fb": [["🇲🇻"], "", "", ["flag-mv"], 3, 11, 15, 0],
              "1f1f2-1f1fc": [["🇲🇼"], "", "", ["flag-mw"], 3, 12, 15, 0],
              "1f1f2-1f1fd": [["🇲🇽"], "", "", ["flag-mx"], 3, 13, 15, 0],
              "1f1f2-1f1fe": [["🇲🇾"], "", "", ["flag-my"], 3, 14, 15, 0],
              "1f1f2-1f1ff": [["🇲🇿"], "", "", ["flag-mz"], 3, 15, 15, 0],
              "1f1f3-1f1e6": [["🇳🇦"], "", "", ["flag-na"], 3, 16, 15, 0],
              "1f1f3-1f1e8": [["🇳🇨"], "", "", ["flag-nc"], 3, 17, 15, 0],
              "1f1f3-1f1ea": [["🇳🇪"], "", "", ["flag-ne"], 3, 18, 15, 0],
              "1f1f3-1f1eb": [["🇳🇫"], "", "", ["flag-nf"], 3, 19, 15, 0],
              "1f1f3-1f1ec": [["🇳🇬"], "", "", ["flag-ng"], 3, 20, 15, 0],
              "1f1f3-1f1ee": [["🇳🇮"], "", "", ["flag-ni"], 3, 21, 15, 0],
              "1f1f3-1f1f1": [["🇳🇱"], "", "", ["flag-nl"], 3, 22, 15, 0],
              "1f1f3-1f1f4": [["🇳🇴"], "", "", ["flag-no"], 3, 23, 15, 0],
              "1f1f3-1f1f5": [["🇳🇵"], "", "", ["flag-np"], 3, 24, 15, 0],
              "1f1f3-1f1f7": [["🇳🇷"], "", "", ["flag-nr"], 3, 25, 15, 0],
              "1f1f3-1f1fa": [["🇳🇺"], "", "", ["flag-nu"], 3, 26, 15, 0],
              "1f1f3-1f1ff": [["🇳🇿"], "", "", ["flag-nz"], 3, 27, 15, 0],
              "1f1f4-1f1f2": [["🇴🇲"], "", "", ["flag-om"], 3, 28, 15, 0],
              "1f1f5-1f1e6": [["🇵🇦"], "", "", ["flag-pa"], 3, 29, 15, 0],
              "1f1f5-1f1ea": [["🇵🇪"], "", "", ["flag-pe"], 3, 30, 15, 0],
              "1f1f5-1f1eb": [["🇵🇫"], "", "", ["flag-pf"], 3, 31, 15, 0],
              "1f1f5-1f1ec": [["🇵🇬"], "", "", ["flag-pg"], 3, 32, 15, 0],
              "1f1f5-1f1ed": [["🇵🇭"], "", "", ["flag-ph"], 3, 33, 15, 0],
              "1f1f5-1f1f0": [["🇵🇰"], "", "", ["flag-pk"], 3, 34, 15, 0],
              "1f1f5-1f1f1": [["🇵🇱"], "", "", ["flag-pl"], 3, 35, 15, 0],
              "1f1f5-1f1f2": [["🇵🇲"], "", "", ["flag-pm"], 3, 36, 15, 0],
              "1f1f5-1f1f3": [["🇵🇳"], "", "", ["flag-pn"], 3, 37, 15, 0],
              "1f1f5-1f1f7": [["🇵🇷"], "", "", ["flag-pr"], 3, 38, 15, 0],
              "1f1f5-1f1f8": [["🇵🇸"], "", "", ["flag-ps"], 3, 39, 15, 0],
              "1f1f5-1f1f9": [["🇵🇹"], "", "", ["flag-pt"], 3, 40, 15, 0],
              "1f1f5-1f1fc": [["🇵🇼"], "", "", ["flag-pw"], 3, 41, 15, 0],
              "1f1f5-1f1fe": [["🇵🇾"], "", "", ["flag-py"], 3, 42, 15, 0],
              "1f1f6-1f1e6": [["🇶🇦"], "", "", ["flag-qa"], 3, 43, 15, 0],
              "1f1f7-1f1ea": [["🇷🇪"], "", "", ["flag-re"], 3, 44, 15, 0],
              "1f1f7-1f1f4": [["🇷🇴"], "", "", ["flag-ro"], 3, 45, 15, 0],
              "1f1f7-1f1f8": [["🇷🇸"], "", "", ["flag-rs"], 3, 46, 15, 0],
              "1f1f7-1f1fa": [
                ["🇷🇺"],
                "",
                "󾓬",
                ["ru", "flag-ru"],
                3,
                47,
                15,
                0,
              ],
              "1f1f7-1f1fc": [["🇷🇼"], "", "", ["flag-rw"], 3, 48, 15, 0],
              "1f1f8-1f1e6": [["🇸🇦"], "", "", ["flag-sa"], 3, 49, 15, 0],
              "1f1f8-1f1e7": [["🇸🇧"], "", "", ["flag-sb"], 3, 50, 15, 0],
              "1f1f8-1f1e8": [["🇸🇨"], "", "", ["flag-sc"], 3, 51, 15, 0],
              "1f1f8-1f1e9": [["🇸🇩"], "", "", ["flag-sd"], 3, 52, 15, 0],
              "1f1f8-1f1ea": [["🇸🇪"], "", "", ["flag-se"], 3, 53, 15, 0],
              "1f1f8-1f1ec": [["🇸🇬"], "", "", ["flag-sg"], 3, 54, 15, 0],
              "1f1f8-1f1ed": [["🇸🇭"], "", "", ["flag-sh"], 3, 55, 15, 0],
              "1f1f8-1f1ee": [["🇸🇮"], "", "", ["flag-si"], 3, 56, 15, 0],
              "1f1f8-1f1ef": [["🇸🇯"], "", "", ["flag-sj"], 3, 57, 15, 0],
              "1f1f8-1f1f0": [["🇸🇰"], "", "", ["flag-sk"], 3, 58, 15, 0],
              "1f1f8-1f1f1": [["🇸🇱"], "", "", ["flag-sl"], 3, 59, 15, 0],
              "1f1f8-1f1f2": [["🇸🇲"], "", "", ["flag-sm"], 4, 0, 15, 0],
              "1f1f8-1f1f3": [["🇸🇳"], "", "", ["flag-sn"], 4, 1, 15, 0],
              "1f1f8-1f1f4": [["🇸🇴"], "", "", ["flag-so"], 4, 2, 15, 0],
              "1f1f8-1f1f7": [["🇸🇷"], "", "", ["flag-sr"], 4, 3, 15, 0],
              "1f1f8-1f1f8": [["🇸🇸"], "", "", ["flag-ss"], 4, 4, 15, 0],
              "1f1f8-1f1f9": [["🇸🇹"], "", "", ["flag-st"], 4, 5, 15, 0],
              "1f1f8-1f1fb": [["🇸🇻"], "", "", ["flag-sv"], 4, 6, 15, 0],
              "1f1f8-1f1fd": [["🇸🇽"], "", "", ["flag-sx"], 4, 7, 15, 0],
              "1f1f8-1f1fe": [["🇸🇾"], "", "", ["flag-sy"], 4, 8, 15, 0],
              "1f1f8-1f1ff": [["🇸🇿"], "", "", ["flag-sz"], 4, 9, 15, 0],
              "1f1f9-1f1e6": [["🇹🇦"], "", "", ["flag-ta"], 4, 10, 15, 0],
              "1f1f9-1f1e8": [["🇹🇨"], "", "", ["flag-tc"], 4, 11, 15, 0],
              "1f1f9-1f1e9": [["🇹🇩"], "", "", ["flag-td"], 4, 12, 15, 0],
              "1f1f9-1f1eb": [["🇹🇫"], "", "", ["flag-tf"], 4, 13, 15, 0],
              "1f1f9-1f1ec": [["🇹🇬"], "", "", ["flag-tg"], 4, 14, 15, 0],
              "1f1f9-1f1ed": [["🇹🇭"], "", "", ["flag-th"], 4, 15, 15, 0],
              "1f1f9-1f1ef": [["🇹🇯"], "", "", ["flag-tj"], 4, 16, 15, 0],
              "1f1f9-1f1f0": [["🇹🇰"], "", "", ["flag-tk"], 4, 17, 15, 0],
              "1f1f9-1f1f1": [["🇹🇱"], "", "", ["flag-tl"], 4, 18, 15, 0],
              "1f1f9-1f1f2": [["🇹🇲"], "", "", ["flag-tm"], 4, 19, 15, 0],
              "1f1f9-1f1f3": [["🇹🇳"], "", "", ["flag-tn"], 4, 20, 15, 0],
              "1f1f9-1f1f4": [["🇹🇴"], "", "", ["flag-to"], 4, 21, 15, 0],
              "1f1f9-1f1f7": [["🇹🇷"], "", "", ["flag-tr"], 4, 22, 15, 0],
              "1f1f9-1f1f9": [["🇹🇹"], "", "", ["flag-tt"], 4, 23, 15, 0],
              "1f1f9-1f1fb": [["🇹🇻"], "", "", ["flag-tv"], 4, 24, 15, 0],
              "1f1f9-1f1fc": [["🇹🇼"], "", "", ["flag-tw"], 4, 25, 15, 0],
              "1f1f9-1f1ff": [["🇹🇿"], "", "", ["flag-tz"], 4, 26, 15, 0],
              "1f1fa-1f1e6": [["🇺🇦"], "", "", ["flag-ua"], 4, 27, 15, 0],
              "1f1fa-1f1ec": [["🇺🇬"], "", "", ["flag-ug"], 4, 28, 15, 0],
              "1f1fa-1f1f2": [["🇺🇲"], "", "", ["flag-um"], 4, 29, 15, 0],
              "1f1fa-1f1f3": [["🇺🇳"], "", "", ["flag-un"], 4, 30, 15, 0],
              "1f1fa-1f1f8": [
                ["🇺🇸"],
                "",
                "󾓦",
                ["us", "flag-us"],
                4,
                31,
                15,
                0,
              ],
              "1f1fa-1f1fe": [["🇺🇾"], "", "", ["flag-uy"], 4, 32, 15, 0],
              "1f1fa-1f1ff": [["🇺🇿"], "", "", ["flag-uz"], 4, 33, 15, 0],
              "1f1fb-1f1e6": [["🇻🇦"], "", "", ["flag-va"], 4, 34, 15, 0],
              "1f1fb-1f1e8": [["🇻🇨"], "", "", ["flag-vc"], 4, 35, 15, 0],
              "1f1fb-1f1ea": [["🇻🇪"], "", "", ["flag-ve"], 4, 36, 15, 0],
              "1f1fb-1f1ec": [["🇻🇬"], "", "", ["flag-vg"], 4, 37, 15, 0],
              "1f1fb-1f1ee": [["🇻🇮"], "", "", ["flag-vi"], 4, 38, 15, 0],
              "1f1fb-1f1f3": [["🇻🇳"], "", "", ["flag-vn"], 4, 39, 15, 0],
              "1f1fb-1f1fa": [["🇻🇺"], "", "", ["flag-vu"], 4, 40, 15, 0],
              "1f1fc-1f1eb": [["🇼🇫"], "", "", ["flag-wf"], 4, 41, 15, 0],
              "1f1fc-1f1f8": [["🇼🇸"], "", "", ["flag-ws"], 4, 42, 15, 0],
              "1f1fd-1f1f0": [["🇽🇰"], "", "", ["flag-xk"], 4, 43, 15, 0],
              "1f1fe-1f1ea": [["🇾🇪"], "", "", ["flag-ye"], 4, 44, 15, 0],
              "1f1fe-1f1f9": [["🇾🇹"], "", "", ["flag-yt"], 4, 45, 15, 0],
              "1f1ff-1f1e6": [["🇿🇦"], "", "", ["flag-za"], 4, 46, 15, 0],
              "1f1ff-1f1f2": [["🇿🇲"], "", "", ["flag-zm"], 4, 47, 15, 0],
              "1f1ff-1f1fc": [["🇿🇼"], "", "", ["flag-zw"], 4, 48, 15, 0],
              "1f201": [["🈁"], "", "󾬤", ["koko"], 4, 49, 15, 0],
              "1f202-fe0f": [["🈂️", "🈂"], "", "󾬿", ["sa"], 4, 50, 15, 0],
              "1f21a": [["🈚"], "", "󾬺", ["u7121"], 4, 51, 15, 0],
              "1f22f": [["🈯"], "", "󾭀", ["u6307"], 4, 52, 15, 0],
              "1f232": [["🈲"], "", "󾬮", ["u7981"], 4, 53, 15, 0],
              "1f233": [["🈳"], "", "󾬯", ["u7a7a"], 4, 54, 15, 0],
              "1f234": [["🈴"], "", "󾬰", ["u5408"], 4, 55, 15, 0],
              "1f235": [["🈵"], "", "󾬱", ["u6e80"], 4, 56, 15, 0],
              "1f236": [["🈶"], "", "󾬹", ["u6709"], 4, 57, 15, 0],
              "1f237-fe0f": [["🈷️", "🈷"], "", "󾬻", ["u6708"], 4, 58, 15, 0],
              "1f238": [["🈸"], "", "󾬼", ["u7533"], 4, 59, 15, 0],
              "1f239": [["🈹"], "", "󾬾", ["u5272"], 5, 0, 15, 0],
              "1f23a": [["🈺"], "", "󾭁", ["u55b6"], 5, 1, 15, 0],
              "1f250": [["🉐"], "", "󾬽", ["ideograph_advantage"], 5, 2, 15, 0],
              "1f251": [["🉑"], "", "󾭐", ["accept"], 5, 3, 15, 0],
              "1f300": [["🌀"], "", "󾀅", ["cyclone"], 5, 4, 15, 0],
              "1f301": [["🌁"], "", "󾀆", ["foggy"], 5, 5, 15, 0],
              "1f302": [["🌂"], "", "󾀇", ["closed_umbrella"], 5, 6, 15, 0],
              "1f303": [["🌃"], "", "󾀈", ["night_with_stars"], 5, 7, 15, 0],
              "1f304": [
                ["🌄"],
                "",
                "󾀉",
                ["sunrise_over_mountains"],
                5,
                8,
                15,
                0,
              ],
              "1f305": [["🌅"], "", "󾀊", ["sunrise"], 5, 9, 15, 0],
              "1f306": [["🌆"], "", "󾀋", ["city_sunset"], 5, 10, 15, 0],
              "1f307": [["🌇"], "", "󾀌", ["city_sunrise"], 5, 11, 15, 0],
              "1f308": [["🌈"], "", "󾀍", ["rainbow"], 5, 12, 15, 0],
              "1f309": [["🌉"], "", "󾀐", ["bridge_at_night"], 5, 13, 15, 0],
              "1f30a": [["🌊"], "", "󾀸", ["ocean"], 5, 14, 15, 0],
              "1f30b": [["🌋"], "", "󾀺", ["volcano"], 5, 15, 15, 0],
              "1f30c": [["🌌"], "", "󾀻", ["milky_way"], 5, 16, 15, 0],
              "1f30d": [["🌍"], "", "", ["earth_africa"], 5, 17, 15, 0],
              "1f30e": [["🌎"], "", "", ["earth_americas"], 5, 18, 15, 0],
              "1f30f": [["🌏"], "", "󾀹", ["earth_asia"], 5, 19, 15, 0],
              "1f310": [["🌐"], "", "", ["globe_with_meridians"], 5, 20, 15, 0],
              "1f311": [["🌑"], "", "󾀑", ["new_moon"], 5, 21, 15, 0],
              "1f312": [["🌒"], "", "", ["waxing_crescent_moon"], 5, 22, 15, 0],
              "1f313": [["🌓"], "", "󾀓", ["first_quarter_moon"], 5, 23, 15, 0],
              "1f314": [
                ["🌔"],
                "",
                "󾀒",
                ["moon", "waxing_gibbous_moon"],
                5,
                24,
                15,
                0,
              ],
              "1f315": [["🌕"], "", "󾀕", ["full_moon"], 5, 25, 15, 0],
              "1f316": [["🌖"], "", "", ["waning_gibbous_moon"], 5, 26, 15, 0],
              "1f317": [["🌗"], "", "", ["last_quarter_moon"], 5, 27, 15, 0],
              "1f318": [["🌘"], "", "", ["waning_crescent_moon"], 5, 28, 15, 0],
              "1f319": [["🌙"], "", "󾀔", ["crescent_moon"], 5, 29, 15, 0],
              "1f31a": [["🌚"], "", "", ["new_moon_with_face"], 5, 30, 15, 0],
              "1f31b": [
                ["🌛"],
                "",
                "󾀖",
                ["first_quarter_moon_with_face"],
                5,
                31,
                15,
                0,
              ],
              "1f31c": [
                ["🌜"],
                "",
                "",
                ["last_quarter_moon_with_face"],
                5,
                32,
                15,
                0,
              ],
              "1f31d": [["🌝"], "", "", ["full_moon_with_face"], 5, 33, 15, 0],
              "1f31e": [["🌞"], "", "", ["sun_with_face"], 5, 34, 15, 0],
              "1f31f": [["🌟"], "", "󾭩", ["star2"], 5, 35, 15, 0],
              "1f320": [["🌠"], "", "󾭪", ["stars"], 5, 36, 15, 0],
              "1f321-fe0f": [
                ["🌡️", "🌡"],
                "",
                "",
                ["thermometer"],
                5,
                37,
                15,
                0,
              ],
              "1f324-fe0f": [
                ["🌤️", "🌤"],
                "",
                "",
                ["mostly_sunny", "sun_small_cloud"],
                5,
                38,
                15,
                0,
              ],
              "1f325-fe0f": [
                ["🌥️", "🌥"],
                "",
                "",
                ["barely_sunny", "sun_behind_cloud"],
                5,
                39,
                15,
                0,
              ],
              "1f326-fe0f": [
                ["🌦️", "🌦"],
                "",
                "",
                ["partly_sunny_rain", "sun_behind_rain_cloud"],
                5,
                40,
                15,
                0,
              ],
              "1f327-fe0f": [["🌧️", "🌧"], "", "", ["rain_cloud"], 5, 41, 15, 0],
              "1f328-fe0f": [["🌨️", "🌨"], "", "", ["snow_cloud"], 5, 42, 15, 0],
              "1f329-fe0f": [
                ["🌩️", "🌩"],
                "",
                "",
                ["lightning", "lightning_cloud"],
                5,
                43,
                15,
                0,
              ],
              "1f32a-fe0f": [
                ["🌪️", "🌪"],
                "",
                "",
                ["tornado", "tornado_cloud"],
                5,
                44,
                15,
                0,
              ],
              "1f32b-fe0f": [["🌫️", "🌫"], "", "", ["fog"], 5, 45, 15, 0],
              "1f32c-fe0f": [
                ["🌬️", "🌬"],
                "",
                "",
                ["wind_blowing_face"],
                5,
                46,
                15,
                0,
              ],
              "1f32d": [["🌭"], "", "", ["hotdog"], 5, 47, 15, 0],
              "1f32e": [["🌮"], "", "", ["taco"], 5, 48, 15, 0],
              "1f32f": [["🌯"], "", "", ["burrito"], 5, 49, 15, 0],
              "1f330": [["🌰"], "", "󾁌", ["chestnut"], 5, 50, 15, 0],
              "1f331": [["🌱"], "", "󾀾", ["seedling"], 5, 51, 15, 0],
              "1f332": [["🌲"], "", "", ["evergreen_tree"], 5, 52, 15, 0],
              "1f333": [["🌳"], "", "", ["deciduous_tree"], 5, 53, 15, 0],
              "1f334": [["🌴"], "", "󾁇", ["palm_tree"], 5, 54, 15, 0],
              "1f335": [["🌵"], "", "󾁈", ["cactus"], 5, 55, 15, 0],
              "1f336-fe0f": [["🌶️", "🌶"], "", "", ["hot_pepper"], 5, 56, 15, 0],
              "1f337": [["🌷"], "", "󾀽", ["tulip"], 5, 57, 15, 0],
              "1f338": [["🌸"], "", "󾁀", ["cherry_blossom"], 5, 58, 15, 0],
              "1f339": [["🌹"], "", "󾁁", ["rose"], 5, 59, 15, 0],
              "1f33a": [["🌺"], "", "󾁅", ["hibiscus"], 6, 0, 15, 0],
              "1f33b": [["🌻"], "", "󾁆", ["sunflower"], 6, 1, 15, 0],
              "1f33c": [["🌼"], "", "󾁍", ["blossom"], 6, 2, 15, 0],
              "1f33d": [["🌽"], "", "󾁊", ["corn"], 6, 3, 15, 0],
              "1f33e": [["🌾"], "", "󾁉", ["ear_of_rice"], 6, 4, 15, 0],
              "1f33f": [["🌿"], "", "󾁎", ["herb"], 6, 5, 15, 0],
              "1f340": [["🍀"], "", "󾀼", ["four_leaf_clover"], 6, 6, 15, 0],
              "1f341": [["🍁"], "", "󾀿", ["maple_leaf"], 6, 7, 15, 0],
              "1f342": [["🍂"], "", "󾁂", ["fallen_leaf"], 6, 8, 15, 0],
              "1f343": [["🍃"], "", "󾁃", ["leaves"], 6, 9, 15, 0],
              "1f344": [["🍄"], "", "󾁋", ["mushroom"], 6, 10, 15, 0],
              "1f345": [["🍅"], "", "󾁕", ["tomato"], 6, 11, 15, 0],
              "1f346": [["🍆"], "", "󾁖", ["eggplant"], 6, 12, 15, 0],
              "1f347": [["🍇"], "", "󾁙", ["grapes"], 6, 13, 15, 0],
              "1f348": [["🍈"], "", "󾁗", ["melon"], 6, 14, 15, 0],
              "1f349": [["🍉"], "", "󾁔", ["watermelon"], 6, 15, 15, 0],
              "1f34a": [["🍊"], "", "󾁒", ["tangerine"], 6, 16, 15, 0],
              "1f34b": [["🍋"], "", "", ["lemon"], 6, 17, 15, 0],
              "1f34c": [["🍌"], "", "󾁐", ["banana"], 6, 18, 15, 0],
              "1f34d": [["🍍"], "", "󾁘", ["pineapple"], 6, 19, 15, 0],
              "1f34e": [["🍎"], "", "󾁑", ["apple"], 6, 20, 15, 0],
              "1f34f": [["🍏"], "", "󾁛", ["green_apple"], 6, 21, 15, 0],
              "1f350": [["🍐"], "", "", ["pear"], 6, 22, 15, 0],
              "1f351": [["🍑"], "", "󾁚", ["peach"], 6, 23, 15, 0],
              "1f352": [["🍒"], "", "󾁏", ["cherries"], 6, 24, 15, 0],
              "1f353": [["🍓"], "", "󾁓", ["strawberry"], 6, 25, 15, 0],
              "1f354": [["🍔"], "", "󾥠", ["hamburger"], 6, 26, 15, 0],
              "1f355": [["🍕"], "", "󾥵", ["pizza"], 6, 27, 15, 0],
              "1f356": [["🍖"], "", "󾥲", ["meat_on_bone"], 6, 28, 15, 0],
              "1f357": [["🍗"], "", "󾥶", ["poultry_leg"], 6, 29, 15, 0],
              "1f358": [["🍘"], "", "󾥩", ["rice_cracker"], 6, 30, 15, 0],
              "1f359": [["🍙"], "", "󾥡", ["rice_ball"], 6, 31, 15, 0],
              "1f35a": [["🍚"], "", "󾥪", ["rice"], 6, 32, 15, 0],
              "1f35b": [["🍛"], "", "󾥬", ["curry"], 6, 33, 15, 0],
              "1f35c": [["🍜"], "", "󾥣", ["ramen"], 6, 34, 15, 0],
              "1f35d": [["🍝"], "", "󾥫", ["spaghetti"], 6, 35, 15, 0],
              "1f35e": [["🍞"], "", "󾥤", ["bread"], 6, 36, 15, 0],
              "1f35f": [["🍟"], "", "󾥧", ["fries"], 6, 37, 15, 0],
              "1f360": [["🍠"], "", "󾥴", ["sweet_potato"], 6, 38, 15, 0],
              "1f361": [["🍡"], "", "󾥨", ["dango"], 6, 39, 15, 0],
              "1f362": [["🍢"], "", "󾥭", ["oden"], 6, 40, 15, 0],
              "1f363": [["🍣"], "", "󾥮", ["sushi"], 6, 41, 15, 0],
              "1f364": [["🍤"], "", "󾥿", ["fried_shrimp"], 6, 42, 15, 0],
              "1f365": [["🍥"], "", "󾥳", ["fish_cake"], 6, 43, 15, 0],
              "1f366": [["🍦"], "", "󾥦", ["icecream"], 6, 44, 15, 0],
              "1f367": [["🍧"], "", "󾥱", ["shaved_ice"], 6, 45, 15, 0],
              "1f368": [["🍨"], "", "󾥷", ["ice_cream"], 6, 46, 15, 0],
              "1f369": [["🍩"], "", "󾥸", ["doughnut"], 6, 47, 15, 0],
              "1f36a": [["🍪"], "", "󾥹", ["cookie"], 6, 48, 15, 0],
              "1f36b": [["🍫"], "", "󾥺", ["chocolate_bar"], 6, 49, 15, 0],
              "1f36c": [["🍬"], "", "󾥻", ["candy"], 6, 50, 15, 0],
              "1f36d": [["🍭"], "", "󾥼", ["lollipop"], 6, 51, 15, 0],
              "1f36e": [["🍮"], "", "󾥽", ["custard"], 6, 52, 15, 0],
              "1f36f": [["🍯"], "", "󾥾", ["honey_pot"], 6, 53, 15, 0],
              "1f370": [["🍰"], "", "󾥢", ["cake"], 6, 54, 15, 0],
              "1f371": [["🍱"], "", "󾥯", ["bento"], 6, 55, 15, 0],
              "1f372": [["🍲"], "", "󾥰", ["stew"], 6, 56, 15, 0],
              "1f373": [
                ["🍳"],
                "",
                "󾥥",
                ["fried_egg", "cooking"],
                6,
                57,
                15,
                0,
              ],
              "1f374": [["🍴"], "", "󾦀", ["fork_and_knife"], 6, 58, 15, 0],
              "1f375": [["🍵"], "", "󾦄", ["tea"], 6, 59, 15, 0],
              "1f376": [["🍶"], "", "󾦅", ["sake"], 7, 0, 15, 0],
              "1f377": [["🍷"], "", "󾦆", ["wine_glass"], 7, 1, 15, 0],
              "1f378": [["🍸"], "", "󾦂", ["cocktail"], 7, 2, 15, 0],
              "1f379": [["🍹"], "", "󾦈", ["tropical_drink"], 7, 3, 15, 0],
              "1f37a": [["🍺"], "", "󾦃", ["beer"], 7, 4, 15, 0],
              "1f37b": [["🍻"], "", "󾦇", ["beers"], 7, 5, 15, 0],
              "1f37c": [["🍼"], "", "", ["baby_bottle"], 7, 6, 15, 0],
              "1f37d-fe0f": [
                ["🍽️", "🍽"],
                "",
                "",
                ["knife_fork_plate"],
                7,
                7,
                15,
                0,
              ],
              "1f37e": [["🍾"], "", "", ["champagne"], 7, 8, 15, 0],
              "1f37f": [["🍿"], "", "", ["popcorn"], 7, 9, 15, 0],
              "1f380": [["🎀"], "", "󾔏", ["ribbon"], 7, 10, 15, 0],
              "1f381": [["🎁"], "", "󾔐", ["gift"], 7, 11, 15, 0],
              "1f382": [["🎂"], "", "󾔑", ["birthday"], 7, 12, 15, 0],
              "1f383": [["🎃"], "", "󾔟", ["jack_o_lantern"], 7, 13, 15, 0],
              "1f384": [["🎄"], "", "󾔒", ["christmas_tree"], 7, 14, 15, 0],
              "1f385": [["🎅"], "", "󾔓", ["santa"], 7, 15, 15, 0],
              "1f386": [["🎆"], "", "󾔕", ["fireworks"], 7, 21, 15, 0],
              "1f387": [["🎇"], "", "󾔝", ["sparkler"], 7, 22, 15, 0],
              "1f388": [["🎈"], "", "󾔖", ["balloon"], 7, 23, 15, 0],
              "1f389": [["🎉"], "", "󾔗", ["tada"], 7, 24, 15, 0],
              "1f38a": [["🎊"], "", "󾔠", ["confetti_ball"], 7, 25, 15, 0],
              "1f38b": [["🎋"], "", "󾔡", ["tanabata_tree"], 7, 26, 15, 0],
              "1f38c": [["🎌"], "", "󾔔", ["crossed_flags"], 7, 27, 15, 0],
              "1f38d": [["🎍"], "", "󾔘", ["bamboo"], 7, 28, 15, 0],
              "1f38e": [["🎎"], "", "󾔙", ["dolls"], 7, 29, 15, 0],
              "1f38f": [["🎏"], "", "󾔜", ["flags"], 7, 30, 15, 0],
              "1f390": [["🎐"], "", "󾔞", ["wind_chime"], 7, 31, 15, 0],
              "1f391": [["🎑"], "", "󾀗", ["rice_scene"], 7, 32, 15, 0],
              "1f392": [["🎒"], "", "󾔛", ["school_satchel"], 7, 33, 15, 0],
              "1f393": [["🎓"], "", "󾔚", ["mortar_board"], 7, 34, 15, 0],
              "1f396-fe0f": [["🎖️", "🎖"], "", "", ["medal"], 7, 35, 15, 0],
              "1f397-fe0f": [
                ["🎗️", "🎗"],
                "",
                "",
                ["reminder_ribbon"],
                7,
                36,
                15,
                0,
              ],
              "1f399-fe0f": [
                ["🎙️", "🎙"],
                "",
                "",
                ["studio_microphone"],
                7,
                37,
                15,
                0,
              ],
              "1f39a-fe0f": [
                ["🎚️", "🎚"],
                "",
                "",
                ["level_slider"],
                7,
                38,
                15,
                0,
              ],
              "1f39b-fe0f": [
                ["🎛️", "🎛"],
                "",
                "",
                ["control_knobs"],
                7,
                39,
                15,
                0,
              ],
              "1f39e-fe0f": [
                ["🎞️", "🎞"],
                "",
                "",
                ["film_frames"],
                7,
                40,
                15,
                0,
              ],
              "1f39f-fe0f": [
                ["🎟️", "🎟"],
                "",
                "",
                ["admission_tickets"],
                7,
                41,
                15,
                0,
              ],
              "1f3a0": [["🎠"], "", "󾟼", ["carousel_horse"], 7, 42, 15, 0],
              "1f3a1": [["🎡"], "", "󾟽", ["ferris_wheel"], 7, 43, 15, 0],
              "1f3a2": [["🎢"], "", "󾟾", ["roller_coaster"], 7, 44, 15, 0],
              "1f3a3": [
                ["🎣"],
                "",
                "󾟿",
                ["fishing_pole_and_fish"],
                7,
                45,
                15,
                0,
              ],
              "1f3a4": [["🎤"], "", "󾠀", ["microphone"], 7, 46, 15, 0],
              "1f3a5": [["🎥"], "", "󾠁", ["movie_camera"], 7, 47, 15, 0],
              "1f3a6": [["🎦"], "", "󾠂", ["cinema"], 7, 48, 15, 0],
              "1f3a7": [["🎧"], "", "󾠃", ["headphones"], 7, 49, 15, 0],
              "1f3a8": [["🎨"], "", "󾠄", ["art"], 7, 50, 15, 0],
              "1f3a9": [["🎩"], "", "󾠅", ["tophat"], 7, 51, 15, 0],
              "1f3aa": [["🎪"], "", "󾠆", ["circus_tent"], 7, 52, 15, 0],
              "1f3ab": [["🎫"], "", "󾠇", ["ticket"], 7, 53, 15, 0],
              "1f3ac": [["🎬"], "", "󾠈", ["clapper"], 7, 54, 15, 0],
              "1f3ad": [["🎭"], "", "󾠉", ["performing_arts"], 7, 55, 15, 0],
              "1f3ae": [["🎮"], "", "󾠊", ["video_game"], 7, 56, 15, 0],
              "1f3af": [["🎯"], "", "󾠌", ["dart"], 7, 57, 15, 0],
              "1f3b0": [["🎰"], "", "󾠍", ["slot_machine"], 7, 58, 15, 0],
              "1f3b1": [["🎱"], "", "󾠎", ["8ball"], 7, 59, 15, 0],
              "1f3b2": [["🎲"], "", "󾠏", ["game_die"], 8, 0, 15, 0],
              "1f3b3": [["🎳"], "", "󾠐", ["bowling"], 8, 1, 15, 0],
              "1f3b4": [["🎴"], "", "󾠑", ["flower_playing_cards"], 8, 2, 15, 0],
              "1f3b5": [["🎵"], "", "󾠓", ["musical_note"], 8, 3, 15, 0],
              "1f3b6": [["🎶"], "", "󾠔", ["notes"], 8, 4, 15, 0],
              "1f3b7": [["🎷"], "", "󾠕", ["saxophone"], 8, 5, 15, 0],
              "1f3b8": [["🎸"], "", "󾠖", ["guitar"], 8, 6, 15, 0],
              "1f3b9": [["🎹"], "", "󾠗", ["musical_keyboard"], 8, 7, 15, 0],
              "1f3ba": [["🎺"], "", "󾠘", ["trumpet"], 8, 8, 15, 0],
              "1f3bb": [["🎻"], "", "󾠙", ["violin"], 8, 9, 15, 0],
              "1f3bc": [["🎼"], "", "󾠚", ["musical_score"], 8, 10, 15, 0],
              "1f3bd": [
                ["🎽"],
                "",
                "󾟐",
                ["running_shirt_with_sash"],
                8,
                11,
                15,
                0,
              ],
              "1f3be": [["🎾"], "", "󾟓", ["tennis"], 8, 12, 15, 0],
              "1f3bf": [["🎿"], "", "󾟕", ["ski"], 8, 13, 15, 0],
              "1f3c0": [["🏀"], "", "󾟖", ["basketball"], 8, 14, 15, 0],
              "1f3c1": [["🏁"], "", "󾟗", ["checkered_flag"], 8, 15, 15, 0],
              "1f3c2": [["🏂"], "", "󾟘", ["snowboarder"], 8, 16, 15, 0],
              "1f3c3-200d-2640-fe0f": [
                ["🏃‍♀️", "🏃‍♀"],
                "",
                "",
                ["woman-running"],
                8,
                22,
                15,
                0,
              ],
              "1f3c3-200d-2642-fe0f": [
                ["🏃‍♂️", "🏃‍♂", "🏃"],
                "",
                "",
                ["man-running", "runner", "running"],
                8,
                28,
                15,
                0,
              ],
              "1f3c4-200d-2640-fe0f": [
                ["🏄‍♀️", "🏄‍♀"],
                "",
                "",
                ["woman-surfing"],
                8,
                40,
                15,
                0,
              ],
              "1f3c4-200d-2642-fe0f": [
                ["🏄‍♂️", "🏄‍♂", "🏄"],
                "",
                "",
                ["man-surfing", "surfer"],
                8,
                46,
                15,
                0,
              ],
              "1f3c5": [["🏅"], "", "", ["sports_medal"], 8, 58, 15, 0],
              "1f3c6": [["🏆"], "", "󾟛", ["trophy"], 8, 59, 15, 0],
              "1f3c7": [["🏇"], "", "", ["horse_racing"], 9, 0, 15, 0],
              "1f3c8": [["🏈"], "", "󾟝", ["football"], 9, 6, 15, 0],
              "1f3c9": [["🏉"], "", "", ["rugby_football"], 9, 7, 15, 0],
              "1f3ca-200d-2640-fe0f": [
                ["🏊‍♀️", "🏊‍♀"],
                "",
                "",
                ["woman-swimming"],
                9,
                8,
                15,
                0,
              ],
              "1f3ca-200d-2642-fe0f": [
                ["🏊‍♂️", "🏊‍♂", "🏊"],
                "",
                "",
                ["man-swimming", "swimmer"],
                9,
                14,
                15,
                0,
              ],
              "1f3cb-fe0f-200d-2640-fe0f": [
                ["🏋️‍♀️"],
                "",
                "",
                ["woman-lifting-weights"],
                9,
                26,
                7,
                0,
              ],
              "1f3cb-fe0f-200d-2642-fe0f": [
                ["🏋️‍♂️", "🏋️", "🏋"],
                "",
                "",
                ["man-lifting-weights", "weight_lifter"],
                9,
                32,
                7,
                0,
              ],
              "1f3cc-fe0f-200d-2640-fe0f": [
                ["🏌️‍♀️"],
                "",
                "",
                ["woman-golfing"],
                9,
                44,
                7,
                0,
              ],
              "1f3cc-fe0f-200d-2642-fe0f": [
                ["🏌️‍♂️", "🏌️", "🏌"],
                "",
                "",
                ["man-golfing", "golfer"],
                9,
                50,
                7,
                0,
              ],
              "1f3cd-fe0f": [
                ["🏍️", "🏍"],
                "",
                "",
                ["racing_motorcycle"],
                10,
                2,
                15,
                0,
              ],
              "1f3ce-fe0f": [["🏎️", "🏎"], "", "", ["racing_car"], 10, 3, 15, 0],
              "1f3cf": [["🏏"], "", "", ["cricket_bat_and_ball"], 10, 4, 15, 0],
              "1f3d0": [["🏐"], "", "", ["volleyball"], 10, 5, 15, 0],
              "1f3d1": [
                ["🏑"],
                "",
                "",
                ["field_hockey_stick_and_ball"],
                10,
                6,
                15,
                0,
              ],
              "1f3d2": [
                ["🏒"],
                "",
                "",
                ["ice_hockey_stick_and_puck"],
                10,
                7,
                15,
                0,
              ],
              "1f3d3": [
                ["🏓"],
                "",
                "",
                ["table_tennis_paddle_and_ball"],
                10,
                8,
                15,
                0,
              ],
              "1f3d4-fe0f": [
                ["🏔️", "🏔"],
                "",
                "",
                ["snow_capped_mountain"],
                10,
                9,
                15,
                0,
              ],
              "1f3d5-fe0f": [["🏕️", "🏕"], "", "", ["camping"], 10, 10, 15, 0],
              "1f3d6-fe0f": [
                ["🏖️", "🏖"],
                "",
                "",
                ["beach_with_umbrella"],
                10,
                11,
                15,
                0,
              ],
              "1f3d7-fe0f": [
                ["🏗️", "🏗"],
                "",
                "",
                ["building_construction"],
                10,
                12,
                15,
                0,
              ],
              "1f3d8-fe0f": [
                ["🏘️", "🏘"],
                "",
                "",
                ["house_buildings"],
                10,
                13,
                15,
                0,
              ],
              "1f3d9-fe0f": [["🏙️", "🏙"], "", "", ["cityscape"], 10, 14, 15, 0],
              "1f3da-fe0f": [
                ["🏚️", "🏚"],
                "",
                "",
                ["derelict_house_building"],
                10,
                15,
                15,
                0,
              ],
              "1f3db-fe0f": [
                ["🏛️", "🏛"],
                "",
                "",
                ["classical_building"],
                10,
                16,
                15,
                0,
              ],
              "1f3dc-fe0f": [["🏜️", "🏜"], "", "", ["desert"], 10, 17, 15, 0],
              "1f3dd-fe0f": [
                ["🏝️", "🏝"],
                "",
                "",
                ["desert_island"],
                10,
                18,
                15,
                0,
              ],
              "1f3de-fe0f": [
                ["🏞️", "🏞"],
                "",
                "",
                ["national_park"],
                10,
                19,
                15,
                0,
              ],
              "1f3df-fe0f": [["🏟️", "🏟"], "", "", ["stadium"], 10, 20, 15, 0],
              "1f3e0": [["🏠"], "", "󾒰", ["house"], 10, 21, 15, 0],
              "1f3e1": [["🏡"], "", "󾒱", ["house_with_garden"], 10, 22, 15, 0],
              "1f3e2": [["🏢"], "", "󾒲", ["office"], 10, 23, 15, 0],
              "1f3e3": [["🏣"], "", "󾒳", ["post_office"], 10, 24, 15, 0],
              "1f3e4": [
                ["🏤"],
                "",
                "",
                ["european_post_office"],
                10,
                25,
                15,
                0,
              ],
              "1f3e5": [["🏥"], "", "󾒴", ["hospital"], 10, 26, 15, 0],
              "1f3e6": [["🏦"], "", "󾒵", ["bank"], 10, 27, 15, 0],
              "1f3e7": [["🏧"], "", "󾒶", ["atm"], 10, 28, 15, 0],
              "1f3e8": [["🏨"], "", "󾒷", ["hotel"], 10, 29, 15, 0],
              "1f3e9": [["🏩"], "", "󾒸", ["love_hotel"], 10, 30, 15, 0],
              "1f3ea": [["🏪"], "", "󾒹", ["convenience_store"], 10, 31, 15, 0],
              "1f3eb": [["🏫"], "", "󾒺", ["school"], 10, 32, 15, 0],
              "1f3ec": [["🏬"], "", "󾒽", ["department_store"], 10, 33, 15, 0],
              "1f3ed": [["🏭"], "", "󾓀", ["factory"], 10, 34, 15, 0],
              "1f3ee": [
                ["🏮"],
                "",
                "󾓂",
                ["izakaya_lantern", "lantern"],
                10,
                35,
                15,
                0,
              ],
              "1f3ef": [["🏯"], "", "󾒾", ["japanese_castle"], 10, 36, 15, 0],
              "1f3f0": [["🏰"], "", "󾒿", ["european_castle"], 10, 37, 15, 0],
              "1f3f3-fe0f-200d-1f308": [
                ["🏳️‍🌈", "🏳‍🌈"],
                "",
                "",
                ["rainbow-flag"],
                10,
                38,
                15,
                0,
              ],
              "1f3f3-fe0f-200d-26a7-fe0f": [
                ["🏳️‍⚧️"],
                "",
                "",
                ["transgender_flag"],
                10,
                39,
                7,
                0,
              ],
              "1f3f3-fe0f": [
                ["🏳️", "🏳"],
                "",
                "",
                ["waving_white_flag"],
                10,
                40,
                15,
                0,
              ],
              "1f3f4-200d-2620-fe0f": [
                ["🏴‍☠️", "🏴‍☠"],
                "",
                "",
                ["pirate_flag"],
                10,
                41,
                15,
                0,
              ],
              "1f3f4-e0067-e0062-e0065-e006e-e0067-e007f": [
                ["🏴󠁧󠁢󠁥󠁮󠁧󠁿"],
                "",
                "",
                ["flag-england"],
                10,
                42,
                15,
                0,
              ],
              "1f3f4-e0067-e0062-e0073-e0063-e0074-e007f": [
                ["🏴󠁧󠁢󠁳󠁣󠁴󠁿"],
                "",
                "",
                ["flag-scotland"],
                10,
                43,
                15,
                0,
              ],
              "1f3f4-e0067-e0062-e0077-e006c-e0073-e007f": [
                ["🏴󠁧󠁢󠁷󠁬󠁳󠁿"],
                "",
                "",
                ["flag-wales"],
                10,
                44,
                15,
                0,
              ],
              "1f3f4": [["🏴"], "", "", ["waving_black_flag"], 10, 45, 15, 0],
              "1f3f5-fe0f": [["🏵️", "🏵"], "", "", ["rosette"], 10, 46, 15, 0],
              "1f3f7-fe0f": [["🏷️", "🏷"], "", "", ["label"], 10, 47, 15, 0],
              "1f3f8": [
                ["🏸"],
                "",
                "",
                ["badminton_racquet_and_shuttlecock"],
                10,
                48,
                15,
                0,
              ],
              "1f3f9": [["🏹"], "", "", ["bow_and_arrow"], 10, 49, 15, 0],
              "1f3fa": [["🏺"], "", "", ["amphora"], 10, 50, 15, 0],
              "1f3fb": [["🏻"], "", "", ["skin-tone-2"], 10, 51, 15, 0],
              "1f3fc": [["🏼"], "", "", ["skin-tone-3"], 10, 52, 15, 0],
              "1f3fd": [["🏽"], "", "", ["skin-tone-4"], 10, 53, 15, 0],
              "1f3fe": [["🏾"], "", "", ["skin-tone-5"], 10, 54, 15, 0],
              "1f3ff": [["🏿"], "", "", ["skin-tone-6"], 10, 55, 15, 0],
              "1f400": [["🐀"], "", "", ["rat"], 10, 56, 15, 0],
              "1f401": [["🐁"], "", "", ["mouse2"], 10, 57, 15, 0],
              "1f402": [["🐂"], "", "", ["ox"], 10, 58, 15, 0],
              "1f403": [["🐃"], "", "", ["water_buffalo"], 10, 59, 15, 0],
              "1f404": [["🐄"], "", "", ["cow2"], 11, 0, 15, 0],
              "1f405": [["🐅"], "", "", ["tiger2"], 11, 1, 15, 0],
              "1f406": [["🐆"], "", "", ["leopard"], 11, 2, 15, 0],
              "1f407": [["🐇"], "", "", ["rabbit2"], 11, 3, 15, 0],
              "1f408-200d-2b1b": [["🐈‍⬛"], "", "", ["black_cat"], 11, 4, 15, 0],
              "1f408": [["🐈"], "", "", ["cat2"], 11, 5, 15, 0],
              "1f409": [["🐉"], "", "", ["dragon"], 11, 6, 15, 0],
              "1f40a": [["🐊"], "", "", ["crocodile"], 11, 7, 15, 0],
              "1f40b": [["🐋"], "", "", ["whale2"], 11, 8, 15, 0],
              "1f40c": [["🐌"], "", "󾆹", ["snail"], 11, 9, 15, 0],
              "1f40d": [["🐍"], "", "󾇓", ["snake"], 11, 10, 15, 0],
              "1f40e": [["🐎"], "", "󾟜", ["racehorse"], 11, 11, 15, 0],
              "1f40f": [["🐏"], "", "", ["ram"], 11, 12, 15, 0],
              "1f410": [["🐐"], "", "", ["goat"], 11, 13, 15, 0],
              "1f411": [["🐑"], "", "󾇏", ["sheep"], 11, 14, 15, 0],
              "1f412": [["🐒"], "", "󾇎", ["monkey"], 11, 15, 15, 0],
              "1f413": [["🐓"], "", "", ["rooster"], 11, 16, 15, 0],
              "1f414": [["🐔"], "", "󾇔", ["chicken"], 11, 17, 15, 0],
              "1f415-200d-1f9ba": [
                ["🐕‍🦺"],
                "",
                "",
                ["service_dog"],
                11,
                18,
                15,
                0,
              ],
              "1f415": [["🐕"], "", "", ["dog2"], 11, 19, 15, 0],
              "1f416": [["🐖"], "", "", ["pig2"], 11, 20, 15, 0],
              "1f417": [["🐗"], "", "󾇕", ["boar"], 11, 21, 15, 0],
              "1f418": [["🐘"], "", "󾇌", ["elephant"], 11, 22, 15, 0],
              "1f419": [["🐙"], "", "󾇅", ["octopus"], 11, 23, 15, 0],
              "1f41a": [["🐚"], "", "󾇆", ["shell"], 11, 24, 15, 0],
              "1f41b": [["🐛"], "", "󾇋", ["bug"], 11, 25, 15, 0],
              "1f41c": [["🐜"], "", "󾇚", ["ant"], 11, 26, 15, 0],
              "1f41d": [["🐝"], "", "󾇡", ["bee", "honeybee"], 11, 27, 15, 0],
              "1f41e": [
                ["🐞"],
                "",
                "󾇢",
                ["ladybug", "lady_beetle"],
                11,
                28,
                15,
                0,
              ],
              "1f41f": [["🐟"], "", "󾆽", ["fish"], 11, 29, 15, 0],
              "1f420": [["🐠"], "", "󾇉", ["tropical_fish"], 11, 30, 15, 0],
              "1f421": [["🐡"], "", "󾇙", ["blowfish"], 11, 31, 15, 0],
              "1f422": [["🐢"], "", "󾇜", ["turtle"], 11, 32, 15, 0],
              "1f423": [["🐣"], "", "󾇝", ["hatching_chick"], 11, 33, 15, 0],
              "1f424": [["🐤"], "", "󾆺", ["baby_chick"], 11, 34, 15, 0],
              "1f425": [["🐥"], "", "󾆻", ["hatched_chick"], 11, 35, 15, 0],
              "1f426": [["🐦"], "", "󾇈", ["bird"], 11, 36, 15, 0],
              "1f427": [["🐧"], "", "󾆼", ["penguin"], 11, 37, 15, 0],
              "1f428": [["🐨"], "", "󾇍", ["koala"], 11, 38, 15, 0],
              "1f429": [["🐩"], "", "󾇘", ["poodle"], 11, 39, 15, 0],
              "1f42a": [["🐪"], "", "", ["dromedary_camel"], 11, 40, 15, 0],
              "1f42b": [["🐫"], "", "󾇖", ["camel"], 11, 41, 15, 0],
              "1f42c": [
                ["🐬"],
                "",
                "󾇇",
                ["dolphin", "flipper"],
                11,
                42,
                15,
                0,
              ],
              "1f42d": [["🐭"], "", "󾇂", ["mouse"], 11, 43, 15, 0],
              "1f42e": [["🐮"], "", "󾇑", ["cow"], 11, 44, 15, 0],
              "1f42f": [["🐯"], "", "󾇀", ["tiger"], 11, 45, 15, 0],
              "1f430": [["🐰"], "", "󾇒", ["rabbit"], 11, 46, 15, 0],
              "1f431": [["🐱"], "", "󾆸", ["cat"], 11, 47, 15, 0],
              "1f432": [["🐲"], "", "󾇞", ["dragon_face"], 11, 48, 15, 0],
              "1f433": [["🐳"], "", "󾇃", ["whale"], 11, 49, 15, 0],
              "1f434": [["🐴"], "", "󾆾", ["horse"], 11, 50, 15, 0],
              "1f435": [["🐵"], "", "󾇄", ["monkey_face"], 11, 51, 15, 0],
              "1f436": [["🐶"], "", "󾆷", ["dog"], 11, 52, 15, 0],
              "1f437": [["🐷"], "", "󾆿", ["pig"], 11, 53, 15, 0],
              "1f438": [["🐸"], "", "󾇗", ["frog"], 11, 54, 15, 0],
              "1f439": [["🐹"], "", "󾇊", ["hamster"], 11, 55, 15, 0],
              "1f43a": [["🐺"], "", "󾇐", ["wolf"], 11, 56, 15, 0],
              "1f43b-200d-2744-fe0f": [
                ["🐻‍❄️", "🐻‍❄"],
                "",
                "",
                ["polar_bear"],
                11,
                57,
                15,
                0,
              ],
              "1f43b": [["🐻"], "", "󾇁", ["bear"], 11, 58, 15, 0],
              "1f43c": [["🐼"], "", "󾇟", ["panda_face"], 11, 59, 15, 0],
              "1f43d": [["🐽"], "", "󾇠", ["pig_nose"], 12, 0, 15, 0],
              "1f43e": [["🐾"], "", "󾇛", ["feet", "paw_prints"], 12, 1, 15, 0],
              "1f43f-fe0f": [["🐿️", "🐿"], "", "", ["chipmunk"], 12, 2, 15, 0],
              "1f440": [["👀"], "", "󾆐", ["eyes"], 12, 3, 15, 0],
              "1f441-fe0f-200d-1f5e8-fe0f": [
                ["👁️‍🗨️"],
                "",
                "",
                ["eye-in-speech-bubble"],
                12,
                4,
                7,
                0,
              ],
              "1f441-fe0f": [["👁️", "👁"], "", "", ["eye"], 12, 5, 15, 0],
              "1f442": [["👂"], "", "󾆑", ["ear"], 12, 6, 15, 0],
              "1f443": [["👃"], "", "󾆒", ["nose"], 12, 12, 15, 0],
              "1f444": [["👄"], "", "󾆓", ["lips"], 12, 18, 15, 0],
              "1f445": [["👅"], "", "󾆔", ["tongue"], 12, 19, 15, 0],
              "1f446": [["👆"], "", "󾮙", ["point_up_2"], 12, 20, 15, 0],
              "1f447": [["👇"], "", "󾮚", ["point_down"], 12, 26, 15, 0],
              "1f448": [["👈"], "", "󾮛", ["point_left"], 12, 32, 15, 0],
              "1f449": [["👉"], "", "󾮜", ["point_right"], 12, 38, 15, 0],
              "1f44a": [
                ["👊"],
                "",
                "󾮖",
                ["facepunch", "punch"],
                12,
                44,
                15,
                0,
              ],
              "1f44b": [["👋"], "", "󾮝", ["wave"], 12, 50, 15, 0],
              "1f44c": [["👌"], "", "󾮟", ["ok_hand"], 12, 56, 15, 0],
              "1f44d": [["👍"], "", "󾮗", ["+1", "thumbsup"], 13, 2, 15, 0],
              "1f44e": [["👎"], "", "󾮠", ["-1", "thumbsdown"], 13, 8, 15, 0],
              "1f44f": [["👏"], "", "󾮞", ["clap"], 13, 14, 15, 0],
              "1f450": [["👐"], "", "󾮡", ["open_hands"], 13, 20, 15, 0],
              "1f451": [["👑"], "", "󾓑", ["crown"], 13, 26, 15, 0],
              "1f452": [["👒"], "", "󾓔", ["womans_hat"], 13, 27, 15, 0],
              "1f453": [["👓"], "", "󾓎", ["eyeglasses"], 13, 28, 15, 0],
              "1f454": [["👔"], "", "󾓓", ["necktie"], 13, 29, 15, 0],
              "1f455": [["👕"], "", "󾓏", ["shirt", "tshirt"], 13, 30, 15, 0],
              "1f456": [["👖"], "", "󾓐", ["jeans"], 13, 31, 15, 0],
              "1f457": [["👗"], "", "󾓕", ["dress"], 13, 32, 15, 0],
              "1f458": [["👘"], "", "󾓙", ["kimono"], 13, 33, 15, 0],
              "1f459": [["👙"], "", "󾓚", ["bikini"], 13, 34, 15, 0],
              "1f45a": [["👚"], "", "󾓛", ["womans_clothes"], 13, 35, 15, 0],
              "1f45b": [["👛"], "", "󾓜", ["purse"], 13, 36, 15, 0],
              "1f45c": [["👜"], "", "󾓰", ["handbag"], 13, 37, 15, 0],
              "1f45d": [["👝"], "", "󾓱", ["pouch"], 13, 38, 15, 0],
              "1f45e": [["👞"], "", "󾓌", ["mans_shoe", "shoe"], 13, 39, 15, 0],
              "1f45f": [["👟"], "", "󾓍", ["athletic_shoe"], 13, 40, 15, 0],
              "1f460": [["👠"], "", "󾓖", ["high_heel"], 13, 41, 15, 0],
              "1f461": [["👡"], "", "󾓗", ["sandal"], 13, 42, 15, 0],
              "1f462": [["👢"], "", "󾓘", ["boot"], 13, 43, 15, 0],
              "1f463": [["👣"], "", "󾕓", ["footprints"], 13, 44, 15, 0],
              "1f464": [["👤"], "", "󾆚", ["bust_in_silhouette"], 13, 45, 15, 0],
              "1f465": [["👥"], "", "", ["busts_in_silhouette"], 13, 46, 15, 0],
              "1f466": [["👦"], "", "󾆛", ["boy"], 13, 47, 15, 0],
              "1f467": [["👧"], "", "󾆜", ["girl"], 13, 53, 15, 0],
              "1f468-200d-1f33e": [
                ["👨‍🌾"],
                "",
                "",
                ["male-farmer"],
                13,
                59,
                15,
                0,
              ],
              "1f468-200d-1f373": [["👨‍🍳"], "", "", ["male-cook"], 14, 5, 15, 0],
              "1f468-200d-1f37c": [
                ["👨‍🍼"],
                "",
                "",
                ["man_feeding_baby"],
                14,
                11,
                15,
                0,
              ],
              "1f468-200d-1f393": [
                ["👨‍🎓"],
                "",
                "",
                ["male-student"],
                14,
                17,
                15,
                0,
              ],
              "1f468-200d-1f3a4": [
                ["👨‍🎤"],
                "",
                "",
                ["male-singer"],
                14,
                23,
                15,
                0,
              ],
              "1f468-200d-1f3a8": [
                ["👨‍🎨"],
                "",
                "",
                ["male-artist"],
                14,
                29,
                15,
                0,
              ],
              "1f468-200d-1f3eb": [
                ["👨‍🏫"],
                "",
                "",
                ["male-teacher"],
                14,
                35,
                15,
                0,
              ],
              "1f468-200d-1f3ed": [
                ["👨‍🏭"],
                "",
                "",
                ["male-factory-worker"],
                14,
                41,
                15,
                0,
              ],
              "1f468-200d-1f466-200d-1f466": [
                ["👨‍👦‍👦"],
                "",
                "",
                ["man-boy-boy"],
                14,
                47,
                15,
                0,
              ],
              "1f468-200d-1f466": [["👨‍👦"], "", "", ["man-boy"], 14, 48, 15, 0],
              "1f468-200d-1f467-200d-1f466": [
                ["👨‍👧‍👦"],
                "",
                "",
                ["man-girl-boy"],
                14,
                49,
                15,
                0,
              ],
              "1f468-200d-1f467-200d-1f467": [
                ["👨‍👧‍👧"],
                "",
                "",
                ["man-girl-girl"],
                14,
                50,
                15,
                0,
              ],
              "1f468-200d-1f467": [["👨‍👧"], "", "", ["man-girl"], 14, 51, 15, 0],
              "1f468-200d-1f468-200d-1f466": [
                ["👨‍👨‍👦"],
                "",
                "",
                ["man-man-boy"],
                14,
                52,
                15,
                0,
              ],
              "1f468-200d-1f468-200d-1f466-200d-1f466": [
                ["👨‍👨‍👦‍👦"],
                "",
                "",
                ["man-man-boy-boy"],
                14,
                53,
                15,
                0,
              ],
              "1f468-200d-1f468-200d-1f467": [
                ["👨‍👨‍👧"],
                "",
                "",
                ["man-man-girl"],
                14,
                54,
                15,
                0,
              ],
              "1f468-200d-1f468-200d-1f467-200d-1f466": [
                ["👨‍👨‍👧‍👦"],
                "",
                "",
                ["man-man-girl-boy"],
                14,
                55,
                15,
                0,
              ],
              "1f468-200d-1f468-200d-1f467-200d-1f467": [
                ["👨‍👨‍👧‍👧"],
                "",
                "",
                ["man-man-girl-girl"],
                14,
                56,
                15,
                0,
              ],
              "1f468-200d-1f469-200d-1f466": [
                ["👨‍👩‍👦", "👪"],
                "",
                "",
                ["man-woman-boy", "family"],
                14,
                57,
                15,
                0,
              ],
              "1f468-200d-1f469-200d-1f466-200d-1f466": [
                ["👨‍👩‍👦‍👦"],
                "",
                "",
                ["man-woman-boy-boy"],
                14,
                58,
                15,
                0,
              ],
              "1f468-200d-1f469-200d-1f467": [
                ["👨‍👩‍👧"],
                "",
                "",
                ["man-woman-girl"],
                14,
                59,
                15,
                0,
              ],
              "1f468-200d-1f469-200d-1f467-200d-1f466": [
                ["👨‍👩‍👧‍👦"],
                "",
                "",
                ["man-woman-girl-boy"],
                15,
                0,
                15,
                0,
              ],
              "1f468-200d-1f469-200d-1f467-200d-1f467": [
                ["👨‍👩‍👧‍👧"],
                "",
                "",
                ["man-woman-girl-girl"],
                15,
                1,
                15,
                0,
              ],
              "1f468-200d-1f4bb": [
                ["👨‍💻"],
                "",
                "",
                ["male-technologist"],
                15,
                2,
                15,
                0,
              ],
              "1f468-200d-1f4bc": [
                ["👨‍💼"],
                "",
                "",
                ["male-office-worker"],
                15,
                8,
                15,
                0,
              ],
              "1f468-200d-1f527": [
                ["👨‍🔧"],
                "",
                "",
                ["male-mechanic"],
                15,
                14,
                15,
                0,
              ],
              "1f468-200d-1f52c": [
                ["👨‍🔬"],
                "",
                "",
                ["male-scientist"],
                15,
                20,
                15,
                0,
              ],
              "1f468-200d-1f680": [
                ["👨‍🚀"],
                "",
                "",
                ["male-astronaut"],
                15,
                26,
                15,
                0,
              ],
              "1f468-200d-1f692": [
                ["👨‍🚒"],
                "",
                "",
                ["male-firefighter"],
                15,
                32,
                15,
                0,
              ],
              "1f468-200d-1f9af": [
                ["👨‍🦯"],
                "",
                "",
                ["man_with_probing_cane"],
                15,
                38,
                15,
                0,
              ],
              "1f468-200d-1f9b0": [
                ["👨‍🦰"],
                "",
                "",
                ["red_haired_man"],
                15,
                44,
                15,
                0,
              ],
              "1f468-200d-1f9b1": [
                ["👨‍🦱"],
                "",
                "",
                ["curly_haired_man"],
                15,
                50,
                15,
                0,
              ],
              "1f468-200d-1f9b2": [["👨‍🦲"], "", "", ["bald_man"], 15, 56, 15, 0],
              "1f468-200d-1f9b3": [
                ["👨‍🦳"],
                "",
                "",
                ["white_haired_man"],
                16,
                2,
                15,
                0,
              ],
              "1f468-200d-1f9bc": [
                ["👨‍🦼"],
                "",
                "",
                ["man_in_motorized_wheelchair"],
                16,
                8,
                15,
                0,
              ],
              "1f468-200d-1f9bd": [
                ["👨‍🦽"],
                "",
                "",
                ["man_in_manual_wheelchair"],
                16,
                14,
                15,
                0,
              ],
              "1f468-200d-2695-fe0f": [
                ["👨‍⚕️", "👨‍⚕"],
                "",
                "",
                ["male-doctor"],
                16,
                20,
                15,
                0,
              ],
              "1f468-200d-2696-fe0f": [
                ["👨‍⚖️", "👨‍⚖"],
                "",
                "",
                ["male-judge"],
                16,
                26,
                15,
                0,
              ],
              "1f468-200d-2708-fe0f": [
                ["👨‍✈️", "👨‍✈"],
                "",
                "",
                ["male-pilot"],
                16,
                32,
                15,
                0,
              ],
              "1f468-200d-2764-fe0f-200d-1f468": [
                ["👨‍❤️‍👨", "👨‍❤‍👨"],
                "",
                "",
                ["man-heart-man"],
                16,
                38,
                15,
                0,
              ],
              "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468": [
                ["👨‍❤️‍💋‍👨", "👨‍❤‍💋‍👨"],
                "",
                "",
                ["man-kiss-man"],
                17,
                4,
                15,
                0,
              ],
              "1f468": [["👨"], "", "󾆝", ["man"], 17, 30, 15, 0],
              "1f469-200d-1f33e": [
                ["👩‍🌾"],
                "",
                "",
                ["female-farmer"],
                17,
                36,
                15,
                0,
              ],
              "1f469-200d-1f373": [
                ["👩‍🍳"],
                "",
                "",
                ["female-cook"],
                17,
                42,
                15,
                0,
              ],
              "1f469-200d-1f37c": [
                ["👩‍🍼"],
                "",
                "",
                ["woman_feeding_baby"],
                17,
                48,
                15,
                0,
              ],
              "1f469-200d-1f393": [
                ["👩‍🎓"],
                "",
                "",
                ["female-student"],
                17,
                54,
                15,
                0,
              ],
              "1f469-200d-1f3a4": [
                ["👩‍🎤"],
                "",
                "",
                ["female-singer"],
                18,
                0,
                15,
                0,
              ],
              "1f469-200d-1f3a8": [
                ["👩‍🎨"],
                "",
                "",
                ["female-artist"],
                18,
                6,
                15,
                0,
              ],
              "1f469-200d-1f3eb": [
                ["👩‍🏫"],
                "",
                "",
                ["female-teacher"],
                18,
                12,
                15,
                0,
              ],
              "1f469-200d-1f3ed": [
                ["👩‍🏭"],
                "",
                "",
                ["female-factory-worker"],
                18,
                18,
                15,
                0,
              ],
              "1f469-200d-1f466-200d-1f466": [
                ["👩‍👦‍👦"],
                "",
                "",
                ["woman-boy-boy"],
                18,
                24,
                15,
                0,
              ],
              "1f469-200d-1f466": [
                ["👩‍👦"],
                "",
                "",
                ["woman-boy"],
                18,
                25,
                15,
                0,
              ],
              "1f469-200d-1f467-200d-1f466": [
                ["👩‍👧‍👦"],
                "",
                "",
                ["woman-girl-boy"],
                18,
                26,
                15,
                0,
              ],
              "1f469-200d-1f467-200d-1f467": [
                ["👩‍👧‍👧"],
                "",
                "",
                ["woman-girl-girl"],
                18,
                27,
                15,
                0,
              ],
              "1f469-200d-1f467": [
                ["👩‍👧"],
                "",
                "",
                ["woman-girl"],
                18,
                28,
                15,
                0,
              ],
              "1f469-200d-1f469-200d-1f466": [
                ["👩‍👩‍👦"],
                "",
                "",
                ["woman-woman-boy"],
                18,
                29,
                15,
                0,
              ],
              "1f469-200d-1f469-200d-1f466-200d-1f466": [
                ["👩‍👩‍👦‍👦"],
                "",
                "",
                ["woman-woman-boy-boy"],
                18,
                30,
                15,
                0,
              ],
              "1f469-200d-1f469-200d-1f467": [
                ["👩‍👩‍👧"],
                "",
                "",
                ["woman-woman-girl"],
                18,
                31,
                15,
                0,
              ],
              "1f469-200d-1f469-200d-1f467-200d-1f466": [
                ["👩‍👩‍👧‍👦"],
                "",
                "",
                ["woman-woman-girl-boy"],
                18,
                32,
                15,
                0,
              ],
              "1f469-200d-1f469-200d-1f467-200d-1f467": [
                ["👩‍👩‍👧‍👧"],
                "",
                "",
                ["woman-woman-girl-girl"],
                18,
                33,
                15,
                0,
              ],
              "1f469-200d-1f4bb": [
                ["👩‍💻"],
                "",
                "",
                ["female-technologist"],
                18,
                34,
                15,
                0,
              ],
              "1f469-200d-1f4bc": [
                ["👩‍💼"],
                "",
                "",
                ["female-office-worker"],
                18,
                40,
                15,
                0,
              ],
              "1f469-200d-1f527": [
                ["👩‍🔧"],
                "",
                "",
                ["female-mechanic"],
                18,
                46,
                15,
                0,
              ],
              "1f469-200d-1f52c": [
                ["👩‍🔬"],
                "",
                "",
                ["female-scientist"],
                18,
                52,
                15,
                0,
              ],
              "1f469-200d-1f680": [
                ["👩‍🚀"],
                "",
                "",
                ["female-astronaut"],
                18,
                58,
                15,
                0,
              ],
              "1f469-200d-1f692": [
                ["👩‍🚒"],
                "",
                "",
                ["female-firefighter"],
                19,
                4,
                15,
                0,
              ],
              "1f469-200d-1f9af": [
                ["👩‍🦯"],
                "",
                "",
                ["woman_with_probing_cane"],
                19,
                10,
                15,
                0,
              ],
              "1f469-200d-1f9b0": [
                ["👩‍🦰"],
                "",
                "",
                ["red_haired_woman"],
                19,
                16,
                15,
                0,
              ],
              "1f469-200d-1f9b1": [
                ["👩‍🦱"],
                "",
                "",
                ["curly_haired_woman"],
                19,
                22,
                15,
                0,
              ],
              "1f469-200d-1f9b2": [
                ["👩‍🦲"],
                "",
                "",
                ["bald_woman"],
                19,
                28,
                15,
                0,
              ],
              "1f469-200d-1f9b3": [
                ["👩‍🦳"],
                "",
                "",
                ["white_haired_woman"],
                19,
                34,
                15,
                0,
              ],
              "1f469-200d-1f9bc": [
                ["👩‍🦼"],
                "",
                "",
                ["woman_in_motorized_wheelchair"],
                19,
                40,
                15,
                0,
              ],
              "1f469-200d-1f9bd": [
                ["👩‍🦽"],
                "",
                "",
                ["woman_in_manual_wheelchair"],
                19,
                46,
                15,
                0,
              ],
              "1f469-200d-2695-fe0f": [
                ["👩‍⚕️", "👩‍⚕"],
                "",
                "",
                ["female-doctor"],
                19,
                52,
                15,
                0,
              ],
              "1f469-200d-2696-fe0f": [
                ["👩‍⚖️", "👩‍⚖"],
                "",
                "",
                ["female-judge"],
                19,
                58,
                15,
                0,
              ],
              "1f469-200d-2708-fe0f": [
                ["👩‍✈️", "👩‍✈"],
                "",
                "",
                ["female-pilot"],
                20,
                4,
                15,
                0,
              ],
              "1f469-200d-2764-fe0f-200d-1f468": [
                ["👩‍❤️‍👨", "👩‍❤‍👨"],
                "",
                "",
                ["woman-heart-man"],
                20,
                10,
                15,
                0,
              ],
              "1f469-200d-2764-fe0f-200d-1f469": [
                ["👩‍❤️‍👩", "👩‍❤‍👩"],
                "",
                "",
                ["woman-heart-woman"],
                20,
                36,
                15,
                0,
              ],
              "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468": [
                ["👩‍❤️‍💋‍👨", "👩‍❤‍💋‍👨"],
                "",
                "",
                ["woman-kiss-man"],
                21,
                2,
                15,
                0,
              ],
              "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469": [
                ["👩‍❤️‍💋‍👩", "👩‍❤‍💋‍👩"],
                "",
                "",
                ["woman-kiss-woman"],
                21,
                28,
                15,
                0,
              ],
              "1f469": [["👩"], "", "󾆞", ["woman"], 21, 54, 15, 0],
              "1f46b": [
                ["👫"],
                "",
                "󾆠",
                [
                  "man_and_woman_holding_hands",
                  "woman_and_man_holding_hands",
                  "couple",
                ],
                22,
                1,
                15,
                0,
              ],
              "1f46c": [
                ["👬"],
                "",
                "",
                ["two_men_holding_hands", "men_holding_hands"],
                22,
                27,
                15,
                0,
              ],
              "1f46d": [
                ["👭"],
                "",
                "",
                ["two_women_holding_hands", "women_holding_hands"],
                22,
                53,
                15,
                0,
              ],
              "1f46e-200d-2640-fe0f": [
                ["👮‍♀️", "👮‍♀"],
                "",
                "",
                ["female-police-officer"],
                23,
                19,
                15,
                0,
              ],
              "1f46e-200d-2642-fe0f": [
                ["👮‍♂️", "👮‍♂", "👮"],
                "",
                "",
                ["male-police-officer", "cop"],
                23,
                25,
                15,
                0,
              ],
              "1f46f-200d-2640-fe0f": [
                ["👯‍♀️", "👯‍♀", "👯"],
                "",
                "",
                [
                  "women-with-bunny-ears-partying",
                  "woman-with-bunny-ears-partying",
                  "dancers",
                ],
                23,
                37,
                15,
                0,
              ],
              "1f46f-200d-2642-fe0f": [
                ["👯‍♂️", "👯‍♂"],
                "",
                "",
                [
                  "men-with-bunny-ears-partying",
                  "man-with-bunny-ears-partying",
                ],
                23,
                38,
                15,
                0,
              ],
              "1f470-200d-2640-fe0f": [
                ["👰‍♀️", "👰‍♀"],
                "",
                "",
                ["woman_with_veil"],
                23,
                40,
                15,
                0,
              ],
              "1f470-200d-2642-fe0f": [
                ["👰‍♂️", "👰‍♂"],
                "",
                "",
                ["man_with_veil"],
                23,
                46,
                15,
                0,
              ],
              "1f470": [["👰"], "", "󾆣", ["bride_with_veil"], 23, 52, 15, 0],
              "1f471-200d-2640-fe0f": [
                ["👱‍♀️", "👱‍♀"],
                "",
                "",
                ["blond-haired-woman"],
                23,
                58,
                15,
                0,
              ],
              "1f471-200d-2642-fe0f": [
                ["👱‍♂️", "👱‍♂", "👱"],
                "",
                "",
                ["blond-haired-man", "person_with_blond_hair"],
                24,
                4,
                15,
                0,
              ],
              "1f472": [
                ["👲"],
                "",
                "󾆥",
                ["man_with_gua_pi_mao"],
                24,
                16,
                15,
                0,
              ],
              "1f473-200d-2640-fe0f": [
                ["👳‍♀️", "👳‍♀"],
                "",
                "",
                ["woman-wearing-turban"],
                24,
                22,
                15,
                0,
              ],
              "1f473-200d-2642-fe0f": [
                ["👳‍♂️", "👳‍♂", "👳"],
                "",
                "",
                ["man-wearing-turban", "man_with_turban"],
                24,
                28,
                15,
                0,
              ],
              "1f474": [["👴"], "", "󾆧", ["older_man"], 24, 40, 15, 0],
              "1f475": [["👵"], "", "󾆨", ["older_woman"], 24, 46, 15, 0],
              "1f476": [["👶"], "", "󾆩", ["baby"], 24, 52, 15, 0],
              "1f477-200d-2640-fe0f": [
                ["👷‍♀️", "👷‍♀"],
                "",
                "",
                ["female-construction-worker"],
                24,
                58,
                15,
                0,
              ],
              "1f477-200d-2642-fe0f": [
                ["👷‍♂️", "👷‍♂", "👷"],
                "",
                "",
                ["male-construction-worker", "construction_worker"],
                25,
                4,
                15,
                0,
              ],
              "1f478": [["👸"], "", "󾆫", ["princess"], 25, 16, 15, 0],
              "1f479": [["👹"], "", "󾆬", ["japanese_ogre"], 25, 22, 15, 0],
              "1f47a": [["👺"], "", "󾆭", ["japanese_goblin"], 25, 23, 15, 0],
              "1f47b": [["👻"], "", "󾆮", ["ghost"], 25, 24, 15, 0],
              "1f47c": [["👼"], "", "󾆯", ["angel"], 25, 25, 15, 0],
              "1f47d": [["👽"], "", "󾆰", ["alien"], 25, 31, 15, 0],
              "1f47e": [["👾"], "", "󾆱", ["space_invader"], 25, 32, 15, 0],
              "1f47f": [["👿"], "", "󾆲", ["imp"], 25, 33, 15, 0],
              "1f480": [["💀"], "", "󾆳", ["skull"], 25, 34, 15, 0],
              "1f481-200d-2640-fe0f": [
                ["💁‍♀️", "💁‍♀", "💁"],
                "",
                "",
                ["woman-tipping-hand", "information_desk_person"],
                25,
                35,
                15,
                0,
              ],
              "1f481-200d-2642-fe0f": [
                ["💁‍♂️", "💁‍♂"],
                "",
                "",
                ["man-tipping-hand"],
                25,
                41,
                15,
                0,
              ],
              "1f482-200d-2640-fe0f": [
                ["💂‍♀️", "💂‍♀"],
                "",
                "",
                ["female-guard"],
                25,
                53,
                15,
                0,
              ],
              "1f482-200d-2642-fe0f": [
                ["💂‍♂️", "💂‍♂", "💂"],
                "",
                "",
                ["male-guard", "guardsman"],
                25,
                59,
                15,
                0,
              ],
              "1f483": [["💃"], "", "󾆶", ["dancer"], 26, 11, 15, 0],
              "1f484": [["💄"], "", "󾆕", ["lipstick"], 26, 17, 15, 0],
              "1f485": [["💅"], "", "󾆖", ["nail_care"], 26, 18, 15, 0],
              "1f486-200d-2640-fe0f": [
                ["💆‍♀️", "💆‍♀", "💆"],
                "",
                "",
                ["woman-getting-massage", "massage"],
                26,
                24,
                15,
                0,
              ],
              "1f486-200d-2642-fe0f": [
                ["💆‍♂️", "💆‍♂"],
                "",
                "",
                ["man-getting-massage"],
                26,
                30,
                15,
                0,
              ],
              "1f487-200d-2640-fe0f": [
                ["💇‍♀️", "💇‍♀", "💇"],
                "",
                "",
                ["woman-getting-haircut", "haircut"],
                26,
                42,
                15,
                0,
              ],
              "1f487-200d-2642-fe0f": [
                ["💇‍♂️", "💇‍♂"],
                "",
                "",
                ["man-getting-haircut"],
                26,
                48,
                15,
                0,
              ],
              "1f488": [["💈"], "", "󾆙", ["barber"], 27, 0, 15, 0],
              "1f489": [["💉"], "", "󾔉", ["syringe"], 27, 1, 15, 0],
              "1f48a": [["💊"], "", "󾔊", ["pill"], 27, 2, 15, 0],
              "1f48b": [["💋"], "", "󾠣", ["kiss"], 27, 3, 15, 0],
              "1f48c": [["💌"], "", "󾠤", ["love_letter"], 27, 4, 15, 0],
              "1f48d": [["💍"], "", "󾠥", ["ring"], 27, 5, 15, 0],
              "1f48e": [["💎"], "", "󾠦", ["gem"], 27, 6, 15, 0],
              "1f48f": [["💏"], "", "󾠧", ["couplekiss"], 27, 7, 15, 0],
              "1f490": [["💐"], "", "󾠨", ["bouquet"], 27, 33, 15, 0],
              "1f491": [["💑"], "", "󾠩", ["couple_with_heart"], 27, 34, 15, 0],
              "1f492": [["💒"], "", "󾠪", ["wedding"], 28, 0, 15, 0],
              "1f493": [["💓"], "", "󾬍", ["heartbeat"], 28, 1, 15, 0],
              "1f494": [
                ["💔"],
                "",
                "󾬎",
                ["broken_heart"],
                28,
                2,
                15,
                0,
                "</3",
              ],
              "1f495": [["💕"], "", "󾬏", ["two_hearts"], 28, 3, 15, 0],
              "1f496": [["💖"], "", "󾬐", ["sparkling_heart"], 28, 4, 15, 0],
              "1f497": [["💗"], "", "󾬑", ["heartpulse"], 28, 5, 15, 0],
              "1f498": [["💘"], "", "󾬒", ["cupid"], 28, 6, 15, 0],
              "1f499": [["💙"], "", "󾬓", ["blue_heart"], 28, 7, 15, 0, "<3"],
              "1f49a": [["💚"], "", "󾬔", ["green_heart"], 28, 8, 15, 0, "<3"],
              "1f49b": [["💛"], "", "󾬕", ["yellow_heart"], 28, 9, 15, 0, "<3"],
              "1f49c": [
                ["💜"],
                "",
                "󾬖",
                ["purple_heart"],
                28,
                10,
                15,
                0,
                "<3",
              ],
              "1f49d": [["💝"], "", "󾬗", ["gift_heart"], 28, 11, 15, 0],
              "1f49e": [["💞"], "", "󾬘", ["revolving_hearts"], 28, 12, 15, 0],
              "1f49f": [["💟"], "", "󾬙", ["heart_decoration"], 28, 13, 15, 0],
              "1f4a0": [
                ["💠"],
                "",
                "󾭕",
                ["diamond_shape_with_a_dot_inside"],
                28,
                14,
                15,
                0,
              ],
              "1f4a1": [["💡"], "", "󾭖", ["bulb"], 28, 15, 15, 0],
              "1f4a2": [["💢"], "", "󾭗", ["anger"], 28, 16, 15, 0],
              "1f4a3": [["💣"], "", "󾭘", ["bomb"], 28, 17, 15, 0],
              "1f4a4": [["💤"], "", "󾭙", ["zzz"], 28, 18, 15, 0],
              "1f4a5": [["💥"], "", "󾭚", ["boom", "collision"], 28, 19, 15, 0],
              "1f4a6": [["💦"], "", "󾭛", ["sweat_drops"], 28, 20, 15, 0],
              "1f4a7": [["💧"], "", "󾭜", ["droplet"], 28, 21, 15, 0],
              "1f4a8": [["💨"], "", "󾭝", ["dash"], 28, 22, 15, 0],
              "1f4a9": [
                ["💩"],
                "",
                "󾓴",
                ["hankey", "poop", "shit"],
                28,
                23,
                15,
                0,
              ],
              "1f4aa": [["💪"], "", "󾭞", ["muscle"], 28, 24, 15, 0],
              "1f4ab": [["💫"], "", "󾭟", ["dizzy"], 28, 30, 15, 0],
              "1f4ac": [["💬"], "", "󾔲", ["speech_balloon"], 28, 31, 15, 0],
              "1f4ad": [["💭"], "", "", ["thought_balloon"], 28, 32, 15, 0],
              "1f4ae": [["💮"], "", "󾭺", ["white_flower"], 28, 33, 15, 0],
              "1f4af": [["💯"], "", "󾭻", ["100"], 28, 34, 15, 0],
              "1f4b0": [["💰"], "", "󾓝", ["moneybag"], 28, 35, 15, 0],
              "1f4b1": [["💱"], "", "󾓞", ["currency_exchange"], 28, 36, 15, 0],
              "1f4b2": [["💲"], "", "󾓠", ["heavy_dollar_sign"], 28, 37, 15, 0],
              "1f4b3": [["💳"], "", "󾓡", ["credit_card"], 28, 38, 15, 0],
              "1f4b4": [["💴"], "", "󾓢", ["yen"], 28, 39, 15, 0],
              "1f4b5": [["💵"], "", "󾓣", ["dollar"], 28, 40, 15, 0],
              "1f4b6": [["💶"], "", "", ["euro"], 28, 41, 15, 0],
              "1f4b7": [["💷"], "", "", ["pound"], 28, 42, 15, 0],
              "1f4b8": [["💸"], "", "󾓤", ["money_with_wings"], 28, 43, 15, 0],
              "1f4b9": [["💹"], "", "󾓟", ["chart"], 28, 44, 15, 0],
              "1f4ba": [["💺"], "", "󾔷", ["seat"], 28, 45, 15, 0],
              "1f4bb": [["💻"], "", "󾔸", ["computer"], 28, 46, 15, 0],
              "1f4bc": [["💼"], "", "󾔻", ["briefcase"], 28, 47, 15, 0],
              "1f4bd": [["💽"], "", "󾔼", ["minidisc"], 28, 48, 15, 0],
              "1f4be": [["💾"], "", "󾔽", ["floppy_disk"], 28, 49, 15, 0],
              "1f4bf": [["💿"], "", "󾠝", ["cd"], 28, 50, 15, 0],
              "1f4c0": [["📀"], "", "󾠞", ["dvd"], 28, 51, 15, 0],
              "1f4c1": [["📁"], "", "󾕃", ["file_folder"], 28, 52, 15, 0],
              "1f4c2": [["📂"], "", "󾕄", ["open_file_folder"], 28, 53, 15, 0],
              "1f4c3": [["📃"], "", "󾕀", ["page_with_curl"], 28, 54, 15, 0],
              "1f4c4": [["📄"], "", "󾕁", ["page_facing_up"], 28, 55, 15, 0],
              "1f4c5": [["📅"], "", "󾕂", ["date"], 28, 56, 15, 0],
              "1f4c6": [["📆"], "", "󾕉", ["calendar"], 28, 57, 15, 0],
              "1f4c7": [["📇"], "", "󾕍", ["card_index"], 28, 58, 15, 0],
              "1f4c8": [
                ["📈"],
                "",
                "󾕋",
                ["chart_with_upwards_trend"],
                28,
                59,
                15,
                0,
              ],
              "1f4c9": [
                ["📉"],
                "",
                "󾕌",
                ["chart_with_downwards_trend"],
                29,
                0,
                15,
                0,
              ],
              "1f4ca": [["📊"], "", "󾕊", ["bar_chart"], 29, 1, 15, 0],
              "1f4cb": [["📋"], "", "󾕈", ["clipboard"], 29, 2, 15, 0],
              "1f4cc": [["📌"], "", "󾕎", ["pushpin"], 29, 3, 15, 0],
              "1f4cd": [["📍"], "", "󾔿", ["round_pushpin"], 29, 4, 15, 0],
              "1f4ce": [["📎"], "", "󾔺", ["paperclip"], 29, 5, 15, 0],
              "1f4cf": [["📏"], "", "󾕐", ["straight_ruler"], 29, 6, 15, 0],
              "1f4d0": [["📐"], "", "󾕑", ["triangular_ruler"], 29, 7, 15, 0],
              "1f4d1": [["📑"], "", "󾕒", ["bookmark_tabs"], 29, 8, 15, 0],
              "1f4d2": [["📒"], "", "󾕏", ["ledger"], 29, 9, 15, 0],
              "1f4d3": [["📓"], "", "󾕅", ["notebook"], 29, 10, 15, 0],
              "1f4d4": [
                ["📔"],
                "",
                "󾕇",
                ["notebook_with_decorative_cover"],
                29,
                11,
                15,
                0,
              ],
              "1f4d5": [["📕"], "", "󾔂", ["closed_book"], 29, 12, 15, 0],
              "1f4d6": [["📖"], "", "󾕆", ["book", "open_book"], 29, 13, 15, 0],
              "1f4d7": [["📗"], "", "󾓿", ["green_book"], 29, 14, 15, 0],
              "1f4d8": [["📘"], "", "󾔀", ["blue_book"], 29, 15, 15, 0],
              "1f4d9": [["📙"], "", "󾔁", ["orange_book"], 29, 16, 15, 0],
              "1f4da": [["📚"], "", "󾔃", ["books"], 29, 17, 15, 0],
              "1f4db": [["📛"], "", "󾔄", ["name_badge"], 29, 18, 15, 0],
              "1f4dc": [["📜"], "", "󾓽", ["scroll"], 29, 19, 15, 0],
              "1f4dd": [["📝"], "", "󾔧", ["memo", "pencil"], 29, 20, 15, 0],
              "1f4de": [["📞"], "", "󾔤", ["telephone_receiver"], 29, 21, 15, 0],
              "1f4df": [["📟"], "", "󾔢", ["pager"], 29, 22, 15, 0],
              "1f4e0": [["📠"], "", "󾔨", ["fax"], 29, 23, 15, 0],
              "1f4e1": [["📡"], "", "󾔱", ["satellite_antenna"], 29, 24, 15, 0],
              "1f4e2": [["📢"], "", "󾔯", ["loudspeaker"], 29, 25, 15, 0],
              "1f4e3": [["📣"], "", "󾔰", ["mega"], 29, 26, 15, 0],
              "1f4e4": [["📤"], "", "󾔳", ["outbox_tray"], 29, 27, 15, 0],
              "1f4e5": [["📥"], "", "󾔴", ["inbox_tray"], 29, 28, 15, 0],
              "1f4e6": [["📦"], "", "󾔵", ["package"], 29, 29, 15, 0],
              "1f4e7": [["📧"], "", "󾮒", ["e-mail"], 29, 30, 15, 0],
              "1f4e8": [["📨"], "", "󾔪", ["incoming_envelope"], 29, 31, 15, 0],
              "1f4e9": [
                ["📩"],
                "",
                "󾔫",
                ["envelope_with_arrow"],
                29,
                32,
                15,
                0,
              ],
              "1f4ea": [["📪"], "", "󾔬", ["mailbox_closed"], 29, 33, 15, 0],
              "1f4eb": [["📫"], "", "󾔭", ["mailbox"], 29, 34, 15, 0],
              "1f4ec": [["📬"], "", "", ["mailbox_with_mail"], 29, 35, 15, 0],
              "1f4ed": [
                ["📭"],
                "",
                "",
                ["mailbox_with_no_mail"],
                29,
                36,
                15,
                0,
              ],
              "1f4ee": [["📮"], "", "󾔮", ["postbox"], 29, 37, 15, 0],
              "1f4ef": [["📯"], "", "", ["postal_horn"], 29, 38, 15, 0],
              "1f4f0": [["📰"], "", "󾠢", ["newspaper"], 29, 39, 15, 0],
              "1f4f1": [["📱"], "", "󾔥", ["iphone"], 29, 40, 15, 0],
              "1f4f2": [["📲"], "", "󾔦", ["calling"], 29, 41, 15, 0],
              "1f4f3": [["📳"], "", "󾠹", ["vibration_mode"], 29, 42, 15, 0],
              "1f4f4": [["📴"], "", "󾠺", ["mobile_phone_off"], 29, 43, 15, 0],
              "1f4f5": [["📵"], "", "", ["no_mobile_phones"], 29, 44, 15, 0],
              "1f4f6": [["📶"], "", "󾠸", ["signal_strength"], 29, 45, 15, 0],
              "1f4f7": [["📷"], "", "󾓯", ["camera"], 29, 46, 15, 0],
              "1f4f8": [["📸"], "", "", ["camera_with_flash"], 29, 47, 15, 0],
              "1f4f9": [["📹"], "", "󾓹", ["video_camera"], 29, 48, 15, 0],
              "1f4fa": [["📺"], "", "󾠜", ["tv"], 29, 49, 15, 0],
              "1f4fb": [["📻"], "", "󾠟", ["radio"], 29, 50, 15, 0],
              "1f4fc": [["📼"], "", "󾠠", ["vhs"], 29, 51, 15, 0],
              "1f4fd-fe0f": [
                ["📽️", "📽"],
                "",
                "",
                ["film_projector"],
                29,
                52,
                15,
                0,
              ],
              "1f4ff": [["📿"], "", "", ["prayer_beads"], 29, 53, 15, 0],
              "1f500": [
                ["🔀"],
                "",
                "",
                ["twisted_rightwards_arrows"],
                29,
                54,
                15,
                0,
              ],
              "1f501": [["🔁"], "", "", ["repeat"], 29, 55, 15, 0],
              "1f502": [["🔂"], "", "", ["repeat_one"], 29, 56, 15, 0],
              "1f503": [["🔃"], "", "󾮑", ["arrows_clockwise"], 29, 57, 15, 0],
              "1f504": [
                ["🔄"],
                "",
                "",
                ["arrows_counterclockwise"],
                29,
                58,
                15,
                0,
              ],
              "1f505": [["🔅"], "", "", ["low_brightness"], 29, 59, 15, 0],
              "1f506": [["🔆"], "", "", ["high_brightness"], 30, 0, 15, 0],
              "1f507": [["🔇"], "", "", ["mute"], 30, 1, 15, 0],
              "1f508": [["🔈"], "", "", ["speaker"], 30, 2, 15, 0],
              "1f509": [["🔉"], "", "", ["sound"], 30, 3, 15, 0],
              "1f50a": [["🔊"], "", "󾠡", ["loud_sound"], 30, 4, 15, 0],
              "1f50b": [["🔋"], "", "󾓼", ["battery"], 30, 5, 15, 0],
              "1f50c": [["🔌"], "", "󾓾", ["electric_plug"], 30, 6, 15, 0],
              "1f50d": [["🔍"], "", "󾮅", ["mag"], 30, 7, 15, 0],
              "1f50e": [["🔎"], "", "󾮍", ["mag_right"], 30, 8, 15, 0],
              "1f50f": [["🔏"], "", "󾮐", ["lock_with_ink_pen"], 30, 9, 15, 0],
              "1f510": [
                ["🔐"],
                "",
                "󾮊",
                ["closed_lock_with_key"],
                30,
                10,
                15,
                0,
              ],
              "1f511": [["🔑"], "", "󾮂", ["key"], 30, 11, 15, 0],
              "1f512": [["🔒"], "", "󾮆", ["lock"], 30, 12, 15, 0],
              "1f513": [["🔓"], "", "󾮇", ["unlock"], 30, 13, 15, 0],
              "1f514": [["🔔"], "", "󾓲", ["bell"], 30, 14, 15, 0],
              "1f515": [["🔕"], "", "", ["no_bell"], 30, 15, 15, 0],
              "1f516": [["🔖"], "", "󾮏", ["bookmark"], 30, 16, 15, 0],
              "1f517": [["🔗"], "", "󾭋", ["link"], 30, 17, 15, 0],
              "1f518": [["🔘"], "", "󾮌", ["radio_button"], 30, 18, 15, 0],
              "1f519": [["🔙"], "", "󾮎", ["back"], 30, 19, 15, 0],
              "1f51a": [["🔚"], "", "󾀚", ["end"], 30, 20, 15, 0],
              "1f51b": [["🔛"], "", "󾀙", ["on"], 30, 21, 15, 0],
              "1f51c": [["🔜"], "", "󾀘", ["soon"], 30, 22, 15, 0],
              "1f51d": [["🔝"], "", "󾭂", ["top"], 30, 23, 15, 0],
              "1f51e": [["🔞"], "", "󾬥", ["underage"], 30, 24, 15, 0],
              "1f51f": [["🔟"], "", "󾠻", ["keycap_ten"], 30, 25, 15, 0],
              "1f520": [["🔠"], "", "󾭼", ["capital_abcd"], 30, 26, 15, 0],
              "1f521": [["🔡"], "", "󾭽", ["abcd"], 30, 27, 15, 0],
              "1f522": [["🔢"], "", "󾭾", ["1234"], 30, 28, 15, 0],
              "1f523": [["🔣"], "", "󾭿", ["symbols"], 30, 29, 15, 0],
              "1f524": [["🔤"], "", "󾮀", ["abc"], 30, 30, 15, 0],
              "1f525": [["🔥"], "", "󾓶", ["fire"], 30, 31, 15, 0],
              "1f526": [["🔦"], "", "󾓻", ["flashlight"], 30, 32, 15, 0],
              "1f527": [["🔧"], "", "󾓉", ["wrench"], 30, 33, 15, 0],
              "1f528": [["🔨"], "", "󾓊", ["hammer"], 30, 34, 15, 0],
              "1f529": [["🔩"], "", "󾓋", ["nut_and_bolt"], 30, 35, 15, 0],
              "1f52a": [["🔪"], "", "󾓺", ["hocho", "knife"], 30, 36, 15, 0],
              "1f52b": [["🔫"], "", "󾓵", ["gun"], 30, 37, 15, 0],
              "1f52c": [["🔬"], "", "", ["microscope"], 30, 38, 15, 0],
              "1f52d": [["🔭"], "", "", ["telescope"], 30, 39, 15, 0],
              "1f52e": [["🔮"], "", "󾓷", ["crystal_ball"], 30, 40, 15, 0],
              "1f52f": [["🔯"], "", "󾓸", ["six_pointed_star"], 30, 41, 15, 0],
              "1f530": [["🔰"], "", "󾁄", ["beginner"], 30, 42, 15, 0],
              "1f531": [["🔱"], "", "󾓒", ["trident"], 30, 43, 15, 0],
              "1f532": [
                ["🔲"],
                "",
                "󾭤",
                ["black_square_button"],
                30,
                44,
                15,
                0,
              ],
              "1f533": [
                ["🔳"],
                "",
                "󾭧",
                ["white_square_button"],
                30,
                45,
                15,
                0,
              ],
              "1f534": [["🔴"], "", "󾭣", ["red_circle"], 30, 46, 15, 0],
              "1f535": [["🔵"], "", "󾭤", ["large_blue_circle"], 30, 47, 15, 0],
              "1f536": [
                ["🔶"],
                "",
                "󾭳",
                ["large_orange_diamond"],
                30,
                48,
                15,
                0,
              ],
              "1f537": [["🔷"], "", "󾭴", ["large_blue_diamond"], 30, 49, 15, 0],
              "1f538": [
                ["🔸"],
                "",
                "󾭵",
                ["small_orange_diamond"],
                30,
                50,
                15,
                0,
              ],
              "1f539": [["🔹"], "", "󾭶", ["small_blue_diamond"], 30, 51, 15, 0],
              "1f53a": [["🔺"], "", "󾭸", ["small_red_triangle"], 30, 52, 15, 0],
              "1f53b": [
                ["🔻"],
                "",
                "󾭹",
                ["small_red_triangle_down"],
                30,
                53,
                15,
                0,
              ],
              "1f53c": [["🔼"], "", "󾬁", ["arrow_up_small"], 30, 54, 15, 0],
              "1f53d": [["🔽"], "", "󾬀", ["arrow_down_small"], 30, 55, 15, 0],
              "1f549-fe0f": [["🕉️", "🕉"], "", "", ["om_symbol"], 30, 56, 15, 0],
              "1f54a-fe0f": [
                ["🕊️", "🕊"],
                "",
                "",
                ["dove_of_peace"],
                30,
                57,
                15,
                0,
              ],
              "1f54b": [["🕋"], "", "", ["kaaba"], 30, 58, 15, 0],
              "1f54c": [["🕌"], "", "", ["mosque"], 30, 59, 15, 0],
              "1f54d": [["🕍"], "", "", ["synagogue"], 31, 0, 15, 0],
              "1f54e": [
                ["🕎"],
                "",
                "",
                ["menorah_with_nine_branches"],
                31,
                1,
                15,
                0,
              ],
              "1f550": [["🕐"], "", "󾀞", ["clock1"], 31, 2, 15, 0],
              "1f551": [["🕑"], "", "󾀟", ["clock2"], 31, 3, 15, 0],
              "1f552": [["🕒"], "", "󾀠", ["clock3"], 31, 4, 15, 0],
              "1f553": [["🕓"], "", "󾀡", ["clock4"], 31, 5, 15, 0],
              "1f554": [["🕔"], "", "󾀢", ["clock5"], 31, 6, 15, 0],
              "1f555": [["🕕"], "", "󾀣", ["clock6"], 31, 7, 15, 0],
              "1f556": [["🕖"], "", "󾀤", ["clock7"], 31, 8, 15, 0],
              "1f557": [["🕗"], "", "󾀥", ["clock8"], 31, 9, 15, 0],
              "1f558": [["🕘"], "", "󾀦", ["clock9"], 31, 10, 15, 0],
              "1f559": [["🕙"], "", "󾀧", ["clock10"], 31, 11, 15, 0],
              "1f55a": [["🕚"], "", "󾀨", ["clock11"], 31, 12, 15, 0],
              "1f55b": [["🕛"], "", "󾀩", ["clock12"], 31, 13, 15, 0],
              "1f55c": [["🕜"], "", "", ["clock130"], 31, 14, 15, 0],
              "1f55d": [["🕝"], "", "", ["clock230"], 31, 15, 15, 0],
              "1f55e": [["🕞"], "", "", ["clock330"], 31, 16, 15, 0],
              "1f55f": [["🕟"], "", "", ["clock430"], 31, 17, 15, 0],
              "1f560": [["🕠"], "", "", ["clock530"], 31, 18, 15, 0],
              "1f561": [["🕡"], "", "", ["clock630"], 31, 19, 15, 0],
              "1f562": [["🕢"], "", "", ["clock730"], 31, 20, 15, 0],
              "1f563": [["🕣"], "", "", ["clock830"], 31, 21, 15, 0],
              "1f564": [["🕤"], "", "", ["clock930"], 31, 22, 15, 0],
              "1f565": [["🕥"], "", "", ["clock1030"], 31, 23, 15, 0],
              "1f566": [["🕦"], "", "", ["clock1130"], 31, 24, 15, 0],
              "1f567": [["🕧"], "", "", ["clock1230"], 31, 25, 15, 0],
              "1f56f-fe0f": [["🕯️", "🕯"], "", "", ["candle"], 31, 26, 15, 0],
              "1f570-fe0f": [
                ["🕰️", "🕰"],
                "",
                "",
                ["mantelpiece_clock"],
                31,
                27,
                15,
                0,
              ],
              "1f573-fe0f": [["🕳️", "🕳"], "", "", ["hole"], 31, 28, 15, 0],
              "1f574-fe0f": [
                ["🕴️", "🕴"],
                "",
                "",
                ["man_in_business_suit_levitating"],
                31,
                29,
                15,
                0,
              ],
              "1f575-fe0f-200d-2640-fe0f": [
                ["🕵️‍♀️"],
                "",
                "",
                ["female-detective"],
                31,
                35,
                7,
                0,
              ],
              "1f575-fe0f-200d-2642-fe0f": [
                ["🕵️‍♂️", "🕵️", "🕵"],
                "",
                "",
                ["male-detective", "sleuth_or_spy"],
                31,
                41,
                7,
                0,
              ],
              "1f576-fe0f": [
                ["🕶️", "🕶"],
                "",
                "",
                ["dark_sunglasses"],
                31,
                53,
                15,
                0,
              ],
              "1f577-fe0f": [["🕷️", "🕷"], "", "", ["spider"], 31, 54, 15, 0],
              "1f578-fe0f": [
                ["🕸️", "🕸"],
                "",
                "",
                ["spider_web"],
                31,
                55,
                15,
                0,
              ],
              "1f579-fe0f": [["🕹️", "🕹"], "", "", ["joystick"], 31, 56, 15, 0],
              "1f57a": [["🕺"], "", "", ["man_dancing"], 31, 57, 15, 0],
              "1f587-fe0f": [
                ["🖇️", "🖇"],
                "",
                "",
                ["linked_paperclips"],
                32,
                3,
                15,
                0,
              ],
              "1f58a-fe0f": [
                ["🖊️", "🖊"],
                "",
                "",
                ["lower_left_ballpoint_pen"],
                32,
                4,
                15,
                0,
              ],
              "1f58b-fe0f": [
                ["🖋️", "🖋"],
                "",
                "",
                ["lower_left_fountain_pen"],
                32,
                5,
                15,
                0,
              ],
              "1f58c-fe0f": [
                ["🖌️", "🖌"],
                "",
                "",
                ["lower_left_paintbrush"],
                32,
                6,
                15,
                0,
              ],
              "1f58d-fe0f": [
                ["🖍️", "🖍"],
                "",
                "",
                ["lower_left_crayon"],
                32,
                7,
                15,
                0,
              ],
              "1f590-fe0f": [
                ["🖐️", "🖐"],
                "",
                "",
                ["raised_hand_with_fingers_splayed"],
                32,
                8,
                15,
                0,
              ],
              "1f595": [
                ["🖕"],
                "",
                "",
                ["middle_finger", "reversed_hand_with_middle_finger_extended"],
                32,
                14,
                15,
                0,
              ],
              "1f596": [["🖖"], "", "", ["spock-hand"], 32, 20, 15, 0],
              "1f5a4": [["🖤"], "", "", ["black_heart"], 32, 26, 15, 0],
              "1f5a5-fe0f": [
                ["🖥️", "🖥"],
                "",
                "",
                ["desktop_computer"],
                32,
                27,
                15,
                0,
              ],
              "1f5a8-fe0f": [["🖨️", "🖨"], "", "", ["printer"], 32, 28, 15, 0],
              "1f5b1-fe0f": [
                ["🖱️", "🖱"],
                "",
                "",
                ["three_button_mouse"],
                32,
                29,
                15,
                0,
              ],
              "1f5b2-fe0f": [["🖲️", "🖲"], "", "", ["trackball"], 32, 30, 15, 0],
              "1f5bc-fe0f": [
                ["🖼️", "🖼"],
                "",
                "",
                ["frame_with_picture"],
                32,
                31,
                15,
                0,
              ],
              "1f5c2-fe0f": [
                ["🗂️", "🗂"],
                "",
                "",
                ["card_index_dividers"],
                32,
                32,
                15,
                0,
              ],
              "1f5c3-fe0f": [
                ["🗃️", "🗃"],
                "",
                "",
                ["card_file_box"],
                32,
                33,
                15,
                0,
              ],
              "1f5c4-fe0f": [
                ["🗄️", "🗄"],
                "",
                "",
                ["file_cabinet"],
                32,
                34,
                15,
                0,
              ],
              "1f5d1-fe0f": [
                ["🗑️", "🗑"],
                "",
                "",
                ["wastebasket"],
                32,
                35,
                15,
                0,
              ],
              "1f5d2-fe0f": [
                ["🗒️", "🗒"],
                "",
                "",
                ["spiral_note_pad"],
                32,
                36,
                15,
                0,
              ],
              "1f5d3-fe0f": [
                ["🗓️", "🗓"],
                "",
                "",
                ["spiral_calendar_pad"],
                32,
                37,
                15,
                0,
              ],
              "1f5dc-fe0f": [
                ["🗜️", "🗜"],
                "",
                "",
                ["compression"],
                32,
                38,
                15,
                0,
              ],
              "1f5dd-fe0f": [["🗝️", "🗝"], "", "", ["old_key"], 32, 39, 15, 0],
              "1f5de-fe0f": [
                ["🗞️", "🗞"],
                "",
                "",
                ["rolled_up_newspaper"],
                32,
                40,
                15,
                0,
              ],
              "1f5e1-fe0f": [
                ["🗡️", "🗡"],
                "",
                "",
                ["dagger_knife"],
                32,
                41,
                15,
                0,
              ],
              "1f5e3-fe0f": [
                ["🗣️", "🗣"],
                "",
                "",
                ["speaking_head_in_silhouette"],
                32,
                42,
                15,
                0,
              ],
              "1f5e8-fe0f": [
                ["🗨️", "🗨"],
                "",
                "",
                ["left_speech_bubble"],
                32,
                43,
                15,
                0,
              ],
              "1f5ef-fe0f": [
                ["🗯️", "🗯"],
                "",
                "",
                ["right_anger_bubble"],
                32,
                44,
                15,
                0,
              ],
              "1f5f3-fe0f": [
                ["🗳️", "🗳"],
                "",
                "",
                ["ballot_box_with_ballot"],
                32,
                45,
                15,
                0,
              ],
              "1f5fa-fe0f": [["🗺️", "🗺"], "", "", ["world_map"], 32, 46, 15, 0],
              "1f5fb": [["🗻"], "", "󾓃", ["mount_fuji"], 32, 47, 15, 0],
              "1f5fc": [["🗼"], "", "󾓄", ["tokyo_tower"], 32, 48, 15, 0],
              "1f5fd": [["🗽"], "", "󾓆", ["statue_of_liberty"], 32, 49, 15, 0],
              "1f5fe": [["🗾"], "", "󾓇", ["japan"], 32, 50, 15, 0],
              "1f5ff": [["🗿"], "", "󾓈", ["moyai"], 32, 51, 15, 0],
              "1f600": [["😀"], "", "", ["grinning"], 32, 52, 15, 0, ":D"],
              "1f601": [["😁"], "", "󾌳", ["grin"], 32, 53, 15, 0],
              "1f602": [["😂"], "", "󾌴", ["joy"], 32, 54, 15, 0],
              "1f603": [["😃"], "", "󾌰", ["smiley"], 32, 55, 15, 0, ":)"],
              "1f604": [["😄"], "", "󾌸", ["smile"], 32, 56, 15, 0, ":)"],
              "1f605": [["😅"], "", "󾌱", ["sweat_smile"], 32, 57, 15, 0],
              "1f606": [
                ["😆"],
                "",
                "󾌲",
                ["laughing", "satisfied"],
                32,
                58,
                15,
                0,
              ],
              "1f607": [["😇"], "", "", ["innocent"], 32, 59, 15, 0],
              "1f608": [["😈"], "", "", ["smiling_imp"], 33, 0, 15, 0],
              "1f609": [["😉"], "", "󾍇", ["wink"], 33, 1, 15, 0, ";)"],
              "1f60a": [["😊"], "", "󾌵", ["blush"], 33, 2, 15, 0, ":)"],
              "1f60b": [["😋"], "", "󾌫", ["yum"], 33, 3, 15, 0],
              "1f60c": [["😌"], "", "󾌾", ["relieved"], 33, 4, 15, 0],
              "1f60d": [["😍"], "", "󾌧", ["heart_eyes"], 33, 5, 15, 0],
              "1f60e": [["😎"], "", "", ["sunglasses"], 33, 6, 15, 0],
              "1f60f": [["😏"], "", "󾍃", ["smirk"], 33, 7, 15, 0],
              "1f610": [["😐"], "", "", ["neutral_face"], 33, 8, 15, 0],
              "1f611": [["😑"], "", "", ["expressionless"], 33, 9, 15, 0],
              "1f612": [["😒"], "", "󾌦", ["unamused"], 33, 10, 15, 0, ":("],
              "1f613": [["😓"], "", "󾍄", ["sweat"], 33, 11, 15, 0],
              "1f614": [["😔"], "", "󾍀", ["pensive"], 33, 12, 15, 0],
              "1f615": [["😕"], "", "", ["confused"], 33, 13, 15, 0],
              "1f616": [["😖"], "", "󾌿", ["confounded"], 33, 14, 15, 0],
              "1f617": [["😗"], "", "", ["kissing"], 33, 15, 15, 0],
              "1f618": [["😘"], "", "󾌬", ["kissing_heart"], 33, 16, 15, 0],
              "1f619": [
                ["😙"],
                "",
                "",
                ["kissing_smiling_eyes"],
                33,
                17,
                15,
                0,
              ],
              "1f61a": [
                ["😚"],
                "",
                "󾌭",
                ["kissing_closed_eyes"],
                33,
                18,
                15,
                0,
              ],
              "1f61b": [
                ["😛"],
                "",
                "",
                ["stuck_out_tongue"],
                33,
                19,
                15,
                0,
                ":p",
              ],
              "1f61c": [
                ["😜"],
                "",
                "󾌩",
                ["stuck_out_tongue_winking_eye"],
                33,
                20,
                15,
                0,
                ";p",
              ],
              "1f61d": [
                ["😝"],
                "",
                "󾌪",
                ["stuck_out_tongue_closed_eyes"],
                33,
                21,
                15,
                0,
              ],
              "1f61e": [
                ["😞"],
                "",
                "󾌣",
                ["disappointed"],
                33,
                22,
                15,
                0,
                ":(",
              ],
              "1f61f": [["😟"], "", "", ["worried"], 33, 23, 15, 0],
              "1f620": [["😠"], "", "󾌠", ["angry"], 33, 24, 15, 0],
              "1f621": [["😡"], "", "󾌽", ["rage"], 33, 25, 15, 0],
              "1f622": [["😢"], "", "󾌹", ["cry"], 33, 26, 15, 0, ":'("],
              "1f623": [["😣"], "", "󾌼", ["persevere"], 33, 27, 15, 0],
              "1f624": [["😤"], "", "󾌨", ["triumph"], 33, 28, 15, 0],
              "1f625": [
                ["😥"],
                "",
                "󾍅",
                ["disappointed_relieved"],
                33,
                29,
                15,
                0,
              ],
              "1f626": [["😦"], "", "", ["frowning"], 33, 30, 15, 0],
              "1f627": [["😧"], "", "", ["anguished"], 33, 31, 15, 0],
              "1f628": [["😨"], "", "󾌻", ["fearful"], 33, 32, 15, 0],
              "1f629": [["😩"], "", "󾌡", ["weary"], 33, 33, 15, 0],
              "1f62a": [["😪"], "", "󾍂", ["sleepy"], 33, 34, 15, 0],
              "1f62b": [["😫"], "", "󾍆", ["tired_face"], 33, 35, 15, 0],
              "1f62c": [["😬"], "", "", ["grimacing"], 33, 36, 15, 0],
              "1f62d": [["😭"], "", "󾌺", ["sob"], 33, 37, 15, 0, ":'("],
              "1f62e-200d-1f4a8": [
                ["😮‍💨"],
                "",
                "",
                ["face_exhaling"],
                33,
                38,
                7,
                0,
              ],
              "1f62e": [["😮"], "", "", ["open_mouth"], 33, 39, 15, 0],
              "1f62f": [["😯"], "", "", ["hushed"], 33, 40, 15, 0],
              "1f630": [["😰"], "", "󾌥", ["cold_sweat"], 33, 41, 15, 0],
              "1f631": [["😱"], "", "󾍁", ["scream"], 33, 42, 15, 0],
              "1f632": [["😲"], "", "󾌢", ["astonished"], 33, 43, 15, 0],
              "1f633": [["😳"], "", "󾌯", ["flushed"], 33, 44, 15, 0],
              "1f634": [["😴"], "", "", ["sleeping"], 33, 45, 15, 0],
              "1f635-200d-1f4ab": [
                ["😵‍💫"],
                "",
                "",
                ["face_with_spiral_eyes"],
                33,
                46,
                7,
                0,
              ],
              "1f635": [["😵"], "", "󾌤", ["dizzy_face"], 33, 47, 15, 0],
              "1f636-200d-1f32b-fe0f": [
                ["😶‍🌫️", "😶‍🌫"],
                "",
                "",
                ["face_in_clouds"],
                33,
                48,
                7,
                0,
              ],
              "1f636": [["😶"], "", "", ["no_mouth"], 33, 49, 15, 0],
              "1f637": [["😷"], "", "󾌮", ["mask"], 33, 50, 15, 0],
              "1f638": [["😸"], "", "󾍉", ["smile_cat"], 33, 51, 15, 0],
              "1f639": [["😹"], "", "󾍊", ["joy_cat"], 33, 52, 15, 0],
              "1f63a": [["😺"], "", "󾍈", ["smiley_cat"], 33, 53, 15, 0],
              "1f63b": [["😻"], "", "󾍌", ["heart_eyes_cat"], 33, 54, 15, 0],
              "1f63c": [["😼"], "", "󾍏", ["smirk_cat"], 33, 55, 15, 0],
              "1f63d": [["😽"], "", "󾍋", ["kissing_cat"], 33, 56, 15, 0],
              "1f63e": [["😾"], "", "󾍎", ["pouting_cat"], 33, 57, 15, 0],
              "1f63f": [["😿"], "", "󾍍", ["crying_cat_face"], 33, 58, 15, 0],
              "1f640": [["🙀"], "", "󾍐", ["scream_cat"], 33, 59, 15, 0],
              "1f641": [
                ["🙁"],
                "",
                "",
                ["slightly_frowning_face"],
                34,
                0,
                15,
                0,
              ],
              "1f642": [
                ["🙂"],
                "",
                "",
                ["slightly_smiling_face"],
                34,
                1,
                15,
                0,
              ],
              "1f643": [["🙃"], "", "", ["upside_down_face"], 34, 2, 15, 0],
              "1f644": [
                ["🙄"],
                "",
                "",
                ["face_with_rolling_eyes"],
                34,
                3,
                15,
                0,
              ],
              "1f645-200d-2640-fe0f": [
                ["🙅‍♀️", "🙅‍♀", "🙅"],
                "",
                "",
                ["woman-gesturing-no", "no_good"],
                34,
                4,
                15,
                0,
              ],
              "1f645-200d-2642-fe0f": [
                ["🙅‍♂️", "🙅‍♂"],
                "",
                "",
                ["man-gesturing-no"],
                34,
                10,
                15,
                0,
              ],
              "1f646-200d-2640-fe0f": [
                ["🙆‍♀️", "🙆‍♀", "🙆"],
                "",
                "",
                ["woman-gesturing-ok", "ok_woman"],
                34,
                22,
                15,
                0,
              ],
              "1f646-200d-2642-fe0f": [
                ["🙆‍♂️", "🙆‍♂"],
                "",
                "",
                ["man-gesturing-ok"],
                34,
                28,
                15,
                0,
              ],
              "1f647-200d-2640-fe0f": [
                ["🙇‍♀️", "🙇‍♀"],
                "",
                "",
                ["woman-bowing"],
                34,
                40,
                15,
                0,
              ],
              "1f647-200d-2642-fe0f": [
                ["🙇‍♂️", "🙇‍♂", "🙇"],
                "",
                "",
                ["man-bowing", "bow"],
                34,
                46,
                15,
                0,
              ],
              "1f648": [["🙈"], "", "󾍔", ["see_no_evil"], 34, 58, 15, 0],
              "1f649": [["🙉"], "", "󾍖", ["hear_no_evil"], 34, 59, 15, 0],
              "1f64a": [["🙊"], "", "󾍕", ["speak_no_evil"], 35, 0, 15, 0],
              "1f64b-200d-2640-fe0f": [
                ["🙋‍♀️", "🙋‍♀", "🙋"],
                "",
                "",
                ["woman-raising-hand", "raising_hand"],
                35,
                1,
                15,
                0,
              ],
              "1f64b-200d-2642-fe0f": [
                ["🙋‍♂️", "🙋‍♂"],
                "",
                "",
                ["man-raising-hand"],
                35,
                7,
                15,
                0,
              ],
              "1f64c": [["🙌"], "", "󾍘", ["raised_hands"], 35, 19, 15, 0],
              "1f64d-200d-2640-fe0f": [
                ["🙍‍♀️", "🙍‍♀", "🙍"],
                "",
                "",
                ["woman-frowning", "person_frowning"],
                35,
                25,
                15,
                0,
              ],
              "1f64d-200d-2642-fe0f": [
                ["🙍‍♂️", "🙍‍♂"],
                "",
                "",
                ["man-frowning"],
                35,
                31,
                15,
                0,
              ],
              "1f64e-200d-2640-fe0f": [
                ["🙎‍♀️", "🙎‍♀", "🙎"],
                "",
                "",
                ["woman-pouting", "person_with_pouting_face"],
                35,
                43,
                15,
                0,
              ],
              "1f64e-200d-2642-fe0f": [
                ["🙎‍♂️", "🙎‍♂"],
                "",
                "",
                ["man-pouting"],
                35,
                49,
                15,
                0,
              ],
              "1f64f": [["🙏"], "", "󾍛", ["pray"], 36, 1, 15, 0],
              "1f680": [["🚀"], "", "󾟭", ["rocket"], 36, 7, 15, 0],
              "1f681": [["🚁"], "", "", ["helicopter"], 36, 8, 15, 0],
              "1f682": [["🚂"], "", "", ["steam_locomotive"], 36, 9, 15, 0],
              "1f683": [["🚃"], "", "󾟟", ["railway_car"], 36, 10, 15, 0],
              "1f684": [["🚄"], "", "󾟢", ["bullettrain_side"], 36, 11, 15, 0],
              "1f685": [["🚅"], "", "󾟣", ["bullettrain_front"], 36, 12, 15, 0],
              "1f686": [["🚆"], "", "", ["train2"], 36, 13, 15, 0],
              "1f687": [["🚇"], "", "󾟠", ["metro"], 36, 14, 15, 0],
              "1f688": [["🚈"], "", "", ["light_rail"], 36, 15, 15, 0],
              "1f689": [["🚉"], "", "󾟬", ["station"], 36, 16, 15, 0],
              "1f68a": [["🚊"], "", "", ["tram"], 36, 17, 15, 0],
              "1f68b": [["🚋"], "", "", ["train"], 36, 18, 15, 0],
              "1f68c": [["🚌"], "", "󾟦", ["bus"], 36, 19, 15, 0],
              "1f68d": [["🚍"], "", "", ["oncoming_bus"], 36, 20, 15, 0],
              "1f68e": [["🚎"], "", "", ["trolleybus"], 36, 21, 15, 0],
              "1f68f": [["🚏"], "", "󾟧", ["busstop"], 36, 22, 15, 0],
              "1f690": [["🚐"], "", "", ["minibus"], 36, 23, 15, 0],
              "1f691": [["🚑"], "", "󾟳", ["ambulance"], 36, 24, 15, 0],
              "1f692": [["🚒"], "", "󾟲", ["fire_engine"], 36, 25, 15, 0],
              "1f693": [["🚓"], "", "󾟴", ["police_car"], 36, 26, 15, 0],
              "1f694": [["🚔"], "", "", ["oncoming_police_car"], 36, 27, 15, 0],
              "1f695": [["🚕"], "", "󾟯", ["taxi"], 36, 28, 15, 0],
              "1f696": [["🚖"], "", "", ["oncoming_taxi"], 36, 29, 15, 0],
              "1f697": [["🚗"], "", "󾟤", ["car", "red_car"], 36, 30, 15, 0],
              "1f698": [["🚘"], "", "", ["oncoming_automobile"], 36, 31, 15, 0],
              "1f699": [["🚙"], "", "󾟥", ["blue_car"], 36, 32, 15, 0],
              "1f69a": [["🚚"], "", "󾟱", ["truck"], 36, 33, 15, 0],
              "1f69b": [["🚛"], "", "", ["articulated_lorry"], 36, 34, 15, 0],
              "1f69c": [["🚜"], "", "", ["tractor"], 36, 35, 15, 0],
              "1f69d": [["🚝"], "", "", ["monorail"], 36, 36, 15, 0],
              "1f69e": [["🚞"], "", "", ["mountain_railway"], 36, 37, 15, 0],
              "1f69f": [["🚟"], "", "", ["suspension_railway"], 36, 38, 15, 0],
              "1f6a0": [["🚠"], "", "", ["mountain_cableway"], 36, 39, 15, 0],
              "1f6a1": [["🚡"], "", "", ["aerial_tramway"], 36, 40, 15, 0],
              "1f6a2": [["🚢"], "", "󾟨", ["ship"], 36, 41, 15, 0],
              "1f6a3-200d-2640-fe0f": [
                ["🚣‍♀️", "🚣‍♀"],
                "",
                "",
                ["woman-rowing-boat"],
                36,
                42,
                15,
                0,
              ],
              "1f6a3-200d-2642-fe0f": [
                ["🚣‍♂️", "🚣‍♂", "🚣"],
                "",
                "",
                ["man-rowing-boat", "rowboat"],
                36,
                48,
                15,
                0,
              ],
              "1f6a4": [["🚤"], "", "󾟮", ["speedboat"], 37, 0, 15, 0],
              "1f6a5": [["🚥"], "", "󾟷", ["traffic_light"], 37, 1, 15, 0],
              "1f6a6": [
                ["🚦"],
                "",
                "",
                ["vertical_traffic_light"],
                37,
                2,
                15,
                0,
              ],
              "1f6a7": [["🚧"], "", "󾟸", ["construction"], 37, 3, 15, 0],
              "1f6a8": [["🚨"], "", "󾟹", ["rotating_light"], 37, 4, 15, 0],
              "1f6a9": [
                ["🚩"],
                "",
                "󾬢",
                ["triangular_flag_on_post"],
                37,
                5,
                15,
                0,
              ],
              "1f6aa": [["🚪"], "", "󾓳", ["door"], 37, 6, 15, 0],
              "1f6ab": [["🚫"], "", "󾭈", ["no_entry_sign"], 37, 7, 15, 0],
              "1f6ac": [["🚬"], "", "󾬞", ["smoking"], 37, 8, 15, 0],
              "1f6ad": [["🚭"], "", "󾬟", ["no_smoking"], 37, 9, 15, 0],
              "1f6ae": [
                ["🚮"],
                "",
                "",
                ["put_litter_in_its_place"],
                37,
                10,
                15,
                0,
              ],
              "1f6af": [["🚯"], "", "", ["do_not_litter"], 37, 11, 15, 0],
              "1f6b0": [["🚰"], "", "", ["potable_water"], 37, 12, 15, 0],
              "1f6b1": [["🚱"], "", "", ["non-potable_water"], 37, 13, 15, 0],
              "1f6b2": [["🚲"], "", "󾟫", ["bike"], 37, 14, 15, 0],
              "1f6b3": [["🚳"], "", "", ["no_bicycles"], 37, 15, 15, 0],
              "1f6b4-200d-2640-fe0f": [
                ["🚴‍♀️", "🚴‍♀"],
                "",
                "",
                ["woman-biking"],
                37,
                16,
                15,
                0,
              ],
              "1f6b4-200d-2642-fe0f": [
                ["🚴‍♂️", "🚴‍♂", "🚴"],
                "",
                "",
                ["man-biking", "bicyclist"],
                37,
                22,
                15,
                0,
              ],
              "1f6b5-200d-2640-fe0f": [
                ["🚵‍♀️", "🚵‍♀"],
                "",
                "",
                ["woman-mountain-biking"],
                37,
                34,
                15,
                0,
              ],
              "1f6b5-200d-2642-fe0f": [
                ["🚵‍♂️", "🚵‍♂", "🚵"],
                "",
                "",
                ["man-mountain-biking", "mountain_bicyclist"],
                37,
                40,
                15,
                0,
              ],
              "1f6b6-200d-2640-fe0f": [
                ["🚶‍♀️", "🚶‍♀"],
                "",
                "",
                ["woman-walking"],
                37,
                52,
                15,
                0,
              ],
              "1f6b6-200d-2642-fe0f": [
                ["🚶‍♂️", "🚶‍♂", "🚶"],
                "",
                "",
                ["man-walking", "walking"],
                37,
                58,
                15,
                0,
              ],
              "1f6b7": [["🚷"], "", "", ["no_pedestrians"], 38, 10, 15, 0],
              "1f6b8": [["🚸"], "", "", ["children_crossing"], 38, 11, 15, 0],
              "1f6b9": [["🚹"], "", "󾬳", ["mens"], 38, 12, 15, 0],
              "1f6ba": [["🚺"], "", "󾬴", ["womens"], 38, 13, 15, 0],
              "1f6bb": [["🚻"], "", "󾔆", ["restroom"], 38, 14, 15, 0],
              "1f6bc": [["🚼"], "", "󾬵", ["baby_symbol"], 38, 15, 15, 0],
              "1f6bd": [["🚽"], "", "󾔇", ["toilet"], 38, 16, 15, 0],
              "1f6be": [["🚾"], "", "󾔈", ["wc"], 38, 17, 15, 0],
              "1f6bf": [["🚿"], "", "", ["shower"], 38, 18, 15, 0],
              "1f6c0": [["🛀"], "", "󾔅", ["bath"], 38, 19, 15, 0],
              "1f6c1": [["🛁"], "", "", ["bathtub"], 38, 25, 15, 0],
              "1f6c2": [["🛂"], "", "", ["passport_control"], 38, 26, 15, 0],
              "1f6c3": [["🛃"], "", "", ["customs"], 38, 27, 15, 0],
              "1f6c4": [["🛄"], "", "", ["baggage_claim"], 38, 28, 15, 0],
              "1f6c5": [["🛅"], "", "", ["left_luggage"], 38, 29, 15, 0],
              "1f6cb-fe0f": [
                ["🛋️", "🛋"],
                "",
                "",
                ["couch_and_lamp"],
                38,
                30,
                15,
                0,
              ],
              "1f6cc": [
                ["🛌"],
                "",
                "",
                ["sleeping_accommodation"],
                38,
                31,
                15,
                0,
              ],
              "1f6cd-fe0f": [
                ["🛍️", "🛍"],
                "",
                "",
                ["shopping_bags"],
                38,
                37,
                15,
                0,
              ],
              "1f6ce-fe0f": [
                ["🛎️", "🛎"],
                "",
                "",
                ["bellhop_bell"],
                38,
                38,
                15,
                0,
              ],
              "1f6cf-fe0f": [["🛏️", "🛏"], "", "", ["bed"], 38, 39, 15, 0],
              "1f6d0": [["🛐"], "", "", ["place_of_worship"], 38, 40, 15, 0],
              "1f6d1": [["🛑"], "", "", ["octagonal_sign"], 38, 41, 15, 0],
              "1f6d2": [["🛒"], "", "", ["shopping_trolley"], 38, 42, 15, 0],
              "1f6d5": [["🛕"], "", "", ["hindu_temple"], 38, 43, 15, 0],
              "1f6d6": [["🛖"], "", "", ["hut"], 38, 44, 15, 0],
              "1f6d7": [["🛗"], "", "", ["elevator"], 38, 45, 15, 0],
              "1f6e0-fe0f": [
                ["🛠️", "🛠"],
                "",
                "",
                ["hammer_and_wrench"],
                38,
                46,
                15,
                0,
              ],
              "1f6e1-fe0f": [["🛡️", "🛡"], "", "", ["shield"], 38, 47, 15, 0],
              "1f6e2-fe0f": [["🛢️", "🛢"], "", "", ["oil_drum"], 38, 48, 15, 0],
              "1f6e3-fe0f": [["🛣️", "🛣"], "", "", ["motorway"], 38, 49, 15, 0],
              "1f6e4-fe0f": [
                ["🛤️", "🛤"],
                "",
                "",
                ["railway_track"],
                38,
                50,
                15,
                0,
              ],
              "1f6e5-fe0f": [
                ["🛥️", "🛥"],
                "",
                "",
                ["motor_boat"],
                38,
                51,
                15,
                0,
              ],
              "1f6e9-fe0f": [
                ["🛩️", "🛩"],
                "",
                "",
                ["small_airplane"],
                38,
                52,
                15,
                0,
              ],
              "1f6eb": [["🛫"], "", "", ["airplane_departure"], 38, 53, 15, 0],
              "1f6ec": [["🛬"], "", "", ["airplane_arriving"], 38, 54, 15, 0],
              "1f6f0-fe0f": [["🛰️", "🛰"], "", "", ["satellite"], 38, 55, 15, 0],
              "1f6f3-fe0f": [
                ["🛳️", "🛳"],
                "",
                "",
                ["passenger_ship"],
                38,
                56,
                15,
                0,
              ],
              "1f6f4": [["🛴"], "", "", ["scooter"], 38, 57, 15, 0],
              "1f6f5": [["🛵"], "", "", ["motor_scooter"], 38, 58, 15, 0],
              "1f6f6": [["🛶"], "", "", ["canoe"], 38, 59, 15, 0],
              "1f6f7": [["🛷"], "", "", ["sled"], 39, 0, 15, 0],
              "1f6f8": [["🛸"], "", "", ["flying_saucer"], 39, 1, 15, 0],
              "1f6f9": [["🛹"], "", "", ["skateboard"], 39, 2, 15, 0],
              "1f6fa": [["🛺"], "", "", ["auto_rickshaw"], 39, 3, 15, 0],
              "1f6fb": [["🛻"], "", "", ["pickup_truck"], 39, 4, 15, 0],
              "1f6fc": [["🛼"], "", "", ["roller_skate"], 39, 5, 15, 0],
              "1f7e0": [["🟠"], "", "", ["large_orange_circle"], 39, 6, 15, 0],
              "1f7e1": [["🟡"], "", "", ["large_yellow_circle"], 39, 7, 15, 0],
              "1f7e2": [["🟢"], "", "", ["large_green_circle"], 39, 8, 15, 0],
              "1f7e3": [["🟣"], "", "", ["large_purple_circle"], 39, 9, 15, 0],
              "1f7e4": [["🟤"], "", "", ["large_brown_circle"], 39, 10, 15, 0],
              "1f7e5": [["🟥"], "", "", ["large_red_square"], 39, 11, 15, 0],
              "1f7e6": [["🟦"], "", "", ["large_blue_square"], 39, 12, 15, 0],
              "1f7e7": [["🟧"], "", "", ["large_orange_square"], 39, 13, 15, 0],
              "1f7e8": [["🟨"], "", "", ["large_yellow_square"], 39, 14, 15, 0],
              "1f7e9": [["🟩"], "", "", ["large_green_square"], 39, 15, 15, 0],
              "1f7ea": [["🟪"], "", "", ["large_purple_square"], 39, 16, 15, 0],
              "1f7eb": [["🟫"], "", "", ["large_brown_square"], 39, 17, 15, 0],
              "1f90c": [["🤌"], "", "", ["pinched_fingers"], 39, 18, 15, 0],
              "1f90d": [["🤍"], "", "", ["white_heart"], 39, 24, 15, 0],
              "1f90e": [["🤎"], "", "", ["brown_heart"], 39, 25, 15, 0],
              "1f90f": [["🤏"], "", "", ["pinching_hand"], 39, 26, 15, 0],
              "1f910": [["🤐"], "", "", ["zipper_mouth_face"], 39, 32, 15, 0],
              "1f911": [["🤑"], "", "", ["money_mouth_face"], 39, 33, 15, 0],
              "1f912": [
                ["🤒"],
                "",
                "",
                ["face_with_thermometer"],
                39,
                34,
                15,
                0,
              ],
              "1f913": [["🤓"], "", "", ["nerd_face"], 39, 35, 15, 0],
              "1f914": [["🤔"], "", "", ["thinking_face"], 39, 36, 15, 0],
              "1f915": [
                ["🤕"],
                "",
                "",
                ["face_with_head_bandage"],
                39,
                37,
                15,
                0,
              ],
              "1f916": [["🤖"], "", "", ["robot_face"], 39, 38, 15, 0],
              "1f917": [["🤗"], "", "", ["hugging_face"], 39, 39, 15, 0],
              "1f918": [
                ["🤘"],
                "",
                "",
                ["the_horns", "sign_of_the_horns"],
                39,
                40,
                15,
                0,
              ],
              "1f919": [["🤙"], "", "", ["call_me_hand"], 39, 46, 15, 0],
              "1f91a": [["🤚"], "", "", ["raised_back_of_hand"], 39, 52, 15, 0],
              "1f91b": [["🤛"], "", "", ["left-facing_fist"], 39, 58, 15, 0],
              "1f91c": [["🤜"], "", "", ["right-facing_fist"], 40, 4, 15, 0],
              "1f91d": [["🤝"], "", "", ["handshake"], 40, 10, 15, 0],
              "1f91e": [
                ["🤞"],
                "",
                "",
                [
                  "crossed_fingers",
                  "hand_with_index_and_middle_fingers_crossed",
                ],
                40,
                11,
                15,
                0,
              ],
              "1f91f": [
                ["🤟"],
                "",
                "",
                ["i_love_you_hand_sign"],
                40,
                17,
                15,
                0,
              ],
              "1f920": [
                ["🤠"],
                "",
                "",
                ["face_with_cowboy_hat"],
                40,
                23,
                15,
                0,
              ],
              "1f921": [["🤡"], "", "", ["clown_face"], 40, 24, 15, 0],
              "1f922": [["🤢"], "", "", ["nauseated_face"], 40, 25, 15, 0],
              "1f923": [
                ["🤣"],
                "",
                "",
                ["rolling_on_the_floor_laughing"],
                40,
                26,
                15,
                0,
              ],
              "1f924": [["🤤"], "", "", ["drooling_face"], 40, 27, 15, 0],
              "1f925": [["🤥"], "", "", ["lying_face"], 40, 28, 15, 0],
              "1f926-200d-2640-fe0f": [
                ["🤦‍♀️", "🤦‍♀"],
                "",
                "",
                ["woman-facepalming"],
                40,
                29,
                15,
                0,
              ],
              "1f926-200d-2642-fe0f": [
                ["🤦‍♂️", "🤦‍♂"],
                "",
                "",
                ["man-facepalming"],
                40,
                35,
                15,
                0,
              ],
              "1f926": [["🤦"], "", "", ["face_palm"], 40, 41, 15, 0],
              "1f927": [["🤧"], "", "", ["sneezing_face"], 40, 47, 15, 0],
              "1f928": [
                ["🤨"],
                "",
                "",
                ["face_with_raised_eyebrow", "face_with_one_eyebrow_raised"],
                40,
                48,
                15,
                0,
              ],
              "1f929": [
                ["🤩"],
                "",
                "",
                ["star-struck", "grinning_face_with_star_eyes"],
                40,
                49,
                15,
                0,
              ],
              "1f92a": [
                ["🤪"],
                "",
                "",
                ["zany_face", "grinning_face_with_one_large_and_one_small_eye"],
                40,
                50,
                15,
                0,
              ],
              "1f92b": [
                ["🤫"],
                "",
                "",
                ["shushing_face", "face_with_finger_covering_closed_lips"],
                40,
                51,
                15,
                0,
              ],
              "1f92c": [
                ["🤬"],
                "",
                "",
                [
                  "face_with_symbols_on_mouth",
                  "serious_face_with_symbols_covering_mouth",
                ],
                40,
                52,
                15,
                0,
              ],
              "1f92d": [
                ["🤭"],
                "",
                "",
                [
                  "face_with_hand_over_mouth",
                  "smiling_face_with_smiling_eyes_and_hand_covering_mouth",
                ],
                40,
                53,
                15,
                0,
              ],
              "1f92e": [
                ["🤮"],
                "",
                "",
                ["face_vomiting", "face_with_open_mouth_vomiting"],
                40,
                54,
                15,
                0,
              ],
              "1f92f": [
                ["🤯"],
                "",
                "",
                ["exploding_head", "shocked_face_with_exploding_head"],
                40,
                55,
                15,
                0,
              ],
              "1f930": [["🤰"], "", "", ["pregnant_woman"], 40, 56, 15, 0],
              "1f931": [["🤱"], "", "", ["breast-feeding"], 41, 2, 15, 0],
              "1f932": [["🤲"], "", "", ["palms_up_together"], 41, 8, 15, 0],
              "1f933": [["🤳"], "", "", ["selfie"], 41, 14, 15, 0],
              "1f934": [["🤴"], "", "", ["prince"], 41, 20, 15, 0],
              "1f935-200d-2640-fe0f": [
                ["🤵‍♀️", "🤵‍♀"],
                "",
                "",
                ["woman_in_tuxedo"],
                41,
                26,
                15,
                0,
              ],
              "1f935-200d-2642-fe0f": [
                ["🤵‍♂️", "🤵‍♂"],
                "",
                "",
                ["man_in_tuxedo"],
                41,
                32,
                15,
                0,
              ],
              "1f935": [["🤵"], "", "", ["person_in_tuxedo"], 41, 38, 15, 0],
              "1f936": [
                ["🤶"],
                "",
                "",
                ["mrs_claus", "mother_christmas"],
                41,
                44,
                15,
                0,
              ],
              "1f937-200d-2640-fe0f": [
                ["🤷‍♀️", "🤷‍♀"],
                "",
                "",
                ["woman-shrugging"],
                41,
                50,
                15,
                0,
              ],
              "1f937-200d-2642-fe0f": [
                ["🤷‍♂️", "🤷‍♂"],
                "",
                "",
                ["man-shrugging"],
                41,
                56,
                15,
                0,
              ],
              "1f937": [["🤷"], "", "", ["shrug"], 42, 2, 15, 0],
              "1f938-200d-2640-fe0f": [
                ["🤸‍♀️", "🤸‍♀"],
                "",
                "",
                ["woman-cartwheeling"],
                42,
                8,
                15,
                0,
              ],
              "1f938-200d-2642-fe0f": [
                ["🤸‍♂️", "🤸‍♂"],
                "",
                "",
                ["man-cartwheeling"],
                42,
                14,
                15,
                0,
              ],
              "1f938": [
                ["🤸"],
                "",
                "",
                ["person_doing_cartwheel"],
                42,
                20,
                15,
                0,
              ],
              "1f939-200d-2640-fe0f": [
                ["🤹‍♀️", "🤹‍♀"],
                "",
                "",
                ["woman-juggling"],
                42,
                26,
                15,
                0,
              ],
              "1f939-200d-2642-fe0f": [
                ["🤹‍♂️", "🤹‍♂"],
                "",
                "",
                ["man-juggling"],
                42,
                32,
                15,
                0,
              ],
              "1f939": [["🤹"], "", "", ["juggling"], 42, 38, 15, 0],
              "1f93a": [["🤺"], "", "", ["fencer"], 42, 44, 15, 0],
              "1f93c-200d-2640-fe0f": [
                ["🤼‍♀️", "🤼‍♀"],
                "",
                "",
                ["woman-wrestling"],
                42,
                45,
                15,
                0,
              ],
              "1f93c-200d-2642-fe0f": [
                ["🤼‍♂️", "🤼‍♂"],
                "",
                "",
                ["man-wrestling"],
                42,
                46,
                15,
                0,
              ],
              "1f93c": [["🤼"], "", "", ["wrestlers"], 42, 47, 15, 0],
              "1f93d-200d-2640-fe0f": [
                ["🤽‍♀️", "🤽‍♀"],
                "",
                "",
                ["woman-playing-water-polo"],
                42,
                48,
                15,
                0,
              ],
              "1f93d-200d-2642-fe0f": [
                ["🤽‍♂️", "🤽‍♂"],
                "",
                "",
                ["man-playing-water-polo"],
                42,
                54,
                15,
                0,
              ],
              "1f93d": [["🤽"], "", "", ["water_polo"], 43, 0, 15, 0],
              "1f93e-200d-2640-fe0f": [
                ["🤾‍♀️", "🤾‍♀"],
                "",
                "",
                ["woman-playing-handball"],
                43,
                6,
                15,
                0,
              ],
              "1f93e-200d-2642-fe0f": [
                ["🤾‍♂️", "🤾‍♂"],
                "",
                "",
                ["man-playing-handball"],
                43,
                12,
                15,
                0,
              ],
              "1f93e": [["🤾"], "", "", ["handball"], 43, 18, 15, 0],
              "1f93f": [["🤿"], "", "", ["diving_mask"], 43, 24, 15, 0],
              "1f940": [["🥀"], "", "", ["wilted_flower"], 43, 25, 15, 0],
              "1f941": [
                ["🥁"],
                "",
                "",
                ["drum_with_drumsticks"],
                43,
                26,
                15,
                0,
              ],
              "1f942": [["🥂"], "", "", ["clinking_glasses"], 43, 27, 15, 0],
              "1f943": [["🥃"], "", "", ["tumbler_glass"], 43, 28, 15, 0],
              "1f944": [["🥄"], "", "", ["spoon"], 43, 29, 15, 0],
              "1f945": [["🥅"], "", "", ["goal_net"], 43, 30, 15, 0],
              "1f947": [["🥇"], "", "", ["first_place_medal"], 43, 31, 15, 0],
              "1f948": [["🥈"], "", "", ["second_place_medal"], 43, 32, 15, 0],
              "1f949": [["🥉"], "", "", ["third_place_medal"], 43, 33, 15, 0],
              "1f94a": [["🥊"], "", "", ["boxing_glove"], 43, 34, 15, 0],
              "1f94b": [
                ["🥋"],
                "",
                "",
                ["martial_arts_uniform"],
                43,
                35,
                15,
                0,
              ],
              "1f94c": [["🥌"], "", "", ["curling_stone"], 43, 36, 15, 0],
              "1f94d": [["🥍"], "", "", ["lacrosse"], 43, 37, 15, 0],
              "1f94e": [["🥎"], "", "", ["softball"], 43, 38, 15, 0],
              "1f94f": [["🥏"], "", "", ["flying_disc"], 43, 39, 15, 0],
              "1f950": [["🥐"], "", "", ["croissant"], 43, 40, 15, 0],
              "1f951": [["🥑"], "", "", ["avocado"], 43, 41, 15, 0],
              "1f952": [["🥒"], "", "", ["cucumber"], 43, 42, 15, 0],
              "1f953": [["🥓"], "", "", ["bacon"], 43, 43, 15, 0],
              "1f954": [["🥔"], "", "", ["potato"], 43, 44, 15, 0],
              "1f955": [["🥕"], "", "", ["carrot"], 43, 45, 15, 0],
              "1f956": [["🥖"], "", "", ["baguette_bread"], 43, 46, 15, 0],
              "1f957": [["🥗"], "", "", ["green_salad"], 43, 47, 15, 0],
              "1f958": [["🥘"], "", "", ["shallow_pan_of_food"], 43, 48, 15, 0],
              "1f959": [["🥙"], "", "", ["stuffed_flatbread"], 43, 49, 15, 0],
              "1f95a": [["🥚"], "", "", ["egg"], 43, 50, 15, 0],
              "1f95b": [["🥛"], "", "", ["glass_of_milk"], 43, 51, 15, 0],
              "1f95c": [["🥜"], "", "", ["peanuts"], 43, 52, 15, 0],
              "1f95d": [["🥝"], "", "", ["kiwifruit"], 43, 53, 15, 0],
              "1f95e": [["🥞"], "", "", ["pancakes"], 43, 54, 15, 0],
              "1f95f": [["🥟"], "", "", ["dumpling"], 43, 55, 15, 0],
              "1f960": [["🥠"], "", "", ["fortune_cookie"], 43, 56, 15, 0],
              "1f961": [["🥡"], "", "", ["takeout_box"], 43, 57, 15, 0],
              "1f962": [["🥢"], "", "", ["chopsticks"], 43, 58, 15, 0],
              "1f963": [["🥣"], "", "", ["bowl_with_spoon"], 43, 59, 15, 0],
              "1f964": [["🥤"], "", "", ["cup_with_straw"], 44, 0, 15, 0],
              "1f965": [["🥥"], "", "", ["coconut"], 44, 1, 15, 0],
              "1f966": [["🥦"], "", "", ["broccoli"], 44, 2, 15, 0],
              "1f967": [["🥧"], "", "", ["pie"], 44, 3, 15, 0],
              "1f968": [["🥨"], "", "", ["pretzel"], 44, 4, 15, 0],
              "1f969": [["🥩"], "", "", ["cut_of_meat"], 44, 5, 15, 0],
              "1f96a": [["🥪"], "", "", ["sandwich"], 44, 6, 15, 0],
              "1f96b": [["🥫"], "", "", ["canned_food"], 44, 7, 15, 0],
              "1f96c": [["🥬"], "", "", ["leafy_green"], 44, 8, 15, 0],
              "1f96d": [["🥭"], "", "", ["mango"], 44, 9, 15, 0],
              "1f96e": [["🥮"], "", "", ["moon_cake"], 44, 10, 15, 0],
              "1f96f": [["🥯"], "", "", ["bagel"], 44, 11, 15, 0],
              "1f970": [
                ["🥰"],
                "",
                "",
                ["smiling_face_with_3_hearts"],
                44,
                12,
                15,
                0,
              ],
              "1f971": [["🥱"], "", "", ["yawning_face"], 44, 13, 15, 0],
              "1f972": [
                ["🥲"],
                "",
                "",
                ["smiling_face_with_tear"],
                44,
                14,
                15,
                0,
              ],
              "1f973": [["🥳"], "", "", ["partying_face"], 44, 15, 15, 0],
              "1f974": [["🥴"], "", "", ["woozy_face"], 44, 16, 15, 0],
              "1f975": [["🥵"], "", "", ["hot_face"], 44, 17, 15, 0],
              "1f976": [["🥶"], "", "", ["cold_face"], 44, 18, 15, 0],
              "1f977": [["🥷"], "", "", ["ninja"], 44, 19, 15, 0],
              "1f978": [["🥸"], "", "", ["disguised_face"], 44, 25, 15, 0],
              "1f97a": [["🥺"], "", "", ["pleading_face"], 44, 26, 15, 0],
              "1f97b": [["🥻"], "", "", ["sari"], 44, 27, 15, 0],
              "1f97c": [["🥼"], "", "", ["lab_coat"], 44, 28, 15, 0],
              "1f97d": [["🥽"], "", "", ["goggles"], 44, 29, 15, 0],
              "1f97e": [["🥾"], "", "", ["hiking_boot"], 44, 30, 15, 0],
              "1f97f": [["🥿"], "", "", ["womans_flat_shoe"], 44, 31, 15, 0],
              "1f980": [["🦀"], "", "", ["crab"], 44, 32, 15, 0],
              "1f981": [["🦁"], "", "", ["lion_face"], 44, 33, 15, 0],
              "1f982": [["🦂"], "", "", ["scorpion"], 44, 34, 15, 0],
              "1f983": [["🦃"], "", "", ["turkey"], 44, 35, 15, 0],
              "1f984": [["🦄"], "", "", ["unicorn_face"], 44, 36, 15, 0],
              "1f985": [["🦅"], "", "", ["eagle"], 44, 37, 15, 0],
              "1f986": [["🦆"], "", "", ["duck"], 44, 38, 15, 0],
              "1f987": [["🦇"], "", "", ["bat"], 44, 39, 15, 0],
              "1f988": [["🦈"], "", "", ["shark"], 44, 40, 15, 0],
              "1f989": [["🦉"], "", "", ["owl"], 44, 41, 15, 0],
              "1f98a": [["🦊"], "", "", ["fox_face"], 44, 42, 15, 0],
              "1f98b": [["🦋"], "", "", ["butterfly"], 44, 43, 15, 0],
              "1f98c": [["🦌"], "", "", ["deer"], 44, 44, 15, 0],
              "1f98d": [["🦍"], "", "", ["gorilla"], 44, 45, 15, 0],
              "1f98e": [["🦎"], "", "", ["lizard"], 44, 46, 15, 0],
              "1f98f": [["🦏"], "", "", ["rhinoceros"], 44, 47, 15, 0],
              "1f990": [["🦐"], "", "", ["shrimp"], 44, 48, 15, 0],
              "1f991": [["🦑"], "", "", ["squid"], 44, 49, 15, 0],
              "1f992": [["🦒"], "", "", ["giraffe_face"], 44, 50, 15, 0],
              "1f993": [["🦓"], "", "", ["zebra_face"], 44, 51, 15, 0],
              "1f994": [["🦔"], "", "", ["hedgehog"], 44, 52, 15, 0],
              "1f995": [["🦕"], "", "", ["sauropod"], 44, 53, 15, 0],
              "1f996": [["🦖"], "", "", ["t-rex"], 44, 54, 15, 0],
              "1f997": [["🦗"], "", "", ["cricket"], 44, 55, 15, 0],
              "1f998": [["🦘"], "", "", ["kangaroo"], 44, 56, 15, 0],
              "1f999": [["🦙"], "", "", ["llama"], 44, 57, 15, 0],
              "1f99a": [["🦚"], "", "", ["peacock"], 44, 58, 15, 0],
              "1f99b": [["🦛"], "", "", ["hippopotamus"], 44, 59, 15, 0],
              "1f99c": [["🦜"], "", "", ["parrot"], 45, 0, 15, 0],
              "1f99d": [["🦝"], "", "", ["raccoon"], 45, 1, 15, 0],
              "1f99e": [["🦞"], "", "", ["lobster"], 45, 2, 15, 0],
              "1f99f": [["🦟"], "", "", ["mosquito"], 45, 3, 15, 0],
              "1f9a0": [["🦠"], "", "", ["microbe"], 45, 4, 15, 0],
              "1f9a1": [["🦡"], "", "", ["badger"], 45, 5, 15, 0],
              "1f9a2": [["🦢"], "", "", ["swan"], 45, 6, 15, 0],
              "1f9a3": [["🦣"], "", "", ["mammoth"], 45, 7, 15, 0],
              "1f9a4": [["🦤"], "", "", ["dodo"], 45, 8, 15, 0],
              "1f9a5": [["🦥"], "", "", ["sloth"], 45, 9, 15, 0],
              "1f9a6": [["🦦"], "", "", ["otter"], 45, 10, 15, 0],
              "1f9a7": [["🦧"], "", "", ["orangutan"], 45, 11, 15, 0],
              "1f9a8": [["🦨"], "", "", ["skunk"], 45, 12, 15, 0],
              "1f9a9": [["🦩"], "", "", ["flamingo"], 45, 13, 15, 0],
              "1f9aa": [["🦪"], "", "", ["oyster"], 45, 14, 15, 0],
              "1f9ab": [["🦫"], "", "", ["beaver"], 45, 15, 15, 0],
              "1f9ac": [["🦬"], "", "", ["bison"], 45, 16, 15, 0],
              "1f9ad": [["🦭"], "", "", ["seal"], 45, 17, 15, 0],
              "1f9ae": [["🦮"], "", "", ["guide_dog"], 45, 18, 15, 0],
              "1f9af": [["🦯"], "", "", ["probing_cane"], 45, 19, 15, 0],
              "1f9b4": [["🦴"], "", "", ["bone"], 45, 20, 15, 0],
              "1f9b5": [["🦵"], "", "", ["leg"], 45, 21, 15, 0],
              "1f9b6": [["🦶"], "", "", ["foot"], 45, 27, 15, 0],
              "1f9b7": [["🦷"], "", "", ["tooth"], 45, 33, 15, 0],
              "1f9b8-200d-2640-fe0f": [
                ["🦸‍♀️", "🦸‍♀"],
                "",
                "",
                ["female_superhero"],
                45,
                34,
                15,
                0,
              ],
              "1f9b8-200d-2642-fe0f": [
                ["🦸‍♂️", "🦸‍♂"],
                "",
                "",
                ["male_superhero"],
                45,
                40,
                15,
                0,
              ],
              "1f9b8": [["🦸"], "", "", ["superhero"], 45, 46, 15, 0],
              "1f9b9-200d-2640-fe0f": [
                ["🦹‍♀️", "🦹‍♀"],
                "",
                "",
                ["female_supervillain"],
                45,
                52,
                15,
                0,
              ],
              "1f9b9-200d-2642-fe0f": [
                ["🦹‍♂️", "🦹‍♂"],
                "",
                "",
                ["male_supervillain"],
                45,
                58,
                15,
                0,
              ],
              "1f9b9": [["🦹"], "", "", ["supervillain"], 46, 4, 15, 0],
              "1f9ba": [["🦺"], "", "", ["safety_vest"], 46, 10, 15, 0],
              "1f9bb": [
                ["🦻"],
                "",
                "",
                ["ear_with_hearing_aid"],
                46,
                11,
                15,
                0,
              ],
              "1f9bc": [
                ["🦼"],
                "",
                "",
                ["motorized_wheelchair"],
                46,
                17,
                15,
                0,
              ],
              "1f9bd": [["🦽"], "", "", ["manual_wheelchair"], 46, 18, 15, 0],
              "1f9be": [["🦾"], "", "", ["mechanical_arm"], 46, 19, 15, 0],
              "1f9bf": [["🦿"], "", "", ["mechanical_leg"], 46, 20, 15, 0],
              "1f9c0": [["🧀"], "", "", ["cheese_wedge"], 46, 21, 15, 0],
              "1f9c1": [["🧁"], "", "", ["cupcake"], 46, 22, 15, 0],
              "1f9c2": [["🧂"], "", "", ["salt"], 46, 23, 15, 0],
              "1f9c3": [["🧃"], "", "", ["beverage_box"], 46, 24, 15, 0],
              "1f9c4": [["🧄"], "", "", ["garlic"], 46, 25, 15, 0],
              "1f9c5": [["🧅"], "", "", ["onion"], 46, 26, 15, 0],
              "1f9c6": [["🧆"], "", "", ["falafel"], 46, 27, 15, 0],
              "1f9c7": [["🧇"], "", "", ["waffle"], 46, 28, 15, 0],
              "1f9c8": [["🧈"], "", "", ["butter"], 46, 29, 15, 0],
              "1f9c9": [["🧉"], "", "", ["mate_drink"], 46, 30, 15, 0],
              "1f9ca": [["🧊"], "", "", ["ice_cube"], 46, 31, 15, 0],
              "1f9cb": [["🧋"], "", "", ["bubble_tea"], 46, 32, 15, 0],
              "1f9cd-200d-2640-fe0f": [
                ["🧍‍♀️", "🧍‍♀"],
                "",
                "",
                ["woman_standing"],
                46,
                33,
                15,
                0,
              ],
              "1f9cd-200d-2642-fe0f": [
                ["🧍‍♂️", "🧍‍♂"],
                "",
                "",
                ["man_standing"],
                46,
                39,
                15,
                0,
              ],
              "1f9cd": [["🧍"], "", "", ["standing_person"], 46, 45, 15, 0],
              "1f9ce-200d-2640-fe0f": [
                ["🧎‍♀️", "🧎‍♀"],
                "",
                "",
                ["woman_kneeling"],
                46,
                51,
                15,
                0,
              ],
              "1f9ce-200d-2642-fe0f": [
                ["🧎‍♂️", "🧎‍♂"],
                "",
                "",
                ["man_kneeling"],
                46,
                57,
                15,
                0,
              ],
              "1f9ce": [["🧎"], "", "", ["kneeling_person"], 47, 3, 15, 0],
              "1f9cf-200d-2640-fe0f": [
                ["🧏‍♀️", "🧏‍♀"],
                "",
                "",
                ["deaf_woman"],
                47,
                9,
                15,
                0,
              ],
              "1f9cf-200d-2642-fe0f": [
                ["🧏‍♂️", "🧏‍♂"],
                "",
                "",
                ["deaf_man"],
                47,
                15,
                15,
                0,
              ],
              "1f9cf": [["🧏"], "", "", ["deaf_person"], 47, 21, 15, 0],
              "1f9d0": [["🧐"], "", "", ["face_with_monocle"], 47, 27, 15, 0],
              "1f9d1-200d-1f33e": [["🧑‍🌾"], "", "", ["farmer"], 47, 28, 15, 0],
              "1f9d1-200d-1f373": [["🧑‍🍳"], "", "", ["cook"], 47, 34, 15, 0],
              "1f9d1-200d-1f37c": [
                ["🧑‍🍼"],
                "",
                "",
                ["person_feeding_baby"],
                47,
                40,
                15,
                0,
              ],
              "1f9d1-200d-1f384": [["🧑‍🎄"], "", "", ["mx_claus"], 47, 46, 15, 0],
              "1f9d1-200d-1f393": [["🧑‍🎓"], "", "", ["student"], 47, 52, 15, 0],
              "1f9d1-200d-1f3a4": [["🧑‍🎤"], "", "", ["singer"], 47, 58, 15, 0],
              "1f9d1-200d-1f3a8": [["🧑‍🎨"], "", "", ["artist"], 48, 4, 15, 0],
              "1f9d1-200d-1f3eb": [["🧑‍🏫"], "", "", ["teacher"], 48, 10, 15, 0],
              "1f9d1-200d-1f3ed": [
                ["🧑‍🏭"],
                "",
                "",
                ["factory_worker"],
                48,
                16,
                15,
                0,
              ],
              "1f9d1-200d-1f4bb": [
                ["🧑‍💻"],
                "",
                "",
                ["technologist"],
                48,
                22,
                15,
                0,
              ],
              "1f9d1-200d-1f4bc": [
                ["🧑‍💼"],
                "",
                "",
                ["office_worker"],
                48,
                28,
                15,
                0,
              ],
              "1f9d1-200d-1f527": [["🧑‍🔧"], "", "", ["mechanic"], 48, 34, 15, 0],
              "1f9d1-200d-1f52c": [
                ["🧑‍🔬"],
                "",
                "",
                ["scientist"],
                48,
                40,
                15,
                0,
              ],
              "1f9d1-200d-1f680": [
                ["🧑‍🚀"],
                "",
                "",
                ["astronaut"],
                48,
                46,
                15,
                0,
              ],
              "1f9d1-200d-1f692": [
                ["🧑‍🚒"],
                "",
                "",
                ["firefighter"],
                48,
                52,
                15,
                0,
              ],
              "1f9d1-200d-1f91d-200d-1f9d1": [
                ["🧑‍🤝‍🧑"],
                "",
                "",
                ["people_holding_hands"],
                48,
                58,
                15,
                0,
              ],
              "1f9d1-200d-1f9af": [
                ["🧑‍🦯"],
                "",
                "",
                ["person_with_probing_cane"],
                49,
                24,
                15,
                0,
              ],
              "1f9d1-200d-1f9b0": [
                ["🧑‍🦰"],
                "",
                "",
                ["red_haired_person"],
                49,
                30,
                15,
                0,
              ],
              "1f9d1-200d-1f9b1": [
                ["🧑‍🦱"],
                "",
                "",
                ["curly_haired_person"],
                49,
                36,
                15,
                0,
              ],
              "1f9d1-200d-1f9b2": [
                ["🧑‍🦲"],
                "",
                "",
                ["bald_person"],
                49,
                42,
                7,
                0,
              ],
              "1f9d1-200d-1f9b3": [
                ["🧑‍🦳"],
                "",
                "",
                ["white_haired_person"],
                49,
                48,
                7,
                0,
              ],
              "1f9d1-200d-1f9bc": [
                ["🧑‍🦼"],
                "",
                "",
                ["person_in_motorized_wheelchair"],
                49,
                54,
                15,
                0,
              ],
              "1f9d1-200d-1f9bd": [
                ["🧑‍🦽"],
                "",
                "",
                ["person_in_manual_wheelchair"],
                50,
                0,
                15,
                0,
              ],
              "1f9d1-200d-2695-fe0f": [
                ["🧑‍⚕️", "🧑‍⚕"],
                "",
                "",
                ["health_worker"],
                50,
                6,
                15,
                0,
              ],
              "1f9d1-200d-2696-fe0f": [
                ["🧑‍⚖️", "🧑‍⚖"],
                "",
                "",
                ["judge"],
                50,
                12,
                15,
                0,
              ],
              "1f9d1-200d-2708-fe0f": [
                ["🧑‍✈️", "🧑‍✈"],
                "",
                "",
                ["pilot"],
                50,
                18,
                15,
                0,
              ],
              "1f9d1": [["🧑"], "", "", ["adult"], 50, 24, 15, 0],
              "1f9d2": [["🧒"], "", "", ["child"], 50, 30, 15, 0],
              "1f9d3": [["🧓"], "", "", ["older_adult"], 50, 36, 15, 0],
              "1f9d4-200d-2640-fe0f": [
                ["🧔‍♀️", "🧔‍♀"],
                "",
                "",
                ["woman_with_beard"],
                50,
                42,
                7,
                0,
              ],
              "1f9d4-200d-2642-fe0f": [
                ["🧔‍♂️", "🧔‍♂"],
                "",
                "",
                ["man_with_beard"],
                50,
                48,
                7,
                0,
              ],
              "1f9d4": [["🧔"], "", "", ["bearded_person"], 50, 54, 15, 0],
              "1f9d5": [
                ["🧕"],
                "",
                "",
                ["person_with_headscarf"],
                51,
                0,
                15,
                0,
              ],
              "1f9d6-200d-2640-fe0f": [
                ["🧖‍♀️", "🧖‍♀"],
                "",
                "",
                ["woman_in_steamy_room"],
                51,
                6,
                15,
                0,
              ],
              "1f9d6-200d-2642-fe0f": [
                ["🧖‍♂️", "🧖‍♂", "🧖"],
                "",
                "",
                ["man_in_steamy_room", "person_in_steamy_room"],
                51,
                12,
                15,
                0,
              ],
              "1f9d7-200d-2640-fe0f": [
                ["🧗‍♀️", "🧗‍♀", "🧗"],
                "",
                "",
                ["woman_climbing", "person_climbing"],
                51,
                24,
                15,
                0,
              ],
              "1f9d7-200d-2642-fe0f": [
                ["🧗‍♂️", "🧗‍♂"],
                "",
                "",
                ["man_climbing"],
                51,
                30,
                15,
                0,
              ],
              "1f9d8-200d-2640-fe0f": [
                ["🧘‍♀️", "🧘‍♀", "🧘"],
                "",
                "",
                ["woman_in_lotus_position", "person_in_lotus_position"],
                51,
                42,
                15,
                0,
              ],
              "1f9d8-200d-2642-fe0f": [
                ["🧘‍♂️", "🧘‍♂"],
                "",
                "",
                ["man_in_lotus_position"],
                51,
                48,
                15,
                0,
              ],
              "1f9d9-200d-2640-fe0f": [
                ["🧙‍♀️", "🧙‍♀", "🧙"],
                "",
                "",
                ["female_mage", "mage"],
                52,
                0,
                15,
                0,
              ],
              "1f9d9-200d-2642-fe0f": [
                ["🧙‍♂️", "🧙‍♂"],
                "",
                "",
                ["male_mage"],
                52,
                6,
                15,
                0,
              ],
              "1f9da-200d-2640-fe0f": [
                ["🧚‍♀️", "🧚‍♀", "🧚"],
                "",
                "",
                ["female_fairy", "fairy"],
                52,
                18,
                15,
                0,
              ],
              "1f9da-200d-2642-fe0f": [
                ["🧚‍♂️", "🧚‍♂"],
                "",
                "",
                ["male_fairy"],
                52,
                24,
                15,
                0,
              ],
              "1f9db-200d-2640-fe0f": [
                ["🧛‍♀️", "🧛‍♀", "🧛"],
                "",
                "",
                ["female_vampire", "vampire"],
                52,
                36,
                15,
                0,
              ],
              "1f9db-200d-2642-fe0f": [
                ["🧛‍♂️", "🧛‍♂"],
                "",
                "",
                ["male_vampire"],
                52,
                42,
                15,
                0,
              ],
              "1f9dc-200d-2640-fe0f": [
                ["🧜‍♀️", "🧜‍♀"],
                "",
                "",
                ["mermaid"],
                52,
                54,
                15,
                0,
              ],
              "1f9dc-200d-2642-fe0f": [
                ["🧜‍♂️", "🧜‍♂", "🧜"],
                "",
                "",
                ["merman", "merperson"],
                53,
                0,
                15,
                0,
              ],
              "1f9dd-200d-2640-fe0f": [
                ["🧝‍♀️", "🧝‍♀"],
                "",
                "",
                ["female_elf"],
                53,
                12,
                15,
                0,
              ],
              "1f9dd-200d-2642-fe0f": [
                ["🧝‍♂️", "🧝‍♂", "🧝"],
                "",
                "",
                ["male_elf", "elf"],
                53,
                18,
                15,
                0,
              ],
              "1f9de-200d-2640-fe0f": [
                ["🧞‍♀️", "🧞‍♀"],
                "",
                "",
                ["female_genie"],
                53,
                30,
                15,
                0,
              ],
              "1f9de-200d-2642-fe0f": [
                ["🧞‍♂️", "🧞‍♂", "🧞"],
                "",
                "",
                ["male_genie", "genie"],
                53,
                31,
                15,
                0,
              ],
              "1f9df-200d-2640-fe0f": [
                ["🧟‍♀️", "🧟‍♀"],
                "",
                "",
                ["female_zombie"],
                53,
                33,
                15,
                0,
              ],
              "1f9df-200d-2642-fe0f": [
                ["🧟‍♂️", "🧟‍♂", "🧟"],
                "",
                "",
                ["male_zombie", "zombie"],
                53,
                34,
                15,
                0,
              ],
              "1f9e0": [["🧠"], "", "", ["brain"], 53, 36, 15, 0],
              "1f9e1": [["🧡"], "", "", ["orange_heart"], 53, 37, 15, 0],
              "1f9e2": [["🧢"], "", "", ["billed_cap"], 53, 38, 15, 0],
              "1f9e3": [["🧣"], "", "", ["scarf"], 53, 39, 15, 0],
              "1f9e4": [["🧤"], "", "", ["gloves"], 53, 40, 15, 0],
              "1f9e5": [["🧥"], "", "", ["coat"], 53, 41, 15, 0],
              "1f9e6": [["🧦"], "", "", ["socks"], 53, 42, 15, 0],
              "1f9e7": [["🧧"], "", "", ["red_envelope"], 53, 43, 15, 0],
              "1f9e8": [["🧨"], "", "", ["firecracker"], 53, 44, 15, 0],
              "1f9e9": [["🧩"], "", "", ["jigsaw"], 53, 45, 15, 0],
              "1f9ea": [["🧪"], "", "", ["test_tube"], 53, 46, 15, 0],
              "1f9eb": [["🧫"], "", "", ["petri_dish"], 53, 47, 15, 0],
              "1f9ec": [["🧬"], "", "", ["dna"], 53, 48, 15, 0],
              "1f9ed": [["🧭"], "", "", ["compass"], 53, 49, 15, 0],
              "1f9ee": [["🧮"], "", "", ["abacus"], 53, 50, 15, 0],
              "1f9ef": [["🧯"], "", "", ["fire_extinguisher"], 53, 51, 15, 0],
              "1f9f0": [["🧰"], "", "", ["toolbox"], 53, 52, 15, 0],
              "1f9f1": [["🧱"], "", "", ["bricks"], 53, 53, 15, 0],
              "1f9f2": [["🧲"], "", "", ["magnet"], 53, 54, 15, 0],
              "1f9f3": [["🧳"], "", "", ["luggage"], 53, 55, 15, 0],
              "1f9f4": [["🧴"], "", "", ["lotion_bottle"], 53, 56, 15, 0],
              "1f9f5": [["🧵"], "", "", ["thread"], 53, 57, 15, 0],
              "1f9f6": [["🧶"], "", "", ["yarn"], 53, 58, 15, 0],
              "1f9f7": [["🧷"], "", "", ["safety_pin"], 53, 59, 15, 0],
              "1f9f8": [["🧸"], "", "", ["teddy_bear"], 54, 0, 15, 0],
              "1f9f9": [["🧹"], "", "", ["broom"], 54, 1, 15, 0],
              "1f9fa": [["🧺"], "", "", ["basket"], 54, 2, 15, 0],
              "1f9fb": [["🧻"], "", "", ["roll_of_paper"], 54, 3, 15, 0],
              "1f9fc": [["🧼"], "", "", ["soap"], 54, 4, 15, 0],
              "1f9fd": [["🧽"], "", "", ["sponge"], 54, 5, 15, 0],
              "1f9fe": [["🧾"], "", "", ["receipt"], 54, 6, 15, 0],
              "1f9ff": [["🧿"], "", "", ["nazar_amulet"], 54, 7, 15, 0],
              "1fa70": [["🩰"], "", "", ["ballet_shoes"], 54, 8, 15, 0],
              "1fa71": [["🩱"], "", "", ["one-piece_swimsuit"], 54, 9, 15, 0],
              "1fa72": [["🩲"], "", "", ["briefs"], 54, 10, 15, 0],
              "1fa73": [["🩳"], "", "", ["shorts"], 54, 11, 15, 0],
              "1fa74": [["🩴"], "", "", ["thong_sandal"], 54, 12, 15, 0],
              "1fa78": [["🩸"], "", "", ["drop_of_blood"], 54, 13, 15, 0],
              "1fa79": [["🩹"], "", "", ["adhesive_bandage"], 54, 14, 15, 0],
              "1fa7a": [["🩺"], "", "", ["stethoscope"], 54, 15, 15, 0],
              "1fa80": [["🪀"], "", "", ["yo-yo"], 54, 16, 15, 0],
              "1fa81": [["🪁"], "", "", ["kite"], 54, 17, 15, 0],
              "1fa82": [["🪂"], "", "", ["parachute"], 54, 18, 15, 0],
              "1fa83": [["🪃"], "", "", ["boomerang"], 54, 19, 15, 0],
              "1fa84": [["🪄"], "", "", ["magic_wand"], 54, 20, 15, 0],
              "1fa85": [["🪅"], "", "", ["pinata"], 54, 21, 15, 0],
              "1fa86": [["🪆"], "", "", ["nesting_dolls"], 54, 22, 15, 0],
              "1fa90": [["🪐"], "", "", ["ringed_planet"], 54, 23, 15, 0],
              "1fa91": [["🪑"], "", "", ["chair"], 54, 24, 15, 0],
              "1fa92": [["🪒"], "", "", ["razor"], 54, 25, 15, 0],
              "1fa93": [["🪓"], "", "", ["axe"], 54, 26, 15, 0],
              "1fa94": [["🪔"], "", "", ["diya_lamp"], 54, 27, 15, 0],
              "1fa95": [["🪕"], "", "", ["banjo"], 54, 28, 15, 0],
              "1fa96": [["🪖"], "", "", ["military_helmet"], 54, 29, 15, 0],
              "1fa97": [["🪗"], "", "", ["accordion"], 54, 30, 15, 0],
              "1fa98": [["🪘"], "", "", ["long_drum"], 54, 31, 15, 0],
              "1fa99": [["🪙"], "", "", ["coin"], 54, 32, 15, 0],
              "1fa9a": [["🪚"], "", "", ["carpentry_saw"], 54, 33, 15, 0],
              "1fa9b": [["🪛"], "", "", ["screwdriver"], 54, 34, 15, 0],
              "1fa9c": [["🪜"], "", "", ["ladder"], 54, 35, 15, 0],
              "1fa9d": [["🪝"], "", "", ["hook"], 54, 36, 15, 0],
              "1fa9e": [["🪞"], "", "", ["mirror"], 54, 37, 15, 0],
              "1fa9f": [["🪟"], "", "", ["window"], 54, 38, 15, 0],
              "1faa0": [["🪠"], "", "", ["plunger"], 54, 39, 15, 0],
              "1faa1": [["🪡"], "", "", ["sewing_needle"], 54, 40, 15, 0],
              "1faa2": [["🪢"], "", "", ["knot"], 54, 41, 15, 0],
              "1faa3": [["🪣"], "", "", ["bucket"], 54, 42, 15, 0],
              "1faa4": [["🪤"], "", "", ["mouse_trap"], 54, 43, 15, 0],
              "1faa5": [["🪥"], "", "", ["toothbrush"], 54, 44, 15, 0],
              "1faa6": [["🪦"], "", "", ["headstone"], 54, 45, 15, 0],
              "1faa7": [["🪧"], "", "", ["placard"], 54, 46, 15, 0],
              "1faa8": [["🪨"], "", "", ["rock"], 54, 47, 15, 0],
              "1fab0": [["🪰"], "", "", ["fly"], 54, 48, 15, 0],
              "1fab1": [["🪱"], "", "", ["worm"], 54, 49, 15, 0],
              "1fab2": [["🪲"], "", "", ["beetle"], 54, 50, 15, 0],
              "1fab3": [["🪳"], "", "", ["cockroach"], 54, 51, 15, 0],
              "1fab4": [["🪴"], "", "", ["potted_plant"], 54, 52, 15, 0],
              "1fab5": [["🪵"], "", "", ["wood"], 54, 53, 15, 0],
              "1fab6": [["🪶"], "", "", ["feather"], 54, 54, 15, 0],
              "1fac0": [["🫀"], "", "", ["anatomical_heart"], 54, 55, 15, 0],
              "1fac1": [["🫁"], "", "", ["lungs"], 54, 56, 15, 0],
              "1fac2": [["🫂"], "", "", ["people_hugging"], 54, 57, 15, 0],
              "1fad0": [["🫐"], "", "", ["blueberries"], 54, 58, 15, 0],
              "1fad1": [["🫑"], "", "", ["bell_pepper"], 54, 59, 15, 0],
              "1fad2": [["🫒"], "", "", ["olive"], 55, 0, 15, 0],
              "1fad3": [["🫓"], "", "", ["flatbread"], 55, 1, 15, 0],
              "1fad4": [["🫔"], "", "", ["tamale"], 55, 2, 15, 0],
              "1fad5": [["🫕"], "", "", ["fondue"], 55, 3, 15, 0],
              "1fad6": [["🫖"], "", "", ["teapot"], 55, 4, 15, 0],
              "203c-fe0f": [["‼️", "‼"], "", "󾬆", ["bangbang"], 55, 5, 15, 0],
              "2049-fe0f": [
                ["⁉️", "⁉"],
                "",
                "󾬅",
                ["interrobang"],
                55,
                6,
                15,
                0,
              ],
              "2122-fe0f": [["™️", "™"], "", "󾬪", ["tm"], 55, 7, 15, 0],
              "2139-fe0f": [
                ["ℹ️", "ℹ"],
                "",
                "󾭇",
                ["information_source"],
                55,
                8,
                15,
                0,
              ],
              "2194-fe0f": [
                ["↔️", "↔"],
                "",
                "󾫶",
                ["left_right_arrow"],
                55,
                9,
                15,
                0,
              ],
              "2195-fe0f": [
                ["↕️", "↕"],
                "",
                "󾫷",
                ["arrow_up_down"],
                55,
                10,
                15,
                0,
              ],
              "2196-fe0f": [
                ["↖️", "↖"],
                "",
                "󾫲",
                ["arrow_upper_left"],
                55,
                11,
                15,
                0,
              ],
              "2197-fe0f": [
                ["↗️", "↗"],
                "",
                "󾫰",
                ["arrow_upper_right"],
                55,
                12,
                15,
                0,
              ],
              "2198-fe0f": [
                ["↘️", "↘"],
                "",
                "󾫱",
                ["arrow_lower_right"],
                55,
                13,
                15,
                0,
              ],
              "2199-fe0f": [
                ["↙️", "↙"],
                "",
                "󾫳",
                ["arrow_lower_left"],
                55,
                14,
                15,
                0,
              ],
              "21a9-fe0f": [
                ["↩️", "↩"],
                "",
                "󾮃",
                ["leftwards_arrow_with_hook"],
                55,
                15,
                15,
                0,
              ],
              "21aa-fe0f": [
                ["↪️", "↪"],
                "",
                "󾮈",
                ["arrow_right_hook"],
                55,
                16,
                15,
                0,
              ],
              "231a": [["⌚"], "", "󾀝", ["watch"], 55, 17, 15, 0],
              "231b": [["⌛"], "", "󾀜", ["hourglass"], 55, 18, 15, 0],
              "2328-fe0f": [["⌨️", "⌨"], "", "", ["keyboard"], 55, 19, 15, 0],
              "23cf-fe0f": [["⏏️", "⏏"], "", "", ["eject"], 55, 20, 15, 0],
              "23e9": [["⏩"], "", "󾫾", ["fast_forward"], 55, 21, 15, 0],
              "23ea": [["⏪"], "", "󾫿", ["rewind"], 55, 22, 15, 0],
              "23eb": [["⏫"], "", "󾬃", ["arrow_double_up"], 55, 23, 15, 0],
              "23ec": [["⏬"], "", "󾬂", ["arrow_double_down"], 55, 24, 15, 0],
              "23ed-fe0f": [
                ["⏭️", "⏭"],
                "",
                "",
                ["black_right_pointing_double_triangle_with_vertical_bar"],
                55,
                25,
                15,
                0,
              ],
              "23ee-fe0f": [
                ["⏮️", "⏮"],
                "",
                "",
                ["black_left_pointing_double_triangle_with_vertical_bar"],
                55,
                26,
                15,
                0,
              ],
              "23ef-fe0f": [
                ["⏯️", "⏯"],
                "",
                "",
                ["black_right_pointing_triangle_with_double_vertical_bar"],
                55,
                27,
                15,
                0,
              ],
              "23f0": [["⏰"], "", "󾀪", ["alarm_clock"], 55, 28, 15, 0],
              "23f1-fe0f": [["⏱️", "⏱"], "", "", ["stopwatch"], 55, 29, 15, 0],
              "23f2-fe0f": [
                ["⏲️", "⏲"],
                "",
                "",
                ["timer_clock"],
                55,
                30,
                15,
                0,
              ],
              "23f3": [
                ["⏳"],
                "",
                "󾀛",
                ["hourglass_flowing_sand"],
                55,
                31,
                15,
                0,
              ],
              "23f8-fe0f": [
                ["⏸️", "⏸"],
                "",
                "",
                ["double_vertical_bar"],
                55,
                32,
                15,
                0,
              ],
              "23f9-fe0f": [
                ["⏹️", "⏹"],
                "",
                "",
                ["black_square_for_stop"],
                55,
                33,
                15,
                0,
              ],
              "23fa-fe0f": [
                ["⏺️", "⏺"],
                "",
                "",
                ["black_circle_for_record"],
                55,
                34,
                15,
                0,
              ],
              "24c2-fe0f": [["Ⓜ️", "Ⓜ"], "", "󾟡", ["m"], 55, 35, 15, 0],
              "25aa-fe0f": [
                ["▪️", "▪"],
                "",
                "󾭮",
                ["black_small_square"],
                55,
                36,
                15,
                0,
              ],
              "25ab-fe0f": [
                ["▫️", "▫"],
                "",
                "󾭭",
                ["white_small_square"],
                55,
                37,
                15,
                0,
              ],
              "25b6-fe0f": [
                ["▶️", "▶"],
                "",
                "󾫼",
                ["arrow_forward"],
                55,
                38,
                15,
                0,
              ],
              "25c0-fe0f": [
                ["◀️", "◀"],
                "",
                "󾫽",
                ["arrow_backward"],
                55,
                39,
                15,
                0,
              ],
              "25fb-fe0f": [
                ["◻️", "◻"],
                "",
                "󾭱",
                ["white_medium_square"],
                55,
                40,
                15,
                0,
              ],
              "25fc-fe0f": [
                ["◼️", "◼"],
                "",
                "󾭲",
                ["black_medium_square"],
                55,
                41,
                15,
                0,
              ],
              "25fd": [
                ["◽"],
                "",
                "󾭯",
                ["white_medium_small_square"],
                55,
                42,
                15,
                0,
              ],
              "25fe": [
                ["◾"],
                "",
                "󾭰",
                ["black_medium_small_square"],
                55,
                43,
                15,
                0,
              ],
              "2600-fe0f": [["☀️", "☀"], "", "󾀀", ["sunny"], 55, 44, 15, 0],
              "2601-fe0f": [["☁️", "☁"], "", "󾀁", ["cloud"], 55, 45, 15, 0],
              "2602-fe0f": [["☂️", "☂"], "", "", ["umbrella"], 55, 46, 15, 0],
              "2603-fe0f": [["☃️", "☃"], "", "", ["snowman"], 55, 47, 15, 0],
              "2604-fe0f": [["☄️", "☄"], "", "", ["comet"], 55, 48, 15, 0],
              "260e-fe0f": [
                ["☎️", "☎"],
                "",
                "󾔣",
                ["phone", "telephone"],
                55,
                49,
                15,
                0,
              ],
              "2611-fe0f": [
                ["☑️", "☑"],
                "",
                "󾮋",
                ["ballot_box_with_check"],
                55,
                50,
                15,
                0,
              ],
              2614: [
                ["☔"],
                "",
                "󾀂",
                ["umbrella_with_rain_drops"],
                55,
                51,
                15,
                0,
              ],
              2615: [["☕"], "", "󾦁", ["coffee"], 55, 52, 15, 0],
              "2618-fe0f": [["☘️", "☘"], "", "", ["shamrock"], 55, 53, 15, 0],
              "261d-fe0f": [
                ["☝️", "☝"],
                "",
                "󾮘",
                ["point_up"],
                55,
                54,
                15,
                0,
              ],
              "2620-fe0f": [
                ["☠️", "☠"],
                "",
                "",
                ["skull_and_crossbones"],
                56,
                0,
                15,
                0,
              ],
              "2622-fe0f": [
                ["☢️", "☢"],
                "",
                "",
                ["radioactive_sign"],
                56,
                1,
                15,
                0,
              ],
              "2623-fe0f": [
                ["☣️", "☣"],
                "",
                "",
                ["biohazard_sign"],
                56,
                2,
                15,
                0,
              ],
              "2626-fe0f": [
                ["☦️", "☦"],
                "",
                "",
                ["orthodox_cross"],
                56,
                3,
                15,
                0,
              ],
              "262a-fe0f": [
                ["☪️", "☪"],
                "",
                "",
                ["star_and_crescent"],
                56,
                4,
                15,
                0,
              ],
              "262e-fe0f": [
                ["☮️", "☮"],
                "",
                "",
                ["peace_symbol"],
                56,
                5,
                15,
                0,
              ],
              "262f-fe0f": [["☯️", "☯"], "", "", ["yin_yang"], 56, 6, 15, 0],
              "2638-fe0f": [
                ["☸️", "☸"],
                "",
                "",
                ["wheel_of_dharma"],
                56,
                7,
                15,
                0,
              ],
              "2639-fe0f": [
                ["☹️", "☹"],
                "",
                "",
                ["white_frowning_face"],
                56,
                8,
                15,
                0,
              ],
              "263a-fe0f": [["☺️", "☺"], "", "󾌶", ["relaxed"], 56, 9, 15, 0],
              "2640-fe0f": [
                ["♀️", "♀"],
                "",
                "",
                ["female_sign"],
                56,
                10,
                14,
                0,
              ],
              "2642-fe0f": [["♂️", "♂"], "", "", ["male_sign"], 56, 11, 14, 0],
              2648: [["♈"], "", "󾀫", ["aries"], 56, 12, 15, 0],
              2649: [["♉"], "", "󾀬", ["taurus"], 56, 13, 15, 0],
              "264a": [["♊"], "", "󾀭", ["gemini"], 56, 14, 15, 0],
              "264b": [["♋"], "", "󾀮", ["cancer"], 56, 15, 15, 0],
              "264c": [["♌"], "", "󾀯", ["leo"], 56, 16, 15, 0],
              "264d": [["♍"], "", "󾀰", ["virgo"], 56, 17, 15, 0],
              "264e": [["♎"], "", "󾀱", ["libra"], 56, 18, 15, 0],
              "264f": [["♏"], "", "󾀲", ["scorpius"], 56, 19, 15, 0],
              2650: [["♐"], "", "󾀳", ["sagittarius"], 56, 20, 15, 0],
              2651: [["♑"], "", "󾀴", ["capricorn"], 56, 21, 15, 0],
              2652: [["♒"], "", "󾀵", ["aquarius"], 56, 22, 15, 0],
              2653: [["♓"], "", "󾀶", ["pisces"], 56, 23, 15, 0],
              "265f-fe0f": [["♟️", "♟"], "", "", ["chess_pawn"], 56, 24, 15, 0],
              "2660-fe0f": [["♠️", "♠"], "", "󾬛", ["spades"], 56, 25, 15, 0],
              "2663-fe0f": [["♣️", "♣"], "", "󾬝", ["clubs"], 56, 26, 15, 0],
              "2665-fe0f": [["♥️", "♥"], "", "󾬚", ["hearts"], 56, 27, 15, 0],
              "2666-fe0f": [["♦️", "♦"], "", "󾬜", ["diamonds"], 56, 28, 15, 0],
              "2668-fe0f": [
                ["♨️", "♨"],
                "",
                "󾟺",
                ["hotsprings"],
                56,
                29,
                15,
                0,
              ],
              "267b-fe0f": [["♻️", "♻"], "", "󾬬", ["recycle"], 56, 30, 15, 0],
              "267e-fe0f": [["♾️", "♾"], "", "", ["infinity"], 56, 31, 15, 0],
              "267f": [["♿"], "", "󾬠", ["wheelchair"], 56, 32, 15, 0],
              "2692-fe0f": [
                ["⚒️", "⚒"],
                "",
                "",
                ["hammer_and_pick"],
                56,
                33,
                15,
                0,
              ],
              2693: [["⚓"], "", "󾓁", ["anchor"], 56, 34, 15, 0],
              "2694-fe0f": [
                ["⚔️", "⚔"],
                "",
                "",
                ["crossed_swords"],
                56,
                35,
                15,
                0,
              ],
              "2695-fe0f": [
                ["⚕️", "⚕"],
                "",
                "",
                ["medical_symbol", "staff_of_aesculapius"],
                56,
                36,
                14,
                0,
              ],
              "2696-fe0f": [["⚖️", "⚖"], "", "", ["scales"], 56, 37, 15, 0],
              "2697-fe0f": [["⚗️", "⚗"], "", "", ["alembic"], 56, 38, 15, 0],
              "2699-fe0f": [["⚙️", "⚙"], "", "", ["gear"], 56, 39, 15, 0],
              "269b-fe0f": [
                ["⚛️", "⚛"],
                "",
                "",
                ["atom_symbol"],
                56,
                40,
                15,
                0,
              ],
              "269c-fe0f": [
                ["⚜️", "⚜"],
                "",
                "",
                ["fleur_de_lis"],
                56,
                41,
                15,
                0,
              ],
              "26a0-fe0f": [["⚠️", "⚠"], "", "󾬣", ["warning"], 56, 42, 15, 0],
              "26a1": [["⚡"], "", "󾀄", ["zap"], 56, 43, 15, 0],
              "26a7-fe0f": [
                ["⚧️", "⚧"],
                "",
                "",
                ["transgender_symbol"],
                56,
                44,
                15,
                0,
              ],
              "26aa": [["⚪"], "", "󾭥", ["white_circle"], 56, 45, 15, 0],
              "26ab": [["⚫"], "", "󾭦", ["black_circle"], 56, 46, 15, 0],
              "26b0-fe0f": [["⚰️", "⚰"], "", "", ["coffin"], 56, 47, 15, 0],
              "26b1-fe0f": [
                ["⚱️", "⚱"],
                "",
                "",
                ["funeral_urn"],
                56,
                48,
                15,
                0,
              ],
              "26bd": [["⚽"], "", "󾟔", ["soccer"], 56, 49, 15, 0],
              "26be": [["⚾"], "", "󾟑", ["baseball"], 56, 50, 15, 0],
              "26c4": [
                ["⛄"],
                "",
                "󾀃",
                ["snowman_without_snow"],
                56,
                51,
                15,
                0,
              ],
              "26c5": [["⛅"], "", "󾀏", ["partly_sunny"], 56, 52, 15, 0],
              "26c8-fe0f": [
                ["⛈️", "⛈"],
                "",
                "",
                ["thunder_cloud_and_rain"],
                56,
                53,
                15,
                0,
              ],
              "26ce": [["⛎"], "", "󾀷", ["ophiuchus"], 56, 54, 15, 0],
              "26cf-fe0f": [["⛏️", "⛏"], "", "", ["pick"], 56, 55, 15, 0],
              "26d1-fe0f": [
                ["⛑️", "⛑"],
                "",
                "",
                ["helmet_with_white_cross"],
                56,
                56,
                15,
                0,
              ],
              "26d3-fe0f": [["⛓️", "⛓"], "", "", ["chains"], 56, 57, 15, 0],
              "26d4": [["⛔"], "", "󾬦", ["no_entry"], 56, 58, 15, 0],
              "26e9-fe0f": [
                ["⛩️", "⛩"],
                "",
                "",
                ["shinto_shrine"],
                56,
                59,
                15,
                0,
              ],
              "26ea": [["⛪"], "", "󾒻", ["church"], 57, 0, 15, 0],
              "26f0-fe0f": [["⛰️", "⛰"], "", "", ["mountain"], 57, 1, 15, 0],
              "26f1-fe0f": [
                ["⛱️", "⛱"],
                "",
                "",
                ["umbrella_on_ground"],
                57,
                2,
                15,
                0,
              ],
              "26f2": [["⛲"], "", "󾒼", ["fountain"], 57, 3, 15, 0],
              "26f3": [["⛳"], "", "󾟒", ["golf"], 57, 4, 15, 0],
              "26f4-fe0f": [["⛴️", "⛴"], "", "", ["ferry"], 57, 5, 15, 0],
              "26f5": [["⛵"], "", "󾟪", ["boat", "sailboat"], 57, 6, 15, 0],
              "26f7-fe0f": [["⛷️", "⛷"], "", "", ["skier"], 57, 7, 15, 0],
              "26f8-fe0f": [["⛸️", "⛸"], "", "", ["ice_skate"], 57, 8, 15, 0],
              "26f9-fe0f-200d-2640-fe0f": [
                ["⛹️‍♀️"],
                "",
                "",
                ["woman-bouncing-ball"],
                57,
                9,
                7,
                0,
              ],
              "26f9-fe0f-200d-2642-fe0f": [
                ["⛹️‍♂️", "⛹️", "⛹"],
                "",
                "",
                ["man-bouncing-ball", "person_with_ball"],
                57,
                15,
                7,
                0,
              ],
              "26fa": [["⛺"], "", "󾟻", ["tent"], 57, 27, 15, 0],
              "26fd": [["⛽"], "", "󾟵", ["fuelpump"], 57, 28, 15, 0],
              "2702-fe0f": [["✂️", "✂"], "", "󾔾", ["scissors"], 57, 29, 15, 0],
              2705: [["✅"], "", "󾭊", ["white_check_mark"], 57, 30, 15, 0],
              "2708-fe0f": [["✈️", "✈"], "", "󾟩", ["airplane"], 57, 31, 15, 0],
              "2709-fe0f": [
                ["✉️", "✉"],
                "",
                "󾔩",
                ["email", "envelope"],
                57,
                32,
                15,
                0,
              ],
              "270a": [["✊"], "", "󾮓", ["fist"], 57, 33, 15, 0],
              "270b": [
                ["✋"],
                "",
                "󾮕",
                ["hand", "raised_hand"],
                57,
                39,
                15,
                0,
              ],
              "270c-fe0f": [["✌️", "✌"], "", "󾮔", ["v"], 57, 45, 15, 0],
              "270d-fe0f": [
                ["✍️", "✍"],
                "",
                "",
                ["writing_hand"],
                57,
                51,
                15,
                0,
              ],
              "270f-fe0f": [["✏️", "✏"], "", "󾔹", ["pencil2"], 57, 57, 15, 0],
              "2712-fe0f": [["✒️", "✒"], "", "󾔶", ["black_nib"], 57, 58, 15, 0],
              "2714-fe0f": [
                ["✔️", "✔"],
                "",
                "󾭉",
                ["heavy_check_mark"],
                57,
                59,
                15,
                0,
              ],
              "2716-fe0f": [
                ["✖️", "✖"],
                "",
                "󾭓",
                ["heavy_multiplication_x"],
                58,
                0,
                15,
                0,
              ],
              "271d-fe0f": [["✝️", "✝"], "", "", ["latin_cross"], 58, 1, 15, 0],
              "2721-fe0f": [
                ["✡️", "✡"],
                "",
                "",
                ["star_of_david"],
                58,
                2,
                15,
                0,
              ],
              2728: [["✨"], "", "󾭠", ["sparkles"], 58, 3, 15, 0],
              "2733-fe0f": [
                ["✳️", "✳"],
                "",
                "󾭢",
                ["eight_spoked_asterisk"],
                58,
                4,
                15,
                0,
              ],
              "2734-fe0f": [
                ["✴️", "✴"],
                "",
                "󾭡",
                ["eight_pointed_black_star"],
                58,
                5,
                15,
                0,
              ],
              "2744-fe0f": [["❄️", "❄"], "", "󾀎", ["snowflake"], 58, 6, 15, 0],
              "2747-fe0f": [["❇️", "❇"], "", "󾭷", ["sparkle"], 58, 7, 15, 0],
              "274c": [["❌"], "", "󾭅", ["x"], 58, 8, 15, 0],
              "274e": [
                ["❎"],
                "",
                "󾭆",
                ["negative_squared_cross_mark"],
                58,
                9,
                15,
                0,
              ],
              2753: [["❓"], "", "󾬉", ["question"], 58, 10, 15, 0],
              2754: [["❔"], "", "󾬊", ["grey_question"], 58, 11, 15, 0],
              2755: [["❕"], "", "󾬋", ["grey_exclamation"], 58, 12, 15, 0],
              2757: [
                ["❗"],
                "",
                "󾬄",
                ["exclamation", "heavy_exclamation_mark"],
                58,
                13,
                15,
                0,
              ],
              "2763-fe0f": [
                ["❣️", "❣"],
                "",
                "",
                ["heavy_heart_exclamation_mark_ornament"],
                58,
                14,
                15,
                0,
              ],
              "2764-fe0f-200d-1f525": [
                ["❤️‍🔥", "❤‍🔥"],
                "",
                "",
                ["heart_on_fire"],
                58,
                15,
                7,
                0,
              ],
              "2764-fe0f-200d-1fa79": [
                ["❤️‍🩹", "❤‍🩹"],
                "",
                "",
                ["mending_heart"],
                58,
                16,
                7,
                0,
              ],
              "2764-fe0f": [
                ["❤️", "❤"],
                "",
                "󾬌",
                ["heart"],
                58,
                17,
                15,
                0,
                "<3",
              ],
              2795: [["➕"], "", "󾭑", ["heavy_plus_sign"], 58, 18, 15, 0],
              2796: [["➖"], "", "󾭒", ["heavy_minus_sign"], 58, 19, 15, 0],
              2797: [["➗"], "", "󾭔", ["heavy_division_sign"], 58, 20, 15, 0],
              "27a1-fe0f": [
                ["➡️", "➡"],
                "",
                "󾫺",
                ["arrow_right"],
                58,
                21,
                15,
                0,
              ],
              "27b0": [["➰"], "", "󾬈", ["curly_loop"], 58, 22, 15, 0],
              "27bf": [["➿"], "", "󾠫", ["loop"], 58, 23, 15, 0],
              "2934-fe0f": [
                ["⤴️", "⤴"],
                "",
                "󾫴",
                ["arrow_heading_up"],
                58,
                24,
                15,
                0,
              ],
              "2935-fe0f": [
                ["⤵️", "⤵"],
                "",
                "󾫵",
                ["arrow_heading_down"],
                58,
                25,
                15,
                0,
              ],
              "2b05-fe0f": [
                ["⬅️", "⬅"],
                "",
                "󾫻",
                ["arrow_left"],
                58,
                26,
                15,
                0,
              ],
              "2b06-fe0f": [["⬆️", "⬆"], "", "󾫸", ["arrow_up"], 58, 27, 15, 0],
              "2b07-fe0f": [
                ["⬇️", "⬇"],
                "",
                "󾫹",
                ["arrow_down"],
                58,
                28,
                15,
                0,
              ],
              "2b1b": [["⬛"], "", "󾭬", ["black_large_square"], 58, 29, 15, 0],
              "2b1c": [["⬜"], "", "󾭫", ["white_large_square"], 58, 30, 15, 0],
              "2b50": [["⭐"], "", "󾭨", ["star"], 58, 31, 15, 0],
              "2b55": [["⭕"], "", "󾭄", ["o"], 58, 32, 15, 0],
              "3030-fe0f": [
                ["〰️", "〰"],
                "",
                "󾬇",
                ["wavy_dash"],
                58,
                33,
                15,
                0,
              ],
              "303d-fe0f": [
                ["〽️", "〽"],
                "",
                "󾠛",
                ["part_alternation_mark"],
                58,
                34,
                15,
                0,
              ],
              "3297-fe0f": [
                ["㊗️", "㊗"],
                "",
                "󾭃",
                ["congratulations"],
                58,
                35,
                15,
                0,
              ],
              "3299-fe0f": [["㊙️", "㊙"], "", "󾬫", ["secret"], 58, 36, 15, 0],
            }),
            (r.prototype.emoticons_data = {
              ":o)": "monkey_face",
              "</3": "broken_heart",
              "=)": "smiley",
              "=-)": "smiley",
              "C:": "smile",
              "c:": "smile",
              ":D": "smile",
              ":-D": "smile",
              ":>": "laughing",
              ":->": "laughing",
              ";)": "wink",
              ";-)": "wink",
              "8)": "sunglasses",
              ":|": "neutral_face",
              ":-|": "neutral_face",
              ":\\": "confused",
              ":-\\": "confused",
              ":/": "confused",
              ":-/": "confused",
              ":*": "kissing_heart",
              ":-*": "kissing_heart",
              ":p": "stuck_out_tongue",
              ":-p": "stuck_out_tongue",
              ":P": "stuck_out_tongue",
              ":-P": "stuck_out_tongue",
              ":b": "stuck_out_tongue",
              ":-b": "stuck_out_tongue",
              ";p": "stuck_out_tongue_winking_eye",
              ";-p": "stuck_out_tongue_winking_eye",
              ";b": "stuck_out_tongue_winking_eye",
              ";-b": "stuck_out_tongue_winking_eye",
              ";P": "stuck_out_tongue_winking_eye",
              ";-P": "stuck_out_tongue_winking_eye",
              "):": "disappointed",
              ":(": "disappointed",
              ":-(": "disappointed",
              ">:(": "angry",
              ">:-(": "angry",
              ":'(": "cry",
              "D:": "anguished",
              ":o": "open_mouth",
              ":-o": "open_mouth",
              ":O": "open_mouth",
              ":-O": "open_mouth",
              ":)": "slightly_smiling_face",
              "(:": "slightly_smiling_face",
              ":-)": "slightly_smiling_face",
              "<3": "heart",
            }),
            (r.prototype.variations_data = {
              "1f385": {
                "1f3fb": ["1f385-1f3fb", 7, 16, 15, ["🎅🏻"]],
                "1f3fc": ["1f385-1f3fc", 7, 17, 15, ["🎅🏼"]],
                "1f3fd": ["1f385-1f3fd", 7, 18, 15, ["🎅🏽"]],
                "1f3fe": ["1f385-1f3fe", 7, 19, 15, ["🎅🏾"]],
                "1f3ff": ["1f385-1f3ff", 7, 20, 15, ["🎅🏿"]],
              },
              "1f3c2": {
                "1f3fb": ["1f3c2-1f3fb", 8, 17, 15, ["🏂🏻"]],
                "1f3fc": ["1f3c2-1f3fc", 8, 18, 15, ["🏂🏼"]],
                "1f3fd": ["1f3c2-1f3fd", 8, 19, 15, ["🏂🏽"]],
                "1f3fe": ["1f3c2-1f3fe", 8, 20, 15, ["🏂🏾"]],
                "1f3ff": ["1f3c2-1f3ff", 8, 21, 15, ["🏂🏿"]],
              },
              "1f3c3-200d-2640-fe0f": {
                "1f3fb": ["1f3c3-1f3fb-200d-2640-fe0f", 8, 23, 15, ["🏃🏻‍♀️"]],
                "1f3fc": ["1f3c3-1f3fc-200d-2640-fe0f", 8, 24, 15, ["🏃🏼‍♀️"]],
                "1f3fd": ["1f3c3-1f3fd-200d-2640-fe0f", 8, 25, 15, ["🏃🏽‍♀️"]],
                "1f3fe": ["1f3c3-1f3fe-200d-2640-fe0f", 8, 26, 15, ["🏃🏾‍♀️"]],
                "1f3ff": ["1f3c3-1f3ff-200d-2640-fe0f", 8, 27, 15, ["🏃🏿‍♀️"]],
              },
              "1f3c3-200d-2642-fe0f": {
                "1f3fb": [
                  "1f3c3-1f3fb-200d-2642-fe0f",
                  8,
                  29,
                  15,
                  ["🏃🏻‍♂️", "🏃🏻"],
                ],
                "1f3fc": [
                  "1f3c3-1f3fc-200d-2642-fe0f",
                  8,
                  30,
                  15,
                  ["🏃🏼‍♂️", "🏃🏼"],
                ],
                "1f3fd": [
                  "1f3c3-1f3fd-200d-2642-fe0f",
                  8,
                  31,
                  15,
                  ["🏃🏽‍♂️", "🏃🏽"],
                ],
                "1f3fe": [
                  "1f3c3-1f3fe-200d-2642-fe0f",
                  8,
                  32,
                  15,
                  ["🏃🏾‍♂️", "🏃🏾"],
                ],
                "1f3ff": [
                  "1f3c3-1f3ff-200d-2642-fe0f",
                  8,
                  33,
                  15,
                  ["🏃🏿‍♂️", "🏃🏿"],
                ],
              },
              "1f3c4-200d-2640-fe0f": {
                "1f3fb": ["1f3c4-1f3fb-200d-2640-fe0f", 8, 41, 15, ["🏄🏻‍♀️"]],
                "1f3fc": ["1f3c4-1f3fc-200d-2640-fe0f", 8, 42, 15, ["🏄🏼‍♀️"]],
                "1f3fd": ["1f3c4-1f3fd-200d-2640-fe0f", 8, 43, 15, ["🏄🏽‍♀️"]],
                "1f3fe": ["1f3c4-1f3fe-200d-2640-fe0f", 8, 44, 15, ["🏄🏾‍♀️"]],
                "1f3ff": ["1f3c4-1f3ff-200d-2640-fe0f", 8, 45, 15, ["🏄🏿‍♀️"]],
              },
              "1f3c4-200d-2642-fe0f": {
                "1f3fb": [
                  "1f3c4-1f3fb-200d-2642-fe0f",
                  8,
                  47,
                  15,
                  ["🏄🏻‍♂️", "🏄🏻"],
                ],
                "1f3fc": [
                  "1f3c4-1f3fc-200d-2642-fe0f",
                  8,
                  48,
                  15,
                  ["🏄🏼‍♂️", "🏄🏼"],
                ],
                "1f3fd": [
                  "1f3c4-1f3fd-200d-2642-fe0f",
                  8,
                  49,
                  15,
                  ["🏄🏽‍♂️", "🏄🏽"],
                ],
                "1f3fe": [
                  "1f3c4-1f3fe-200d-2642-fe0f",
                  8,
                  50,
                  15,
                  ["🏄🏾‍♂️", "🏄🏾"],
                ],
                "1f3ff": [
                  "1f3c4-1f3ff-200d-2642-fe0f",
                  8,
                  51,
                  15,
                  ["🏄🏿‍♂️", "🏄🏿"],
                ],
              },
              "1f3c7": {
                "1f3fb": ["1f3c7-1f3fb", 9, 1, 15, ["🏇🏻"]],
                "1f3fc": ["1f3c7-1f3fc", 9, 2, 15, ["🏇🏼"]],
                "1f3fd": ["1f3c7-1f3fd", 9, 3, 15, ["🏇🏽"]],
                "1f3fe": ["1f3c7-1f3fe", 9, 4, 15, ["🏇🏾"]],
                "1f3ff": ["1f3c7-1f3ff", 9, 5, 15, ["🏇🏿"]],
              },
              "1f3ca-200d-2640-fe0f": {
                "1f3fb": ["1f3ca-1f3fb-200d-2640-fe0f", 9, 9, 15, ["🏊🏻‍♀️"]],
                "1f3fc": ["1f3ca-1f3fc-200d-2640-fe0f", 9, 10, 15, ["🏊🏼‍♀️"]],
                "1f3fd": ["1f3ca-1f3fd-200d-2640-fe0f", 9, 11, 15, ["🏊🏽‍♀️"]],
                "1f3fe": ["1f3ca-1f3fe-200d-2640-fe0f", 9, 12, 15, ["🏊🏾‍♀️"]],
                "1f3ff": ["1f3ca-1f3ff-200d-2640-fe0f", 9, 13, 15, ["🏊🏿‍♀️"]],
              },
              "1f3ca-200d-2642-fe0f": {
                "1f3fb": [
                  "1f3ca-1f3fb-200d-2642-fe0f",
                  9,
                  15,
                  15,
                  ["🏊🏻‍♂️", "🏊🏻"],
                ],
                "1f3fc": [
                  "1f3ca-1f3fc-200d-2642-fe0f",
                  9,
                  16,
                  15,
                  ["🏊🏼‍♂️", "🏊🏼"],
                ],
                "1f3fd": [
                  "1f3ca-1f3fd-200d-2642-fe0f",
                  9,
                  17,
                  15,
                  ["🏊🏽‍♂️", "🏊🏽"],
                ],
                "1f3fe": [
                  "1f3ca-1f3fe-200d-2642-fe0f",
                  9,
                  18,
                  15,
                  ["🏊🏾‍♂️", "🏊🏾"],
                ],
                "1f3ff": [
                  "1f3ca-1f3ff-200d-2642-fe0f",
                  9,
                  19,
                  15,
                  ["🏊🏿‍♂️", "🏊🏿"],
                ],
              },
              "1f3cb-fe0f-200d-2640-fe0f": {
                "1f3fb": ["1f3cb-1f3fb-200d-2640-fe0f", 9, 27, 15, ["🏋🏻‍♀️"]],
                "1f3fc": ["1f3cb-1f3fc-200d-2640-fe0f", 9, 28, 15, ["🏋🏼‍♀️"]],
                "1f3fd": ["1f3cb-1f3fd-200d-2640-fe0f", 9, 29, 15, ["🏋🏽‍♀️"]],
                "1f3fe": ["1f3cb-1f3fe-200d-2640-fe0f", 9, 30, 15, ["🏋🏾‍♀️"]],
                "1f3ff": ["1f3cb-1f3ff-200d-2640-fe0f", 9, 31, 15, ["🏋🏿‍♀️"]],
              },
              "1f3cb-fe0f-200d-2642-fe0f": {
                "1f3fb": [
                  "1f3cb-1f3fb-200d-2642-fe0f",
                  9,
                  33,
                  15,
                  ["🏋🏻‍♂️", "🏋🏻"],
                ],
                "1f3fc": [
                  "1f3cb-1f3fc-200d-2642-fe0f",
                  9,
                  34,
                  15,
                  ["🏋🏼‍♂️", "🏋🏼"],
                ],
                "1f3fd": [
                  "1f3cb-1f3fd-200d-2642-fe0f",
                  9,
                  35,
                  15,
                  ["🏋🏽‍♂️", "🏋🏽"],
                ],
                "1f3fe": [
                  "1f3cb-1f3fe-200d-2642-fe0f",
                  9,
                  36,
                  15,
                  ["🏋🏾‍♂️", "🏋🏾"],
                ],
                "1f3ff": [
                  "1f3cb-1f3ff-200d-2642-fe0f",
                  9,
                  37,
                  15,
                  ["🏋🏿‍♂️", "🏋🏿"],
                ],
              },
              "1f3cc-fe0f-200d-2640-fe0f": {
                "1f3fb": ["1f3cc-1f3fb-200d-2640-fe0f", 9, 45, 15, ["🏌🏻‍♀️"]],
                "1f3fc": ["1f3cc-1f3fc-200d-2640-fe0f", 9, 46, 15, ["🏌🏼‍♀️"]],
                "1f3fd": ["1f3cc-1f3fd-200d-2640-fe0f", 9, 47, 15, ["🏌🏽‍♀️"]],
                "1f3fe": ["1f3cc-1f3fe-200d-2640-fe0f", 9, 48, 15, ["🏌🏾‍♀️"]],
                "1f3ff": ["1f3cc-1f3ff-200d-2640-fe0f", 9, 49, 15, ["🏌🏿‍♀️"]],
              },
              "1f3cc-fe0f-200d-2642-fe0f": {
                "1f3fb": [
                  "1f3cc-1f3fb-200d-2642-fe0f",
                  9,
                  51,
                  15,
                  ["🏌🏻‍♂️", "🏌🏻"],
                ],
                "1f3fc": [
                  "1f3cc-1f3fc-200d-2642-fe0f",
                  9,
                  52,
                  15,
                  ["🏌🏼‍♂️", "🏌🏼"],
                ],
                "1f3fd": [
                  "1f3cc-1f3fd-200d-2642-fe0f",
                  9,
                  53,
                  15,
                  ["🏌🏽‍♂️", "🏌🏽"],
                ],
                "1f3fe": [
                  "1f3cc-1f3fe-200d-2642-fe0f",
                  9,
                  54,
                  15,
                  ["🏌🏾‍♂️", "🏌🏾"],
                ],
                "1f3ff": [
                  "1f3cc-1f3ff-200d-2642-fe0f",
                  9,
                  55,
                  15,
                  ["🏌🏿‍♂️", "🏌🏿"],
                ],
              },
              "1f442": {
                "1f3fb": ["1f442-1f3fb", 12, 7, 15, ["👂🏻"]],
                "1f3fc": ["1f442-1f3fc", 12, 8, 15, ["👂🏼"]],
                "1f3fd": ["1f442-1f3fd", 12, 9, 15, ["👂🏽"]],
                "1f3fe": ["1f442-1f3fe", 12, 10, 15, ["👂🏾"]],
                "1f3ff": ["1f442-1f3ff", 12, 11, 15, ["👂🏿"]],
              },
              "1f443": {
                "1f3fb": ["1f443-1f3fb", 12, 13, 15, ["👃🏻"]],
                "1f3fc": ["1f443-1f3fc", 12, 14, 15, ["👃🏼"]],
                "1f3fd": ["1f443-1f3fd", 12, 15, 15, ["👃🏽"]],
                "1f3fe": ["1f443-1f3fe", 12, 16, 15, ["👃🏾"]],
                "1f3ff": ["1f443-1f3ff", 12, 17, 15, ["👃🏿"]],
              },
              "1f446": {
                "1f3fb": ["1f446-1f3fb", 12, 21, 15, ["👆🏻"]],
                "1f3fc": ["1f446-1f3fc", 12, 22, 15, ["👆🏼"]],
                "1f3fd": ["1f446-1f3fd", 12, 23, 15, ["👆🏽"]],
                "1f3fe": ["1f446-1f3fe", 12, 24, 15, ["👆🏾"]],
                "1f3ff": ["1f446-1f3ff", 12, 25, 15, ["👆🏿"]],
              },
              "1f447": {
                "1f3fb": ["1f447-1f3fb", 12, 27, 15, ["👇🏻"]],
                "1f3fc": ["1f447-1f3fc", 12, 28, 15, ["👇🏼"]],
                "1f3fd": ["1f447-1f3fd", 12, 29, 15, ["👇🏽"]],
                "1f3fe": ["1f447-1f3fe", 12, 30, 15, ["👇🏾"]],
                "1f3ff": ["1f447-1f3ff", 12, 31, 15, ["👇🏿"]],
              },
              "1f448": {
                "1f3fb": ["1f448-1f3fb", 12, 33, 15, ["👈🏻"]],
                "1f3fc": ["1f448-1f3fc", 12, 34, 15, ["👈🏼"]],
                "1f3fd": ["1f448-1f3fd", 12, 35, 15, ["👈🏽"]],
                "1f3fe": ["1f448-1f3fe", 12, 36, 15, ["👈🏾"]],
                "1f3ff": ["1f448-1f3ff", 12, 37, 15, ["👈🏿"]],
              },
              "1f449": {
                "1f3fb": ["1f449-1f3fb", 12, 39, 15, ["👉🏻"]],
                "1f3fc": ["1f449-1f3fc", 12, 40, 15, ["👉🏼"]],
                "1f3fd": ["1f449-1f3fd", 12, 41, 15, ["👉🏽"]],
                "1f3fe": ["1f449-1f3fe", 12, 42, 15, ["👉🏾"]],
                "1f3ff": ["1f449-1f3ff", 12, 43, 15, ["👉🏿"]],
              },
              "1f44a": {
                "1f3fb": ["1f44a-1f3fb", 12, 45, 15, ["👊🏻"]],
                "1f3fc": ["1f44a-1f3fc", 12, 46, 15, ["👊🏼"]],
                "1f3fd": ["1f44a-1f3fd", 12, 47, 15, ["👊🏽"]],
                "1f3fe": ["1f44a-1f3fe", 12, 48, 15, ["👊🏾"]],
                "1f3ff": ["1f44a-1f3ff", 12, 49, 15, ["👊🏿"]],
              },
              "1f44b": {
                "1f3fb": ["1f44b-1f3fb", 12, 51, 15, ["👋🏻"]],
                "1f3fc": ["1f44b-1f3fc", 12, 52, 15, ["👋🏼"]],
                "1f3fd": ["1f44b-1f3fd", 12, 53, 15, ["👋🏽"]],
                "1f3fe": ["1f44b-1f3fe", 12, 54, 15, ["👋🏾"]],
                "1f3ff": ["1f44b-1f3ff", 12, 55, 15, ["👋🏿"]],
              },
              "1f44c": {
                "1f3fb": ["1f44c-1f3fb", 12, 57, 15, ["👌🏻"]],
                "1f3fc": ["1f44c-1f3fc", 12, 58, 15, ["👌🏼"]],
                "1f3fd": ["1f44c-1f3fd", 12, 59, 15, ["👌🏽"]],
                "1f3fe": ["1f44c-1f3fe", 13, 0, 15, ["👌🏾"]],
                "1f3ff": ["1f44c-1f3ff", 13, 1, 15, ["👌🏿"]],
              },
              "1f44d": {
                "1f3fb": ["1f44d-1f3fb", 13, 3, 15, ["👍🏻"]],
                "1f3fc": ["1f44d-1f3fc", 13, 4, 15, ["👍🏼"]],
                "1f3fd": ["1f44d-1f3fd", 13, 5, 15, ["👍🏽"]],
                "1f3fe": ["1f44d-1f3fe", 13, 6, 15, ["👍🏾"]],
                "1f3ff": ["1f44d-1f3ff", 13, 7, 15, ["👍🏿"]],
              },
              "1f44e": {
                "1f3fb": ["1f44e-1f3fb", 13, 9, 15, ["👎🏻"]],
                "1f3fc": ["1f44e-1f3fc", 13, 10, 15, ["👎🏼"]],
                "1f3fd": ["1f44e-1f3fd", 13, 11, 15, ["👎🏽"]],
                "1f3fe": ["1f44e-1f3fe", 13, 12, 15, ["👎🏾"]],
                "1f3ff": ["1f44e-1f3ff", 13, 13, 15, ["👎🏿"]],
              },
              "1f44f": {
                "1f3fb": ["1f44f-1f3fb", 13, 15, 15, ["👏🏻"]],
                "1f3fc": ["1f44f-1f3fc", 13, 16, 15, ["👏🏼"]],
                "1f3fd": ["1f44f-1f3fd", 13, 17, 15, ["👏🏽"]],
                "1f3fe": ["1f44f-1f3fe", 13, 18, 15, ["👏🏾"]],
                "1f3ff": ["1f44f-1f3ff", 13, 19, 15, ["👏🏿"]],
              },
              "1f450": {
                "1f3fb": ["1f450-1f3fb", 13, 21, 15, ["👐🏻"]],
                "1f3fc": ["1f450-1f3fc", 13, 22, 15, ["👐🏼"]],
                "1f3fd": ["1f450-1f3fd", 13, 23, 15, ["👐🏽"]],
                "1f3fe": ["1f450-1f3fe", 13, 24, 15, ["👐🏾"]],
                "1f3ff": ["1f450-1f3ff", 13, 25, 15, ["👐🏿"]],
              },
              "1f466": {
                "1f3fb": ["1f466-1f3fb", 13, 48, 15, ["👦🏻"]],
                "1f3fc": ["1f466-1f3fc", 13, 49, 15, ["👦🏼"]],
                "1f3fd": ["1f466-1f3fd", 13, 50, 15, ["👦🏽"]],
                "1f3fe": ["1f466-1f3fe", 13, 51, 15, ["👦🏾"]],
                "1f3ff": ["1f466-1f3ff", 13, 52, 15, ["👦🏿"]],
              },
              "1f467": {
                "1f3fb": ["1f467-1f3fb", 13, 54, 15, ["👧🏻"]],
                "1f3fc": ["1f467-1f3fc", 13, 55, 15, ["👧🏼"]],
                "1f3fd": ["1f467-1f3fd", 13, 56, 15, ["👧🏽"]],
                "1f3fe": ["1f467-1f3fe", 13, 57, 15, ["👧🏾"]],
                "1f3ff": ["1f467-1f3ff", 13, 58, 15, ["👧🏿"]],
              },
              "1f468-200d-1f33e": {
                "1f3fb": ["1f468-1f3fb-200d-1f33e", 14, 0, 15, ["👨🏻‍🌾"]],
                "1f3fc": ["1f468-1f3fc-200d-1f33e", 14, 1, 15, ["👨🏼‍🌾"]],
                "1f3fd": ["1f468-1f3fd-200d-1f33e", 14, 2, 15, ["👨🏽‍🌾"]],
                "1f3fe": ["1f468-1f3fe-200d-1f33e", 14, 3, 15, ["👨🏾‍🌾"]],
                "1f3ff": ["1f468-1f3ff-200d-1f33e", 14, 4, 15, ["👨🏿‍🌾"]],
              },
              "1f468-200d-1f373": {
                "1f3fb": ["1f468-1f3fb-200d-1f373", 14, 6, 15, ["👨🏻‍🍳"]],
                "1f3fc": ["1f468-1f3fc-200d-1f373", 14, 7, 15, ["👨🏼‍🍳"]],
                "1f3fd": ["1f468-1f3fd-200d-1f373", 14, 8, 15, ["👨🏽‍🍳"]],
                "1f3fe": ["1f468-1f3fe-200d-1f373", 14, 9, 15, ["👨🏾‍🍳"]],
                "1f3ff": ["1f468-1f3ff-200d-1f373", 14, 10, 15, ["👨🏿‍🍳"]],
              },
              "1f468-200d-1f37c": {
                "1f3fb": ["1f468-1f3fb-200d-1f37c", 14, 12, 15, ["👨🏻‍🍼"]],
                "1f3fc": ["1f468-1f3fc-200d-1f37c", 14, 13, 15, ["👨🏼‍🍼"]],
                "1f3fd": ["1f468-1f3fd-200d-1f37c", 14, 14, 15, ["👨🏽‍🍼"]],
                "1f3fe": ["1f468-1f3fe-200d-1f37c", 14, 15, 15, ["👨🏾‍🍼"]],
                "1f3ff": ["1f468-1f3ff-200d-1f37c", 14, 16, 15, ["👨🏿‍🍼"]],
              },
              "1f468-200d-1f393": {
                "1f3fb": ["1f468-1f3fb-200d-1f393", 14, 18, 15, ["👨🏻‍🎓"]],
                "1f3fc": ["1f468-1f3fc-200d-1f393", 14, 19, 15, ["👨🏼‍🎓"]],
                "1f3fd": ["1f468-1f3fd-200d-1f393", 14, 20, 15, ["👨🏽‍🎓"]],
                "1f3fe": ["1f468-1f3fe-200d-1f393", 14, 21, 15, ["👨🏾‍🎓"]],
                "1f3ff": ["1f468-1f3ff-200d-1f393", 14, 22, 15, ["👨🏿‍🎓"]],
              },
              "1f468-200d-1f3a4": {
                "1f3fb": ["1f468-1f3fb-200d-1f3a4", 14, 24, 15, ["👨🏻‍🎤"]],
                "1f3fc": ["1f468-1f3fc-200d-1f3a4", 14, 25, 15, ["👨🏼‍🎤"]],
                "1f3fd": ["1f468-1f3fd-200d-1f3a4", 14, 26, 15, ["👨🏽‍🎤"]],
                "1f3fe": ["1f468-1f3fe-200d-1f3a4", 14, 27, 15, ["👨🏾‍🎤"]],
                "1f3ff": ["1f468-1f3ff-200d-1f3a4", 14, 28, 15, ["👨🏿‍🎤"]],
              },
              "1f468-200d-1f3a8": {
                "1f3fb": ["1f468-1f3fb-200d-1f3a8", 14, 30, 15, ["👨🏻‍🎨"]],
                "1f3fc": ["1f468-1f3fc-200d-1f3a8", 14, 31, 15, ["👨🏼‍🎨"]],
                "1f3fd": ["1f468-1f3fd-200d-1f3a8", 14, 32, 15, ["👨🏽‍🎨"]],
                "1f3fe": ["1f468-1f3fe-200d-1f3a8", 14, 33, 15, ["👨🏾‍🎨"]],
                "1f3ff": ["1f468-1f3ff-200d-1f3a8", 14, 34, 15, ["👨🏿‍🎨"]],
              },
              "1f468-200d-1f3eb": {
                "1f3fb": ["1f468-1f3fb-200d-1f3eb", 14, 36, 15, ["👨🏻‍🏫"]],
                "1f3fc": ["1f468-1f3fc-200d-1f3eb", 14, 37, 15, ["👨🏼‍🏫"]],
                "1f3fd": ["1f468-1f3fd-200d-1f3eb", 14, 38, 15, ["👨🏽‍🏫"]],
                "1f3fe": ["1f468-1f3fe-200d-1f3eb", 14, 39, 15, ["👨🏾‍🏫"]],
                "1f3ff": ["1f468-1f3ff-200d-1f3eb", 14, 40, 15, ["👨🏿‍🏫"]],
              },
              "1f468-200d-1f3ed": {
                "1f3fb": ["1f468-1f3fb-200d-1f3ed", 14, 42, 15, ["👨🏻‍🏭"]],
                "1f3fc": ["1f468-1f3fc-200d-1f3ed", 14, 43, 15, ["👨🏼‍🏭"]],
                "1f3fd": ["1f468-1f3fd-200d-1f3ed", 14, 44, 15, ["👨🏽‍🏭"]],
                "1f3fe": ["1f468-1f3fe-200d-1f3ed", 14, 45, 15, ["👨🏾‍🏭"]],
                "1f3ff": ["1f468-1f3ff-200d-1f3ed", 14, 46, 15, ["👨🏿‍🏭"]],
              },
              "1f468-200d-1f4bb": {
                "1f3fb": ["1f468-1f3fb-200d-1f4bb", 15, 3, 15, ["👨🏻‍💻"]],
                "1f3fc": ["1f468-1f3fc-200d-1f4bb", 15, 4, 15, ["👨🏼‍💻"]],
                "1f3fd": ["1f468-1f3fd-200d-1f4bb", 15, 5, 15, ["👨🏽‍💻"]],
                "1f3fe": ["1f468-1f3fe-200d-1f4bb", 15, 6, 15, ["👨🏾‍💻"]],
                "1f3ff": ["1f468-1f3ff-200d-1f4bb", 15, 7, 15, ["👨🏿‍💻"]],
              },
              "1f468-200d-1f4bc": {
                "1f3fb": ["1f468-1f3fb-200d-1f4bc", 15, 9, 15, ["👨🏻‍💼"]],
                "1f3fc": ["1f468-1f3fc-200d-1f4bc", 15, 10, 15, ["👨🏼‍💼"]],
                "1f3fd": ["1f468-1f3fd-200d-1f4bc", 15, 11, 15, ["👨🏽‍💼"]],
                "1f3fe": ["1f468-1f3fe-200d-1f4bc", 15, 12, 15, ["👨🏾‍💼"]],
                "1f3ff": ["1f468-1f3ff-200d-1f4bc", 15, 13, 15, ["👨🏿‍💼"]],
              },
              "1f468-200d-1f527": {
                "1f3fb": ["1f468-1f3fb-200d-1f527", 15, 15, 15, ["👨🏻‍🔧"]],
                "1f3fc": ["1f468-1f3fc-200d-1f527", 15, 16, 15, ["👨🏼‍🔧"]],
                "1f3fd": ["1f468-1f3fd-200d-1f527", 15, 17, 15, ["👨🏽‍🔧"]],
                "1f3fe": ["1f468-1f3fe-200d-1f527", 15, 18, 15, ["👨🏾‍🔧"]],
                "1f3ff": ["1f468-1f3ff-200d-1f527", 15, 19, 15, ["👨🏿‍🔧"]],
              },
              "1f468-200d-1f52c": {
                "1f3fb": ["1f468-1f3fb-200d-1f52c", 15, 21, 15, ["👨🏻‍🔬"]],
                "1f3fc": ["1f468-1f3fc-200d-1f52c", 15, 22, 15, ["👨🏼‍🔬"]],
                "1f3fd": ["1f468-1f3fd-200d-1f52c", 15, 23, 15, ["👨🏽‍🔬"]],
                "1f3fe": ["1f468-1f3fe-200d-1f52c", 15, 24, 15, ["👨🏾‍🔬"]],
                "1f3ff": ["1f468-1f3ff-200d-1f52c", 15, 25, 15, ["👨🏿‍🔬"]],
              },
              "1f468-200d-1f680": {
                "1f3fb": ["1f468-1f3fb-200d-1f680", 15, 27, 15, ["👨🏻‍🚀"]],
                "1f3fc": ["1f468-1f3fc-200d-1f680", 15, 28, 15, ["👨🏼‍🚀"]],
                "1f3fd": ["1f468-1f3fd-200d-1f680", 15, 29, 15, ["👨🏽‍🚀"]],
                "1f3fe": ["1f468-1f3fe-200d-1f680", 15, 30, 15, ["👨🏾‍🚀"]],
                "1f3ff": ["1f468-1f3ff-200d-1f680", 15, 31, 15, ["👨🏿‍🚀"]],
              },
              "1f468-200d-1f692": {
                "1f3fb": ["1f468-1f3fb-200d-1f692", 15, 33, 15, ["👨🏻‍🚒"]],
                "1f3fc": ["1f468-1f3fc-200d-1f692", 15, 34, 15, ["👨🏼‍🚒"]],
                "1f3fd": ["1f468-1f3fd-200d-1f692", 15, 35, 15, ["👨🏽‍🚒"]],
                "1f3fe": ["1f468-1f3fe-200d-1f692", 15, 36, 15, ["👨🏾‍🚒"]],
                "1f3ff": ["1f468-1f3ff-200d-1f692", 15, 37, 15, ["👨🏿‍🚒"]],
              },
              "1f468-200d-1f9af": {
                "1f3fb": ["1f468-1f3fb-200d-1f9af", 15, 39, 15, ["👨🏻‍🦯"]],
                "1f3fc": ["1f468-1f3fc-200d-1f9af", 15, 40, 15, ["👨🏼‍🦯"]],
                "1f3fd": ["1f468-1f3fd-200d-1f9af", 15, 41, 15, ["👨🏽‍🦯"]],
                "1f3fe": ["1f468-1f3fe-200d-1f9af", 15, 42, 15, ["👨🏾‍🦯"]],
                "1f3ff": ["1f468-1f3ff-200d-1f9af", 15, 43, 15, ["👨🏿‍🦯"]],
              },
              "1f468-200d-1f9b0": {
                "1f3fb": ["1f468-1f3fb-200d-1f9b0", 15, 45, 15, ["👨🏻‍🦰"]],
                "1f3fc": ["1f468-1f3fc-200d-1f9b0", 15, 46, 15, ["👨🏼‍🦰"]],
                "1f3fd": ["1f468-1f3fd-200d-1f9b0", 15, 47, 15, ["👨🏽‍🦰"]],
                "1f3fe": ["1f468-1f3fe-200d-1f9b0", 15, 48, 15, ["👨🏾‍🦰"]],
                "1f3ff": ["1f468-1f3ff-200d-1f9b0", 15, 49, 15, ["👨🏿‍🦰"]],
              },
              "1f468-200d-1f9b1": {
                "1f3fb": ["1f468-1f3fb-200d-1f9b1", 15, 51, 15, ["👨🏻‍🦱"]],
                "1f3fc": ["1f468-1f3fc-200d-1f9b1", 15, 52, 15, ["👨🏼‍🦱"]],
                "1f3fd": ["1f468-1f3fd-200d-1f9b1", 15, 53, 15, ["👨🏽‍🦱"]],
                "1f3fe": ["1f468-1f3fe-200d-1f9b1", 15, 54, 15, ["👨🏾‍🦱"]],
                "1f3ff": ["1f468-1f3ff-200d-1f9b1", 15, 55, 15, ["👨🏿‍🦱"]],
              },
              "1f468-200d-1f9b2": {
                "1f3fb": ["1f468-1f3fb-200d-1f9b2", 15, 57, 15, ["👨🏻‍🦲"]],
                "1f3fc": ["1f468-1f3fc-200d-1f9b2", 15, 58, 15, ["👨🏼‍🦲"]],
                "1f3fd": ["1f468-1f3fd-200d-1f9b2", 15, 59, 15, ["👨🏽‍🦲"]],
                "1f3fe": ["1f468-1f3fe-200d-1f9b2", 16, 0, 15, ["👨🏾‍🦲"]],
                "1f3ff": ["1f468-1f3ff-200d-1f9b2", 16, 1, 15, ["👨🏿‍🦲"]],
              },
              "1f468-200d-1f9b3": {
                "1f3fb": ["1f468-1f3fb-200d-1f9b3", 16, 3, 15, ["👨🏻‍🦳"]],
                "1f3fc": ["1f468-1f3fc-200d-1f9b3", 16, 4, 15, ["👨🏼‍🦳"]],
                "1f3fd": ["1f468-1f3fd-200d-1f9b3", 16, 5, 15, ["👨🏽‍🦳"]],
                "1f3fe": ["1f468-1f3fe-200d-1f9b3", 16, 6, 15, ["👨🏾‍🦳"]],
                "1f3ff": ["1f468-1f3ff-200d-1f9b3", 16, 7, 15, ["👨🏿‍🦳"]],
              },
              "1f468-200d-1f9bc": {
                "1f3fb": ["1f468-1f3fb-200d-1f9bc", 16, 9, 15, ["👨🏻‍🦼"]],
                "1f3fc": ["1f468-1f3fc-200d-1f9bc", 16, 10, 15, ["👨🏼‍🦼"]],
                "1f3fd": ["1f468-1f3fd-200d-1f9bc", 16, 11, 15, ["👨🏽‍🦼"]],
                "1f3fe": ["1f468-1f3fe-200d-1f9bc", 16, 12, 15, ["👨🏾‍🦼"]],
                "1f3ff": ["1f468-1f3ff-200d-1f9bc", 16, 13, 15, ["👨🏿‍🦼"]],
              },
              "1f468-200d-1f9bd": {
                "1f3fb": ["1f468-1f3fb-200d-1f9bd", 16, 15, 15, ["👨🏻‍🦽"]],
                "1f3fc": ["1f468-1f3fc-200d-1f9bd", 16, 16, 15, ["👨🏼‍🦽"]],
                "1f3fd": ["1f468-1f3fd-200d-1f9bd", 16, 17, 15, ["👨🏽‍🦽"]],
                "1f3fe": ["1f468-1f3fe-200d-1f9bd", 16, 18, 15, ["👨🏾‍🦽"]],
                "1f3ff": ["1f468-1f3ff-200d-1f9bd", 16, 19, 15, ["👨🏿‍🦽"]],
              },
              "1f468-200d-2695-fe0f": {
                "1f3fb": ["1f468-1f3fb-200d-2695-fe0f", 16, 21, 15, ["👨🏻‍⚕️"]],
                "1f3fc": ["1f468-1f3fc-200d-2695-fe0f", 16, 22, 15, ["👨🏼‍⚕️"]],
                "1f3fd": ["1f468-1f3fd-200d-2695-fe0f", 16, 23, 15, ["👨🏽‍⚕️"]],
                "1f3fe": ["1f468-1f3fe-200d-2695-fe0f", 16, 24, 15, ["👨🏾‍⚕️"]],
                "1f3ff": ["1f468-1f3ff-200d-2695-fe0f", 16, 25, 15, ["👨🏿‍⚕️"]],
              },
              "1f468-200d-2696-fe0f": {
                "1f3fb": ["1f468-1f3fb-200d-2696-fe0f", 16, 27, 15, ["👨🏻‍⚖️"]],
                "1f3fc": ["1f468-1f3fc-200d-2696-fe0f", 16, 28, 15, ["👨🏼‍⚖️"]],
                "1f3fd": ["1f468-1f3fd-200d-2696-fe0f", 16, 29, 15, ["👨🏽‍⚖️"]],
                "1f3fe": ["1f468-1f3fe-200d-2696-fe0f", 16, 30, 15, ["👨🏾‍⚖️"]],
                "1f3ff": ["1f468-1f3ff-200d-2696-fe0f", 16, 31, 15, ["👨🏿‍⚖️"]],
              },
              "1f468-200d-2708-fe0f": {
                "1f3fb": ["1f468-1f3fb-200d-2708-fe0f", 16, 33, 15, ["👨🏻‍✈️"]],
                "1f3fc": ["1f468-1f3fc-200d-2708-fe0f", 16, 34, 15, ["👨🏼‍✈️"]],
                "1f3fd": ["1f468-1f3fd-200d-2708-fe0f", 16, 35, 15, ["👨🏽‍✈️"]],
                "1f3fe": ["1f468-1f3fe-200d-2708-fe0f", 16, 36, 15, ["👨🏾‍✈️"]],
                "1f3ff": ["1f468-1f3ff-200d-2708-fe0f", 16, 37, 15, ["👨🏿‍✈️"]],
              },
              "1f468-200d-2764-fe0f-200d-1f468": {
                "1f3fb-1f3fb": [
                  "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb",
                  16,
                  39,
                  7,
                  ["👨🏻‍❤️‍👨🏻"],
                ],
                "1f3fb-1f3fc": [
                  "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fc",
                  16,
                  40,
                  7,
                  ["👨🏻‍❤️‍👨🏼"],
                ],
                "1f3fb-1f3fd": [
                  "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fd",
                  16,
                  41,
                  7,
                  ["👨🏻‍❤️‍👨🏽"],
                ],
                "1f3fb-1f3fe": [
                  "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fe",
                  16,
                  42,
                  7,
                  ["👨🏻‍❤️‍👨🏾"],
                ],
                "1f3fb-1f3ff": [
                  "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3ff",
                  16,
                  43,
                  7,
                  ["👨🏻‍❤️‍👨🏿"],
                ],
                "1f3fc-1f3fb": [
                  "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fb",
                  16,
                  44,
                  7,
                  ["👨🏼‍❤️‍👨🏻"],
                ],
                "1f3fc-1f3fc": [
                  "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc",
                  16,
                  45,
                  7,
                  ["👨🏼‍❤️‍👨🏼"],
                ],
                "1f3fc-1f3fd": [
                  "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fd",
                  16,
                  46,
                  7,
                  ["👨🏼‍❤️‍👨🏽"],
                ],
                "1f3fc-1f3fe": [
                  "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fe",
                  16,
                  47,
                  7,
                  ["👨🏼‍❤️‍👨🏾"],
                ],
                "1f3fc-1f3ff": [
                  "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3ff",
                  16,
                  48,
                  7,
                  ["👨🏼‍❤️‍👨🏿"],
                ],
                "1f3fd-1f3fb": [
                  "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fb",
                  16,
                  49,
                  7,
                  ["👨🏽‍❤️‍👨🏻"],
                ],
                "1f3fd-1f3fc": [
                  "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fc",
                  16,
                  50,
                  7,
                  ["👨🏽‍❤️‍👨🏼"],
                ],
                "1f3fd-1f3fd": [
                  "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd",
                  16,
                  51,
                  7,
                  ["👨🏽‍❤️‍👨🏽"],
                ],
                "1f3fd-1f3fe": [
                  "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fe",
                  16,
                  52,
                  7,
                  ["👨🏽‍❤️‍👨🏾"],
                ],
                "1f3fd-1f3ff": [
                  "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3ff",
                  16,
                  53,
                  7,
                  ["👨🏽‍❤️‍👨🏿"],
                ],
                "1f3fe-1f3fb": [
                  "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fb",
                  16,
                  54,
                  7,
                  ["👨🏾‍❤️‍👨🏻"],
                ],
                "1f3fe-1f3fc": [
                  "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fc",
                  16,
                  55,
                  7,
                  ["👨🏾‍❤️‍👨🏼"],
                ],
                "1f3fe-1f3fd": [
                  "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fd",
                  16,
                  56,
                  7,
                  ["👨🏾‍❤️‍👨🏽"],
                ],
                "1f3fe-1f3fe": [
                  "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe",
                  16,
                  57,
                  7,
                  ["👨🏾‍❤️‍👨🏾"],
                ],
                "1f3fe-1f3ff": [
                  "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3ff",
                  16,
                  58,
                  7,
                  ["👨🏾‍❤️‍👨🏿"],
                ],
                "1f3ff-1f3fb": [
                  "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fb",
                  16,
                  59,
                  7,
                  ["👨🏿‍❤️‍👨🏻"],
                ],
                "1f3ff-1f3fc": [
                  "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fc",
                  17,
                  0,
                  7,
                  ["👨🏿‍❤️‍👨🏼"],
                ],
                "1f3ff-1f3fd": [
                  "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fd",
                  17,
                  1,
                  7,
                  ["👨🏿‍❤️‍👨🏽"],
                ],
                "1f3ff-1f3fe": [
                  "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fe",
                  17,
                  2,
                  7,
                  ["👨🏿‍❤️‍👨🏾"],
                ],
                "1f3ff-1f3ff": [
                  "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff",
                  17,
                  3,
                  7,
                  ["👨🏿‍❤️‍👨🏿"],
                ],
              },
              "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468": {
                "1f3fb-1f3fb": [
                  "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
                  17,
                  5,
                  7,
                  ["👨🏻‍❤️‍💋‍👨🏻"],
                ],
                "1f3fb-1f3fc": [
                  "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
                  17,
                  6,
                  7,
                  ["👨🏻‍❤️‍💋‍👨🏼"],
                ],
                "1f3fb-1f3fd": [
                  "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
                  17,
                  7,
                  7,
                  ["👨🏻‍❤️‍💋‍👨🏽"],
                ],
                "1f3fb-1f3fe": [
                  "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
                  17,
                  8,
                  7,
                  ["👨🏻‍❤️‍💋‍👨🏾"],
                ],
                "1f3fb-1f3ff": [
                  "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
                  17,
                  9,
                  7,
                  ["👨🏻‍❤️‍💋‍👨🏿"],
                ],
                "1f3fc-1f3fb": [
                  "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
                  17,
                  10,
                  7,
                  ["👨🏼‍❤️‍💋‍👨🏻"],
                ],
                "1f3fc-1f3fc": [
                  "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
                  17,
                  11,
                  7,
                  ["👨🏼‍❤️‍💋‍👨🏼"],
                ],
                "1f3fc-1f3fd": [
                  "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
                  17,
                  12,
                  7,
                  ["👨🏼‍❤️‍💋‍👨🏽"],
                ],
                "1f3fc-1f3fe": [
                  "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
                  17,
                  13,
                  7,
                  ["👨🏼‍❤️‍💋‍👨🏾"],
                ],
                "1f3fc-1f3ff": [
                  "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
                  17,
                  14,
                  7,
                  ["👨🏼‍❤️‍💋‍👨🏿"],
                ],
                "1f3fd-1f3fb": [
                  "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
                  17,
                  15,
                  7,
                  ["👨🏽‍❤️‍💋‍👨🏻"],
                ],
                "1f3fd-1f3fc": [
                  "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
                  17,
                  16,
                  7,
                  ["👨🏽‍❤️‍💋‍👨🏼"],
                ],
                "1f3fd-1f3fd": [
                  "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
                  17,
                  17,
                  7,
                  ["👨🏽‍❤️‍💋‍👨🏽"],
                ],
                "1f3fd-1f3fe": [
                  "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
                  17,
                  18,
                  7,
                  ["👨🏽‍❤️‍💋‍👨🏾"],
                ],
                "1f3fd-1f3ff": [
                  "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
                  17,
                  19,
                  7,
                  ["👨🏽‍❤️‍💋‍👨🏿"],
                ],
                "1f3fe-1f3fb": [
                  "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
                  17,
                  20,
                  7,
                  ["👨🏾‍❤️‍💋‍👨🏻"],
                ],
                "1f3fe-1f3fc": [
                  "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
                  17,
                  21,
                  7,
                  ["👨🏾‍❤️‍💋‍👨🏼"],
                ],
                "1f3fe-1f3fd": [
                  "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
                  17,
                  22,
                  7,
                  ["👨🏾‍❤️‍💋‍👨🏽"],
                ],
                "1f3fe-1f3fe": [
                  "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
                  17,
                  23,
                  7,
                  ["👨🏾‍❤️‍💋‍👨🏾"],
                ],
                "1f3fe-1f3ff": [
                  "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
                  17,
                  24,
                  7,
                  ["👨🏾‍❤️‍💋‍👨🏿"],
                ],
                "1f3ff-1f3fb": [
                  "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
                  17,
                  25,
                  7,
                  ["👨🏿‍❤️‍💋‍👨🏻"],
                ],
                "1f3ff-1f3fc": [
                  "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
                  17,
                  26,
                  7,
                  ["👨🏿‍❤️‍💋‍👨🏼"],
                ],
                "1f3ff-1f3fd": [
                  "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
                  17,
                  27,
                  7,
                  ["👨🏿‍❤️‍💋‍👨🏽"],
                ],
                "1f3ff-1f3fe": [
                  "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
                  17,
                  28,
                  7,
                  ["👨🏿‍❤️‍💋‍👨🏾"],
                ],
                "1f3ff-1f3ff": [
                  "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
                  17,
                  29,
                  7,
                  ["👨🏿‍❤️‍💋‍👨🏿"],
                ],
              },
              "1f468": {
                "1f3fb": ["1f468-1f3fb", 17, 31, 15, ["👨🏻"]],
                "1f3fc": ["1f468-1f3fc", 17, 32, 15, ["👨🏼"]],
                "1f3fd": ["1f468-1f3fd", 17, 33, 15, ["👨🏽"]],
                "1f3fe": ["1f468-1f3fe", 17, 34, 15, ["👨🏾"]],
                "1f3ff": ["1f468-1f3ff", 17, 35, 15, ["👨🏿"]],
              },
              "1f469-200d-1f33e": {
                "1f3fb": ["1f469-1f3fb-200d-1f33e", 17, 37, 15, ["👩🏻‍🌾"]],
                "1f3fc": ["1f469-1f3fc-200d-1f33e", 17, 38, 15, ["👩🏼‍🌾"]],
                "1f3fd": ["1f469-1f3fd-200d-1f33e", 17, 39, 15, ["👩🏽‍🌾"]],
                "1f3fe": ["1f469-1f3fe-200d-1f33e", 17, 40, 15, ["👩🏾‍🌾"]],
                "1f3ff": ["1f469-1f3ff-200d-1f33e", 17, 41, 15, ["👩🏿‍🌾"]],
              },
              "1f469-200d-1f373": {
                "1f3fb": ["1f469-1f3fb-200d-1f373", 17, 43, 15, ["👩🏻‍🍳"]],
                "1f3fc": ["1f469-1f3fc-200d-1f373", 17, 44, 15, ["👩🏼‍🍳"]],
                "1f3fd": ["1f469-1f3fd-200d-1f373", 17, 45, 15, ["👩🏽‍🍳"]],
                "1f3fe": ["1f469-1f3fe-200d-1f373", 17, 46, 15, ["👩🏾‍🍳"]],
                "1f3ff": ["1f469-1f3ff-200d-1f373", 17, 47, 15, ["👩🏿‍🍳"]],
              },
              "1f469-200d-1f37c": {
                "1f3fb": ["1f469-1f3fb-200d-1f37c", 17, 49, 15, ["👩🏻‍🍼"]],
                "1f3fc": ["1f469-1f3fc-200d-1f37c", 17, 50, 15, ["👩🏼‍🍼"]],
                "1f3fd": ["1f469-1f3fd-200d-1f37c", 17, 51, 15, ["👩🏽‍🍼"]],
                "1f3fe": ["1f469-1f3fe-200d-1f37c", 17, 52, 15, ["👩🏾‍🍼"]],
                "1f3ff": ["1f469-1f3ff-200d-1f37c", 17, 53, 15, ["👩🏿‍🍼"]],
              },
              "1f469-200d-1f393": {
                "1f3fb": ["1f469-1f3fb-200d-1f393", 17, 55, 15, ["👩🏻‍🎓"]],
                "1f3fc": ["1f469-1f3fc-200d-1f393", 17, 56, 15, ["👩🏼‍🎓"]],
                "1f3fd": ["1f469-1f3fd-200d-1f393", 17, 57, 15, ["👩🏽‍🎓"]],
                "1f3fe": ["1f469-1f3fe-200d-1f393", 17, 58, 15, ["👩🏾‍🎓"]],
                "1f3ff": ["1f469-1f3ff-200d-1f393", 17, 59, 15, ["👩🏿‍🎓"]],
              },
              "1f469-200d-1f3a4": {
                "1f3fb": ["1f469-1f3fb-200d-1f3a4", 18, 1, 15, ["👩🏻‍🎤"]],
                "1f3fc": ["1f469-1f3fc-200d-1f3a4", 18, 2, 15, ["👩🏼‍🎤"]],
                "1f3fd": ["1f469-1f3fd-200d-1f3a4", 18, 3, 15, ["👩🏽‍🎤"]],
                "1f3fe": ["1f469-1f3fe-200d-1f3a4", 18, 4, 15, ["👩🏾‍🎤"]],
                "1f3ff": ["1f469-1f3ff-200d-1f3a4", 18, 5, 15, ["👩🏿‍🎤"]],
              },
              "1f469-200d-1f3a8": {
                "1f3fb": ["1f469-1f3fb-200d-1f3a8", 18, 7, 15, ["👩🏻‍🎨"]],
                "1f3fc": ["1f469-1f3fc-200d-1f3a8", 18, 8, 15, ["👩🏼‍🎨"]],
                "1f3fd": ["1f469-1f3fd-200d-1f3a8", 18, 9, 15, ["👩🏽‍🎨"]],
                "1f3fe": ["1f469-1f3fe-200d-1f3a8", 18, 10, 15, ["👩🏾‍🎨"]],
                "1f3ff": ["1f469-1f3ff-200d-1f3a8", 18, 11, 15, ["👩🏿‍🎨"]],
              },
              "1f469-200d-1f3eb": {
                "1f3fb": ["1f469-1f3fb-200d-1f3eb", 18, 13, 15, ["👩🏻‍🏫"]],
                "1f3fc": ["1f469-1f3fc-200d-1f3eb", 18, 14, 15, ["👩🏼‍🏫"]],
                "1f3fd": ["1f469-1f3fd-200d-1f3eb", 18, 15, 15, ["👩🏽‍🏫"]],
                "1f3fe": ["1f469-1f3fe-200d-1f3eb", 18, 16, 15, ["👩🏾‍🏫"]],
                "1f3ff": ["1f469-1f3ff-200d-1f3eb", 18, 17, 15, ["👩🏿‍🏫"]],
              },
              "1f469-200d-1f3ed": {
                "1f3fb": ["1f469-1f3fb-200d-1f3ed", 18, 19, 15, ["👩🏻‍🏭"]],
                "1f3fc": ["1f469-1f3fc-200d-1f3ed", 18, 20, 15, ["👩🏼‍🏭"]],
                "1f3fd": ["1f469-1f3fd-200d-1f3ed", 18, 21, 15, ["👩🏽‍🏭"]],
                "1f3fe": ["1f469-1f3fe-200d-1f3ed", 18, 22, 15, ["👩🏾‍🏭"]],
                "1f3ff": ["1f469-1f3ff-200d-1f3ed", 18, 23, 15, ["👩🏿‍🏭"]],
              },
              "1f469-200d-1f4bb": {
                "1f3fb": ["1f469-1f3fb-200d-1f4bb", 18, 35, 15, ["👩🏻‍💻"]],
                "1f3fc": ["1f469-1f3fc-200d-1f4bb", 18, 36, 15, ["👩🏼‍💻"]],
                "1f3fd": ["1f469-1f3fd-200d-1f4bb", 18, 37, 15, ["👩🏽‍💻"]],
                "1f3fe": ["1f469-1f3fe-200d-1f4bb", 18, 38, 15, ["👩🏾‍💻"]],
                "1f3ff": ["1f469-1f3ff-200d-1f4bb", 18, 39, 15, ["👩🏿‍💻"]],
              },
              "1f469-200d-1f4bc": {
                "1f3fb": ["1f469-1f3fb-200d-1f4bc", 18, 41, 15, ["👩🏻‍💼"]],
                "1f3fc": ["1f469-1f3fc-200d-1f4bc", 18, 42, 15, ["👩🏼‍💼"]],
                "1f3fd": ["1f469-1f3fd-200d-1f4bc", 18, 43, 15, ["👩🏽‍💼"]],
                "1f3fe": ["1f469-1f3fe-200d-1f4bc", 18, 44, 15, ["👩🏾‍💼"]],
                "1f3ff": ["1f469-1f3ff-200d-1f4bc", 18, 45, 15, ["👩🏿‍💼"]],
              },
              "1f469-200d-1f527": {
                "1f3fb": ["1f469-1f3fb-200d-1f527", 18, 47, 15, ["👩🏻‍🔧"]],
                "1f3fc": ["1f469-1f3fc-200d-1f527", 18, 48, 15, ["👩🏼‍🔧"]],
                "1f3fd": ["1f469-1f3fd-200d-1f527", 18, 49, 15, ["👩🏽‍🔧"]],
                "1f3fe": ["1f469-1f3fe-200d-1f527", 18, 50, 15, ["👩🏾‍🔧"]],
                "1f3ff": ["1f469-1f3ff-200d-1f527", 18, 51, 15, ["👩🏿‍🔧"]],
              },
              "1f469-200d-1f52c": {
                "1f3fb": ["1f469-1f3fb-200d-1f52c", 18, 53, 15, ["👩🏻‍🔬"]],
                "1f3fc": ["1f469-1f3fc-200d-1f52c", 18, 54, 15, ["👩🏼‍🔬"]],
                "1f3fd": ["1f469-1f3fd-200d-1f52c", 18, 55, 15, ["👩🏽‍🔬"]],
                "1f3fe": ["1f469-1f3fe-200d-1f52c", 18, 56, 15, ["👩🏾‍🔬"]],
                "1f3ff": ["1f469-1f3ff-200d-1f52c", 18, 57, 15, ["👩🏿‍🔬"]],
              },
              "1f469-200d-1f680": {
                "1f3fb": ["1f469-1f3fb-200d-1f680", 18, 59, 15, ["👩🏻‍🚀"]],
                "1f3fc": ["1f469-1f3fc-200d-1f680", 19, 0, 15, ["👩🏼‍🚀"]],
                "1f3fd": ["1f469-1f3fd-200d-1f680", 19, 1, 15, ["👩🏽‍🚀"]],
                "1f3fe": ["1f469-1f3fe-200d-1f680", 19, 2, 15, ["👩🏾‍🚀"]],
                "1f3ff": ["1f469-1f3ff-200d-1f680", 19, 3, 15, ["👩🏿‍🚀"]],
              },
              "1f469-200d-1f692": {
                "1f3fb": ["1f469-1f3fb-200d-1f692", 19, 5, 15, ["👩🏻‍🚒"]],
                "1f3fc": ["1f469-1f3fc-200d-1f692", 19, 6, 15, ["👩🏼‍🚒"]],
                "1f3fd": ["1f469-1f3fd-200d-1f692", 19, 7, 15, ["👩🏽‍🚒"]],
                "1f3fe": ["1f469-1f3fe-200d-1f692", 19, 8, 15, ["👩🏾‍🚒"]],
                "1f3ff": ["1f469-1f3ff-200d-1f692", 19, 9, 15, ["👩🏿‍🚒"]],
              },
              "1f469-200d-1f9af": {
                "1f3fb": ["1f469-1f3fb-200d-1f9af", 19, 11, 15, ["👩🏻‍🦯"]],
                "1f3fc": ["1f469-1f3fc-200d-1f9af", 19, 12, 15, ["👩🏼‍🦯"]],
                "1f3fd": ["1f469-1f3fd-200d-1f9af", 19, 13, 15, ["👩🏽‍🦯"]],
                "1f3fe": ["1f469-1f3fe-200d-1f9af", 19, 14, 15, ["👩🏾‍🦯"]],
                "1f3ff": ["1f469-1f3ff-200d-1f9af", 19, 15, 15, ["👩🏿‍🦯"]],
              },
              "1f469-200d-1f9b0": {
                "1f3fb": ["1f469-1f3fb-200d-1f9b0", 19, 17, 15, ["👩🏻‍🦰"]],
                "1f3fc": ["1f469-1f3fc-200d-1f9b0", 19, 18, 15, ["👩🏼‍🦰"]],
                "1f3fd": ["1f469-1f3fd-200d-1f9b0", 19, 19, 15, ["👩🏽‍🦰"]],
                "1f3fe": ["1f469-1f3fe-200d-1f9b0", 19, 20, 15, ["👩🏾‍🦰"]],
                "1f3ff": ["1f469-1f3ff-200d-1f9b0", 19, 21, 15, ["👩🏿‍🦰"]],
              },
              "1f469-200d-1f9b1": {
                "1f3fb": ["1f469-1f3fb-200d-1f9b1", 19, 23, 15, ["👩🏻‍🦱"]],
                "1f3fc": ["1f469-1f3fc-200d-1f9b1", 19, 24, 15, ["👩🏼‍🦱"]],
                "1f3fd": ["1f469-1f3fd-200d-1f9b1", 19, 25, 15, ["👩🏽‍🦱"]],
                "1f3fe": ["1f469-1f3fe-200d-1f9b1", 19, 26, 15, ["👩🏾‍🦱"]],
                "1f3ff": ["1f469-1f3ff-200d-1f9b1", 19, 27, 15, ["👩🏿‍🦱"]],
              },
              "1f469-200d-1f9b2": {
                "1f3fb": ["1f469-1f3fb-200d-1f9b2", 19, 29, 15, ["👩🏻‍🦲"]],
                "1f3fc": ["1f469-1f3fc-200d-1f9b2", 19, 30, 15, ["👩🏼‍🦲"]],
                "1f3fd": ["1f469-1f3fd-200d-1f9b2", 19, 31, 15, ["👩🏽‍🦲"]],
                "1f3fe": ["1f469-1f3fe-200d-1f9b2", 19, 32, 15, ["👩🏾‍🦲"]],
                "1f3ff": ["1f469-1f3ff-200d-1f9b2", 19, 33, 15, ["👩🏿‍🦲"]],
              },
              "1f469-200d-1f9b3": {
                "1f3fb": ["1f469-1f3fb-200d-1f9b3", 19, 35, 15, ["👩🏻‍🦳"]],
                "1f3fc": ["1f469-1f3fc-200d-1f9b3", 19, 36, 15, ["👩🏼‍🦳"]],
                "1f3fd": ["1f469-1f3fd-200d-1f9b3", 19, 37, 15, ["👩🏽‍🦳"]],
                "1f3fe": ["1f469-1f3fe-200d-1f9b3", 19, 38, 15, ["👩🏾‍🦳"]],
                "1f3ff": ["1f469-1f3ff-200d-1f9b3", 19, 39, 15, ["👩🏿‍🦳"]],
              },
              "1f469-200d-1f9bc": {
                "1f3fb": ["1f469-1f3fb-200d-1f9bc", 19, 41, 15, ["👩🏻‍🦼"]],
                "1f3fc": ["1f469-1f3fc-200d-1f9bc", 19, 42, 15, ["👩🏼‍🦼"]],
                "1f3fd": ["1f469-1f3fd-200d-1f9bc", 19, 43, 15, ["👩🏽‍🦼"]],
                "1f3fe": ["1f469-1f3fe-200d-1f9bc", 19, 44, 15, ["👩🏾‍🦼"]],
                "1f3ff": ["1f469-1f3ff-200d-1f9bc", 19, 45, 15, ["👩🏿‍🦼"]],
              },
              "1f469-200d-1f9bd": {
                "1f3fb": ["1f469-1f3fb-200d-1f9bd", 19, 47, 15, ["👩🏻‍🦽"]],
                "1f3fc": ["1f469-1f3fc-200d-1f9bd", 19, 48, 15, ["👩🏼‍🦽"]],
                "1f3fd": ["1f469-1f3fd-200d-1f9bd", 19, 49, 15, ["👩🏽‍🦽"]],
                "1f3fe": ["1f469-1f3fe-200d-1f9bd", 19, 50, 15, ["👩🏾‍🦽"]],
                "1f3ff": ["1f469-1f3ff-200d-1f9bd", 19, 51, 15, ["👩🏿‍🦽"]],
              },
              "1f469-200d-2695-fe0f": {
                "1f3fb": ["1f469-1f3fb-200d-2695-fe0f", 19, 53, 15, ["👩🏻‍⚕️"]],
                "1f3fc": ["1f469-1f3fc-200d-2695-fe0f", 19, 54, 15, ["👩🏼‍⚕️"]],
                "1f3fd": ["1f469-1f3fd-200d-2695-fe0f", 19, 55, 15, ["👩🏽‍⚕️"]],
                "1f3fe": ["1f469-1f3fe-200d-2695-fe0f", 19, 56, 15, ["👩🏾‍⚕️"]],
                "1f3ff": ["1f469-1f3ff-200d-2695-fe0f", 19, 57, 15, ["👩🏿‍⚕️"]],
              },
              "1f469-200d-2696-fe0f": {
                "1f3fb": ["1f469-1f3fb-200d-2696-fe0f", 19, 59, 15, ["👩🏻‍⚖️"]],
                "1f3fc": ["1f469-1f3fc-200d-2696-fe0f", 20, 0, 15, ["👩🏼‍⚖️"]],
                "1f3fd": ["1f469-1f3fd-200d-2696-fe0f", 20, 1, 15, ["👩🏽‍⚖️"]],
                "1f3fe": ["1f469-1f3fe-200d-2696-fe0f", 20, 2, 15, ["👩🏾‍⚖️"]],
                "1f3ff": ["1f469-1f3ff-200d-2696-fe0f", 20, 3, 15, ["👩🏿‍⚖️"]],
              },
              "1f469-200d-2708-fe0f": {
                "1f3fb": ["1f469-1f3fb-200d-2708-fe0f", 20, 5, 15, ["👩🏻‍✈️"]],
                "1f3fc": ["1f469-1f3fc-200d-2708-fe0f", 20, 6, 15, ["👩🏼‍✈️"]],
                "1f3fd": ["1f469-1f3fd-200d-2708-fe0f", 20, 7, 15, ["👩🏽‍✈️"]],
                "1f3fe": ["1f469-1f3fe-200d-2708-fe0f", 20, 8, 15, ["👩🏾‍✈️"]],
                "1f3ff": ["1f469-1f3ff-200d-2708-fe0f", 20, 9, 15, ["👩🏿‍✈️"]],
              },
              "1f469-200d-2764-fe0f-200d-1f468": {
                "1f3fb-1f3fb": [
                  "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb",
                  20,
                  11,
                  7,
                  ["👩🏻‍❤️‍👨🏻"],
                ],
                "1f3fb-1f3fc": [
                  "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fc",
                  20,
                  12,
                  7,
                  ["👩🏻‍❤️‍👨🏼"],
                ],
                "1f3fb-1f3fd": [
                  "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fd",
                  20,
                  13,
                  7,
                  ["👩🏻‍❤️‍👨🏽"],
                ],
                "1f3fb-1f3fe": [
                  "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fe",
                  20,
                  14,
                  7,
                  ["👩🏻‍❤️‍👨🏾"],
                ],
                "1f3fb-1f3ff": [
                  "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3ff",
                  20,
                  15,
                  7,
                  ["👩🏻‍❤️‍👨🏿"],
                ],
                "1f3fc-1f3fb": [
                  "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fb",
                  20,
                  16,
                  7,
                  ["👩🏼‍❤️‍👨🏻"],
                ],
                "1f3fc-1f3fc": [
                  "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc",
                  20,
                  17,
                  7,
                  ["👩🏼‍❤️‍👨🏼"],
                ],
                "1f3fc-1f3fd": [
                  "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fd",
                  20,
                  18,
                  7,
                  ["👩🏼‍❤️‍👨🏽"],
                ],
                "1f3fc-1f3fe": [
                  "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fe",
                  20,
                  19,
                  7,
                  ["👩🏼‍❤️‍👨🏾"],
                ],
                "1f3fc-1f3ff": [
                  "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3ff",
                  20,
                  20,
                  7,
                  ["👩🏼‍❤️‍👨🏿"],
                ],
                "1f3fd-1f3fb": [
                  "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fb",
                  20,
                  21,
                  7,
                  ["👩🏽‍❤️‍👨🏻"],
                ],
                "1f3fd-1f3fc": [
                  "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fc",
                  20,
                  22,
                  7,
                  ["👩🏽‍❤️‍👨🏼"],
                ],
                "1f3fd-1f3fd": [
                  "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd",
                  20,
                  23,
                  7,
                  ["👩🏽‍❤️‍👨🏽"],
                ],
                "1f3fd-1f3fe": [
                  "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fe",
                  20,
                  24,
                  7,
                  ["👩🏽‍❤️‍👨🏾"],
                ],
                "1f3fd-1f3ff": [
                  "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3ff",
                  20,
                  25,
                  7,
                  ["👩🏽‍❤️‍👨🏿"],
                ],
                "1f3fe-1f3fb": [
                  "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fb",
                  20,
                  26,
                  7,
                  ["👩🏾‍❤️‍👨🏻"],
                ],
                "1f3fe-1f3fc": [
                  "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fc",
                  20,
                  27,
                  7,
                  ["👩🏾‍❤️‍👨🏼"],
                ],
                "1f3fe-1f3fd": [
                  "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fd",
                  20,
                  28,
                  7,
                  ["👩🏾‍❤️‍👨🏽"],
                ],
                "1f3fe-1f3fe": [
                  "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe",
                  20,
                  29,
                  7,
                  ["👩🏾‍❤️‍👨🏾"],
                ],
                "1f3fe-1f3ff": [
                  "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3ff",
                  20,
                  30,
                  7,
                  ["👩🏾‍❤️‍👨🏿"],
                ],
                "1f3ff-1f3fb": [
                  "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fb",
                  20,
                  31,
                  7,
                  ["👩🏿‍❤️‍👨🏻"],
                ],
                "1f3ff-1f3fc": [
                  "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fc",
                  20,
                  32,
                  7,
                  ["👩🏿‍❤️‍👨🏼"],
                ],
                "1f3ff-1f3fd": [
                  "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fd",
                  20,
                  33,
                  7,
                  ["👩🏿‍❤️‍👨🏽"],
                ],
                "1f3ff-1f3fe": [
                  "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fe",
                  20,
                  34,
                  7,
                  ["👩🏿‍❤️‍👨🏾"],
                ],
                "1f3ff-1f3ff": [
                  "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff",
                  20,
                  35,
                  7,
                  ["👩🏿‍❤️‍👨🏿"],
                ],
              },
              "1f469-200d-2764-fe0f-200d-1f469": {
                "1f3fb-1f3fb": [
                  "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fb",
                  20,
                  37,
                  7,
                  ["👩🏻‍❤️‍👩🏻"],
                ],
                "1f3fb-1f3fc": [
                  "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fc",
                  20,
                  38,
                  7,
                  ["👩🏻‍❤️‍👩🏼"],
                ],
                "1f3fb-1f3fd": [
                  "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fd",
                  20,
                  39,
                  7,
                  ["👩🏻‍❤️‍👩🏽"],
                ],
                "1f3fb-1f3fe": [
                  "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fe",
                  20,
                  40,
                  7,
                  ["👩🏻‍❤️‍👩🏾"],
                ],
                "1f3fb-1f3ff": [
                  "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3ff",
                  20,
                  41,
                  7,
                  ["👩🏻‍❤️‍👩🏿"],
                ],
                "1f3fc-1f3fb": [
                  "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fb",
                  20,
                  42,
                  7,
                  ["👩🏼‍❤️‍👩🏻"],
                ],
                "1f3fc-1f3fc": [
                  "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fc",
                  20,
                  43,
                  7,
                  ["👩🏼‍❤️‍👩🏼"],
                ],
                "1f3fc-1f3fd": [
                  "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fd",
                  20,
                  44,
                  7,
                  ["👩🏼‍❤️‍👩🏽"],
                ],
                "1f3fc-1f3fe": [
                  "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fe",
                  20,
                  45,
                  7,
                  ["👩🏼‍❤️‍👩🏾"],
                ],
                "1f3fc-1f3ff": [
                  "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3ff",
                  20,
                  46,
                  7,
                  ["👩🏼‍❤️‍👩🏿"],
                ],
                "1f3fd-1f3fb": [
                  "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fb",
                  20,
                  47,
                  7,
                  ["👩🏽‍❤️‍👩🏻"],
                ],
                "1f3fd-1f3fc": [
                  "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fc",
                  20,
                  48,
                  7,
                  ["👩🏽‍❤️‍👩🏼"],
                ],
                "1f3fd-1f3fd": [
                  "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fd",
                  20,
                  49,
                  7,
                  ["👩🏽‍❤️‍👩🏽"],
                ],
                "1f3fd-1f3fe": [
                  "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fe",
                  20,
                  50,
                  7,
                  ["👩🏽‍❤️‍👩🏾"],
                ],
                "1f3fd-1f3ff": [
                  "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3ff",
                  20,
                  51,
                  7,
                  ["👩🏽‍❤️‍👩🏿"],
                ],
                "1f3fe-1f3fb": [
                  "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fb",
                  20,
                  52,
                  7,
                  ["👩🏾‍❤️‍👩🏻"],
                ],
                "1f3fe-1f3fc": [
                  "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fc",
                  20,
                  53,
                  7,
                  ["👩🏾‍❤️‍👩🏼"],
                ],
                "1f3fe-1f3fd": [
                  "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fd",
                  20,
                  54,
                  7,
                  ["👩🏾‍❤️‍👩🏽"],
                ],
                "1f3fe-1f3fe": [
                  "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fe",
                  20,
                  55,
                  7,
                  ["👩🏾‍❤️‍👩🏾"],
                ],
                "1f3fe-1f3ff": [
                  "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3ff",
                  20,
                  56,
                  7,
                  ["👩🏾‍❤️‍👩🏿"],
                ],
                "1f3ff-1f3fb": [
                  "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fb",
                  20,
                  57,
                  7,
                  ["👩🏿‍❤️‍👩🏻"],
                ],
                "1f3ff-1f3fc": [
                  "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fc",
                  20,
                  58,
                  7,
                  ["👩🏿‍❤️‍👩🏼"],
                ],
                "1f3ff-1f3fd": [
                  "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fd",
                  20,
                  59,
                  7,
                  ["👩🏿‍❤️‍👩🏽"],
                ],
                "1f3ff-1f3fe": [
                  "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fe",
                  21,
                  0,
                  7,
                  ["👩🏿‍❤️‍👩🏾"],
                ],
                "1f3ff-1f3ff": [
                  "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3ff",
                  21,
                  1,
                  7,
                  ["👩🏿‍❤️‍👩🏿"],
                ],
              },
              "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468": {
                "1f3fb-1f3fb": [
                  "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
                  21,
                  3,
                  7,
                  ["👩🏻‍❤️‍💋‍👨🏻"],
                ],
                "1f3fb-1f3fc": [
                  "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
                  21,
                  4,
                  7,
                  ["👩🏻‍❤️‍💋‍👨🏼"],
                ],
                "1f3fb-1f3fd": [
                  "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
                  21,
                  5,
                  7,
                  ["👩🏻‍❤️‍💋‍👨🏽"],
                ],
                "1f3fb-1f3fe": [
                  "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
                  21,
                  6,
                  7,
                  ["👩🏻‍❤️‍💋‍👨🏾"],
                ],
                "1f3fb-1f3ff": [
                  "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
                  21,
                  7,
                  7,
                  ["👩🏻‍❤️‍💋‍👨🏿"],
                ],
                "1f3fc-1f3fb": [
                  "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
                  21,
                  8,
                  7,
                  ["👩🏼‍❤️‍💋‍👨🏻"],
                ],
                "1f3fc-1f3fc": [
                  "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
                  21,
                  9,
                  7,
                  ["👩🏼‍❤️‍💋‍👨🏼"],
                ],
                "1f3fc-1f3fd": [
                  "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
                  21,
                  10,
                  7,
                  ["👩🏼‍❤️‍💋‍👨🏽"],
                ],
                "1f3fc-1f3fe": [
                  "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
                  21,
                  11,
                  7,
                  ["👩🏼‍❤️‍💋‍👨🏾"],
                ],
                "1f3fc-1f3ff": [
                  "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
                  21,
                  12,
                  7,
                  ["👩🏼‍❤️‍💋‍👨🏿"],
                ],
                "1f3fd-1f3fb": [
                  "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
                  21,
                  13,
                  7,
                  ["👩🏽‍❤️‍💋‍👨🏻"],
                ],
                "1f3fd-1f3fc": [
                  "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
                  21,
                  14,
                  7,
                  ["👩🏽‍❤️‍💋‍👨🏼"],
                ],
                "1f3fd-1f3fd": [
                  "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
                  21,
                  15,
                  7,
                  ["👩🏽‍❤️‍💋‍👨🏽"],
                ],
                "1f3fd-1f3fe": [
                  "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
                  21,
                  16,
                  7,
                  ["👩🏽‍❤️‍💋‍👨🏾"],
                ],
                "1f3fd-1f3ff": [
                  "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
                  21,
                  17,
                  7,
                  ["👩🏽‍❤️‍💋‍👨🏿"],
                ],
                "1f3fe-1f3fb": [
                  "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
                  21,
                  18,
                  7,
                  ["👩🏾‍❤️‍💋‍👨🏻"],
                ],
                "1f3fe-1f3fc": [
                  "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
                  21,
                  19,
                  7,
                  ["👩🏾‍❤️‍💋‍👨🏼"],
                ],
                "1f3fe-1f3fd": [
                  "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
                  21,
                  20,
                  7,
                  ["👩🏾‍❤️‍💋‍👨🏽"],
                ],
                "1f3fe-1f3fe": [
                  "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
                  21,
                  21,
                  7,
                  ["👩🏾‍❤️‍💋‍👨🏾"],
                ],
                "1f3fe-1f3ff": [
                  "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
                  21,
                  22,
                  7,
                  ["👩🏾‍❤️‍💋‍👨🏿"],
                ],
                "1f3ff-1f3fb": [
                  "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
                  21,
                  23,
                  7,
                  ["👩🏿‍❤️‍💋‍👨🏻"],
                ],
                "1f3ff-1f3fc": [
                  "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
                  21,
                  24,
                  7,
                  ["👩🏿‍❤️‍💋‍👨🏼"],
                ],
                "1f3ff-1f3fd": [
                  "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
                  21,
                  25,
                  7,
                  ["👩🏿‍❤️‍💋‍👨🏽"],
                ],
                "1f3ff-1f3fe": [
                  "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
                  21,
                  26,
                  7,
                  ["👩🏿‍❤️‍💋‍👨🏾"],
                ],
                "1f3ff-1f3ff": [
                  "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
                  21,
                  27,
                  7,
                  ["👩🏿‍❤️‍💋‍👨🏿"],
                ],
              },
              "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469": {
                "1f3fb-1f3fb": [
                  "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
                  21,
                  29,
                  7,
                  ["👩🏻‍❤️‍💋‍👩🏻"],
                ],
                "1f3fb-1f3fc": [
                  "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
                  21,
                  30,
                  7,
                  ["👩🏻‍❤️‍💋‍👩🏼"],
                ],
                "1f3fb-1f3fd": [
                  "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
                  21,
                  31,
                  7,
                  ["👩🏻‍❤️‍💋‍👩🏽"],
                ],
                "1f3fb-1f3fe": [
                  "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
                  21,
                  32,
                  7,
                  ["👩🏻‍❤️‍💋‍👩🏾"],
                ],
                "1f3fb-1f3ff": [
                  "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
                  21,
                  33,
                  7,
                  ["👩🏻‍❤️‍💋‍👩🏿"],
                ],
                "1f3fc-1f3fb": [
                  "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
                  21,
                  34,
                  7,
                  ["👩🏼‍❤️‍💋‍👩🏻"],
                ],
                "1f3fc-1f3fc": [
                  "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
                  21,
                  35,
                  7,
                  ["👩🏼‍❤️‍💋‍👩🏼"],
                ],
                "1f3fc-1f3fd": [
                  "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
                  21,
                  36,
                  7,
                  ["👩🏼‍❤️‍💋‍👩🏽"],
                ],
                "1f3fc-1f3fe": [
                  "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
                  21,
                  37,
                  7,
                  ["👩🏼‍❤️‍💋‍👩🏾"],
                ],
                "1f3fc-1f3ff": [
                  "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
                  21,
                  38,
                  7,
                  ["👩🏼‍❤️‍💋‍👩🏿"],
                ],
                "1f3fd-1f3fb": [
                  "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
                  21,
                  39,
                  7,
                  ["👩🏽‍❤️‍💋‍👩🏻"],
                ],
                "1f3fd-1f3fc": [
                  "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
                  21,
                  40,
                  7,
                  ["👩🏽‍❤️‍💋‍👩🏼"],
                ],
                "1f3fd-1f3fd": [
                  "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
                  21,
                  41,
                  7,
                  ["👩🏽‍❤️‍💋‍👩🏽"],
                ],
                "1f3fd-1f3fe": [
                  "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
                  21,
                  42,
                  7,
                  ["👩🏽‍❤️‍💋‍👩🏾"],
                ],
                "1f3fd-1f3ff": [
                  "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
                  21,
                  43,
                  7,
                  ["👩🏽‍❤️‍💋‍👩🏿"],
                ],
                "1f3fe-1f3fb": [
                  "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
                  21,
                  44,
                  7,
                  ["👩🏾‍❤️‍💋‍👩🏻"],
                ],
                "1f3fe-1f3fc": [
                  "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
                  21,
                  45,
                  7,
                  ["👩🏾‍❤️‍💋‍👩🏼"],
                ],
                "1f3fe-1f3fd": [
                  "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
                  21,
                  46,
                  7,
                  ["👩🏾‍❤️‍💋‍👩🏽"],
                ],
                "1f3fe-1f3fe": [
                  "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
                  21,
                  47,
                  7,
                  ["👩🏾‍❤️‍💋‍👩🏾"],
                ],
                "1f3fe-1f3ff": [
                  "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
                  21,
                  48,
                  7,
                  ["👩🏾‍❤️‍💋‍👩🏿"],
                ],
                "1f3ff-1f3fb": [
                  "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
                  21,
                  49,
                  7,
                  ["👩🏿‍❤️‍💋‍👩🏻"],
                ],
                "1f3ff-1f3fc": [
                  "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
                  21,
                  50,
                  7,
                  ["👩🏿‍❤️‍💋‍👩🏼"],
                ],
                "1f3ff-1f3fd": [
                  "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
                  21,
                  51,
                  7,
                  ["👩🏿‍❤️‍💋‍👩🏽"],
                ],
                "1f3ff-1f3fe": [
                  "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
                  21,
                  52,
                  7,
                  ["👩🏿‍❤️‍💋‍👩🏾"],
                ],
                "1f3ff-1f3ff": [
                  "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
                  21,
                  53,
                  7,
                  ["👩🏿‍❤️‍💋‍👩🏿"],
                ],
              },
              "1f469": {
                "1f3fb": ["1f469-1f3fb", 21, 55, 15, ["👩🏻"]],
                "1f3fc": ["1f469-1f3fc", 21, 56, 15, ["👩🏼"]],
                "1f3fd": ["1f469-1f3fd", 21, 57, 15, ["👩🏽"]],
                "1f3fe": ["1f469-1f3fe", 21, 58, 15, ["👩🏾"]],
                "1f3ff": ["1f469-1f3ff", 21, 59, 15, ["👩🏿"]],
              },
              "1f46b": {
                "1f3fb": ["1f46b-1f3fb", 22, 2, 15, ["👫🏻"]],
                "1f3fc": ["1f46b-1f3fc", 22, 3, 15, ["👫🏼"]],
                "1f3fd": ["1f46b-1f3fd", 22, 4, 15, ["👫🏽"]],
                "1f3fe": ["1f46b-1f3fe", 22, 5, 15, ["👫🏾"]],
                "1f3ff": ["1f46b-1f3ff", 22, 6, 15, ["👫🏿"]],
                "1f3fb-1f3fc": [
                  "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fc",
                  22,
                  7,
                  15,
                  ["👩🏻‍🤝‍👨🏼"],
                ],
                "1f3fb-1f3fd": [
                  "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fd",
                  22,
                  8,
                  15,
                  ["👩🏻‍🤝‍👨🏽"],
                ],
                "1f3fb-1f3fe": [
                  "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fe",
                  22,
                  9,
                  15,
                  ["👩🏻‍🤝‍👨🏾"],
                ],
                "1f3fb-1f3ff": [
                  "1f469-1f3fb-200d-1f91d-200d-1f468-1f3ff",
                  22,
                  10,
                  15,
                  ["👩🏻‍🤝‍👨🏿"],
                ],
                "1f3fc-1f3fb": [
                  "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fb",
                  22,
                  11,
                  15,
                  ["👩🏼‍🤝‍👨🏻"],
                ],
                "1f3fc-1f3fd": [
                  "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fd",
                  22,
                  12,
                  15,
                  ["👩🏼‍🤝‍👨🏽"],
                ],
                "1f3fc-1f3fe": [
                  "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fe",
                  22,
                  13,
                  15,
                  ["👩🏼‍🤝‍👨🏾"],
                ],
                "1f3fc-1f3ff": [
                  "1f469-1f3fc-200d-1f91d-200d-1f468-1f3ff",
                  22,
                  14,
                  15,
                  ["👩🏼‍🤝‍👨🏿"],
                ],
                "1f3fd-1f3fb": [
                  "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fb",
                  22,
                  15,
                  15,
                  ["👩🏽‍🤝‍👨🏻"],
                ],
                "1f3fd-1f3fc": [
                  "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fc",
                  22,
                  16,
                  15,
                  ["👩🏽‍🤝‍👨🏼"],
                ],
                "1f3fd-1f3fe": [
                  "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fe",
                  22,
                  17,
                  15,
                  ["👩🏽‍🤝‍👨🏾"],
                ],
                "1f3fd-1f3ff": [
                  "1f469-1f3fd-200d-1f91d-200d-1f468-1f3ff",
                  22,
                  18,
                  15,
                  ["👩🏽‍🤝‍👨🏿"],
                ],
                "1f3fe-1f3fb": [
                  "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fb",
                  22,
                  19,
                  15,
                  ["👩🏾‍🤝‍👨🏻"],
                ],
                "1f3fe-1f3fc": [
                  "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fc",
                  22,
                  20,
                  15,
                  ["👩🏾‍🤝‍👨🏼"],
                ],
                "1f3fe-1f3fd": [
                  "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fd",
                  22,
                  21,
                  15,
                  ["👩🏾‍🤝‍👨🏽"],
                ],
                "1f3fe-1f3ff": [
                  "1f469-1f3fe-200d-1f91d-200d-1f468-1f3ff",
                  22,
                  22,
                  15,
                  ["👩🏾‍🤝‍👨🏿"],
                ],
                "1f3ff-1f3fb": [
                  "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fb",
                  22,
                  23,
                  15,
                  ["👩🏿‍🤝‍👨🏻"],
                ],
                "1f3ff-1f3fc": [
                  "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fc",
                  22,
                  24,
                  15,
                  ["👩🏿‍🤝‍👨🏼"],
                ],
                "1f3ff-1f3fd": [
                  "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fd",
                  22,
                  25,
                  15,
                  ["👩🏿‍🤝‍👨🏽"],
                ],
                "1f3ff-1f3fe": [
                  "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fe",
                  22,
                  26,
                  15,
                  ["👩🏿‍🤝‍👨🏾"],
                ],
              },
              "1f46c": {
                "1f3fb": ["1f46c-1f3fb", 22, 28, 15, ["👬🏻"]],
                "1f3fc": ["1f46c-1f3fc", 22, 29, 15, ["👬🏼"]],
                "1f3fd": ["1f46c-1f3fd", 22, 30, 15, ["👬🏽"]],
                "1f3fe": ["1f46c-1f3fe", 22, 31, 15, ["👬🏾"]],
                "1f3ff": ["1f46c-1f3ff", 22, 32, 15, ["👬🏿"]],
                "1f3fb-1f3fc": [
                  "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fc",
                  22,
                  33,
                  7,
                  ["👨🏻‍🤝‍👨🏼"],
                ],
                "1f3fb-1f3fd": [
                  "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fd",
                  22,
                  34,
                  7,
                  ["👨🏻‍🤝‍👨🏽"],
                ],
                "1f3fb-1f3fe": [
                  "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fe",
                  22,
                  35,
                  7,
                  ["👨🏻‍🤝‍👨🏾"],
                ],
                "1f3fb-1f3ff": [
                  "1f468-1f3fb-200d-1f91d-200d-1f468-1f3ff",
                  22,
                  36,
                  7,
                  ["👨🏻‍🤝‍👨🏿"],
                ],
                "1f3fc-1f3fb": [
                  "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fb",
                  22,
                  37,
                  15,
                  ["👨🏼‍🤝‍👨🏻"],
                ],
                "1f3fc-1f3fd": [
                  "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fd",
                  22,
                  38,
                  7,
                  ["👨🏼‍🤝‍👨🏽"],
                ],
                "1f3fc-1f3fe": [
                  "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fe",
                  22,
                  39,
                  7,
                  ["👨🏼‍🤝‍👨🏾"],
                ],
                "1f3fc-1f3ff": [
                  "1f468-1f3fc-200d-1f91d-200d-1f468-1f3ff",
                  22,
                  40,
                  7,
                  ["👨🏼‍🤝‍👨🏿"],
                ],
                "1f3fd-1f3fb": [
                  "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fb",
                  22,
                  41,
                  15,
                  ["👨🏽‍🤝‍👨🏻"],
                ],
                "1f3fd-1f3fc": [
                  "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fc",
                  22,
                  42,
                  15,
                  ["👨🏽‍🤝‍👨🏼"],
                ],
                "1f3fd-1f3fe": [
                  "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fe",
                  22,
                  43,
                  7,
                  ["👨🏽‍🤝‍👨🏾"],
                ],
                "1f3fd-1f3ff": [
                  "1f468-1f3fd-200d-1f91d-200d-1f468-1f3ff",
                  22,
                  44,
                  7,
                  ["👨🏽‍🤝‍👨🏿"],
                ],
                "1f3fe-1f3fb": [
                  "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fb",
                  22,
                  45,
                  15,
                  ["👨🏾‍🤝‍👨🏻"],
                ],
                "1f3fe-1f3fc": [
                  "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fc",
                  22,
                  46,
                  15,
                  ["👨🏾‍🤝‍👨🏼"],
                ],
                "1f3fe-1f3fd": [
                  "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fd",
                  22,
                  47,
                  15,
                  ["👨🏾‍🤝‍👨🏽"],
                ],
                "1f3fe-1f3ff": [
                  "1f468-1f3fe-200d-1f91d-200d-1f468-1f3ff",
                  22,
                  48,
                  7,
                  ["👨🏾‍🤝‍👨🏿"],
                ],
                "1f3ff-1f3fb": [
                  "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fb",
                  22,
                  49,
                  15,
                  ["👨🏿‍🤝‍👨🏻"],
                ],
                "1f3ff-1f3fc": [
                  "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fc",
                  22,
                  50,
                  15,
                  ["👨🏿‍🤝‍👨🏼"],
                ],
                "1f3ff-1f3fd": [
                  "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fd",
                  22,
                  51,
                  15,
                  ["👨🏿‍🤝‍👨🏽"],
                ],
                "1f3ff-1f3fe": [
                  "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fe",
                  22,
                  52,
                  15,
                  ["👨🏿‍🤝‍👨🏾"],
                ],
              },
              "1f46d": {
                "1f3fb": ["1f46d-1f3fb", 22, 54, 15, ["👭🏻"]],
                "1f3fc": ["1f46d-1f3fc", 22, 55, 15, ["👭🏼"]],
                "1f3fd": ["1f46d-1f3fd", 22, 56, 15, ["👭🏽"]],
                "1f3fe": ["1f46d-1f3fe", 22, 57, 15, ["👭🏾"]],
                "1f3ff": ["1f46d-1f3ff", 22, 58, 15, ["👭🏿"]],
                "1f3fb-1f3fc": [
                  "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fc",
                  22,
                  59,
                  7,
                  ["👩🏻‍🤝‍👩🏼"],
                ],
                "1f3fb-1f3fd": [
                  "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fd",
                  23,
                  0,
                  7,
                  ["👩🏻‍🤝‍👩🏽"],
                ],
                "1f3fb-1f3fe": [
                  "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fe",
                  23,
                  1,
                  7,
                  ["👩🏻‍🤝‍👩🏾"],
                ],
                "1f3fb-1f3ff": [
                  "1f469-1f3fb-200d-1f91d-200d-1f469-1f3ff",
                  23,
                  2,
                  7,
                  ["👩🏻‍🤝‍👩🏿"],
                ],
                "1f3fc-1f3fb": [
                  "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fb",
                  23,
                  3,
                  15,
                  ["👩🏼‍🤝‍👩🏻"],
                ],
                "1f3fc-1f3fd": [
                  "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fd",
                  23,
                  4,
                  7,
                  ["👩🏼‍🤝‍👩🏽"],
                ],
                "1f3fc-1f3fe": [
                  "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fe",
                  23,
                  5,
                  7,
                  ["👩🏼‍🤝‍👩🏾"],
                ],
                "1f3fc-1f3ff": [
                  "1f469-1f3fc-200d-1f91d-200d-1f469-1f3ff",
                  23,
                  6,
                  7,
                  ["👩🏼‍🤝‍👩🏿"],
                ],
                "1f3fd-1f3fb": [
                  "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fb",
                  23,
                  7,
                  15,
                  ["👩🏽‍🤝‍👩🏻"],
                ],
                "1f3fd-1f3fc": [
                  "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fc",
                  23,
                  8,
                  15,
                  ["👩🏽‍🤝‍👩🏼"],
                ],
                "1f3fd-1f3fe": [
                  "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fe",
                  23,
                  9,
                  7,
                  ["👩🏽‍🤝‍👩🏾"],
                ],
                "1f3fd-1f3ff": [
                  "1f469-1f3fd-200d-1f91d-200d-1f469-1f3ff",
                  23,
                  10,
                  7,
                  ["👩🏽‍🤝‍👩🏿"],
                ],
                "1f3fe-1f3fb": [
                  "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fb",
                  23,
                  11,
                  15,
                  ["👩🏾‍🤝‍👩🏻"],
                ],
                "1f3fe-1f3fc": [
                  "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fc",
                  23,
                  12,
                  15,
                  ["👩🏾‍🤝‍👩🏼"],
                ],
                "1f3fe-1f3fd": [
                  "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fd",
                  23,
                  13,
                  15,
                  ["👩🏾‍🤝‍👩🏽"],
                ],
                "1f3fe-1f3ff": [
                  "1f469-1f3fe-200d-1f91d-200d-1f469-1f3ff",
                  23,
                  14,
                  7,
                  ["👩🏾‍🤝‍👩🏿"],
                ],
                "1f3ff-1f3fb": [
                  "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fb",
                  23,
                  15,
                  15,
                  ["👩🏿‍🤝‍👩🏻"],
                ],
                "1f3ff-1f3fc": [
                  "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fc",
                  23,
                  16,
                  15,
                  ["👩🏿‍🤝‍👩🏼"],
                ],
                "1f3ff-1f3fd": [
                  "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fd",
                  23,
                  17,
                  15,
                  ["👩🏿‍🤝‍👩🏽"],
                ],
                "1f3ff-1f3fe": [
                  "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fe",
                  23,
                  18,
                  15,
                  ["👩🏿‍🤝‍👩🏾"],
                ],
              },
              "1f46e-200d-2640-fe0f": {
                "1f3fb": ["1f46e-1f3fb-200d-2640-fe0f", 23, 20, 15, ["👮🏻‍♀️"]],
                "1f3fc": ["1f46e-1f3fc-200d-2640-fe0f", 23, 21, 15, ["👮🏼‍♀️"]],
                "1f3fd": ["1f46e-1f3fd-200d-2640-fe0f", 23, 22, 15, ["👮🏽‍♀️"]],
                "1f3fe": ["1f46e-1f3fe-200d-2640-fe0f", 23, 23, 15, ["👮🏾‍♀️"]],
                "1f3ff": ["1f46e-1f3ff-200d-2640-fe0f", 23, 24, 15, ["👮🏿‍♀️"]],
              },
              "1f46e-200d-2642-fe0f": {
                "1f3fb": [
                  "1f46e-1f3fb-200d-2642-fe0f",
                  23,
                  26,
                  15,
                  ["👮🏻‍♂️", "👮🏻"],
                ],
                "1f3fc": [
                  "1f46e-1f3fc-200d-2642-fe0f",
                  23,
                  27,
                  15,
                  ["👮🏼‍♂️", "👮🏼"],
                ],
                "1f3fd": [
                  "1f46e-1f3fd-200d-2642-fe0f",
                  23,
                  28,
                  15,
                  ["👮🏽‍♂️", "👮🏽"],
                ],
                "1f3fe": [
                  "1f46e-1f3fe-200d-2642-fe0f",
                  23,
                  29,
                  15,
                  ["👮🏾‍♂️", "👮🏾"],
                ],
                "1f3ff": [
                  "1f46e-1f3ff-200d-2642-fe0f",
                  23,
                  30,
                  15,
                  ["👮🏿‍♂️", "👮🏿"],
                ],
              },
              "1f470-200d-2640-fe0f": {
                "1f3fb": ["1f470-1f3fb-200d-2640-fe0f", 23, 41, 15, ["👰🏻‍♀️"]],
                "1f3fc": ["1f470-1f3fc-200d-2640-fe0f", 23, 42, 15, ["👰🏼‍♀️"]],
                "1f3fd": ["1f470-1f3fd-200d-2640-fe0f", 23, 43, 15, ["👰🏽‍♀️"]],
                "1f3fe": ["1f470-1f3fe-200d-2640-fe0f", 23, 44, 15, ["👰🏾‍♀️"]],
                "1f3ff": ["1f470-1f3ff-200d-2640-fe0f", 23, 45, 15, ["👰🏿‍♀️"]],
              },
              "1f470-200d-2642-fe0f": {
                "1f3fb": ["1f470-1f3fb-200d-2642-fe0f", 23, 47, 15, ["👰🏻‍♂️"]],
                "1f3fc": ["1f470-1f3fc-200d-2642-fe0f", 23, 48, 15, ["👰🏼‍♂️"]],
                "1f3fd": ["1f470-1f3fd-200d-2642-fe0f", 23, 49, 15, ["👰🏽‍♂️"]],
                "1f3fe": ["1f470-1f3fe-200d-2642-fe0f", 23, 50, 15, ["👰🏾‍♂️"]],
                "1f3ff": ["1f470-1f3ff-200d-2642-fe0f", 23, 51, 15, ["👰🏿‍♂️"]],
              },
              "1f470": {
                "1f3fb": ["1f470-1f3fb", 23, 53, 15, ["👰🏻"]],
                "1f3fc": ["1f470-1f3fc", 23, 54, 15, ["👰🏼"]],
                "1f3fd": ["1f470-1f3fd", 23, 55, 15, ["👰🏽"]],
                "1f3fe": ["1f470-1f3fe", 23, 56, 15, ["👰🏾"]],
                "1f3ff": ["1f470-1f3ff", 23, 57, 15, ["👰🏿"]],
              },
              "1f471-200d-2640-fe0f": {
                "1f3fb": ["1f471-1f3fb-200d-2640-fe0f", 23, 59, 15, ["👱🏻‍♀️"]],
                "1f3fc": ["1f471-1f3fc-200d-2640-fe0f", 24, 0, 15, ["👱🏼‍♀️"]],
                "1f3fd": ["1f471-1f3fd-200d-2640-fe0f", 24, 1, 15, ["👱🏽‍♀️"]],
                "1f3fe": ["1f471-1f3fe-200d-2640-fe0f", 24, 2, 15, ["👱🏾‍♀️"]],
                "1f3ff": ["1f471-1f3ff-200d-2640-fe0f", 24, 3, 15, ["👱🏿‍♀️"]],
              },
              "1f471-200d-2642-fe0f": {
                "1f3fb": [
                  "1f471-1f3fb-200d-2642-fe0f",
                  24,
                  5,
                  15,
                  ["👱🏻‍♂️", "👱🏻"],
                ],
                "1f3fc": [
                  "1f471-1f3fc-200d-2642-fe0f",
                  24,
                  6,
                  15,
                  ["👱🏼‍♂️", "👱🏼"],
                ],
                "1f3fd": [
                  "1f471-1f3fd-200d-2642-fe0f",
                  24,
                  7,
                  15,
                  ["👱🏽‍♂️", "👱🏽"],
                ],
                "1f3fe": [
                  "1f471-1f3fe-200d-2642-fe0f",
                  24,
                  8,
                  15,
                  ["👱🏾‍♂️", "👱🏾"],
                ],
                "1f3ff": [
                  "1f471-1f3ff-200d-2642-fe0f",
                  24,
                  9,
                  15,
                  ["👱🏿‍♂️", "👱🏿"],
                ],
              },
              "1f472": {
                "1f3fb": ["1f472-1f3fb", 24, 17, 15, ["👲🏻"]],
                "1f3fc": ["1f472-1f3fc", 24, 18, 15, ["👲🏼"]],
                "1f3fd": ["1f472-1f3fd", 24, 19, 15, ["👲🏽"]],
                "1f3fe": ["1f472-1f3fe", 24, 20, 15, ["👲🏾"]],
                "1f3ff": ["1f472-1f3ff", 24, 21, 15, ["👲🏿"]],
              },
              "1f473-200d-2640-fe0f": {
                "1f3fb": ["1f473-1f3fb-200d-2640-fe0f", 24, 23, 15, ["👳🏻‍♀️"]],
                "1f3fc": ["1f473-1f3fc-200d-2640-fe0f", 24, 24, 15, ["👳🏼‍♀️"]],
                "1f3fd": ["1f473-1f3fd-200d-2640-fe0f", 24, 25, 15, ["👳🏽‍♀️"]],
                "1f3fe": ["1f473-1f3fe-200d-2640-fe0f", 24, 26, 15, ["👳🏾‍♀️"]],
                "1f3ff": ["1f473-1f3ff-200d-2640-fe0f", 24, 27, 15, ["👳🏿‍♀️"]],
              },
              "1f473-200d-2642-fe0f": {
                "1f3fb": [
                  "1f473-1f3fb-200d-2642-fe0f",
                  24,
                  29,
                  15,
                  ["👳🏻‍♂️", "👳🏻"],
                ],
                "1f3fc": [
                  "1f473-1f3fc-200d-2642-fe0f",
                  24,
                  30,
                  15,
                  ["👳🏼‍♂️", "👳🏼"],
                ],
                "1f3fd": [
                  "1f473-1f3fd-200d-2642-fe0f",
                  24,
                  31,
                  15,
                  ["👳🏽‍♂️", "👳🏽"],
                ],
                "1f3fe": [
                  "1f473-1f3fe-200d-2642-fe0f",
                  24,
                  32,
                  15,
                  ["👳🏾‍♂️", "👳🏾"],
                ],
                "1f3ff": [
                  "1f473-1f3ff-200d-2642-fe0f",
                  24,
                  33,
                  15,
                  ["👳🏿‍♂️", "👳🏿"],
                ],
              },
              "1f474": {
                "1f3fb": ["1f474-1f3fb", 24, 41, 15, ["👴🏻"]],
                "1f3fc": ["1f474-1f3fc", 24, 42, 15, ["👴🏼"]],
                "1f3fd": ["1f474-1f3fd", 24, 43, 15, ["👴🏽"]],
                "1f3fe": ["1f474-1f3fe", 24, 44, 15, ["👴🏾"]],
                "1f3ff": ["1f474-1f3ff", 24, 45, 15, ["👴🏿"]],
              },
              "1f475": {
                "1f3fb": ["1f475-1f3fb", 24, 47, 15, ["👵🏻"]],
                "1f3fc": ["1f475-1f3fc", 24, 48, 15, ["👵🏼"]],
                "1f3fd": ["1f475-1f3fd", 24, 49, 15, ["👵🏽"]],
                "1f3fe": ["1f475-1f3fe", 24, 50, 15, ["👵🏾"]],
                "1f3ff": ["1f475-1f3ff", 24, 51, 15, ["👵🏿"]],
              },
              "1f476": {
                "1f3fb": ["1f476-1f3fb", 24, 53, 15, ["👶🏻"]],
                "1f3fc": ["1f476-1f3fc", 24, 54, 15, ["👶🏼"]],
                "1f3fd": ["1f476-1f3fd", 24, 55, 15, ["👶🏽"]],
                "1f3fe": ["1f476-1f3fe", 24, 56, 15, ["👶🏾"]],
                "1f3ff": ["1f476-1f3ff", 24, 57, 15, ["👶🏿"]],
              },
              "1f477-200d-2640-fe0f": {
                "1f3fb": ["1f477-1f3fb-200d-2640-fe0f", 24, 59, 15, ["👷🏻‍♀️"]],
                "1f3fc": ["1f477-1f3fc-200d-2640-fe0f", 25, 0, 15, ["👷🏼‍♀️"]],
                "1f3fd": ["1f477-1f3fd-200d-2640-fe0f", 25, 1, 15, ["👷🏽‍♀️"]],
                "1f3fe": ["1f477-1f3fe-200d-2640-fe0f", 25, 2, 15, ["👷🏾‍♀️"]],
                "1f3ff": ["1f477-1f3ff-200d-2640-fe0f", 25, 3, 15, ["👷🏿‍♀️"]],
              },
              "1f477-200d-2642-fe0f": {
                "1f3fb": [
                  "1f477-1f3fb-200d-2642-fe0f",
                  25,
                  5,
                  15,
                  ["👷🏻‍♂️", "👷🏻"],
                ],
                "1f3fc": [
                  "1f477-1f3fc-200d-2642-fe0f",
                  25,
                  6,
                  15,
                  ["👷🏼‍♂️", "👷🏼"],
                ],
                "1f3fd": [
                  "1f477-1f3fd-200d-2642-fe0f",
                  25,
                  7,
                  15,
                  ["👷🏽‍♂️", "👷🏽"],
                ],
                "1f3fe": [
                  "1f477-1f3fe-200d-2642-fe0f",
                  25,
                  8,
                  15,
                  ["👷🏾‍♂️", "👷🏾"],
                ],
                "1f3ff": [
                  "1f477-1f3ff-200d-2642-fe0f",
                  25,
                  9,
                  15,
                  ["👷🏿‍♂️", "👷🏿"],
                ],
              },
              "1f478": {
                "1f3fb": ["1f478-1f3fb", 25, 17, 15, ["👸🏻"]],
                "1f3fc": ["1f478-1f3fc", 25, 18, 15, ["👸🏼"]],
                "1f3fd": ["1f478-1f3fd", 25, 19, 15, ["👸🏽"]],
                "1f3fe": ["1f478-1f3fe", 25, 20, 15, ["👸🏾"]],
                "1f3ff": ["1f478-1f3ff", 25, 21, 15, ["👸🏿"]],
              },
              "1f47c": {
                "1f3fb": ["1f47c-1f3fb", 25, 26, 15, ["👼🏻"]],
                "1f3fc": ["1f47c-1f3fc", 25, 27, 15, ["👼🏼"]],
                "1f3fd": ["1f47c-1f3fd", 25, 28, 15, ["👼🏽"]],
                "1f3fe": ["1f47c-1f3fe", 25, 29, 15, ["👼🏾"]],
                "1f3ff": ["1f47c-1f3ff", 25, 30, 15, ["👼🏿"]],
              },
              "1f481-200d-2640-fe0f": {
                "1f3fb": [
                  "1f481-1f3fb-200d-2640-fe0f",
                  25,
                  36,
                  15,
                  ["💁🏻‍♀️", "💁🏻"],
                ],
                "1f3fc": [
                  "1f481-1f3fc-200d-2640-fe0f",
                  25,
                  37,
                  15,
                  ["💁🏼‍♀️", "💁🏼"],
                ],
                "1f3fd": [
                  "1f481-1f3fd-200d-2640-fe0f",
                  25,
                  38,
                  15,
                  ["💁🏽‍♀️", "💁🏽"],
                ],
                "1f3fe": [
                  "1f481-1f3fe-200d-2640-fe0f",
                  25,
                  39,
                  15,
                  ["💁🏾‍♀️", "💁🏾"],
                ],
                "1f3ff": [
                  "1f481-1f3ff-200d-2640-fe0f",
                  25,
                  40,
                  15,
                  ["💁🏿‍♀️", "💁🏿"],
                ],
              },
              "1f481-200d-2642-fe0f": {
                "1f3fb": ["1f481-1f3fb-200d-2642-fe0f", 25, 42, 15, ["💁🏻‍♂️"]],
                "1f3fc": ["1f481-1f3fc-200d-2642-fe0f", 25, 43, 15, ["💁🏼‍♂️"]],
                "1f3fd": ["1f481-1f3fd-200d-2642-fe0f", 25, 44, 15, ["💁🏽‍♂️"]],
                "1f3fe": ["1f481-1f3fe-200d-2642-fe0f", 25, 45, 15, ["💁🏾‍♂️"]],
                "1f3ff": ["1f481-1f3ff-200d-2642-fe0f", 25, 46, 15, ["💁🏿‍♂️"]],
              },
              "1f482-200d-2640-fe0f": {
                "1f3fb": ["1f482-1f3fb-200d-2640-fe0f", 25, 54, 15, ["💂🏻‍♀️"]],
                "1f3fc": ["1f482-1f3fc-200d-2640-fe0f", 25, 55, 15, ["💂🏼‍♀️"]],
                "1f3fd": ["1f482-1f3fd-200d-2640-fe0f", 25, 56, 15, ["💂🏽‍♀️"]],
                "1f3fe": ["1f482-1f3fe-200d-2640-fe0f", 25, 57, 15, ["💂🏾‍♀️"]],
                "1f3ff": ["1f482-1f3ff-200d-2640-fe0f", 25, 58, 15, ["💂🏿‍♀️"]],
              },
              "1f482-200d-2642-fe0f": {
                "1f3fb": [
                  "1f482-1f3fb-200d-2642-fe0f",
                  26,
                  0,
                  15,
                  ["💂🏻‍♂️", "💂🏻"],
                ],
                "1f3fc": [
                  "1f482-1f3fc-200d-2642-fe0f",
                  26,
                  1,
                  15,
                  ["💂🏼‍♂️", "💂🏼"],
                ],
                "1f3fd": [
                  "1f482-1f3fd-200d-2642-fe0f",
                  26,
                  2,
                  15,
                  ["💂🏽‍♂️", "💂🏽"],
                ],
                "1f3fe": [
                  "1f482-1f3fe-200d-2642-fe0f",
                  26,
                  3,
                  15,
                  ["💂🏾‍♂️", "💂🏾"],
                ],
                "1f3ff": [
                  "1f482-1f3ff-200d-2642-fe0f",
                  26,
                  4,
                  15,
                  ["💂🏿‍♂️", "💂🏿"],
                ],
              },
              "1f483": {
                "1f3fb": ["1f483-1f3fb", 26, 12, 15, ["💃🏻"]],
                "1f3fc": ["1f483-1f3fc", 26, 13, 15, ["💃🏼"]],
                "1f3fd": ["1f483-1f3fd", 26, 14, 15, ["💃🏽"]],
                "1f3fe": ["1f483-1f3fe", 26, 15, 15, ["💃🏾"]],
                "1f3ff": ["1f483-1f3ff", 26, 16, 15, ["💃🏿"]],
              },
              "1f485": {
                "1f3fb": ["1f485-1f3fb", 26, 19, 15, ["💅🏻"]],
                "1f3fc": ["1f485-1f3fc", 26, 20, 15, ["💅🏼"]],
                "1f3fd": ["1f485-1f3fd", 26, 21, 15, ["💅🏽"]],
                "1f3fe": ["1f485-1f3fe", 26, 22, 15, ["💅🏾"]],
                "1f3ff": ["1f485-1f3ff", 26, 23, 15, ["💅🏿"]],
              },
              "1f486-200d-2640-fe0f": {
                "1f3fb": [
                  "1f486-1f3fb-200d-2640-fe0f",
                  26,
                  25,
                  15,
                  ["💆🏻‍♀️", "💆🏻"],
                ],
                "1f3fc": [
                  "1f486-1f3fc-200d-2640-fe0f",
                  26,
                  26,
                  15,
                  ["💆🏼‍♀️", "💆🏼"],
                ],
                "1f3fd": [
                  "1f486-1f3fd-200d-2640-fe0f",
                  26,
                  27,
                  15,
                  ["💆🏽‍♀️", "💆🏽"],
                ],
                "1f3fe": [
                  "1f486-1f3fe-200d-2640-fe0f",
                  26,
                  28,
                  15,
                  ["💆🏾‍♀️", "💆🏾"],
                ],
                "1f3ff": [
                  "1f486-1f3ff-200d-2640-fe0f",
                  26,
                  29,
                  15,
                  ["💆🏿‍♀️", "💆🏿"],
                ],
              },
              "1f486-200d-2642-fe0f": {
                "1f3fb": ["1f486-1f3fb-200d-2642-fe0f", 26, 31, 15, ["💆🏻‍♂️"]],
                "1f3fc": ["1f486-1f3fc-200d-2642-fe0f", 26, 32, 15, ["💆🏼‍♂️"]],
                "1f3fd": ["1f486-1f3fd-200d-2642-fe0f", 26, 33, 15, ["💆🏽‍♂️"]],
                "1f3fe": ["1f486-1f3fe-200d-2642-fe0f", 26, 34, 15, ["💆🏾‍♂️"]],
                "1f3ff": ["1f486-1f3ff-200d-2642-fe0f", 26, 35, 15, ["💆🏿‍♂️"]],
              },
              "1f487-200d-2640-fe0f": {
                "1f3fb": [
                  "1f487-1f3fb-200d-2640-fe0f",
                  26,
                  43,
                  15,
                  ["💇🏻‍♀️", "💇🏻"],
                ],
                "1f3fc": [
                  "1f487-1f3fc-200d-2640-fe0f",
                  26,
                  44,
                  15,
                  ["💇🏼‍♀️", "💇🏼"],
                ],
                "1f3fd": [
                  "1f487-1f3fd-200d-2640-fe0f",
                  26,
                  45,
                  15,
                  ["💇🏽‍♀️", "💇🏽"],
                ],
                "1f3fe": [
                  "1f487-1f3fe-200d-2640-fe0f",
                  26,
                  46,
                  15,
                  ["💇🏾‍♀️", "💇🏾"],
                ],
                "1f3ff": [
                  "1f487-1f3ff-200d-2640-fe0f",
                  26,
                  47,
                  15,
                  ["💇🏿‍♀️", "💇🏿"],
                ],
              },
              "1f487-200d-2642-fe0f": {
                "1f3fb": ["1f487-1f3fb-200d-2642-fe0f", 26, 49, 15, ["💇🏻‍♂️"]],
                "1f3fc": ["1f487-1f3fc-200d-2642-fe0f", 26, 50, 15, ["💇🏼‍♂️"]],
                "1f3fd": ["1f487-1f3fd-200d-2642-fe0f", 26, 51, 15, ["💇🏽‍♂️"]],
                "1f3fe": ["1f487-1f3fe-200d-2642-fe0f", 26, 52, 15, ["💇🏾‍♂️"]],
                "1f3ff": ["1f487-1f3ff-200d-2642-fe0f", 26, 53, 15, ["💇🏿‍♂️"]],
              },
              "1f48f": {
                "1f3fb": ["1f48f-1f3fb", 27, 8, 15, ["💏🏻"]],
                "1f3fc": ["1f48f-1f3fc", 27, 9, 15, ["💏🏼"]],
                "1f3fd": ["1f48f-1f3fd", 27, 10, 15, ["💏🏽"]],
                "1f3fe": ["1f48f-1f3fe", 27, 11, 15, ["💏🏾"]],
                "1f3ff": ["1f48f-1f3ff", 27, 12, 15, ["💏🏿"]],
                "1f3fb-1f3fc": [
                  "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
                  27,
                  13,
                  7,
                  ["🧑🏻‍❤️‍💋‍🧑🏼"],
                ],
                "1f3fb-1f3fd": [
                  "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
                  27,
                  14,
                  7,
                  ["🧑🏻‍❤️‍💋‍🧑🏽"],
                ],
                "1f3fb-1f3fe": [
                  "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",
                  27,
                  15,
                  7,
                  ["🧑🏻‍❤️‍💋‍🧑🏾"],
                ],
                "1f3fb-1f3ff": [
                  "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
                  27,
                  16,
                  7,
                  ["🧑🏻‍❤️‍💋‍🧑🏿"],
                ],
                "1f3fc-1f3fb": [
                  "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
                  27,
                  17,
                  7,
                  ["🧑🏼‍❤️‍💋‍🧑🏻"],
                ],
                "1f3fc-1f3fd": [
                  "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
                  27,
                  18,
                  7,
                  ["🧑🏼‍❤️‍💋‍🧑🏽"],
                ],
                "1f3fc-1f3fe": [
                  "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",
                  27,
                  19,
                  7,
                  ["🧑🏼‍❤️‍💋‍🧑🏾"],
                ],
                "1f3fc-1f3ff": [
                  "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
                  27,
                  20,
                  7,
                  ["🧑🏼‍❤️‍💋‍🧑🏿"],
                ],
                "1f3fd-1f3fb": [
                  "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
                  27,
                  21,
                  7,
                  ["🧑🏽‍❤️‍💋‍🧑🏻"],
                ],
                "1f3fd-1f3fc": [
                  "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
                  27,
                  22,
                  7,
                  ["🧑🏽‍❤️‍💋‍🧑🏼"],
                ],
                "1f3fd-1f3fe": [
                  "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",
                  27,
                  23,
                  7,
                  ["🧑🏽‍❤️‍💋‍🧑🏾"],
                ],
                "1f3fd-1f3ff": [
                  "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
                  27,
                  24,
                  7,
                  ["🧑🏽‍❤️‍💋‍🧑🏿"],
                ],
                "1f3fe-1f3fb": [
                  "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
                  27,
                  25,
                  7,
                  ["🧑🏾‍❤️‍💋‍🧑🏻"],
                ],
                "1f3fe-1f3fc": [
                  "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
                  27,
                  26,
                  7,
                  ["🧑🏾‍❤️‍💋‍🧑🏼"],
                ],
                "1f3fe-1f3fd": [
                  "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
                  27,
                  27,
                  7,
                  ["🧑🏾‍❤️‍💋‍🧑🏽"],
                ],
                "1f3fe-1f3ff": [
                  "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
                  27,
                  28,
                  7,
                  ["🧑🏾‍❤️‍💋‍🧑🏿"],
                ],
                "1f3ff-1f3fb": [
                  "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
                  27,
                  29,
                  7,
                  ["🧑🏿‍❤️‍💋‍🧑🏻"],
                ],
                "1f3ff-1f3fc": [
                  "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
                  27,
                  30,
                  7,
                  ["🧑🏿‍❤️‍💋‍🧑🏼"],
                ],
                "1f3ff-1f3fd": [
                  "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
                  27,
                  31,
                  7,
                  ["🧑🏿‍❤️‍💋‍🧑🏽"],
                ],
                "1f3ff-1f3fe": [
                  "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",
                  27,
                  32,
                  7,
                  ["🧑🏿‍❤️‍💋‍🧑🏾"],
                ],
              },
              "1f491": {
                "1f3fb": ["1f491-1f3fb", 27, 35, 15, ["💑🏻"]],
                "1f3fc": ["1f491-1f3fc", 27, 36, 15, ["💑🏼"]],
                "1f3fd": ["1f491-1f3fd", 27, 37, 15, ["💑🏽"]],
                "1f3fe": ["1f491-1f3fe", 27, 38, 15, ["💑🏾"]],
                "1f3ff": ["1f491-1f3ff", 27, 39, 15, ["💑🏿"]],
                "1f3fb-1f3fc": [
                  "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fc",
                  27,
                  40,
                  7,
                  ["🧑🏻‍❤️‍🧑🏼"],
                ],
                "1f3fb-1f3fd": [
                  "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fd",
                  27,
                  41,
                  7,
                  ["🧑🏻‍❤️‍🧑🏽"],
                ],
                "1f3fb-1f3fe": [
                  "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fe",
                  27,
                  42,
                  7,
                  ["🧑🏻‍❤️‍🧑🏾"],
                ],
                "1f3fb-1f3ff": [
                  "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3ff",
                  27,
                  43,
                  7,
                  ["🧑🏻‍❤️‍🧑🏿"],
                ],
                "1f3fc-1f3fb": [
                  "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fb",
                  27,
                  44,
                  7,
                  ["🧑🏼‍❤️‍🧑🏻"],
                ],
                "1f3fc-1f3fd": [
                  "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fd",
                  27,
                  45,
                  7,
                  ["🧑🏼‍❤️‍🧑🏽"],
                ],
                "1f3fc-1f3fe": [
                  "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fe",
                  27,
                  46,
                  7,
                  ["🧑🏼‍❤️‍🧑🏾"],
                ],
                "1f3fc-1f3ff": [
                  "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3ff",
                  27,
                  47,
                  7,
                  ["🧑🏼‍❤️‍🧑🏿"],
                ],
                "1f3fd-1f3fb": [
                  "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fb",
                  27,
                  48,
                  7,
                  ["🧑🏽‍❤️‍🧑🏻"],
                ],
                "1f3fd-1f3fc": [
                  "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fc",
                  27,
                  49,
                  7,
                  ["🧑🏽‍❤️‍🧑🏼"],
                ],
                "1f3fd-1f3fe": [
                  "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fe",
                  27,
                  50,
                  7,
                  ["🧑🏽‍❤️‍🧑🏾"],
                ],
                "1f3fd-1f3ff": [
                  "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3ff",
                  27,
                  51,
                  7,
                  ["🧑🏽‍❤️‍🧑🏿"],
                ],
                "1f3fe-1f3fb": [
                  "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fb",
                  27,
                  52,
                  7,
                  ["🧑🏾‍❤️‍🧑🏻"],
                ],
                "1f3fe-1f3fc": [
                  "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fc",
                  27,
                  53,
                  7,
                  ["🧑🏾‍❤️‍🧑🏼"],
                ],
                "1f3fe-1f3fd": [
                  "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fd",
                  27,
                  54,
                  7,
                  ["🧑🏾‍❤️‍🧑🏽"],
                ],
                "1f3fe-1f3ff": [
                  "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3ff",
                  27,
                  55,
                  7,
                  ["🧑🏾‍❤️‍🧑🏿"],
                ],
                "1f3ff-1f3fb": [
                  "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fb",
                  27,
                  56,
                  7,
                  ["🧑🏿‍❤️‍🧑🏻"],
                ],
                "1f3ff-1f3fc": [
                  "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fc",
                  27,
                  57,
                  7,
                  ["🧑🏿‍❤️‍🧑🏼"],
                ],
                "1f3ff-1f3fd": [
                  "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fd",
                  27,
                  58,
                  7,
                  ["🧑🏿‍❤️‍🧑🏽"],
                ],
                "1f3ff-1f3fe": [
                  "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fe",
                  27,
                  59,
                  7,
                  ["🧑🏿‍❤️‍🧑🏾"],
                ],
              },
              "1f4aa": {
                "1f3fb": ["1f4aa-1f3fb", 28, 25, 15, ["💪🏻"]],
                "1f3fc": ["1f4aa-1f3fc", 28, 26, 15, ["💪🏼"]],
                "1f3fd": ["1f4aa-1f3fd", 28, 27, 15, ["💪🏽"]],
                "1f3fe": ["1f4aa-1f3fe", 28, 28, 15, ["💪🏾"]],
                "1f3ff": ["1f4aa-1f3ff", 28, 29, 15, ["💪🏿"]],
              },
              "1f574-fe0f": {
                "1f3fb": ["1f574-1f3fb", 31, 30, 15, ["🕴🏻"]],
                "1f3fc": ["1f574-1f3fc", 31, 31, 15, ["🕴🏼"]],
                "1f3fd": ["1f574-1f3fd", 31, 32, 15, ["🕴🏽"]],
                "1f3fe": ["1f574-1f3fe", 31, 33, 15, ["🕴🏾"]],
                "1f3ff": ["1f574-1f3ff", 31, 34, 15, ["🕴🏿"]],
              },
              "1f575-fe0f-200d-2640-fe0f": {
                "1f3fb": ["1f575-1f3fb-200d-2640-fe0f", 31, 36, 15, ["🕵🏻‍♀️"]],
                "1f3fc": ["1f575-1f3fc-200d-2640-fe0f", 31, 37, 15, ["🕵🏼‍♀️"]],
                "1f3fd": ["1f575-1f3fd-200d-2640-fe0f", 31, 38, 15, ["🕵🏽‍♀️"]],
                "1f3fe": ["1f575-1f3fe-200d-2640-fe0f", 31, 39, 15, ["🕵🏾‍♀️"]],
                "1f3ff": ["1f575-1f3ff-200d-2640-fe0f", 31, 40, 15, ["🕵🏿‍♀️"]],
              },
              "1f575-fe0f-200d-2642-fe0f": {
                "1f3fb": [
                  "1f575-1f3fb-200d-2642-fe0f",
                  31,
                  42,
                  15,
                  ["🕵🏻‍♂️", "🕵🏻"],
                ],
                "1f3fc": [
                  "1f575-1f3fc-200d-2642-fe0f",
                  31,
                  43,
                  15,
                  ["🕵🏼‍♂️", "🕵🏼"],
                ],
                "1f3fd": [
                  "1f575-1f3fd-200d-2642-fe0f",
                  31,
                  44,
                  15,
                  ["🕵🏽‍♂️", "🕵🏽"],
                ],
                "1f3fe": [
                  "1f575-1f3fe-200d-2642-fe0f",
                  31,
                  45,
                  15,
                  ["🕵🏾‍♂️", "🕵🏾"],
                ],
                "1f3ff": [
                  "1f575-1f3ff-200d-2642-fe0f",
                  31,
                  46,
                  15,
                  ["🕵🏿‍♂️", "🕵🏿"],
                ],
              },
              "1f57a": {
                "1f3fb": ["1f57a-1f3fb", 31, 58, 15, ["🕺🏻"]],
                "1f3fc": ["1f57a-1f3fc", 31, 59, 15, ["🕺🏼"]],
                "1f3fd": ["1f57a-1f3fd", 32, 0, 15, ["🕺🏽"]],
                "1f3fe": ["1f57a-1f3fe", 32, 1, 15, ["🕺🏾"]],
                "1f3ff": ["1f57a-1f3ff", 32, 2, 15, ["🕺🏿"]],
              },
              "1f590-fe0f": {
                "1f3fb": ["1f590-1f3fb", 32, 9, 15, ["🖐🏻"]],
                "1f3fc": ["1f590-1f3fc", 32, 10, 15, ["🖐🏼"]],
                "1f3fd": ["1f590-1f3fd", 32, 11, 15, ["🖐🏽"]],
                "1f3fe": ["1f590-1f3fe", 32, 12, 15, ["🖐🏾"]],
                "1f3ff": ["1f590-1f3ff", 32, 13, 15, ["🖐🏿"]],
              },
              "1f595": {
                "1f3fb": ["1f595-1f3fb", 32, 15, 15, ["🖕🏻"]],
                "1f3fc": ["1f595-1f3fc", 32, 16, 15, ["🖕🏼"]],
                "1f3fd": ["1f595-1f3fd", 32, 17, 15, ["🖕🏽"]],
                "1f3fe": ["1f595-1f3fe", 32, 18, 15, ["🖕🏾"]],
                "1f3ff": ["1f595-1f3ff", 32, 19, 15, ["🖕🏿"]],
              },
              "1f596": {
                "1f3fb": ["1f596-1f3fb", 32, 21, 15, ["🖖🏻"]],
                "1f3fc": ["1f596-1f3fc", 32, 22, 15, ["🖖🏼"]],
                "1f3fd": ["1f596-1f3fd", 32, 23, 15, ["🖖🏽"]],
                "1f3fe": ["1f596-1f3fe", 32, 24, 15, ["🖖🏾"]],
                "1f3ff": ["1f596-1f3ff", 32, 25, 15, ["🖖🏿"]],
              },
              "1f645-200d-2640-fe0f": {
                "1f3fb": [
                  "1f645-1f3fb-200d-2640-fe0f",
                  34,
                  5,
                  15,
                  ["🙅🏻‍♀️", "🙅🏻"],
                ],
                "1f3fc": [
                  "1f645-1f3fc-200d-2640-fe0f",
                  34,
                  6,
                  15,
                  ["🙅🏼‍♀️", "🙅🏼"],
                ],
                "1f3fd": [
                  "1f645-1f3fd-200d-2640-fe0f",
                  34,
                  7,
                  15,
                  ["🙅🏽‍♀️", "🙅🏽"],
                ],
                "1f3fe": [
                  "1f645-1f3fe-200d-2640-fe0f",
                  34,
                  8,
                  15,
                  ["🙅🏾‍♀️", "🙅🏾"],
                ],
                "1f3ff": [
                  "1f645-1f3ff-200d-2640-fe0f",
                  34,
                  9,
                  15,
                  ["🙅🏿‍♀️", "🙅🏿"],
                ],
              },
              "1f645-200d-2642-fe0f": {
                "1f3fb": ["1f645-1f3fb-200d-2642-fe0f", 34, 11, 15, ["🙅🏻‍♂️"]],
                "1f3fc": ["1f645-1f3fc-200d-2642-fe0f", 34, 12, 15, ["🙅🏼‍♂️"]],
                "1f3fd": ["1f645-1f3fd-200d-2642-fe0f", 34, 13, 15, ["🙅🏽‍♂️"]],
                "1f3fe": ["1f645-1f3fe-200d-2642-fe0f", 34, 14, 15, ["🙅🏾‍♂️"]],
                "1f3ff": ["1f645-1f3ff-200d-2642-fe0f", 34, 15, 15, ["🙅🏿‍♂️"]],
              },
              "1f646-200d-2640-fe0f": {
                "1f3fb": [
                  "1f646-1f3fb-200d-2640-fe0f",
                  34,
                  23,
                  15,
                  ["🙆🏻‍♀️", "🙆🏻"],
                ],
                "1f3fc": [
                  "1f646-1f3fc-200d-2640-fe0f",
                  34,
                  24,
                  15,
                  ["🙆🏼‍♀️", "🙆🏼"],
                ],
                "1f3fd": [
                  "1f646-1f3fd-200d-2640-fe0f",
                  34,
                  25,
                  15,
                  ["🙆🏽‍♀️", "🙆🏽"],
                ],
                "1f3fe": [
                  "1f646-1f3fe-200d-2640-fe0f",
                  34,
                  26,
                  15,
                  ["🙆🏾‍♀️", "🙆🏾"],
                ],
                "1f3ff": [
                  "1f646-1f3ff-200d-2640-fe0f",
                  34,
                  27,
                  15,
                  ["🙆🏿‍♀️", "🙆🏿"],
                ],
              },
              "1f646-200d-2642-fe0f": {
                "1f3fb": ["1f646-1f3fb-200d-2642-fe0f", 34, 29, 15, ["🙆🏻‍♂️"]],
                "1f3fc": ["1f646-1f3fc-200d-2642-fe0f", 34, 30, 15, ["🙆🏼‍♂️"]],
                "1f3fd": ["1f646-1f3fd-200d-2642-fe0f", 34, 31, 15, ["🙆🏽‍♂️"]],
                "1f3fe": ["1f646-1f3fe-200d-2642-fe0f", 34, 32, 15, ["🙆🏾‍♂️"]],
                "1f3ff": ["1f646-1f3ff-200d-2642-fe0f", 34, 33, 15, ["🙆🏿‍♂️"]],
              },
              "1f647-200d-2640-fe0f": {
                "1f3fb": ["1f647-1f3fb-200d-2640-fe0f", 34, 41, 15, ["🙇🏻‍♀️"]],
                "1f3fc": ["1f647-1f3fc-200d-2640-fe0f", 34, 42, 15, ["🙇🏼‍♀️"]],
                "1f3fd": ["1f647-1f3fd-200d-2640-fe0f", 34, 43, 15, ["🙇🏽‍♀️"]],
                "1f3fe": ["1f647-1f3fe-200d-2640-fe0f", 34, 44, 15, ["🙇🏾‍♀️"]],
                "1f3ff": ["1f647-1f3ff-200d-2640-fe0f", 34, 45, 15, ["🙇🏿‍♀️"]],
              },
              "1f647-200d-2642-fe0f": {
                "1f3fb": [
                  "1f647-1f3fb-200d-2642-fe0f",
                  34,
                  47,
                  15,
                  ["🙇🏻‍♂️", "🙇🏻"],
                ],
                "1f3fc": [
                  "1f647-1f3fc-200d-2642-fe0f",
                  34,
                  48,
                  15,
                  ["🙇🏼‍♂️", "🙇🏼"],
                ],
                "1f3fd": [
                  "1f647-1f3fd-200d-2642-fe0f",
                  34,
                  49,
                  15,
                  ["🙇🏽‍♂️", "🙇🏽"],
                ],
                "1f3fe": [
                  "1f647-1f3fe-200d-2642-fe0f",
                  34,
                  50,
                  15,
                  ["🙇🏾‍♂️", "🙇🏾"],
                ],
                "1f3ff": [
                  "1f647-1f3ff-200d-2642-fe0f",
                  34,
                  51,
                  15,
                  ["🙇🏿‍♂️", "🙇🏿"],
                ],
              },
              "1f64b-200d-2640-fe0f": {
                "1f3fb": [
                  "1f64b-1f3fb-200d-2640-fe0f",
                  35,
                  2,
                  15,
                  ["🙋🏻‍♀️", "🙋🏻"],
                ],
                "1f3fc": [
                  "1f64b-1f3fc-200d-2640-fe0f",
                  35,
                  3,
                  15,
                  ["🙋🏼‍♀️", "🙋🏼"],
                ],
                "1f3fd": [
                  "1f64b-1f3fd-200d-2640-fe0f",
                  35,
                  4,
                  15,
                  ["🙋🏽‍♀️", "🙋🏽"],
                ],
                "1f3fe": [
                  "1f64b-1f3fe-200d-2640-fe0f",
                  35,
                  5,
                  15,
                  ["🙋🏾‍♀️", "🙋🏾"],
                ],
                "1f3ff": [
                  "1f64b-1f3ff-200d-2640-fe0f",
                  35,
                  6,
                  15,
                  ["🙋🏿‍♀️", "🙋🏿"],
                ],
              },
              "1f64b-200d-2642-fe0f": {
                "1f3fb": ["1f64b-1f3fb-200d-2642-fe0f", 35, 8, 15, ["🙋🏻‍♂️"]],
                "1f3fc": ["1f64b-1f3fc-200d-2642-fe0f", 35, 9, 15, ["🙋🏼‍♂️"]],
                "1f3fd": ["1f64b-1f3fd-200d-2642-fe0f", 35, 10, 15, ["🙋🏽‍♂️"]],
                "1f3fe": ["1f64b-1f3fe-200d-2642-fe0f", 35, 11, 15, ["🙋🏾‍♂️"]],
                "1f3ff": ["1f64b-1f3ff-200d-2642-fe0f", 35, 12, 15, ["🙋🏿‍♂️"]],
              },
              "1f64c": {
                "1f3fb": ["1f64c-1f3fb", 35, 20, 15, ["🙌🏻"]],
                "1f3fc": ["1f64c-1f3fc", 35, 21, 15, ["🙌🏼"]],
                "1f3fd": ["1f64c-1f3fd", 35, 22, 15, ["🙌🏽"]],
                "1f3fe": ["1f64c-1f3fe", 35, 23, 15, ["🙌🏾"]],
                "1f3ff": ["1f64c-1f3ff", 35, 24, 15, ["🙌🏿"]],
              },
              "1f64d-200d-2640-fe0f": {
                "1f3fb": [
                  "1f64d-1f3fb-200d-2640-fe0f",
                  35,
                  26,
                  15,
                  ["🙍🏻‍♀️", "🙍🏻"],
                ],
                "1f3fc": [
                  "1f64d-1f3fc-200d-2640-fe0f",
                  35,
                  27,
                  15,
                  ["🙍🏼‍♀️", "🙍🏼"],
                ],
                "1f3fd": [
                  "1f64d-1f3fd-200d-2640-fe0f",
                  35,
                  28,
                  15,
                  ["🙍🏽‍♀️", "🙍🏽"],
                ],
                "1f3fe": [
                  "1f64d-1f3fe-200d-2640-fe0f",
                  35,
                  29,
                  15,
                  ["🙍🏾‍♀️", "🙍🏾"],
                ],
                "1f3ff": [
                  "1f64d-1f3ff-200d-2640-fe0f",
                  35,
                  30,
                  15,
                  ["🙍🏿‍♀️", "🙍🏿"],
                ],
              },
              "1f64d-200d-2642-fe0f": {
                "1f3fb": ["1f64d-1f3fb-200d-2642-fe0f", 35, 32, 15, ["🙍🏻‍♂️"]],
                "1f3fc": ["1f64d-1f3fc-200d-2642-fe0f", 35, 33, 15, ["🙍🏼‍♂️"]],
                "1f3fd": ["1f64d-1f3fd-200d-2642-fe0f", 35, 34, 15, ["🙍🏽‍♂️"]],
                "1f3fe": ["1f64d-1f3fe-200d-2642-fe0f", 35, 35, 15, ["🙍🏾‍♂️"]],
                "1f3ff": ["1f64d-1f3ff-200d-2642-fe0f", 35, 36, 15, ["🙍🏿‍♂️"]],
              },
              "1f64e-200d-2640-fe0f": {
                "1f3fb": [
                  "1f64e-1f3fb-200d-2640-fe0f",
                  35,
                  44,
                  15,
                  ["🙎🏻‍♀️", "🙎🏻"],
                ],
                "1f3fc": [
                  "1f64e-1f3fc-200d-2640-fe0f",
                  35,
                  45,
                  15,
                  ["🙎🏼‍♀️", "🙎🏼"],
                ],
                "1f3fd": [
                  "1f64e-1f3fd-200d-2640-fe0f",
                  35,
                  46,
                  15,
                  ["🙎🏽‍♀️", "🙎🏽"],
                ],
                "1f3fe": [
                  "1f64e-1f3fe-200d-2640-fe0f",
                  35,
                  47,
                  15,
                  ["🙎🏾‍♀️", "🙎🏾"],
                ],
                "1f3ff": [
                  "1f64e-1f3ff-200d-2640-fe0f",
                  35,
                  48,
                  15,
                  ["🙎🏿‍♀️", "🙎🏿"],
                ],
              },
              "1f64e-200d-2642-fe0f": {
                "1f3fb": ["1f64e-1f3fb-200d-2642-fe0f", 35, 50, 15, ["🙎🏻‍♂️"]],
                "1f3fc": ["1f64e-1f3fc-200d-2642-fe0f", 35, 51, 15, ["🙎🏼‍♂️"]],
                "1f3fd": ["1f64e-1f3fd-200d-2642-fe0f", 35, 52, 15, ["🙎🏽‍♂️"]],
                "1f3fe": ["1f64e-1f3fe-200d-2642-fe0f", 35, 53, 15, ["🙎🏾‍♂️"]],
                "1f3ff": ["1f64e-1f3ff-200d-2642-fe0f", 35, 54, 15, ["🙎🏿‍♂️"]],
              },
              "1f64f": {
                "1f3fb": ["1f64f-1f3fb", 36, 2, 15, ["🙏🏻"]],
                "1f3fc": ["1f64f-1f3fc", 36, 3, 15, ["🙏🏼"]],
                "1f3fd": ["1f64f-1f3fd", 36, 4, 15, ["🙏🏽"]],
                "1f3fe": ["1f64f-1f3fe", 36, 5, 15, ["🙏🏾"]],
                "1f3ff": ["1f64f-1f3ff", 36, 6, 15, ["🙏🏿"]],
              },
              "1f6a3-200d-2640-fe0f": {
                "1f3fb": ["1f6a3-1f3fb-200d-2640-fe0f", 36, 43, 15, ["🚣🏻‍♀️"]],
                "1f3fc": ["1f6a3-1f3fc-200d-2640-fe0f", 36, 44, 15, ["🚣🏼‍♀️"]],
                "1f3fd": ["1f6a3-1f3fd-200d-2640-fe0f", 36, 45, 15, ["🚣🏽‍♀️"]],
                "1f3fe": ["1f6a3-1f3fe-200d-2640-fe0f", 36, 46, 15, ["🚣🏾‍♀️"]],
                "1f3ff": ["1f6a3-1f3ff-200d-2640-fe0f", 36, 47, 15, ["🚣🏿‍♀️"]],
              },
              "1f6a3-200d-2642-fe0f": {
                "1f3fb": [
                  "1f6a3-1f3fb-200d-2642-fe0f",
                  36,
                  49,
                  15,
                  ["🚣🏻‍♂️", "🚣🏻"],
                ],
                "1f3fc": [
                  "1f6a3-1f3fc-200d-2642-fe0f",
                  36,
                  50,
                  15,
                  ["🚣🏼‍♂️", "🚣🏼"],
                ],
                "1f3fd": [
                  "1f6a3-1f3fd-200d-2642-fe0f",
                  36,
                  51,
                  15,
                  ["🚣🏽‍♂️", "🚣🏽"],
                ],
                "1f3fe": [
                  "1f6a3-1f3fe-200d-2642-fe0f",
                  36,
                  52,
                  15,
                  ["🚣🏾‍♂️", "🚣🏾"],
                ],
                "1f3ff": [
                  "1f6a3-1f3ff-200d-2642-fe0f",
                  36,
                  53,
                  15,
                  ["🚣🏿‍♂️", "🚣🏿"],
                ],
              },
              "1f6b4-200d-2640-fe0f": {
                "1f3fb": ["1f6b4-1f3fb-200d-2640-fe0f", 37, 17, 15, ["🚴🏻‍♀️"]],
                "1f3fc": ["1f6b4-1f3fc-200d-2640-fe0f", 37, 18, 15, ["🚴🏼‍♀️"]],
                "1f3fd": ["1f6b4-1f3fd-200d-2640-fe0f", 37, 19, 15, ["🚴🏽‍♀️"]],
                "1f3fe": ["1f6b4-1f3fe-200d-2640-fe0f", 37, 20, 15, ["🚴🏾‍♀️"]],
                "1f3ff": ["1f6b4-1f3ff-200d-2640-fe0f", 37, 21, 15, ["🚴🏿‍♀️"]],
              },
              "1f6b4-200d-2642-fe0f": {
                "1f3fb": [
                  "1f6b4-1f3fb-200d-2642-fe0f",
                  37,
                  23,
                  15,
                  ["🚴🏻‍♂️", "🚴🏻"],
                ],
                "1f3fc": [
                  "1f6b4-1f3fc-200d-2642-fe0f",
                  37,
                  24,
                  15,
                  ["🚴🏼‍♂️", "🚴🏼"],
                ],
                "1f3fd": [
                  "1f6b4-1f3fd-200d-2642-fe0f",
                  37,
                  25,
                  15,
                  ["🚴🏽‍♂️", "🚴🏽"],
                ],
                "1f3fe": [
                  "1f6b4-1f3fe-200d-2642-fe0f",
                  37,
                  26,
                  15,
                  ["🚴🏾‍♂️", "🚴🏾"],
                ],
                "1f3ff": [
                  "1f6b4-1f3ff-200d-2642-fe0f",
                  37,
                  27,
                  15,
                  ["🚴🏿‍♂️", "🚴🏿"],
                ],
              },
              "1f6b5-200d-2640-fe0f": {
                "1f3fb": ["1f6b5-1f3fb-200d-2640-fe0f", 37, 35, 15, ["🚵🏻‍♀️"]],
                "1f3fc": ["1f6b5-1f3fc-200d-2640-fe0f", 37, 36, 15, ["🚵🏼‍♀️"]],
                "1f3fd": ["1f6b5-1f3fd-200d-2640-fe0f", 37, 37, 15, ["🚵🏽‍♀️"]],
                "1f3fe": ["1f6b5-1f3fe-200d-2640-fe0f", 37, 38, 15, ["🚵🏾‍♀️"]],
                "1f3ff": ["1f6b5-1f3ff-200d-2640-fe0f", 37, 39, 15, ["🚵🏿‍♀️"]],
              },
              "1f6b5-200d-2642-fe0f": {
                "1f3fb": [
                  "1f6b5-1f3fb-200d-2642-fe0f",
                  37,
                  41,
                  15,
                  ["🚵🏻‍♂️", "🚵🏻"],
                ],
                "1f3fc": [
                  "1f6b5-1f3fc-200d-2642-fe0f",
                  37,
                  42,
                  15,
                  ["🚵🏼‍♂️", "🚵🏼"],
                ],
                "1f3fd": [
                  "1f6b5-1f3fd-200d-2642-fe0f",
                  37,
                  43,
                  15,
                  ["🚵🏽‍♂️", "🚵🏽"],
                ],
                "1f3fe": [
                  "1f6b5-1f3fe-200d-2642-fe0f",
                  37,
                  44,
                  15,
                  ["🚵🏾‍♂️", "🚵🏾"],
                ],
                "1f3ff": [
                  "1f6b5-1f3ff-200d-2642-fe0f",
                  37,
                  45,
                  15,
                  ["🚵🏿‍♂️", "🚵🏿"],
                ],
              },
              "1f6b6-200d-2640-fe0f": {
                "1f3fb": ["1f6b6-1f3fb-200d-2640-fe0f", 37, 53, 15, ["🚶🏻‍♀️"]],
                "1f3fc": ["1f6b6-1f3fc-200d-2640-fe0f", 37, 54, 15, ["🚶🏼‍♀️"]],
                "1f3fd": ["1f6b6-1f3fd-200d-2640-fe0f", 37, 55, 15, ["🚶🏽‍♀️"]],
                "1f3fe": ["1f6b6-1f3fe-200d-2640-fe0f", 37, 56, 15, ["🚶🏾‍♀️"]],
                "1f3ff": ["1f6b6-1f3ff-200d-2640-fe0f", 37, 57, 15, ["🚶🏿‍♀️"]],
              },
              "1f6b6-200d-2642-fe0f": {
                "1f3fb": [
                  "1f6b6-1f3fb-200d-2642-fe0f",
                  37,
                  59,
                  15,
                  ["🚶🏻‍♂️", "🚶🏻"],
                ],
                "1f3fc": [
                  "1f6b6-1f3fc-200d-2642-fe0f",
                  38,
                  0,
                  15,
                  ["🚶🏼‍♂️", "🚶🏼"],
                ],
                "1f3fd": [
                  "1f6b6-1f3fd-200d-2642-fe0f",
                  38,
                  1,
                  15,
                  ["🚶🏽‍♂️", "🚶🏽"],
                ],
                "1f3fe": [
                  "1f6b6-1f3fe-200d-2642-fe0f",
                  38,
                  2,
                  15,
                  ["🚶🏾‍♂️", "🚶🏾"],
                ],
                "1f3ff": [
                  "1f6b6-1f3ff-200d-2642-fe0f",
                  38,
                  3,
                  15,
                  ["🚶🏿‍♂️", "🚶🏿"],
                ],
              },
              "1f6c0": {
                "1f3fb": ["1f6c0-1f3fb", 38, 20, 15, ["🛀🏻"]],
                "1f3fc": ["1f6c0-1f3fc", 38, 21, 15, ["🛀🏼"]],
                "1f3fd": ["1f6c0-1f3fd", 38, 22, 15, ["🛀🏽"]],
                "1f3fe": ["1f6c0-1f3fe", 38, 23, 15, ["🛀🏾"]],
                "1f3ff": ["1f6c0-1f3ff", 38, 24, 15, ["🛀🏿"]],
              },
              "1f6cc": {
                "1f3fb": ["1f6cc-1f3fb", 38, 32, 15, ["🛌🏻"]],
                "1f3fc": ["1f6cc-1f3fc", 38, 33, 15, ["🛌🏼"]],
                "1f3fd": ["1f6cc-1f3fd", 38, 34, 15, ["🛌🏽"]],
                "1f3fe": ["1f6cc-1f3fe", 38, 35, 15, ["🛌🏾"]],
                "1f3ff": ["1f6cc-1f3ff", 38, 36, 15, ["🛌🏿"]],
              },
              "1f90c": {
                "1f3fb": ["1f90c-1f3fb", 39, 19, 15, ["🤌🏻"]],
                "1f3fc": ["1f90c-1f3fc", 39, 20, 15, ["🤌🏼"]],
                "1f3fd": ["1f90c-1f3fd", 39, 21, 15, ["🤌🏽"]],
                "1f3fe": ["1f90c-1f3fe", 39, 22, 15, ["🤌🏾"]],
                "1f3ff": ["1f90c-1f3ff", 39, 23, 15, ["🤌🏿"]],
              },
              "1f90f": {
                "1f3fb": ["1f90f-1f3fb", 39, 27, 15, ["🤏🏻"]],
                "1f3fc": ["1f90f-1f3fc", 39, 28, 15, ["🤏🏼"]],
                "1f3fd": ["1f90f-1f3fd", 39, 29, 15, ["🤏🏽"]],
                "1f3fe": ["1f90f-1f3fe", 39, 30, 15, ["🤏🏾"]],
                "1f3ff": ["1f90f-1f3ff", 39, 31, 15, ["🤏🏿"]],
              },
              "1f918": {
                "1f3fb": ["1f918-1f3fb", 39, 41, 15, ["🤘🏻"]],
                "1f3fc": ["1f918-1f3fc", 39, 42, 15, ["🤘🏼"]],
                "1f3fd": ["1f918-1f3fd", 39, 43, 15, ["🤘🏽"]],
                "1f3fe": ["1f918-1f3fe", 39, 44, 15, ["🤘🏾"]],
                "1f3ff": ["1f918-1f3ff", 39, 45, 15, ["🤘🏿"]],
              },
              "1f919": {
                "1f3fb": ["1f919-1f3fb", 39, 47, 15, ["🤙🏻"]],
                "1f3fc": ["1f919-1f3fc", 39, 48, 15, ["🤙🏼"]],
                "1f3fd": ["1f919-1f3fd", 39, 49, 15, ["🤙🏽"]],
                "1f3fe": ["1f919-1f3fe", 39, 50, 15, ["🤙🏾"]],
                "1f3ff": ["1f919-1f3ff", 39, 51, 15, ["🤙🏿"]],
              },
              "1f91a": {
                "1f3fb": ["1f91a-1f3fb", 39, 53, 15, ["🤚🏻"]],
                "1f3fc": ["1f91a-1f3fc", 39, 54, 15, ["🤚🏼"]],
                "1f3fd": ["1f91a-1f3fd", 39, 55, 15, ["🤚🏽"]],
                "1f3fe": ["1f91a-1f3fe", 39, 56, 15, ["🤚🏾"]],
                "1f3ff": ["1f91a-1f3ff", 39, 57, 15, ["🤚🏿"]],
              },
              "1f91b": {
                "1f3fb": ["1f91b-1f3fb", 39, 59, 15, ["🤛🏻"]],
                "1f3fc": ["1f91b-1f3fc", 40, 0, 15, ["🤛🏼"]],
                "1f3fd": ["1f91b-1f3fd", 40, 1, 15, ["🤛🏽"]],
                "1f3fe": ["1f91b-1f3fe", 40, 2, 15, ["🤛🏾"]],
                "1f3ff": ["1f91b-1f3ff", 40, 3, 15, ["🤛🏿"]],
              },
              "1f91c": {
                "1f3fb": ["1f91c-1f3fb", 40, 5, 15, ["🤜🏻"]],
                "1f3fc": ["1f91c-1f3fc", 40, 6, 15, ["🤜🏼"]],
                "1f3fd": ["1f91c-1f3fd", 40, 7, 15, ["🤜🏽"]],
                "1f3fe": ["1f91c-1f3fe", 40, 8, 15, ["🤜🏾"]],
                "1f3ff": ["1f91c-1f3ff", 40, 9, 15, ["🤜🏿"]],
              },
              "1f91e": {
                "1f3fb": ["1f91e-1f3fb", 40, 12, 15, ["🤞🏻"]],
                "1f3fc": ["1f91e-1f3fc", 40, 13, 15, ["🤞🏼"]],
                "1f3fd": ["1f91e-1f3fd", 40, 14, 15, ["🤞🏽"]],
                "1f3fe": ["1f91e-1f3fe", 40, 15, 15, ["🤞🏾"]],
                "1f3ff": ["1f91e-1f3ff", 40, 16, 15, ["🤞🏿"]],
              },
              "1f91f": {
                "1f3fb": ["1f91f-1f3fb", 40, 18, 15, ["🤟🏻"]],
                "1f3fc": ["1f91f-1f3fc", 40, 19, 15, ["🤟🏼"]],
                "1f3fd": ["1f91f-1f3fd", 40, 20, 15, ["🤟🏽"]],
                "1f3fe": ["1f91f-1f3fe", 40, 21, 15, ["🤟🏾"]],
                "1f3ff": ["1f91f-1f3ff", 40, 22, 15, ["🤟🏿"]],
              },
              "1f926-200d-2640-fe0f": {
                "1f3fb": ["1f926-1f3fb-200d-2640-fe0f", 40, 30, 15, ["🤦🏻‍♀️"]],
                "1f3fc": ["1f926-1f3fc-200d-2640-fe0f", 40, 31, 15, ["🤦🏼‍♀️"]],
                "1f3fd": ["1f926-1f3fd-200d-2640-fe0f", 40, 32, 15, ["🤦🏽‍♀️"]],
                "1f3fe": ["1f926-1f3fe-200d-2640-fe0f", 40, 33, 15, ["🤦🏾‍♀️"]],
                "1f3ff": ["1f926-1f3ff-200d-2640-fe0f", 40, 34, 15, ["🤦🏿‍♀️"]],
              },
              "1f926-200d-2642-fe0f": {
                "1f3fb": ["1f926-1f3fb-200d-2642-fe0f", 40, 36, 15, ["🤦🏻‍♂️"]],
                "1f3fc": ["1f926-1f3fc-200d-2642-fe0f", 40, 37, 15, ["🤦🏼‍♂️"]],
                "1f3fd": ["1f926-1f3fd-200d-2642-fe0f", 40, 38, 15, ["🤦🏽‍♂️"]],
                "1f3fe": ["1f926-1f3fe-200d-2642-fe0f", 40, 39, 15, ["🤦🏾‍♂️"]],
                "1f3ff": ["1f926-1f3ff-200d-2642-fe0f", 40, 40, 15, ["🤦🏿‍♂️"]],
              },
              "1f926": {
                "1f3fb": ["1f926-1f3fb", 40, 42, 15, ["🤦🏻"]],
                "1f3fc": ["1f926-1f3fc", 40, 43, 15, ["🤦🏼"]],
                "1f3fd": ["1f926-1f3fd", 40, 44, 15, ["🤦🏽"]],
                "1f3fe": ["1f926-1f3fe", 40, 45, 15, ["🤦🏾"]],
                "1f3ff": ["1f926-1f3ff", 40, 46, 15, ["🤦🏿"]],
              },
              "1f930": {
                "1f3fb": ["1f930-1f3fb", 40, 57, 15, ["🤰🏻"]],
                "1f3fc": ["1f930-1f3fc", 40, 58, 15, ["🤰🏼"]],
                "1f3fd": ["1f930-1f3fd", 40, 59, 15, ["🤰🏽"]],
                "1f3fe": ["1f930-1f3fe", 41, 0, 15, ["🤰🏾"]],
                "1f3ff": ["1f930-1f3ff", 41, 1, 15, ["🤰🏿"]],
              },
              "1f931": {
                "1f3fb": ["1f931-1f3fb", 41, 3, 15, ["🤱🏻"]],
                "1f3fc": ["1f931-1f3fc", 41, 4, 15, ["🤱🏼"]],
                "1f3fd": ["1f931-1f3fd", 41, 5, 15, ["🤱🏽"]],
                "1f3fe": ["1f931-1f3fe", 41, 6, 15, ["🤱🏾"]],
                "1f3ff": ["1f931-1f3ff", 41, 7, 15, ["🤱🏿"]],
              },
              "1f932": {
                "1f3fb": ["1f932-1f3fb", 41, 9, 15, ["🤲🏻"]],
                "1f3fc": ["1f932-1f3fc", 41, 10, 15, ["🤲🏼"]],
                "1f3fd": ["1f932-1f3fd", 41, 11, 15, ["🤲🏽"]],
                "1f3fe": ["1f932-1f3fe", 41, 12, 15, ["🤲🏾"]],
                "1f3ff": ["1f932-1f3ff", 41, 13, 15, ["🤲🏿"]],
              },
              "1f933": {
                "1f3fb": ["1f933-1f3fb", 41, 15, 15, ["🤳🏻"]],
                "1f3fc": ["1f933-1f3fc", 41, 16, 15, ["🤳🏼"]],
                "1f3fd": ["1f933-1f3fd", 41, 17, 15, ["🤳🏽"]],
                "1f3fe": ["1f933-1f3fe", 41, 18, 15, ["🤳🏾"]],
                "1f3ff": ["1f933-1f3ff", 41, 19, 15, ["🤳🏿"]],
              },
              "1f934": {
                "1f3fb": ["1f934-1f3fb", 41, 21, 15, ["🤴🏻"]],
                "1f3fc": ["1f934-1f3fc", 41, 22, 15, ["🤴🏼"]],
                "1f3fd": ["1f934-1f3fd", 41, 23, 15, ["🤴🏽"]],
                "1f3fe": ["1f934-1f3fe", 41, 24, 15, ["🤴🏾"]],
                "1f3ff": ["1f934-1f3ff", 41, 25, 15, ["🤴🏿"]],
              },
              "1f935-200d-2640-fe0f": {
                "1f3fb": ["1f935-1f3fb-200d-2640-fe0f", 41, 27, 15, ["🤵🏻‍♀️"]],
                "1f3fc": ["1f935-1f3fc-200d-2640-fe0f", 41, 28, 15, ["🤵🏼‍♀️"]],
                "1f3fd": ["1f935-1f3fd-200d-2640-fe0f", 41, 29, 15, ["🤵🏽‍♀️"]],
                "1f3fe": ["1f935-1f3fe-200d-2640-fe0f", 41, 30, 15, ["🤵🏾‍♀️"]],
                "1f3ff": ["1f935-1f3ff-200d-2640-fe0f", 41, 31, 15, ["🤵🏿‍♀️"]],
              },
              "1f935-200d-2642-fe0f": {
                "1f3fb": ["1f935-1f3fb-200d-2642-fe0f", 41, 33, 15, ["🤵🏻‍♂️"]],
                "1f3fc": ["1f935-1f3fc-200d-2642-fe0f", 41, 34, 15, ["🤵🏼‍♂️"]],
                "1f3fd": ["1f935-1f3fd-200d-2642-fe0f", 41, 35, 15, ["🤵🏽‍♂️"]],
                "1f3fe": ["1f935-1f3fe-200d-2642-fe0f", 41, 36, 15, ["🤵🏾‍♂️"]],
                "1f3ff": ["1f935-1f3ff-200d-2642-fe0f", 41, 37, 15, ["🤵🏿‍♂️"]],
              },
              "1f935": {
                "1f3fb": ["1f935-1f3fb", 41, 39, 15, ["🤵🏻"]],
                "1f3fc": ["1f935-1f3fc", 41, 40, 15, ["🤵🏼"]],
                "1f3fd": ["1f935-1f3fd", 41, 41, 15, ["🤵🏽"]],
                "1f3fe": ["1f935-1f3fe", 41, 42, 15, ["🤵🏾"]],
                "1f3ff": ["1f935-1f3ff", 41, 43, 15, ["🤵🏿"]],
              },
              "1f936": {
                "1f3fb": ["1f936-1f3fb", 41, 45, 15, ["🤶🏻"]],
                "1f3fc": ["1f936-1f3fc", 41, 46, 15, ["🤶🏼"]],
                "1f3fd": ["1f936-1f3fd", 41, 47, 15, ["🤶🏽"]],
                "1f3fe": ["1f936-1f3fe", 41, 48, 15, ["🤶🏾"]],
                "1f3ff": ["1f936-1f3ff", 41, 49, 15, ["🤶🏿"]],
              },
              "1f937-200d-2640-fe0f": {
                "1f3fb": ["1f937-1f3fb-200d-2640-fe0f", 41, 51, 15, ["🤷🏻‍♀️"]],
                "1f3fc": ["1f937-1f3fc-200d-2640-fe0f", 41, 52, 15, ["🤷🏼‍♀️"]],
                "1f3fd": ["1f937-1f3fd-200d-2640-fe0f", 41, 53, 15, ["🤷🏽‍♀️"]],
                "1f3fe": ["1f937-1f3fe-200d-2640-fe0f", 41, 54, 15, ["🤷🏾‍♀️"]],
                "1f3ff": ["1f937-1f3ff-200d-2640-fe0f", 41, 55, 15, ["🤷🏿‍♀️"]],
              },
              "1f937-200d-2642-fe0f": {
                "1f3fb": ["1f937-1f3fb-200d-2642-fe0f", 41, 57, 15, ["🤷🏻‍♂️"]],
                "1f3fc": ["1f937-1f3fc-200d-2642-fe0f", 41, 58, 15, ["🤷🏼‍♂️"]],
                "1f3fd": ["1f937-1f3fd-200d-2642-fe0f", 41, 59, 15, ["🤷🏽‍♂️"]],
                "1f3fe": ["1f937-1f3fe-200d-2642-fe0f", 42, 0, 15, ["🤷🏾‍♂️"]],
                "1f3ff": ["1f937-1f3ff-200d-2642-fe0f", 42, 1, 15, ["🤷🏿‍♂️"]],
              },
              "1f937": {
                "1f3fb": ["1f937-1f3fb", 42, 3, 15, ["🤷🏻"]],
                "1f3fc": ["1f937-1f3fc", 42, 4, 15, ["🤷🏼"]],
                "1f3fd": ["1f937-1f3fd", 42, 5, 15, ["🤷🏽"]],
                "1f3fe": ["1f937-1f3fe", 42, 6, 15, ["🤷🏾"]],
                "1f3ff": ["1f937-1f3ff", 42, 7, 15, ["🤷🏿"]],
              },
              "1f938-200d-2640-fe0f": {
                "1f3fb": ["1f938-1f3fb-200d-2640-fe0f", 42, 9, 15, ["🤸🏻‍♀️"]],
                "1f3fc": ["1f938-1f3fc-200d-2640-fe0f", 42, 10, 15, ["🤸🏼‍♀️"]],
                "1f3fd": ["1f938-1f3fd-200d-2640-fe0f", 42, 11, 15, ["🤸🏽‍♀️"]],
                "1f3fe": ["1f938-1f3fe-200d-2640-fe0f", 42, 12, 15, ["🤸🏾‍♀️"]],
                "1f3ff": ["1f938-1f3ff-200d-2640-fe0f", 42, 13, 15, ["🤸🏿‍♀️"]],
              },
              "1f938-200d-2642-fe0f": {
                "1f3fb": ["1f938-1f3fb-200d-2642-fe0f", 42, 15, 15, ["🤸🏻‍♂️"]],
                "1f3fc": ["1f938-1f3fc-200d-2642-fe0f", 42, 16, 15, ["🤸🏼‍♂️"]],
                "1f3fd": ["1f938-1f3fd-200d-2642-fe0f", 42, 17, 15, ["🤸🏽‍♂️"]],
                "1f3fe": ["1f938-1f3fe-200d-2642-fe0f", 42, 18, 15, ["🤸🏾‍♂️"]],
                "1f3ff": ["1f938-1f3ff-200d-2642-fe0f", 42, 19, 15, ["🤸🏿‍♂️"]],
              },
              "1f938": {
                "1f3fb": ["1f938-1f3fb", 42, 21, 15, ["🤸🏻"]],
                "1f3fc": ["1f938-1f3fc", 42, 22, 15, ["🤸🏼"]],
                "1f3fd": ["1f938-1f3fd", 42, 23, 15, ["🤸🏽"]],
                "1f3fe": ["1f938-1f3fe", 42, 24, 15, ["🤸🏾"]],
                "1f3ff": ["1f938-1f3ff", 42, 25, 15, ["🤸🏿"]],
              },
              "1f939-200d-2640-fe0f": {
                "1f3fb": ["1f939-1f3fb-200d-2640-fe0f", 42, 27, 15, ["🤹🏻‍♀️"]],
                "1f3fc": ["1f939-1f3fc-200d-2640-fe0f", 42, 28, 15, ["🤹🏼‍♀️"]],
                "1f3fd": ["1f939-1f3fd-200d-2640-fe0f", 42, 29, 15, ["🤹🏽‍♀️"]],
                "1f3fe": ["1f939-1f3fe-200d-2640-fe0f", 42, 30, 15, ["🤹🏾‍♀️"]],
                "1f3ff": ["1f939-1f3ff-200d-2640-fe0f", 42, 31, 15, ["🤹🏿‍♀️"]],
              },
              "1f939-200d-2642-fe0f": {
                "1f3fb": ["1f939-1f3fb-200d-2642-fe0f", 42, 33, 15, ["🤹🏻‍♂️"]],
                "1f3fc": ["1f939-1f3fc-200d-2642-fe0f", 42, 34, 15, ["🤹🏼‍♂️"]],
                "1f3fd": ["1f939-1f3fd-200d-2642-fe0f", 42, 35, 15, ["🤹🏽‍♂️"]],
                "1f3fe": ["1f939-1f3fe-200d-2642-fe0f", 42, 36, 15, ["🤹🏾‍♂️"]],
                "1f3ff": ["1f939-1f3ff-200d-2642-fe0f", 42, 37, 15, ["🤹🏿‍♂️"]],
              },
              "1f939": {
                "1f3fb": ["1f939-1f3fb", 42, 39, 15, ["🤹🏻"]],
                "1f3fc": ["1f939-1f3fc", 42, 40, 15, ["🤹🏼"]],
                "1f3fd": ["1f939-1f3fd", 42, 41, 15, ["🤹🏽"]],
                "1f3fe": ["1f939-1f3fe", 42, 42, 15, ["🤹🏾"]],
                "1f3ff": ["1f939-1f3ff", 42, 43, 15, ["🤹🏿"]],
              },
              "1f93d-200d-2640-fe0f": {
                "1f3fb": ["1f93d-1f3fb-200d-2640-fe0f", 42, 49, 15, ["🤽🏻‍♀️"]],
                "1f3fc": ["1f93d-1f3fc-200d-2640-fe0f", 42, 50, 15, ["🤽🏼‍♀️"]],
                "1f3fd": ["1f93d-1f3fd-200d-2640-fe0f", 42, 51, 15, ["🤽🏽‍♀️"]],
                "1f3fe": ["1f93d-1f3fe-200d-2640-fe0f", 42, 52, 15, ["🤽🏾‍♀️"]],
                "1f3ff": ["1f93d-1f3ff-200d-2640-fe0f", 42, 53, 15, ["🤽🏿‍♀️"]],
              },
              "1f93d-200d-2642-fe0f": {
                "1f3fb": ["1f93d-1f3fb-200d-2642-fe0f", 42, 55, 15, ["🤽🏻‍♂️"]],
                "1f3fc": ["1f93d-1f3fc-200d-2642-fe0f", 42, 56, 15, ["🤽🏼‍♂️"]],
                "1f3fd": ["1f93d-1f3fd-200d-2642-fe0f", 42, 57, 15, ["🤽🏽‍♂️"]],
                "1f3fe": ["1f93d-1f3fe-200d-2642-fe0f", 42, 58, 15, ["🤽🏾‍♂️"]],
                "1f3ff": ["1f93d-1f3ff-200d-2642-fe0f", 42, 59, 15, ["🤽🏿‍♂️"]],
              },
              "1f93d": {
                "1f3fb": ["1f93d-1f3fb", 43, 1, 15, ["🤽🏻"]],
                "1f3fc": ["1f93d-1f3fc", 43, 2, 15, ["🤽🏼"]],
                "1f3fd": ["1f93d-1f3fd", 43, 3, 15, ["🤽🏽"]],
                "1f3fe": ["1f93d-1f3fe", 43, 4, 15, ["🤽🏾"]],
                "1f3ff": ["1f93d-1f3ff", 43, 5, 15, ["🤽🏿"]],
              },
              "1f93e-200d-2640-fe0f": {
                "1f3fb": ["1f93e-1f3fb-200d-2640-fe0f", 43, 7, 15, ["🤾🏻‍♀️"]],
                "1f3fc": ["1f93e-1f3fc-200d-2640-fe0f", 43, 8, 15, ["🤾🏼‍♀️"]],
                "1f3fd": ["1f93e-1f3fd-200d-2640-fe0f", 43, 9, 15, ["🤾🏽‍♀️"]],
                "1f3fe": ["1f93e-1f3fe-200d-2640-fe0f", 43, 10, 15, ["🤾🏾‍♀️"]],
                "1f3ff": ["1f93e-1f3ff-200d-2640-fe0f", 43, 11, 15, ["🤾🏿‍♀️"]],
              },
              "1f93e-200d-2642-fe0f": {
                "1f3fb": ["1f93e-1f3fb-200d-2642-fe0f", 43, 13, 15, ["🤾🏻‍♂️"]],
                "1f3fc": ["1f93e-1f3fc-200d-2642-fe0f", 43, 14, 15, ["🤾🏼‍♂️"]],
                "1f3fd": ["1f93e-1f3fd-200d-2642-fe0f", 43, 15, 15, ["🤾🏽‍♂️"]],
                "1f3fe": ["1f93e-1f3fe-200d-2642-fe0f", 43, 16, 15, ["🤾🏾‍♂️"]],
                "1f3ff": ["1f93e-1f3ff-200d-2642-fe0f", 43, 17, 15, ["🤾🏿‍♂️"]],
              },
              "1f93e": {
                "1f3fb": ["1f93e-1f3fb", 43, 19, 15, ["🤾🏻"]],
                "1f3fc": ["1f93e-1f3fc", 43, 20, 15, ["🤾🏼"]],
                "1f3fd": ["1f93e-1f3fd", 43, 21, 15, ["🤾🏽"]],
                "1f3fe": ["1f93e-1f3fe", 43, 22, 15, ["🤾🏾"]],
                "1f3ff": ["1f93e-1f3ff", 43, 23, 15, ["🤾🏿"]],
              },
              "1f977": {
                "1f3fb": ["1f977-1f3fb", 44, 20, 15, ["🥷🏻"]],
                "1f3fc": ["1f977-1f3fc", 44, 21, 15, ["🥷🏼"]],
                "1f3fd": ["1f977-1f3fd", 44, 22, 15, ["🥷🏽"]],
                "1f3fe": ["1f977-1f3fe", 44, 23, 15, ["🥷🏾"]],
                "1f3ff": ["1f977-1f3ff", 44, 24, 15, ["🥷🏿"]],
              },
              "1f9b5": {
                "1f3fb": ["1f9b5-1f3fb", 45, 22, 15, ["🦵🏻"]],
                "1f3fc": ["1f9b5-1f3fc", 45, 23, 15, ["🦵🏼"]],
                "1f3fd": ["1f9b5-1f3fd", 45, 24, 15, ["🦵🏽"]],
                "1f3fe": ["1f9b5-1f3fe", 45, 25, 15, ["🦵🏾"]],
                "1f3ff": ["1f9b5-1f3ff", 45, 26, 15, ["🦵🏿"]],
              },
              "1f9b6": {
                "1f3fb": ["1f9b6-1f3fb", 45, 28, 15, ["🦶🏻"]],
                "1f3fc": ["1f9b6-1f3fc", 45, 29, 15, ["🦶🏼"]],
                "1f3fd": ["1f9b6-1f3fd", 45, 30, 15, ["🦶🏽"]],
                "1f3fe": ["1f9b6-1f3fe", 45, 31, 15, ["🦶🏾"]],
                "1f3ff": ["1f9b6-1f3ff", 45, 32, 15, ["🦶🏿"]],
              },
              "1f9b8-200d-2640-fe0f": {
                "1f3fb": ["1f9b8-1f3fb-200d-2640-fe0f", 45, 35, 15, ["🦸🏻‍♀️"]],
                "1f3fc": ["1f9b8-1f3fc-200d-2640-fe0f", 45, 36, 15, ["🦸🏼‍♀️"]],
                "1f3fd": ["1f9b8-1f3fd-200d-2640-fe0f", 45, 37, 15, ["🦸🏽‍♀️"]],
                "1f3fe": ["1f9b8-1f3fe-200d-2640-fe0f", 45, 38, 15, ["🦸🏾‍♀️"]],
                "1f3ff": ["1f9b8-1f3ff-200d-2640-fe0f", 45, 39, 15, ["🦸🏿‍♀️"]],
              },
              "1f9b8-200d-2642-fe0f": {
                "1f3fb": ["1f9b8-1f3fb-200d-2642-fe0f", 45, 41, 15, ["🦸🏻‍♂️"]],
                "1f3fc": ["1f9b8-1f3fc-200d-2642-fe0f", 45, 42, 15, ["🦸🏼‍♂️"]],
                "1f3fd": ["1f9b8-1f3fd-200d-2642-fe0f", 45, 43, 15, ["🦸🏽‍♂️"]],
                "1f3fe": ["1f9b8-1f3fe-200d-2642-fe0f", 45, 44, 15, ["🦸🏾‍♂️"]],
                "1f3ff": ["1f9b8-1f3ff-200d-2642-fe0f", 45, 45, 15, ["🦸🏿‍♂️"]],
              },
              "1f9b8": {
                "1f3fb": ["1f9b8-1f3fb", 45, 47, 15, ["🦸🏻"]],
                "1f3fc": ["1f9b8-1f3fc", 45, 48, 15, ["🦸🏼"]],
                "1f3fd": ["1f9b8-1f3fd", 45, 49, 15, ["🦸🏽"]],
                "1f3fe": ["1f9b8-1f3fe", 45, 50, 15, ["🦸🏾"]],
                "1f3ff": ["1f9b8-1f3ff", 45, 51, 15, ["🦸🏿"]],
              },
              "1f9b9-200d-2640-fe0f": {
                "1f3fb": ["1f9b9-1f3fb-200d-2640-fe0f", 45, 53, 15, ["🦹🏻‍♀️"]],
                "1f3fc": ["1f9b9-1f3fc-200d-2640-fe0f", 45, 54, 15, ["🦹🏼‍♀️"]],
                "1f3fd": ["1f9b9-1f3fd-200d-2640-fe0f", 45, 55, 15, ["🦹🏽‍♀️"]],
                "1f3fe": ["1f9b9-1f3fe-200d-2640-fe0f", 45, 56, 15, ["🦹🏾‍♀️"]],
                "1f3ff": ["1f9b9-1f3ff-200d-2640-fe0f", 45, 57, 15, ["🦹🏿‍♀️"]],
              },
              "1f9b9-200d-2642-fe0f": {
                "1f3fb": ["1f9b9-1f3fb-200d-2642-fe0f", 45, 59, 15, ["🦹🏻‍♂️"]],
                "1f3fc": ["1f9b9-1f3fc-200d-2642-fe0f", 46, 0, 15, ["🦹🏼‍♂️"]],
                "1f3fd": ["1f9b9-1f3fd-200d-2642-fe0f", 46, 1, 15, ["🦹🏽‍♂️"]],
                "1f3fe": ["1f9b9-1f3fe-200d-2642-fe0f", 46, 2, 15, ["🦹🏾‍♂️"]],
                "1f3ff": ["1f9b9-1f3ff-200d-2642-fe0f", 46, 3, 15, ["🦹🏿‍♂️"]],
              },
              "1f9b9": {
                "1f3fb": ["1f9b9-1f3fb", 46, 5, 15, ["🦹🏻"]],
                "1f3fc": ["1f9b9-1f3fc", 46, 6, 15, ["🦹🏼"]],
                "1f3fd": ["1f9b9-1f3fd", 46, 7, 15, ["🦹🏽"]],
                "1f3fe": ["1f9b9-1f3fe", 46, 8, 15, ["🦹🏾"]],
                "1f3ff": ["1f9b9-1f3ff", 46, 9, 15, ["🦹🏿"]],
              },
              "1f9bb": {
                "1f3fb": ["1f9bb-1f3fb", 46, 12, 15, ["🦻🏻"]],
                "1f3fc": ["1f9bb-1f3fc", 46, 13, 15, ["🦻🏼"]],
                "1f3fd": ["1f9bb-1f3fd", 46, 14, 15, ["🦻🏽"]],
                "1f3fe": ["1f9bb-1f3fe", 46, 15, 15, ["🦻🏾"]],
                "1f3ff": ["1f9bb-1f3ff", 46, 16, 15, ["🦻🏿"]],
              },
              "1f9cd-200d-2640-fe0f": {
                "1f3fb": ["1f9cd-1f3fb-200d-2640-fe0f", 46, 34, 15, ["🧍🏻‍♀️"]],
                "1f3fc": ["1f9cd-1f3fc-200d-2640-fe0f", 46, 35, 15, ["🧍🏼‍♀️"]],
                "1f3fd": ["1f9cd-1f3fd-200d-2640-fe0f", 46, 36, 15, ["🧍🏽‍♀️"]],
                "1f3fe": ["1f9cd-1f3fe-200d-2640-fe0f", 46, 37, 15, ["🧍🏾‍♀️"]],
                "1f3ff": ["1f9cd-1f3ff-200d-2640-fe0f", 46, 38, 15, ["🧍🏿‍♀️"]],
              },
              "1f9cd-200d-2642-fe0f": {
                "1f3fb": ["1f9cd-1f3fb-200d-2642-fe0f", 46, 40, 15, ["🧍🏻‍♂️"]],
                "1f3fc": ["1f9cd-1f3fc-200d-2642-fe0f", 46, 41, 15, ["🧍🏼‍♂️"]],
                "1f3fd": ["1f9cd-1f3fd-200d-2642-fe0f", 46, 42, 15, ["🧍🏽‍♂️"]],
                "1f3fe": ["1f9cd-1f3fe-200d-2642-fe0f", 46, 43, 15, ["🧍🏾‍♂️"]],
                "1f3ff": ["1f9cd-1f3ff-200d-2642-fe0f", 46, 44, 15, ["🧍🏿‍♂️"]],
              },
              "1f9cd": {
                "1f3fb": ["1f9cd-1f3fb", 46, 46, 15, ["🧍🏻"]],
                "1f3fc": ["1f9cd-1f3fc", 46, 47, 15, ["🧍🏼"]],
                "1f3fd": ["1f9cd-1f3fd", 46, 48, 15, ["🧍🏽"]],
                "1f3fe": ["1f9cd-1f3fe", 46, 49, 15, ["🧍🏾"]],
                "1f3ff": ["1f9cd-1f3ff", 46, 50, 15, ["🧍🏿"]],
              },
              "1f9ce-200d-2640-fe0f": {
                "1f3fb": ["1f9ce-1f3fb-200d-2640-fe0f", 46, 52, 15, ["🧎🏻‍♀️"]],
                "1f3fc": ["1f9ce-1f3fc-200d-2640-fe0f", 46, 53, 15, ["🧎🏼‍♀️"]],
                "1f3fd": ["1f9ce-1f3fd-200d-2640-fe0f", 46, 54, 15, ["🧎🏽‍♀️"]],
                "1f3fe": ["1f9ce-1f3fe-200d-2640-fe0f", 46, 55, 15, ["🧎🏾‍♀️"]],
                "1f3ff": ["1f9ce-1f3ff-200d-2640-fe0f", 46, 56, 15, ["🧎🏿‍♀️"]],
              },
              "1f9ce-200d-2642-fe0f": {
                "1f3fb": ["1f9ce-1f3fb-200d-2642-fe0f", 46, 58, 15, ["🧎🏻‍♂️"]],
                "1f3fc": ["1f9ce-1f3fc-200d-2642-fe0f", 46, 59, 15, ["🧎🏼‍♂️"]],
                "1f3fd": ["1f9ce-1f3fd-200d-2642-fe0f", 47, 0, 15, ["🧎🏽‍♂️"]],
                "1f3fe": ["1f9ce-1f3fe-200d-2642-fe0f", 47, 1, 15, ["🧎🏾‍♂️"]],
                "1f3ff": ["1f9ce-1f3ff-200d-2642-fe0f", 47, 2, 15, ["🧎🏿‍♂️"]],
              },
              "1f9ce": {
                "1f3fb": ["1f9ce-1f3fb", 47, 4, 15, ["🧎🏻"]],
                "1f3fc": ["1f9ce-1f3fc", 47, 5, 15, ["🧎🏼"]],
                "1f3fd": ["1f9ce-1f3fd", 47, 6, 15, ["🧎🏽"]],
                "1f3fe": ["1f9ce-1f3fe", 47, 7, 15, ["🧎🏾"]],
                "1f3ff": ["1f9ce-1f3ff", 47, 8, 15, ["🧎🏿"]],
              },
              "1f9cf-200d-2640-fe0f": {
                "1f3fb": ["1f9cf-1f3fb-200d-2640-fe0f", 47, 10, 15, ["🧏🏻‍♀️"]],
                "1f3fc": ["1f9cf-1f3fc-200d-2640-fe0f", 47, 11, 15, ["🧏🏼‍♀️"]],
                "1f3fd": ["1f9cf-1f3fd-200d-2640-fe0f", 47, 12, 15, ["🧏🏽‍♀️"]],
                "1f3fe": ["1f9cf-1f3fe-200d-2640-fe0f", 47, 13, 15, ["🧏🏾‍♀️"]],
                "1f3ff": ["1f9cf-1f3ff-200d-2640-fe0f", 47, 14, 15, ["🧏🏿‍♀️"]],
              },
              "1f9cf-200d-2642-fe0f": {
                "1f3fb": ["1f9cf-1f3fb-200d-2642-fe0f", 47, 16, 15, ["🧏🏻‍♂️"]],
                "1f3fc": ["1f9cf-1f3fc-200d-2642-fe0f", 47, 17, 15, ["🧏🏼‍♂️"]],
                "1f3fd": ["1f9cf-1f3fd-200d-2642-fe0f", 47, 18, 15, ["🧏🏽‍♂️"]],
                "1f3fe": ["1f9cf-1f3fe-200d-2642-fe0f", 47, 19, 15, ["🧏🏾‍♂️"]],
                "1f3ff": ["1f9cf-1f3ff-200d-2642-fe0f", 47, 20, 15, ["🧏🏿‍♂️"]],
              },
              "1f9cf": {
                "1f3fb": ["1f9cf-1f3fb", 47, 22, 15, ["🧏🏻"]],
                "1f3fc": ["1f9cf-1f3fc", 47, 23, 15, ["🧏🏼"]],
                "1f3fd": ["1f9cf-1f3fd", 47, 24, 15, ["🧏🏽"]],
                "1f3fe": ["1f9cf-1f3fe", 47, 25, 15, ["🧏🏾"]],
                "1f3ff": ["1f9cf-1f3ff", 47, 26, 15, ["🧏🏿"]],
              },
              "1f9d1-200d-1f33e": {
                "1f3fb": ["1f9d1-1f3fb-200d-1f33e", 47, 29, 15, ["🧑🏻‍🌾"]],
                "1f3fc": ["1f9d1-1f3fc-200d-1f33e", 47, 30, 15, ["🧑🏼‍🌾"]],
                "1f3fd": ["1f9d1-1f3fd-200d-1f33e", 47, 31, 15, ["🧑🏽‍🌾"]],
                "1f3fe": ["1f9d1-1f3fe-200d-1f33e", 47, 32, 15, ["🧑🏾‍🌾"]],
                "1f3ff": ["1f9d1-1f3ff-200d-1f33e", 47, 33, 15, ["🧑🏿‍🌾"]],
              },
              "1f9d1-200d-1f373": {
                "1f3fb": ["1f9d1-1f3fb-200d-1f373", 47, 35, 15, ["🧑🏻‍🍳"]],
                "1f3fc": ["1f9d1-1f3fc-200d-1f373", 47, 36, 15, ["🧑🏼‍🍳"]],
                "1f3fd": ["1f9d1-1f3fd-200d-1f373", 47, 37, 15, ["🧑🏽‍🍳"]],
                "1f3fe": ["1f9d1-1f3fe-200d-1f373", 47, 38, 15, ["🧑🏾‍🍳"]],
                "1f3ff": ["1f9d1-1f3ff-200d-1f373", 47, 39, 15, ["🧑🏿‍🍳"]],
              },
              "1f9d1-200d-1f37c": {
                "1f3fb": ["1f9d1-1f3fb-200d-1f37c", 47, 41, 15, ["🧑🏻‍🍼"]],
                "1f3fc": ["1f9d1-1f3fc-200d-1f37c", 47, 42, 15, ["🧑🏼‍🍼"]],
                "1f3fd": ["1f9d1-1f3fd-200d-1f37c", 47, 43, 15, ["🧑🏽‍🍼"]],
                "1f3fe": ["1f9d1-1f3fe-200d-1f37c", 47, 44, 15, ["🧑🏾‍🍼"]],
                "1f3ff": ["1f9d1-1f3ff-200d-1f37c", 47, 45, 15, ["🧑🏿‍🍼"]],
              },
              "1f9d1-200d-1f384": {
                "1f3fb": ["1f9d1-1f3fb-200d-1f384", 47, 47, 15, ["🧑🏻‍🎄"]],
                "1f3fc": ["1f9d1-1f3fc-200d-1f384", 47, 48, 15, ["🧑🏼‍🎄"]],
                "1f3fd": ["1f9d1-1f3fd-200d-1f384", 47, 49, 15, ["🧑🏽‍🎄"]],
                "1f3fe": ["1f9d1-1f3fe-200d-1f384", 47, 50, 15, ["🧑🏾‍🎄"]],
                "1f3ff": ["1f9d1-1f3ff-200d-1f384", 47, 51, 15, ["🧑🏿‍🎄"]],
              },
              "1f9d1-200d-1f393": {
                "1f3fb": ["1f9d1-1f3fb-200d-1f393", 47, 53, 15, ["🧑🏻‍🎓"]],
                "1f3fc": ["1f9d1-1f3fc-200d-1f393", 47, 54, 15, ["🧑🏼‍🎓"]],
                "1f3fd": ["1f9d1-1f3fd-200d-1f393", 47, 55, 15, ["🧑🏽‍🎓"]],
                "1f3fe": ["1f9d1-1f3fe-200d-1f393", 47, 56, 15, ["🧑🏾‍🎓"]],
                "1f3ff": ["1f9d1-1f3ff-200d-1f393", 47, 57, 15, ["🧑🏿‍🎓"]],
              },
              "1f9d1-200d-1f3a4": {
                "1f3fb": ["1f9d1-1f3fb-200d-1f3a4", 47, 59, 15, ["🧑🏻‍🎤"]],
                "1f3fc": ["1f9d1-1f3fc-200d-1f3a4", 48, 0, 15, ["🧑🏼‍🎤"]],
                "1f3fd": ["1f9d1-1f3fd-200d-1f3a4", 48, 1, 15, ["🧑🏽‍🎤"]],
                "1f3fe": ["1f9d1-1f3fe-200d-1f3a4", 48, 2, 15, ["🧑🏾‍🎤"]],
                "1f3ff": ["1f9d1-1f3ff-200d-1f3a4", 48, 3, 15, ["🧑🏿‍🎤"]],
              },
              "1f9d1-200d-1f3a8": {
                "1f3fb": ["1f9d1-1f3fb-200d-1f3a8", 48, 5, 15, ["🧑🏻‍🎨"]],
                "1f3fc": ["1f9d1-1f3fc-200d-1f3a8", 48, 6, 15, ["🧑🏼‍🎨"]],
                "1f3fd": ["1f9d1-1f3fd-200d-1f3a8", 48, 7, 15, ["🧑🏽‍🎨"]],
                "1f3fe": ["1f9d1-1f3fe-200d-1f3a8", 48, 8, 15, ["🧑🏾‍🎨"]],
                "1f3ff": ["1f9d1-1f3ff-200d-1f3a8", 48, 9, 15, ["🧑🏿‍🎨"]],
              },
              "1f9d1-200d-1f3eb": {
                "1f3fb": ["1f9d1-1f3fb-200d-1f3eb", 48, 11, 15, ["🧑🏻‍🏫"]],
                "1f3fc": ["1f9d1-1f3fc-200d-1f3eb", 48, 12, 15, ["🧑🏼‍🏫"]],
                "1f3fd": ["1f9d1-1f3fd-200d-1f3eb", 48, 13, 15, ["🧑🏽‍🏫"]],
                "1f3fe": ["1f9d1-1f3fe-200d-1f3eb", 48, 14, 15, ["🧑🏾‍🏫"]],
                "1f3ff": ["1f9d1-1f3ff-200d-1f3eb", 48, 15, 15, ["🧑🏿‍🏫"]],
              },
              "1f9d1-200d-1f3ed": {
                "1f3fb": ["1f9d1-1f3fb-200d-1f3ed", 48, 17, 15, ["🧑🏻‍🏭"]],
                "1f3fc": ["1f9d1-1f3fc-200d-1f3ed", 48, 18, 15, ["🧑🏼‍🏭"]],
                "1f3fd": ["1f9d1-1f3fd-200d-1f3ed", 48, 19, 15, ["🧑🏽‍🏭"]],
                "1f3fe": ["1f9d1-1f3fe-200d-1f3ed", 48, 20, 15, ["🧑🏾‍🏭"]],
                "1f3ff": ["1f9d1-1f3ff-200d-1f3ed", 48, 21, 15, ["🧑🏿‍🏭"]],
              },
              "1f9d1-200d-1f4bb": {
                "1f3fb": ["1f9d1-1f3fb-200d-1f4bb", 48, 23, 15, ["🧑🏻‍💻"]],
                "1f3fc": ["1f9d1-1f3fc-200d-1f4bb", 48, 24, 15, ["🧑🏼‍💻"]],
                "1f3fd": ["1f9d1-1f3fd-200d-1f4bb", 48, 25, 15, ["🧑🏽‍💻"]],
                "1f3fe": ["1f9d1-1f3fe-200d-1f4bb", 48, 26, 15, ["🧑🏾‍💻"]],
                "1f3ff": ["1f9d1-1f3ff-200d-1f4bb", 48, 27, 15, ["🧑🏿‍💻"]],
              },
              "1f9d1-200d-1f4bc": {
                "1f3fb": ["1f9d1-1f3fb-200d-1f4bc", 48, 29, 15, ["🧑🏻‍💼"]],
                "1f3fc": ["1f9d1-1f3fc-200d-1f4bc", 48, 30, 15, ["🧑🏼‍💼"]],
                "1f3fd": ["1f9d1-1f3fd-200d-1f4bc", 48, 31, 15, ["🧑🏽‍💼"]],
                "1f3fe": ["1f9d1-1f3fe-200d-1f4bc", 48, 32, 15, ["🧑🏾‍💼"]],
                "1f3ff": ["1f9d1-1f3ff-200d-1f4bc", 48, 33, 15, ["🧑🏿‍💼"]],
              },
              "1f9d1-200d-1f527": {
                "1f3fb": ["1f9d1-1f3fb-200d-1f527", 48, 35, 15, ["🧑🏻‍🔧"]],
                "1f3fc": ["1f9d1-1f3fc-200d-1f527", 48, 36, 15, ["🧑🏼‍🔧"]],
                "1f3fd": ["1f9d1-1f3fd-200d-1f527", 48, 37, 15, ["🧑🏽‍🔧"]],
                "1f3fe": ["1f9d1-1f3fe-200d-1f527", 48, 38, 15, ["🧑🏾‍🔧"]],
                "1f3ff": ["1f9d1-1f3ff-200d-1f527", 48, 39, 15, ["🧑🏿‍🔧"]],
              },
              "1f9d1-200d-1f52c": {
                "1f3fb": ["1f9d1-1f3fb-200d-1f52c", 48, 41, 15, ["🧑🏻‍🔬"]],
                "1f3fc": ["1f9d1-1f3fc-200d-1f52c", 48, 42, 15, ["🧑🏼‍🔬"]],
                "1f3fd": ["1f9d1-1f3fd-200d-1f52c", 48, 43, 15, ["🧑🏽‍🔬"]],
                "1f3fe": ["1f9d1-1f3fe-200d-1f52c", 48, 44, 15, ["🧑🏾‍🔬"]],
                "1f3ff": ["1f9d1-1f3ff-200d-1f52c", 48, 45, 15, ["🧑🏿‍🔬"]],
              },
              "1f9d1-200d-1f680": {
                "1f3fb": ["1f9d1-1f3fb-200d-1f680", 48, 47, 15, ["🧑🏻‍🚀"]],
                "1f3fc": ["1f9d1-1f3fc-200d-1f680", 48, 48, 15, ["🧑🏼‍🚀"]],
                "1f3fd": ["1f9d1-1f3fd-200d-1f680", 48, 49, 15, ["🧑🏽‍🚀"]],
                "1f3fe": ["1f9d1-1f3fe-200d-1f680", 48, 50, 15, ["🧑🏾‍🚀"]],
                "1f3ff": ["1f9d1-1f3ff-200d-1f680", 48, 51, 15, ["🧑🏿‍🚀"]],
              },
              "1f9d1-200d-1f692": {
                "1f3fb": ["1f9d1-1f3fb-200d-1f692", 48, 53, 15, ["🧑🏻‍🚒"]],
                "1f3fc": ["1f9d1-1f3fc-200d-1f692", 48, 54, 15, ["🧑🏼‍🚒"]],
                "1f3fd": ["1f9d1-1f3fd-200d-1f692", 48, 55, 15, ["🧑🏽‍🚒"]],
                "1f3fe": ["1f9d1-1f3fe-200d-1f692", 48, 56, 15, ["🧑🏾‍🚒"]],
                "1f3ff": ["1f9d1-1f3ff-200d-1f692", 48, 57, 15, ["🧑🏿‍🚒"]],
              },
              "1f9d1-200d-1f91d-200d-1f9d1": {
                "1f3fb-1f3fb": [
                  "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb",
                  48,
                  59,
                  15,
                  ["🧑🏻‍🤝‍🧑🏻"],
                ],
                "1f3fb-1f3fc": [
                  "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fc",
                  49,
                  0,
                  7,
                  ["🧑🏻‍🤝‍🧑🏼"],
                ],
                "1f3fb-1f3fd": [
                  "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fd",
                  49,
                  1,
                  7,
                  ["🧑🏻‍🤝‍🧑🏽"],
                ],
                "1f3fb-1f3fe": [
                  "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fe",
                  49,
                  2,
                  7,
                  ["🧑🏻‍🤝‍🧑🏾"],
                ],
                "1f3fb-1f3ff": [
                  "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3ff",
                  49,
                  3,
                  7,
                  ["🧑🏻‍🤝‍🧑🏿"],
                ],
                "1f3fc-1f3fb": [
                  "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fb",
                  49,
                  4,
                  15,
                  ["🧑🏼‍🤝‍🧑🏻"],
                ],
                "1f3fc-1f3fc": [
                  "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc",
                  49,
                  5,
                  15,
                  ["🧑🏼‍🤝‍🧑🏼"],
                ],
                "1f3fc-1f3fd": [
                  "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fd",
                  49,
                  6,
                  7,
                  ["🧑🏼‍🤝‍🧑🏽"],
                ],
                "1f3fc-1f3fe": [
                  "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fe",
                  49,
                  7,
                  7,
                  ["🧑🏼‍🤝‍🧑🏾"],
                ],
                "1f3fc-1f3ff": [
                  "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3ff",
                  49,
                  8,
                  7,
                  ["🧑🏼‍🤝‍🧑🏿"],
                ],
                "1f3fd-1f3fb": [
                  "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fb",
                  49,
                  9,
                  15,
                  ["🧑🏽‍🤝‍🧑🏻"],
                ],
                "1f3fd-1f3fc": [
                  "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fc",
                  49,
                  10,
                  15,
                  ["🧑🏽‍🤝‍🧑🏼"],
                ],
                "1f3fd-1f3fd": [
                  "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd",
                  49,
                  11,
                  15,
                  ["🧑🏽‍🤝‍🧑🏽"],
                ],
                "1f3fd-1f3fe": [
                  "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fe",
                  49,
                  12,
                  7,
                  ["🧑🏽‍🤝‍🧑🏾"],
                ],
                "1f3fd-1f3ff": [
                  "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3ff",
                  49,
                  13,
                  7,
                  ["🧑🏽‍🤝‍🧑🏿"],
                ],
                "1f3fe-1f3fb": [
                  "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fb",
                  49,
                  14,
                  15,
                  ["🧑🏾‍🤝‍🧑🏻"],
                ],
                "1f3fe-1f3fc": [
                  "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fc",
                  49,
                  15,
                  15,
                  ["🧑🏾‍🤝‍🧑🏼"],
                ],
                "1f3fe-1f3fd": [
                  "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fd",
                  49,
                  16,
                  15,
                  ["🧑🏾‍🤝‍🧑🏽"],
                ],
                "1f3fe-1f3fe": [
                  "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe",
                  49,
                  17,
                  15,
                  ["🧑🏾‍🤝‍🧑🏾"],
                ],
                "1f3fe-1f3ff": [
                  "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3ff",
                  49,
                  18,
                  7,
                  ["🧑🏾‍🤝‍🧑🏿"],
                ],
                "1f3ff-1f3fb": [
                  "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fb",
                  49,
                  19,
                  15,
                  ["🧑🏿‍🤝‍🧑🏻"],
                ],
                "1f3ff-1f3fc": [
                  "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fc",
                  49,
                  20,
                  15,
                  ["🧑🏿‍🤝‍🧑🏼"],
                ],
                "1f3ff-1f3fd": [
                  "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fd",
                  49,
                  21,
                  15,
                  ["🧑🏿‍🤝‍🧑🏽"],
                ],
                "1f3ff-1f3fe": [
                  "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fe",
                  49,
                  22,
                  15,
                  ["🧑🏿‍🤝‍🧑🏾"],
                ],
                "1f3ff-1f3ff": [
                  "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff",
                  49,
                  23,
                  15,
                  ["🧑🏿‍🤝‍🧑🏿"],
                ],
              },
              "1f9d1-200d-1f9af": {
                "1f3fb": ["1f9d1-1f3fb-200d-1f9af", 49, 25, 15, ["🧑🏻‍🦯"]],
                "1f3fc": ["1f9d1-1f3fc-200d-1f9af", 49, 26, 15, ["🧑🏼‍🦯"]],
                "1f3fd": ["1f9d1-1f3fd-200d-1f9af", 49, 27, 15, ["🧑🏽‍🦯"]],
                "1f3fe": ["1f9d1-1f3fe-200d-1f9af", 49, 28, 15, ["🧑🏾‍🦯"]],
                "1f3ff": ["1f9d1-1f3ff-200d-1f9af", 49, 29, 15, ["🧑🏿‍🦯"]],
              },
              "1f9d1-200d-1f9b0": {
                "1f3fb": ["1f9d1-1f3fb-200d-1f9b0", 49, 31, 15, ["🧑🏻‍🦰"]],
                "1f3fc": ["1f9d1-1f3fc-200d-1f9b0", 49, 32, 15, ["🧑🏼‍🦰"]],
                "1f3fd": ["1f9d1-1f3fd-200d-1f9b0", 49, 33, 15, ["🧑🏽‍🦰"]],
                "1f3fe": ["1f9d1-1f3fe-200d-1f9b0", 49, 34, 15, ["🧑🏾‍🦰"]],
                "1f3ff": ["1f9d1-1f3ff-200d-1f9b0", 49, 35, 15, ["🧑🏿‍🦰"]],
              },
              "1f9d1-200d-1f9b1": {
                "1f3fb": ["1f9d1-1f3fb-200d-1f9b1", 49, 37, 15, ["🧑🏻‍🦱"]],
                "1f3fc": ["1f9d1-1f3fc-200d-1f9b1", 49, 38, 15, ["🧑🏼‍🦱"]],
                "1f3fd": ["1f9d1-1f3fd-200d-1f9b1", 49, 39, 15, ["🧑🏽‍🦱"]],
                "1f3fe": ["1f9d1-1f3fe-200d-1f9b1", 49, 40, 15, ["🧑🏾‍🦱"]],
                "1f3ff": ["1f9d1-1f3ff-200d-1f9b1", 49, 41, 15, ["🧑🏿‍🦱"]],
              },
              "1f9d1-200d-1f9b2": {
                "1f3fb": ["1f9d1-1f3fb-200d-1f9b2", 49, 43, 7, ["🧑🏻‍🦲"]],
                "1f3fc": ["1f9d1-1f3fc-200d-1f9b2", 49, 44, 7, ["🧑🏼‍🦲"]],
                "1f3fd": ["1f9d1-1f3fd-200d-1f9b2", 49, 45, 7, ["🧑🏽‍🦲"]],
                "1f3fe": ["1f9d1-1f3fe-200d-1f9b2", 49, 46, 7, ["🧑🏾‍🦲"]],
                "1f3ff": ["1f9d1-1f3ff-200d-1f9b2", 49, 47, 7, ["🧑🏿‍🦲"]],
              },
              "1f9d1-200d-1f9b3": {
                "1f3fb": ["1f9d1-1f3fb-200d-1f9b3", 49, 49, 7, ["🧑🏻‍🦳"]],
                "1f3fc": ["1f9d1-1f3fc-200d-1f9b3", 49, 50, 7, ["🧑🏼‍🦳"]],
                "1f3fd": ["1f9d1-1f3fd-200d-1f9b3", 49, 51, 7, ["🧑🏽‍🦳"]],
                "1f3fe": ["1f9d1-1f3fe-200d-1f9b3", 49, 52, 7, ["🧑🏾‍🦳"]],
                "1f3ff": ["1f9d1-1f3ff-200d-1f9b3", 49, 53, 7, ["🧑🏿‍🦳"]],
              },
              "1f9d1-200d-1f9bc": {
                "1f3fb": ["1f9d1-1f3fb-200d-1f9bc", 49, 55, 15, ["🧑🏻‍🦼"]],
                "1f3fc": ["1f9d1-1f3fc-200d-1f9bc", 49, 56, 15, ["🧑🏼‍🦼"]],
                "1f3fd": ["1f9d1-1f3fd-200d-1f9bc", 49, 57, 15, ["🧑🏽‍🦼"]],
                "1f3fe": ["1f9d1-1f3fe-200d-1f9bc", 49, 58, 15, ["🧑🏾‍🦼"]],
                "1f3ff": ["1f9d1-1f3ff-200d-1f9bc", 49, 59, 15, ["🧑🏿‍🦼"]],
              },
              "1f9d1-200d-1f9bd": {
                "1f3fb": ["1f9d1-1f3fb-200d-1f9bd", 50, 1, 15, ["🧑🏻‍🦽"]],
                "1f3fc": ["1f9d1-1f3fc-200d-1f9bd", 50, 2, 15, ["🧑🏼‍🦽"]],
                "1f3fd": ["1f9d1-1f3fd-200d-1f9bd", 50, 3, 15, ["🧑🏽‍🦽"]],
                "1f3fe": ["1f9d1-1f3fe-200d-1f9bd", 50, 4, 15, ["🧑🏾‍🦽"]],
                "1f3ff": ["1f9d1-1f3ff-200d-1f9bd", 50, 5, 15, ["🧑🏿‍🦽"]],
              },
              "1f9d1-200d-2695-fe0f": {
                "1f3fb": ["1f9d1-1f3fb-200d-2695-fe0f", 50, 7, 15, ["🧑🏻‍⚕️"]],
                "1f3fc": ["1f9d1-1f3fc-200d-2695-fe0f", 50, 8, 15, ["🧑🏼‍⚕️"]],
                "1f3fd": ["1f9d1-1f3fd-200d-2695-fe0f", 50, 9, 15, ["🧑🏽‍⚕️"]],
                "1f3fe": ["1f9d1-1f3fe-200d-2695-fe0f", 50, 10, 15, ["🧑🏾‍⚕️"]],
                "1f3ff": ["1f9d1-1f3ff-200d-2695-fe0f", 50, 11, 15, ["🧑🏿‍⚕️"]],
              },
              "1f9d1-200d-2696-fe0f": {
                "1f3fb": ["1f9d1-1f3fb-200d-2696-fe0f", 50, 13, 15, ["🧑🏻‍⚖️"]],
                "1f3fc": ["1f9d1-1f3fc-200d-2696-fe0f", 50, 14, 15, ["🧑🏼‍⚖️"]],
                "1f3fd": ["1f9d1-1f3fd-200d-2696-fe0f", 50, 15, 15, ["🧑🏽‍⚖️"]],
                "1f3fe": ["1f9d1-1f3fe-200d-2696-fe0f", 50, 16, 15, ["🧑🏾‍⚖️"]],
                "1f3ff": ["1f9d1-1f3ff-200d-2696-fe0f", 50, 17, 15, ["🧑🏿‍⚖️"]],
              },
              "1f9d1-200d-2708-fe0f": {
                "1f3fb": ["1f9d1-1f3fb-200d-2708-fe0f", 50, 19, 15, ["🧑🏻‍✈️"]],
                "1f3fc": ["1f9d1-1f3fc-200d-2708-fe0f", 50, 20, 15, ["🧑🏼‍✈️"]],
                "1f3fd": ["1f9d1-1f3fd-200d-2708-fe0f", 50, 21, 15, ["🧑🏽‍✈️"]],
                "1f3fe": ["1f9d1-1f3fe-200d-2708-fe0f", 50, 22, 15, ["🧑🏾‍✈️"]],
                "1f3ff": ["1f9d1-1f3ff-200d-2708-fe0f", 50, 23, 15, ["🧑🏿‍✈️"]],
              },
              "1f9d1": {
                "1f3fb": ["1f9d1-1f3fb", 50, 25, 15, ["🧑🏻"]],
                "1f3fc": ["1f9d1-1f3fc", 50, 26, 15, ["🧑🏼"]],
                "1f3fd": ["1f9d1-1f3fd", 50, 27, 15, ["🧑🏽"]],
                "1f3fe": ["1f9d1-1f3fe", 50, 28, 15, ["🧑🏾"]],
                "1f3ff": ["1f9d1-1f3ff", 50, 29, 15, ["🧑🏿"]],
              },
              "1f9d2": {
                "1f3fb": ["1f9d2-1f3fb", 50, 31, 15, ["🧒🏻"]],
                "1f3fc": ["1f9d2-1f3fc", 50, 32, 15, ["🧒🏼"]],
                "1f3fd": ["1f9d2-1f3fd", 50, 33, 15, ["🧒🏽"]],
                "1f3fe": ["1f9d2-1f3fe", 50, 34, 15, ["🧒🏾"]],
                "1f3ff": ["1f9d2-1f3ff", 50, 35, 15, ["🧒🏿"]],
              },
              "1f9d3": {
                "1f3fb": ["1f9d3-1f3fb", 50, 37, 15, ["🧓🏻"]],
                "1f3fc": ["1f9d3-1f3fc", 50, 38, 15, ["🧓🏼"]],
                "1f3fd": ["1f9d3-1f3fd", 50, 39, 15, ["🧓🏽"]],
                "1f3fe": ["1f9d3-1f3fe", 50, 40, 15, ["🧓🏾"]],
                "1f3ff": ["1f9d3-1f3ff", 50, 41, 15, ["🧓🏿"]],
              },
              "1f9d4-200d-2640-fe0f": {
                "1f3fb": ["1f9d4-1f3fb-200d-2640-fe0f", 50, 43, 7, ["🧔🏻‍♀️"]],
                "1f3fc": ["1f9d4-1f3fc-200d-2640-fe0f", 50, 44, 7, ["🧔🏼‍♀️"]],
                "1f3fd": ["1f9d4-1f3fd-200d-2640-fe0f", 50, 45, 7, ["🧔🏽‍♀️"]],
                "1f3fe": ["1f9d4-1f3fe-200d-2640-fe0f", 50, 46, 7, ["🧔🏾‍♀️"]],
                "1f3ff": ["1f9d4-1f3ff-200d-2640-fe0f", 50, 47, 7, ["🧔🏿‍♀️"]],
              },
              "1f9d4-200d-2642-fe0f": {
                "1f3fb": ["1f9d4-1f3fb-200d-2642-fe0f", 50, 49, 7, ["🧔🏻‍♂️"]],
                "1f3fc": ["1f9d4-1f3fc-200d-2642-fe0f", 50, 50, 7, ["🧔🏼‍♂️"]],
                "1f3fd": ["1f9d4-1f3fd-200d-2642-fe0f", 50, 51, 7, ["🧔🏽‍♂️"]],
                "1f3fe": ["1f9d4-1f3fe-200d-2642-fe0f", 50, 52, 7, ["🧔🏾‍♂️"]],
                "1f3ff": ["1f9d4-1f3ff-200d-2642-fe0f", 50, 53, 7, ["🧔🏿‍♂️"]],
              },
              "1f9d4": {
                "1f3fb": ["1f9d4-1f3fb", 50, 55, 15, ["🧔🏻"]],
                "1f3fc": ["1f9d4-1f3fc", 50, 56, 15, ["🧔🏼"]],
                "1f3fd": ["1f9d4-1f3fd", 50, 57, 15, ["🧔🏽"]],
                "1f3fe": ["1f9d4-1f3fe", 50, 58, 15, ["🧔🏾"]],
                "1f3ff": ["1f9d4-1f3ff", 50, 59, 15, ["🧔🏿"]],
              },
              "1f9d5": {
                "1f3fb": ["1f9d5-1f3fb", 51, 1, 15, ["🧕🏻"]],
                "1f3fc": ["1f9d5-1f3fc", 51, 2, 15, ["🧕🏼"]],
                "1f3fd": ["1f9d5-1f3fd", 51, 3, 15, ["🧕🏽"]],
                "1f3fe": ["1f9d5-1f3fe", 51, 4, 15, ["🧕🏾"]],
                "1f3ff": ["1f9d5-1f3ff", 51, 5, 15, ["🧕🏿"]],
              },
              "1f9d6-200d-2640-fe0f": {
                "1f3fb": ["1f9d6-1f3fb-200d-2640-fe0f", 51, 7, 15, ["🧖🏻‍♀️"]],
                "1f3fc": ["1f9d6-1f3fc-200d-2640-fe0f", 51, 8, 15, ["🧖🏼‍♀️"]],
                "1f3fd": ["1f9d6-1f3fd-200d-2640-fe0f", 51, 9, 15, ["🧖🏽‍♀️"]],
                "1f3fe": ["1f9d6-1f3fe-200d-2640-fe0f", 51, 10, 15, ["🧖🏾‍♀️"]],
                "1f3ff": ["1f9d6-1f3ff-200d-2640-fe0f", 51, 11, 15, ["🧖🏿‍♀️"]],
              },
              "1f9d6-200d-2642-fe0f": {
                "1f3fb": [
                  "1f9d6-1f3fb-200d-2642-fe0f",
                  51,
                  13,
                  15,
                  ["🧖🏻‍♂️", "🧖🏻"],
                ],
                "1f3fc": [
                  "1f9d6-1f3fc-200d-2642-fe0f",
                  51,
                  14,
                  15,
                  ["🧖🏼‍♂️", "🧖🏼"],
                ],
                "1f3fd": [
                  "1f9d6-1f3fd-200d-2642-fe0f",
                  51,
                  15,
                  15,
                  ["🧖🏽‍♂️", "🧖🏽"],
                ],
                "1f3fe": [
                  "1f9d6-1f3fe-200d-2642-fe0f",
                  51,
                  16,
                  15,
                  ["🧖🏾‍♂️", "🧖🏾"],
                ],
                "1f3ff": [
                  "1f9d6-1f3ff-200d-2642-fe0f",
                  51,
                  17,
                  15,
                  ["🧖🏿‍♂️", "🧖🏿"],
                ],
              },
              "1f9d7-200d-2640-fe0f": {
                "1f3fb": [
                  "1f9d7-1f3fb-200d-2640-fe0f",
                  51,
                  25,
                  15,
                  ["🧗🏻‍♀️", "🧗🏻"],
                ],
                "1f3fc": [
                  "1f9d7-1f3fc-200d-2640-fe0f",
                  51,
                  26,
                  15,
                  ["🧗🏼‍♀️", "🧗🏼"],
                ],
                "1f3fd": [
                  "1f9d7-1f3fd-200d-2640-fe0f",
                  51,
                  27,
                  15,
                  ["🧗🏽‍♀️", "🧗🏽"],
                ],
                "1f3fe": [
                  "1f9d7-1f3fe-200d-2640-fe0f",
                  51,
                  28,
                  15,
                  ["🧗🏾‍♀️", "🧗🏾"],
                ],
                "1f3ff": [
                  "1f9d7-1f3ff-200d-2640-fe0f",
                  51,
                  29,
                  15,
                  ["🧗🏿‍♀️", "🧗🏿"],
                ],
              },
              "1f9d7-200d-2642-fe0f": {
                "1f3fb": ["1f9d7-1f3fb-200d-2642-fe0f", 51, 31, 15, ["🧗🏻‍♂️"]],
                "1f3fc": ["1f9d7-1f3fc-200d-2642-fe0f", 51, 32, 15, ["🧗🏼‍♂️"]],
                "1f3fd": ["1f9d7-1f3fd-200d-2642-fe0f", 51, 33, 15, ["🧗🏽‍♂️"]],
                "1f3fe": ["1f9d7-1f3fe-200d-2642-fe0f", 51, 34, 15, ["🧗🏾‍♂️"]],
                "1f3ff": ["1f9d7-1f3ff-200d-2642-fe0f", 51, 35, 15, ["🧗🏿‍♂️"]],
              },
              "1f9d8-200d-2640-fe0f": {
                "1f3fb": [
                  "1f9d8-1f3fb-200d-2640-fe0f",
                  51,
                  43,
                  15,
                  ["🧘🏻‍♀️", "🧘🏻"],
                ],
                "1f3fc": [
                  "1f9d8-1f3fc-200d-2640-fe0f",
                  51,
                  44,
                  15,
                  ["🧘🏼‍♀️", "🧘🏼"],
                ],
                "1f3fd": [
                  "1f9d8-1f3fd-200d-2640-fe0f",
                  51,
                  45,
                  15,
                  ["🧘🏽‍♀️", "🧘🏽"],
                ],
                "1f3fe": [
                  "1f9d8-1f3fe-200d-2640-fe0f",
                  51,
                  46,
                  15,
                  ["🧘🏾‍♀️", "🧘🏾"],
                ],
                "1f3ff": [
                  "1f9d8-1f3ff-200d-2640-fe0f",
                  51,
                  47,
                  15,
                  ["🧘🏿‍♀️", "🧘🏿"],
                ],
              },
              "1f9d8-200d-2642-fe0f": {
                "1f3fb": ["1f9d8-1f3fb-200d-2642-fe0f", 51, 49, 15, ["🧘🏻‍♂️"]],
                "1f3fc": ["1f9d8-1f3fc-200d-2642-fe0f", 51, 50, 15, ["🧘🏼‍♂️"]],
                "1f3fd": ["1f9d8-1f3fd-200d-2642-fe0f", 51, 51, 15, ["🧘🏽‍♂️"]],
                "1f3fe": ["1f9d8-1f3fe-200d-2642-fe0f", 51, 52, 15, ["🧘🏾‍♂️"]],
                "1f3ff": ["1f9d8-1f3ff-200d-2642-fe0f", 51, 53, 15, ["🧘🏿‍♂️"]],
              },
              "1f9d9-200d-2640-fe0f": {
                "1f3fb": [
                  "1f9d9-1f3fb-200d-2640-fe0f",
                  52,
                  1,
                  15,
                  ["🧙🏻‍♀️", "🧙🏻"],
                ],
                "1f3fc": [
                  "1f9d9-1f3fc-200d-2640-fe0f",
                  52,
                  2,
                  15,
                  ["🧙🏼‍♀️", "🧙🏼"],
                ],
                "1f3fd": [
                  "1f9d9-1f3fd-200d-2640-fe0f",
                  52,
                  3,
                  15,
                  ["🧙🏽‍♀️", "🧙🏽"],
                ],
                "1f3fe": [
                  "1f9d9-1f3fe-200d-2640-fe0f",
                  52,
                  4,
                  15,
                  ["🧙🏾‍♀️", "🧙🏾"],
                ],
                "1f3ff": [
                  "1f9d9-1f3ff-200d-2640-fe0f",
                  52,
                  5,
                  15,
                  ["🧙🏿‍♀️", "🧙🏿"],
                ],
              },
              "1f9d9-200d-2642-fe0f": {
                "1f3fb": ["1f9d9-1f3fb-200d-2642-fe0f", 52, 7, 15, ["🧙🏻‍♂️"]],
                "1f3fc": ["1f9d9-1f3fc-200d-2642-fe0f", 52, 8, 15, ["🧙🏼‍♂️"]],
                "1f3fd": ["1f9d9-1f3fd-200d-2642-fe0f", 52, 9, 15, ["🧙🏽‍♂️"]],
                "1f3fe": ["1f9d9-1f3fe-200d-2642-fe0f", 52, 10, 15, ["🧙🏾‍♂️"]],
                "1f3ff": ["1f9d9-1f3ff-200d-2642-fe0f", 52, 11, 15, ["🧙🏿‍♂️"]],
              },
              "1f9da-200d-2640-fe0f": {
                "1f3fb": [
                  "1f9da-1f3fb-200d-2640-fe0f",
                  52,
                  19,
                  15,
                  ["🧚🏻‍♀️", "🧚🏻"],
                ],
                "1f3fc": [
                  "1f9da-1f3fc-200d-2640-fe0f",
                  52,
                  20,
                  15,
                  ["🧚🏼‍♀️", "🧚🏼"],
                ],
                "1f3fd": [
                  "1f9da-1f3fd-200d-2640-fe0f",
                  52,
                  21,
                  15,
                  ["🧚🏽‍♀️", "🧚🏽"],
                ],
                "1f3fe": [
                  "1f9da-1f3fe-200d-2640-fe0f",
                  52,
                  22,
                  15,
                  ["🧚🏾‍♀️", "🧚🏾"],
                ],
                "1f3ff": [
                  "1f9da-1f3ff-200d-2640-fe0f",
                  52,
                  23,
                  15,
                  ["🧚🏿‍♀️", "🧚🏿"],
                ],
              },
              "1f9da-200d-2642-fe0f": {
                "1f3fb": ["1f9da-1f3fb-200d-2642-fe0f", 52, 25, 15, ["🧚🏻‍♂️"]],
                "1f3fc": ["1f9da-1f3fc-200d-2642-fe0f", 52, 26, 15, ["🧚🏼‍♂️"]],
                "1f3fd": ["1f9da-1f3fd-200d-2642-fe0f", 52, 27, 15, ["🧚🏽‍♂️"]],
                "1f3fe": ["1f9da-1f3fe-200d-2642-fe0f", 52, 28, 15, ["🧚🏾‍♂️"]],
                "1f3ff": ["1f9da-1f3ff-200d-2642-fe0f", 52, 29, 15, ["🧚🏿‍♂️"]],
              },
              "1f9db-200d-2640-fe0f": {
                "1f3fb": [
                  "1f9db-1f3fb-200d-2640-fe0f",
                  52,
                  37,
                  15,
                  ["🧛🏻‍♀️", "🧛🏻"],
                ],
                "1f3fc": [
                  "1f9db-1f3fc-200d-2640-fe0f",
                  52,
                  38,
                  15,
                  ["🧛🏼‍♀️", "🧛🏼"],
                ],
                "1f3fd": [
                  "1f9db-1f3fd-200d-2640-fe0f",
                  52,
                  39,
                  15,
                  ["🧛🏽‍♀️", "🧛🏽"],
                ],
                "1f3fe": [
                  "1f9db-1f3fe-200d-2640-fe0f",
                  52,
                  40,
                  15,
                  ["🧛🏾‍♀️", "🧛🏾"],
                ],
                "1f3ff": [
                  "1f9db-1f3ff-200d-2640-fe0f",
                  52,
                  41,
                  15,
                  ["🧛🏿‍♀️", "🧛🏿"],
                ],
              },
              "1f9db-200d-2642-fe0f": {
                "1f3fb": ["1f9db-1f3fb-200d-2642-fe0f", 52, 43, 15, ["🧛🏻‍♂️"]],
                "1f3fc": ["1f9db-1f3fc-200d-2642-fe0f", 52, 44, 15, ["🧛🏼‍♂️"]],
                "1f3fd": ["1f9db-1f3fd-200d-2642-fe0f", 52, 45, 15, ["🧛🏽‍♂️"]],
                "1f3fe": ["1f9db-1f3fe-200d-2642-fe0f", 52, 46, 15, ["🧛🏾‍♂️"]],
                "1f3ff": ["1f9db-1f3ff-200d-2642-fe0f", 52, 47, 15, ["🧛🏿‍♂️"]],
              },
              "1f9dc-200d-2640-fe0f": {
                "1f3fb": ["1f9dc-1f3fb-200d-2640-fe0f", 52, 55, 15, ["🧜🏻‍♀️"]],
                "1f3fc": ["1f9dc-1f3fc-200d-2640-fe0f", 52, 56, 15, ["🧜🏼‍♀️"]],
                "1f3fd": ["1f9dc-1f3fd-200d-2640-fe0f", 52, 57, 15, ["🧜🏽‍♀️"]],
                "1f3fe": ["1f9dc-1f3fe-200d-2640-fe0f", 52, 58, 15, ["🧜🏾‍♀️"]],
                "1f3ff": ["1f9dc-1f3ff-200d-2640-fe0f", 52, 59, 15, ["🧜🏿‍♀️"]],
              },
              "1f9dc-200d-2642-fe0f": {
                "1f3fb": [
                  "1f9dc-1f3fb-200d-2642-fe0f",
                  53,
                  1,
                  15,
                  ["🧜🏻‍♂️", "🧜🏻"],
                ],
                "1f3fc": [
                  "1f9dc-1f3fc-200d-2642-fe0f",
                  53,
                  2,
                  15,
                  ["🧜🏼‍♂️", "🧜🏼"],
                ],
                "1f3fd": [
                  "1f9dc-1f3fd-200d-2642-fe0f",
                  53,
                  3,
                  15,
                  ["🧜🏽‍♂️", "🧜🏽"],
                ],
                "1f3fe": [
                  "1f9dc-1f3fe-200d-2642-fe0f",
                  53,
                  4,
                  15,
                  ["🧜🏾‍♂️", "🧜🏾"],
                ],
                "1f3ff": [
                  "1f9dc-1f3ff-200d-2642-fe0f",
                  53,
                  5,
                  15,
                  ["🧜🏿‍♂️", "🧜🏿"],
                ],
              },
              "1f9dd-200d-2640-fe0f": {
                "1f3fb": ["1f9dd-1f3fb-200d-2640-fe0f", 53, 13, 15, ["🧝🏻‍♀️"]],
                "1f3fc": ["1f9dd-1f3fc-200d-2640-fe0f", 53, 14, 15, ["🧝🏼‍♀️"]],
                "1f3fd": ["1f9dd-1f3fd-200d-2640-fe0f", 53, 15, 15, ["🧝🏽‍♀️"]],
                "1f3fe": ["1f9dd-1f3fe-200d-2640-fe0f", 53, 16, 15, ["🧝🏾‍♀️"]],
                "1f3ff": ["1f9dd-1f3ff-200d-2640-fe0f", 53, 17, 15, ["🧝🏿‍♀️"]],
              },
              "1f9dd-200d-2642-fe0f": {
                "1f3fb": [
                  "1f9dd-1f3fb-200d-2642-fe0f",
                  53,
                  19,
                  15,
                  ["🧝🏻‍♂️", "🧝🏻"],
                ],
                "1f3fc": [
                  "1f9dd-1f3fc-200d-2642-fe0f",
                  53,
                  20,
                  15,
                  ["🧝🏼‍♂️", "🧝🏼"],
                ],
                "1f3fd": [
                  "1f9dd-1f3fd-200d-2642-fe0f",
                  53,
                  21,
                  15,
                  ["🧝🏽‍♂️", "🧝🏽"],
                ],
                "1f3fe": [
                  "1f9dd-1f3fe-200d-2642-fe0f",
                  53,
                  22,
                  15,
                  ["🧝🏾‍♂️", "🧝🏾"],
                ],
                "1f3ff": [
                  "1f9dd-1f3ff-200d-2642-fe0f",
                  53,
                  23,
                  15,
                  ["🧝🏿‍♂️", "🧝🏿"],
                ],
              },
              "261d-fe0f": {
                "1f3fb": ["261d-1f3fb", 55, 55, 15, ["☝🏻"]],
                "1f3fc": ["261d-1f3fc", 55, 56, 15, ["☝🏼"]],
                "1f3fd": ["261d-1f3fd", 55, 57, 15, ["☝🏽"]],
                "1f3fe": ["261d-1f3fe", 55, 58, 15, ["☝🏾"]],
                "1f3ff": ["261d-1f3ff", 55, 59, 15, ["☝🏿"]],
              },
              "26f9-fe0f-200d-2640-fe0f": {
                "1f3fb": ["26f9-1f3fb-200d-2640-fe0f", 57, 10, 15, ["⛹🏻‍♀️"]],
                "1f3fc": ["26f9-1f3fc-200d-2640-fe0f", 57, 11, 15, ["⛹🏼‍♀️"]],
                "1f3fd": ["26f9-1f3fd-200d-2640-fe0f", 57, 12, 15, ["⛹🏽‍♀️"]],
                "1f3fe": ["26f9-1f3fe-200d-2640-fe0f", 57, 13, 15, ["⛹🏾‍♀️"]],
                "1f3ff": ["26f9-1f3ff-200d-2640-fe0f", 57, 14, 15, ["⛹🏿‍♀️"]],
              },
              "26f9-fe0f-200d-2642-fe0f": {
                "1f3fb": [
                  "26f9-1f3fb-200d-2642-fe0f",
                  57,
                  16,
                  15,
                  ["⛹🏻‍♂️", "⛹🏻"],
                ],
                "1f3fc": [
                  "26f9-1f3fc-200d-2642-fe0f",
                  57,
                  17,
                  15,
                  ["⛹🏼‍♂️", "⛹🏼"],
                ],
                "1f3fd": [
                  "26f9-1f3fd-200d-2642-fe0f",
                  57,
                  18,
                  15,
                  ["⛹🏽‍♂️", "⛹🏽"],
                ],
                "1f3fe": [
                  "26f9-1f3fe-200d-2642-fe0f",
                  57,
                  19,
                  15,
                  ["⛹🏾‍♂️", "⛹🏾"],
                ],
                "1f3ff": [
                  "26f9-1f3ff-200d-2642-fe0f",
                  57,
                  20,
                  15,
                  ["⛹🏿‍♂️", "⛹🏿"],
                ],
              },
              "270a": {
                "1f3fb": ["270a-1f3fb", 57, 34, 15, ["✊🏻"]],
                "1f3fc": ["270a-1f3fc", 57, 35, 15, ["✊🏼"]],
                "1f3fd": ["270a-1f3fd", 57, 36, 15, ["✊🏽"]],
                "1f3fe": ["270a-1f3fe", 57, 37, 15, ["✊🏾"]],
                "1f3ff": ["270a-1f3ff", 57, 38, 15, ["✊🏿"]],
              },
              "270b": {
                "1f3fb": ["270b-1f3fb", 57, 40, 15, ["✋🏻"]],
                "1f3fc": ["270b-1f3fc", 57, 41, 15, ["✋🏼"]],
                "1f3fd": ["270b-1f3fd", 57, 42, 15, ["✋🏽"]],
                "1f3fe": ["270b-1f3fe", 57, 43, 15, ["✋🏾"]],
                "1f3ff": ["270b-1f3ff", 57, 44, 15, ["✋🏿"]],
              },
              "270c-fe0f": {
                "1f3fb": ["270c-1f3fb", 57, 46, 15, ["✌🏻"]],
                "1f3fc": ["270c-1f3fc", 57, 47, 15, ["✌🏼"]],
                "1f3fd": ["270c-1f3fd", 57, 48, 15, ["✌🏽"]],
                "1f3fe": ["270c-1f3fe", 57, 49, 15, ["✌🏾"]],
                "1f3ff": ["270c-1f3ff", 57, 50, 15, ["✌🏿"]],
              },
              "270d-fe0f": {
                "1f3fb": ["270d-1f3fb", 57, 52, 15, ["✍🏻"]],
                "1f3fc": ["270d-1f3fc", 57, 53, 15, ["✍🏼"]],
                "1f3fd": ["270d-1f3fd", 57, 54, 15, ["✍🏽"]],
                "1f3fe": ["270d-1f3fe", 57, 55, 15, ["✍🏾"]],
                "1f3ff": ["270d-1f3ff", 57, 56, 15, ["✍🏿"]],
              },
            }),
            (r.prototype.obsoletes_data = {
              "1f3c3-200d-2642-fe0f": ["1f3c3", 8, 34, 15],
              "1f3c3-1f3fb-200d-2642-fe0f": ["1f3c3-1f3fb", 8, 35, 15],
              "1f3c3-1f3fc-200d-2642-fe0f": ["1f3c3-1f3fc", 8, 36, 15],
              "1f3c3-1f3fd-200d-2642-fe0f": ["1f3c3-1f3fd", 8, 37, 15],
              "1f3c3-1f3fe-200d-2642-fe0f": ["1f3c3-1f3fe", 8, 38, 15],
              "1f3c3-1f3ff-200d-2642-fe0f": ["1f3c3-1f3ff", 8, 39, 15],
              "1f3c4-200d-2642-fe0f": ["1f3c4", 8, 52, 15],
              "1f3c4-1f3fb-200d-2642-fe0f": ["1f3c4-1f3fb", 8, 53, 15],
              "1f3c4-1f3fc-200d-2642-fe0f": ["1f3c4-1f3fc", 8, 54, 15],
              "1f3c4-1f3fd-200d-2642-fe0f": ["1f3c4-1f3fd", 8, 55, 15],
              "1f3c4-1f3fe-200d-2642-fe0f": ["1f3c4-1f3fe", 8, 56, 15],
              "1f3c4-1f3ff-200d-2642-fe0f": ["1f3c4-1f3ff", 8, 57, 15],
              "1f3ca-200d-2642-fe0f": ["1f3ca", 9, 20, 15],
              "1f3ca-1f3fb-200d-2642-fe0f": ["1f3ca-1f3fb", 9, 21, 15],
              "1f3ca-1f3fc-200d-2642-fe0f": ["1f3ca-1f3fc", 9, 22, 15],
              "1f3ca-1f3fd-200d-2642-fe0f": ["1f3ca-1f3fd", 9, 23, 15],
              "1f3ca-1f3fe-200d-2642-fe0f": ["1f3ca-1f3fe", 9, 24, 15],
              "1f3ca-1f3ff-200d-2642-fe0f": ["1f3ca-1f3ff", 9, 25, 15],
              "1f3cb-fe0f-200d-2642-fe0f": ["1f3cb-fe0f", 9, 38, 15],
              "1f3cb-1f3fb-200d-2642-fe0f": ["1f3cb-1f3fb", 9, 39, 15],
              "1f3cb-1f3fc-200d-2642-fe0f": ["1f3cb-1f3fc", 9, 40, 15],
              "1f3cb-1f3fd-200d-2642-fe0f": ["1f3cb-1f3fd", 9, 41, 15],
              "1f3cb-1f3fe-200d-2642-fe0f": ["1f3cb-1f3fe", 9, 42, 15],
              "1f3cb-1f3ff-200d-2642-fe0f": ["1f3cb-1f3ff", 9, 43, 15],
              "1f3cc-fe0f-200d-2642-fe0f": ["1f3cc-fe0f", 9, 56, 15],
              "1f3cc-1f3fb-200d-2642-fe0f": ["1f3cc-1f3fb", 9, 57, 15],
              "1f3cc-1f3fc-200d-2642-fe0f": ["1f3cc-1f3fc", 9, 58, 15],
              "1f3cc-1f3fd-200d-2642-fe0f": ["1f3cc-1f3fd", 9, 59, 15],
              "1f3cc-1f3fe-200d-2642-fe0f": ["1f3cc-1f3fe", 10, 0, 15],
              "1f3cc-1f3ff-200d-2642-fe0f": ["1f3cc-1f3ff", 10, 1, 15],
              "1f468-200d-1f469-200d-1f466": ["1f46a", 22, 0, 15],
              "1f46e-200d-2642-fe0f": ["1f46e", 23, 31, 15],
              "1f46e-1f3fb-200d-2642-fe0f": ["1f46e-1f3fb", 23, 32, 15],
              "1f46e-1f3fc-200d-2642-fe0f": ["1f46e-1f3fc", 23, 33, 15],
              "1f46e-1f3fd-200d-2642-fe0f": ["1f46e-1f3fd", 23, 34, 15],
              "1f46e-1f3fe-200d-2642-fe0f": ["1f46e-1f3fe", 23, 35, 15],
              "1f46e-1f3ff-200d-2642-fe0f": ["1f46e-1f3ff", 23, 36, 15],
              "1f46f-200d-2640-fe0f": ["1f46f", 23, 39, 15],
              "1f471-200d-2642-fe0f": ["1f471", 24, 10, 15],
              "1f471-1f3fb-200d-2642-fe0f": ["1f471-1f3fb", 24, 11, 15],
              "1f471-1f3fc-200d-2642-fe0f": ["1f471-1f3fc", 24, 12, 15],
              "1f471-1f3fd-200d-2642-fe0f": ["1f471-1f3fd", 24, 13, 15],
              "1f471-1f3fe-200d-2642-fe0f": ["1f471-1f3fe", 24, 14, 15],
              "1f471-1f3ff-200d-2642-fe0f": ["1f471-1f3ff", 24, 15, 15],
              "1f473-200d-2642-fe0f": ["1f473", 24, 34, 15],
              "1f473-1f3fb-200d-2642-fe0f": ["1f473-1f3fb", 24, 35, 15],
              "1f473-1f3fc-200d-2642-fe0f": ["1f473-1f3fc", 24, 36, 15],
              "1f473-1f3fd-200d-2642-fe0f": ["1f473-1f3fd", 24, 37, 15],
              "1f473-1f3fe-200d-2642-fe0f": ["1f473-1f3fe", 24, 38, 15],
              "1f473-1f3ff-200d-2642-fe0f": ["1f473-1f3ff", 24, 39, 15],
              "1f477-200d-2642-fe0f": ["1f477", 25, 10, 15],
              "1f477-1f3fb-200d-2642-fe0f": ["1f477-1f3fb", 25, 11, 15],
              "1f477-1f3fc-200d-2642-fe0f": ["1f477-1f3fc", 25, 12, 15],
              "1f477-1f3fd-200d-2642-fe0f": ["1f477-1f3fd", 25, 13, 15],
              "1f477-1f3fe-200d-2642-fe0f": ["1f477-1f3fe", 25, 14, 15],
              "1f477-1f3ff-200d-2642-fe0f": ["1f477-1f3ff", 25, 15, 15],
              "1f481-200d-2640-fe0f": ["1f481", 25, 47, 15],
              "1f481-1f3fb-200d-2640-fe0f": ["1f481-1f3fb", 25, 48, 15],
              "1f481-1f3fc-200d-2640-fe0f": ["1f481-1f3fc", 25, 49, 15],
              "1f481-1f3fd-200d-2640-fe0f": ["1f481-1f3fd", 25, 50, 15],
              "1f481-1f3fe-200d-2640-fe0f": ["1f481-1f3fe", 25, 51, 15],
              "1f481-1f3ff-200d-2640-fe0f": ["1f481-1f3ff", 25, 52, 15],
              "1f482-200d-2642-fe0f": ["1f482", 26, 5, 15],
              "1f482-1f3fb-200d-2642-fe0f": ["1f482-1f3fb", 26, 6, 15],
              "1f482-1f3fc-200d-2642-fe0f": ["1f482-1f3fc", 26, 7, 15],
              "1f482-1f3fd-200d-2642-fe0f": ["1f482-1f3fd", 26, 8, 15],
              "1f482-1f3fe-200d-2642-fe0f": ["1f482-1f3fe", 26, 9, 15],
              "1f482-1f3ff-200d-2642-fe0f": ["1f482-1f3ff", 26, 10, 15],
              "1f486-200d-2640-fe0f": ["1f486", 26, 36, 15],
              "1f486-1f3fb-200d-2640-fe0f": ["1f486-1f3fb", 26, 37, 15],
              "1f486-1f3fc-200d-2640-fe0f": ["1f486-1f3fc", 26, 38, 15],
              "1f486-1f3fd-200d-2640-fe0f": ["1f486-1f3fd", 26, 39, 15],
              "1f486-1f3fe-200d-2640-fe0f": ["1f486-1f3fe", 26, 40, 15],
              "1f486-1f3ff-200d-2640-fe0f": ["1f486-1f3ff", 26, 41, 15],
              "1f487-200d-2640-fe0f": ["1f487", 26, 54, 15],
              "1f487-1f3fb-200d-2640-fe0f": ["1f487-1f3fb", 26, 55, 15],
              "1f487-1f3fc-200d-2640-fe0f": ["1f487-1f3fc", 26, 56, 15],
              "1f487-1f3fd-200d-2640-fe0f": ["1f487-1f3fd", 26, 57, 15],
              "1f487-1f3fe-200d-2640-fe0f": ["1f487-1f3fe", 26, 58, 15],
              "1f487-1f3ff-200d-2640-fe0f": ["1f487-1f3ff", 26, 59, 15],
              "1f575-fe0f-200d-2642-fe0f": ["1f575-fe0f", 31, 47, 15],
              "1f575-1f3fb-200d-2642-fe0f": ["1f575-1f3fb", 31, 48, 15],
              "1f575-1f3fc-200d-2642-fe0f": ["1f575-1f3fc", 31, 49, 15],
              "1f575-1f3fd-200d-2642-fe0f": ["1f575-1f3fd", 31, 50, 15],
              "1f575-1f3fe-200d-2642-fe0f": ["1f575-1f3fe", 31, 51, 15],
              "1f575-1f3ff-200d-2642-fe0f": ["1f575-1f3ff", 31, 52, 15],
              "1f645-200d-2640-fe0f": ["1f645", 34, 16, 15],
              "1f645-1f3fb-200d-2640-fe0f": ["1f645-1f3fb", 34, 17, 15],
              "1f645-1f3fc-200d-2640-fe0f": ["1f645-1f3fc", 34, 18, 15],
              "1f645-1f3fd-200d-2640-fe0f": ["1f645-1f3fd", 34, 19, 15],
              "1f645-1f3fe-200d-2640-fe0f": ["1f645-1f3fe", 34, 20, 15],
              "1f645-1f3ff-200d-2640-fe0f": ["1f645-1f3ff", 34, 21, 15],
              "1f646-200d-2640-fe0f": ["1f646", 34, 34, 15],
              "1f646-1f3fb-200d-2640-fe0f": ["1f646-1f3fb", 34, 35, 15],
              "1f646-1f3fc-200d-2640-fe0f": ["1f646-1f3fc", 34, 36, 15],
              "1f646-1f3fd-200d-2640-fe0f": ["1f646-1f3fd", 34, 37, 15],
              "1f646-1f3fe-200d-2640-fe0f": ["1f646-1f3fe", 34, 38, 15],
              "1f646-1f3ff-200d-2640-fe0f": ["1f646-1f3ff", 34, 39, 15],
              "1f647-200d-2642-fe0f": ["1f647", 34, 52, 15],
              "1f647-1f3fb-200d-2642-fe0f": ["1f647-1f3fb", 34, 53, 15],
              "1f647-1f3fc-200d-2642-fe0f": ["1f647-1f3fc", 34, 54, 15],
              "1f647-1f3fd-200d-2642-fe0f": ["1f647-1f3fd", 34, 55, 15],
              "1f647-1f3fe-200d-2642-fe0f": ["1f647-1f3fe", 34, 56, 15],
              "1f647-1f3ff-200d-2642-fe0f": ["1f647-1f3ff", 34, 57, 15],
              "1f64b-200d-2640-fe0f": ["1f64b", 35, 13, 15],
              "1f64b-1f3fb-200d-2640-fe0f": ["1f64b-1f3fb", 35, 14, 15],
              "1f64b-1f3fc-200d-2640-fe0f": ["1f64b-1f3fc", 35, 15, 15],
              "1f64b-1f3fd-200d-2640-fe0f": ["1f64b-1f3fd", 35, 16, 15],
              "1f64b-1f3fe-200d-2640-fe0f": ["1f64b-1f3fe", 35, 17, 15],
              "1f64b-1f3ff-200d-2640-fe0f": ["1f64b-1f3ff", 35, 18, 15],
              "1f64d-200d-2640-fe0f": ["1f64d", 35, 37, 15],
              "1f64d-1f3fb-200d-2640-fe0f": ["1f64d-1f3fb", 35, 38, 15],
              "1f64d-1f3fc-200d-2640-fe0f": ["1f64d-1f3fc", 35, 39, 15],
              "1f64d-1f3fd-200d-2640-fe0f": ["1f64d-1f3fd", 35, 40, 15],
              "1f64d-1f3fe-200d-2640-fe0f": ["1f64d-1f3fe", 35, 41, 15],
              "1f64d-1f3ff-200d-2640-fe0f": ["1f64d-1f3ff", 35, 42, 15],
              "1f64e-200d-2640-fe0f": ["1f64e", 35, 55, 15],
              "1f64e-1f3fb-200d-2640-fe0f": ["1f64e-1f3fb", 35, 56, 15],
              "1f64e-1f3fc-200d-2640-fe0f": ["1f64e-1f3fc", 35, 57, 15],
              "1f64e-1f3fd-200d-2640-fe0f": ["1f64e-1f3fd", 35, 58, 15],
              "1f64e-1f3fe-200d-2640-fe0f": ["1f64e-1f3fe", 35, 59, 15],
              "1f64e-1f3ff-200d-2640-fe0f": ["1f64e-1f3ff", 36, 0, 15],
              "1f6a3-200d-2642-fe0f": ["1f6a3", 36, 54, 15],
              "1f6a3-1f3fb-200d-2642-fe0f": ["1f6a3-1f3fb", 36, 55, 15],
              "1f6a3-1f3fc-200d-2642-fe0f": ["1f6a3-1f3fc", 36, 56, 15],
              "1f6a3-1f3fd-200d-2642-fe0f": ["1f6a3-1f3fd", 36, 57, 15],
              "1f6a3-1f3fe-200d-2642-fe0f": ["1f6a3-1f3fe", 36, 58, 15],
              "1f6a3-1f3ff-200d-2642-fe0f": ["1f6a3-1f3ff", 36, 59, 15],
              "1f6b4-200d-2642-fe0f": ["1f6b4", 37, 28, 15],
              "1f6b4-1f3fb-200d-2642-fe0f": ["1f6b4-1f3fb", 37, 29, 15],
              "1f6b4-1f3fc-200d-2642-fe0f": ["1f6b4-1f3fc", 37, 30, 15],
              "1f6b4-1f3fd-200d-2642-fe0f": ["1f6b4-1f3fd", 37, 31, 15],
              "1f6b4-1f3fe-200d-2642-fe0f": ["1f6b4-1f3fe", 37, 32, 15],
              "1f6b4-1f3ff-200d-2642-fe0f": ["1f6b4-1f3ff", 37, 33, 15],
              "1f6b5-200d-2642-fe0f": ["1f6b5", 37, 46, 15],
              "1f6b5-1f3fb-200d-2642-fe0f": ["1f6b5-1f3fb", 37, 47, 15],
              "1f6b5-1f3fc-200d-2642-fe0f": ["1f6b5-1f3fc", 37, 48, 15],
              "1f6b5-1f3fd-200d-2642-fe0f": ["1f6b5-1f3fd", 37, 49, 15],
              "1f6b5-1f3fe-200d-2642-fe0f": ["1f6b5-1f3fe", 37, 50, 15],
              "1f6b5-1f3ff-200d-2642-fe0f": ["1f6b5-1f3ff", 37, 51, 15],
              "1f6b6-200d-2642-fe0f": ["1f6b6", 38, 4, 15],
              "1f6b6-1f3fb-200d-2642-fe0f": ["1f6b6-1f3fb", 38, 5, 15],
              "1f6b6-1f3fc-200d-2642-fe0f": ["1f6b6-1f3fc", 38, 6, 15],
              "1f6b6-1f3fd-200d-2642-fe0f": ["1f6b6-1f3fd", 38, 7, 15],
              "1f6b6-1f3fe-200d-2642-fe0f": ["1f6b6-1f3fe", 38, 8, 15],
              "1f6b6-1f3ff-200d-2642-fe0f": ["1f6b6-1f3ff", 38, 9, 15],
              "1f9d6-200d-2642-fe0f": ["1f9d6", 51, 18, 15],
              "1f9d6-1f3fb-200d-2642-fe0f": ["1f9d6-1f3fb", 51, 19, 15],
              "1f9d6-1f3fc-200d-2642-fe0f": ["1f9d6-1f3fc", 51, 20, 15],
              "1f9d6-1f3fd-200d-2642-fe0f": ["1f9d6-1f3fd", 51, 21, 15],
              "1f9d6-1f3fe-200d-2642-fe0f": ["1f9d6-1f3fe", 51, 22, 15],
              "1f9d6-1f3ff-200d-2642-fe0f": ["1f9d6-1f3ff", 51, 23, 15],
              "1f9d7-200d-2640-fe0f": ["1f9d7", 51, 36, 15],
              "1f9d7-1f3fb-200d-2640-fe0f": ["1f9d7-1f3fb", 51, 37, 15],
              "1f9d7-1f3fc-200d-2640-fe0f": ["1f9d7-1f3fc", 51, 38, 15],
              "1f9d7-1f3fd-200d-2640-fe0f": ["1f9d7-1f3fd", 51, 39, 15],
              "1f9d7-1f3fe-200d-2640-fe0f": ["1f9d7-1f3fe", 51, 40, 15],
              "1f9d7-1f3ff-200d-2640-fe0f": ["1f9d7-1f3ff", 51, 41, 15],
              "1f9d8-200d-2640-fe0f": ["1f9d8", 51, 54, 15],
              "1f9d8-1f3fb-200d-2640-fe0f": ["1f9d8-1f3fb", 51, 55, 15],
              "1f9d8-1f3fc-200d-2640-fe0f": ["1f9d8-1f3fc", 51, 56, 15],
              "1f9d8-1f3fd-200d-2640-fe0f": ["1f9d8-1f3fd", 51, 57, 15],
              "1f9d8-1f3fe-200d-2640-fe0f": ["1f9d8-1f3fe", 51, 58, 15],
              "1f9d8-1f3ff-200d-2640-fe0f": ["1f9d8-1f3ff", 51, 59, 15],
              "1f9d9-200d-2640-fe0f": ["1f9d9", 52, 12, 15],
              "1f9d9-1f3fb-200d-2640-fe0f": ["1f9d9-1f3fb", 52, 13, 15],
              "1f9d9-1f3fc-200d-2640-fe0f": ["1f9d9-1f3fc", 52, 14, 15],
              "1f9d9-1f3fd-200d-2640-fe0f": ["1f9d9-1f3fd", 52, 15, 15],
              "1f9d9-1f3fe-200d-2640-fe0f": ["1f9d9-1f3fe", 52, 16, 15],
              "1f9d9-1f3ff-200d-2640-fe0f": ["1f9d9-1f3ff", 52, 17, 15],
              "1f9da-200d-2640-fe0f": ["1f9da", 52, 30, 15],
              "1f9da-1f3fb-200d-2640-fe0f": ["1f9da-1f3fb", 52, 31, 15],
              "1f9da-1f3fc-200d-2640-fe0f": ["1f9da-1f3fc", 52, 32, 15],
              "1f9da-1f3fd-200d-2640-fe0f": ["1f9da-1f3fd", 52, 33, 15],
              "1f9da-1f3fe-200d-2640-fe0f": ["1f9da-1f3fe", 52, 34, 15],
              "1f9da-1f3ff-200d-2640-fe0f": ["1f9da-1f3ff", 52, 35, 15],
              "1f9db-200d-2640-fe0f": ["1f9db", 52, 48, 15],
              "1f9db-1f3fb-200d-2640-fe0f": ["1f9db-1f3fb", 52, 49, 15],
              "1f9db-1f3fc-200d-2640-fe0f": ["1f9db-1f3fc", 52, 50, 15],
              "1f9db-1f3fd-200d-2640-fe0f": ["1f9db-1f3fd", 52, 51, 15],
              "1f9db-1f3fe-200d-2640-fe0f": ["1f9db-1f3fe", 52, 52, 15],
              "1f9db-1f3ff-200d-2640-fe0f": ["1f9db-1f3ff", 52, 53, 15],
              "1f9dc-200d-2642-fe0f": ["1f9dc", 53, 6, 15],
              "1f9dc-1f3fb-200d-2642-fe0f": ["1f9dc-1f3fb", 53, 7, 15],
              "1f9dc-1f3fc-200d-2642-fe0f": ["1f9dc-1f3fc", 53, 8, 15],
              "1f9dc-1f3fd-200d-2642-fe0f": ["1f9dc-1f3fd", 53, 9, 15],
              "1f9dc-1f3fe-200d-2642-fe0f": ["1f9dc-1f3fe", 53, 10, 15],
              "1f9dc-1f3ff-200d-2642-fe0f": ["1f9dc-1f3ff", 53, 11, 15],
              "1f9dd-200d-2642-fe0f": ["1f9dd", 53, 24, 15],
              "1f9dd-1f3fb-200d-2642-fe0f": ["1f9dd-1f3fb", 53, 25, 15],
              "1f9dd-1f3fc-200d-2642-fe0f": ["1f9dd-1f3fc", 53, 26, 15],
              "1f9dd-1f3fd-200d-2642-fe0f": ["1f9dd-1f3fd", 53, 27, 15],
              "1f9dd-1f3fe-200d-2642-fe0f": ["1f9dd-1f3fe", 53, 28, 15],
              "1f9dd-1f3ff-200d-2642-fe0f": ["1f9dd-1f3ff", 53, 29, 15],
              "1f9de-200d-2642-fe0f": ["1f9de", 53, 32, 15],
              "1f9df-200d-2642-fe0f": ["1f9df", 53, 35, 15],
              "26f9-fe0f-200d-2642-fe0f": ["26f9-fe0f", 57, 21, 15],
              "26f9-1f3fb-200d-2642-fe0f": ["26f9-1f3fb", 57, 22, 15],
              "26f9-1f3fc-200d-2642-fe0f": ["26f9-1f3fc", 57, 23, 15],
              "26f9-1f3fd-200d-2642-fe0f": ["26f9-1f3fd", 57, 24, 15],
              "26f9-1f3fe-200d-2642-fe0f": ["26f9-1f3fe", 57, 25, 15],
              "26f9-1f3ff-200d-2642-fe0f": ["26f9-1f3ff", 57, 26, 15],
            }),
            f.exports && (e = f.exports = r),
            (e.EmojiConvertor = r);
        }).call(
          (function () {
            return this || ("undefined" !== typeof window ? window : t);
          })()
        );
      }).call(this, t("c8ba"));
    },
    edfa: function (f, e) {
      function t(f) {
        var e = -1,
          t = Array(f.size);
        return (
          f.forEach(function (f, n) {
            t[++e] = [n, f];
          }),
          t
        );
      }
      f.exports = t;
    },
    ef45: function (f) {
      f.exports = JSON.parse(
        '{"writeMsg":"輸入訊息...","here2help":"我能夠幫助您","send":"發送","edit":"編輯","cancel":"取消","rating":"評分","submit":"遞交","back":"返回"}'
      );
    },
    efb6: function (f, e, t) {
      var n = t("5e2e");
      function r() {
        (this.__data__ = new n()), (this.size = 0);
      }
      f.exports = r;
    },
    f069: function (f, e, t) {
      "use strict";
      var n = t("59ed"),
        r = function (f) {
          var e, t;
          (this.promise = new f(function (f, n) {
            if (void 0 !== e || void 0 !== t)
              throw TypeError("Bad Promise constructor");
            (e = f), (t = n);
          })),
            (this.resolve = n(e)),
            (this.reject = n(t));
        };
      f.exports.f = function (f) {
        return new r(f);
      };
    },
    f0bd: function (f, e, t) {
      "use strict";
      (function (f) {
        /**!
         * @fileOverview Kickass library to create and place poppers near their reference elements.
         * @version 1.16.1
         * @license
         * Copyright (c) 2016 Federico Zivolo and contributors
         *
         * Permission is hereby granted, free of charge, to any person obtaining a copy
         * of this software and associated documentation files (the "Software"), to deal
         * in the Software without restriction, including without limitation the rights
         * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
         * copies of the Software, and to permit persons to whom the Software is
         * furnished to do so, subject to the following conditions:
         *
         * The above copyright notice and this permission notice shall be included in all
         * copies or substantial portions of the Software.
         *
         * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
         * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
         * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
         * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
         * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
         * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
         * SOFTWARE.
         */
        var t =
            "undefined" !== typeof window &&
            "undefined" !== typeof document &&
            "undefined" !== typeof navigator,
          n = (function () {
            for (
              var f = ["Edge", "Trident", "Firefox"], e = 0;
              e < f.length;
              e += 1
            )
              if (t && navigator.userAgent.indexOf(f[e]) >= 0) return 1;
            return 0;
          })();
        function r(f) {
          var e = !1;
          return function () {
            e ||
              ((e = !0),
              window.Promise.resolve().then(function () {
                (e = !1), f();
              }));
          };
        }
        function o(f) {
          var e = !1;
          return function () {
            e ||
              ((e = !0),
              setTimeout(function () {
                (e = !1), f();
              }, n));
          };
        }
        var a = t && window.Promise,
          i = a ? r : o;
        function s(f) {
          var e = {};
          return f && "[object Function]" === e.toString.call(f);
        }
        function d(f, e) {
          if (1 !== f.nodeType) return [];
          var t = f.ownerDocument.defaultView,
            n = t.getComputedStyle(f, null);
          return e ? n[e] : n;
        }
        function c(f) {
          return "HTML" === f.nodeName ? f : f.parentNode || f.host;
        }
        function l(f) {
          if (!f) return document.body;
          switch (f.nodeName) {
            case "HTML":
            case "BODY":
              return f.ownerDocument.body;
            case "#document":
              return f.body;
          }
          var e = d(f),
            t = e.overflow,
            n = e.overflowX,
            r = e.overflowY;
          return /(auto|scroll|overlay)/.test(t + r + n) ? f : l(c(f));
        }
        function u(f) {
          return f && f.referenceNode ? f.referenceNode : f;
        }
        var p = t && !(!window.MSInputMethodContext || !document.documentMode),
          b = t && /MSIE 10/.test(navigator.userAgent);
        function h(f) {
          return 11 === f ? p : 10 === f ? b : p || b;
        }
        function g(f) {
          if (!f) return document.documentElement;
          var e = h(10) ? document.body : null,
            t = f.offsetParent || null;
          while (t === e && f.nextElementSibling)
            t = (f = f.nextElementSibling).offsetParent;
          var n = t && t.nodeName;
          return n && "BODY" !== n && "HTML" !== n
            ? -1 !== ["TH", "TD", "TABLE"].indexOf(t.nodeName) &&
              "static" === d(t, "position")
              ? g(t)
              : t
            : f
            ? f.ownerDocument.documentElement
            : document.documentElement;
        }
        function m(f) {
          var e = f.nodeName;
          return "BODY" !== e && ("HTML" === e || g(f.firstElementChild) === f);
        }
        function v(f) {
          return null !== f.parentNode ? v(f.parentNode) : f;
        }
        function y(f, e) {
          if (!f || !f.nodeType || !e || !e.nodeType)
            return document.documentElement;
          var t =
              f.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_FOLLOWING,
            n = t ? f : e,
            r = t ? e : f,
            o = document.createRange();
          o.setStart(n, 0), o.setEnd(r, 0);
          var a = o.commonAncestorContainer;
          if ((f !== a && e !== a) || n.contains(r)) return m(a) ? a : g(a);
          var i = v(f);
          return i.host ? y(i.host, e) : y(f, v(e).host);
        }
        function w(f) {
          var e =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : "top",
            t = "top" === e ? "scrollTop" : "scrollLeft",
            n = f.nodeName;
          if ("BODY" === n || "HTML" === n) {
            var r = f.ownerDocument.documentElement,
              o = f.ownerDocument.scrollingElement || r;
            return o[t];
          }
          return f[t];
        }
        function x(f, e) {
          var t =
              arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
            n = w(e, "top"),
            r = w(e, "left"),
            o = t ? -1 : 1;
          return (
            (f.top += n * o),
            (f.bottom += n * o),
            (f.left += r * o),
            (f.right += r * o),
            f
          );
        }
        function _(f, e) {
          var t = "x" === e ? "Left" : "Top",
            n = "Left" === t ? "Right" : "Bottom";
          return (
            parseFloat(f["border" + t + "Width"]) +
            parseFloat(f["border" + n + "Width"])
          );
        }
        function k(f, e, t, n) {
          return Math.max(
            e["offset" + f],
            e["scroll" + f],
            t["client" + f],
            t["offset" + f],
            t["scroll" + f],
            h(10)
              ? parseInt(t["offset" + f]) +
                  parseInt(n["margin" + ("Height" === f ? "Top" : "Left")]) +
                  parseInt(n["margin" + ("Height" === f ? "Bottom" : "Right")])
              : 0
          );
        }
        function M(f) {
          var e = f.body,
            t = f.documentElement,
            n = h(10) && getComputedStyle(t);
          return { height: k("Height", e, t, n), width: k("Width", e, t, n) };
        }
        var C = function (f, e) {
            if (!(f instanceof e))
              throw new TypeError("Cannot call a class as a function");
          },
          A = (function () {
            function f(f, e) {
              for (var t = 0; t < e.length; t++) {
                var n = e[t];
                (n.enumerable = n.enumerable || !1),
                  (n.configurable = !0),
                  "value" in n && (n.writable = !0),
                  Object.defineProperty(f, n.key, n);
              }
            }
            return function (e, t, n) {
              return t && f(e.prototype, t), n && f(e, n), e;
            };
          })(),
          j = function (f, e, t) {
            return (
              e in f
                ? Object.defineProperty(f, e, {
                    value: t,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (f[e] = t),
              f
            );
          },
          I =
            Object.assign ||
            function (f) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var n in t)
                  Object.prototype.hasOwnProperty.call(t, n) && (f[n] = t[n]);
              }
              return f;
            };
        function T(f) {
          return I({}, f, {
            right: f.left + f.width,
            bottom: f.top + f.height,
          });
        }
        function S(f) {
          var e = {};
          try {
            if (h(10)) {
              e = f.getBoundingClientRect();
              var t = w(f, "top"),
                n = w(f, "left");
              (e.top += t), (e.left += n), (e.bottom += t), (e.right += n);
            } else e = f.getBoundingClientRect();
          } catch (u) {}
          var r = {
              left: e.left,
              top: e.top,
              width: e.right - e.left,
              height: e.bottom - e.top,
            },
            o = "HTML" === f.nodeName ? M(f.ownerDocument) : {},
            a = o.width || f.clientWidth || r.width,
            i = o.height || f.clientHeight || r.height,
            s = f.offsetWidth - a,
            c = f.offsetHeight - i;
          if (s || c) {
            var l = d(f);
            (s -= _(l, "x")), (c -= _(l, "y")), (r.width -= s), (r.height -= c);
          }
          return T(r);
        }
        function O(f, e) {
          var t =
              arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
            n = h(10),
            r = "HTML" === e.nodeName,
            o = S(f),
            a = S(e),
            i = l(f),
            s = d(e),
            c = parseFloat(s.borderTopWidth),
            u = parseFloat(s.borderLeftWidth);
          t &&
            r &&
            ((a.top = Math.max(a.top, 0)), (a.left = Math.max(a.left, 0)));
          var p = T({
            top: o.top - a.top - c,
            left: o.left - a.left - u,
            width: o.width,
            height: o.height,
          });
          if (((p.marginTop = 0), (p.marginLeft = 0), !n && r)) {
            var b = parseFloat(s.marginTop),
              g = parseFloat(s.marginLeft);
            (p.top -= c - b),
              (p.bottom -= c - b),
              (p.left -= u - g),
              (p.right -= u - g),
              (p.marginTop = b),
              (p.marginLeft = g);
          }
          return (
            (n && !t ? e.contains(i) : e === i && "BODY" !== i.nodeName) &&
              (p = x(p, e)),
            p
          );
        }
        function E(f) {
          var e =
              arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
            t = f.ownerDocument.documentElement,
            n = O(f, t),
            r = Math.max(t.clientWidth, window.innerWidth || 0),
            o = Math.max(t.clientHeight, window.innerHeight || 0),
            a = e ? 0 : w(t),
            i = e ? 0 : w(t, "left"),
            s = {
              top: a - n.top + n.marginTop,
              left: i - n.left + n.marginLeft,
              width: r,
              height: o,
            };
          return T(s);
        }
        function L(f) {
          var e = f.nodeName;
          if ("BODY" === e || "HTML" === e) return !1;
          if ("fixed" === d(f, "position")) return !0;
          var t = c(f);
          return !!t && L(t);
        }
        function N(f) {
          if (!f || !f.parentElement || h()) return document.documentElement;
          var e = f.parentElement;
          while (e && "none" === d(e, "transform")) e = e.parentElement;
          return e || document.documentElement;
        }
        function z(f, e, t, n) {
          var r =
              arguments.length > 4 && void 0 !== arguments[4] && arguments[4],
            o = { top: 0, left: 0 },
            a = r ? N(f) : y(f, u(e));
          if ("viewport" === n) o = E(a, r);
          else {
            var i = void 0;
            "scrollParent" === n
              ? ((i = l(c(e))),
                "BODY" === i.nodeName && (i = f.ownerDocument.documentElement))
              : (i = "window" === n ? f.ownerDocument.documentElement : n);
            var s = O(i, a, r);
            if ("HTML" !== i.nodeName || L(a)) o = s;
            else {
              var d = M(f.ownerDocument),
                p = d.height,
                b = d.width;
              (o.top += s.top - s.marginTop),
                (o.bottom = p + s.top),
                (o.left += s.left - s.marginLeft),
                (o.right = b + s.left);
            }
          }
          t = t || 0;
          var h = "number" === typeof t;
          return (
            (o.left += h ? t : t.left || 0),
            (o.top += h ? t : t.top || 0),
            (o.right -= h ? t : t.right || 0),
            (o.bottom -= h ? t : t.bottom || 0),
            o
          );
        }
        function P(f) {
          var e = f.width,
            t = f.height;
          return e * t;
        }
        function D(f, e, t, n, r) {
          var o =
            arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0;
          if (-1 === f.indexOf("auto")) return f;
          var a = z(t, n, o, r),
            i = {
              top: { width: a.width, height: e.top - a.top },
              right: { width: a.right - e.right, height: a.height },
              bottom: { width: a.width, height: a.bottom - e.bottom },
              left: { width: e.left - a.left, height: a.height },
            },
            s = Object.keys(i)
              .map(function (f) {
                return I({ key: f }, i[f], { area: P(i[f]) });
              })
              .sort(function (f, e) {
                return e.area - f.area;
              }),
            d = s.filter(function (f) {
              var e = f.width,
                n = f.height;
              return e >= t.clientWidth && n >= t.clientHeight;
            }),
            c = d.length > 0 ? d[0].key : s[0].key,
            l = f.split("-")[1];
          return c + (l ? "-" + l : "");
        }
        function B(f, e, t) {
          var n =
              arguments.length > 3 && void 0 !== arguments[3]
                ? arguments[3]
                : null,
            r = n ? N(e) : y(e, u(t));
          return O(t, r, n);
        }
        function R(f) {
          var e = f.ownerDocument.defaultView,
            t = e.getComputedStyle(f),
            n = parseFloat(t.marginTop || 0) + parseFloat(t.marginBottom || 0),
            r = parseFloat(t.marginLeft || 0) + parseFloat(t.marginRight || 0),
            o = { width: f.offsetWidth + r, height: f.offsetHeight + n };
          return o;
        }
        function U(f) {
          var e = {
            left: "right",
            right: "left",
            bottom: "top",
            top: "bottom",
          };
          return f.replace(/left|right|bottom|top/g, function (f) {
            return e[f];
          });
        }
        function F(f, e, t) {
          t = t.split("-")[0];
          var n = R(f),
            r = { width: n.width, height: n.height },
            o = -1 !== ["right", "left"].indexOf(t),
            a = o ? "top" : "left",
            i = o ? "left" : "top",
            s = o ? "height" : "width",
            d = o ? "width" : "height";
          return (
            (r[a] = e[a] + e[s] / 2 - n[s] / 2),
            (r[i] = t === i ? e[i] - n[d] : e[U(i)]),
            r
          );
        }
        function G(f, e) {
          return Array.prototype.find ? f.find(e) : f.filter(e)[0];
        }
        function H(f, e, t) {
          if (Array.prototype.findIndex)
            return f.findIndex(function (f) {
              return f[e] === t;
            });
          var n = G(f, function (f) {
            return f[e] === t;
          });
          return f.indexOf(n);
        }
        function Z(f, e, t) {
          var n = void 0 === t ? f : f.slice(0, H(f, "name", t));
          return (
            n.forEach(function (f) {
              f["function"] &&
                console.warn(
                  "`modifier.function` is deprecated, use `modifier.fn`!"
                );
              var t = f["function"] || f.fn;
              f.enabled &&
                s(t) &&
                ((e.offsets.popper = T(e.offsets.popper)),
                (e.offsets.reference = T(e.offsets.reference)),
                (e = t(e, f)));
            }),
            e
          );
        }
        function q() {
          if (!this.state.isDestroyed) {
            var f = {
              instance: this,
              styles: {},
              arrowStyles: {},
              attributes: {},
              flipped: !1,
              offsets: {},
            };
            (f.offsets.reference = B(
              this.state,
              this.popper,
              this.reference,
              this.options.positionFixed
            )),
              (f.placement = D(
                this.options.placement,
                f.offsets.reference,
                this.popper,
                this.reference,
                this.options.modifiers.flip.boundariesElement,
                this.options.modifiers.flip.padding
              )),
              (f.originalPlacement = f.placement),
              (f.positionFixed = this.options.positionFixed),
              (f.offsets.popper = F(
                this.popper,
                f.offsets.reference,
                f.placement
              )),
              (f.offsets.popper.position = this.options.positionFixed
                ? "fixed"
                : "absolute"),
              (f = Z(this.modifiers, f)),
              this.state.isCreated
                ? this.options.onUpdate(f)
                : ((this.state.isCreated = !0), this.options.onCreate(f));
          }
        }
        function Q(f, e) {
          return f.some(function (f) {
            var t = f.name,
              n = f.enabled;
            return n && t === e;
          });
        }
        function W(f) {
          for (
            var e = [!1, "ms", "Webkit", "Moz", "O"],
              t = f.charAt(0).toUpperCase() + f.slice(1),
              n = 0;
            n < e.length;
            n++
          ) {
            var r = e[n],
              o = r ? "" + r + t : f;
            if ("undefined" !== typeof document.body.style[o]) return o;
          }
          return null;
        }
        function V() {
          return (
            (this.state.isDestroyed = !0),
            Q(this.modifiers, "applyStyle") &&
              (this.popper.removeAttribute("x-placement"),
              (this.popper.style.position = ""),
              (this.popper.style.top = ""),
              (this.popper.style.left = ""),
              (this.popper.style.right = ""),
              (this.popper.style.bottom = ""),
              (this.popper.style.willChange = ""),
              (this.popper.style[W("transform")] = "")),
            this.disableEventListeners(),
            this.options.removeOnDestroy &&
              this.popper.parentNode.removeChild(this.popper),
            this
          );
        }
        function J(f) {
          var e = f.ownerDocument;
          return e ? e.defaultView : window;
        }
        function Y(f, e, t, n) {
          var r = "BODY" === f.nodeName,
            o = r ? f.ownerDocument.defaultView : f;
          o.addEventListener(e, t, { passive: !0 }),
            r || Y(l(o.parentNode), e, t, n),
            n.push(o);
        }
        function X(f, e, t, n) {
          (t.updateBound = n),
            J(f).addEventListener("resize", t.updateBound, { passive: !0 });
          var r = l(f);
          return (
            Y(r, "scroll", t.updateBound, t.scrollParents),
            (t.scrollElement = r),
            (t.eventsEnabled = !0),
            t
          );
        }
        function K() {
          this.state.eventsEnabled ||
            (this.state = X(
              this.reference,
              this.options,
              this.state,
              this.scheduleUpdate
            ));
        }
        function $(f, e) {
          return (
            J(f).removeEventListener("resize", e.updateBound),
            e.scrollParents.forEach(function (f) {
              f.removeEventListener("scroll", e.updateBound);
            }),
            (e.updateBound = null),
            (e.scrollParents = []),
            (e.scrollElement = null),
            (e.eventsEnabled = !1),
            e
          );
        }
        function ff() {
          this.state.eventsEnabled &&
            (cancelAnimationFrame(this.scheduleUpdate),
            (this.state = $(this.reference, this.state)));
        }
        function ef(f) {
          return "" !== f && !isNaN(parseFloat(f)) && isFinite(f);
        }
        function tf(f, e) {
          Object.keys(e).forEach(function (t) {
            var n = "";
            -1 !==
              ["width", "height", "top", "right", "bottom", "left"].indexOf(
                t
              ) &&
              ef(e[t]) &&
              (n = "px"),
              (f.style[t] = e[t] + n);
          });
        }
        function nf(f, e) {
          Object.keys(e).forEach(function (t) {
            var n = e[t];
            !1 !== n ? f.setAttribute(t, e[t]) : f.removeAttribute(t);
          });
        }
        function rf(f) {
          return (
            tf(f.instance.popper, f.styles),
            nf(f.instance.popper, f.attributes),
            f.arrowElement &&
              Object.keys(f.arrowStyles).length &&
              tf(f.arrowElement, f.arrowStyles),
            f
          );
        }
        function of(f, e, t, n, r) {
          var o = B(r, e, f, t.positionFixed),
            a = D(
              t.placement,
              o,
              e,
              f,
              t.modifiers.flip.boundariesElement,
              t.modifiers.flip.padding
            );
          return (
            e.setAttribute("x-placement", a),
            tf(e, { position: t.positionFixed ? "fixed" : "absolute" }),
            t
          );
        }
        function af(f, e) {
          var t = f.offsets,
            n = t.popper,
            r = t.reference,
            o = Math.round,
            a = Math.floor,
            i = function (f) {
              return f;
            },
            s = o(r.width),
            d = o(n.width),
            c = -1 !== ["left", "right"].indexOf(f.placement),
            l = -1 !== f.placement.indexOf("-"),
            u = s % 2 === d % 2,
            p = s % 2 === 1 && d % 2 === 1,
            b = e ? (c || l || u ? o : a) : i,
            h = e ? o : i;
          return {
            left: b(p && !l && e ? n.left - 1 : n.left),
            top: h(n.top),
            bottom: h(n.bottom),
            right: b(n.right),
          };
        }
        var sf = t && /Firefox/i.test(navigator.userAgent);
        function df(f, e) {
          var t = e.x,
            n = e.y,
            r = f.offsets.popper,
            o = G(f.instance.modifiers, function (f) {
              return "applyStyle" === f.name;
            }).gpuAcceleration;
          void 0 !== o &&
            console.warn(
              "WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!"
            );
          var a = void 0 !== o ? o : e.gpuAcceleration,
            i = g(f.instance.popper),
            s = S(i),
            d = { position: r.position },
            c = af(f, window.devicePixelRatio < 2 || !sf),
            l = "bottom" === t ? "top" : "bottom",
            u = "right" === n ? "left" : "right",
            p = W("transform"),
            b = void 0,
            h = void 0;
          if (
            ((h =
              "bottom" === l
                ? "HTML" === i.nodeName
                  ? -i.clientHeight + c.bottom
                  : -s.height + c.bottom
                : c.top),
            (b =
              "right" === u
                ? "HTML" === i.nodeName
                  ? -i.clientWidth + c.right
                  : -s.width + c.right
                : c.left),
            a && p)
          )
            (d[p] = "translate3d(" + b + "px, " + h + "px, 0)"),
              (d[l] = 0),
              (d[u] = 0),
              (d.willChange = "transform");
          else {
            var m = "bottom" === l ? -1 : 1,
              v = "right" === u ? -1 : 1;
            (d[l] = h * m), (d[u] = b * v), (d.willChange = l + ", " + u);
          }
          var y = { "x-placement": f.placement };
          return (
            (f.attributes = I({}, y, f.attributes)),
            (f.styles = I({}, d, f.styles)),
            (f.arrowStyles = I({}, f.offsets.arrow, f.arrowStyles)),
            f
          );
        }
        function cf(f, e, t) {
          var n = G(f, function (f) {
              var t = f.name;
              return t === e;
            }),
            r =
              !!n &&
              f.some(function (f) {
                return f.name === t && f.enabled && f.order < n.order;
              });
          if (!r) {
            var o = "`" + e + "`",
              a = "`" + t + "`";
            console.warn(
              a +
                " modifier is required by " +
                o +
                " modifier in order to work, be sure to include it before " +
                o +
                "!"
            );
          }
          return r;
        }
        function lf(f, e) {
          var t;
          if (!cf(f.instance.modifiers, "arrow", "keepTogether")) return f;
          var n = e.element;
          if ("string" === typeof n) {
            if (((n = f.instance.popper.querySelector(n)), !n)) return f;
          } else if (!f.instance.popper.contains(n))
            return (
              console.warn(
                "WARNING: `arrow.element` must be child of its popper element!"
              ),
              f
            );
          var r = f.placement.split("-")[0],
            o = f.offsets,
            a = o.popper,
            i = o.reference,
            s = -1 !== ["left", "right"].indexOf(r),
            c = s ? "height" : "width",
            l = s ? "Top" : "Left",
            u = l.toLowerCase(),
            p = s ? "left" : "top",
            b = s ? "bottom" : "right",
            h = R(n)[c];
          i[b] - h < a[u] && (f.offsets.popper[u] -= a[u] - (i[b] - h)),
            i[u] + h > a[b] && (f.offsets.popper[u] += i[u] + h - a[b]),
            (f.offsets.popper = T(f.offsets.popper));
          var g = i[u] + i[c] / 2 - h / 2,
            m = d(f.instance.popper),
            v = parseFloat(m["margin" + l]),
            y = parseFloat(m["border" + l + "Width"]),
            w = g - f.offsets.popper[u] - v - y;
          return (
            (w = Math.max(Math.min(a[c] - h, w), 0)),
            (f.arrowElement = n),
            (f.offsets.arrow =
              ((t = {}), j(t, u, Math.round(w)), j(t, p, ""), t)),
            f
          );
        }
        function uf(f) {
          return "end" === f ? "start" : "start" === f ? "end" : f;
        }
        var pf = [
            "auto-start",
            "auto",
            "auto-end",
            "top-start",
            "top",
            "top-end",
            "right-start",
            "right",
            "right-end",
            "bottom-end",
            "bottom",
            "bottom-start",
            "left-end",
            "left",
            "left-start",
          ],
          bf = pf.slice(3);
        function hf(f) {
          var e =
              arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
            t = bf.indexOf(f),
            n = bf.slice(t + 1).concat(bf.slice(0, t));
          return e ? n.reverse() : n;
        }
        var gf = {
          FLIP: "flip",
          CLOCKWISE: "clockwise",
          COUNTERCLOCKWISE: "counterclockwise",
        };
        function mf(f, e) {
          if (Q(f.instance.modifiers, "inner")) return f;
          if (f.flipped && f.placement === f.originalPlacement) return f;
          var t = z(
              f.instance.popper,
              f.instance.reference,
              e.padding,
              e.boundariesElement,
              f.positionFixed
            ),
            n = f.placement.split("-")[0],
            r = U(n),
            o = f.placement.split("-")[1] || "",
            a = [];
          switch (e.behavior) {
            case gf.FLIP:
              a = [n, r];
              break;
            case gf.CLOCKWISE:
              a = hf(n);
              break;
            case gf.COUNTERCLOCKWISE:
              a = hf(n, !0);
              break;
            default:
              a = e.behavior;
          }
          return (
            a.forEach(function (i, s) {
              if (n !== i || a.length === s + 1) return f;
              (n = f.placement.split("-")[0]), (r = U(n));
              var d = f.offsets.popper,
                c = f.offsets.reference,
                l = Math.floor,
                u =
                  ("left" === n && l(d.right) > l(c.left)) ||
                  ("right" === n && l(d.left) < l(c.right)) ||
                  ("top" === n && l(d.bottom) > l(c.top)) ||
                  ("bottom" === n && l(d.top) < l(c.bottom)),
                p = l(d.left) < l(t.left),
                b = l(d.right) > l(t.right),
                h = l(d.top) < l(t.top),
                g = l(d.bottom) > l(t.bottom),
                m =
                  ("left" === n && p) ||
                  ("right" === n && b) ||
                  ("top" === n && h) ||
                  ("bottom" === n && g),
                v = -1 !== ["top", "bottom"].indexOf(n),
                y =
                  !!e.flipVariations &&
                  ((v && "start" === o && p) ||
                    (v && "end" === o && b) ||
                    (!v && "start" === o && h) ||
                    (!v && "end" === o && g)),
                w =
                  !!e.flipVariationsByContent &&
                  ((v && "start" === o && b) ||
                    (v && "end" === o && p) ||
                    (!v && "start" === o && g) ||
                    (!v && "end" === o && h)),
                x = y || w;
              (u || m || x) &&
                ((f.flipped = !0),
                (u || m) && (n = a[s + 1]),
                x && (o = uf(o)),
                (f.placement = n + (o ? "-" + o : "")),
                (f.offsets.popper = I(
                  {},
                  f.offsets.popper,
                  F(f.instance.popper, f.offsets.reference, f.placement)
                )),
                (f = Z(f.instance.modifiers, f, "flip")));
            }),
            f
          );
        }
        function vf(f) {
          var e = f.offsets,
            t = e.popper,
            n = e.reference,
            r = f.placement.split("-")[0],
            o = Math.floor,
            a = -1 !== ["top", "bottom"].indexOf(r),
            i = a ? "right" : "bottom",
            s = a ? "left" : "top",
            d = a ? "width" : "height";
          return (
            t[i] < o(n[s]) && (f.offsets.popper[s] = o(n[s]) - t[d]),
            t[s] > o(n[i]) && (f.offsets.popper[s] = o(n[i])),
            f
          );
        }
        function yf(f, e, t, n) {
          var r = f.match(/((?:\-|\+)?\d*\.?\d*)(.*)/),
            o = +r[1],
            a = r[2];
          if (!o) return f;
          if (0 === a.indexOf("%")) {
            var i = void 0;
            switch (a) {
              case "%p":
                i = t;
                break;
              case "%":
              case "%r":
              default:
                i = n;
            }
            var s = T(i);
            return (s[e] / 100) * o;
          }
          if ("vh" === a || "vw" === a) {
            var d = void 0;
            return (
              (d =
                "vh" === a
                  ? Math.max(
                      document.documentElement.clientHeight,
                      window.innerHeight || 0
                    )
                  : Math.max(
                      document.documentElement.clientWidth,
                      window.innerWidth || 0
                    )),
              (d / 100) * o
            );
          }
          return o;
        }
        function wf(f, e, t, n) {
          var r = [0, 0],
            o = -1 !== ["right", "left"].indexOf(n),
            a = f.split(/(\+|\-)/).map(function (f) {
              return f.trim();
            }),
            i = a.indexOf(
              G(a, function (f) {
                return -1 !== f.search(/,|\s/);
              })
            );
          a[i] &&
            -1 === a[i].indexOf(",") &&
            console.warn(
              "Offsets separated by white space(s) are deprecated, use a comma (,) instead."
            );
          var s = /\s*,\s*|\s+/,
            d =
              -1 !== i
                ? [
                    a.slice(0, i).concat([a[i].split(s)[0]]),
                    [a[i].split(s)[1]].concat(a.slice(i + 1)),
                  ]
                : [a];
          return (
            (d = d.map(function (f, n) {
              var r = (1 === n ? !o : o) ? "height" : "width",
                a = !1;
              return f
                .reduce(function (f, e) {
                  return "" === f[f.length - 1] && -1 !== ["+", "-"].indexOf(e)
                    ? ((f[f.length - 1] = e), (a = !0), f)
                    : a
                    ? ((f[f.length - 1] += e), (a = !1), f)
                    : f.concat(e);
                }, [])
                .map(function (f) {
                  return yf(f, r, e, t);
                });
            })),
            d.forEach(function (f, e) {
              f.forEach(function (t, n) {
                ef(t) && (r[e] += t * ("-" === f[n - 1] ? -1 : 1));
              });
            }),
            r
          );
        }
        function xf(f, e) {
          var t = e.offset,
            n = f.placement,
            r = f.offsets,
            o = r.popper,
            a = r.reference,
            i = n.split("-")[0],
            s = void 0;
          return (
            (s = ef(+t) ? [+t, 0] : wf(t, o, a, i)),
            "left" === i
              ? ((o.top += s[0]), (o.left -= s[1]))
              : "right" === i
              ? ((o.top += s[0]), (o.left += s[1]))
              : "top" === i
              ? ((o.left += s[0]), (o.top -= s[1]))
              : "bottom" === i && ((o.left += s[0]), (o.top += s[1])),
            (f.popper = o),
            f
          );
        }
        function _f(f, e) {
          var t = e.boundariesElement || g(f.instance.popper);
          f.instance.reference === t && (t = g(t));
          var n = W("transform"),
            r = f.instance.popper.style,
            o = r.top,
            a = r.left,
            i = r[n];
          (r.top = ""), (r.left = ""), (r[n] = "");
          var s = z(
            f.instance.popper,
            f.instance.reference,
            e.padding,
            t,
            f.positionFixed
          );
          (r.top = o), (r.left = a), (r[n] = i), (e.boundaries = s);
          var d = e.priority,
            c = f.offsets.popper,
            l = {
              primary: function (f) {
                var t = c[f];
                return (
                  c[f] < s[f] &&
                    !e.escapeWithReference &&
                    (t = Math.max(c[f], s[f])),
                  j({}, f, t)
                );
              },
              secondary: function (f) {
                var t = "right" === f ? "left" : "top",
                  n = c[t];
                return (
                  c[f] > s[f] &&
                    !e.escapeWithReference &&
                    (n = Math.min(
                      c[t],
                      s[f] - ("right" === f ? c.width : c.height)
                    )),
                  j({}, t, n)
                );
              },
            };
          return (
            d.forEach(function (f) {
              var e =
                -1 !== ["left", "top"].indexOf(f) ? "primary" : "secondary";
              c = I({}, c, l[e](f));
            }),
            (f.offsets.popper = c),
            f
          );
        }
        function kf(f) {
          var e = f.placement,
            t = e.split("-")[0],
            n = e.split("-")[1];
          if (n) {
            var r = f.offsets,
              o = r.reference,
              a = r.popper,
              i = -1 !== ["bottom", "top"].indexOf(t),
              s = i ? "left" : "top",
              d = i ? "width" : "height",
              c = { start: j({}, s, o[s]), end: j({}, s, o[s] + o[d] - a[d]) };
            f.offsets.popper = I({}, a, c[n]);
          }
          return f;
        }
        function Mf(f) {
          if (!cf(f.instance.modifiers, "hide", "preventOverflow")) return f;
          var e = f.offsets.reference,
            t = G(f.instance.modifiers, function (f) {
              return "preventOverflow" === f.name;
            }).boundaries;
          if (
            e.bottom < t.top ||
            e.left > t.right ||
            e.top > t.bottom ||
            e.right < t.left
          ) {
            if (!0 === f.hide) return f;
            (f.hide = !0), (f.attributes["x-out-of-boundaries"] = "");
          } else {
            if (!1 === f.hide) return f;
            (f.hide = !1), (f.attributes["x-out-of-boundaries"] = !1);
          }
          return f;
        }
        function Cf(f) {
          var e = f.placement,
            t = e.split("-")[0],
            n = f.offsets,
            r = n.popper,
            o = n.reference,
            a = -1 !== ["left", "right"].indexOf(t),
            i = -1 === ["top", "left"].indexOf(t);
          return (
            (r[a ? "left" : "top"] =
              o[t] - (i ? r[a ? "width" : "height"] : 0)),
            (f.placement = U(e)),
            (f.offsets.popper = T(r)),
            f
          );
        }
        var Af = {
            shift: { order: 100, enabled: !0, fn: kf },
            offset: { order: 200, enabled: !0, fn: xf, offset: 0 },
            preventOverflow: {
              order: 300,
              enabled: !0,
              fn: _f,
              priority: ["left", "right", "top", "bottom"],
              padding: 5,
              boundariesElement: "scrollParent",
            },
            keepTogether: { order: 400, enabled: !0, fn: vf },
            arrow: { order: 500, enabled: !0, fn: lf, element: "[x-arrow]" },
            flip: {
              order: 600,
              enabled: !0,
              fn: mf,
              behavior: "flip",
              padding: 5,
              boundariesElement: "viewport",
              flipVariations: !1,
              flipVariationsByContent: !1,
            },
            inner: { order: 700, enabled: !1, fn: Cf },
            hide: { order: 800, enabled: !0, fn: Mf },
            computeStyle: {
              order: 850,
              enabled: !0,
              fn: df,
              gpuAcceleration: !0,
              x: "bottom",
              y: "right",
            },
            applyStyle: {
              order: 900,
              enabled: !0,
              fn: rf,
              onLoad: of,
              gpuAcceleration: void 0,
            },
          },
          jf = {
            placement: "bottom",
            positionFixed: !1,
            eventsEnabled: !0,
            removeOnDestroy: !1,
            onCreate: function () {},
            onUpdate: function () {},
            modifiers: Af,
          },
          If = (function () {
            function f(e, t) {
              var n = this,
                r =
                  arguments.length > 2 && void 0 !== arguments[2]
                    ? arguments[2]
                    : {};
              C(this, f),
                (this.scheduleUpdate = function () {
                  return requestAnimationFrame(n.update);
                }),
                (this.update = i(this.update.bind(this))),
                (this.options = I({}, f.Defaults, r)),
                (this.state = {
                  isDestroyed: !1,
                  isCreated: !1,
                  scrollParents: [],
                }),
                (this.reference = e && e.jquery ? e[0] : e),
                (this.popper = t && t.jquery ? t[0] : t),
                (this.options.modifiers = {}),
                Object.keys(I({}, f.Defaults.modifiers, r.modifiers)).forEach(
                  function (e) {
                    n.options.modifiers[e] = I(
                      {},
                      f.Defaults.modifiers[e] || {},
                      r.modifiers ? r.modifiers[e] : {}
                    );
                  }
                ),
                (this.modifiers = Object.keys(this.options.modifiers)
                  .map(function (f) {
                    return I({ name: f }, n.options.modifiers[f]);
                  })
                  .sort(function (f, e) {
                    return f.order - e.order;
                  })),
                this.modifiers.forEach(function (f) {
                  f.enabled &&
                    s(f.onLoad) &&
                    f.onLoad(n.reference, n.popper, n.options, f, n.state);
                }),
                this.update();
              var o = this.options.eventsEnabled;
              o && this.enableEventListeners(), (this.state.eventsEnabled = o);
            }
            return (
              A(f, [
                {
                  key: "update",
                  value: function () {
                    return q.call(this);
                  },
                },
                {
                  key: "destroy",
                  value: function () {
                    return V.call(this);
                  },
                },
                {
                  key: "enableEventListeners",
                  value: function () {
                    return K.call(this);
                  },
                },
                {
                  key: "disableEventListeners",
                  value: function () {
                    return ff.call(this);
                  },
                },
              ]),
              f
            );
          })();
        (If.Utils = ("undefined" !== typeof window ? window : f).PopperUtils),
          (If.placements = pf),
          (If.Defaults = jf),
          (e["a"] = If);
      }).call(this, t("c8ba"));
    },
    f0c8: function (f, e) {
      f.exports =
        "data:image/png;base64,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";
    },
    f36a: function (f, e, t) {
      var n = t("e330");
      f.exports = n([].slice);
    },
    f36a5: function (f, e, t) {
      "use strict";
      t("c094");
    },
    f3c1: function (f, e) {
      var t = 800,
        n = 16,
        r = Date.now;
      function o(f) {
        var e = 0,
          o = 0;
        return function () {
          var a = r(),
            i = n - (a - o);
          if (((o = a), i > 0)) {
            if (++e >= t) return arguments[0];
          } else e = 0;
          return f.apply(void 0, arguments);
        };
      }
      f.exports = o;
    },
    f5df: function (f, e, t) {
      var n = t("da84"),
        r = t("00ee"),
        o = t("1626"),
        a = t("c6b6"),
        i = t("b622"),
        s = i("toStringTag"),
        d = n.Object,
        c =
          "Arguments" ==
          a(
            (function () {
              return arguments;
            })()
          ),
        l = function (f, e) {
          try {
            return f[e];
          } catch (t) {}
        };
      f.exports = r
        ? a
        : function (f) {
            var e, t, n;
            return void 0 === f
              ? "Undefined"
              : null === f
              ? "Null"
              : "string" == typeof (t = l((e = d(f)), s))
              ? t
              : c
              ? a(e)
              : "Object" == (n = a(e)) && o(e.callee)
              ? "Arguments"
              : n;
          };
    },
    f5e6: function (f, e, t) {
      var n = t("0601");
      n.__esModule && (n = n.default),
        "string" === typeof n && (n = [[f.i, n, ""]]),
        n.locals && (f.exports = n.locals);
      var r = t("499e").default;
      r("1e5b338d", n, !0, { sourceMap: !1, shadowMode: !1 });
    },
    f66f: function (f, e, t) {
      var n = t("24fb");
      (e = n(!1)),
        e.push([
          f.i,
          ".sc-message--emoji[data-v-31eb6bba]{font-size:40px}",
          "",
        ]),
        (f.exports = e);
    },
    f6fd: function (f, e) {
      (function (f) {
        var e = "currentScript",
          t = f.getElementsByTagName("script");
        e in f ||
          Object.defineProperty(f, e, {
            get: function () {
              try {
                throw new Error();
              } catch (n) {
                var f,
                  e = (/.*at [^\(]*\((.*):.+:.+\)$/gi.exec(n.stack) || [!1])[1];
                for (f in t)
                  if (t[f].src == e || "interactive" == t[f].readyState)
                    return t[f];
                return null;
              }
            },
          });
      })(document);
    },
    f772: function (f, e, t) {
      var n = t("5692"),
        r = t("90e3"),
        o = n("keys");
      f.exports = function (f) {
        return o[f] || (o[f] = r(f));
      };
    },
    f787: function (f, e) {
      f.exports =
        "data:image/png;base64,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";
    },
    f7fa: function (f, e, t) {
      var n = t("6306");
      n.__esModule && (n = n.default),
        "string" === typeof n && (n = [[f.i, n, ""]]),
        n.locals && (f.exports = n.locals);
      var r = t("499e").default;
      r("2cbbc4ee", n, !0, { sourceMap: !1, shadowMode: !1 });
    },
    f8af: function (f, e, t) {
      var n = t("2474");
      function r(f) {
        var e = new f.constructor(f.byteLength);
        return new n(e).set(new n(f)), e;
      }
      f.exports = r;
    },
    f909: function (f, e, t) {
      var n = t("7e64"),
        r = t("b760"),
        o = t("72af"),
        a = t("4f50"),
        i = t("1a8c"),
        s = t("9934"),
        d = t("8adb");
      function c(f, e, t, l, u) {
        f !== e &&
          o(
            e,
            function (o, s) {
              if ((u || (u = new n()), i(o))) a(f, e, s, t, c, l, u);
              else {
                var p = l ? l(d(f, s), o, s + "", f, e, u) : void 0;
                void 0 === p && (p = o), r(f, s, p);
              }
            },
            s
          );
      }
      f.exports = c;
    },
    f94b: function (f, e, t) {
      "use strict";
      t("2e57");
    },
    fa21: function (f, e, t) {
      var n = t("7530"),
        r = t("2dcb"),
        o = t("eac5");
      function a(f) {
        return "function" != typeof f.constructor || o(f) ? {} : n(r(f));
      }
      f.exports = a;
    },
    fb15: function (f, e, t) {
      "use strict";
      var n;
      (t.r(e), "undefined" !== typeof window) &&
        (t("f6fd"),
        (n = window.document.currentScript) &&
          (n = n.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)) &&
          (t.p = n[1]));
      var r = function () {
          var f = this,
            e = f.$createElement,
            n = f._self._c || e;
          return n(
            "div",
            [
              f.showLauncher
                ? n(
                    "div",
                    {
                      staticClass: "sc-launcher",
                      class: { opened: f.isOpen },
                      on: {
                        click: function (e) {
                          e.preventDefault(),
                            f.isOpen ? f.close() : f.openAndFocus();
                        },
                      },
                    },
                    [
                      f.newMessagesCount > 0 && !f.isOpen
                        ? n("div", { staticClass: "sc-new-messsages-count" }, [
                            f._v(" " + f._s(f.newMessagesCount) + " "),
                          ])
                        : f._e(),
                      n("div", { staticClass: "sc-open-icon" }, [
                        n("img", {
                          staticClass: "shockwave",
                          attrs: { src: t("01f5"), alt: "bot" },
                        }),
                        n("img", { attrs: { src: t("f787"), alt: "talk" } }),
                      ]),
                    ]
                  )
                : f._e(),
              n("ChatWindow", {
                attrs: {
                  language: f.displayLang,
                  "message-list": f.messageList,
                  "on-user-input-submit": f.onMessageWasSent,
                  participants: f.participants,
                  title: f.title,
                  "is-open": f.isOpen,
                  "show-emoji": f.showEmoji,
                  "show-file": f.showFile,
                  "show-header": f.showHeader,
                  placeholder: f.localPlaceholder,
                  "show-typing-indicator": f.showTypingIndicator,
                  colors: f.colors,
                  "always-scroll-to-bottom": f.alwaysScrollToBottom,
                  "message-styling": f.messageStyling,
                  "show-close-button": f.showCloseButton,
                  "enable-user-input": f.enableUserInput,
                },
                on: {
                  close: f.close,
                  scrollToTop: function (e) {
                    return f.$emit("scrollToTop");
                  },
                  onType: function (e) {
                    return f.$emit("onType");
                  },
                  edit: function (e) {
                    return f.$emit("edit", e);
                  },
                  remove: function (e) {
                    return f.$emit("remove", e);
                  },
                },
                scopedSlots: f._u(
                  [
                    {
                      key: "header",
                      fn: function () {
                        return [f._t("header")];
                      },
                      proxy: !0,
                    },
                    {
                      key: "user-avatar",
                      fn: function (e) {
                        return [
                          f._t("user-avatar", null, {
                            user: e.user,
                            message: e.message,
                          }),
                        ];
                      },
                    },
                    {
                      key: "text-message-body",
                      fn: function (e) {
                        return [
                          f._t("text-message-body", null, {
                            message: e.message,
                            messageText: e.messageText,
                            messageColors: e.messageColors,
                            me: e.me,
                          }),
                        ];
                      },
                    },
                    {
                      key: "system-message-body",
                      fn: function (e) {
                        return [
                          f._t("system-message-body", null, {
                            message: e.message,
                          }),
                        ];
                      },
                    },
                    {
                      key: "text-message-toolbox",
                      fn: function (e) {
                        return [
                          f._t("text-message-toolbox", null, {
                            message: e.message,
                            me: e.me,
                          }),
                        ];
                      },
                    },
                  ],
                  null,
                  !0
                ),
              }),
            ],
            1
          );
        },
        o = [],
        a = (t("a9e3"), t("b0c0"), t("4160"), t("d3b7"), t("159b"), t("8bbf")),
        i = t.n(a),
        s = {
          state: i.a.observable({ editMessage: null }),
          setState: function (f, e) {
            i.a.set(this.state, f, e);
          },
        };
      function d(f) {
        var e = {};
        return (
          f.forEach(function (f) {
            e[f] = function () {
              return s.state[f];
            };
          }),
          e
        );
      }
      var c = s,
        l = t("e088"),
        u = t("ef45"),
        p = t("1937"),
        b = "en",
        h = {
          setLang: function (f) {
            b = f;
          },
          getLang: function () {
            return b;
          },
          t: function (f) {
            switch (b) {
              case "tc":
              case "hk":
                return u[f];
              case "sc":
                return p[f];
              default:
                return l[f];
            }
          },
        },
        g = h,
        m = function () {
          var f = this,
            e = f.$createElement,
            t = f._self._c || e;
          return t(
            "div",
            {
              staticClass: "sc-chat-window",
              class: { opened: f.isOpen, closed: !f.isOpen },
              style: {
                backgroundColor: f.colors.messageList.bg,
                "background-image": "url(" + f.colors.messageList.bgImage + ")",
              },
            },
            [
              f.showHeader
                ? t(
                    "Header",
                    {
                      attrs: {
                        participant: f.participants[0],
                        colors: f.colors,
                        showCloseButton: f.showCloseButton,
                        language: f.language,
                      },
                      on: {
                        close: function (e) {
                          return f.$emit("close");
                        },
                        userList: f.handleUserListToggle,
                      },
                    },
                    [[f._t("header")]],
                    2
                  )
                : f._e(),
              f.showUserList
                ? t("UserList", {
                    attrs: { colors: f.colors, participants: f.participants },
                  })
                : f._e(),
              f.showUserList
                ? f._e()
                : t("MessageList", {
                    attrs: {
                      messages: f.messages,
                      participants: f.participants,
                      "show-typing-indicator": f.showTypingIndicator,
                      colors: f.colors,
                      "always-scroll-to-bottom": f.alwaysScrollToBottom,
                      "message-styling": f.messageStyling,
                      suggestions: f.getSuggestions(),
                    },
                    on: {
                      scrollToTop: function (e) {
                        return f.$emit("scrollToTop");
                      },
                      remove: function (e) {
                        return f.$emit("remove", e);
                      },
                      sendSuggestion: f._submitSuggestion,
                    },
                    scopedSlots: f._u(
                      [
                        {
                          key: "user-avatar",
                          fn: function (e) {
                            return [
                              f._t("user-avatar", null, {
                                user: e.user,
                                message: e.message,
                              }),
                            ];
                          },
                        },
                        {
                          key: "text-message-body",
                          fn: function (e) {
                            return [
                              f._t("text-message-body", null, {
                                message: e.message,
                                messageText: e.messageText,
                                messageColors: e.messageColors,
                                me: e.me,
                              }),
                            ];
                          },
                        },
                        {
                          key: "system-message-body",
                          fn: function (e) {
                            return [
                              f._t("system-message-body", null, {
                                message: e.message,
                              }),
                            ];
                          },
                        },
                        {
                          key: "text-message-toolbox",
                          fn: function (e) {
                            return [
                              f._t("text-message-toolbox", null, {
                                message: e.message,
                                me: e.me,
                              }),
                            ];
                          },
                        },
                      ],
                      null,
                      !0
                    ),
                  }),
              f.showUserList
                ? f._e()
                : t("UserInput", {
                    attrs: {
                      "show-emoji": f.showEmoji,
                      "on-submit": f.onUserInputSubmit,
                      suggestions: f.getSuggestions(),
                      "show-file": f.showFile,
                      placeholder: f.placeholder,
                      colors: f.colors,
                      "enable-user-input": f.enableUserInput,
                      "show-review-btn": f.showReviewBtn,
                    },
                    on: {
                      onType: function (e) {
                        return f.$emit("onType");
                      },
                      edit: function (e) {
                        return f.$emit("edit", e);
                      },
                      showReviewModal: function (e) {
                        f.showReviewModal = !0;
                      },
                    },
                  }),
              f.showReviewModal
                ? t("ReviewModal", {
                    attrs: { colors: f.colors },
                    on: {
                      close: function (e) {
                        f.showReviewModal = !1;
                      },
                      submitReview: f.submitReview,
                    },
                  })
                : f._e(),
            ],
            1
          );
        },
        v = [],
        y = function () {
          var f = this,
            e = f.$createElement,
            t = f._self._c || e;
          return t(
            "div",
            {
              staticClass: "sc-header",
              style: {
                background: f.colors.header.bg,
                color: f.colors.header.text,
              },
            },
            [
              t("img", {
                staticClass: "sc-header--img",
                attrs: {
                  src: f.participant.imageUrl,
                  alt:
                    "hk" == f.language
                      ? f.participant.name_tc
                      : f.participant.name,
                },
              }),
              t("div", { staticClass: "sc-header--username" }, [
                t("span", { staticClass: "sc-header--username--name" }, [
                  f._v(
                    f._s(
                      "hk" == f.language
                        ? f.participant.name_tc
                        : f.participant.name
                    )
                  ),
                ]),
              ]),
              f.showCloseButton
                ? t(
                    "div",
                    {
                      staticClass: "sc-header--close-button",
                      on: {
                        click: function (e) {
                          return f.$emit("close");
                        },
                      },
                    },
                    [
                      t("img", {
                        attrs: {
                          src: f.icons.close.img,
                          alt: f.icons.close.name,
                        },
                      }),
                    ]
                  )
                : f._e(),
            ]
          );
        },
        w = [];
      t("b64b"),
        t("a4d3"),
        t("4de4"),
        t("e439"),
        t("dbb4"),
        t("1d1c"),
        t("7a82");
      function x(f, e, t) {
        return (
          e in f
            ? Object.defineProperty(f, e, {
                value: t,
                enumerable: !0,
                configurable: !0,
                writable: !0,
              })
            : (f[e] = t),
          f
        );
      }
      function _(f, e) {
        var t = Object.keys(f);
        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(f);
          e &&
            (n = n.filter(function (e) {
              return Object.getOwnPropertyDescriptor(f, e).enumerable;
            })),
            t.push.apply(t, n);
        }
        return t;
      }
      function k(f) {
        for (var e = 1; e < arguments.length; e++) {
          var t = null != arguments[e] ? arguments[e] : {};
          e % 2
            ? _(Object(t), !0).forEach(function (e) {
                x(f, e, t[e]);
              })
            : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(f, Object.getOwnPropertyDescriptors(t))
            : _(Object(t)).forEach(function (e) {
                Object.defineProperty(
                  f,
                  e,
                  Object.getOwnPropertyDescriptor(t, e)
                );
              });
        }
        return f;
      }
      t("ac1f"), t("466d");
      var M = t("bd73"),
        C = t.n(M),
        A = {
          props: {
            icons: {
              type: Object,
              default: function () {
                return { close: { img: C.a, name: "default" } };
              },
            },
            participant: { type: Object, required: !0 },
            colors: { type: Object, required: !0 },
            language: { type: String, required: !0 },
          },
          data: function () {
            return { inUserList: !1, status: g.t("here2help") };
          },
          computed: k(
            k({}, d(["disableUserListToggle", "logo", "showCloseButton"])),
            {},
            {
              isMobile: function () {
                return (
                  navigator.userAgent.match(/(iPad|iPhone|iPod)/i) ||
                  navigator.userAgent.match(/android/i)
                );
              },
            }
          ),
          methods: {
            toggleUserList: function () {
              (this.inUserList = !this.inUserList),
                this.$emit("userList", this.inUserList);
            },
          },
        },
        j = A;
      t("f36a5");
      function I(f, e, t, n, r, o, a, i) {
        var s,
          d = "function" === typeof f ? f.options : f;
        if (
          (e && ((d.render = e), (d.staticRenderFns = t), (d._compiled = !0)),
          n && (d.functional = !0),
          o && (d._scopeId = "data-v-" + o),
          a
            ? ((s = function (f) {
                (f =
                  f ||
                  (this.$vnode && this.$vnode.ssrContext) ||
                  (this.parent &&
                    this.parent.$vnode &&
                    this.parent.$vnode.ssrContext)),
                  f ||
                    "undefined" === typeof __VUE_SSR_CONTEXT__ ||
                    (f = __VUE_SSR_CONTEXT__),
                  r && r.call(this, f),
                  f &&
                    f._registeredComponents &&
                    f._registeredComponents.add(a);
              }),
              (d._ssrRegister = s))
            : r &&
              (s = i
                ? function () {
                    r.call(
                      this,
                      (d.functional ? this.parent : this).$root.$options
                        .shadowRoot
                    );
                  }
                : r),
          s)
        )
          if (d.functional) {
            d._injectStyles = s;
            var c = d.render;
            d.render = function (f, e) {
              return s.call(e), c(f, e);
            };
          } else {
            var l = d.beforeCreate;
            d.beforeCreate = l ? [].concat(l, s) : [s];
          }
        return { exports: f, options: d };
      }
      var T = I(j, y, w, !1, null, "12a03780", null),
        S = T.exports,
        O = function () {
          var f = this,
            e = f.$createElement,
            t = f._self._c || e;
          return t(
            "div",
            {
              ref: "scrollList",
              staticClass: "sc-message-list",
              style: { backgroundColor: f.colors.messageList.bg },
              attrs: { id: "sc-message-list" },
              on: { scroll: f.handleScroll },
            },
            [
              f._l(f.messages, function (e, n) {
                return t("Message", {
                  key: n,
                  attrs: {
                    showAvatar:
                      void 0 == f.messages[n + 1] ||
                      f.messages[n + 1].author != f.participants[0].id,
                    message: e,
                    user: f.profile(e.author),
                    colors: f.colors,
                    "message-styling": f.messageStyling,
                  },
                  on: {
                    remove: function (t) {
                      return f.$emit("remove", e);
                    },
                  },
                  scopedSlots: f._u(
                    [
                      {
                        key: "user-avatar",
                        fn: function (e) {
                          return [
                            f._t("user-avatar", null, {
                              user: e.user,
                              message: e.message,
                            }),
                          ];
                        },
                      },
                      {
                        key: "text-message-body",
                        fn: function (e) {
                          return [
                            f._t("text-message-body", null, {
                              message: e.message,
                              messageText: e.messageText,
                              messageColors: e.messageColors,
                              me: e.me,
                            }),
                          ];
                        },
                      },
                      {
                        key: "system-message-body",
                        fn: function (e) {
                          return [
                            f._t("system-message-body", null, {
                              message: e.message,
                            }),
                          ];
                        },
                      },
                      {
                        key: "text-message-toolbox",
                        fn: function (e) {
                          return [
                            f._t("text-message-toolbox", null, {
                              message: e.message,
                              me: e.me,
                            }),
                          ];
                        },
                      },
                    ],
                    null,
                    !0
                  ),
                });
              }),
              t("Message", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: f.isTyping,
                    expression: "isTyping",
                  },
                ],
                key: f.messages.length,
                attrs: {
                  message: { author: f.showTypingIndicator, type: "typing" },
                  user: f.profile(f.showTypingIndicator),
                  colors: f.colors,
                  "message-styling": f.messageStyling,
                  showAvatar: !0,
                },
              }),
              f.suggestions.length > 0
                ? t("Suggestions", {
                    attrs: { suggestions: f.suggestions, colors: f.colors },
                    on: { sendSuggestion: f._submitSuggestion },
                  })
                : f._e(),
            ],
            2
          );
        },
        E = [],
        L =
          (t("7db0"),
          function () {
            var f = this,
              e = f.$createElement,
              t = f._self._c || e;
            return t(
              "div",
              {
                staticClass: "sc-message",
                class: {
                  sent: "me" === f.message.author,
                  received:
                    "me" !== f.message.author && "system" !== f.message.type,
                  system: "system" === f.message.type,
                },
                attrs: { id: f.message.id },
              },
              [
                t(
                  "div",
                  {
                    staticClass: "sc-message--content",
                    class: {
                      sent: "me" === f.message.author,
                      received:
                        "me" !== f.message.author &&
                        "system" !== f.message.type,
                      system: "system" === f.message.type,
                    },
                  },
                  [
                    "system" !== f.message.type
                      ? f._t(
                          "user-avatar",
                          function () {
                            return [
                              t("div", {
                                staticClass: "sc-message--avatar",
                                style: {
                                  backgroundImage:
                                    f.showAvatar &&
                                    "system" !== f.message.type &&
                                    f.authorName &&
                                    "me" !== f.authorName
                                      ? "url(" + f.chatImageUrl + ")"
                                      : "",
                                },
                                attrs: { title: f.authorName },
                              }),
                            ];
                          },
                          { message: f.message, user: f.user }
                        )
                      : f._e(),
                    "text" === f.message.type
                      ? t("TextMessage", {
                          attrs: {
                            message: f.message,
                            "message-colors": f.messageColors,
                            "message-styling": f.messageStyling,
                          },
                          on: {
                            remove: function (e) {
                              return f.$emit("remove");
                            },
                          },
                          scopedSlots: f._u(
                            [
                              {
                                key: "default",
                                fn: function (e) {
                                  return [
                                    f._t("text-message-body", null, {
                                      message: e.message,
                                      messageText: e.messageText,
                                      messageColors: e.messageColors,
                                      me: e.me,
                                    }),
                                  ];
                                },
                              },
                              {
                                key: "text-message-toolbox",
                                fn: function (e) {
                                  return [
                                    f._t("text-message-toolbox", null, {
                                      message: e.message,
                                      me: e.me,
                                    }),
                                  ];
                                },
                              },
                            ],
                            null,
                            !0
                          ),
                        })
                      : "emoji" === f.message.type
                      ? t("EmojiMessage", { attrs: { data: f.message.data } })
                      : "file" === f.message.type
                      ? t("FileMessage", {
                          attrs: {
                            data: f.message.data,
                            author: f.message.author,
                            "message-colors": f.messageColors,
                          },
                        })
                      : "typing" === f.message.type
                      ? t("TypingMessage", {
                          attrs: { "message-colors": f.messageColors },
                        })
                      : "system" === f.message.type
                      ? t(
                          "SystemMessage",
                          {
                            attrs: {
                              data: f.message.data,
                              "message-colors": f.messageColors,
                            },
                          },
                          [
                            f._t("system-message-body", null, {
                              message: f.message.data,
                            }),
                          ],
                          2
                        )
                      : f._e(),
                  ],
                  2
                ),
              ]
            );
          }),
        N = [],
        z =
          (t("498a"),
          t("caad"),
          t("2532"),
          t("e6cf"),
          t("4795"),
          function () {
            var f = this,
              e = f.$createElement,
              t = f._self._c || e;
            return t(
              "div",
              {
                staticClass: "sc-message--text",
                class: f.me ? "from-me" : "from-them",
                style: [
                  f.messageColors,
                  { "--borderColor": f.messageColors.backgroundColor },
                ],
              },
              [
                [
                  t(
                    "div",
                    {
                      staticClass: "sc-message--toolbox",
                      style: { background: f.messageColors.backgroundColor },
                    },
                    [
                      f._t("text-message-toolbox", null, {
                        message: f.message,
                        me: f.me,
                      }),
                    ],
                    2
                  ),
                ],
                f._t(
                  "default",
                  function () {
                    return [
                      t("p", {
                        staticClass: "sc-message--text-content",
                        domProps: { innerHTML: f._s(f.messageText) },
                      }),
                      f.message.data.meta
                        ? t(
                            "p",
                            {
                              staticClass: "sc-message--meta",
                              style: {
                                color: f.messageColors.color,
                                "text-align": f.me ? "right" : "left",
                              },
                            },
                            [f._v(" " + f._s(f.message.data.meta) + " ")]
                          )
                        : f._e(),
                      f.message.isEdited
                        ? t(
                            "p",
                            { staticClass: "sc-message--edited" },
                            [
                              t(
                                "IconBase",
                                {
                                  attrs: { width: "10", "icon-name": "edited" },
                                },
                                [t("IconEdit")],
                                1
                              ),
                              f._v(" edited "),
                            ],
                            1
                          )
                        : f._e(),
                    ];
                  },
                  {
                    message: f.message,
                    messageText: f.messageText,
                    messageColors: f.messageColors,
                    me: f.me,
                  }
                ),
              ],
              2
            );
          }),
        P = [],
        D =
          (t("9911"),
          function () {
            var f = this,
              e = f.$createElement,
              t = f._self._c || e;
            return t(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: f.width,
                  height: f.height,
                  viewBox: f.viewBox,
                  "aria-labelledby": f.iconName,
                  role: "presentation",
                },
              },
              [
                t("title", { attrs: { id: f.iconName, lang: "en" } }, [
                  f._v(f._s(f.iconName)),
                ]),
                t("g", { attrs: { fill: f.iconColor } }, [f._t("default")], 2),
              ]
            );
          }),
        B = [],
        R = {
          props: {
            iconName: { type: String, default: "box" },
            width: { type: [Number, String], default: 18 },
            height: { type: [Number, String], default: 18 },
            viewBox: { type: String, default: "0 0 18 18" },
            iconColor: { type: String, default: "currentColor" },
          },
        },
        U = R,
        F = (t("d79b"), I(U, D, B, !1, null, "4339dcad", null)),
        G = F.exports,
        H = function () {
          var f = this,
            e = f.$createElement,
            t = f._self._c || e;
          return t("path", {
            attrs: {
              d: "M19.404,6.65l-5.998-5.996c-0.292-0.292-0.765-0.292-1.056,0l-2.22,2.22l-8.311,8.313l-0.003,0.001v0.003l-0.161,0.161c-0.114,0.112-0.187,0.258-0.21,0.417l-1.059,7.051c-0.035,0.233,0.044,0.47,0.21,0.639c0.143,0.14,0.333,0.219,0.528,0.219c0.038,0,0.073-0.003,0.111-0.009l7.054-1.055c0.158-0.025,0.306-0.098,0.417-0.211l8.478-8.476l2.22-2.22C19.695,7.414,19.695,6.941,19.404,6.65z M8.341,16.656l-0.989-0.99l7.258-7.258l0.989,0.99L8.341,16.656z M2.332,15.919l0.411-2.748l4.143,4.143l-2.748,0.41L2.332,15.919z M13.554,7.351L6.296,14.61l-0.849-0.848l7.259-7.258l0.423,0.424L13.554,7.351zM10.658,4.457l0.992,0.99l-7.259,7.258L3.4,11.715L10.658,4.457z M16.656,8.342l-1.517-1.517V6.823h-0.003l-0.951-0.951l-2.471-2.471l1.164-1.164l4.942,4.94L16.656,8.342z",
            },
          });
        },
        Z = [],
        q = {},
        Q = I(q, H, Z, !1, null, null, null),
        W = Q.exports,
        V = function () {
          var f = this,
            e = f.$createElement,
            t = f._self._c || e;
          return t("path", {
            attrs: {
              d: "M15.9 4.04a.7.7 0 00-.99 0l-4.7 4.72-4.72-4.71a.7.7 0 00-.98.98l4.7 4.71-4.7 4.71a.7.7 0 00.98.99l4.71-4.71 4.71 4.7a.7.7 0 00.99 0 .7.7 0 000-.98l-4.71-4.7 4.7-4.72a.7.7 0 000-.99z",
            },
          });
        },
        J = [],
        Y = {},
        X = I(Y, V, J, !1, null, null, null),
        K = X.exports,
        $ = t("21eb"),
        ff = t.n($),
        ef = t("71cc"),
        tf = t.n(ef),
        nf = t("3715"),
        rf = {
          components: { IconBase: G, IconCross: K, IconEdit: W },
          props: {
            message: { type: Object, required: !0 },
            messageColors: { type: Object, required: !0 },
            messageStyling: { type: Boolean, required: !0 },
          },
          computed: k(
            {
              messageText: function () {
                var f = ff.a.escape(this.message.data.text);
                return tf.a.link(this.messageStyling ? nf(f) : f, {
                  className: "chatLink",
                  stripPrefix: !1,
                });
              },
              me: function () {
                return "me" === this.message.author;
              },
              isEditing: function () {
                return (
                  (c.state.editMessage && c.state.editMessage.id) ===
                  this.message.id
                );
              },
            },
            d(["showDeletion", "showEdition"])
          ),
          methods: {
            edit: function () {
              c.setState("editMessage", this.message);
            },
          },
          data: function () {
            return { borderColor: "red" };
          },
        },
        of = rf,
        af = (t("a918"), I(of, z, P, !1, null, "31de3dd1", null)),
        sf = af.exports,
        df = function () {
          var f = this,
            e = f.$createElement,
            t = f._self._c || e;
          return t(
            "div",
            { staticClass: "sc-message--file", style: f.messageColors },
            [
              t("img", {
                staticClass: "sc-image",
                attrs: { src: f.data.file.url },
              }),
              f.data.title
                ? t(
                    "p",
                    { staticClass: "sc-message--file-text sc-message--title" },
                    [f._v(f._s(f.data.title))]
                  )
                : f._e(),
              f.data.text.startsWith("http") || f.data.text.startsWith("https")
                ? t(
                    "a",
                    {
                      staticClass: "sc-message--file-text sc-message--url",
                      class: f.me ? "from-me" : "from-them",
                      style: [
                        f.messageColors,
                        { "--borderColor": f.messageColors.backgroundColor },
                      ],
                      attrs: { href: f.data.text, target: "_blank" },
                    },
                    [f._v(f._s(f.data.text))]
                  )
                : t(
                    "p",
                    {
                      staticClass: "sc-message--file-text",
                      class: f.me ? "from-me" : "from-them",
                      style: [
                        f.messageColors,
                        { "--borderColor": f.messageColors.backgroundColor },
                      ],
                    },
                    [f._v(f._s(f.data.text))]
                  ),
            ]
          );
        },
        cf = [],
        lf = {
          props: {
            data: { type: Object, required: !0 },
            author: { type: String, required: !0 },
            messageColors: { type: Object, required: !0 },
          },
          computed: {
            me: function () {
              return "me" === this.author;
            },
          },
        },
        uf = lf,
        pf = (t("7f2b"), I(uf, df, cf, !1, null, "32bd0ef6", null)),
        bf = pf.exports,
        hf = function () {
          var f = this,
            e = f.$createElement,
            t = f._self._c || e;
          return t("div", { staticClass: "sc-message--emoji" }, [
            f._v(f._s(f.data.emoji)),
          ]);
        },
        gf = [],
        mf = { props: { data: { type: Object, required: !0 } } },
        vf = mf,
        yf = (t("39c2"), I(vf, hf, gf, !1, null, "31eb6bba", null)),
        wf = yf.exports,
        xf = function () {
          var f = this,
            e = f.$createElement,
            t = f._self._c || e;
          return t(
            "div",
            { staticClass: "sc-typing-indicator", style: f.messageColors },
            [
              t("span", { staticClass: "dot1" }),
              t("span", { staticClass: "dot2" }),
              t("span", { staticClass: "dot3" }),
            ]
          );
        },
        _f = [],
        kf = { props: { messageColors: { type: Object, required: !0 } } },
        Mf = kf,
        Cf = (t("39ba"), I(Mf, xf, _f, !1, null, "255b28fb", null)),
        Af = Cf.exports,
        jf = function () {
          var f = this,
            e = f.$createElement,
            t = f._self._c || e;
          return t(
            "div",
            { staticClass: "sc-message--system", style: f.messageColors },
            [
              f._t(
                "default",
                function () {
                  return [
                    f._v(" " + f._s(f.data.text) + " "),
                    f.data.meta
                      ? t(
                          "p",
                          {
                            staticClass: "sc-message--meta",
                            style: { color: f.messageColors.color },
                          },
                          [f._v(" " + f._s(f.data.meta) + " ")]
                        )
                      : f._e(),
                  ];
                },
                { message: f.data }
              ),
            ],
            2
          );
        },
        If = [],
        Tf = {
          props: {
            data: { type: Object, required: !0 },
            messageColors: { type: Object, required: !0 },
          },
        },
        Sf = Tf,
        Of = (t("456a"), I(Sf, jf, If, !1, null, "50d00423", null)),
        Ef = Of.exports,
        Lf = t("a5d7"),
        Nf = t.n(Lf),
        zf = function () {
          var f = this,
            e = f.$createElement,
            t = f._self._c || e;
          return t(
            "button",
            {
              staticClass: "sc-user-input--button-icon-wrapper",
              attrs: { disabled: f.disabled },
            },
            [
              t(
                "IconBase",
                {
                  attrs: {
                    color: f.color,
                    width: "20",
                    height: "20",
                    "view-box": "2.24 2.24 15.52 15.52",
                    "icon-name": f.tooltip,
                  },
                },
                [f._t("default")],
                2
              ),
            ],
            1
          );
        },
        Pf = [],
        Df = {
          components: { IconBase: G },
          props: {
            color: { type: String },
            tooltip: { type: String, default: "" },
            disabled: { type: Boolean, default: !1 },
          },
        },
        Bf = Df,
        Rf = (t("6863"), I(Bf, zf, Pf, !1, null, "122be205", null)),
        Uf = Rf.exports,
        Ff = function () {
          var f = this,
            e = f.$createElement,
            t = f._self._c || e;
          return t("path", {
            attrs: {
              d: "M21.875,14A5.625,5.625,0,0,0,18.75,8.962V19.025A5.592,5.592,0,0,0,21.875,14ZM5,10.25v7.5h5L16.25,24V4L10,10.25Z",
              transform: "translate(-4.5 -3.793)",
            },
          });
        },
        Gf = [],
        Hf = {},
        Zf = I(Hf, Ff, Gf, !1, null, null, null),
        qf = Zf.exports,
        Qf = {
          components: {
            TextMessage: sf,
            FileMessage: bf,
            EmojiMessage: wf,
            TypingMessage: Af,
            SystemMessage: Ef,
            UserInputButton: Uf,
            IconSpeaker: qf,
          },
          props: {
            message: { type: Object, required: !0 },
            colors: { type: Object, required: !0 },
            messageStyling: { type: Boolean, required: !0 },
            user: { type: Object, required: !0 },
            showAvatar: { type: Boolean },
          },
          computed: {
            authorName: function () {
              return this.user && this.user.name;
            },
            chatImageUrl: function () {
              return (this.user && this.user.imageUrl) || Nf.a;
            },
            messageColors: function () {
              return "system" === this.message.type
                ? this.systemColorsStyle
                : "me" === this.message.author
                ? this.sentColorsStyle
                : this.receivedColorsStyle;
            },
            receivedColorsStyle: function () {
              return {
                color: this.colors.receivedMessage.text,
                backgroundColor: this.colors.receivedMessage.bg,
              };
            },
            sentColorsStyle: function () {
              return {
                color: this.colors.sentMessage.text,
                backgroundColor: this.colors.sentMessage.bg,
              };
            },
            systemColorsStyle: function () {
              return {
                color: this.colors.systemMessage.text,
                backgroundColor: this.colors.systemMessage.bg,
              };
            },
            sendIconColor: function () {
              return void 0 == this.userInput || "" == this.userInput.trim()
                ? this.colors.voiceBtn.text
                : this.colors.header.bg;
            },
          },
          data: function () {
            return { voice: null };
          },
          mounted: function () {
            var f = this,
              e = g.getLang();
            speechSynthesis.cancel();
            var t = this.setSpeech();
            t.then(function (t) {
              var n = t.filter(function (f) {
                return f.lang.toLowerCase().includes(e);
              });
              f.voice = n[0];
            });
          },
          methods: {
            setSpeech: function () {
              return new Promise(function (f, e) {
                var t,
                  n = speechSynthesis;
                t = setInterval(function () {
                  0 !== n.getVoices().length &&
                    (f(n.getVoices()), clearInterval(t));
                }, 10);
              });
            },
            _tts: function () {
              var f = new SpeechSynthesisUtterance();
              (f.text = this.message.data.text),
                (f.voice = this.voice),
                (f.pitch = 1),
                (f.rate = 1);
            },
          },
          watch: {
            message: function (f, e) {
              do {
                if ("me" == f.author) break;
                if ("text" != f.type) break;
                if (void 0 != f.data.text) {
                  if (
                    f.data.text.includes("https://") ||
                    f.data.text.includes("http://")
                  )
                    break;
                  this._tts();
                  break;
                }
              } while (1);
            },
          },
        },
        Wf = Qf,
        Vf = (t("8571"), I(Wf, L, N, !1, null, null, null)),
        Jf = Vf.exports,
        Yf = function () {
          var f = this,
            e = f.$createElement,
            t = f._self._c || e;
          return t(
            "div",
            {
              staticClass: "sc-suggestions-row",
              style: { background: f.colors.messageList.bg },
            },
            f._l(f.suggestions, function (e, n) {
              return t(
                "button",
                {
                  key: n,
                  staticClass: "sc-suggestions-element",
                  style: f.style,
                  on: {
                    click: function (t) {
                      return f.$emit("sendSuggestion", e);
                    },
                  },
                },
                [f._v(" " + f._s(e.title) + " ")]
              );
            }),
            0
          );
        },
        Xf = [],
        Kf = {
          props: {
            suggestions: {
              type: Array,
              default: function () {
                return [];
              },
            },
            colors: { type: Object, required: !0 },
          },
          data: function () {
            return {
              style: {
                "--color": this.colors.buttons.bg,
                "--fontcolor": "#ffffff",
              },
            };
          },
        },
        $f = Kf,
        fe = (t("bb06"), I($f, Yf, Xf, !1, null, null, null)),
        ee = fe.exports,
        te = {
          components: { Message: Jf, Suggestions: ee },
          props: {
            participants: { type: Array, required: !0 },
            messages: { type: Array, required: !0 },
            showTypingIndicator: { type: String, required: !0 },
            colors: { type: Object, required: !0 },
            alwaysScrollToBottom: { type: Boolean, required: !0 },
            messageStyling: { type: Boolean, required: !0 },
            suggestions: {
              type: Array,
              default: function () {
                return [];
              },
            },
          },
          data: function () {
            return { subtitle: g.t("here2help") };
          },
          computed: k(
            {
              isTyping: function () {
                return "" !== this.showTypingIndicator;
              },
              defaultChatIcon: function () {
                return Nf.a;
              },
              latestChatbotMsgIndex: function () {
                var f = this,
                  e = this.messages.filter(function (e) {
                    return e.author == f.participants[0].id;
                  });
                return e[e.length - 1].id;
              },
            },
            d(["logo", "title"])
          ),
          mounted: function () {
            this.$nextTick(this._scrollDown());
          },
          updated: function () {
            this.shouldScrollToBottom() && this.$nextTick(this._scrollDown());
          },
          methods: {
            _scrollDown: function () {
              this.$refs.scrollList.scrollTop =
                this.$refs.scrollList.scrollHeight;
            },
            handleScroll: function (f) {
              0 === f.target.scrollTop && this.$emit("scrollToTop");
            },
            shouldScrollToBottom: function () {
              var f = this.$refs.scrollList.scrollTop,
                e = f > this.$refs.scrollList.scrollHeight - 600;
              return this.alwaysScrollToBottom || e;
            },
            profile: function (f) {
              var e = this.participants.find(function (e) {
                return e.id === f;
              });
              return e || { imageUrl: "", name: "" };
            },
            _submitSuggestion: function (f) {
              this.$emit("sendSuggestion", f);
            },
          },
        },
        ne = te,
        re = (t("b4be"), I(ne, O, E, !1, null, "1c13b751", null)),
        oe = re.exports,
        ae = function () {
          var f = this,
            e = f.$createElement,
            t = f._self._c || e;
          return t(
            "div",
            { staticStyle: { position: "relative" } },
            [
              f.file
                ? t(
                    "div",
                    {
                      staticClass: "file-container",
                      style: {
                        backgroundColor: f.colors.userInput.text,
                        color: f.colors.userInput.bg,
                      },
                    },
                    [
                      t("span", { staticClass: "icon-file-message" }, [
                        t("img", {
                          attrs: {
                            src: f.icons.file.img,
                            alt: f.icons.file.name,
                            height: "15",
                          },
                        }),
                      ]),
                      f._v(" " + f._s(f.file.name) + " "),
                      t(
                        "span",
                        {
                          staticClass: "delete-file-message",
                          on: {
                            click: function (e) {
                              return f.cancelFile();
                            },
                          },
                        },
                        [
                          t("img", {
                            attrs: {
                              src: f.icons.closeSvg.img,
                              alt: f.icons.closeSvg.name,
                              height: "10",
                              title: "Remove the file",
                            },
                          }),
                        ]
                      ),
                    ]
                  )
                : f._e(),
              t(
                "form",
                {
                  staticClass: "sc-user-input",
                  class: { active: f.inputActive },
                },
                [
                  t(
                    "div",
                    {
                      staticClass: "sc-user-input-area",
                      style: { background: f.colors.userInput.bg },
                    },
                    [
                      t("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: f.userInput,
                            expression: "userInput",
                          },
                        ],
                        staticClass: "sc-user-input--text",
                        style: { color: f.colors.userInput.text },
                        attrs: {
                          refs: "userInput",
                          role: "button",
                          type: "text",
                          tabIndex: "0",
                          contentEditable: "true",
                          placeholder: f.placeholder,
                          maxlength: f.maxlength,
                        },
                        domProps: { value: f.userInput },
                        on: {
                          focus: function (e) {
                            return f.setInputActive(!0);
                          },
                          blur: function (e) {
                            return f.setInputActive(!1);
                          },
                          keydown: f.handleKey,
                          focusUserInput: function (e) {
                            return f.focusUserInput();
                          },
                          input: function (e) {
                            e.target.composing ||
                              (f.userInput = e.target.value);
                          },
                        },
                      }),
                      t("div", { staticClass: "sc-user-input--word-counter" }, [
                        t(
                          "p",
                          {
                            staticStyle: { "margin-bottom": "0" },
                            style: { color: f.colors.userInput.text },
                          },
                          [
                            f._v(
                              " " +
                                f._s(
                                  void 0 != f.userInput ? f.userInput.length : 0
                                ) +
                                "/" +
                                f._s(f.maxlength) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                      t("div", { staticClass: "sc-user-input--buttons" }, [
                        f.showEmoji && !f.isEditing
                          ? t(
                              "div",
                              { staticClass: "sc-user-input--button" },
                              [
                                t("EmojiIcon", {
                                  attrs: {
                                    "on-emoji-picked": f._handleEmojiPicked,
                                    color: f.colors.userInput.text,
                                  },
                                }),
                              ],
                              1
                            )
                          : f._e(),
                        f.showFile && !f.isEditing
                          ? t(
                              "div",
                              { staticClass: "sc-user-input--button" },
                              [
                                t("FileIcons", {
                                  attrs: {
                                    "on-change": f._handleFileSubmit,
                                    color: f.colors.userInput.text,
                                  },
                                }),
                              ],
                              1
                            )
                          : f._e(),
                        f.isEditing
                          ? t(
                              "div",
                              { staticClass: "sc-user-input--button" },
                              [
                                t(
                                  "UserInputButton",
                                  {
                                    attrs: {
                                      color: f.colors.userInput.text,
                                      tooltip: f.cancelTooltip,
                                    },
                                    nativeOn: {
                                      click: function (e) {
                                        return (
                                          e.preventDefault(),
                                          f._editFinish.apply(null, arguments)
                                        );
                                      },
                                    },
                                  },
                                  [t("IconCross")],
                                  1
                                ),
                              ],
                              1
                            )
                          : f._e(),
                        t(
                          "div",
                          { staticClass: "sc-user-input--button" },
                          [
                            f.isEditing
                              ? t(
                                  "UserInputButton",
                                  {
                                    attrs: {
                                      color: f.colors.userInput.text,
                                      tooltip: f.editTooltip,
                                    },
                                    nativeOn: {
                                      click: function (e) {
                                        return (
                                          e.preventDefault(),
                                          f._editText.apply(null, arguments)
                                        );
                                      },
                                    },
                                  },
                                  [t("IconOk")],
                                  1
                                )
                              : t(
                                  "UserInputButton",
                                  {
                                    attrs: {
                                      color: f.sendIconColor,
                                      tooltip: f.sendTooltip,
                                      disabled: !f.enableUserInput,
                                    },
                                    nativeOn: {
                                      click: function (e) {
                                        return (
                                          e.preventDefault(),
                                          f._submitText.apply(null, arguments)
                                        );
                                      },
                                    },
                                  },
                                  [t("IconSend")],
                                  1
                                ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
              f.showReviewBtn
                ? t("ReviewButton", {
                    staticClass: "sc-review-btn",
                    attrs: { colors: f.colors },
                    on: {
                      showReviewModal: function (e) {
                        return f.$emit("showReviewModal");
                      },
                    },
                  })
                : f._e(),
            ],
            1
          );
        },
        ie = [],
        se =
          (t("c0b6"),
          function () {
            var f = this,
              e = f.$createElement,
              t = f._self._c || e;
            return t(
              "div",
              { staticClass: "sc-user-input--picker-wrapper" },
              [
                f.isActive
                  ? t("EmojiPicker", {
                      attrs: {
                        "on-emoji-picked": f.onEmojiPicked,
                        "on-blur": f._handlePickerBlur,
                      },
                    })
                  : f._e(),
                t(
                  "button",
                  {
                    staticClass: "sc-user-input--emoji-icon-wrapper",
                    on: {
                      click: function (e) {
                        return (
                          e.preventDefault(),
                          f._openPicker.apply(null, arguments)
                        );
                      },
                    },
                  },
                  [
                    t(
                      "svg",
                      {
                        staticClass: "sc-user-input--emoji-icon",
                        class: { active: f.isActive },
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "20",
                          height: "20",
                          viewBox: "0 0 37.4 37.4",
                        },
                      },
                      [
                        t("path", {
                          style: { fill: f.color },
                          attrs: {
                            d: "M18.7 37.4C8.39 37.4 0 29 0 18.7 0 8.39 8.39 0 18.7 0 29 0 37.4 8.39 37.4 18.7c0 10.3-8.4 18.7-18.7 18.7zm0-35.4C9.49 2 2 9.49 2 18.7c0 9.2 7.49 16.7 16.7 16.7 9.2 0 16.7-7.5 16.7-16.7C35.4 9.49 27.9 2 18.7 2z",
                          },
                        }),
                        t("circle", {
                          style: { fill: f.color },
                          attrs: { cx: "12.38", cy: "14.36", r: "1.94" },
                        }),
                        t("circle", {
                          style: { fill: f.color },
                          attrs: { cx: "24.37", cy: "14.41", r: "1.99" },
                        }),
                        t("path", {
                          style: { fill: f.color },
                          attrs: {
                            d: "M18.04 27.45a10 10 0 01-8.45-4.35 1 1 0 011.7-1.04c.1.15 2.17 3.4 6.75 3.4 4.7 0 7.51-3.47 7.54-3.5a1 1 0 011.57 1.24c-.14.17-3.45 4.25-9.11 4.25z",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ],
              1
            );
          }),
        de = [],
        ce = function () {
          var f = this,
            e = f.$createElement,
            t = f._self._c || e;
          return t(
            "div",
            {
              ref: "domNode",
              staticClass: "sc-emoji-picker",
              attrs: { tabIndex: "0" },
              on: { blur: f.onBlur },
            },
            [
              t(
                "div",
                { staticClass: "sc-emoji-picker--content" },
                f._l(f.emojiData, function (e) {
                  return t(
                    "div",
                    { key: e.name, staticClass: "sc-emoji-picker--category" },
                    [
                      t(
                        "div",
                        { staticClass: "sc-emoji-picker--category-title" },
                        [f._v(f._s(e.name))]
                      ),
                      f._l(e.emojis, function (e) {
                        return t(
                          "span",
                          {
                            key: e,
                            staticClass: "sc-emoji-picker--emoji",
                            on: {
                              click: function (t) {
                                return f.emojiClicked(e);
                              },
                            },
                          },
                          [f._v(" " + f._s(e) + " ")]
                        );
                      }),
                    ],
                    2
                  );
                }),
                0
              ),
            ]
          );
        },
        le = [],
        ue = t("edbf"),
        pe = t.n(ue),
        be = [
          {
            name: "People",
            emojis: [
              "😄",
              "😃",
              "😀",
              "😊",
              "😉",
              "😍",
              "😘",
              "😚",
              "😗",
              "😙",
              "😜",
              "😝",
              "😛",
              "😳",
              "😁",
              "😔",
              "😌",
              "😒",
              "😞",
              "😣",
              "😢",
              "😂",
              "😭",
              "😪",
              "😥",
              "😰",
              "😅",
              "😓",
              "😩",
              "😫",
              "😨",
              "😱",
              "😠",
              "😡",
              "😤",
              "😖",
              "😆",
              "😋",
              "😷",
              "😎",
              "😴",
              "😵",
              "😲",
              "😟",
              "😦",
              "😧",
              "👿",
              "😮",
              "😬",
              "😐",
              "😕",
              "😯",
              "😏",
              "😑",
              "👲",
              "👳",
              "👮",
              "👷",
              "💂",
              "👶",
              "👦",
              "👧",
              "👨",
              "👩",
              "👴",
              "👵",
              "👱",
              "👼",
              "👸",
              "😺",
              "😸",
              "😻",
              "😽",
              "😼",
              "🙀",
              "😿",
              "😹",
              "😾",
              "👹",
              "👺",
              "🙈",
              "🙉",
              "🙊",
              "💀",
              "👽",
              "💩",
              "🔥",
              "✨",
              "🌟",
              "💫",
              "💥",
              "💢",
              "💦",
              "💧",
              "💤",
              "💨",
              "👂",
              "👀",
              "👃",
              "👅",
              "👄",
              "👍",
              "👎",
              "👌",
              "👊",
              "✊",
              "👋",
              "✋",
              "👐",
              "👆",
              "👇",
              "👉",
              "👈",
              "🙌",
              "🙏",
              "👏",
              "💪",
              "🚶",
              "🏃",
              "💃",
              "👫",
              "👪",
              "💏",
              "💑",
              "👯",
              "🙆",
              "🙅",
              "💁",
              "🙋",
              "💆",
              "💇",
              "💅",
              "👰",
              "🙎",
              "🙍",
              "🙇",
              "🎩",
              "👑",
              "👒",
              "👟",
              "👞",
              "👡",
              "👠",
              "👢",
              "👕",
              "👔",
              "👚",
              "👗",
              "🎽",
              "👖",
              "👘",
              "👙",
              "💼",
              "👜",
              "👝",
              "👛",
              "👓",
              "🎀",
              "🌂",
              "💄",
              "💛",
              "💙",
              "💜",
              "💚",
              "💔",
              "💗",
              "💓",
              "💕",
              "💖",
              "💞",
              "💘",
              "💌",
              "💋",
              "💍",
              "💎",
              "👤",
              "💬",
              "👣",
            ],
          },
          {
            name: "Nature",
            emojis: [
              "🐶",
              "🐺",
              "🐱",
              "🐭",
              "🐹",
              "🐰",
              "🐸",
              "🐯",
              "🐨",
              "🐻",
              "🐷",
              "🐽",
              "🐮",
              "🐗",
              "🐵",
              "🐒",
              "🐴",
              "🐑",
              "🐘",
              "🐼",
              "🐧",
              "🐦",
              "🐤",
              "🐥",
              "🐣",
              "🐔",
              "🐍",
              "🐢",
              "🐛",
              "🐝",
              "🐜",
              "🐞",
              "🐌",
              "🐙",
              "🐚",
              "🐠",
              "🐟",
              "🐬",
              "🐳",
              "🐎",
              "🐲",
              "🐡",
              "🐫",
              "🐩",
              "🐾",
              "💐",
              "🌸",
              "🌷",
              "🍀",
              "🌹",
              "🌻",
              "🌺",
              "🍁",
              "🍃",
              "🍂",
              "🌿",
              "🌾",
              "🍄",
              "🌵",
              "🌴",
              "🌰",
              "🌱",
              "🌼",
              "🌑",
              "🌓",
              "🌔",
              "🌕",
              "🌛",
              "🌙",
              "🌏",
              "🌋",
              "🌌",
              "🌠",
              "⛅",
              "⛄",
              "🌀",
              "🌁",
              "🌈",
              "🌊",
            ],
          },
          {
            name: "Objects",
            emojis: [
              "🎍",
              "💝",
              "🎎",
              "🎒",
              "🎓",
              "🎏",
              "🎆",
              "🎇",
              "🎐",
              "🎑",
              "🎃",
              "👻",
              "🎅",
              "🎄",
              "🎁",
              "🎋",
              "🎉",
              "🎊",
              "🎈",
              "🎌",
              "🔮",
              "🎥",
              "📷",
              "📹",
              "📼",
              "💿",
              "📀",
              "💽",
              "💾",
              "💻",
              "📱",
              "📞",
              "📟",
              "📠",
              "📡",
              "📺",
              "📻",
              "🔊",
              "🔔",
              "📢",
              "📣",
              "⏳",
              "⌛",
              "⏰",
              "⌚",
              "🔓",
              "🔒",
              "🔏",
              "🔐",
              "🔑",
              "🔎",
              "💡",
              "🔦",
              "🔌",
              "🔋",
              "🔍",
              "🛀",
              "🚽",
              "🔧",
              "🔩",
              "🔨",
              "🚪",
              "🚬",
              "💣",
              "🔫",
              "🔪",
              "💊",
              "💉",
              "💰",
              "💴",
              "💵",
              "💳",
              "💸",
              "📲",
              "📧",
              "📥",
              "📤",
              "📩",
              "📨",
              "📫",
              "📪",
              "📮",
              "📦",
              "📝",
              "📄",
              "📃",
              "📑",
              "📊",
              "📈",
              "📉",
              "📜",
              "📋",
              "📅",
              "📆",
              "📇",
              "📁",
              "📂",
              "📌",
              "📎",
              "📏",
              "📐",
              "📕",
              "📗",
              "📘",
              "📙",
              "📓",
              "📔",
              "📒",
              "📚",
              "📖",
              "🔖",
              "📛",
              "📰",
              "🎨",
              "🎬",
              "🎤",
              "🎧",
              "🎼",
              "🎵",
              "🎶",
              "🎹",
              "🎻",
              "🎺",
              "🎷",
              "🎸",
              "👾",
              "🎮",
              "🃏",
              "🎴",
              "🀄",
              "🎲",
              "🎯",
              "🏈",
              "🏀",
              "⚽",
              "⚾",
              "🎾",
              "🎱",
              "🎳",
              "⛳",
              "🏁",
              "🏆",
              "🎿",
              "🏂",
              "🏊",
              "🏄",
              "🎣",
              "🍵",
              "🍶",
              "🍺",
              "🍻",
              "🍸",
              "🍹",
              "🍷",
              "🍴",
              "🍕",
              "🍔",
              "🍟",
              "🍗",
              "🍖",
              "🍝",
              "🍛",
              "🍤",
              "🍱",
              "🍣",
              "🍥",
              "🍙",
              "🍘",
              "🍚",
              "🍜",
              "🍲",
              "🍢",
              "🍡",
              "🍳",
              "🍞",
              "🍩",
              "🍮",
              "🍦",
              "🍨",
              "🍧",
              "🎂",
              "🍰",
              "🍪",
              "🍫",
              "🍬",
              "🍭",
              "🍯",
              "🍎",
              "🍏",
              "🍊",
              "🍒",
              "🍇",
              "🍉",
              "🍓",
              "🍑",
              "🍈",
              "🍌",
              "🍍",
              "🍠",
              "🍆",
              "🍅",
              "🌽",
            ],
          },
          {
            name: "Places",
            emojis: [
              "🏠",
              "🏡",
              "🏫",
              "🏢",
              "🏣",
              "🏥",
              "🏦",
              "🏪",
              "🏩",
              "🏨",
              "💒",
              "⛪",
              "🏬",
              "🌇",
              "🌆",
              "🏯",
              "🏰",
              "⛺",
              "🏭",
              "🗼",
              "🗾",
              "🗻",
              "🌄",
              "🌅",
              "🌃",
              "🗽",
              "🌉",
              "🎠",
              "🎡",
              "⛲",
              "🎢",
              "🚢",
              "⛵",
              "🚤",
              "🚀",
              "💺",
              "🚉",
              "🚄",
              "🚅",
              "🚇",
              "🚃",
              "🚌",
              "🚙",
              "🚗",
              "🚕",
              "🚚",
              "🚨",
              "🚓",
              "🚒",
              "🚑",
              "🚲",
              "💈",
              "🚏",
              "🎫",
              "🚥",
              "🚧",
              "🔰",
              "⛽",
              "🏮",
              "🎰",
              "🗿",
              "🎪",
              "🎭",
              "📍",
              "🚩",
            ],
          },
          {
            name: "Symbols",
            emojis: [
              "🔟",
              "🔢",
              "🔣",
              "🔠",
              "🔡",
              "🔤",
              "🔼",
              "🔽",
              "⏪",
              "⏩",
              "⏫",
              "⏬",
              "🆗",
              "🆕",
              "🆙",
              "🆒",
              "🆓",
              "🆖",
              "📶",
              "🎦",
              "🈁",
              "🈯",
              "🈳",
              "🈵",
              "🈴",
              "🈲",
              "🉐",
              "🈹",
              "🈺",
              "🈶",
              "🈚",
              "🚻",
              "🚹",
              "🚺",
              "🚼",
              "🚾",
              "🚭",
              "🈸",
              "🉑",
              "🆑",
              "🆘",
              "🆔",
              "🚫",
              "🔞",
              "⛔",
              "❎",
              "✅",
              "💟",
              "🆚",
              "📳",
              "📴",
              "🆎",
              "💠",
              "⛎",
              "🔯",
              "🏧",
              "💹",
              "💲",
              "💱",
              "❌",
              "❗",
              "❓",
              "❕",
              "❔",
              "⭕",
              "🔝",
              "🔚",
              "🔙",
              "🔛",
              "🔜",
              "🔃",
              "🕛",
              "🕐",
              "🕑",
              "🕒",
              "🕓",
              "🕔",
              "🕕",
              "🕖",
              "🕗",
              "🕘",
              "🕙",
              "🕚",
              "➕",
              "➖",
              "➗",
              "💮",
              "💯",
              "🔘",
              "🔗",
              "➰",
              "🔱",
              "🔺",
              "🔲",
              "🔳",
              "🔴",
              "🔵",
              "🔻",
              "⬜",
              "⬛",
              "🔶",
              "🔷",
              "🔸",
              "🔹",
            ],
          },
        ],
        he = {
          props: {
            onBlur: { type: Function, required: !0 },
            onEmojiPicked: { type: Function, required: !0 },
          },
          data: function () {
            return { emojiData: be, emojiConvertor: new pe.a() };
          },
          mounted: function () {
            var f = this.$refs.domNode;
            (f.style.opacity = 0),
              window.requestAnimationFrame(function () {
                (f.style.transition = "opacity 350ms"), (f.style.opacity = 1);
              }),
              this.$refs.domNode.focus(),
              this.emojiConvertor.init_env();
          },
          methods: {
            emojiClicked: function (f) {
              this.onEmojiPicked(f), this.$refs.domNode.blur();
            },
          },
        },
        ge = he,
        me = (t("f94b"), I(ge, ce, le, !1, null, "5503164d", null)),
        ve = me.exports,
        ye = {
          components: { EmojiPicker: ve },
          props: {
            onEmojiPicked: { type: Function, required: !0 },
            color: { type: String, required: !0 },
          },
          data: function () {
            return { isActive: !1 };
          },
          methods: {
            _openPicker: function (f) {
              this.isActive = !this.isActive;
            },
            _handlePickerBlur: function () {
              this.isActive = !1;
            },
          },
        },
        we = ye,
        xe = (t("c676"), I(we, se, de, !1, null, "1a7c780e", null)),
        _e = xe.exports,
        ke = function () {
          var f = this,
            e = f.$createElement,
            t = f._self._c || e;
          return t(
            "label",
            {
              staticClass: "sc-user-input--file-icon-wrapper",
              attrs: { role: "button" },
            },
            [
              t(
                "svg",
                {
                  staticClass: "sc-user-input--file-icon",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "20",
                    height: "20",
                    viewBox: "0 0 31.4 34.4",
                  },
                },
                [
                  t("path", {
                    style: { fill: f.color },
                    attrs: {
                      d: "M20.8 10.22l-2.02-2.03L8.63 18.34a4.3 4.3 0 106.09 6.09L26.9 12.25A7.17 7.17 0 1016.75 2.1L3.96 14.9l-.03.02A10 10 0 1018.1 29.07l.02-.03 8.73-8.73-2.03-2.02L16.1 27l-.03.03a7.15 7.15 0 01-10.1-10.1l.03-.02L18.78 4.13a4.31 4.31 0 016.09 6.09L12.69 22.4a1.44 1.44 0 01-2.03-2.03l10.15-10.15z",
                    },
                  }),
                ]
              ),
              t("input", {
                attrs: { type: "file" },
                on: { change: f._handleChange },
              }),
            ]
          );
        },
        Me = [],
        Ce = {
          props: {
            onChange: { type: Function, required: !0 },
            color: { type: String, required: !0 },
          },
          methods: {
            _handleChange: function (f) {
              this.onChange(f.target.files[0]);
            },
          },
        },
        Ae = Ce,
        je = (t("96ec"), I(Ae, ke, Me, !1, null, "ba6bc394", null)),
        Ie = je.exports,
        Te = t("46c7"),
        Se = t.n(Te),
        Oe = t("bf37"),
        Ee = t.n(Oe),
        Le = function () {
          var f = this,
            e = f.$createElement,
            t = f._self._c || e;
          return t("path", {
            attrs: {
              d: "M7.63 14.57a.64.64 0 00.91 0l8.22-8.22a.64.64 0 10-.91-.92L8.08 13.2 4.15 9.27a.65.65 0 00-.9.9l4.38 4.4z",
            },
          });
        },
        Ne = [],
        ze = {},
        Pe = I(ze, Le, Ne, !1, null, null, null),
        De = Pe.exports,
        Be = function () {
          var f = this,
            e = f.$createElement,
            t = f._self._c || e;
          return t("path", {
            attrs: {
              d: "M17.22 2.27L2.48 8.39c-.35.14-.32.66.06.74l6.79 1.54 1.53 6.79c.09.37.6.41.75.06l6.12-14.74a.4.4 0 00-.51-.51M3.92 8.64l11.77-4.89-6.15 6.16-5.62-1.27zm7.44 7.44l-1.27-5.61 6.16-6.16-4.9 11.77z",
            },
          });
        },
        Re = [],
        Ue = {},
        Fe = I(Ue, Be, Re, !1, null, null, null),
        Ge = Fe.exports,
        He = function () {
          var f = this,
            e = f.$createElement,
            n = f._self._c || e;
          return n(
            "div",
            {
              staticClass: "sc-review-btn-body",
              style: { background: f.colors.header.bg },
              on: {
                click: function (e) {
                  return f.$emit("showReviewModal");
                },
              },
            },
            [
              n("img", {
                staticClass: "sc-review-btn-icon",
                attrs: { src: t("f0c8"), width: "20", height: "20" },
              }),
              n("span", [f._v(f._s(f.text))]),
            ]
          );
        },
        Ze = [],
        qe = function () {
          var f = this,
            e = f.$createElement,
            t = f._self._c || e;
          return t("path", {
            attrs: {
              d: "M7.143,9.955a.822.822,0,0,1-1.16,0L4.107,8.08a.82.82,0,0,1,1.16-1.16L6.563,8.215l3.17-3.17a.82.82,0,0,1,1.16,1.16ZM15,7.5A7.5,7.5,0,1,1,7.5,0,7.5,7.5,0,0,1,15,7.5ZM7.5,1.406A6.094,6.094,0,1,0,13.594,7.5,6.093,6.093,0,0,0,7.5,1.406Z",
            },
          });
        },
        Qe = [],
        We = {},
        Ve = I(We, qe, Qe, !1, null, null, null),
        Je = Ve.exports,
        Ye = {
          components: {
            IconBase: G,
            IconCheckboxSquare: Je,
            UserInputButton: Uf,
          },
          props: { colors: { type: Object, required: !0 } },
          data: function () {
            return { text: g.t("rating") };
          },
        },
        Xe = Ye,
        Ke = (t("ae04"), I(Xe, He, Ze, !1, null, "46bb18a0", null)),
        $e = Ke.exports,
        ft = {
          components: {
            EmojiIcon: _e,
            FileIcons: Ie,
            UserInputButton: Uf,
            Suggestions: ee,
            IconCross: K,
            IconOk: De,
            IconSend: Ge,
            ReviewButton: $e,
          },
          props: {
            icons: {
              type: Object,
              default: function () {
                return {
                  file: { img: Se.a, name: "default" },
                  closeSvg: { img: Ee.a, name: "default" },
                };
              },
            },
            showEmoji: {
              type: Boolean,
              default: function () {
                return !1;
              },
            },
            suggestions: {
              type: Array,
              default: function () {
                return [];
              },
            },
            showFile: {
              type: Boolean,
              default: function () {
                return !1;
              },
            },
            onSubmit: { type: Function, required: !0 },
            placeholder: { type: String, default: "Write something..." },
            colors: { type: Object, required: !0 },
            maxlength: { type: Number, default: 100 },
            enableUserInput: { type: Boolean, default: !0 },
            showReviewBtn: { type: Boolean, default: !0 },
          },
          data: function () {
            return {
              file: null,
              inputActive: !1,
              userInput: null,
              sendTooltip: g.t("send"),
              editTooltip: g.t("edit"),
              cancelTooltip: g.t("cancel"),
            };
          },
          computed: {
            editMessageId: function () {
              return this.isEditing && c.state.editMessage.id;
            },
            isEditing: function () {
              return c.state.editMessage && c.state.editMessage.id;
            },
            sendIconColor: function () {
              return void 0 == this.userInput || "" == this.userInput.trim()
                ? this.colors.userInput.text
                : this.colors.header.bg;
            },
          },
          watch: {
            editMessageId: function (f) {
              null != c.state.editMessage && void 0 != c.state.editMessage
                ? (this.$refs.userInput.focus(),
                  (this.userInput = c.state.editMessage.data.text))
                : (this.userInput = "");
            },
          },
          mounted: function () {
            var f = this;
            this.$root.$on("focusUserInput", function () {
              f.$refs.userInput && f.focusUserInput();
            });
          },
          methods: {
            cancelFile: function () {
              this.file = null;
            },
            setInputActive: function (f) {
              this.inputActive = f;
            },
            handleKey: function (f) {
              13 !== f.keyCode || f.shiftKey
                ? 27 === f.keyCode && (this._editFinish(), f.preventDefault())
                : (this.isEditing ? this._editText(f) : this._submitText(f),
                  this._editFinish(),
                  f.preventDefault()),
                this.$emit("onType");
            },
            focusUserInput: function () {
              var f = this;
              this.$nextTick(function () {
                f.$refs.userInput.focus();
              });
            },
            _submitSuggestion: function (f) {
              console.log(f),
                this.onSubmit({
                  author: "me",
                  type: "text",
                  data: { text: f.payload, title: f.title },
                });
            },
            _checkSubmitSuccess: function (f) {
              void 0 !== Promise
                ? Promise.resolve(f).then(
                    function (f) {
                      (void 0 === f || f) &&
                        ((this.file = null), (this.userInput = ""));
                    }.bind(this)
                  )
                : ((this.file = null), (this.userInput = ""));
            },
            _submitText: function (f) {
              var e = this.userInput,
                t = this.file;
              t
                ? this._submitTextWhenFile(f, e, t)
                : e &&
                  e.length > 0 &&
                  this._checkSubmitSuccess(
                    this.onSubmit({
                      author: "me",
                      type: "text",
                      data: { text: e },
                    })
                  );
            },
            _submitTextWhenFile: function (f, e, t) {
              e && e.length > 0
                ? this._checkSubmitSuccess(
                    this.onSubmit({
                      author: "me",
                      type: "file",
                      data: { text: e, file: t },
                    })
                  )
                : this._checkSubmitSuccess(
                    this.onSubmit({
                      author: "me",
                      type: "file",
                      data: { file: t },
                    })
                  );
            },
            _editText: function (f) {
              var e = this.userInput;
              e &&
                e.length &&
                (this.$emit("edit", {
                  author: "me",
                  type: "text",
                  id: c.state.editMessage.id,
                  data: { text: e },
                }),
                this._editFinish());
            },
            _handleEmojiPicked: function (f) {
              this._checkSubmitSuccess(
                this.onSubmit({
                  author: "me",
                  type: "emoji",
                  data: { emoji: f },
                })
              );
            },
            _handleFileSubmit: function (f) {
              this.file = f;
            },
            _editFinish: function () {
              c.setState("editMessage", null);
            },
            showReviewModal: function () {
              console.log("clicked");
            },
          },
        },
        et = ft,
        tt = (t("0a97"), I(et, ae, ie, !1, null, "23e31aa6", null)),
        nt = tt.exports,
        rt = function () {
          var f = this,
            e = f.$createElement,
            t = f._self._c || e;
          return t(
            "div",
            {
              staticClass: "user-list",
              style: { background: f.userListColor.userList.bg },
            },
            [
              t("table", { staticStyle: { "padding-top": "5px" } }, [
                t(
                  "tbody",
                  f._l(f.participants, function (e) {
                    return t("tr", { key: e.id }, [
                      t("td", { staticStyle: { "text-align": "center" } }, [
                        t("img", {
                          staticClass: "img-msg",
                          attrs: { src: e.imageUrl },
                        }),
                      ]),
                      t(
                        "td",
                        {
                          staticClass: "user-element",
                          style: { color: f.userListColor.userList.text },
                        },
                        [f._v(" " + f._s(e.name) + " ")]
                      ),
                    ]);
                  }),
                  0
                ),
              ]),
            ]
          );
        },
        ot = [],
        at =
          (t("cca6"),
          {
            props: {
              participants: { type: Array, required: !0 },
              colors: {
                type: Object,
                default: function () {
                  return {};
                },
              },
            },
            computed: {
              userListColor: function () {
                var f = { userList: { bg: "#FFFFFF", text: "#000000" } };
                return Object.assign(f, this.colors);
              },
            },
          }),
        it = at,
        st = (t("387a"), I(it, rt, ot, !1, null, "30547438", null)),
        dt = st.exports,
        ct = function () {
          var f = this,
            e = f.$createElement,
            n = f._self._c || e;
          return n("transition", { attrs: { name: "modal" } }, [
            n("div", { staticClass: "modal-mask" }, [
              n("div", { staticClass: "modal-wrapper" }, [
                n("div", { staticClass: "modal-container" }, [
                  n(
                    "div",
                    {
                      staticClass: "modal-header",
                      style: { backgroundColor: f.colors.header.bg },
                    },
                    [
                      n("div", { staticClass: "sc-header--username" }, [
                        n(
                          "span",
                          { staticClass: "sc-header--username--name" },
                          [f._v("請你為一一剛才嘅表現評吓分!")]
                        ),
                      ]),
                      n(
                        "div",
                        {
                          staticClass: "sc-header--close-button",
                          on: {
                            click: function (e) {
                              return f.$emit("close");
                            },
                          },
                        },
                        [n("img", { attrs: { src: t("bd73") } })]
                      ),
                    ]
                  ),
                  n(
                    "div",
                    { staticClass: "modal-body" },
                    [
                      f.isSubmitted
                        ? n("p", [f._v("感謝你的意見")])
                        : n("star-rating", {
                            attrs: { "show-rating": !1 },
                            on: { "rating-selected": f.setRating },
                          }),
                    ],
                    1
                  ),
                  n("div", { staticClass: "modal-footer" }, [
                    f.isSubmitted
                      ? n(
                          "button",
                          {
                            staticClass: "btn",
                            on: {
                              click: function (e) {
                                return f.$emit("close");
                              },
                            },
                          },
                          [f._v(f._s(f.backBtn))]
                        )
                      : n(
                          "button",
                          { staticClass: "btn", on: { click: f.submit } },
                          [f._v(f._s(f.submitBtn))]
                        ),
                  ]),
                ]),
              ]),
            ]),
          ]);
        },
        lt = [],
        ut = {
          props: { colors: { type: Object, required: !0 } },
          data: function () {
            return {
              submitBtn: g.t("submit"),
              backBtn: g.t("back"),
              isSubmitted: !1,
            };
          },
          methods: {
            setRating: function (f) {
              this.rating = f;
            },
            submit: function () {
              (this.isSubmitted = !0), this.$emit("submitReview", this.rating);
            },
          },
        },
        pt = ut,
        bt = (t("6250"), I(pt, ct, lt, !1, null, "1d5e0284", null)),
        ht = bt.exports,
        gt = {
          components: {
            Header: S,
            MessageList: oe,
            UserInput: nt,
            UserList: dt,
            ReviewModal: ht,
          },
          props: {
            showEmoji: { type: Boolean, default: !1 },
            showFile: { type: Boolean, default: !1 },
            showHeader: { type: Boolean, default: !0 },
            participants: { type: Array, required: !0 },
            title: { type: String, required: !0 },
            onUserInputSubmit: { type: Function, required: !0 },
            messageList: {
              type: Array,
              default: function () {
                return [];
              },
            },
            isOpen: {
              type: Boolean,
              default: function () {
                return !1;
              },
            },
            placeholder: { type: String, required: !0 },
            showTypingIndicator: { type: String, required: !0 },
            colors: { type: Object, required: !0 },
            alwaysScrollToBottom: { type: Boolean, required: !0 },
            messageStyling: { type: Boolean, required: !0 },
            language: { type: String, required: !0 },
            showCloseButton: { type: Boolean, default: !0 },
            enableUserInput: { type: Boolean, default: !0 },
          },
          data: function () {
            return { showUserList: !1, showReviewModal: !1, showReviewBtn: !1 };
          },
          computed: {
            messages: function () {
              var f = this.messageList;
              return f;
            },
          },
          methods: {
            handleUserListToggle: function (f) {
              this.showUserList = f;
            },
            getSuggestions: function () {
              return this.messages.length > 0
                ? this.messages[this.messages.length - 1].suggestions
                : [];
            },
            _submitSuggestion: function (f) {
              this.onUserInputSubmit({
                author: "me",
                type: "text",
                data: { text: f.payload, title: f.title },
              });
            },
            submitReview: function (f) {
              (this.showReviewBtn = !1),
                this.onUserInputSubmit({
                  author: "me",
                  type: "text",
                  data: {
                    text: '/send_user_review{"rate":"' + f + '"}',
                    title: "rating",
                    donotdisplay: !0,
                  },
                });
            },
          },
          mounted: function () {
            g.setLang(this.language);
            var f = document.getElementById("sc-message-list");
            f.scrollTop = f.scrollHeight;
          },
        },
        mt = gt,
        vt = (t("c6c5"), t("deb8"), I(mt, m, v, !1, null, "193ba5e7", null)),
        yt = vt.exports,
        wt = t("c2f4"),
        xt = t.n(wt),
        _t = t("3df2"),
        kt = t.n(_t),
        Mt = {
          components: { ChatWindow: yt },
          created: function () {
            g.setLang(this.language), (this.localPlaceholder = g.t("writeMsg"));
          },
          props: {
            icons: {
              type: Object,
              default: function () {
                return {
                  open: { img: kt.a, name: "default" },
                  close: { img: xt.a, name: "default" },
                };
              },
            },
            showEmoji: { type: Boolean, default: !1 },
            showEdition: { type: Boolean, default: !1 },
            showDeletion: { type: Boolean, default: !1 },
            isOpen: { type: Boolean, required: !0 },
            open: { type: Function, required: !0 },
            close: { type: Function, required: !0 },
            showFile: { type: Boolean, default: !1 },
            showLauncher: { type: Boolean, default: !0 },
            showCloseButton: { type: Boolean, default: !0 },
            showHeader: { type: Boolean, default: !0 },
            participants: { type: Array, required: !0 },
            title: {
              type: String,
              default: function () {
                return "";
              },
            },
            logo: {
              type: String,
              default: function () {
                return "";
              },
            },
            onMessageWasSent: { type: Function, required: !0 },
            messageList: {
              type: Array,
              default: function () {
                return [];
              },
            },
            newMessagesCount: {
              type: Number,
              default: function () {
                return 0;
              },
            },
            placeholder: { type: String, default: "" },
            showTypingIndicator: {
              type: String,
              default: function () {
                return "";
              },
            },
            colors: {
              type: Object,
              validator: function (f) {
                return (
                  "header" in f &&
                  "bg" in f.header &&
                  "text" in f.header &&
                  "launcher" in f &&
                  "bg" in f.launcher &&
                  "messageList" in f &&
                  "bg" in f.messageList &&
                  "sentMessage" in f &&
                  "bg" in f.sentMessage &&
                  "text" in f.sentMessage &&
                  "receivedMessage" in f &&
                  "bg" in f.receivedMessage &&
                  "text" in f.receivedMessage &&
                  "userInput" in f &&
                  "bg" in f.userInput &&
                  "text" in f.userInput
                );
              },
              default: function () {
                return {
                  header: { bg: "#4e8cff", text: "#ffffff" },
                  launcher: { bg: "#4e8cff" },
                  messageList: { bg: "#ffffff" },
                  sentMessage: { bg: "#4e8cff", text: "#ffffff" },
                  receivedMessage: { bg: "#f4f7f9", text: "#ffffff" },
                  userInput: { bg: "#f4f7f9", text: "#565867" },
                };
              },
            },
            alwaysScrollToBottom: {
              type: Boolean,
              default: function () {
                return !1;
              },
            },
            messageStyling: {
              type: Boolean,
              default: function () {
                return !1;
              },
            },
            disableUserListToggle: { type: Boolean, default: !1 },
            language: {
              type: String,
              default: function () {
                return "en";
              },
            },
            enableUserInput: { type: Boolean, default: !0 },
          },
          computed: {
            chatWindowTitle: function () {
              return "" !== this.title
                ? this.title
                : 0 === this.participants.length
                ? "You"
                : this.participants.length > 1
                ? "You, " + this.participants[0].name + " & others"
                : "You & " + this.participants[0].name;
            },
          },
          watch: {
            $props: {
              deep: !0,
              immediate: !0,
              handler: function (f) {
                for (var e in f) c.setState(e, f[e]);
              },
            },
            language: function (f, e) {
              this.displayLang = f;
            },
          },
          methods: {
            openAndFocus: function () {
              this.open(), this.$root.$emit("focusUserInput");
            },
          },
          data: function () {
            return {
              localPlaceholder: this.placeholder,
              displayLang: this.language,
            };
          },
        },
        Ct = Mt,
        At = (t("a1a1"), t("586d"), I(Ct, r, o, !1, null, "e889f236", null)),
        jt = At.exports,
        It = t("e37d");
      i.a.component("star-rating", VueStarRating["default"]);
      var Tt = "BeautifulChat",
        St = {
          install: function (f) {
            var e =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : {};
            this.installed ||
              ((this.installed = !0),
              (this.event = new f()),
              (this.dynamicContainer = null),
              (this.componentName = e.componentName || Tt),
              (f.prototype.$chat = {
                _setDynamicContainer: function (f) {
                  St.dynamicContainer = f;
                },
              }),
              f.component(this.componentName, jt),
              f.use(It["a"]));
          },
        },
        Ot = St;
      e["default"] = Ot;
    },
    fb4c: function (f, e, t) {
      var n = t("01e9");
      n.__esModule && (n = n.default),
        "string" === typeof n && (n = [[f.i, n, ""]]),
        n.locals && (f.exports = n.locals);
      var r = t("499e").default;
      r("0eac3024", n, !0, { sourceMap: !1, shadowMode: !1 });
    },
    fba5: function (f, e, t) {
      var n = t("cb5a");
      function r(f) {
        return n(this.__data__, f) > -1;
      }
      f.exports = r;
    },
    fc6a: function (f, e, t) {
      var n = t("44ad"),
        r = t("1d80");
      f.exports = function (f) {
        return n(r(f));
      };
    },
    fc8c: function (f, e, t) {
      var n = t("24fb");
      (e = n(!1)),
        e.push([
          f.i,
          ".sc-message--file[data-v-32bd0ef6]{border-radius:.7rem;font-weight:300;font-size:14px;line-height:1.4;-webkit-font-smoothing:subpixel-antialiased}.sc-message--content.sent .sc-message--file[data-v-32bd0ef6]{word-wrap:break-word}.sc-message--file-icon[data-v-32bd0ef6]{text-align:center;margin-left:auto;margin-right:auto;margin-top:15px;margin-bottom:0}.sc-image[data-v-32bd0ef6]{max-width:100%;min-width:100%;border-top-left-radius:10px;border-top-right-radius:10px}.sc-message--file-text[data-v-32bd0ef6]{position:relative;padding:2px 15px .5rem 15px;border-radius:10px;font-weight:300;font-size:14px;line-height:1.4;white-space:pre-wrap;-webkit-font-smoothing:subpixel-antialiased}.sc-message--file-name[data-v-32bd0ef6]{color:#fff;padding-left:15px;padding-right:15px;padding-top:0;font-size:x-small;text-align:center}.sc-message--file-name a[data-v-32bd0ef6]{text-decoration:none;color:#ece7e7}.sc-message--file-name a[data-v-32bd0ef6]:hover{color:#fff}.sc-message--content.sent .sc-message--file-text[data-v-32bd0ef6]{color:#fff;background-color:#4e8cff;word-wrap:break-word}.sc-message--content.received .sc-message--file[data-v-32bd0ef6]{color:#263238;background-color:#f4f7f9}.sc-message--content.received .sc-message--file-name[data-v-32bd0ef6]{color:#000}.sc-message--content.received .sc-message--file a[data-v-32bd0ef6]{color:rgba(43,40,40,.7)}.sc-message--content.received .sc-message--file a[data-v-32bd0ef6]:hover{color:#0c0c0c}.sc-message--url[data-v-32bd0ef6]{word-break:break-all;display:block;-webkit-margin-before:1em;margin-block-start:1em;-webkit-margin-after:1em;margin-block-end:1em;-webkit-margin-start:0;margin-inline-start:0;-webkit-margin-end:0;margin-inline-end:0}.sc-message--title[data-v-32bd0ef6]{padding-bottom:0;font-weight:700}",
          "",
        ]),
        (f.exports = e);
    },
    fce3: function (f, e, t) {
      var n = t("d039"),
        r = t("da84"),
        o = r.RegExp;
      f.exports = n(function () {
        var f = o(".", "s");
        return !(f.dotAll && f.exec("\n") && "s" === f.flags);
      });
    },
    fdbc: function (f, e) {
      f.exports = {
        CSSRuleList: 0,
        CSSStyleDeclaration: 0,
        CSSValueList: 0,
        ClientRectList: 0,
        DOMRectList: 0,
        DOMStringList: 0,
        DOMTokenList: 1,
        DataTransferItemList: 0,
        FileList: 0,
        HTMLAllCollection: 0,
        HTMLCollection: 0,
        HTMLFormElement: 0,
        HTMLSelectElement: 0,
        MediaList: 0,
        MimeTypeArray: 0,
        NamedNodeMap: 0,
        NodeList: 1,
        PaintRequestList: 0,
        Plugin: 0,
        PluginArray: 0,
        SVGLengthList: 0,
        SVGNumberList: 0,
        SVGPathSegList: 0,
        SVGPointList: 0,
        SVGStringList: 0,
        SVGTransformList: 0,
        SourceBufferList: 0,
        StyleSheetList: 0,
        TextTrackCueList: 0,
        TextTrackList: 0,
        TouchList: 0,
      };
    },
    fdbf: function (f, e, t) {
      var n = t("4930");
      f.exports = n && !Symbol.sham && "symbol" == typeof Symbol.iterator;
    },
    fea9: function (f, e, t) {
      var n = t("da84");
      f.exports = n.Promise;
    },
  });
});
//# sourceMappingURL=vue-beautiful-chat.umd.min.js.map
